/******/ (() => {
  // webpackBootstrap
  /******/ var __webpack_modules__ = {
    /***/ "./node_modules/@popperjs/core/lib/createPopper.js":
      /*!*********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/createPopper.js ***!
  \*********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ createPopper: () => /* binding */ createPopper,
          /* harmony export */ detectOverflow: () =>
            /* reexport safe */ _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_13__[
              "default"
            ],
          /* harmony export */ popperGenerator: () =>
            /* binding */ popperGenerator,
          /* harmony export */
        });
        /* harmony import */ var _dom_utils_getCompositeRect_js__WEBPACK_IMPORTED_MODULE_9__ =
          __webpack_require__(
            /*! ./dom-utils/getCompositeRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js"
          );
        /* harmony import */ var _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_11__ =
          __webpack_require__(
            /*! ./dom-utils/getLayoutRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js"
          );
        /* harmony import */ var _dom_utils_listScrollParents_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./dom-utils/listScrollParents.js */ "./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js"
          );
        /* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_10__ =
          __webpack_require__(
            /*! ./dom-utils/getOffsetParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js"
          );
        /* harmony import */ var _dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ./dom-utils/getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js"
          );
        /* harmony import */ var _utils_orderModifiers_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./utils/orderModifiers.js */ "./node_modules/@popperjs/core/lib/utils/orderModifiers.js"
          );
        /* harmony import */ var _utils_debounce_js__WEBPACK_IMPORTED_MODULE_12__ =
          __webpack_require__(
            /*! ./utils/debounce.js */ "./node_modules/@popperjs/core/lib/utils/debounce.js"
          );
        /* harmony import */ var _utils_validateModifiers_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./utils/validateModifiers.js */ "./node_modules/@popperjs/core/lib/utils/validateModifiers.js"
          );
        /* harmony import */ var _utils_uniqueBy_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./utils/uniqueBy.js */ "./node_modules/@popperjs/core/lib/utils/uniqueBy.js"
          );
        /* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js"
          );
        /* harmony import */ var _utils_mergeByName_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./utils/mergeByName.js */ "./node_modules/@popperjs/core/lib/utils/mergeByName.js"
          );
        /* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_13__ =
          __webpack_require__(
            /*! ./utils/detectOverflow.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js"
          );
        /* harmony import */ var _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./dom-utils/instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );

        var INVALID_ELEMENT_ERROR =
          "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
        var INFINITE_LOOP_ERROR =
          "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
        var DEFAULT_OPTIONS = {
          placement: "bottom",
          modifiers: [],
          strategy: "absolute",
        };

        function areValidElements() {
          for (
            var _len = arguments.length, args = new Array(_len), _key = 0;
            _key < _len;
            _key++
          ) {
            args[_key] = arguments[_key];
          }

          return !args.some(function (element) {
            return !(
              element && typeof element.getBoundingClientRect === "function"
            );
          });
        }

        function popperGenerator(generatorOptions) {
          if (generatorOptions === void 0) {
            generatorOptions = {};
          }

          var _generatorOptions = generatorOptions,
            _generatorOptions$def = _generatorOptions.defaultModifiers,
            defaultModifiers =
              _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
            _generatorOptions$def2 = _generatorOptions.defaultOptions,
            defaultOptions =
              _generatorOptions$def2 === void 0
                ? DEFAULT_OPTIONS
                : _generatorOptions$def2;
          return function createPopper(reference, popper, options) {
            if (options === void 0) {
              options = defaultOptions;
            }

            var state = {
              placement: "bottom",
              orderedModifiers: [],
              options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
              modifiersData: {},
              elements: {
                reference: reference,
                popper: popper,
              },
              attributes: {},
              styles: {},
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
              state: state,
              setOptions: function setOptions(setOptionsAction) {
                var options =
                  typeof setOptionsAction === "function"
                    ? setOptionsAction(state.options)
                    : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign(
                  {},
                  defaultOptions,
                  state.options,
                  options
                );
                state.scrollParents = {
                  reference: (0,
                  _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isElement)(
                    reference
                  )
                    ? (0,
                      _dom_utils_listScrollParents_js__WEBPACK_IMPORTED_MODULE_1__[
                        "default"
                      ])(reference)
                    : reference.contextElement
                    ? (0,
                      _dom_utils_listScrollParents_js__WEBPACK_IMPORTED_MODULE_1__[
                        "default"
                      ])(reference.contextElement)
                    : [],
                  popper: (0,
                  _dom_utils_listScrollParents_js__WEBPACK_IMPORTED_MODULE_1__[
                    "default"
                  ])(popper),
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties

                var orderedModifiers = (0,
                _utils_orderModifiers_js__WEBPACK_IMPORTED_MODULE_2__[
                  "default"
                ])(
                  (0,
                  _utils_mergeByName_js__WEBPACK_IMPORTED_MODULE_3__[
                    "default"
                  ])([].concat(defaultModifiers, state.options.modifiers))
                ); // Strip out disabled modifiers

                state.orderedModifiers = orderedModifiers.filter(function (m) {
                  return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                // if one of the modifiers is invalid for any reason

                if (true) {
                  var modifiers = (0,
                  _utils_uniqueBy_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
                    [].concat(orderedModifiers, state.options.modifiers),
                    function (_ref) {
                      var name = _ref.name;
                      return name;
                    }
                  );
                  (0,
                  _utils_validateModifiers_js__WEBPACK_IMPORTED_MODULE_5__[
                    "default"
                  ])(modifiers);

                  if (
                    (0,
                    _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__[
                      "default"
                    ])(state.options.placement) ===
                    _enums_js__WEBPACK_IMPORTED_MODULE_7__.auto
                  ) {
                    var flipModifier = state.orderedModifiers.find(function (
                      _ref2
                    ) {
                      var name = _ref2.name;
                      return name === "flip";
                    });

                    if (!flipModifier) {
                      console.error(
                        [
                          'Popper: "auto" placements require the "flip" modifier be',
                          "present and enabled to work.",
                        ].join(" ")
                      );
                    }
                  }

                  var _getComputedStyle = (0,
                    _dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_8__[
                      "default"
                    ])(popper),
                    marginTop = _getComputedStyle.marginTop,
                    marginRight = _getComputedStyle.marginRight,
                    marginBottom = _getComputedStyle.marginBottom,
                    marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
                  // cause bugs with positioning, so we'll warn the consumer

                  if (
                    [marginTop, marginRight, marginBottom, marginLeft].some(
                      function (margin) {
                        return parseFloat(margin);
                      }
                    )
                  ) {
                    console.warn(
                      [
                        'Popper: CSS "margin" styles cannot be used to apply padding',
                        "between the popper and its reference element or boundary.",
                        "To replicate margin, use the `offset` modifier, as well as",
                        "the `padding` option in the `preventOverflow` and `flip`",
                        "modifiers.",
                      ].join(" ")
                    );
                  }
                }

                runModifierEffects();
                return instance.update();
              },
              // Sync update – it will always be executed, even if not necessary. This
              // is useful for low frequency updates where sync behavior simplifies the
              // logic.
              // For high frequency updates (e.g. `resize` and `scroll` events), always
              // prefer the async Popper#update method
              forceUpdate: function forceUpdate() {
                if (isDestroyed) {
                  return;
                }

                var _state$elements = state.elements,
                  reference = _state$elements.reference,
                  popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore

                if (!areValidElements(reference, popper)) {
                  if (true) {
                    console.error(INVALID_ELEMENT_ERROR);
                  }

                  return;
                } // Store the reference and popper rects to be read by modifiers

                state.rects = {
                  reference: (0,
                  _dom_utils_getCompositeRect_js__WEBPACK_IMPORTED_MODULE_9__[
                    "default"
                  ])(
                    reference,
                    (0,
                    _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_10__[
                      "default"
                    ])(popper),
                    state.options.strategy === "fixed"
                  ),
                  popper: (0,
                  _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_11__[
                    "default"
                  ])(popper),
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect

                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`

                state.orderedModifiers.forEach(function (modifier) {
                  return (state.modifiersData[modifier.name] = Object.assign(
                    {},
                    modifier.data
                  ));
                });
                var __debug_loops__ = 0;

                for (
                  var index = 0;
                  index < state.orderedModifiers.length;
                  index++
                ) {
                  if (true) {
                    __debug_loops__ += 1;

                    if (__debug_loops__ > 100) {
                      console.error(INFINITE_LOOP_ERROR);
                      break;
                    }
                  }

                  if (state.reset === true) {
                    state.reset = false;
                    index = -1;
                    continue;
                  }

                  var _state$orderedModifie = state.orderedModifiers[index],
                    fn = _state$orderedModifie.fn,
                    _state$orderedModifie2 = _state$orderedModifie.options,
                    _options =
                      _state$orderedModifie2 === void 0
                        ? {}
                        : _state$orderedModifie2,
                    name = _state$orderedModifie.name;

                  if (typeof fn === "function") {
                    state =
                      fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance,
                      }) || state;
                  }
                }
              },
              // Async and optimistically optimized update – it will not be executed if
              // not necessary (debounced to run at most once-per-tick)
              update: (0,
              _utils_debounce_js__WEBPACK_IMPORTED_MODULE_12__["default"])(
                function () {
                  return new Promise(function (resolve) {
                    instance.forceUpdate();
                    resolve(state);
                  });
                }
              ),
              destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
              },
            };

            if (!areValidElements(reference, popper)) {
              if (true) {
                console.error(INVALID_ELEMENT_ERROR);
              }

              return instance;
            }

            instance.setOptions(options).then(function (state) {
              if (!isDestroyed && options.onFirstUpdate) {
                options.onFirstUpdate(state);
              }
            }); // Modifiers have the ability to execute arbitrary code before the first
            // update cycle runs. They will be executed in the same order as the update
            // cycle. This is useful when a modifier adds some persistent data that
            // other modifiers need to use, but the modifier is run after the dependent
            // one.

            function runModifierEffects() {
              state.orderedModifiers.forEach(function (_ref3) {
                var name = _ref3.name,
                  _ref3$options = _ref3.options,
                  options = _ref3$options === void 0 ? {} : _ref3$options,
                  effect = _ref3.effect;

                if (typeof effect === "function") {
                  var cleanupFn = effect({
                    state: state,
                    name: name,
                    instance: instance,
                    options: options,
                  });

                  var noopFn = function noopFn() {};

                  effectCleanupFns.push(cleanupFn || noopFn);
                }
              });
            }

            function cleanupModifierEffects() {
              effectCleanupFns.forEach(function (fn) {
                return fn();
              });
              effectCleanupFns = [];
            }

            return instance;
          };
        }
        var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/contains.js":
      /*!***************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/contains.js ***!
  \***************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ contains,
          /* harmony export */
        });
        /* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );

        function contains(parent, child) {
          var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

          if (parent.contains(child)) {
            return true;
          } // then fallback to custom implementation with Shadow DOM support
          else if (
            rootNode &&
            (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isShadowRoot)(
              rootNode
            )
          ) {
            var next = child;

            do {
              if (next && parent.isSameNode(next)) {
                return true;
              } // $FlowFixMe[prop-missing]: need a better way to handle this...

              next = next.parentNode || next.host;
            } while (next);
          } // Give up, the result is false

          return false;
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js":
      /*!****************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js ***!
  \****************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () =>
            /* binding */ getBoundingClientRect,
          /* harmony export */
        });
        /* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );
        /* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js"
          );
        /* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js"
          );
        /* harmony import */ var _isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./isLayoutViewport.js */ "./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js"
          );

        function getBoundingClientRect(element, includeScale, isFixedStrategy) {
          if (includeScale === void 0) {
            includeScale = false;
          }

          if (isFixedStrategy === void 0) {
            isFixedStrategy = false;
          }

          var clientRect = element.getBoundingClientRect();
          var scaleX = 1;
          var scaleY = 1;

          if (
            includeScale &&
            (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(
              element
            )
          ) {
            scaleX =
              element.offsetWidth > 0
                ? (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_1__.round)(
                    clientRect.width
                  ) / element.offsetWidth || 1
                : 1;
            scaleY =
              element.offsetHeight > 0
                ? (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_1__.round)(
                    clientRect.height
                  ) / element.offsetHeight || 1
                : 1;
          }

          var _ref = (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isElement)(
              element
            )
              ? (0, _getWindow_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
                  element
                )
              : window,
            visualViewport = _ref.visualViewport;

          var addVisualOffsets =
            !(0,
            _isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_3__["default"])() &&
            isFixedStrategy;
          var x =
            (clientRect.left +
              (addVisualOffsets && visualViewport
                ? visualViewport.offsetLeft
                : 0)) /
            scaleX;
          var y =
            (clientRect.top +
              (addVisualOffsets && visualViewport
                ? visualViewport.offsetTop
                : 0)) /
            scaleY;
          var width = clientRect.width / scaleX;
          var height = clientRect.height / scaleY;
          return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y,
          };
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getClippingRect,
          /* harmony export */
        });
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );
        /* harmony import */ var _getViewportRect_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./getViewportRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js"
          );
        /* harmony import */ var _getDocumentRect_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./getDocumentRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js"
          );
        /* harmony import */ var _listScrollParents_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./listScrollParents.js */ "./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js"
          );
        /* harmony import */ var _getOffsetParent_js__WEBPACK_IMPORTED_MODULE_10__ =
          __webpack_require__(
            /*! ./getOffsetParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js"
          );
        /* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js"
          );
        /* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_9__ =
          __webpack_require__(
            /*! ./getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js"
          );
        /* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );
        /* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getBoundingClientRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js"
          );
        /* harmony import */ var _getParentNode_js__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ./getParentNode.js */ "./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js"
          );
        /* harmony import */ var _contains_js__WEBPACK_IMPORTED_MODULE_11__ =
          __webpack_require__(
            /*! ./contains.js */ "./node_modules/@popperjs/core/lib/dom-utils/contains.js"
          );
        /* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_12__ =
          __webpack_require__(
            /*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js"
          );
        /* harmony import */ var _utils_rectToClientRect_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../utils/rectToClientRect.js */ "./node_modules/@popperjs/core/lib/utils/rectToClientRect.js"
          );
        /* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_13__ =
          __webpack_require__(
            /*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js"
          );

        function getInnerBoundingClientRect(element, strategy) {
          var rect = (0,
          _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            element,
            false,
            strategy === "fixed"
          );
          rect.top = rect.top + element.clientTop;
          rect.left = rect.left + element.clientLeft;
          rect.bottom = rect.top + element.clientHeight;
          rect.right = rect.left + element.clientWidth;
          rect.width = element.clientWidth;
          rect.height = element.clientHeight;
          rect.x = rect.left;
          rect.y = rect.top;
          return rect;
        }

        function getClientRectFromMixedType(element, clippingParent, strategy) {
          return clippingParent ===
            _enums_js__WEBPACK_IMPORTED_MODULE_1__.viewport
            ? (0,
              _utils_rectToClientRect_js__WEBPACK_IMPORTED_MODULE_2__[
                "default"
              ])(
                (0,
                _getViewportRect_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
                  element,
                  strategy
                )
              )
            : (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_4__.isElement)(
                clippingParent
              )
            ? getInnerBoundingClientRect(clippingParent, strategy)
            : (0,
              _utils_rectToClientRect_js__WEBPACK_IMPORTED_MODULE_2__[
                "default"
              ])(
                (0,
                _getDocumentRect_js__WEBPACK_IMPORTED_MODULE_5__["default"])(
                  (0,
                  _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_6__[
                    "default"
                  ])(element)
                )
              );
        } // A "clipping parent" is an overflowable container with the characteristic of
        // clipping (or hiding) overflowing elements with a position different from
        // `initial`

        function getClippingParents(element) {
          var clippingParents = (0,
          _listScrollParents_js__WEBPACK_IMPORTED_MODULE_7__["default"])(
            (0, _getParentNode_js__WEBPACK_IMPORTED_MODULE_8__["default"])(
              element
            )
          );
          var canEscapeClipping =
            ["absolute", "fixed"].indexOf(
              (0, _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_9__["default"])(
                element
              ).position
            ) >= 0;
          var clipperElement =
            canEscapeClipping &&
            (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_4__.isHTMLElement)(
              element
            )
              ? (0,
                _getOffsetParent_js__WEBPACK_IMPORTED_MODULE_10__["default"])(
                  element
                )
              : element;

          if (
            !(0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_4__.isElement)(
              clipperElement
            )
          ) {
            return [];
          } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414

          return clippingParents.filter(function (clippingParent) {
            return (
              (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_4__.isElement)(
                clippingParent
              ) &&
              (0, _contains_js__WEBPACK_IMPORTED_MODULE_11__["default"])(
                clippingParent,
                clipperElement
              ) &&
              (0, _getNodeName_js__WEBPACK_IMPORTED_MODULE_12__["default"])(
                clippingParent
              ) !== "body"
            );
          });
        } // Gets the maximum area that the element is visible in due to any number of
        // clipping parents

        function getClippingRect(element, boundary, rootBoundary, strategy) {
          var mainClippingParents =
            boundary === "clippingParents"
              ? getClippingParents(element)
              : [].concat(boundary);
          var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
          var firstClippingParent = clippingParents[0];
          var clippingRect = clippingParents.reduce(function (
            accRect,
            clippingParent
          ) {
            var rect = getClientRectFromMixedType(
              element,
              clippingParent,
              strategy
            );
            accRect.top = (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_13__.max)(
              rect.top,
              accRect.top
            );
            accRect.right = (0,
            _utils_math_js__WEBPACK_IMPORTED_MODULE_13__.min)(
              rect.right,
              accRect.right
            );
            accRect.bottom = (0,
            _utils_math_js__WEBPACK_IMPORTED_MODULE_13__.min)(
              rect.bottom,
              accRect.bottom
            );
            accRect.left = (0,
            _utils_math_js__WEBPACK_IMPORTED_MODULE_13__.max)(
              rect.left,
              accRect.left
            );
            return accRect;
          },
          getClientRectFromMixedType(element, firstClippingParent, strategy));
          clippingRect.width = clippingRect.right - clippingRect.left;
          clippingRect.height = clippingRect.bottom - clippingRect.top;
          clippingRect.x = clippingRect.left;
          clippingRect.y = clippingRect.top;
          return clippingRect;
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js ***!
  \***********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getCompositeRect,
          /* harmony export */
        });
        /* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./getBoundingClientRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js"
          );
        /* harmony import */ var _getNodeScroll_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./getNodeScroll.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js"
          );
        /* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js"
          );
        /* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );
        /* harmony import */ var _getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./getWindowScrollBarX.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js"
          );
        /* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js"
          );
        /* harmony import */ var _isScrollParent_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./isScrollParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js"
          );
        /* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js"
          );

        function isElementScaled(element) {
          var rect = element.getBoundingClientRect();
          var scaleX =
            (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_0__.round)(rect.width) /
              element.offsetWidth || 1;
          var scaleY =
            (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_0__.round)(
              rect.height
            ) / element.offsetHeight || 1;
          return scaleX !== 1 || scaleY !== 1;
        } // Returns the composite rect of an element relative to its offsetParent.
        // Composite means it takes into account transforms as well as layout.

        function getCompositeRect(
          elementOrVirtualElement,
          offsetParent,
          isFixed
        ) {
          if (isFixed === void 0) {
            isFixed = false;
          }

          var isOffsetParentAnElement = (0,
          _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isHTMLElement)(
            offsetParent
          );
          var offsetParentIsScaled =
            (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isHTMLElement)(
              offsetParent
            ) && isElementScaled(offsetParent);
          var documentElement = (0,
          _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
            offsetParent
          );
          var rect = (0,
          _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
            elementOrVirtualElement,
            offsetParentIsScaled,
            isFixed
          );
          var scroll = {
            scrollLeft: 0,
            scrollTop: 0,
          };
          var offsets = {
            x: 0,
            y: 0,
          };

          if (
            isOffsetParentAnElement ||
            (!isOffsetParentAnElement && !isFixed)
          ) {
            if (
              (0, _getNodeName_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
                offsetParent
              ) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
              (0, _isScrollParent_js__WEBPACK_IMPORTED_MODULE_5__["default"])(
                documentElement
              )
            ) {
              scroll = (0,
              _getNodeScroll_js__WEBPACK_IMPORTED_MODULE_6__["default"])(
                offsetParent
              );
            }

            if (
              (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isHTMLElement)(
                offsetParent
              )
            ) {
              offsets = (0,
              _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_3__[
                "default"
              ])(offsetParent, true);
              offsets.x += offsetParent.clientLeft;
              offsets.y += offsetParent.clientTop;
            } else if (documentElement) {
              offsets.x = (0,
              _getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_7__["default"])(
                documentElement
              );
            }
          }

          return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height,
          };
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js ***!
  \***********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getComputedStyle,
          /* harmony export */
        });
        /* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js"
          );

        function getComputedStyle(element) {
          return (0, _getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            element
          ).getComputedStyle(element);
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js":
      /*!*************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js ***!
  \*************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getDocumentElement,
          /* harmony export */
        });
        /* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );

        function getDocumentElement(element) {
          // $FlowFixMe[incompatible-return]: assume body is always available
          return (
            ((0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isElement)(element)
              ? element.ownerDocument // $FlowFixMe[prop-missing]
              : element.document) || window.document
          ).documentElement;
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getDocumentRect,
          /* harmony export */
        });
        /* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js"
          );
        /* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js"
          );
        /* harmony import */ var _getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./getWindowScrollBarX.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js"
          );
        /* harmony import */ var _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./getWindowScroll.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js"
          );
        /* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js"
          );

        // Gets the entire size of the scrollable document area, even extending outside
        // of the `<html>` and `<body>` rect bounds if horizontally scrollable

        function getDocumentRect(element) {
          var _element$ownerDocumen;

          var html = (0,
          _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            element
          );
          var winScroll = (0,
          _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_1__["default"])(element);
          var body =
            (_element$ownerDocumen = element.ownerDocument) == null
              ? void 0
              : _element$ownerDocumen.body;
          var width = (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_2__.max)(
            html.scrollWidth,
            html.clientWidth,
            body ? body.scrollWidth : 0,
            body ? body.clientWidth : 0
          );
          var height = (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_2__.max)(
            html.scrollHeight,
            html.clientHeight,
            body ? body.scrollHeight : 0,
            body ? body.clientHeight : 0
          );
          var x =
            -winScroll.scrollLeft +
            (0,
            _getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
              element
            );
          var y = -winScroll.scrollTop;

          if (
            (0, _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
              body || html
            ).direction === "rtl"
          ) {
            x +=
              (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_2__.max)(
                html.clientWidth,
                body ? body.clientWidth : 0
              ) - width;
          }

          return {
            width: width,
            height: height,
            x: x,
            y: y,
          };
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js":
      /*!***************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js ***!
  \***************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () =>
            /* binding */ getHTMLElementScroll,
          /* harmony export */
        });
        function getHTMLElementScroll(element) {
          return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop,
          };
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js":
      /*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js ***!
  \********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getLayoutRect,
          /* harmony export */
        });
        /* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getBoundingClientRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js"
          );
        // Returns the layout rect of an element relative to its offsetParent. Layout
        // means it doesn't take into account transforms.

        function getLayoutRect(element) {
          var clientRect = (0,
          _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            element
          ); // Use the clientRect sizes if it's not been transformed.
          // Fixes https://github.com/popperjs/popper-core/issues/1223

          var width = element.offsetWidth;
          var height = element.offsetHeight;

          if (Math.abs(clientRect.width - width) <= 1) {
            width = clientRect.width;
          }

          if (Math.abs(clientRect.height - height) <= 1) {
            height = clientRect.height;
          }

          return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height,
          };
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js":
      /*!******************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js ***!
  \******************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getNodeName,
          /* harmony export */
        });
        function getNodeName(element) {
          return element ? (element.nodeName || "").toLowerCase() : null;
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js":
      /*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js ***!
  \********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getNodeScroll,
          /* harmony export */
        });
        /* harmony import */ var _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./getWindowScroll.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js"
          );
        /* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js"
          );
        /* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );
        /* harmony import */ var _getHTMLElementScroll_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./getHTMLElementScroll.js */ "./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js"
          );

        function getNodeScroll(node) {
          if (
            node ===
              (0, _getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                node
              ) ||
            !(0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isHTMLElement)(
              node
            )
          ) {
            return (0,
            _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__["default"])(node);
          } else {
            return (0,
            _getHTMLElementScroll_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
              node
            );
          }
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getOffsetParent,
          /* harmony export */
        });
        /* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js"
          );
        /* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js"
          );
        /* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js"
          );
        /* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );
        /* harmony import */ var _isTableElement_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./isTableElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js"
          );
        /* harmony import */ var _getParentNode_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./getParentNode.js */ "./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js"
          );
        /* harmony import */ var _utils_userAgent_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../utils/userAgent.js */ "./node_modules/@popperjs/core/lib/utils/userAgent.js"
          );

        function getTrueOffsetParent(element) {
          if (
            !(0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(
              element
            ) || // https://github.com/popperjs/popper-core/issues/837
            (0, _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
              element
            ).position === "fixed"
          ) {
            return null;
          }

          return element.offsetParent;
        } // `.offsetParent` reports `null` for fixed elements, while absolute elements
        // return the containing block

        function getContainingBlock(element) {
          var isFirefox = /firefox/i.test(
            (0, _utils_userAgent_js__WEBPACK_IMPORTED_MODULE_2__["default"])()
          );
          var isIE = /Trident/i.test(
            (0, _utils_userAgent_js__WEBPACK_IMPORTED_MODULE_2__["default"])()
          );

          if (
            isIE &&
            (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(
              element
            )
          ) {
            // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
            var elementCss = (0,
            _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
              element
            );

            if (elementCss.position === "fixed") {
              return null;
            }
          }

          var currentNode = (0,
          _getParentNode_js__WEBPACK_IMPORTED_MODULE_3__["default"])(element);

          if (
            (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isShadowRoot)(
              currentNode
            )
          ) {
            currentNode = currentNode.host;
          }

          while (
            (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(
              currentNode
            ) &&
            ["html", "body"].indexOf(
              (0, _getNodeName_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
                currentNode
              )
            ) < 0
          ) {
            var css = (0,
            _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
              currentNode
            ); // This is non-exhaustive but covers the most common CSS properties that
            // create a containing block.
            // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

            if (
              css.transform !== "none" ||
              css.perspective !== "none" ||
              css.contain === "paint" ||
              ["transform", "perspective"].indexOf(css.willChange) !== -1 ||
              (isFirefox && css.willChange === "filter") ||
              (isFirefox && css.filter && css.filter !== "none")
            ) {
              return currentNode;
            } else {
              currentNode = currentNode.parentNode;
            }
          }

          return null;
        } // Gets the closest ancestor positioned element. Handles some edge cases,
        // such as table ancestors and cross browser bugs.

        function getOffsetParent(element) {
          var window = (0,
          _getWindow_js__WEBPACK_IMPORTED_MODULE_5__["default"])(element);
          var offsetParent = getTrueOffsetParent(element);

          while (
            offsetParent &&
            (0, _isTableElement_js__WEBPACK_IMPORTED_MODULE_6__["default"])(
              offsetParent
            ) &&
            (0, _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
              offsetParent
            ).position === "static"
          ) {
            offsetParent = getTrueOffsetParent(offsetParent);
          }

          if (
            offsetParent &&
            ((0, _getNodeName_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
              offsetParent
            ) === "html" ||
              ((0, _getNodeName_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
                offsetParent
              ) === "body" &&
                (0,
                _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
                  offsetParent
                ).position === "static"))
          ) {
            return window;
          }

          return offsetParent || getContainingBlock(element) || window;
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js":
      /*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js ***!
  \********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getParentNode,
          /* harmony export */
        });
        /* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js"
          );
        /* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js"
          );
        /* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );

        function getParentNode(element) {
          if (
            (0, _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
              element
            ) === "html"
          ) {
            return element;
          }

          return (
            // this is a quicker (but less type safe) way to save quite some bytes from the bundle
            // $FlowFixMe[incompatible-return]
            // $FlowFixMe[prop-missing]
            element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
            element.parentNode || // DOM Element detected
            ((0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isShadowRoot)(
              element
            )
              ? element.host
              : null) || // ShadowRoot detected
            // $FlowFixMe[incompatible-call]: HTMLElement is a Node
            (0, _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
              element
            ) // fallback
          );
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getScrollParent,
          /* harmony export */
        });
        /* harmony import */ var _getParentNode_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./getParentNode.js */ "./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js"
          );
        /* harmony import */ var _isScrollParent_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./isScrollParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js"
          );
        /* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js"
          );
        /* harmony import */ var _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );

        function getScrollParent(node) {
          if (
            ["html", "body", "#document"].indexOf(
              (0, _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__["default"])(node)
            ) >= 0
          ) {
            // $FlowFixMe[incompatible-return]: assume body is always available
            return node.ownerDocument.body;
          }

          if (
            (0, _instanceOf_js__WEBPACK_IMPORTED_MODULE_1__.isHTMLElement)(
              node
            ) &&
            (0, _isScrollParent_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
              node
            )
          ) {
            return node;
          }

          return getScrollParent(
            (0, _getParentNode_js__WEBPACK_IMPORTED_MODULE_3__["default"])(node)
          );
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getViewportRect,
          /* harmony export */
        });
        /* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js"
          );
        /* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js"
          );
        /* harmony import */ var _getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./getWindowScrollBarX.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js"
          );
        /* harmony import */ var _isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./isLayoutViewport.js */ "./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js"
          );

        function getViewportRect(element, strategy) {
          var win = (0, _getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            element
          );
          var html = (0,
          _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
            element
          );
          var visualViewport = win.visualViewport;
          var width = html.clientWidth;
          var height = html.clientHeight;
          var x = 0;
          var y = 0;

          if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0,
            _isLayoutViewport_js__WEBPACK_IMPORTED_MODULE_2__["default"])();

            if (layoutViewport || (!layoutViewport && strategy === "fixed")) {
              x = visualViewport.offsetLeft;
              y = visualViewport.offsetTop;
            }
          }

          return {
            width: width,
            height: height,
            x:
              x +
              (0,
              _getWindowScrollBarX_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
                element
              ),
            y: y,
          };
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js":
      /*!****************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js ***!
  \****************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getWindow,
          /* harmony export */
        });
        function getWindow(node) {
          if (node == null) {
            return window;
          }

          if (node.toString() !== "[object Window]") {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
          }

          return node;
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getWindowScroll,
          /* harmony export */
        });
        /* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js"
          );

        function getWindowScroll(node) {
          var win = (0, _getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            node
          );
          var scrollLeft = win.pageXOffset;
          var scrollTop = win.pageYOffset;
          return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
          };
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js":
      /*!**************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js ***!
  \**************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getWindowScrollBarX,
          /* harmony export */
        });
        /* harmony import */ var _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getBoundingClientRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js"
          );
        /* harmony import */ var _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js"
          );
        /* harmony import */ var _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./getWindowScroll.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js"
          );

        function getWindowScrollBarX(element) {
          // If <html> has a CSS width greater than the viewport, then this will be
          // incorrect for RTL.
          // Popper 1 is broken in this case and never had a bug report so let's assume
          // it's not an issue. I don't think anyone ever specifies width on <html>
          // anyway.
          // Browsers where the left scrollbar doesn't cause an issue report `0` for
          // this (e.g. Edge 2019, IE11, Safari)
          return (
            (0,
            _getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
              (0,
              _getDocumentElement_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
                element
              )
            ).left +
            (0, _getWindowScroll_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
              element
            ).scrollLeft
          );
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js ***!
  \*****************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ isElement: () => /* binding */ isElement,
          /* harmony export */ isHTMLElement: () => /* binding */ isHTMLElement,
          /* harmony export */ isShadowRoot: () => /* binding */ isShadowRoot,
          /* harmony export */
        });
        /* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js"
          );

        function isElement(node) {
          var OwnElement = (0,
          _getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(node).Element;
          return node instanceof OwnElement || node instanceof Element;
        }

        function isHTMLElement(node) {
          var OwnElement = (0,
          _getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            node
          ).HTMLElement;
          return node instanceof OwnElement || node instanceof HTMLElement;
        }

        function isShadowRoot(node) {
          // IE 11 has no ShadowRoot
          if (typeof ShadowRoot === "undefined") {
            return false;
          }

          var OwnElement = (0,
          _getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            node
          ).ShadowRoot;
          return node instanceof OwnElement || node instanceof ShadowRoot;
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js ***!
  \***********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ isLayoutViewport,
          /* harmony export */
        });
        /* harmony import */ var _utils_userAgent_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/userAgent.js */ "./node_modules/@popperjs/core/lib/utils/userAgent.js"
          );

        function isLayoutViewport() {
          return !/^((?!chrome|android).)*safari/i.test(
            (0, _utils_userAgent_js__WEBPACK_IMPORTED_MODULE_0__["default"])()
          );
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js":
      /*!*********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js ***!
  \*********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ isScrollParent,
          /* harmony export */
        });
        /* harmony import */ var _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js"
          );

        function isScrollParent(element) {
          // Firefox wants us to check `-x` and `-y` variations as well
          var _getComputedStyle = (0,
            _getComputedStyle_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
              element
            ),
            overflow = _getComputedStyle.overflow,
            overflowX = _getComputedStyle.overflowX,
            overflowY = _getComputedStyle.overflowY;

          return /auto|scroll|overlay|hidden/.test(
            overflow + overflowY + overflowX
          );
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js":
      /*!*********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js ***!
  \*********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ isTableElement,
          /* harmony export */
        });
        /* harmony import */ var _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js"
          );

        function isTableElement(element) {
          return (
            ["table", "td", "th"].indexOf(
              (0, _getNodeName_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                element
              )
            ) >= 0
          );
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js":
      /*!************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js ***!
  \************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ listScrollParents,
          /* harmony export */
        });
        /* harmony import */ var _getScrollParent_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getScrollParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js"
          );
        /* harmony import */ var _getParentNode_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./getParentNode.js */ "./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js"
          );
        /* harmony import */ var _getWindow_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js"
          );
        /* harmony import */ var _isScrollParent_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./isScrollParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js"
          );

        /*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

        function listScrollParents(element, list) {
          var _element$ownerDocumen;

          if (list === void 0) {
            list = [];
          }

          var scrollParent = (0,
          _getScrollParent_js__WEBPACK_IMPORTED_MODULE_0__["default"])(element);
          var isBody =
            scrollParent ===
            ((_element$ownerDocumen = element.ownerDocument) == null
              ? void 0
              : _element$ownerDocumen.body);
          var win = (0, _getWindow_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
            scrollParent
          );
          var target = isBody
            ? [win].concat(
                win.visualViewport || [],
                (0, _isScrollParent_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
                  scrollParent
                )
                  ? scrollParent
                  : []
              )
            : scrollParent;
          var updatedList = list.concat(target);
          return isBody
            ? updatedList // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
            : updatedList.concat(
                listScrollParents(
                  (0,
                  _getParentNode_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
                    target
                  )
                )
              );
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/enums.js":
      /*!**************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/enums.js ***!
  \**************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ afterMain: () => /* binding */ afterMain,
          /* harmony export */ afterRead: () => /* binding */ afterRead,
          /* harmony export */ afterWrite: () => /* binding */ afterWrite,
          /* harmony export */ auto: () => /* binding */ auto,
          /* harmony export */ basePlacements: () =>
            /* binding */ basePlacements,
          /* harmony export */ beforeMain: () => /* binding */ beforeMain,
          /* harmony export */ beforeRead: () => /* binding */ beforeRead,
          /* harmony export */ beforeWrite: () => /* binding */ beforeWrite,
          /* harmony export */ bottom: () => /* binding */ bottom,
          /* harmony export */ clippingParents: () =>
            /* binding */ clippingParents,
          /* harmony export */ end: () => /* binding */ end,
          /* harmony export */ left: () => /* binding */ left,
          /* harmony export */ main: () => /* binding */ main,
          /* harmony export */ modifierPhases: () =>
            /* binding */ modifierPhases,
          /* harmony export */ placements: () => /* binding */ placements,
          /* harmony export */ popper: () => /* binding */ popper,
          /* harmony export */ read: () => /* binding */ read,
          /* harmony export */ reference: () => /* binding */ reference,
          /* harmony export */ right: () => /* binding */ right,
          /* harmony export */ start: () => /* binding */ start,
          /* harmony export */ top: () => /* binding */ top,
          /* harmony export */ variationPlacements: () =>
            /* binding */ variationPlacements,
          /* harmony export */ viewport: () => /* binding */ viewport,
          /* harmony export */ write: () => /* binding */ write,
          /* harmony export */
        });
        var top = "top";
        var bottom = "bottom";
        var right = "right";
        var left = "left";
        var auto = "auto";
        var basePlacements = [top, bottom, right, left];
        var start = "start";
        var end = "end";
        var clippingParents = "clippingParents";
        var viewport = "viewport";
        var popper = "popper";
        var reference = "reference";
        var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function (
          acc,
          placement
        ) {
          return acc.concat([placement + "-" + start, placement + "-" + end]);
        },
        []);
        var placements = /*#__PURE__*/ []
          .concat(basePlacements, [auto])
          .reduce(function (acc, placement) {
            return acc.concat([
              placement,
              placement + "-" + start,
              placement + "-" + end,
            ]);
          }, []); // modifiers that need to read the DOM

        var beforeRead = "beforeRead";
        var read = "read";
        var afterRead = "afterRead"; // pure-logic modifiers

        var beforeMain = "beforeMain";
        var main = "main";
        var afterMain = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)

        var beforeWrite = "beforeWrite";
        var write = "write";
        var afterWrite = "afterWrite";
        var modifierPhases = [
          beforeRead,
          read,
          afterRead,
          beforeMain,
          main,
          afterMain,
          beforeWrite,
          write,
          afterWrite,
        ];

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/modifiers/applyStyles.js":
      /*!******************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js ***!
  \******************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _dom_utils_getNodeName_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../dom-utils/getNodeName.js */ "./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js"
          );
        /* harmony import */ var _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../dom-utils/instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );

        // This modifier takes the styles prepared by the `computeStyles` modifier
        // and applies them to the HTMLElements such as popper and arrow

        function applyStyles(_ref) {
          var state = _ref.state;
          Object.keys(state.elements).forEach(function (name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name]; // arrow is optional + virtual elements

            if (
              !(0,
              _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(
                element
              ) ||
              !(0,
              _dom_utils_getNodeName_js__WEBPACK_IMPORTED_MODULE_1__[
                "default"
              ])(element)
            ) {
              return;
            } // Flow doesn't support to extend this property, but it's the most
            // effective way to apply styles to an HTMLElement
            // $FlowFixMe[cannot-write]

            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function (name) {
              var value = attributes[name];

              if (value === false) {
                element.removeAttribute(name);
              } else {
                element.setAttribute(name, value === true ? "" : value);
              }
            });
          });
        }

        function effect(_ref2) {
          var state = _ref2.state;
          var initialStyles = {
            popper: {
              position: state.options.strategy,
              left: "0",
              top: "0",
              margin: "0",
            },
            arrow: {
              position: "absolute",
            },
            reference: {},
          };
          Object.assign(state.elements.popper.style, initialStyles.popper);
          state.styles = initialStyles;

          if (state.elements.arrow) {
            Object.assign(state.elements.arrow.style, initialStyles.arrow);
          }

          return function () {
            Object.keys(state.elements).forEach(function (name) {
              var element = state.elements[name];
              var attributes = state.attributes[name] || {};
              var styleProperties = Object.keys(
                state.styles.hasOwnProperty(name)
                  ? state.styles[name]
                  : initialStyles[name]
              ); // Set all values to an empty string to unset them

              var style = styleProperties.reduce(function (style, property) {
                style[property] = "";
                return style;
              }, {}); // arrow is optional + virtual elements

              if (
                !(0,
                _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_0__.isHTMLElement)(
                  element
                ) ||
                !(0,
                _dom_utils_getNodeName_js__WEBPACK_IMPORTED_MODULE_1__[
                  "default"
                ])(element)
              ) {
                return;
              }

              Object.assign(element.style, style);
              Object.keys(attributes).forEach(function (attribute) {
                element.removeAttribute(attribute);
              });
            });
          };
        } // eslint-disable-next-line import/no-unused-modules

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          name: "applyStyles",
          enabled: true,
          phase: "write",
          fn: applyStyles,
          effect: effect,
          requires: ["computeStyles"],
        };

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/modifiers/arrow.js":
      /*!************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/arrow.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js"
          );
        /* harmony import */ var _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ../dom-utils/getLayoutRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js"
          );
        /* harmony import */ var _dom_utils_contains_js__WEBPACK_IMPORTED_MODULE_9__ =
          __webpack_require__(
            /*! ../dom-utils/contains.js */ "./node_modules/@popperjs/core/lib/dom-utils/contains.js"
          );
        /* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ../dom-utils/getOffsetParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js"
          );
        /* harmony import */ var _utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../utils/getMainAxisFromPlacement.js */ "./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js"
          );
        /* harmony import */ var _utils_within_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ../utils/within.js */ "./node_modules/@popperjs/core/lib/utils/within.js"
          );
        /* harmony import */ var _utils_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/mergePaddingObject.js */ "./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js"
          );
        /* harmony import */ var _utils_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../utils/expandToHashMap.js */ "./node_modules/@popperjs/core/lib/utils/expandToHashMap.js"
          );
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );
        /* harmony import */ var _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ../dom-utils/instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );

        // eslint-disable-next-line import/no-unused-modules

        var toPaddingObject = function toPaddingObject(padding, state) {
          padding =
            typeof padding === "function"
              ? padding(
                  Object.assign({}, state.rects, {
                    placement: state.placement,
                  })
                )
              : padding;
          return (0,
          _utils_mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            typeof padding !== "number"
              ? padding
              : (0,
                _utils_expandToHashMap_js__WEBPACK_IMPORTED_MODULE_1__[
                  "default"
                ])(
                  padding,
                  _enums_js__WEBPACK_IMPORTED_MODULE_2__.basePlacements
                )
          );
        };

        function arrow(_ref) {
          var _state$modifiersData$;

          var state = _ref.state,
            name = _ref.name,
            options = _ref.options;
          var arrowElement = state.elements.arrow;
          var popperOffsets = state.modifiersData.popperOffsets;
          var basePlacement = (0,
          _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
            state.placement
          );
          var axis = (0,
          _utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_4__[
            "default"
          ])(basePlacement);
          var isVertical =
            [
              _enums_js__WEBPACK_IMPORTED_MODULE_2__.left,
              _enums_js__WEBPACK_IMPORTED_MODULE_2__.right,
            ].indexOf(basePlacement) >= 0;
          var len = isVertical ? "height" : "width";

          if (!arrowElement || !popperOffsets) {
            return;
          }

          var paddingObject = toPaddingObject(options.padding, state);
          var arrowRect = (0,
          _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_5__["default"])(
            arrowElement
          );
          var minProp =
            axis === "y"
              ? _enums_js__WEBPACK_IMPORTED_MODULE_2__.top
              : _enums_js__WEBPACK_IMPORTED_MODULE_2__.left;
          var maxProp =
            axis === "y"
              ? _enums_js__WEBPACK_IMPORTED_MODULE_2__.bottom
              : _enums_js__WEBPACK_IMPORTED_MODULE_2__.right;
          var endDiff =
            state.rects.reference[len] +
            state.rects.reference[axis] -
            popperOffsets[axis] -
            state.rects.popper[len];
          var startDiff = popperOffsets[axis] - state.rects.reference[axis];
          var arrowOffsetParent = (0,
          _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_6__[
            "default"
          ])(arrowElement);
          var clientSize = arrowOffsetParent
            ? axis === "y"
              ? arrowOffsetParent.clientHeight || 0
              : arrowOffsetParent.clientWidth || 0
            : 0;
          var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
          // outside of the popper bounds

          var min = paddingObject[minProp];
          var max = clientSize - arrowRect[len] - paddingObject[maxProp];
          var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
          var offset = (0,
          _utils_within_js__WEBPACK_IMPORTED_MODULE_7__.within)(
            min,
            center,
            max
          ); // Prevents breaking syntax highlighting...

          var axisProp = axis;
          state.modifiersData[name] =
            ((_state$modifiersData$ = {}),
            (_state$modifiersData$[axisProp] = offset),
            (_state$modifiersData$.centerOffset = offset - center),
            _state$modifiersData$);
        }

        function effect(_ref2) {
          var state = _ref2.state,
            options = _ref2.options;
          var _options$element = options.element,
            arrowElement =
              _options$element === void 0
                ? "[data-popper-arrow]"
                : _options$element;

          if (arrowElement == null) {
            return;
          } // CSS selector

          if (typeof arrowElement === "string") {
            arrowElement = state.elements.popper.querySelector(arrowElement);

            if (!arrowElement) {
              return;
            }
          }

          if (true) {
            if (
              !(0,
              _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_8__.isHTMLElement)(
                arrowElement
              )
            ) {
              console.error(
                [
                  'Popper: "arrow" element must be an HTMLElement (not an SVGElement).',
                  "To use an SVG arrow, wrap it in an HTMLElement that will be used as",
                  "the arrow.",
                ].join(" ")
              );
            }
          }

          if (
            !(0,
            _dom_utils_contains_js__WEBPACK_IMPORTED_MODULE_9__["default"])(
              state.elements.popper,
              arrowElement
            )
          ) {
            if (true) {
              console.error(
                [
                  'Popper: "arrow" modifier\'s `element` must be a child of the popper',
                  "element.",
                ].join(" ")
              );
            }

            return;
          }

          state.elements.arrow = arrowElement;
        } // eslint-disable-next-line import/no-unused-modules

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          name: "arrow",
          enabled: true,
          phase: "main",
          fn: arrow,
          effect: effect,
          requires: ["popperOffsets"],
          requiresIfExists: ["preventOverflow"],
        };

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/modifiers/computeStyles.js":
      /*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js ***!
  \********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */ mapToStyles: () => /* binding */ mapToStyles,
          /* harmony export */
        });
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );
        /* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../dom-utils/getOffsetParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js"
          );
        /* harmony import */ var _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../dom-utils/getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js"
          );
        /* harmony import */ var _dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../dom-utils/getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js"
          );
        /* harmony import */ var _dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ../dom-utils/getComputedStyle.js */ "./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js"
          );
        /* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ../utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js"
          );
        /* harmony import */ var _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ../utils/getVariation.js */ "./node_modules/@popperjs/core/lib/utils/getVariation.js"
          );
        /* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js"
          );

        // eslint-disable-next-line import/no-unused-modules

        var unsetSides = {
          top: "auto",
          right: "auto",
          bottom: "auto",
          left: "auto",
        }; // Round the offsets to the nearest suitable subpixel based on the DPR.
        // Zooming can change the DPR, but it seems to report a value that will
        // cleanly divide the values into the appropriate subpixels.

        function roundOffsetsByDPR(_ref) {
          var x = _ref.x,
            y = _ref.y;
          var win = window;
          var dpr = win.devicePixelRatio || 1;
          return {
            x:
              (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_0__.round)(x * dpr) /
                dpr || 0,
            y:
              (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_0__.round)(y * dpr) /
                dpr || 0,
          };
        }

        function mapToStyles(_ref2) {
          var _Object$assign2;

          var popper = _ref2.popper,
            popperRect = _ref2.popperRect,
            placement = _ref2.placement,
            variation = _ref2.variation,
            offsets = _ref2.offsets,
            position = _ref2.position,
            gpuAcceleration = _ref2.gpuAcceleration,
            adaptive = _ref2.adaptive,
            roundOffsets = _ref2.roundOffsets,
            isFixed = _ref2.isFixed;
          var _offsets$x = offsets.x,
            x = _offsets$x === void 0 ? 0 : _offsets$x,
            _offsets$y = offsets.y,
            y = _offsets$y === void 0 ? 0 : _offsets$y;

          var _ref3 =
            typeof roundOffsets === "function"
              ? roundOffsets({
                  x: x,
                  y: y,
                })
              : {
                  x: x,
                  y: y,
                };

          x = _ref3.x;
          y = _ref3.y;
          var hasX = offsets.hasOwnProperty("x");
          var hasY = offsets.hasOwnProperty("y");
          var sideX = _enums_js__WEBPACK_IMPORTED_MODULE_1__.left;
          var sideY = _enums_js__WEBPACK_IMPORTED_MODULE_1__.top;
          var win = window;

          if (adaptive) {
            var offsetParent = (0,
            _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_2__[
              "default"
            ])(popper);
            var heightProp = "clientHeight";
            var widthProp = "clientWidth";

            if (
              offsetParent ===
              (0,
              _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
                popper
              )
            ) {
              offsetParent = (0,
              _dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_4__[
                "default"
              ])(popper);

              if (
                (0,
                _dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__[
                  "default"
                ])(offsetParent).position !== "static" &&
                position === "absolute"
              ) {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
              }
            } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

            offsetParent = offsetParent;

            if (
              placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.top ||
              ((placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.left ||
                placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.right) &&
                variation === _enums_js__WEBPACK_IMPORTED_MODULE_1__.end)
            ) {
              sideY = _enums_js__WEBPACK_IMPORTED_MODULE_1__.bottom;
              var offsetY =
                isFixed && offsetParent === win && win.visualViewport
                  ? win.visualViewport.height // $FlowFixMe[prop-missing]
                  : offsetParent[heightProp];
              y -= offsetY - popperRect.height;
              y *= gpuAcceleration ? 1 : -1;
            }

            if (
              placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.left ||
              ((placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.top ||
                placement === _enums_js__WEBPACK_IMPORTED_MODULE_1__.bottom) &&
                variation === _enums_js__WEBPACK_IMPORTED_MODULE_1__.end)
            ) {
              sideX = _enums_js__WEBPACK_IMPORTED_MODULE_1__.right;
              var offsetX =
                isFixed && offsetParent === win && win.visualViewport
                  ? win.visualViewport.width // $FlowFixMe[prop-missing]
                  : offsetParent[widthProp];
              x -= offsetX - popperRect.width;
              x *= gpuAcceleration ? 1 : -1;
            }
          }

          var commonStyles = Object.assign(
            {
              position: position,
            },
            adaptive && unsetSides
          );

          var _ref4 =
            roundOffsets === true
              ? roundOffsetsByDPR({
                  x: x,
                  y: y,
                })
              : {
                  x: x,
                  y: y,
                };

          x = _ref4.x;
          y = _ref4.y;

          if (gpuAcceleration) {
            var _Object$assign;

            return Object.assign(
              {},
              commonStyles,
              ((_Object$assign = {}),
              (_Object$assign[sideY] = hasY ? "0" : ""),
              (_Object$assign[sideX] = hasX ? "0" : ""),
              (_Object$assign.transform =
                (win.devicePixelRatio || 1) <= 1
                  ? "translate(" + x + "px, " + y + "px)"
                  : "translate3d(" + x + "px, " + y + "px, 0)"),
              _Object$assign)
            );
          }

          return Object.assign(
            {},
            commonStyles,
            ((_Object$assign2 = {}),
            (_Object$assign2[sideY] = hasY ? y + "px" : ""),
            (_Object$assign2[sideX] = hasX ? x + "px" : ""),
            (_Object$assign2.transform = ""),
            _Object$assign2)
          );
        }

        function computeStyles(_ref5) {
          var state = _ref5.state,
            options = _ref5.options;
          var _options$gpuAccelerat = options.gpuAcceleration,
            gpuAcceleration =
              _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
            _options$adaptive = options.adaptive,
            adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
            _options$roundOffsets = options.roundOffsets,
            roundOffsets =
              _options$roundOffsets === void 0 ? true : _options$roundOffsets;

          if (true) {
            var transitionProperty =
              (0,
              _dom_utils_getComputedStyle_js__WEBPACK_IMPORTED_MODULE_5__[
                "default"
              ])(state.elements.popper).transitionProperty || "";

            if (
              adaptive &&
              ["transform", "top", "right", "bottom", "left"].some(function (
                property
              ) {
                return transitionProperty.indexOf(property) >= 0;
              })
            ) {
              console.warn(
                [
                  "Popper: Detected CSS transitions on at least one of the following",
                  'CSS properties: "transform", "top", "right", "bottom", "left".',
                  "\n\n",
                  'Disable the "computeStyles" modifier\'s `adaptive` option to allow',
                  "for smooth transitions, or remove these properties from the CSS",
                  "transition declaration on the popper element if only transitioning",
                  "opacity or background-color for example.",
                  "\n\n",
                  "We recommend using the popper element as a wrapper around an inner",
                  "element that can have any CSS property transitioned for animations.",
                ].join(" ")
              );
            }
          }

          var commonStyles = {
            placement: (0,
            _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_6__["default"])(
              state.placement
            ),
            variation: (0,
            _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_7__["default"])(
              state.placement
            ),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === "fixed",
          };

          if (state.modifiersData.popperOffsets != null) {
            state.styles.popper = Object.assign(
              {},
              state.styles.popper,
              mapToStyles(
                Object.assign({}, commonStyles, {
                  offsets: state.modifiersData.popperOffsets,
                  position: state.options.strategy,
                  adaptive: adaptive,
                  roundOffsets: roundOffsets,
                })
              )
            );
          }

          if (state.modifiersData.arrow != null) {
            state.styles.arrow = Object.assign(
              {},
              state.styles.arrow,
              mapToStyles(
                Object.assign({}, commonStyles, {
                  offsets: state.modifiersData.arrow,
                  position: "absolute",
                  adaptive: false,
                  roundOffsets: roundOffsets,
                })
              )
            );
          }

          state.attributes.popper = Object.assign({}, state.attributes.popper, {
            "data-popper-placement": state.placement,
          });
        } // eslint-disable-next-line import/no-unused-modules

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          name: "computeStyles",
          enabled: true,
          phase: "beforeWrite",
          fn: computeStyles,
          data: {},
        };

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/modifiers/eventListeners.js":
      /*!*********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js ***!
  \*********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../dom-utils/getWindow.js */ "./node_modules/@popperjs/core/lib/dom-utils/getWindow.js"
          );
        // eslint-disable-next-line import/no-unused-modules

        var passive = {
          passive: true,
        };

        function effect(_ref) {
          var state = _ref.state,
            instance = _ref.instance,
            options = _ref.options;
          var _options$scroll = options.scroll,
            scroll = _options$scroll === void 0 ? true : _options$scroll,
            _options$resize = options.resize,
            resize = _options$resize === void 0 ? true : _options$resize;
          var window = (0,
          _dom_utils_getWindow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            state.elements.popper
          );
          var scrollParents = [].concat(
            state.scrollParents.reference,
            state.scrollParents.popper
          );

          if (scroll) {
            scrollParents.forEach(function (scrollParent) {
              scrollParent.addEventListener("scroll", instance.update, passive);
            });
          }

          if (resize) {
            window.addEventListener("resize", instance.update, passive);
          }

          return function () {
            if (scroll) {
              scrollParents.forEach(function (scrollParent) {
                scrollParent.removeEventListener(
                  "scroll",
                  instance.update,
                  passive
                );
              });
            }

            if (resize) {
              window.removeEventListener("resize", instance.update, passive);
            }
          };
        } // eslint-disable-next-line import/no-unused-modules

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          name: "eventListeners",
          enabled: true,
          phase: "write",
          fn: function fn() {},
          effect: effect,
          data: {},
        };

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/modifiers/flip.js":
      /*!***********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/flip.js ***!
  \***********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_getOppositePlacement_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../utils/getOppositePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js"
          );
        /* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js"
          );
        /* harmony import */ var _utils_getOppositeVariationPlacement_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../utils/getOppositeVariationPlacement.js */ "./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js"
          );
        /* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ../utils/detectOverflow.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js"
          );
        /* harmony import */ var _utils_computeAutoPlacement_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../utils/computeAutoPlacement.js */ "./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js"
          );
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );
        /* harmony import */ var _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ../utils/getVariation.js */ "./node_modules/@popperjs/core/lib/utils/getVariation.js"
          );

        // eslint-disable-next-line import/no-unused-modules

        function getExpandedFallbackPlacements(placement) {
          if (
            (0,
            _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
              placement
            ) === _enums_js__WEBPACK_IMPORTED_MODULE_1__.auto
          ) {
            return [];
          }

          var oppositePlacement = (0,
          _utils_getOppositePlacement_js__WEBPACK_IMPORTED_MODULE_2__[
            "default"
          ])(placement);
          return [
            (0,
            _utils_getOppositeVariationPlacement_js__WEBPACK_IMPORTED_MODULE_3__[
              "default"
            ])(placement),
            oppositePlacement,
            (0,
            _utils_getOppositeVariationPlacement_js__WEBPACK_IMPORTED_MODULE_3__[
              "default"
            ])(oppositePlacement),
          ];
        }

        function flip(_ref) {
          var state = _ref.state,
            options = _ref.options,
            name = _ref.name;

          if (state.modifiersData[name]._skip) {
            return;
          }

          var _options$mainAxis = options.mainAxis,
            checkMainAxis =
              _options$mainAxis === void 0 ? true : _options$mainAxis,
            _options$altAxis = options.altAxis,
            checkAltAxis =
              _options$altAxis === void 0 ? true : _options$altAxis,
            specifiedFallbackPlacements = options.fallbackPlacements,
            padding = options.padding,
            boundary = options.boundary,
            rootBoundary = options.rootBoundary,
            altBoundary = options.altBoundary,
            _options$flipVariatio = options.flipVariations,
            flipVariations =
              _options$flipVariatio === void 0 ? true : _options$flipVariatio,
            allowedAutoPlacements = options.allowedAutoPlacements;
          var preferredPlacement = state.options.placement;
          var basePlacement = (0,
          _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            preferredPlacement
          );
          var isBasePlacement = basePlacement === preferredPlacement;
          var fallbackPlacements =
            specifiedFallbackPlacements ||
            (isBasePlacement || !flipVariations
              ? [
                  (0,
                  _utils_getOppositePlacement_js__WEBPACK_IMPORTED_MODULE_2__[
                    "default"
                  ])(preferredPlacement),
                ]
              : getExpandedFallbackPlacements(preferredPlacement));
          var placements = [preferredPlacement]
            .concat(fallbackPlacements)
            .reduce(function (acc, placement) {
              return acc.concat(
                (0,
                _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__[
                  "default"
                ])(placement) === _enums_js__WEBPACK_IMPORTED_MODULE_1__.auto
                  ? (0,
                    _utils_computeAutoPlacement_js__WEBPACK_IMPORTED_MODULE_4__[
                      "default"
                    ])(state, {
                      placement: placement,
                      boundary: boundary,
                      rootBoundary: rootBoundary,
                      padding: padding,
                      flipVariations: flipVariations,
                      allowedAutoPlacements: allowedAutoPlacements,
                    })
                  : placement
              );
            }, []);
          var referenceRect = state.rects.reference;
          var popperRect = state.rects.popper;
          var checksMap = new Map();
          var makeFallbackChecks = true;
          var firstFittingPlacement = placements[0];

          for (var i = 0; i < placements.length; i++) {
            var placement = placements[i];

            var _basePlacement = (0,
            _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
              placement
            );

            var isStartVariation =
              (0,
              _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_5__["default"])(
                placement
              ) === _enums_js__WEBPACK_IMPORTED_MODULE_1__.start;
            var isVertical =
              [
                _enums_js__WEBPACK_IMPORTED_MODULE_1__.top,
                _enums_js__WEBPACK_IMPORTED_MODULE_1__.bottom,
              ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? "width" : "height";
            var overflow = (0,
            _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_6__["default"])(
              state,
              {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding,
              }
            );
            var mainVariationSide = isVertical
              ? isStartVariation
                ? _enums_js__WEBPACK_IMPORTED_MODULE_1__.right
                : _enums_js__WEBPACK_IMPORTED_MODULE_1__.left
              : isStartVariation
              ? _enums_js__WEBPACK_IMPORTED_MODULE_1__.bottom
              : _enums_js__WEBPACK_IMPORTED_MODULE_1__.top;

            if (referenceRect[len] > popperRect[len]) {
              mainVariationSide = (0,
              _utils_getOppositePlacement_js__WEBPACK_IMPORTED_MODULE_2__[
                "default"
              ])(mainVariationSide);
            }

            var altVariationSide = (0,
            _utils_getOppositePlacement_js__WEBPACK_IMPORTED_MODULE_2__[
              "default"
            ])(mainVariationSide);
            var checks = [];

            if (checkMainAxis) {
              checks.push(overflow[_basePlacement] <= 0);
            }

            if (checkAltAxis) {
              checks.push(
                overflow[mainVariationSide] <= 0,
                overflow[altVariationSide] <= 0
              );
            }

            if (
              checks.every(function (check) {
                return check;
              })
            ) {
              firstFittingPlacement = placement;
              makeFallbackChecks = false;
              break;
            }

            checksMap.set(placement, checks);
          }

          if (makeFallbackChecks) {
            // `2` may be desired in some cases – research later
            var numberOfChecks = flipVariations ? 3 : 1;

            var _loop = function _loop(_i) {
              var fittingPlacement = placements.find(function (placement) {
                var checks = checksMap.get(placement);

                if (checks) {
                  return checks.slice(0, _i).every(function (check) {
                    return check;
                  });
                }
              });

              if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
              }
            };

            for (var _i = numberOfChecks; _i > 0; _i--) {
              var _ret = _loop(_i);

              if (_ret === "break") break;
            }
          }

          if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
          }
        } // eslint-disable-next-line import/no-unused-modules

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          name: "flip",
          enabled: true,
          phase: "main",
          fn: flip,
          requiresIfExists: ["offset"],
          data: {
            _skip: false,
          },
        };

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/modifiers/hide.js":
      /*!***********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/hide.js ***!
  \***********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );
        /* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../utils/detectOverflow.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js"
          );

        function getSideOffsets(overflow, rect, preventedOffsets) {
          if (preventedOffsets === void 0) {
            preventedOffsets = {
              x: 0,
              y: 0,
            };
          }

          return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x,
          };
        }

        function isAnySideFullyClipped(overflow) {
          return [
            _enums_js__WEBPACK_IMPORTED_MODULE_0__.top,
            _enums_js__WEBPACK_IMPORTED_MODULE_0__.right,
            _enums_js__WEBPACK_IMPORTED_MODULE_0__.bottom,
            _enums_js__WEBPACK_IMPORTED_MODULE_0__.left,
          ].some(function (side) {
            return overflow[side] >= 0;
          });
        }

        function hide(_ref) {
          var state = _ref.state,
            name = _ref.name;
          var referenceRect = state.rects.reference;
          var popperRect = state.rects.popper;
          var preventedOffsets = state.modifiersData.preventOverflow;
          var referenceOverflow = (0,
          _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
            state,
            {
              elementContext: "reference",
            }
          );
          var popperAltOverflow = (0,
          _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
            state,
            {
              altBoundary: true,
            }
          );
          var referenceClippingOffsets = getSideOffsets(
            referenceOverflow,
            referenceRect
          );
          var popperEscapeOffsets = getSideOffsets(
            popperAltOverflow,
            popperRect,
            preventedOffsets
          );
          var isReferenceHidden = isAnySideFullyClipped(
            referenceClippingOffsets
          );
          var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
          state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped,
          };
          state.attributes.popper = Object.assign({}, state.attributes.popper, {
            "data-popper-reference-hidden": isReferenceHidden,
            "data-popper-escaped": hasPopperEscaped,
          });
        } // eslint-disable-next-line import/no-unused-modules

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          name: "hide",
          enabled: true,
          phase: "main",
          requiresIfExists: ["preventOverflow"],
          fn: hide,
        };

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/modifiers/index.js":
      /*!************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/index.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ applyStyles: () =>
            /* reexport safe */ _applyStyles_js__WEBPACK_IMPORTED_MODULE_0__[
              "default"
            ],
          /* harmony export */ arrow: () =>
            /* reexport safe */ _arrow_js__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ],
          /* harmony export */ computeStyles: () =>
            /* reexport safe */ _computeStyles_js__WEBPACK_IMPORTED_MODULE_2__[
              "default"
            ],
          /* harmony export */ eventListeners: () =>
            /* reexport safe */ _eventListeners_js__WEBPACK_IMPORTED_MODULE_3__[
              "default"
            ],
          /* harmony export */ flip: () =>
            /* reexport safe */ _flip_js__WEBPACK_IMPORTED_MODULE_4__[
              "default"
            ],
          /* harmony export */ hide: () =>
            /* reexport safe */ _hide_js__WEBPACK_IMPORTED_MODULE_5__[
              "default"
            ],
          /* harmony export */ offset: () =>
            /* reexport safe */ _offset_js__WEBPACK_IMPORTED_MODULE_6__[
              "default"
            ],
          /* harmony export */ popperOffsets: () =>
            /* reexport safe */ _popperOffsets_js__WEBPACK_IMPORTED_MODULE_7__[
              "default"
            ],
          /* harmony export */ preventOverflow: () =>
            /* reexport safe */ _preventOverflow_js__WEBPACK_IMPORTED_MODULE_8__[
              "default"
            ],
          /* harmony export */
        });
        /* harmony import */ var _applyStyles_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./applyStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/applyStyles.js"
          );
        /* harmony import */ var _arrow_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./arrow.js */ "./node_modules/@popperjs/core/lib/modifiers/arrow.js"
          );
        /* harmony import */ var _computeStyles_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./computeStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/computeStyles.js"
          );
        /* harmony import */ var _eventListeners_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./eventListeners.js */ "./node_modules/@popperjs/core/lib/modifiers/eventListeners.js"
          );
        /* harmony import */ var _flip_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./flip.js */ "./node_modules/@popperjs/core/lib/modifiers/flip.js"
          );
        /* harmony import */ var _hide_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./hide.js */ "./node_modules/@popperjs/core/lib/modifiers/hide.js"
          );
        /* harmony import */ var _offset_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./offset.js */ "./node_modules/@popperjs/core/lib/modifiers/offset.js"
          );
        /* harmony import */ var _popperOffsets_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./popperOffsets.js */ "./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js"
          );
        /* harmony import */ var _preventOverflow_js__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ./preventOverflow.js */ "./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js"
          );

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/modifiers/offset.js":
      /*!*************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/offset.js ***!
  \*************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */ distanceAndSkiddingToXY: () =>
            /* binding */ distanceAndSkiddingToXY,
          /* harmony export */
        });
        /* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js"
          );
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );

        // eslint-disable-next-line import/no-unused-modules

        function distanceAndSkiddingToXY(placement, rects, offset) {
          var basePlacement = (0,
          _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            placement
          );
          var invertDistance =
            [
              _enums_js__WEBPACK_IMPORTED_MODULE_1__.left,
              _enums_js__WEBPACK_IMPORTED_MODULE_1__.top,
            ].indexOf(basePlacement) >= 0
              ? -1
              : 1;

          var _ref =
              typeof offset === "function"
                ? offset(
                    Object.assign({}, rects, {
                      placement: placement,
                    })
                  )
                : offset,
            skidding = _ref[0],
            distance = _ref[1];

          skidding = skidding || 0;
          distance = (distance || 0) * invertDistance;
          return [
            _enums_js__WEBPACK_IMPORTED_MODULE_1__.left,
            _enums_js__WEBPACK_IMPORTED_MODULE_1__.right,
          ].indexOf(basePlacement) >= 0
            ? {
                x: distance,
                y: skidding,
              }
            : {
                x: skidding,
                y: distance,
              };
        }

        function offset(_ref2) {
          var state = _ref2.state,
            options = _ref2.options,
            name = _ref2.name;
          var _options$offset = options.offset,
            offset = _options$offset === void 0 ? [0, 0] : _options$offset;
          var data = _enums_js__WEBPACK_IMPORTED_MODULE_1__.placements.reduce(
            function (acc, placement) {
              acc[placement] = distanceAndSkiddingToXY(
                placement,
                state.rects,
                offset
              );
              return acc;
            },
            {}
          );
          var _data$state$placement = data[state.placement],
            x = _data$state$placement.x,
            y = _data$state$placement.y;

          if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
          }

          state.modifiersData[name] = data;
        } // eslint-disable-next-line import/no-unused-modules

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          name: "offset",
          enabled: true,
          phase: "main",
          requires: ["popperOffsets"],
          fn: offset,
        };

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js":
      /*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js ***!
  \********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _utils_computeOffsets_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/computeOffsets.js */ "./node_modules/@popperjs/core/lib/utils/computeOffsets.js"
          );

        function popperOffsets(_ref) {
          var state = _ref.state,
            name = _ref.name;
          // Offsets are the actual position the popper needs to have to be
          // properly positioned near its reference element
          // This is the most basic placement, and will be adjusted by
          // the modifiers in the next step
          state.modifiersData[name] = (0,
          _utils_computeOffsets_js__WEBPACK_IMPORTED_MODULE_0__["default"])({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: "absolute",
            placement: state.placement,
          });
        } // eslint-disable-next-line import/no-unused-modules

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          name: "popperOffsets",
          enabled: true,
          phase: "read",
          fn: popperOffsets,
          data: {},
        };

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );
        /* harmony import */ var _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../utils/getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js"
          );
        /* harmony import */ var _utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../utils/getMainAxisFromPlacement.js */ "./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js"
          );
        /* harmony import */ var _utils_getAltAxis_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../utils/getAltAxis.js */ "./node_modules/@popperjs/core/lib/utils/getAltAxis.js"
          );
        /* harmony import */ var _utils_within_js__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ../utils/within.js */ "./node_modules/@popperjs/core/lib/utils/within.js"
          );
        /* harmony import */ var _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ../dom-utils/getLayoutRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js"
          );
        /* harmony import */ var _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_9__ =
          __webpack_require__(
            /*! ../dom-utils/getOffsetParent.js */ "./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js"
          );
        /* harmony import */ var _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../utils/detectOverflow.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js"
          );
        /* harmony import */ var _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../utils/getVariation.js */ "./node_modules/@popperjs/core/lib/utils/getVariation.js"
          );
        /* harmony import */ var _utils_getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ../utils/getFreshSideObject.js */ "./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js"
          );
        /* harmony import */ var _utils_math_js__WEBPACK_IMPORTED_MODULE_10__ =
          __webpack_require__(
            /*! ../utils/math.js */ "./node_modules/@popperjs/core/lib/utils/math.js"
          );

        function preventOverflow(_ref) {
          var state = _ref.state,
            options = _ref.options,
            name = _ref.name;
          var _options$mainAxis = options.mainAxis,
            checkMainAxis =
              _options$mainAxis === void 0 ? true : _options$mainAxis,
            _options$altAxis = options.altAxis,
            checkAltAxis =
              _options$altAxis === void 0 ? false : _options$altAxis,
            boundary = options.boundary,
            rootBoundary = options.rootBoundary,
            altBoundary = options.altBoundary,
            padding = options.padding,
            _options$tether = options.tether,
            tether = _options$tether === void 0 ? true : _options$tether,
            _options$tetherOffset = options.tetherOffset,
            tetherOffset =
              _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
          var overflow = (0,
          _utils_detectOverflow_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
            state,
            {
              boundary: boundary,
              rootBoundary: rootBoundary,
              padding: padding,
              altBoundary: altBoundary,
            }
          );
          var basePlacement = (0,
          _utils_getBasePlacement_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
            state.placement
          );
          var variation = (0,
          _utils_getVariation_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
            state.placement
          );
          var isBasePlacement = !variation;
          var mainAxis = (0,
          _utils_getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__[
            "default"
          ])(basePlacement);
          var altAxis = (0,
          _utils_getAltAxis_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
            mainAxis
          );
          var popperOffsets = state.modifiersData.popperOffsets;
          var referenceRect = state.rects.reference;
          var popperRect = state.rects.popper;
          var tetherOffsetValue =
            typeof tetherOffset === "function"
              ? tetherOffset(
                  Object.assign({}, state.rects, {
                    placement: state.placement,
                  })
                )
              : tetherOffset;
          var normalizedTetherOffsetValue =
            typeof tetherOffsetValue === "number"
              ? {
                  mainAxis: tetherOffsetValue,
                  altAxis: tetherOffsetValue,
                }
              : Object.assign(
                  {
                    mainAxis: 0,
                    altAxis: 0,
                  },
                  tetherOffsetValue
                );
          var offsetModifierState = state.modifiersData.offset
            ? state.modifiersData.offset[state.placement]
            : null;
          var data = {
            x: 0,
            y: 0,
          };

          if (!popperOffsets) {
            return;
          }

          if (checkMainAxis) {
            var _offsetModifierState$;

            var mainSide =
              mainAxis === "y"
                ? _enums_js__WEBPACK_IMPORTED_MODULE_5__.top
                : _enums_js__WEBPACK_IMPORTED_MODULE_5__.left;
            var altSide =
              mainAxis === "y"
                ? _enums_js__WEBPACK_IMPORTED_MODULE_5__.bottom
                : _enums_js__WEBPACK_IMPORTED_MODULE_5__.right;
            var len = mainAxis === "y" ? "height" : "width";
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen =
              variation === _enums_js__WEBPACK_IMPORTED_MODULE_5__.start
                ? referenceRect[len]
                : popperRect[len];
            var maxLen =
              variation === _enums_js__WEBPACK_IMPORTED_MODULE_5__.start
                ? -popperRect[len]
                : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
            // outside the reference bounds

            var arrowElement = state.elements.arrow;
            var arrowRect =
              tether && arrowElement
                ? (0,
                  _dom_utils_getLayoutRect_js__WEBPACK_IMPORTED_MODULE_6__[
                    "default"
                  ])(arrowElement)
                : {
                    width: 0,
                    height: 0,
                  };
            var arrowPaddingObject = state.modifiersData["arrow#persistent"]
              ? state.modifiersData["arrow#persistent"].padding
              : (0,
                _utils_getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_7__[
                  "default"
                ])();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
            // to include its full size in the calculation. If the reference is small
            // and near the edge of a boundary, the popper can overflow even if the
            // reference is not overflowing as well (e.g. virtual elements with no
            // width or height)

            var arrowLen = (0,
            _utils_within_js__WEBPACK_IMPORTED_MODULE_8__.within)(
              0,
              referenceRect[len],
              arrowRect[len]
            );
            var minOffset = isBasePlacement
              ? referenceRect[len] / 2 -
                additive -
                arrowLen -
                arrowPaddingMin -
                normalizedTetherOffsetValue.mainAxis
              : minLen -
                arrowLen -
                arrowPaddingMin -
                normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement
              ? -referenceRect[len] / 2 +
                additive +
                arrowLen +
                arrowPaddingMax +
                normalizedTetherOffsetValue.mainAxis
              : maxLen +
                arrowLen +
                arrowPaddingMax +
                normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent =
              state.elements.arrow &&
              (0,
              _dom_utils_getOffsetParent_js__WEBPACK_IMPORTED_MODULE_9__[
                "default"
              ])(state.elements.arrow);
            var clientOffset = arrowOffsetParent
              ? mainAxis === "y"
                ? arrowOffsetParent.clientTop || 0
                : arrowOffsetParent.clientLeft || 0
              : 0;
            var offsetModifierValue =
              (_offsetModifierState$ =
                offsetModifierState == null
                  ? void 0
                  : offsetModifierState[mainAxis]) != null
                ? _offsetModifierState$
                : 0;
            var tetherMin =
              offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0,
            _utils_within_js__WEBPACK_IMPORTED_MODULE_8__.within)(
              tether
                ? (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_10__.min)(
                    min,
                    tetherMin
                  )
                : min,
              offset,
              tether
                ? (0, _utils_math_js__WEBPACK_IMPORTED_MODULE_10__.max)(
                    max,
                    tetherMax
                  )
                : max
            );
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
          }

          if (checkAltAxis) {
            var _offsetModifierState$2;

            var _mainSide =
              mainAxis === "x"
                ? _enums_js__WEBPACK_IMPORTED_MODULE_5__.top
                : _enums_js__WEBPACK_IMPORTED_MODULE_5__.left;

            var _altSide =
              mainAxis === "x"
                ? _enums_js__WEBPACK_IMPORTED_MODULE_5__.bottom
                : _enums_js__WEBPACK_IMPORTED_MODULE_5__.right;

            var _offset = popperOffsets[altAxis];

            var _len = altAxis === "y" ? "height" : "width";

            var _min = _offset + overflow[_mainSide];

            var _max = _offset - overflow[_altSide];

            var isOriginSide =
              [
                _enums_js__WEBPACK_IMPORTED_MODULE_5__.top,
                _enums_js__WEBPACK_IMPORTED_MODULE_5__.left,
              ].indexOf(basePlacement) !== -1;

            var _offsetModifierValue =
              (_offsetModifierState$2 =
                offsetModifierState == null
                  ? void 0
                  : offsetModifierState[altAxis]) != null
                ? _offsetModifierState$2
                : 0;

            var _tetherMin = isOriginSide
              ? _min
              : _offset -
                referenceRect[_len] -
                popperRect[_len] -
                _offsetModifierValue +
                normalizedTetherOffsetValue.altAxis;

            var _tetherMax = isOriginSide
              ? _offset +
                referenceRect[_len] +
                popperRect[_len] -
                _offsetModifierValue -
                normalizedTetherOffsetValue.altAxis
              : _max;

            var _preventedOffset =
              tether && isOriginSide
                ? (0,
                  _utils_within_js__WEBPACK_IMPORTED_MODULE_8__.withinMaxClamp)(
                    _tetherMin,
                    _offset,
                    _tetherMax
                  )
                : (0, _utils_within_js__WEBPACK_IMPORTED_MODULE_8__.within)(
                    tether ? _tetherMin : _min,
                    _offset,
                    tether ? _tetherMax : _max
                  );

            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
          }

          state.modifiersData[name] = data;
        } // eslint-disable-next-line import/no-unused-modules

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          name: "preventOverflow",
          enabled: true,
          phase: "main",
          fn: preventOverflow,
          requiresIfExists: ["offset"],
        };

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/popper-lite.js":
      /*!********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/popper-lite.js ***!
  \********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ createPopper: () => /* binding */ createPopper,
          /* harmony export */ defaultModifiers: () =>
            /* binding */ defaultModifiers,
          /* harmony export */ detectOverflow: () =>
            /* reexport safe */ _createPopper_js__WEBPACK_IMPORTED_MODULE_5__[
              "default"
            ],
          /* harmony export */ popperGenerator: () =>
            /* reexport safe */ _createPopper_js__WEBPACK_IMPORTED_MODULE_4__.popperGenerator,
          /* harmony export */
        });
        /* harmony import */ var _createPopper_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./createPopper.js */ "./node_modules/@popperjs/core/lib/createPopper.js"
          );
        /* harmony import */ var _createPopper_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./createPopper.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js"
          );
        /* harmony import */ var _modifiers_eventListeners_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./modifiers/eventListeners.js */ "./node_modules/@popperjs/core/lib/modifiers/eventListeners.js"
          );
        /* harmony import */ var _modifiers_popperOffsets_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./modifiers/popperOffsets.js */ "./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js"
          );
        /* harmony import */ var _modifiers_computeStyles_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./modifiers/computeStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/computeStyles.js"
          );
        /* harmony import */ var _modifiers_applyStyles_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./modifiers/applyStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/applyStyles.js"
          );

        var defaultModifiers = [
          _modifiers_eventListeners_js__WEBPACK_IMPORTED_MODULE_0__["default"],
          _modifiers_popperOffsets_js__WEBPACK_IMPORTED_MODULE_1__["default"],
          _modifiers_computeStyles_js__WEBPACK_IMPORTED_MODULE_2__["default"],
          _modifiers_applyStyles_js__WEBPACK_IMPORTED_MODULE_3__["default"],
        ];
        var createPopper = /*#__PURE__*/ (0,
        _createPopper_js__WEBPACK_IMPORTED_MODULE_4__.popperGenerator)({
          defaultModifiers: defaultModifiers,
        }); // eslint-disable-next-line import/no-unused-modules

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/popper.js":
      /*!***************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/popper.js ***!
  \***************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ applyStyles: () =>
            /* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.applyStyles,
          /* harmony export */ arrow: () =>
            /* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.arrow,
          /* harmony export */ computeStyles: () =>
            /* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.computeStyles,
          /* harmony export */ createPopper: () => /* binding */ createPopper,
          /* harmony export */ createPopperLite: () =>
            /* reexport safe */ _popper_lite_js__WEBPACK_IMPORTED_MODULE_11__.createPopper,
          /* harmony export */ defaultModifiers: () =>
            /* binding */ defaultModifiers,
          /* harmony export */ detectOverflow: () =>
            /* reexport safe */ _createPopper_js__WEBPACK_IMPORTED_MODULE_10__[
              "default"
            ],
          /* harmony export */ eventListeners: () =>
            /* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.eventListeners,
          /* harmony export */ flip: () =>
            /* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.flip,
          /* harmony export */ hide: () =>
            /* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.hide,
          /* harmony export */ offset: () =>
            /* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.offset,
          /* harmony export */ popperGenerator: () =>
            /* reexport safe */ _createPopper_js__WEBPACK_IMPORTED_MODULE_9__.popperGenerator,
          /* harmony export */ popperOffsets: () =>
            /* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.popperOffsets,
          /* harmony export */ preventOverflow: () =>
            /* reexport safe */ _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__.preventOverflow,
          /* harmony export */
        });
        /* harmony import */ var _createPopper_js__WEBPACK_IMPORTED_MODULE_9__ =
          __webpack_require__(
            /*! ./createPopper.js */ "./node_modules/@popperjs/core/lib/createPopper.js"
          );
        /* harmony import */ var _createPopper_js__WEBPACK_IMPORTED_MODULE_10__ =
          __webpack_require__(
            /*! ./createPopper.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js"
          );
        /* harmony import */ var _modifiers_eventListeners_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./modifiers/eventListeners.js */ "./node_modules/@popperjs/core/lib/modifiers/eventListeners.js"
          );
        /* harmony import */ var _modifiers_popperOffsets_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./modifiers/popperOffsets.js */ "./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js"
          );
        /* harmony import */ var _modifiers_computeStyles_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./modifiers/computeStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/computeStyles.js"
          );
        /* harmony import */ var _modifiers_applyStyles_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./modifiers/applyStyles.js */ "./node_modules/@popperjs/core/lib/modifiers/applyStyles.js"
          );
        /* harmony import */ var _modifiers_offset_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./modifiers/offset.js */ "./node_modules/@popperjs/core/lib/modifiers/offset.js"
          );
        /* harmony import */ var _modifiers_flip_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./modifiers/flip.js */ "./node_modules/@popperjs/core/lib/modifiers/flip.js"
          );
        /* harmony import */ var _modifiers_preventOverflow_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./modifiers/preventOverflow.js */ "./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js"
          );
        /* harmony import */ var _modifiers_arrow_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./modifiers/arrow.js */ "./node_modules/@popperjs/core/lib/modifiers/arrow.js"
          );
        /* harmony import */ var _modifiers_hide_js__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ./modifiers/hide.js */ "./node_modules/@popperjs/core/lib/modifiers/hide.js"
          );
        /* harmony import */ var _popper_lite_js__WEBPACK_IMPORTED_MODULE_11__ =
          __webpack_require__(
            /*! ./popper-lite.js */ "./node_modules/@popperjs/core/lib/popper-lite.js"
          );
        /* harmony import */ var _modifiers_index_js__WEBPACK_IMPORTED_MODULE_12__ =
          __webpack_require__(
            /*! ./modifiers/index.js */ "./node_modules/@popperjs/core/lib/modifiers/index.js"
          );

        var defaultModifiers = [
          _modifiers_eventListeners_js__WEBPACK_IMPORTED_MODULE_0__["default"],
          _modifiers_popperOffsets_js__WEBPACK_IMPORTED_MODULE_1__["default"],
          _modifiers_computeStyles_js__WEBPACK_IMPORTED_MODULE_2__["default"],
          _modifiers_applyStyles_js__WEBPACK_IMPORTED_MODULE_3__["default"],
          _modifiers_offset_js__WEBPACK_IMPORTED_MODULE_4__["default"],
          _modifiers_flip_js__WEBPACK_IMPORTED_MODULE_5__["default"],
          _modifiers_preventOverflow_js__WEBPACK_IMPORTED_MODULE_6__["default"],
          _modifiers_arrow_js__WEBPACK_IMPORTED_MODULE_7__["default"],
          _modifiers_hide_js__WEBPACK_IMPORTED_MODULE_8__["default"],
        ];
        var createPopper = /*#__PURE__*/ (0,
        _createPopper_js__WEBPACK_IMPORTED_MODULE_9__.popperGenerator)({
          defaultModifiers: defaultModifiers,
        }); // eslint-disable-next-line import/no-unused-modules

        // eslint-disable-next-line import/no-unused-modules

        // eslint-disable-next-line import/no-unused-modules

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js ***!
  \***********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () =>
            /* binding */ computeAutoPlacement,
          /* harmony export */
        });
        /* harmony import */ var _getVariation_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./getVariation.js */ "./node_modules/@popperjs/core/lib/utils/getVariation.js"
          );
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );
        /* harmony import */ var _detectOverflow_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./detectOverflow.js */ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js"
          );
        /* harmony import */ var _getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js"
          );

        function computeAutoPlacement(state, options) {
          if (options === void 0) {
            options = {};
          }

          var _options = options,
            placement = _options.placement,
            boundary = _options.boundary,
            rootBoundary = _options.rootBoundary,
            padding = _options.padding,
            flipVariations = _options.flipVariations,
            _options$allowedAutoP = _options.allowedAutoPlacements,
            allowedAutoPlacements =
              _options$allowedAutoP === void 0
                ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.placements
                : _options$allowedAutoP;
          var variation = (0,
          _getVariation_js__WEBPACK_IMPORTED_MODULE_1__["default"])(placement);
          var placements = variation
            ? flipVariations
              ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.variationPlacements
              : _enums_js__WEBPACK_IMPORTED_MODULE_0__.variationPlacements.filter(
                  function (placement) {
                    return (
                      (0,
                      _getVariation_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
                        placement
                      ) === variation
                    );
                  }
                )
            : _enums_js__WEBPACK_IMPORTED_MODULE_0__.basePlacements;
          var allowedPlacements = placements.filter(function (placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
          });

          if (allowedPlacements.length === 0) {
            allowedPlacements = placements;

            if (true) {
              console.error(
                [
                  "Popper: The `allowedAutoPlacements` option did not allow any",
                  "placements. Ensure the `placement` option matches the variation",
                  "of the allowed placements.",
                  'For example, "auto" cannot be used to allow "bottom-start".',
                  'Use "auto-start" instead.',
                ].join(" ")
              );
            }
          } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...

          var overflows = allowedPlacements.reduce(function (acc, placement) {
            acc[placement] = (0,
            _detectOverflow_js__WEBPACK_IMPORTED_MODULE_2__["default"])(state, {
              placement: placement,
              boundary: boundary,
              rootBoundary: rootBoundary,
              padding: padding,
            })[
              (0, _getBasePlacement_js__WEBPACK_IMPORTED_MODULE_3__["default"])(
                placement
              )
            ];
            return acc;
          }, {});
          return Object.keys(overflows).sort(function (a, b) {
            return overflows[a] - overflows[b];
          });
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/computeOffsets.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/computeOffsets.js ***!
  \*****************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ computeOffsets,
          /* harmony export */
        });
        /* harmony import */ var _getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getBasePlacement.js */ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js"
          );
        /* harmony import */ var _getVariation_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./getVariation.js */ "./node_modules/@popperjs/core/lib/utils/getVariation.js"
          );
        /* harmony import */ var _getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./getMainAxisFromPlacement.js */ "./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js"
          );
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );

        function computeOffsets(_ref) {
          var reference = _ref.reference,
            element = _ref.element,
            placement = _ref.placement;
          var basePlacement = placement
            ? (0, _getBasePlacement_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                placement
              )
            : null;
          var variation = placement
            ? (0, _getVariation_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
                placement
              )
            : null;
          var commonX = reference.x + reference.width / 2 - element.width / 2;
          var commonY = reference.y + reference.height / 2 - element.height / 2;
          var offsets;

          switch (basePlacement) {
            case _enums_js__WEBPACK_IMPORTED_MODULE_2__.top:
              offsets = {
                x: commonX,
                y: reference.y - element.height,
              };
              break;

            case _enums_js__WEBPACK_IMPORTED_MODULE_2__.bottom:
              offsets = {
                x: commonX,
                y: reference.y + reference.height,
              };
              break;

            case _enums_js__WEBPACK_IMPORTED_MODULE_2__.right:
              offsets = {
                x: reference.x + reference.width,
                y: commonY,
              };
              break;

            case _enums_js__WEBPACK_IMPORTED_MODULE_2__.left:
              offsets = {
                x: reference.x - element.width,
                y: commonY,
              };
              break;

            default:
              offsets = {
                x: reference.x,
                y: reference.y,
              };
          }

          var mainAxis = basePlacement
            ? (0,
              _getMainAxisFromPlacement_js__WEBPACK_IMPORTED_MODULE_3__[
                "default"
              ])(basePlacement)
            : null;

          if (mainAxis != null) {
            var len = mainAxis === "y" ? "height" : "width";

            switch (variation) {
              case _enums_js__WEBPACK_IMPORTED_MODULE_2__.start:
                offsets[mainAxis] =
                  offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;

              case _enums_js__WEBPACK_IMPORTED_MODULE_2__.end:
                offsets[mainAxis] =
                  offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;

              default:
            }
          }

          return offsets;
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/debounce.js":
      /*!***********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/debounce.js ***!
  \***********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ debounce,
          /* harmony export */
        });
        function debounce(fn) {
          var pending;
          return function () {
            if (!pending) {
              pending = new Promise(function (resolve) {
                Promise.resolve().then(function () {
                  pending = undefined;
                  resolve(fn());
                });
              });
            }

            return pending;
          };
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/detectOverflow.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/detectOverflow.js ***!
  \*****************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ detectOverflow,
          /* harmony export */
        });
        /* harmony import */ var _dom_utils_getClippingRect_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../dom-utils/getClippingRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js"
          );
        /* harmony import */ var _dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ../dom-utils/getDocumentElement.js */ "./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js"
          );
        /* harmony import */ var _dom_utils_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ../dom-utils/getBoundingClientRect.js */ "./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js"
          );
        /* harmony import */ var _computeOffsets_js__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./computeOffsets.js */ "./node_modules/@popperjs/core/lib/utils/computeOffsets.js"
          );
        /* harmony import */ var _rectToClientRect_js__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ./rectToClientRect.js */ "./node_modules/@popperjs/core/lib/utils/rectToClientRect.js"
          );
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );
        /* harmony import */ var _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ../dom-utils/instanceOf.js */ "./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js"
          );
        /* harmony import */ var _mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./mergePaddingObject.js */ "./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js"
          );
        /* harmony import */ var _expandToHashMap_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./expandToHashMap.js */ "./node_modules/@popperjs/core/lib/utils/expandToHashMap.js"
          );

        // eslint-disable-next-line import/no-unused-modules

        function detectOverflow(state, options) {
          if (options === void 0) {
            options = {};
          }

          var _options = options,
            _options$placement = _options.placement,
            placement =
              _options$placement === void 0
                ? state.placement
                : _options$placement,
            _options$strategy = _options.strategy,
            strategy =
              _options$strategy === void 0 ? state.strategy : _options$strategy,
            _options$boundary = _options.boundary,
            boundary =
              _options$boundary === void 0
                ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.clippingParents
                : _options$boundary,
            _options$rootBoundary = _options.rootBoundary,
            rootBoundary =
              _options$rootBoundary === void 0
                ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.viewport
                : _options$rootBoundary,
            _options$elementConte = _options.elementContext,
            elementContext =
              _options$elementConte === void 0
                ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.popper
                : _options$elementConte,
            _options$altBoundary = _options.altBoundary,
            altBoundary =
              _options$altBoundary === void 0 ? false : _options$altBoundary,
            _options$padding = _options.padding,
            padding = _options$padding === void 0 ? 0 : _options$padding;
          var paddingObject = (0,
          _mergePaddingObject_js__WEBPACK_IMPORTED_MODULE_1__["default"])(
            typeof padding !== "number"
              ? padding
              : (0,
                _expandToHashMap_js__WEBPACK_IMPORTED_MODULE_2__["default"])(
                  padding,
                  _enums_js__WEBPACK_IMPORTED_MODULE_0__.basePlacements
                )
          );
          var altContext =
            elementContext === _enums_js__WEBPACK_IMPORTED_MODULE_0__.popper
              ? _enums_js__WEBPACK_IMPORTED_MODULE_0__.reference
              : _enums_js__WEBPACK_IMPORTED_MODULE_0__.popper;
          var popperRect = state.rects.popper;
          var element =
            state.elements[altBoundary ? altContext : elementContext];
          var clippingClientRect = (0,
          _dom_utils_getClippingRect_js__WEBPACK_IMPORTED_MODULE_3__[
            "default"
          ])(
            (0,
            _dom_utils_instanceOf_js__WEBPACK_IMPORTED_MODULE_4__.isElement)(
              element
            )
              ? element
              : element.contextElement ||
                  (0,
                  _dom_utils_getDocumentElement_js__WEBPACK_IMPORTED_MODULE_5__[
                    "default"
                  ])(state.elements.popper),
            boundary,
            rootBoundary,
            strategy
          );
          var referenceClientRect = (0,
          _dom_utils_getBoundingClientRect_js__WEBPACK_IMPORTED_MODULE_6__[
            "default"
          ])(state.elements.reference);
          var popperOffsets = (0,
          _computeOffsets_js__WEBPACK_IMPORTED_MODULE_7__["default"])({
            reference: referenceClientRect,
            element: popperRect,
            strategy: "absolute",
            placement: placement,
          });
          var popperClientRect = (0,
          _rectToClientRect_js__WEBPACK_IMPORTED_MODULE_8__["default"])(
            Object.assign({}, popperRect, popperOffsets)
          );
          var elementClientRect =
            elementContext === _enums_js__WEBPACK_IMPORTED_MODULE_0__.popper
              ? popperClientRect
              : referenceClientRect; // positive = overflowing the clipping rect
          // 0 or negative = within the clipping rect

          var overflowOffsets = {
            top:
              clippingClientRect.top -
              elementClientRect.top +
              paddingObject.top,
            bottom:
              elementClientRect.bottom -
              clippingClientRect.bottom +
              paddingObject.bottom,
            left:
              clippingClientRect.left -
              elementClientRect.left +
              paddingObject.left,
            right:
              elementClientRect.right -
              clippingClientRect.right +
              paddingObject.right,
          };
          var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

          if (
            elementContext === _enums_js__WEBPACK_IMPORTED_MODULE_0__.popper &&
            offsetData
          ) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function (key) {
              var multiply =
                [
                  _enums_js__WEBPACK_IMPORTED_MODULE_0__.right,
                  _enums_js__WEBPACK_IMPORTED_MODULE_0__.bottom,
                ].indexOf(key) >= 0
                  ? 1
                  : -1;
              var axis =
                [
                  _enums_js__WEBPACK_IMPORTED_MODULE_0__.top,
                  _enums_js__WEBPACK_IMPORTED_MODULE_0__.bottom,
                ].indexOf(key) >= 0
                  ? "y"
                  : "x";
              overflowOffsets[key] += offset[axis] * multiply;
            });
          }

          return overflowOffsets;
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/expandToHashMap.js":
      /*!******************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js ***!
  \******************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ expandToHashMap,
          /* harmony export */
        });
        function expandToHashMap(value, keys) {
          return keys.reduce(function (hashMap, key) {
            hashMap[key] = value;
            return hashMap;
          }, {});
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/format.js":
      /*!*********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/format.js ***!
  \*********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ format,
          /* harmony export */
        });
        function format(str) {
          for (
            var _len = arguments.length,
              args = new Array(_len > 1 ? _len - 1 : 0),
              _key = 1;
            _key < _len;
            _key++
          ) {
            args[_key - 1] = arguments[_key];
          }

          return [].concat(args).reduce(function (p, c) {
            return p.replace(/%s/, c);
          }, str);
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/getAltAxis.js":
      /*!*************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getAltAxis.js ***!
  \*************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getAltAxis,
          /* harmony export */
        });
        function getAltAxis(axis) {
          return axis === "x" ? "y" : "x";
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/getBasePlacement.js":
      /*!*******************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js ***!
  \*******************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getBasePlacement,
          /* harmony export */
        });

        function getBasePlacement(placement) {
          return placement.split("-")[0];
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js":
      /*!*********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js ***!
  \*********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getFreshSideObject,
          /* harmony export */
        });
        function getFreshSideObject() {
          return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          };
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js":
      /*!***************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js ***!
  \***************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () =>
            /* binding */ getMainAxisFromPlacement,
          /* harmony export */
        });
        function getMainAxisFromPlacement(placement) {
          return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js ***!
  \***********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () =>
            /* binding */ getOppositePlacement,
          /* harmony export */
        });
        var hash = {
          left: "right",
          right: "left",
          bottom: "top",
          top: "bottom",
        };
        function getOppositePlacement(placement) {
          return placement.replace(
            /left|right|bottom|top/g,
            function (matched) {
              return hash[matched];
            }
          );
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js":
      /*!********************************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js ***!
  \********************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () =>
            /* binding */ getOppositeVariationPlacement,
          /* harmony export */
        });
        var hash = {
          start: "end",
          end: "start",
        };
        function getOppositeVariationPlacement(placement) {
          return placement.replace(/start|end/g, function (matched) {
            return hash[matched];
          });
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/getVariation.js":
      /*!***************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/getVariation.js ***!
  \***************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getVariation,
          /* harmony export */
        });
        function getVariation(placement) {
          return placement.split("-")[1];
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/math.js":
      /*!*******************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/math.js ***!
  \*******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ max: () => /* binding */ max,
          /* harmony export */ min: () => /* binding */ min,
          /* harmony export */ round: () => /* binding */ round,
          /* harmony export */
        });
        var max = Math.max;
        var min = Math.min;
        var round = Math.round;

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/mergeByName.js":
      /*!**************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/mergeByName.js ***!
  \**************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ mergeByName,
          /* harmony export */
        });
        function mergeByName(modifiers) {
          var merged = modifiers.reduce(function (merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing
              ? Object.assign({}, existing, current, {
                  options: Object.assign({}, existing.options, current.options),
                  data: Object.assign({}, existing.data, current.data),
                })
              : current;
            return merged;
          }, {}); // IE11 does not support Object.values

          return Object.keys(merged).map(function (key) {
            return merged[key];
          });
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js":
      /*!*********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js ***!
  \*********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ mergePaddingObject,
          /* harmony export */
        });
        /* harmony import */ var _getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./getFreshSideObject.js */ "./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js"
          );

        function mergePaddingObject(paddingObject) {
          return Object.assign(
            {},
            (0,
            _getFreshSideObject_js__WEBPACK_IMPORTED_MODULE_0__["default"])(),
            paddingObject
          );
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/orderModifiers.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/orderModifiers.js ***!
  \*****************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ orderModifiers,
          /* harmony export */
        });
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );
        // source: https://stackoverflow.com/questions/49875255

        function order(modifiers) {
          var map = new Map();
          var visited = new Set();
          var result = [];
          modifiers.forEach(function (modifier) {
            map.set(modifier.name, modifier);
          }); // On visiting object, check for its dependencies and visit them recursively

          function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(
              modifier.requires || [],
              modifier.requiresIfExists || []
            );
            requires.forEach(function (dep) {
              if (!visited.has(dep)) {
                var depModifier = map.get(dep);

                if (depModifier) {
                  sort(depModifier);
                }
              }
            });
            result.push(modifier);
          }

          modifiers.forEach(function (modifier) {
            if (!visited.has(modifier.name)) {
              // check for visited object
              sort(modifier);
            }
          });
          return result;
        }

        function orderModifiers(modifiers) {
          // order based on dependencies
          var orderedModifiers = order(modifiers); // order based on phase

          return _enums_js__WEBPACK_IMPORTED_MODULE_0__.modifierPhases.reduce(
            function (acc, phase) {
              return acc.concat(
                orderedModifiers.filter(function (modifier) {
                  return modifier.phase === phase;
                })
              );
            },
            []
          );
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/rectToClientRect.js":
      /*!*******************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js ***!
  \*******************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ rectToClientRect,
          /* harmony export */
        });
        function rectToClientRect(rect) {
          return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height,
          });
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/uniqueBy.js":
      /*!***********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/uniqueBy.js ***!
  \***********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ uniqueBy,
          /* harmony export */
        });
        function uniqueBy(arr, fn) {
          var identifiers = new Set();
          return arr.filter(function (item) {
            var identifier = fn(item);

            if (!identifiers.has(identifier)) {
              identifiers.add(identifier);
              return true;
            }
          });
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/userAgent.js":
      /*!************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/userAgent.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ getUAString,
          /* harmony export */
        });
        function getUAString() {
          var uaData = navigator.userAgentData;

          if (uaData != null && uaData.brands) {
            return uaData.brands
              .map(function (item) {
                return item.brand + "/" + item.version;
              })
              .join(" ");
          }

          return navigator.userAgent;
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/validateModifiers.js":
      /*!********************************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/validateModifiers.js ***!
  \********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ validateModifiers,
          /* harmony export */
        });
        /* harmony import */ var _format_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./format.js */ "./node_modules/@popperjs/core/lib/utils/format.js"
          );
        /* harmony import */ var _enums_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../enums.js */ "./node_modules/@popperjs/core/lib/enums.js"
          );

        var INVALID_MODIFIER_ERROR =
          'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
        var MISSING_DEPENDENCY_ERROR =
          'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
        var VALID_PROPERTIES = [
          "name",
          "enabled",
          "phase",
          "fn",
          "effect",
          "requires",
          "options",
        ];
        function validateModifiers(modifiers) {
          modifiers.forEach(function (modifier) {
            []
              .concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
              .filter(function (value, index, self) {
                return self.indexOf(value) === index;
              })
              .forEach(function (key) {
                switch (key) {
                  case "name":
                    if (typeof modifier.name !== "string") {
                      console.error(
                        (0, _format_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                          INVALID_MODIFIER_ERROR,
                          String(modifier.name),
                          '"name"',
                          '"string"',
                          '"' + String(modifier.name) + '"'
                        )
                      );
                    }

                    break;

                  case "enabled":
                    if (typeof modifier.enabled !== "boolean") {
                      console.error(
                        (0, _format_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                          INVALID_MODIFIER_ERROR,
                          modifier.name,
                          '"enabled"',
                          '"boolean"',
                          '"' + String(modifier.enabled) + '"'
                        )
                      );
                    }

                    break;

                  case "phase":
                    if (
                      _enums_js__WEBPACK_IMPORTED_MODULE_1__.modifierPhases.indexOf(
                        modifier.phase
                      ) < 0
                    ) {
                      console.error(
                        (0, _format_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                          INVALID_MODIFIER_ERROR,
                          modifier.name,
                          '"phase"',
                          "either " +
                            _enums_js__WEBPACK_IMPORTED_MODULE_1__.modifierPhases.join(
                              ", "
                            ),
                          '"' + String(modifier.phase) + '"'
                        )
                      );
                    }

                    break;

                  case "fn":
                    if (typeof modifier.fn !== "function") {
                      console.error(
                        (0, _format_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                          INVALID_MODIFIER_ERROR,
                          modifier.name,
                          '"fn"',
                          '"function"',
                          '"' + String(modifier.fn) + '"'
                        )
                      );
                    }

                    break;

                  case "effect":
                    if (
                      modifier.effect != null &&
                      typeof modifier.effect !== "function"
                    ) {
                      console.error(
                        (0, _format_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                          INVALID_MODIFIER_ERROR,
                          modifier.name,
                          '"effect"',
                          '"function"',
                          '"' + String(modifier.fn) + '"'
                        )
                      );
                    }

                    break;

                  case "requires":
                    if (
                      modifier.requires != null &&
                      !Array.isArray(modifier.requires)
                    ) {
                      console.error(
                        (0, _format_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                          INVALID_MODIFIER_ERROR,
                          modifier.name,
                          '"requires"',
                          '"array"',
                          '"' + String(modifier.requires) + '"'
                        )
                      );
                    }

                    break;

                  case "requiresIfExists":
                    if (!Array.isArray(modifier.requiresIfExists)) {
                      console.error(
                        (0, _format_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                          INVALID_MODIFIER_ERROR,
                          modifier.name,
                          '"requiresIfExists"',
                          '"array"',
                          '"' + String(modifier.requiresIfExists) + '"'
                        )
                      );
                    }

                    break;

                  case "options":
                  case "data":
                    break;

                  default:
                    console.error(
                      'PopperJS: an invalid property has been provided to the "' +
                        modifier.name +
                        '" modifier, valid properties are ' +
                        VALID_PROPERTIES.map(function (s) {
                          return '"' + s + '"';
                        }).join(", ") +
                        '; but "' +
                        key +
                        '" was provided.'
                    );
                }

                modifier.requires &&
                  modifier.requires.forEach(function (requirement) {
                    if (
                      modifiers.find(function (mod) {
                        return mod.name === requirement;
                      }) == null
                    ) {
                      console.error(
                        (0, _format_js__WEBPACK_IMPORTED_MODULE_0__["default"])(
                          MISSING_DEPENDENCY_ERROR,
                          String(modifier.name),
                          requirement,
                          requirement
                        )
                      );
                    }
                  });
              });
          });
        }

        /***/
      },

    /***/ "./node_modules/@popperjs/core/lib/utils/within.js":
      /*!*********************************************************!*\
  !*** ./node_modules/@popperjs/core/lib/utils/within.js ***!
  \*********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ within: () => /* binding */ within,
          /* harmony export */ withinMaxClamp: () =>
            /* binding */ withinMaxClamp,
          /* harmony export */
        });
        /* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./math.js */ "./node_modules/@popperjs/core/lib/utils/math.js"
          );

        function within(min, value, max) {
          return (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.max)(
            min,
            (0, _math_js__WEBPACK_IMPORTED_MODULE_0__.min)(value, max)
          );
        }
        function withinMaxClamp(min, value, max) {
          var v = within(min, value, max);
          return v > max ? max : v;
        }

        /***/
      },

    /***/ "./node_modules/@shopify/theme-images/images.js":
      /*!******************************************************!*\
  !*** ./node_modules/@shopify/theme-images/images.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ getSizedImageUrl: () =>
            /* binding */ getSizedImageUrl,
          /* harmony export */ imageSize: () => /* binding */ imageSize,
          /* harmony export */ loadImage: () => /* binding */ loadImage,
          /* harmony export */ preload: () => /* binding */ preload,
          /* harmony export */ removeProtocol: () =>
            /* binding */ removeProtocol,
          /* harmony export */
        });
        /**
         * Image Helper Functions
         * -----------------------------------------------------------------------------
         * https://github.com/Shopify/slate.git.
         *
         */

        /**
         * Preloads an image in memory and uses the browsers cache to store it until needed.
         *
         * @param {Array} images - A list of image urls
         * @param {String} size - A shopify image size attribute
         */

        function preload(images, size) {
          if (typeof images === "string") {
            images = [images];
          }

          for (let i = 0; i < images.length; i++) {
            const image = images[i];
            loadImage(getSizedImageUrl(image, size));
          }
        }

        /**
         * Loads and caches an image in the browsers cache.
         * @param {string} path - An image url
         */
        function loadImage(path) {
          new Image().src = path;
        }

        /**
         * Find the Shopify image attribute size
         *
         * @param {string} src
         * @returns {null}
         */
        function imageSize(src) {
          const match = src.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
          );

          if (match) {
            return match[1];
          } else {
            return null;
          }
        }

        /**
         * Adds a Shopify size attribute to a URL
         *
         * @param src
         * @param size
         * @returns {*}
         */
        function getSizedImageUrl(src, size) {
          if (size === null) {
            return src;
          }

          if (size === "master") {
            return removeProtocol(src);
          }

          const match = src.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          );

          if (match) {
            const prefix = src.split(match[0]);
            const suffix = match[0];

            return removeProtocol(`${prefix[0]}_${size}${suffix}`);
          } else {
            return null;
          }
        }

        function removeProtocol(path) {
          return path.replace(/http(s)?:/, "");
        }

        /***/
      },

    /***/ "./src/js/lib/VideoModalHandler.js":
      /*!*****************************************!*\
  !*** ./src/js/lib/VideoModalHandler.js ***!
  \*****************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        var VideoModalHandler = function VideoModalHandler() {
          var videoBtn = document.querySelectorAll(".open-modal");
          if (videoBtn.length > 0) {
            videoBtn.forEach(function (el) {
              if (el.classList.contains("hot")) {
                return;
              }
              el.classList.add("hot");
              el.addEventListener("click", function (e) {
                document.body.classList.add("showing-modal");
                var modalId = el.getAttribute("data-modal-id");
                var modal = document.querySelector("#".concat(modalId));
                if (modal) {
                  modal.classList.add("active");
                  var video = modal.querySelector("video");
                  if (video) {
                    video.play();
                  }
                }
              });
            });
          }
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          VideoModalHandler;

        /***/
      },

    /***/ "./src/js/lib/accessibility.js":
      /*!*************************************!*\
  !*** ./src/js/lib/accessibility.js ***!
  \*************************************/
      /***/ () => {
        var handleFirstTab = function handleFirstTab(e) {
          if (e.keyCode === 9) {
            document.body.classList.add("user-is-tabbing");
            window.removeEventListener("keydown", handleFirstTab);
            window.addEventListener("mousedown", handleMouseDownOnce);
          }
        };
        var handleMouseDownOnce = function handleMouseDownOnce() {
          document.body.classList.remove("user-is-tabbing");
          window.removeEventListener("mousedown", handleMouseDownOnce);
          window.addEventListener("keydown", handleFirstTab);
        };
        window.addEventListener("keydown", handleFirstTab);

        /***/
      },

    /***/ "./src/js/lib/appState.js":
      /*!********************************!*\
  !*** ./src/js/lib/appState.js ***!
  \********************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          isSearchOpen: false,
          isMiniCartOpen: false,
          activeVariant: {},
          lastAdd: null,
          cart: window.BARREL.cart,
        };

        /***/
      },

    /***/ "./src/js/lib/cart.js":
      /*!****************************!*\
  !*** ./src/js/lib/cart.js ***!
  \****************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! nanoajax */ "./node_modules/nanoajax/index.js"
          );
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      "function" == typeof Symbol &&
                      obj.constructor === Symbol &&
                      obj !== Symbol.prototype
                      ? "symbol"
                      : typeof obj;
                  }),
            _typeof(obj)
          );
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(
              target,
              _toPropertyKey(descriptor.key),
              descriptor
            );
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          Object.defineProperty(Constructor, "prototype", { writable: false });
          return Constructor;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }

        var Cart = /*#__PURE__*/ (function () {
          function Cart() {
            _classCallCheck(this, Cart);
          }
          _createClass(Cart, [
            {
              key: "get",
              value: function get() {
                return new Promise(function (resolve) {
                  nanoajax__WEBPACK_IMPORTED_MODULE_0__.ajax(
                    {
                      url: "/cart.js",
                      method: "get",
                    },
                    function (code, responseText, request) {
                      var cart = JSON.parse(responseText);
                      resolve(cart);
                    }
                  );
                });
              },
            },
            {
              key: "generateShopifyCartUpdateBody",
              value: function generateShopifyCartUpdateBody(_ref) {
                var id = _ref.id,
                  quantity = _ref.quantity;
                return "updates[".concat(id, "]=").concat(quantity);
              },
            },
            {
              key: "update",
              value: function update(data) {
                var _this = this;
                return new Promise(function (resolve, reject) {
                  nanoajax__WEBPACK_IMPORTED_MODULE_0__.ajax(
                    {
                      url: "/cart/update.js",
                      method: "post",
                      body: _this.generateShopifyCartUpdateBody(data),
                    },
                    function (code, responseText, request) {
                      var cart = JSON.parse(responseText);
                      if (Number(code) !== 200) {
                        cart["errors"] = [cart.description];
                      }
                      resolve(cart);
                    }
                  );
                });
              },
            },
            {
              key: "generateShopifyCartAddBody",
              value: function generateShopifyCartAddBody(_ref2) {
                var id = _ref2.id,
                  quantity = _ref2.quantity;
                return "quantity=".concat(quantity, "&id=").concat(id);
              },

              /**
               * Adds a product to the Shopify cart
               *
               * @param {Object} data {id: <id>, quantity: <Number>}
               */
            },
            {
              key: "add",
              value: function add(data) {
                var _this2 = this;
                return new Promise(function (resolve) {
                  nanoajax__WEBPACK_IMPORTED_MODULE_0__.ajax(
                    {
                      url: "/cart/add.js",
                      method: "post",
                      body: _this2.generateShopifyCartAddBody(data),
                    },
                    function (code, responseText, request) {
                      var cart = JSON.parse(responseText);
                      resolve(cart);
                    }
                  );
                });
              },
            },
          ]);
          return Cart;
        })();
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          new Cart();

        /***/
      },

    /***/ "./src/js/lib/init.js":
      /*!****************************!*\
  !*** ./src/js/lib/init.js ***!
  \****************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */ loadVueModules: () =>
            /* binding */ loadVueModules,
          /* harmony export */
        });
        function _toConsumableArray(arr) {
          return (
            _arrayWithoutHoles(arr) ||
            _iterableToArray(arr) ||
            _unsupportedIterableToArray(arr) ||
            _nonIterableSpread()
          );
        }
        function _nonIterableSpread() {
          throw new TypeError(
            "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        }
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) return _arrayLikeToArray(arr);
        }
        function _toArray(arr) {
          return (
            _arrayWithHoles(arr) ||
            _iterableToArray(arr) ||
            _unsupportedIterableToArray(arr) ||
            _nonIterableRest()
          );
        }
        function _nonIterableRest() {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }
        function _iterableToArray(iter) {
          if (
            (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null) ||
            iter["@@iterator"] != null
          )
            return Array.from(iter);
        }
        function _arrayWithHoles(arr) {
          if (Array.isArray(arr)) return arr;
        }
        var __cache = {};
        var errors = {
          duplicate: function duplicate(_ref) {
            var _ref2 = _toArray(_ref),
              id = _ref2[0],
              args = _ref2.slice(1);
            return [
              "a duplicate key ".concat(
                id,
                " was found in the cache. This instance will be overwritten."
              ),
            ].concat(_toConsumableArray(args));
          },
          undefined: function undefined(_ref3) {
            var _ref4 = _toArray(_ref3),
              id = _ref4[0],
              args = _ref4.slice(1);
            return ["can't find ".concat(id, " in the cache")].concat(
              _toConsumableArray(args)
            );
          },
          error: function error(_ref5) {
            var _ref6 = _toArray(_ref5),
              id = _ref6[0],
              args = _ref6.slice(1);
            return ["".concat(id, " threw an error\n\n")].concat(
              _toConsumableArray(args)
            );
          },
        };
        function log(level, type) {
          var _console;
          for (
            var _len = arguments.length,
              args = new Array(_len > 2 ? _len - 2 : 0),
              _key = 2;
            _key < _len;
            _key++
          ) {
            args[_key - 2] = arguments[_key];
          }
          (_console = console)[level].apply(
            _console,
            ["⚙️ micromanager -"].concat(_toConsumableArray(errors[type](args)))
          );
        }
        function getModuleName(node) {
          return node.getAttribute("data-module") || "";
        }
        function getVueName(node) {
          return (node.getAttribute("is") || "").replace("vue-", "");
        }
        function requireVueModule() {
          var vueName =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : "";
          if (vueName) {
            var fn = __webpack_require__(
              "./src/modules sync recursive ^\\.\\/.*\\.vue\\.js$"
            )("./".concat(vueName, "/").concat(vueName, ".vue.js"));
            return fn;
          }
        }
        function requireModule() {
          var moduleName =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : "";
          var node = arguments.length > 1 ? arguments[1] : undefined;
          if (moduleName) {
            var fn = __webpack_require__(
              "./src/modules sync recursive ^\\.\\/.*\\.js$"
            )("./".concat(moduleName, "/").concat(moduleName, ".js"))[
              "default"
            ].bind(null, node);
            return {
              fn: fn,
              name: moduleName,
            };
          }
        }
        function getNodes(ctx, selector) {
          return [].slice.call(ctx.querySelectorAll(selector));
        }
        function loadVueModules() {
          var ctx =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : document;
          var nodes = getNodes(ctx, "[is]");
          for (var i = 0; i < nodes.length; i++) {
            try {
              requireVueModule(getVueName(nodes[i]));
            } catch (e) {
              log("warn", "error", getVueName(nodes[i]));
            }
          }
        }
        function init(types) {
          var ctx =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : document;
          return {
            cache: {
              set: function set(id, instance) {
                if (__cache[id]) log("warn", "duplicate", id);
                __cache[id] = instance;
              },
              get: function get(id) {
                try {
                  return __cache[id];
                } catch (e) {
                  log("warn", "undefined", id);
                  return null;
                }
              },
              dump: function dump() {
                return __cache;
              },
            },
            mount: function mount() {
              var _this = this;
              var callModule = function callModule(m) {
                var instance = m.fn();
                if (instance) {
                  _this.cache.set(m.name, instance);
                }
                return instance;
              };
              var loadModules = function loadModules(selector) {
                getNodes(ctx, selector)
                  .filter(getModuleName)
                  .map(function (node) {
                    try {
                      var instance = requireModule(getModuleName(node), node);
                      node.removeAttribute("data-module");
                      callModule(instance);
                    } catch (e) {
                      log("warn", "error", getModuleName(node));
                    }
                  });
              };
              loadVueModules(ctx);
              loadModules("[data-vue-app]");
              loadModules("[data-module]");
              return this;
            },
            unmount: function unmount() {
              for (var key in __cache) {
                var instance = __cache[key];
                if (instance.unmount) {
                  instance.unmount();
                  delete __cache[key];
                }
              }
              return this;
            },
          };
        }
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = init;

        /***/
      },

    /***/ "./src/js/lib/smoothScroll.js":
      /*!************************************!*\
  !*** ./src/js/lib/smoothScroll.js ***!
  \************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        // Simple smooth scroller that takes into account the header for keeping in display
        // Note: should only be used with links with anchor references
        var SmoothScroll = function SmoothScroll() {
          var smoothScrollElm = document.querySelectorAll(".js-smooth-scroll");
          if (!smoothScrollElm) {
            return;
          }
          var smoothScrollTo = function smoothScrollTo(el) {
            var nav = document.getElementById("shopify-section-header-mega");
            el.focus({
              preventScroll: true,
            });
            window.scrollTo({
              top: el.offsetTop - nav.offsetHeight,
              behavior: "smooth",
            });
          };
          smoothScrollElm.forEach(function (anchor) {
            anchor.addEventListener("click", function (e) {
              e.preventDefault();
              var link = anchor.getAttribute("href");
              var element = document.getElementById(link.substring(1));
              smoothScrollTo(element);
            });
          });
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          SmoothScroll;

        /***/
      },

    /***/ "./src/js/lib/util.js":
      /*!****************************!*\
  !*** ./src/js/lib/util.js ***!
  \****************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ contains: () => /* binding */ contains,
          /* harmony export */ createArrayFromNumRange: () =>
            /* binding */ createArrayFromNumRange,
          /* harmony export */ createMonthArray: () =>
            /* binding */ createMonthArray,
          /* harmony export */ decode: () => /* binding */ decode,
          /* harmony export */ deepClone: () => /* binding */ deepClone,
          /* harmony export */ formatPrice: () => /* binding */ formatPrice,
          /* harmony export */ getHeight: () => /* binding */ getHeight,
          /* harmony export */ getImageWithSize: () =>
            /* binding */ getImageWithSize,
          /* harmony export */ getProductImage: () =>
            /* binding */ getProductImage,
          /* harmony export */ getUrlParam: () => /* binding */ getUrlParam,
          /* harmony export */ getWidth: () => /* binding */ getWidth,
          /* harmony export */ handleize: () => /* binding */ handleize,
          /* harmony export */ isFirefox: () => /* binding */ isFirefox,
          /* harmony export */ isIE: () => /* binding */ isIE,
          /* harmony export */ isIEorEdge: () => /* binding */ isIEorEdge,
          /* harmony export */ isMobile: () => /* binding */ isMobile,
          /* harmony export */ isOver: () => /* binding */ isOver,
          /* harmony export */ set: () => /* binding */ set,
          /* harmony export */ supportsObjectFit: () =>
            /* binding */ supportsObjectFit,
          /* harmony export */ toggle: () => /* binding */ toggle,
          /* harmony export */ unset: () => /* binding */ unset,
          /* harmony export */ write: () => /* binding */ write,
          /* harmony export */
        });
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }
        var isMobile = function isMobile() {
          return window.innerWidth < 768;
        };
        var supportsObjectFit = function supportsObjectFit() {
          var objectFit = false;
          for (var prop in document.documentElement.style) {
            if (/object(?:-f|F)it$/.test(prop)) {
              objectFit = true;
              break;
            }
          }
          return objectFit;
        };
        var isIE = function isIE() {
          return navigator.userAgent.toLowerCase().indexOf("msie") > 0;
        };
        var isIEorEdge = function isIEorEdge() {
          if (document.documentMode || /Edge/.test(navigator.userAgent)) {
            return true;
          } else {
            return false;
          }
        };
        var isFirefox = function isFirefox() {
          return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
        };
        var write = function write(el, value) {
          el.innerHTML = value;
        };
        var set = function set(item, selector) {
          if (item instanceof Array) {
            var _iterator = _createForOfIteratorHelper(item),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                var i = _step.value;
                i.classList.add(selector);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            if (item) {
              item.classList.add(selector);
            }
          }
        };
        var unset = function unset(item, selector) {
          if (item instanceof Array) {
            var _iterator2 = _createForOfIteratorHelper(item),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                var i = _step2.value;
                i.classList.remove(selector);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          } else {
            if (item) {
              item.classList.remove(selector);
            }
          }
        };
        var contains = function contains(item, selector) {
          if (!item) {
            return false;
          }
          return item.classList.contains(selector);
        };
        var toggle = function toggle(item, selector) {
          if (item instanceof Array) {
            var _iterator3 = _createForOfIteratorHelper(item),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                var i = _step3.value;
                i.classList.toggle(selector);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          } else {
            if (item) {
              item.classList.toggle(selector);
            }
          }
        };
        var getHeight = function getHeight(el) {
          return "".concat(el.offsetHeight, "px");
        };
        var getWidth = function getWidth(el) {
          return "".concat(el.offsetWidth, "px");
        };
        var isOver = function isOver(breakpoint) {
          return window.innerWidth > breakpoint;
        };
        var deepClone = function deepClone(obj) {
          return JSON.parse(JSON.stringify(obj));
        };
        var formatPrice = function formatPrice(num) {
          var locale =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : "en-EN";
          var currency =
            arguments.length > 2 && arguments[2] !== undefined
              ? arguments[2]
              : "USD";
          var fractionDigits =
            arguments.length > 3 && arguments[3] !== undefined
              ? arguments[3]
              : 2;
          return (Number(num) / 100).toLocaleString(locale, {
            style: "currency",
            currency: currency,
            currencyDisplay: "symbol",
            maximumFractionDigits: fractionDigits,
          });
        };
        var getUrlParam = function getUrlParam(name) {
          name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]"); // eslint-disable-line
          var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
          var results = regex.exec(window.location.search);
          return results === null
            ? ""
            : decodeURIComponent(results[1].replace(/\+/g, " "));
        };
        var handleize = function handleize(str) {
          return str.replace(/[ /_]/g, "-").toLowerCase();
        };

        /**
         * Decodes a string that has been encode through the 'url_encode' Shopify filter
         * @param {*} str
         */
        var decode = function decode(str) {
          return decodeURIComponent(str).replace(/\+/g, " ");
        };

        /**
         * Generates a URL that is suitable for the Shopify
         * image CDN. Adds the current image size suffix.
         *
         * @param {*} src
         * @param {*} size
         */
        var getImageWithSize = function getImageWithSize() {
          var src =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : "";
          var size =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : 1000;
          return ("" + src).replace(
            /([.](?:jpe?g|png))/,
            "_".concat(size, "x$1")
          );
        };

        /**
         * Used by components like the product card to select
         * the current product image based on the active color.
         * If there is no active color, a fallback image
         * should be returned if it is defined.
         *
         * @param {*} color
         * @param {*} images
         * @param {*} featured
         * @param {*} fallback
         */
        var getProductImage = function getProductImage() {
          var name =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : "";
          var value =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : "";
          var images = arguments.length > 2 ? arguments[2] : undefined;
          var featured =
            arguments.length > 3 && arguments[3] !== undefined
              ? arguments[3]
              : false;
          var fallback =
            arguments.length > 4 && arguments[4] !== undefined
              ? arguments[4]
              : false;
          var key = ""
            .concat(name, "-")
            .concat((value || "").replace(/[/ ]/g, "-"))
            .toLowerCase();
          var image = (images || []).find(function (i) {
            return ~i.indexOf(key) && ~i.indexOf(featured ? "pos-1" : "pos-2");
          });
          if (!image) {
            return getImageWithSize(fallback, 600);
          }
          return getImageWithSize(image, featured ? 1200 : 600);
        };
        var createArrayFromNumRange = function createArrayFromNumRange(
          size,
          start
        ) {
          return Array.from(Array(size), function (_, i) {
            return start + i;
          });
        };
        var createMonthArray = function createMonthArray() {
          return [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
        };

        /* Element.closest() polyfill for IE11 */
        var Element =
          typeof window.Element === "undefined"
            ? function () {}
            : window.Element;
        if (!Element.prototype.matches) {
          Element.prototype.matches =
            Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
        }
        if (!Element.prototype.closest) {
          Element.prototype.closest = function (s) {
            var el = this;
            do {
              if (el.matches(s)) return el;
              el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
          };
        }

        /***/
      },

    /***/ "./src/js/main.js":
      /*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var vue_dist_vue__WEBPACK_IMPORTED_MODULE_10__ =
          __webpack_require__(
            /*! vue/dist/vue */ "./node_modules/vue/dist/vue.js"
          );
        /* harmony import */ var vue_dist_vue__WEBPACK_IMPORTED_MODULE_10___default =
          /*#__PURE__*/ __webpack_require__.n(
            vue_dist_vue__WEBPACK_IMPORTED_MODULE_10__
          );
        /* harmony import */ var tippy_js__WEBPACK_IMPORTED_MODULE_11__ =
          __webpack_require__(
            /*! tippy.js */ "./node_modules/tippy.js/dist/tippy.esm.js"
          );
        /* harmony import */ var _lib_init__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! ./lib/init */ "./src/js/lib/init.js");
        /* harmony import */ var _lib_accessibility__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./lib/accessibility */ "./src/js/lib/accessibility.js"
          );
        /* harmony import */ var _lib_accessibility__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            _lib_accessibility__WEBPACK_IMPORTED_MODULE_1__
          );
        /* harmony import */ var _sections_stockists__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./sections/stockists */ "./src/js/sections/stockists.js"
          );
        /* harmony import */ var _sections_quiz__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ./sections/quiz */ "./src/js/sections/quiz.js"
          );
        /* harmony import */ var _sections_collections__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! ./sections/collections */ "./src/js/sections/collections.js"
          );
        /* harmony import */ var _sections_product__WEBPACK_IMPORTED_MODULE_5__ =
          __webpack_require__(
            /*! ./sections/product */ "./src/js/sections/product.js"
          );
        /* harmony import */ var _sections_blog__WEBPACK_IMPORTED_MODULE_6__ =
          __webpack_require__(
            /*! ./sections/blog */ "./src/js/sections/blog.js"
          );
        /* harmony import */ var _lib_smoothScroll__WEBPACK_IMPORTED_MODULE_7__ =
          __webpack_require__(
            /*! ./lib/smoothScroll */ "./src/js/lib/smoothScroll.js"
          );
        /* harmony import */ var _sections_bundle__WEBPACK_IMPORTED_MODULE_8__ =
          __webpack_require__(
            /*! ./sections/bundle */ "./src/js/sections/bundle.js"
          );
        /* harmony import */ var _lib_VideoModalHandler__WEBPACK_IMPORTED_MODULE_9__ =
          __webpack_require__(
            /*! ./lib/VideoModalHandler */ "./src/js/lib/VideoModalHandler.js"
          );

        window.Vue = vue_dist_vue__WEBPACK_IMPORTED_MODULE_10___default();
        document.addEventListener("DOMContentLoaded", function () {
          (0, _lib_init__WEBPACK_IMPORTED_MODULE_0__["default"])().mount();
          if (document.querySelectorAll("#stockist-map").length > 0) {
            (0, _sections_stockists__WEBPACK_IMPORTED_MODULE_2__["default"])();
          }
          if (document.querySelectorAll(".template-quiz").length > 0) {
            (0, _sections_quiz__WEBPACK_IMPORTED_MODULE_3__["default"])();
          }

          // if we have
          var hasAskedMarket = document.cookie.includes("has-asked-market");
          if (!hasAskedMarket) {
            // if its a bot then don't ask the market
            if (navigator.userAgent.includes("bot")) {
              return;
            }

            // if shopify design mode is active then don't ask the market
            if (document.body.classList.contains("shopify-design-mode")) {
              return;
            }
            fetch("/browsing_context_suggestions.json")
              .then(function (res) {
                return res.json();
              })
              .then(function (data) {
                var countryName = data.detected_values.country.name;

                // save the country to a cookie
                document.cookie = "market=".concat(
                  countryName,
                  "; path=/; max-age=31536000; samesite=strict"
                );

                // if country name is AU then make sure the url has en-au prefix
                if (countryName === "Australia") {
                  if (window.location.pathname.includes("en-au")) {
                    return;
                  }

                  // if the url has a ?country parameter then continue
                  if (window.location.search.includes("country")) {
                    return;
                  }

                  // trigger a click on the swap sites button
                  // redirect to the en-au url
                  window.location.href = "/en-au" + window.location.pathname;
                }
              })
              ["catch"](function (error) {
                return console.error("Error fetching country:", error);
              });
          } else {
            // append the market cookie information to the #region-selector modal with a link to clear the cookie
            var regionSelector = document.querySelector("#region-selector");

            // get the `market` cookie
            var marketCookie = document.cookie.split("; ").find(function (row) {
              return row.startsWith("market=");
            });
            var countryName =
              marketCookie === null || marketCookie === void 0
                ? void 0
                : marketCookie.split("=")[1];

            // clicking any a tag within the region-selector should set the has-asked-market cookie
            if (regionSelector) {
              var aTags = regionSelector.querySelectorAll("a.toggle-market");
              aTags.forEach(function (a) {
                a.addEventListener("click", function (e) {
                  e.preventDefault();

                  // set the has-asked-market cookie
                  document.cookie =
                    "has-asked-market=true; path=/; max-age=31536000; samesite=strict";
                });
              });
            }
            if (regionSelector && countryName) {
              var termsP = document.createElement("p");
              termsP.classList.add("small-terms");
              termsP.innerHTML = "We've detected you are in ".concat(
                countryName,
                '. If this is incorrect, you can <a href="#" class="clear-market-cookie">clear the cookie</a> and try again.'
              );
              var modalContent =
                regionSelector.querySelector(".modal__content");
              if (modalContent) {
                modalContent.appendChild(termsP);
              }

              // add a click handler to the clear-market-cookie link
              var clearMarketCookie = document.querySelector(
                ".clear-market-cookie"
              );
              if (clearMarketCookie) {
                clearMarketCookie.addEventListener("click", function (e) {
                  e.preventDefault();

                  // remove the market cookie
                  document.cookie =
                    "market=; path=/; max-age=0; samesite=strict";

                  // reload the page
                  window.location.reload();
                });
              }
            }
          }
          var emailButtons = document.querySelectorAll(
            ".email-quiz-results, a[href^='#email-results']"
          );
          if (emailButtons) {
            emailButtons.forEach(function (button) {
              button.addEventListener("click", function (e) {
                e.preventDefault();
                Brave.QuizApp.showEmailModal();
              });
            });
          }
          (0, _sections_collections__WEBPACK_IMPORTED_MODULE_4__["default"])();
          (0, _sections_product__WEBPACK_IMPORTED_MODULE_5__["default"])();
          (0, _sections_blog__WEBPACK_IMPORTED_MODULE_6__["default"])();
          (0, _lib_smoothScroll__WEBPACK_IMPORTED_MODULE_7__["default"])();
          (0, _sections_bundle__WEBPACK_IMPORTED_MODULE_8__["default"])();
          document.querySelectorAll("[data-tippy]").forEach(function (el) {
            var contentParts = el
              .getAttribute("data-tippy")
              .replaceAll("\n", "<br>")
              .split("<br>");

            // insert a <br> item between each item in contentParts
            for (var i = 0; i < contentParts.length; i++) {
              contentParts.splice(i + 1, 0, "<br>");
              i++;
            }
            var contentDiv = document.createElement("div");
            contentDiv.innerHTML = contentParts
              .join("<br>")
              .replaceAll("<br><br><br>", "<br>");

            // trim any leading or trailing <br> tags
            contentDiv.innerHTML = contentDiv.innerHTML.replace(
              /^<br>|<br>$/g,
              ""
            );
            contentDiv.style.padding = "5px";
            (0, tippy_js__WEBPACK_IMPORTED_MODULE_11__["default"])(el, {
              content: contentDiv,
              placement: "bottom",
              arrow: true,
              theme: "light",
              interactive: true,
            });
          });

          // cleanup shit content
          // remove empty paragraphs from .callout-three-up__product-item
          var calloutThreeUp = document.querySelectorAll(
            ".callout-three-up__product-item"
          );
          calloutThreeUp.forEach(function (item) {
            var p = item.querySelectorAll("p");
            p.forEach(function (p) {
              if (
                !p.innerText ||
                p.innerHTML === "" ||
                p.innerHTML == "&nbsp;"
              ) {
                p.remove();
              }
            });
          });
          var sixTabs = document.querySelectorAll(".six-up-image__tabs button");
          var middle = document.querySelector(".six-up-image-middle");
          if (sixTabs.length > 0) {
            sixTabs.forEach(function (el) {
              el.addEventListener("click", function (e) {
                e.preventDefault();
                if (el.classList.contains("active")) {
                  return;
                }

                // remove active from the current one
                var active = document.querySelector(
                  ".six-up-image__tabs .active"
                );
                if (active) {
                  active.classList.remove("active");
                }
                el.classList.add("active");
                if (el.classList.contains("youth")) {
                  middle === null || middle === void 0
                    ? void 0
                    : middle.classList.remove("show--adult");
                  middle === null || middle === void 0
                    ? void 0
                    : middle.classList.add("hide--adult");
                } else {
                  middle === null || middle === void 0
                    ? void 0
                    : middle.classList.add("show--adult");
                  middle === null || middle === void 0
                    ? void 0
                    : middle.classList.remove("hide--adult");
                }
              });
            });
          }

          // if the current anchor is #cart then open the #header-cart-icon-button
          var anchor = window.location.hash;
          if (anchor === "#cart") {
            var cartButton = document.querySelector("#header-cart-icon-button");
            if (cartButton) {
              cartButton.click();
            }
          }
          (0, _lib_VideoModalHandler__WEBPACK_IMPORTED_MODULE_9__["default"])();
          var disable = document.querySelectorAll(".btn--no-action");
          if (disable.length > 0) {
            disable.forEach(function (el) {
              el.addEventListener("click", function (e) {
                e.preventDefault();
              });
            });
          }

          // on any .wysiwyg__container iframe, if it has a width and a height attribute then also add an aspect ratio style
          var iframes = document.querySelectorAll(".wysiwyg__container iframe");
          if (iframes.length > 0) {
            iframes.forEach(function (el) {
              if (el.width && el.height) {
                el.style.aspectRatio = ""
                  .concat(el.width, "/")
                  .concat(el.height);
              }
            });
          }

          // move the reviews from a block to the #product-reviews__bucket
          var reviews = document.querySelector("#fulfilled-reviews-all");
          var bucket = document.querySelector("#product-reviews__bucket");
          if (bucket && reviews) {
            bucket.appendChild(reviews);
          }
        });
        document.addEventListener("DOMContentLoaded", function () {
          document.body.classList.remove("not-loaded");
        });

        /***/
      },

    /***/ "./src/js/mixins/validate.js":
      /*!***********************************!*\
  !*** ./src/js/mixins/validate.js ***!
  \***********************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = {
          methods: {
            validate: function validate(e) {
              var isValid = this.$children
                .filter(function (c) {
                  return typeof c.validate !== "undefined";
                })
                .map(function (c) {
                  return c.validate();
                })
                .every(function (res) {
                  return res;
                });
              if (!isValid) {
                e.preventDefault();
              }
            },
          },
        };

        /***/
      },

    /***/ "./src/js/sections/blog.js":
      /*!*********************************!*\
  !*** ./src/js/sections/blog.js ***!
  \*********************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var choices_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! choices.js */ "./node_modules/choices.js/public/assets/scripts/choices.js"
          );
        /* harmony import */ var choices_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            choices_js__WEBPACK_IMPORTED_MODULE_0__
          );

        var Blog = function Blog() {
          var filters = document.querySelector(".blog-filter");
          if (!filters) {
            return;
          }
          var tagToURL = function tagToURL(tag) {
            if (tag == "__concern-") {
              return "";
            }
            return tag
              .toLowerCase()
              .replace(/ /g, "-")
              .replace(/[^\w-]+/g, "");
          };
          var updateSelectCounts = function updateSelectCounts() {
            var selects = document.querySelectorAll(".choices");
            selects.forEach(function (select) {
              var inner = select.querySelector(".choices__inner");

              // ensure there is a count element within inner
              if (!inner.querySelector(".choices__count")) {
                var _count = document.createElement("div");
                _count.classList.add("choices__count");
                _count.classList.add("hidden");
                inner.appendChild(_count);
              }

              // count the number of is-selected items within select and update the count element
              var count = select.querySelector(".choices__count");
              var selected = select.querySelectorAll(".is-selected");
              if (selected.length > 0) {
                count.innerHTML = selected.length;
                count === null || count === void 0
                  ? void 0
                  : count.classList.remove("hidden");
              } else {
                count === null || count === void 0
                  ? void 0
                  : count.classList.add("hidden");
              }
            });
          };
          var updateBlogPosts = function updateBlogPosts() {
            var _concerns$value;
            updateSelectCounts();
            var tiles = document.querySelector(".blog-tiles");
            if (!tiles) {
              return;
            }
            var concerns = document.querySelector(
              ".blog-filter--concerns select"
            );

            // @ts-expect-error
            var concernHandle =
              (_concerns$value =
                concerns === null || concerns === void 0
                  ? void 0
                  : concerns.value) !== null && _concerns$value !== void 0
                ? _concerns$value
                : "";
            if (concernHandle === "stress--mood") {
              // concernHandle = "stress";
            }
            var filters = document.querySelector(".blog-filter--tags select");
            var tags = [
              tagToURL("__concern-" + concernHandle),
              tagToURL(
                filters === null || filters === void 0 ? void 0 : filters.value
              ),
            ]
              .filter(function (el) {
                return el;
              })
              .join("+");
            var uri = tags ? "/blogs/news/tagged/".concat(tags) : "/blogs/news";

            // push state to the browser history
            window.history.pushState({}, "", uri);
            tiles.classList.add("loading");
            tiles.innerHTML = "";

            // fetch the blog posts which have the tagged
            fetch(uri)
              .then(function (response) {
                return response.text();
              })
              .then(function (data) {
                // parse the plain text data for the blog tiles and update the DOM
                var doc = new DOMParser().parseFromString(data, "text/html");
                var blogTiles = doc.querySelector(".blog-tiles");
                if (blogTiles) {
                  tiles.classList.remove("loading");
                  tiles.innerHTML = blogTiles.innerHTML;
                } else {
                  var _document$querySelect;
                  tiles.classList.remove("loading");
                  tiles.innerHTML =
                    ((_document$querySelect =
                      document.querySelector("#no-posts")) === null ||
                    _document$querySelect === void 0
                      ? void 0
                      : _document$querySelect.innerHTML) || "";
                }
              })
              ["catch"](function (error) {
                var _document$querySelect2;
                console.error(error);
                tiles.classList.remove("loading");
                tiles.innerHTML =
                  ((_document$querySelect2 =
                    document.querySelector("#no-posts")) === null ||
                  _document$querySelect2 === void 0
                    ? void 0
                    : _document$querySelect2.innerHTML) || "";
              });
          };
          function nicerChoices(element, selector, dropdown) {
            var isRemoving = false;
            element.addEventListener("addItem", function (event) {
              if (!isRemoving) {
                updateBlogPosts();
              }
            });
            element.addEventListener("removeItem", function (event) {
              updateBlogPosts();
              isRemoving = false;
            });
            element.addEventListener("choice", function (event) {
              isRemoving = true;
              // if the choice is already selected, remove it from the dropdown
              if (event.detail.choice.selected) {
                var value = event.detail.choice.value;
                setTimeout(function () {
                  dropdown.removeActiveItemsByValue(value);
                  updateBlogPosts();
                  isRemoving = false;
                  return false;
                }, 20);
              } else {
                isRemoving = false;
              }
            });
            var choiceLists = document.querySelectorAll(
              "".concat(selector, " .choices__list")
            );
            choiceLists.forEach(function (choiceList) {
              choiceList.addEventListener("click", function (event) {
                // if the choice is open, close the dropdown
                if (dropdown.dropdown.isActive) {
                  dropdown.hideDropdown(true);
                }
              });
            });
            updateSelectCounts();
          }

          // on load if we have already tagged posts then select those
          var preSelect = filters.dataset.selected;
          var element = document.querySelector(".blog-filter--tags select");
          if (element) {
            var tagChoices =
              new (choices_js__WEBPACK_IMPORTED_MODULE_0___default())(element, {
                searchEnabled: false,
                placeholderValue: "Filter by tag",
                itemSelectText: "",
                labelId: "tagFilter",
                renderSelectedChoices: "always",
              });
            nicerChoices(element, ".blog-filter--tags", tagChoices);
            if (preSelect) {
              preSelect.split(",").forEach(function (tag) {
                tag = tag.replace("__concern-", "");
                if (
                  document.querySelector(
                    '.blog-filter--tags .choices__item[data-value="'.concat(
                      tag,
                      '"]'
                    )
                  )
                ) {
                  tagChoices.setChoiceByValue(tag);
                }
              });
            }
          }
          var concerns = document.querySelector(
            ".blog-filter--concerns select"
          );
          if (concerns) {
            var concernChoices =
              new (choices_js__WEBPACK_IMPORTED_MODULE_0___default())(
                concerns,
                {
                  searchEnabled: false,
                  placeholderValue: "Filter by concern",
                  labelId: "concernFilter",
                  itemSelectText: "",
                  renderSelectedChoices: "always",
                }
              );
            nicerChoices(concerns, ".blog-filter--concerns", concernChoices);
            if (preSelect) {
              preSelect.split(",").forEach(function (tag) {
                tag = tag.replace("__concern-", "");
                if (
                  document.querySelector(
                    '.blog-filter--concerns .choices__item[data-value="'.concat(
                      tag,
                      '"]'
                    )
                  )
                ) {
                  concernChoices.setChoiceByValue(tag);
                }
              });
            }
          }
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Blog;

        /***/
      },

    /***/ "./src/js/sections/bundle.js":
      /*!***********************************!*\
  !*** ./src/js/sections/bundle.js ***!
  \***********************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _modules_modal_modal__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../../modules/modal/modal */ "./src/modules/modal/modal.js"
          );
        /* harmony import */ var _lib_VideoModalHandler__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../lib/VideoModalHandler */ "./src/js/lib/VideoModalHandler.js"
          );
        function _slicedToArray(arr, i) {
          return (
            _arrayWithHoles(arr) ||
            _iterableToArrayLimit(arr, i) ||
            _unsupportedIterableToArray(arr, i) ||
            _nonIterableRest()
          );
        }
        function _nonIterableRest() {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }
        function _iterableToArrayLimit(arr, i) {
          var _i =
            null == arr
              ? null
              : ("undefined" != typeof Symbol && arr[Symbol.iterator]) ||
                arr["@@iterator"];
          if (null != _i) {
            var _s,
              _e,
              _x,
              _r,
              _arr = [],
              _n = !0,
              _d = !1;
            try {
              if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
                if (Object(_i) !== _i) return;
                _n = !1;
              } else
                for (
                  ;
                  !(_n = (_s = _x.call(_i)).done) &&
                  (_arr.push(_s.value), _arr.length !== i);
                  _n = !0
                );
            } catch (err) {
              (_d = !0), (_e = err);
            } finally {
              try {
                if (
                  !_n &&
                  null != _i["return"] &&
                  ((_r = _i["return"]()), Object(_r) !== _r)
                )
                  return;
              } finally {
                if (_d) throw _e;
              }
            }
            return _arr;
          }
        }
        function _arrayWithHoles(arr) {
          if (Array.isArray(arr)) return arr;
        }

        var BUNDLE_BACK_URL = "http://127.0.0.1:8000/api/bundle";
        BUNDLE_BACK_URL = "https://douglas.akqa.nz/api/bundle";
        var AddGarnishToProductPage = function AddGarnishToProductPage(
          product
        ) {
          var bundlePage = "/collections/build-your-own-anti-anxious-station";

          // create a back link to /collections/
          var backLink = document.createElement("a");
          backLink.setAttribute("href", bundlePage);
          backLink.innerHTML = "Back to Bundle";
          backLink.classList.add("back-to-bundle");

          // add the back link as the first child product page
          var backContainer = document.createElement("div");
          backContainer.classList.add("back-to-bundle-container");
          backContainer.classList.add("container");
          backContainer.classList.add("container-xl");
          backContainer.appendChild(backLink);
          product.insertBefore(backContainer, product.firstChild);

          // hide the default .product-bar on the product page
          var productBar = document.querySelector(".product-bar");
          if (productBar) {
            productBar.style.display = "none";
          }

          // add the video block from the bundle page. Fetch the DOM from the bundle
          // page and insert it into the product page
          fetch(bundlePage).then(function (response) {
            response.text().then(function (text) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(text, "text/html");
              var videoBlock = doc.querySelector(".text-image--has-video");
              if (videoBlock) {
                product.appendChild(videoBlock.closest(".shopify-section"));
                if (typeof window.lazy !== "undefined") {
                  window.lazy.update();
                }
                if (typeof window.layzr !== "undefined") {
                  window.layzr.update().check().handlers(true);
                }
                (0,
                _modules_modal_modal__WEBPACK_IMPORTED_MODULE_0__["default"])();
                (0,
                _lib_VideoModalHandler__WEBPACK_IMPORTED_MODULE_1__[
                  "default"
                ])();
              }

              // make sure bundle_me is in the url
              var params = new URLSearchParams(window.location.search);
              if (!params.has("bundle_me")) {
                params.append("bundle_me", "1");
                window.history.replaceState(
                  {},
                  "",
                  "".concat(location.pathname, "?").concat(params.toString())
                );
              }
            });
          });

          // handle the .product-options__item button. On click we need to add the product
          // to the bundle and take them back to the bundle page

          // check to see if product is out of stock
          var newAddToBundleButton = document.createElement("button");
          newAddToBundleButton.classList.add("bundle__product-add-btn");
          newAddToBundleButton.classList.add("btn");
          newAddToBundleButton.classList.add("btn--primary");
          if (product.dataset.available === "true") {
            newAddToBundleButton.innerHTML = "Add to Bundle";
          } else {
            newAddToBundleButton.innerHTML = "Out of Stock";
            newAddToBundleButton.setAttribute("disabled", "disabled");
            newAddToBundleButton.classList.add("btn--disabled");
          }
          var productForm = product.querySelector(".product-form");
          productForm.appendChild(newAddToBundleButton);
        };
        var bundle = function bundle() {
          var root = document.querySelector("#bundle");
          var stored = localStorage.getItem("bundle");
          var params = new URLSearchParams(window.location.search);
          var productPage = document.querySelector("#new-product");
          if (productPage) {
            if (params.has("bundle_me")) {
              AddGarnishToProductPage(productPage);
              productPage.classList.add("bundle-product-page");
            } else {
              if (root) {
                // remove #bundle from the page
                root.parentNode.removeChild(root);
              }
            }
          }
          if (!root) {
            return;
          }
          if (params.has("preloadBundle")) {
            // preload the bundle with the product as given in the URL
            var sku = params.get("preloadBundle");

            // SKU will be in the format {quantity}@{variant_id}|{quantity}@{variant_id}
            // break this up and add each item to the cart
            var items = sku.split("|");
            var preloadedCart = [];
            items.forEach(function (item) {
              var _item$split = item.split("@"),
                _item$split2 = _slicedToArray(_item$split, 2),
                quantity = _item$split2[0],
                variant_id = _item$split2[1];
              var product = null;
              if (variant_id.indexOf("ID-") > -1) {
                variant_id = variant_id.replace("ID-", "");
                product = root.querySelector(
                  '[data-variant-id="'.concat(variant_id, '"]')
                );
              } else {
                product = root.querySelector(
                  '[data-sku="'.concat(variant_id, '"]')
                );
              }
              if (product) {
                // add the item to the cart
                preloadedCart.push({
                  id: product.dataset.variantId,
                  quantity: parseInt(quantity),
                  title: product.dataset.title,
                  unitPrice: product.dataset.unitPrice,
                  sku: product.dataset.sku || "ID-" + product.dataset.variantId,
                });
              }
            });
            stored = JSON.stringify(preloadedCart);

            // remove preloadBundle from the url
            params["delete"]("preloadBundle");
            window.history.replaceState({}, "", "".concat(location.pathname));
          }

          // eslint:disable-next-line
          window.BUNDLE_CART = [];
          var selectedDiscount = "0";
          var updateCart = function updateCart(cart) {
            window.BUNDLE_CART = cart;
            localStorage.setItem("bundle", JSON.stringify(cart));

            // update the totals used across the bar
            var fullPriceDOM = document.querySelector(
              ".bundle__bar-full-price"
            );
            var discountedPriceDOM =
              document.querySelector(".bundle__bar-total");

            // check to see if we have made the 15% threshold
            var totalItems = 0;
            var total = 0;
            var nextDiscountLevel = "";
            cart.forEach(function (item) {
              totalItems += item.quantity;
              total += item.quantity * (item.unitPrice / 100);
            });
            if (totalItems > 3) {
              selectedDiscount = window.LEVEL_2_DISCOUNT;
              root.removeAttribute("data-discount-level-1");
              root.setAttribute("data-discount-level-2", "true");
            } else if (totalItems > 2) {
              selectedDiscount = window.LEVEL_1_DISCOUNT;
              root.setAttribute("data-discount-level-1", "true");
              root.removeAttribute("data-discount-level-2");
              var diff = 4 - totalItems;
              nextDiscountLevel =
                "Add " +
                diff +
                " more ".concat(diff == 1 ? "item" : "items", " for 20% off");
            } else {
              selectedDiscount = "0";
              root.removeAttribute("data-discount-level-1");
              root.removeAttribute("data-discount-level-2");
              var _diff = 3 - totalItems;
              nextDiscountLevel =
                "Add " +
                (3 - totalItems) +
                " more ".concat(_diff == 1 ? "item" : "items", " for 15% off");
            }
            document
              .querySelectorAll("[data-bundle-total-items]")
              .forEach(function (el) {
                if (totalItems == 1) {
                  el.innerHTML = totalItems + " item";
                } else {
                  el.innerHTML = totalItems + " items";
                }
              });
            var summaryDOM = document.querySelector(".bundle__bar-summary");
            if (summaryDOM && fullPriceDOM) {
              if (totalItems > 0) {
                fullPriceDOM.innerHTML = "$".concat(
                  total.toFixed(2).replace(/\.00$/, "")
                );
                discountedPriceDOM.innerHTML = "$".concat(
                  (total * (1 - selectedDiscount / 100))
                    .toFixed(2)
                    .replace(/\.00$/, "")
                );

                // show the totals
                summaryDOM.style = "";
              } else {
                // hide the totals
                summaryDOM.style.display = "none";
              }
              if (selectedDiscount == "0") {
                fullPriceDOM.style.display = "none";
              } else {
                fullPriceDOM.style.display = "";
              }
            }

            // update all product .bundle__product-discounted with the discounted value
            // since that might have changed
            var discountedPrice = document.querySelectorAll(
              ".bundle__product-discounted"
            );
            discountedPrice.forEach(function (el) {
              var price = parseFloat(el.dataset.price);
              var discountedPrice = (
                (price / 100) *
                (1 - selectedDiscount / 100)
              ).toFixed(2);

              // remove .00 from the end of the price
              discountedPrice = discountedPrice.replace(/\.00$/, "");
              el.innerHTML = "$".concat(discountedPrice);
            });
            var upsellMessage = document.querySelector(
              "[data-bundle-upsell-message]"
            );
            if (upsellMessage) {
              if (nextDiscountLevel) {
                upsellMessage.innerHTML = nextDiscountLevel;
                upsellMessage.style.display = "block";
              } else {
                upsellMessage.style.display = "none";
              }
            }

            // if total items is > 2 then we can activate the button
            var checkoutBtn = document.querySelector(
              ".bundle__bar-checkout-btn"
            );
            if (checkoutBtn) {
              if (totalItems > 1) {
                checkoutBtn.removeAttribute("disabled");
                checkoutBtn.classList.remove("btn--disabled");
              } else {
                checkoutBtn.setAttribute("disabled", "disabled");
                checkoutBtn.classList.add("btn--disabled");
              }
            }
          };

          /**
           * Handle the submission. First we create the required variant id for this
           * custom bundle and then we add the new variant to the cart.
           */
          var checkoutBtn = document.querySelector(".bundle__bar-checkout-btn");
          if (checkoutBtn) {
            checkoutBtn.addEventListener("click", function (e) {
              var _document$querySelect, _document$querySelect2;
              if (checkoutBtn.hasAttribute("disabled")) {
                e.preventDefault();
                return;
              }

              // change button to loading state
              checkoutBtn.setAttribute("disabled", "disabled");
              checkoutBtn.innerHTML = "Adding to cart...";

              // POST request to our backend
              fetch(BUNDLE_BACK_URL, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "Cache-Control": "no-cache",
                },
                body: JSON.stringify({
                  products: window.BUNDLE_CART,
                  discount: selectedDiscount,
                  bundleContainerIds: window.BUNDLE_CONTAINER_IDS,
                  price:
                    (_document$querySelect =
                      document.querySelector(".bundle__bar-total")) === null ||
                    _document$querySelect === void 0
                      ? void 0
                      : _document$querySelect.innerHTML.replace("$", ""),
                  compare_at:
                    (_document$querySelect2 = document.querySelector(
                      ".bundle__bar-full-price"
                    )) === null || _document$querySelect2 === void 0
                      ? void 0
                      : _document$querySelect2.innerHTML.replace("$", ""),
                }),
              })
                .then(function (response) {
                  return response.json();
                })
                .then(function (data) {
                  if (data && data.error) {
                    // show an error message
                    checkoutBtn.innerHTML = "Error";
                    console.error(data.error);
                    return;
                  }
                  checkoutBtn.innerHTML = "Saving..";

                  // add the variant to the cart
                  fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: data.result.variant_id.replace(
                            "gid://shopify/ProductVariant/",
                            ""
                          ),
                          quantity: 1,
                        },
                      ],
                    }),
                  }).then(function (data) {
                    // clear the bundle that we have built
                    localStorage.removeItem("bundle");

                    // reload the same page with the #cart anchor so the user can see the cart
                    var currentURL = window.location.href.split("#")[0];
                    checkoutBtn.innerHTML = "Loading..";
                    window.location.href = currentURL + "#cart";

                    // if debug isn't in the url
                    if (window.location.href.indexOf("debug") === -1) {
                      setTimeout(function () {
                        window.location.reload();
                      }, 3000);
                    }
                  });
                });
            });
          }
          if (stored) {
            var bundleCart = JSON.parse(stored);
            try {
              var invalidItems = [];

              // for all the products already in the cart show the correct quantity
              bundleCart.forEach(function (item) {
                var product = root.querySelector(
                  '[data-variant-id="'.concat(item.id, '"]')
                );
                if (!product) {
                  // remove the item from the cart
                  invalidItems.push(item);
                  return;
                }
                product.classList.add("is-added");
                var quantity = product.querySelector(
                  ".bundle__product-quantity-value"
                );
                if (quantity) {
                  quantity.innerHTML = item.quantity;
                }
              });
              updateCart(bundleCart);
            } catch (e) {
              console.error(e);
              bundleCart = [];
              updateCart(bundleCart);
            }
          } else {
            var _bundleCart = [];
            updateCart(_bundleCart);
          }

          // add handler for each bundle__product-add-btn button so when clicked it adds the product to the bundle cart
          var addBtns = document.querySelectorAll(".bundle__product-add-btn");
          addBtns.forEach(function (btn) {
            btn.addEventListener("click", function (e) {
              e.preventDefault();
              var product = e.target.closest(".bundle__product");
              var isProductPage = false;
              if (!product) {
                // look for a parent
                product = document.querySelector("#new-product");
                isProductPage = true;
              }
              var id = product.dataset.variantId;
              var existing = window.BUNDLE_CART.find(function (item) {
                return item.id == id;
              });
              var cart = window.BUNDLE_CART;
              // check to see if the product is already in the cart
              if (!existing) {
                // add the item to the cart
                cart.push({
                  id: id,
                  quantity: 1,
                  title: product.dataset.title,
                  unitPrice: product.dataset.unitPrice,
                  sku: product.dataset.sku || "ID-" + id,
                });
              } else {
                cart = cart.map(function (item) {
                  if (item.id === id) {
                    item.quantity += 1;
                  }
                  return item;
                });
              }

              // update the quantity value
              var qty = product.querySelector(
                ".bundle__product-quantity-value"
              );
              if (qty) {
                qty.innerHTML = 1;
              }

              // save the updated cart
              updateCart(cart);

              // update the UI
              product.classList.add("is-added");

              // reload the page
              if (isProductPage) {
                // reload the page with the bundle_me parameter
                window.location.reload();
              }
              return false;
            });
          });

          // add handler for the bundle__product-subtract button so when clicked it removes the product from the bundle cart
          // or reduces the quantity
          var subtractBtns = root.querySelectorAll(".bundle__product-subtract");
          subtractBtns.forEach(function (btn) {
            btn.addEventListener("click", function (e) {
              e.preventDefault();
              var product = e.target.closest(".bundle__product");
              var id = product.dataset.variantId.toString();

              // remove the item from the cart
              var isProductRemoved = false;
              var updatedCart = window.BUNDLE_CART.map(function (item) {
                var result = Object.assign({}, item);
                if (result.id == id) {
                  result.quantity -= 1;
                  if (result.quantity === 0) {
                    isProductRemoved = true;
                  }
                }
                return result;
              }).filter(function (item) {
                return item && item.quantity > 0;
              });
              updateCart(updatedCart);

              // update the UI
              if (isProductRemoved) {
                product.classList.remove("is-added");
                product.querySelector(
                  ".bundle__product-quantity-value"
                ).innerHTML = 0;
              } else {
                product.querySelector(
                  ".bundle__product-quantity-value"
                ).innerHTML = updatedCart.find(function (item) {
                  return item.id == id;
                }).quantity;
              }
              return false;
            });
          });

          // add handler for bundle__product-add button so when clicked it increments the quantity
          var addQuantityBtns = root.querySelectorAll(
            ".bundle__product-quantity .bundle__product-add"
          );
          addQuantityBtns.forEach(function (btn) {
            btn.addEventListener("click", function (e) {
              e.preventDefault();
              var product = e.target.closest(".bundle__product");
              var id = product.dataset.variantId;

              // add the item to the cart
              var bundleCart = window.BUNDLE_CART.map(function (item) {
                if (item.id === id) {
                  item.quantity += 1;
                }
                return item;
              });
              updateCart(bundleCart);

              // update the UI
              product.querySelector(
                ".bundle__product-quantity-value"
              ).innerHTML = bundleCart.find(function (item) {
                return item.id === id;
              }).quantity;
              return false;
            });
          });
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = bundle;

        /***/
      },

    /***/ "./src/js/sections/collections.js":
      /*!****************************************!*\
  !*** ./src/js/sections/collections.js ***!
  \****************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var object_fit_images__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! object-fit-images */ "./node_modules/object-fit-images/dist/ofi.common-js.js"
          );
        /* harmony import */ var object_fit_images__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            object_fit_images__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var _lib_appState__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../lib/appState */ "./src/js/lib/appState.js"
          );

        var Collection = function Collection() {
          var moveSliderToActive = function moveSliderToActive(slider, active) {
            var activeX = active.getBoundingClientRect().left;
            var sliderX = slider.getBoundingClientRect().left;

            // align the active one to the 'middle' of the view.
            var scrollLeft =
              activeX -
              sliderX -
              window.innerWidth / 2 +
              active.getBoundingClientRect().width / 2;
            if (scrollLeft < 0) {
              return;
            }
            slider.scrollLeft = scrollLeft;
          };
          var slider = document.querySelector(".plp__categories");
          if (slider) {
            var isDown = false;
            var startX = 0;
            var scrollLeft;
            slider.addEventListener("mousedown", function (e) {
              isDown = true;
              slider.classList.add("active");
              startX = e.pageX - slider.offsetLeft;
              scrollLeft = slider.scrollLeft;
            });
            slider.addEventListener("mouseleave", function () {
              isDown = false;
              slider.classList.remove("active");
            });
            slider.addEventListener("mouseup", function () {
              isDown = false;
              slider.classList.remove("active");
            });
            slider.addEventListener("mousemove", function (e) {
              if (!isDown) return;
              e.preventDefault();
              var x = e.pageX - slider.offsetLeft;
              var walk = (x - startX) * 1;
              slider.scrollLeft = scrollLeft - walk;
            });

            // on load, make sure we have moved the slider scroll to the active category
            var active = document.querySelector(
              ".plp__categories-list a.active"
            );
            if (active) {
              moveSliderToActive(slider, active);
            }
          }
          var nav = document.querySelectorAll(".plp__categories-list a");
          var main = document.querySelector(".plp__main");
          var hero = document.querySelector(".hero-simple");
          var addToCart = function addToCart(btn) {
            var variantId = btn.getAttribute("data-variant-id");
            var quantity = 1;
            btn.classList.add("loading");
            btn.classList.add("disabled");
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "collectionPurchase",
              ecommerce: {
                purchase: {
                  products: [
                    {
                      id: variantId,
                    },
                  ],
                },
              },
            });

            // Add to shopify cart via fetch
            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: quantity,
                  },
                ],
              }),
            })
              .then(function (response) {
                return response.json();
              })
              .then(function (data) {
                _lib_appState__WEBPACK_IMPORTED_MODULE_1__["default"].lastAdd =
                  Date.now();
                btn.classList.remove("loading");
                btn.classList.remove("disabled");
                var icon = btn.querySelector(".button__icon");
                if (icon) {
                  // swap inner html to tick svg
                  icon.innerHTML =
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
                }
                var text = btn.querySelector(".button__el");
                if (text) {
                  text.innerText = "Added!";
                }
                var cartIcon = document.querySelector(
                  "#header-cart-icon-button"
                );
                if (cartIcon) {
                  cartIcon.click();
                  return;
                }
              });
            return false;
          };
          var attachEvents = function attachEvents() {
            var cart = document.querySelectorAll(".add-to-cart");
            cart.forEach(function (addBtn) {
              addBtn.addEventListener("click", function (e) {
                e.preventDefault();
                var btn = e.target;
                if (btn && !btn.classList.contains("add-to-cart")) {
                  btn = btn.closest(".add-to-cart");
                }
                addToCart(btn);
                return false;
              });
            });
          };
          attachEvents();

          // update page via ajax to make it faster
          nav.forEach(function (item) {
            item.addEventListener("click", function (e) {
              if (e.target.classList.contains("active")) {
                return false;
              }

              if (e.target.classList.contains("external")) {
                return;
              }

              // remove the other ones with active
              nav.forEach(function (item) {
                item.classList.remove("active");
              });
              e.target.classList.add("active");
              if (slider) {
                moveSliderToActive(slider, e.target);
              }
              e.preventDefault();
              main.classList.add("loading");
              main.innerHTML = "";
              hero.innerHTML = "";
              var url = item.getAttribute("href");
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.onload = function () {
                if (this.status === 200) {
                  var response = this.responseText;
                  var parser = new DOMParser();
                  var doc = parser.parseFromString(response, "text/html");
                  var updateHero = doc.querySelector(".hero-simple");
                  var updateMain = doc.querySelector(".plp__main");

                  // update the current page title and url
                  var title = doc.querySelector("title").innerText;
                  document.title = title;
                  window.history.pushState(
                    {
                      path: url,
                    },
                    title,
                    url
                  );
                  if (hero && updateHero) {
                    hero.innerHTML = updateHero.innerHTML;
                  }
                  if (main && updateMain) {
                    main.innerHTML = updateMain.innerHTML;
                  }
                  setTimeout(function () {
                    if (typeof window.lazy !== "undefined") {
                      window.lazy.update().check().handlers(true);
                    }
                    if (typeof window.layzr !== "undefined") {
                      window.layzr.update().check().handlers(true);
                    }
                    object_fit_images__WEBPACK_IMPORTED_MODULE_0___default()();

                    // scroll to the top of main
                    var y =
                      main.getBoundingClientRect().top +
                      window.pageYOffset -
                      document.querySelector(".js-header").offsetHeight;
                    window.scrollTo({
                      top: y,
                      behavior: "smooth",
                    });
                    main.classList.remove("loading");
                  }, 50);
                  attachEvents();
                }
              };
              xhr.send();
              return false;
            });
          });
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          Collection;

        /***/
      },

    /***/ "./src/js/sections/product.js":
      /*!************************************!*\
  !*** ./src/js/sections/product.js ***!
  \************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      "function" == typeof Symbol &&
                      obj.constructor === Symbol &&
                      obj !== Symbol.prototype
                      ? "symbol"
                      : typeof obj;
                  }),
            _typeof(obj)
          );
        }
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }
        var Product = function Product() {
          var productBar = document.querySelector(".product-bar");
          if (productBar) {
            var throttle = function throttle(func, timeFrame) {
              var lastTime = 0;
              return function () {
                var now = new Date();
                if (now - lastTime >= timeFrame) {
                  func();
                  lastTime = now;
                }
              };
            };
            var triggerAdd = document.querySelector(".product-form__submit");
            document.addEventListener(
              "scroll",
              throttle(function () {
                var triggerY = window.innerHeight;
                if (triggerAdd) {
                  triggerY = triggerAdd.offsetTop;
                }
                if (window.scrollY > triggerY) {
                  productBar.classList.remove("off-screen");
                  document.body.classList.add("has--product-bar");
                } else {
                  productBar.classList.add("off-screen");
                  document.body.classList.remove("has--product-bar");
                }
              }, 100)
            );
          }

          // subscribe widget. If has_selling_plan changes value then update the `active` class on the parent element
          var sellingPlan = document.querySelectorAll(
            'input[name="has_selling_plan"]'
          );
          if (sellingPlan.length > 0) {
            sellingPlan.forEach(function (el) {
              el.addEventListener("change", function (e) {
                var parent = el.closest(".product-form__selling-plans-toggle");
                if (parent) {
                  if (el.checked) {
                    parent.classList.add("active");

                    // remove the active class from any other parent elements
                    var others = document.querySelectorAll(
                      ".product-form__selling-plans-toggle.active"
                    );
                    others.forEach(function (other) {
                      if (other !== parent) {
                        other.classList.remove("active");
                      }
                    });
                  } else {
                    parent.classList.remove("active");
                  }
                }
              });
            });
          }

          // add gesture handling to the media
          var productMedia = document.querySelectorAll(
            ".product-main__gallery"
          );
          if (productMedia) {
            productMedia.forEach(function (item) {
              var imgs = item.querySelectorAll("img");
              var touchstartX = 0;
              var touchstartY = 0;
              imgs.forEach(function (img) {
                img.ondragstart = function (e) {
                  e.preventDefault();
                };
              });
              item.addEventListener(
                "touchstart",
                function (event) {
                  event.preventDefault();
                  touchstartX = event.changedTouches[0].screenX;
                  touchstartY = event.changedTouches[0].screenY;
                },
                false
              );
              item.addEventListener(
                "touchend",
                function (event) {
                  event.preventDefault();
                  touchendX = event.changedTouches[0].screenX;
                  touchendY = event.changedTouches[0].screenY;
                  handleGesture();
                },
                false
              );
              function handleGesture() {
                if (touchendX < touchstartX) {
                  console.log("Swiped left");
                }
                if (touchendX > touchstartX) {
                  console.log("Swiped right");
                }
                if (touchendY < touchstartY) {
                  console.log("Swiped up");
                }
                if (touchendY > touchstartY) {
                  console.log("Swiped down");
                }
                if (touchendY === touchstartY) {
                  console.log("Tap");
                }
              }
            });
          }
          var carousel = document.querySelector(".product-carousel");
          if (carousel) {
            var next = carousel.querySelector(".next");
            var prev = carousel.querySelector(".previous");
            var updateCarouselProgress = function updateCarouselProgress() {
              var active = document.querySelector(
                ".product-main__gallery-item.active"
              );
              if (active) {
                // count how many items there are before this one
                var items = document.querySelectorAll(
                  ".product-main__gallery-item"
                );
                var count = 1;
                for (var i = 0; i < items.length; i++) {
                  var item = items[i];
                  if (item === active) {
                    break;
                  }
                  count++;
                }
                var progress = document.querySelector(
                  ".product-carousel--progress-bar"
                );
                if (progress) {
                  progress.style.width = "".concat(
                    (count / items.length) * 100,
                    "%"
                  );
                }
              }
            };
            updateCarouselProgress();
            if (next && prev) {
              next.addEventListener("click", function (e) {
                var active = document.querySelector(
                  ".product-main__gallery-item.active"
                );
                if (active) {
                  var _next = active.nextElementSibling;
                  active.classList.remove("active");
                  if (_next) {
                    _next.classList.add("active");
                  } else {
                    // highlight first item
                    var first = document.querySelector(
                      ".product-main__gallery-item"
                    );
                    if (first) {
                      first.classList.add("active");
                    }
                  }
                }
                updateCarouselProgress();
                e.preventDefault();
                return false;
              });
              prev.addEventListener("click", function (e) {
                var active = document.querySelector(
                  ".product-main__gallery-item.active"
                );
                if (active) {
                  var _prev = active.previousElementSibling;
                  if (_prev) {
                    active.classList.remove("active");
                    _prev.classList.add("active");
                  } else {
                    // select the last one on the page
                    var last = document.querySelector(
                      ".product-main__gallery-item:last-child"
                    );
                    if (last) {
                      active.classList.remove("active");
                      last.classList.add("active");
                    }
                  }
                }
                updateCarouselProgress();
                e.preventDefault();
                return false;
              });
            }
          }
          var targetNode = document.getElementById(
            "shopify-product-reviews-holder"
          );
          function containsWhoUsedAgeTag(element) {
            return /\[who_used_age:\s*\d+\]/.test(element.innerHTML);
          }
          function removeAgeTagReadMore(reviews) {
            reviews.forEach(function (review) {
              var toggleContentBtn = review.querySelector(".yotpo-read-more");
              if (!toggleContentBtn) {
                return;
              } else {
                toggleContentBtn.addEventListener("click", function () {
                  var reviewContent = review.querySelector(
                    ".yotpo-read-more-text"
                  );
                  if (containsWhoUsedAgeTag(reviewContent)) {
                    reviewContent.innerHTML = reviewContent.innerHTML.replace(
                      /\[who_used_age:\s*\d+\]/g,
                      ""
                    ); // Remove the "[who_used_age: xx" from the content
                  }
                });
              }
            });
          }

          function removeAgeTag(reviews) {
            reviews.forEach(function (review) {
              var reviewContent = review.querySelector(".yotpo-read-more-text");
              if (reviewContent.classList.contains("age-removed")) {
                return;
              }
              reviewContent.innerHTML = reviewContent.innerHTML.replace(
                /\[who_used_age:\s*\d+\]/g,
                ""
              ); // Remove the "[who_used_age: xx" from the content
              reviewContent.innerHTML = reviewContent.innerHTML.replace(
                /\[who_used_age:/g,
                ""
              ); // Remove the "[who_used_age:" from the content
              reviewContent.classList.add("age-removed");
            });
          }
          var updateReviewUi = function updateReviewUi() {
            targetNode === null || targetNode === void 0
              ? void 0
              : targetNode.classList.remove("loading");

            // remove all notice of [who_used_age: %d] from the review .yotpo-review-content div
            var reviews = document.querySelectorAll(".yotpo-review-content");
            removeAgeTag(reviews);
            removeAgeTagReadMore(reviews);
          };
          if (targetNode) {
            var config = {
              childList: true,
              subtree: true,
            };

            // Callback function to execute when mutations are observed
            var callback = function callback(mutationList, observer) {
              var _iterator = _createForOfIteratorHelper(mutationList),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                  var mutation = _step.value;
                  if (mutation.type === "childList") {
                    updateReviewUi();
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            };
            var observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
          }
          var filter = document.querySelector(".filter-by-matching-tag");

          // go through all li children and check to see if any of them match the tag
          // on the page. If so, include else hide away! Designed so we always see
          // `take` number of items but prioritise the ones that match the tag
          if (filter) {
            var matchTarget = filter.dataset.match;
            var take = filter.dataset.take;
            if (matchTarget) {
              var value = document.querySelector(matchTarget);
              if (value) {
                var tag = value.innerText.trim();

                // check for matching tag in any article__tags
                var _items = filter.querySelectorAll("li");
                var found = 0;
                if (_items.length > 0) {
                  var _loop = function _loop() {
                    var item = _items[i];
                    if (found >= take) {
                      item.remove();
                      return {
                        v: void 0,
                      };
                    }
                    var match = false;
                    item
                      .querySelectorAll(".article__tag")
                      .forEach(function (el) {
                        var tagValue = el.innerText.trim();
                        if (tagValue === tag) {
                          match = true;
                        }
                      });
                    if (match) {
                      found++;
                      item.classList.remove("hidden");
                    }
                  };
                  for (var i = 0; i < _items.length; i++) {
                    var _ret = _loop();
                    if (_typeof(_ret) === "object") return _ret.v;
                  }
                  if (found < take) {
                    // now show the rest up to take
                    var _items2 = filter.querySelectorAll("li.hidden");
                    for (var _i = 0; _i < _items2.length; _i++) {
                      var item = _items2[_i];
                      if (found >= take) {
                        item.remove();
                      }
                      // move the item to the last in the list
                      item.classList.remove("hidden");
                      found++;
                    }
                  }
                }
              } else {
                // no filter found just delete children after take amount
                var _items3 = filter.querySelectorAll("li");
                if (_items3.length > take) {
                  for (var _i2 = take; _i2 < _items3.length; _i2++) {
                    var _item = _items3[_i2];
                    _item.remove();
                  }
                }
              }

              // if no ideas left then hide the whole section
              var items = filter.querySelectorAll("li:not(.hidden)");
              if (items.length === 0) {
                var sec = filter.closest("section");
                if (sec) {
                  sec.remove();
                }
              }
            }
          }

          // replace
        };

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Product;

        /***/
      },

    /***/ "./src/js/sections/quiz.js":
      /*!*********************************!*\
  !*** ./src/js/sections/quiz.js ***!
  \*********************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var vue_dist_vue__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! vue/dist/vue */ "./node_modules/vue/dist/vue.js"
          );
        /* harmony import */ var vue_dist_vue__WEBPACK_IMPORTED_MODULE_2___default =
          /*#__PURE__*/ __webpack_require__.n(
            vue_dist_vue__WEBPACK_IMPORTED_MODULE_2__
          );
        /* harmony import */ var _modules_product_card_product_card_vue_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../../modules/product-card/product-card.vue.js */ "./src/modules/product-card/product-card.vue.js"
          );
        /* harmony import */ var _lib_appState__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../lib/appState */ "./src/js/lib/appState.js"
          );
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      "function" == typeof Symbol &&
                      obj.constructor === Symbol &&
                      obj !== Symbol.prototype
                      ? "symbol"
                      : typeof obj;
                  }),
            _typeof(obj)
          );
        }
        function _slicedToArray(arr, i) {
          return (
            _arrayWithHoles(arr) ||
            _iterableToArrayLimit(arr, i) ||
            _unsupportedIterableToArray(arr, i) ||
            _nonIterableRest()
          );
        }
        function _nonIterableRest() {
          throw new TypeError(
            "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }
        function _iterableToArrayLimit(arr, i) {
          var _i =
            null == arr
              ? null
              : ("undefined" != typeof Symbol && arr[Symbol.iterator]) ||
                arr["@@iterator"];
          if (null != _i) {
            var _s,
              _e,
              _x,
              _r,
              _arr = [],
              _n = !0,
              _d = !1;
            try {
              if (((_x = (_i = _i.call(arr)).next), 0 === i)) {
                if (Object(_i) !== _i) return;
                _n = !1;
              } else
                for (
                  ;
                  !(_n = (_s = _x.call(_i)).done) &&
                  (_arr.push(_s.value), _arr.length !== i);
                  _n = !0
                );
            } catch (err) {
              (_d = !0), (_e = err);
            } finally {
              try {
                if (
                  !_n &&
                  null != _i["return"] &&
                  ((_r = _i["return"]()), Object(_r) !== _r)
                )
                  return;
              } finally {
                if (_d) throw _e;
              }
            }
            return _arr;
          }
        }
        function _arrayWithHoles(arr) {
          if (Array.isArray(arr)) return arr;
        }

        if (typeof Brave === "undefined") {
          window.Brave = {};
        }
        Brave.QuizModal =
          vue_dist_vue__WEBPACK_IMPORTED_MODULE_2___default().component(
            "Modal",
            {
              template: "#template-quiz-modal",
              props: ["data", "name"],
              data: function data() {
                return {
                  open: false,
                  quizResultBannerColor: "quiz-result__state--grey",
                  matchingProducts: [],
                };
              },
              methods: {
                toggleModal: function toggleModal() {
                  this.open = !this.open;
                },
              },
            }
          );
        var persistFields = [
          "day",
          "month",
          "year",
          "steps",
          "variables",
          "tags",
          "goals",
        ];
        var quiz = function quiz() {
          var q = document.querySelector("#quiz");
          if (!q) {
            return;
          }
          Brave.QuizApp =
            new (vue_dist_vue__WEBPACK_IMPORTED_MODULE_2___default())({
              el: "#quiz",
              components: {
                "quiz-modal": Brave.QuizModal,
                "product-card":
                  _modules_product_card_product_card_vue_js__WEBPACK_IMPORTED_MODULE_0__[
                    "default"
                  ],
              },
              delimiters: ["${", "}"],
              mounted: function mounted() {
                var searchParams = new URLSearchParams(window.location.search);
                if (searchParams.has("quizStep")) {
                  var i = 0;
                  while (this.currentStepIndex < searchParams.get("quizStep")) {
                    i++;
                    this.nextStep();
                    if (i == 10) {
                      break;
                    }
                  }
                }
                if (searchParams.has("finished")) {
                  this.showQuizResults(false);
                }
              },
              computed: {
                /**
                 * Returns an array of product IDs that match the user's quiz answers
                 */
                matchingProducts: function matchingProducts() {
                  var _this = this;
                  // if we have no tags then we're not showing any products
                  var tagsToMatchProducts = [
                    "anxiety",
                    "sleep",
                    "stress",
                    "focus",
                    "energy",
                  ].filter(function (tag) {
                    return (_this.goals || []).includes(tag);
                  });
                  if (tagsToMatchProducts.length === 0) {
                    return [];
                  }
                  var isVegan = this.tags.includes("vegan");
                  var result = window.ALL_PRODUCTS.filter(function (product) {
                    // if the user is vegan, we need to check if the product is vegan
                    if (isVegan) {
                      if (!product.tags.includes("quiz:Vegan")) {
                        return false;
                      }
                    }

                    // if we're under 18, we need to check if the product is for juniors
                    if (_this.age) {
                      if (_this.age < 18) {
                        if (!product.tags.includes("quiz:Junior")) {
                          return false;
                        }
                      } else if (product.tags.includes("quiz:Junior")) {
                        return false;
                      }
                    }
                    var matchProduct = tagsToMatchProducts.some(function (tag) {
                      return product.tags.includes(_this.quizTag(tag));
                    });
                    return matchProduct;
                  }).map(function (product) {
                    return {
                      id: product.id,
                      title: product.title,
                    };
                  });

                  // sort products by title alphabetically
                  result.sort(function (a, b) {
                    return a.title.localeCompare(b.title);
                  });

                  // just get the ids
                  var ids = result.map(function (product) {
                    return product.id;
                  });
                  return ids;
                },
              },
              methods: {
                quizTag: function quizTag(tag) {
                  // uc-first the first letter
                  return "quiz:" + tag.charAt(0).toUpperCase() + tag.slice(1);
                },
                isSelectedProduct: function isSelectedProduct(id) {
                  return this.matchingProducts.includes(id);
                },
                persist: function persist() {
                  var _this2 = this;
                  persistFields.forEach(function (field) {
                    localStorage.setItem(field, JSON.stringify(_this2[field]));
                  });
                  localStorage.setItem(
                    "quizExpiry",
                    Date.now() + 1000 * 60 * 60
                  );
                },
                progress: function progress() {
                  var percentage =
                    ((this.currentStepIndex + 1) / this.steps.length) * 100;
                  var css = "width:" + percentage + "%";
                  return css;
                },
                handleize: function handleize(input) {
                  if (Array.isArray(input)) {
                    input = input.join("-");
                  }
                  return input
                    .toString()
                    .toLowerCase()
                    .replace(/[^\w\u00C0-\u024f]+/g, "-")
                    .replace(/^-+|-+$/g, "");
                },
                headingForStep: function headingForStep(step) {
                  var title =
                    Brave.QuizData.summary["when"]["title"][this.variables.who];
                  if (
                    this.age &&
                    this.age <= 17 &&
                    typeof Brave.QuizData.summary["when"]["title"][
                      this.variables.who + "_underage"
                    ] !== "undefined"
                  ) {
                    title =
                      Brave.QuizData.summary["when"]["title"][
                        this.variables.who + "_underage"
                      ];
                  }
                  return this.injectVariables(title);
                },
                animateNextStep: function animateNextStep(event) {
                  var _this3 = this;
                  if (event && event.target && event.target.type !== "radio") {
                    // only applies for radio
                    return false;
                  }
                  var quizBox =
                    event && event.target
                      ? event.target.parentNode.querySelector(".quiz-box")
                      : null;
                  this.moving = true;
                  if (quizBox) {
                    quizBox.classList.add("flash");
                    setTimeout(function () {
                      quizBox.classList.remove("flash");
                      _this3.moving = false;
                      _this3.nextStep();
                    }, 200);
                  } else {
                    this.moving = false;
                    this.nextStep();
                  }
                },
                injectVariables: function injectVariables(input) {
                  if (input) {
                    var output = input.slice();
                    for (
                      var _i = 0,
                        _Object$entries = Object.entries(this.variables);
                      _i < _Object$entries.length;
                      _i++
                    ) {
                      var _Object$entries$_i = _slicedToArray(
                          _Object$entries[_i],
                          2
                        ),
                        key = _Object$entries$_i[0],
                        value = _Object$entries$_i[1];
                      if (key == "name") {
                        // captialize first letter
                        value = value.charAt(0).toUpperCase() + value.slice(1);
                      }
                      output = output.replace("[" + key + "]", value);
                    }
                    return output;
                  }
                },
                prevStep: function prevStep() {
                  if (this.moving) {
                    return false;
                  }
                  this.error = null;
                  var content = document.querySelector(".quiz-content");
                  if (content) {
                    content.classList.remove("completed");
                  }
                  if (this.currentStepIndex > 0) {
                    this.currentStepIndex--;
                  }

                  // update the url
                  if ("URLSearchParams" in window) {
                    var searchParams = new URLSearchParams(
                      window.location.search
                    );
                    searchParams.set("quizStep", this.currentStepIndex + 1);
                    searchParams["delete"]("finished");
                    var newRelativePathQuery =
                      window.location.pathname + "?" + searchParams.toString();
                    history.pushState(null, "", newRelativePathQuery);
                  }
                },
                nextStep: function nextStep() {
                  var _this4 = this;
                  if (this.moving) {
                    return false;
                  }
                  var vthis = this;
                  var step = this.steps[this.currentStepIndex];
                  this.error = null;
                  if (
                    step.variable !== undefined &&
                    (this.variables[step.variable] === undefined ||
                      this.variables[step.variable] == "")
                  ) {
                    if (step.answers !== undefined) {
                      this.error = "Select an answer to continue.";
                    } else {
                      if (step.variable == "name") {
                        this.error = "Please enter a name";
                      } else {
                        this.error =
                          "Please check you've filled in all the fields above";
                      }
                    }
                  }
                  if (step.answer == "date") {
                    if (this.day == "" || this.month == "" || this.year == "") {
                      this.error =
                        "Please check you've filled in all the fields above.";
                    }
                    var today = new Date();
                    var birthDate = new Date(
                      this.year,
                      new Date(Date.parse(this.month + " 1, 2022")).getMonth() +
                        1
                    );
                    var age = today.getFullYear() - birthDate.getFullYear();
                    if (!age || age < 6) {
                      this.error =
                        "Our formulations have been developed for those aged 6+";
                    } else {
                      this.age = age;

                      // update all the step titles

                      // add the age to the url parameters
                      if ("URLSearchParams" in window) {
                        var searchParams = new URLSearchParams(
                          window.location.search
                        );
                        searchParams.set("age", age);
                        var newRelativePathQuery =
                          window.location.pathname +
                          "?" +
                          searchParams.toString();
                        history.pushState(null, "", newRelativePathQuery);
                      }
                    }
                  }
                  if (step.selected !== undefined) {
                    if (
                      step.goals !== undefined &&
                      step.selected.length === 0
                    ) {
                      this.error = "Select an answer to continue";
                    }
                  } else {
                    //
                  }

                  // Merge selected tags with session tag list
                  if (step.tags !== undefined) {
                    if (step.goal !== undefined) {
                      this.mergeGoalTags(step.goal, step.selected, step.tags);
                    } else {
                      this.mergeTags(step.selected, step.tags);
                    }
                    if (
                      _typeof(step.selected) == undefined ||
                      !step.selected.length
                    ) {
                      this.error = "Select a answer to continue";
                    }
                  } else if (step.goals !== undefined && step.goals.length) {
                    // set the goals
                    console.log("SET GOALS", step.selected);
                    this.goals = step.selected;
                  }
                  if (this.error !== null) {
                    return;
                  }

                  // Add goal steps to the steps array
                  if (step.goals !== undefined) {
                    // Clear existing steps
                    this.steps = this.steps.slice(0, this.currentStepIndex + 1);
                    if (typeof step.selected == "string") {
                      var goal = step.selected;
                      if (
                        typeof Brave.QuizData.goalSteps[goal] == "undefined"
                      ) {
                        console.error("goalSteps not found for " + goal);
                      } else {
                        Brave.QuizData.goalSteps[goal].forEach(function (
                          goalStep
                        ) {
                          var heading = _this4.headingForStep(goalStep);
                          goalStep.heading = heading;
                          vthis.steps.push(goalStep);
                        });
                      }
                    } else {
                      step.selected.forEach(function (goal, index) {
                        if (
                          typeof Brave.QuizData.goalSteps[goal] === "undefined"
                        ) {
                          console.error("goalSteps not found for " + goal);
                          return;
                        }
                        Brave.QuizData.goalSteps[goal].forEach(function (
                          goalStep
                        ) {
                          goalStep.heading = goal;
                          vthis.steps.push(goalStep);
                        });
                      });
                    }
                  }

                  // update the url
                  if ("URLSearchParams" in window) {
                    var searchParams = new URLSearchParams(
                      window.location.search
                    );
                    searchParams.set("quizStep", this.currentStepIndex + 1);
                    searchParams["delete"]("start");
                    searchParams["delete"]("clear");
                    var newRelativePathQuery =
                      window.location.pathname + "?" + searchParams.toString();
                    history.pushState(null, "", newRelativePathQuery);
                  }

                  // Advance current step index
                  this.currentStepIndex++;
                },
                mergeGoalTags: function mergeGoalTags(
                  goal,
                  selectedTags,
                  stepTags
                ) {
                  var _this5 = this;
                  // if the selected tag has a `no-stress` tag, remove the `stress` goal
                  if (selectedTags.includes("no-stress")) {
                    this.goals = this.goals.filter(function (g) {
                      return g !== "stress";
                    });
                  }

                  // if the selected tag has a `no-focus` tag, remove the `focus` goal
                  if (selectedTags.includes("focus-king")) {
                    this.goals = this.goals.filter(function (g) {
                      return g !== "focus";
                    });
                  }

                  // if the selected tag has a `no-anxiety` tag, remove the `anxiety` goal
                  if (selectedTags.includes("cool-cucumber")) {
                    this.goals = this.goals.filter(function (g) {
                      return g !== "anxiety";
                    });
                  }

                  // if the selected tag has a `no-sleep` tag, remove the `sleep` goal
                  if (selectedTags.includes("professional-sleep")) {
                    this.goals = this.goals.filter(function (g) {
                      return g !== "sleep";
                    });
                  }
                  stepTags.forEach(function (tag) {
                    _this5.goals.filter(function (g) {
                      return tag !== g;
                    });
                  });
                  console.log("GOALS", this.goals);
                  console.log(
                    "mergeGoalTags after adding",
                    selectedTags,
                    this.goals
                  );
                  if (selectedTags) {
                    selectedTags.flat().forEach(function (tag) {
                      if (tag === null) return;
                      _this5.addGoal(tag);
                    });
                  }
                },
                addGoal: function addGoal(goal) {
                  console.log("addGoal", goal);
                  if (!this.goals.includes(goal)) {
                    this.goals.push(goal);
                  }
                },
                // Tags
                addTag: function addTag(tag) {
                  this.tags.push(tag);
                },
                removeTag: function removeTag(tag) {
                  this.tags = this.tags.filter(function (ele) {
                    return ele != tag;
                  });
                },
                mergeTags: function mergeTags(selectedTags, stepTags) {
                  var vthis = this;
                  // First remove any existing tags added from this step
                  stepTags.forEach(function (tag) {
                    vthis.removeTag(tag.value);
                  });
                  if (selectedTags) {
                    if (typeof selectedTags == "string") {
                      this.addTag(selectedTags);
                    } else {
                      selectedTags.flat().forEach(function (tag) {
                        if (tag === null) return;
                        vthis.addTag(tag);
                      });
                    }
                  }
                },
                disableOptions: function disableOptions(option) {
                  if (this.steps[this.currentStepIndex] === undefined) {
                    return "";
                  }
                  var step = this.steps[this.currentStepIndex];
                  if (step.max === undefined) {
                    return false;
                  }
                  if (step.selected.indexOf(option) !== -1) {
                    return false;
                  }
                  if (step.selected.length == step.max) {
                    return true;
                  }
                  return false;
                },
                setVariableFromDate: function setVariableFromDate() {
                  var step = this.steps[this.currentStepIndex];
                  this.variables[step.variable] =
                    this.day + " " + this.month + " " + this.year;
                  var today = new Date();
                  var birthDate = new Date(
                    this.year,
                    new Date(Date.parse(this.month + " 1, 2022")).getMonth() + 1
                  );
                  this.age = today.getFullYear() - birthDate.getFullYear();
                },
                isSelectedClass: function isSelectedClass(value) {
                  var step = this.steps[this.currentStepIndex];
                  if (
                    this.steps[this.currentStepIndex] === undefined ||
                    step.selected === undefined
                  ) {
                    return "";
                  }
                  var selectedJson = JSON.stringify(step.selected);
                  var valueJson = JSON.stringify(value);
                  return selectedJson.indexOf(valueJson) !== -1
                    ? "selected"
                    : "";
                },
                isVariableClass: function isVariableClass(variable, value) {
                  return this.variables[variable] == value ? "selected" : "";
                },
                sendEmail: function sendEmail() {
                  var _activeState$querySel,
                    _title$textContent,
                    _intro$textContent,
                    _this6 = this;
                  this.sendingEmail = true;
                  var data = [];
                  document
                    .querySelectorAll(".quiz-active-page .quiz-active-state")
                    .forEach(function (collection) {
                      var collectionData = {
                        products: [],
                      };
                      collection
                        .querySelectorAll(".quiz-active-product")
                        .forEach(function (item) {
                          var _heading$textContent,
                            _desc$textContent,
                            _category$textContent,
                            _price$textContent;
                          var link = item.querySelector("a[data-add-to-cart]");
                          var img = item.querySelector(".prod-email-img img");
                          var href = "";
                          if (link) {
                            var _link$getAttribute;
                            href =
                              (_link$getAttribute =
                                link.getAttribute("href")) !== null &&
                              _link$getAttribute !== void 0
                                ? _link$getAttribute
                                : "";
                            if (href.substring(0, 1) == "/") {
                              href = "https:/" + href;
                            }
                          }
                          var imgSrc = "";
                          if (img) {
                            var _img$getAttribute$toS, _img$getAttribute;
                            imgSrc =
                              (_img$getAttribute$toS =
                                (_img$getAttribute =
                                  img.getAttribute("src")) === null ||
                                _img$getAttribute === void 0
                                  ? void 0
                                  : _img$getAttribute.toString()) !== null &&
                              _img$getAttribute$toS !== void 0
                                ? _img$getAttribute$toS
                                : "";
                            if (imgSrc.substring(0, 1) == "/") {
                              imgSrc = "https:" + imgSrc;
                            }
                          }
                          var heading = item.querySelector(
                            ".quiz-result__product-title"
                          );
                          var price = item.querySelector(".money");
                          if (price === null) {
                            price = item.querySelector(".prod-price");
                          }
                          var desc = item.querySelector(".prod-desc p");
                          if (desc === null) {
                            desc = item.querySelector(".desc");
                          }
                          var category = item.querySelector(".prod-subtitle");

                          // @ts-ignore
                          collectionData.products.push({
                            link: href,
                            img: imgSrc,
                            title: heading
                              ? (_heading$textContent = heading.textContent) ===
                                  null || _heading$textContent === void 0
                                ? void 0
                                : _heading$textContent.trim()
                              : "",
                            content: desc
                              ? (_desc$textContent = desc.textContent) ===
                                  null || _desc$textContent === void 0
                                ? void 0
                                : _desc$textContent.trim()
                              : "",
                            category: category
                              ? (_category$textContent =
                                  category.textContent) === null ||
                                _category$textContent === void 0
                                ? void 0
                                : _category$textContent.trim()
                              : "",
                            price: price
                              ? (_price$textContent = price.textContent) ===
                                  null || _price$textContent === void 0
                                ? void 0
                                : _price$textContent.trim()
                              : "",
                          });
                        });
                      data.push(collectionData);
                    });
                  // POST data to send email
                  var activeState =
                    document.querySelector(".quiz-active-state");
                  if (!activeState) {
                    this.sendingEmail = false;
                    this.sentEmail = true;
                    return;
                  }
                  var intro =
                    (_activeState$querySel = activeState.querySelector(
                      ".quiz-result__state__desc"
                    )) !== null && _activeState$querySel !== void 0
                      ? _activeState$querySel
                      : activeState.querySelector(".desc");
                  var title = activeState.querySelector(
                    ".quiz-result__state__title"
                  );
                  fetch("https://douglas.akqa.nz/api/send", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      email: this.emailAddress,
                      brand: "braveface",
                      emailOptIn: this.emailOptIn,
                      firstName: this.firstName,
                      lastName: this.lastName,
                      title: title
                        ? (_title$textContent = title.textContent) === null ||
                          _title$textContent === void 0
                          ? void 0
                          : _title$textContent.trim()
                        : "",
                      intro: intro
                        ? (_intro$textContent = intro.textContent) === null ||
                          _intro$textContent === void 0
                          ? void 0
                          : _intro$textContent.trim()
                        : "",
                      collections: data,
                    }),
                  }).then(function (response) {
                    _this6.sendingEmail = false;
                    _this6.sentEmail = true;
                  });
                },
                isLetter: function isLetter(e) {
                  var _char = String.fromCharCode(e.keyCode); // Get the character
                  if (/^[A-Za-z\s]+$/.test(_char))
                    return true; // Match with regex
                  else e.preventDefault(); // If not match, don't add to input text
                },

                hideEmailModal: function hideEmailModal() {
                  this.sendingEmail = false;
                  this.sentEmail = false;
                  this.showingEmailModal = false;
                },
                showEmailModal: function showEmailModal() {
                  this.sendingEmail = false;
                  this.sentEmail = false;
                  this.showingEmailModal = true;
                },
                showQuizResults: function showQuizResults() {
                  var _this7 = this;
                  var title =
                    Brave.QuizData.summary["when"]["title"][this.variables.who];
                  var heading = this.injectVariables(title);
                  document
                    .querySelectorAll(".quiz-result__state__title")
                    .forEach(function (el) {
                      el.innerHTML = heading;
                    });
                  var content = document.querySelector(".quiz-content");
                  if (content) {
                    content.classList.add("completed");
                  }
                  var emptyStates = Brave.QuizData.summary["emptyStates"];
                  Object.keys(emptyStates).forEach(function (key) {
                    var holder = document.getElementById(key);
                    var empty = emptyStates[key];
                    if (!holder) {
                      console.error("No container for empty state", key);
                    } else {
                      holder.innerHTML = empty[_this7.variables.who];
                    }
                  });

                  // add the finished param to the url
                  var url = new URL(window.location.href);
                  url.searchParams.set("finished", "true");
                  url.searchParams["delete"]("quizStep");
                  url.searchParams.set("goals", JSON.stringify(this.goals));
                  url.searchParams.set("tags", JSON.stringify(this.tags));
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "quizFinished",
                    age: url.searchParams.get("age"),
                    goals: this.goals,
                    tags: this.tags,
                  });
                  window.history.pushState({}, "", url);
                },
              },
              watch: {
                currentStepIndex: function currentStepIndex() {
                  window.scrollTo(0, 0);
                  this.persist();

                  // Show results
                  if (this.steps[this.currentStepIndex] === undefined) {
                    this.showQuizResults();
                    return;
                  }
                  var step = this.steps[this.currentStepIndex];

                  // if this step is only for a certain type then push
                  // If this is an "if" card, check the condition
                  if (step["if"] !== undefined) {
                    // we have a conditional step! so value must match or the
                    // 'or' function must be true
                    var valueMatch =
                      this.variables[step["if"].variable] != step["if"].value;
                    var orMatch = false;
                    if (step["if"].value === "notJunior") {
                      // step is
                      if (this.age < 18) {
                        this.currentStepIndex++;
                        return;
                      }
                    }
                    if (typeof step["if"].or !== "undefined") {
                      if (step["if"].or == "underage") {
                        orMatch = this.age < 18;
                      }
                    }
                    if (!valueMatch && !orMatch) {
                      // skip this step
                      this.currentStepIndex++;
                      return;
                    }
                  }

                  // Inject variables into titles & captions
                  if (step.when !== undefined) {
                    // Title
                    if (step.when.title !== undefined) {
                      var t =
                        step.when.title[this.variables[step.when.variable]];
                      if (
                        this.age &&
                        this.age < 18 &&
                        typeof step.when.title[
                          this.variables[step.when.variable] + "_underage"
                        ] !== "undefined"
                      ) {
                        t =
                          step.when.title[
                            this.variables[step.when.variable] + "_underage"
                          ];
                      }
                      step.title = this.injectVariables(t);
                    }
                    // Caption
                    if (step.when.caption !== undefined) {
                      step.caption = this.injectVariables(
                        step.when.caption[this.variables[step.when.variable]]
                      );
                    }
                    // Placeholder
                    if (step.when.placeholder !== undefined) {
                      step.placeholder = this.injectVariables(
                        step.when.placeholder[
                          this.variables[step.when.variable]
                        ]
                      );
                    }
                    // Image
                    if (step.when.image !== undefined) {
                      step.image =
                        step.when.image[this.variables[step.when.variable]];
                    }
                  } else if (step.title !== undefined) {
                    step.title = this.injectVariables(step.title);
                  }
                },
                day: function day() {
                  this.setVariableFromDate();
                },
                month: function month() {
                  this.setVariableFromDate();
                },
                year: function year() {
                  this.setVariableFromDate();
                },
              },
              data: function data() {
                var days = [];
                for (var day = 1; day <= 31; day++) {
                  days.push(day);
                }
                var months = Array.from(
                  {
                    length: 12,
                  },
                  function (e, i) {
                    return new Date(null, i + 1, null).toLocaleDateString(
                      "en",
                      {
                        month: "short",
                      }
                    );
                  }
                );
                var years = [];
                var currentYear = new Date().getFullYear();
                for (var year = currentYear; year >= 1930; year--) {
                  years.push(year);
                }
                var searchParams = new URLSearchParams(window.location.search);
                var age = 0;
                if (searchParams.get("age")) {
                  age = searchParams.get("age");
                }
                var data = {
                  asset_url: Shopify.asset_url,
                  currentStepIndex: 0,
                  error: null,
                  totalSteps: Brave.QuizData.steps.length + 2,
                  tags: [],
                  goals: [],
                  moving: false,
                  day: "",
                  month: "",
                  year: "",
                  age: age,
                  variables: {},
                  steps: Brave.QuizData.steps,
                  days: days,
                  months: months,
                  years: years,
                  emailAddress: "",
                  showingEmailModal: false,
                  sendingEmail: false,
                  sentEmail: false,
                  firstName: "",
                  lastName: "",
                  emailOptIn: true,
                };
                var searchParams = new URLSearchParams(window.location.search);
                var now = new Date();
                var expiry = localStorage.getItem("quizExpiry");
                if (
                  searchParams.has("clear") ||
                  !expiry ||
                  now.getTime() > expiry
                ) {
                  persistFields.forEach(function (field) {
                    localStorage.clear(field);
                  });
                } else {
                  persistFields.forEach(function (field) {
                    if (localStorage.getItem(field)) {
                      data[field] = JSON.parse(localStorage.getItem(field));
                    }
                  });
                }
                return data;
              },
            });

          // Quiz Start
          var startButton = document.querySelector(".hero-main__btn");
          var quiz = document.querySelector("#quiz");
          var landing = document.querySelector(
            "#shopify-section-quiz-hero-top"
          );
          Brave.startQuiz = function (updateUrl) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "quizStarted",
            });
            window.scrollTo(0, 0);
            landing.style.display = "none";
            quiz.style.display = "block";
            document.body.classList.add("quiz-started");

            // update the url
            if (updateUrl && "URLSearchParams" in window) {
              var searchParams = new URLSearchParams(window.location.search);
              if (searchParams.has("quizStep")) {
              } else {
                searchParams.set("quizStep", 1);
                searchParams.set("start", 1);
                var newRelativePathQuery =
                  window.location.pathname + "?" + searchParams.toString();
                history.pushState(null, "", newRelativePathQuery);
              }
            }
          };
          startButton.addEventListener("click", function (e) {
            e.preventDefault();
            Brave.startQuiz(true);
            return false;
          });
          Brave.qs = new URLSearchParams(window.location.search);
          if (
            Brave.qs.has("start") ||
            Brave.qs.has("quizStep") ||
            Brave.qs.has("finished")
          ) {
            Brave.startQuiz(false);
          }
          document
            .querySelectorAll("[data-add-to-cart]")
            .forEach(function (el) {
              el.addEventListener("click", function (e) {
                e.preventDefault();
                var variantId = this.getAttribute("data-variant-id");
                var quantity = 1;
                e.target.classList.add("loading");
                e.target.classList.add("disabled");
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "quizPurchase",
                  ecommerce: {
                    purchase: {
                      products: [
                        {
                          id: variantId,
                        },
                      ],
                    },
                  },
                });

                // Add to shopify cart via fetch
                fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    items: [
                      {
                        id: variantId,
                        quantity: quantity,
                      },
                    ],
                  }),
                })
                  .then(function (response) {
                    return response.json();
                  })
                  .then(function (data) {
                    e.target.classList.remove("loading");
                    e.target.classList.remove("disabled");
                    var cartIcon = document.querySelector(
                      "#header-cart-icon-button"
                    );
                    _lib_appState__WEBPACK_IMPORTED_MODULE_1__[
                      "default"
                    ].lastAdd = Date.now();
                    if (cartIcon) {
                      cartIcon.click();
                      return;
                    }
                  });
                return false;
              });
            });
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = quiz;

        /***/
      },

    /***/ "./src/js/sections/stockists.js":
      /*!**************************************!*\
  !*** ./src/js/sections/stockists.js ***!
  \**************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var vue2_google_maps__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! vue2-google-maps */ "./node_modules/vue2-google-maps/dist/main.js"
          );

        var WARNING_MAX_DISTANCE_KM = 40;
        var MAX_DISTANCE_KM = 80;
        var MAX_RESULTS = 15;
        var getDistanceFromLatLonInKm = function getDistanceFromLatLonInKm(
          lat1,
          lon1,
          lat2,
          lon2
        ) {
          var R = 6371; // Radius of the earth in km
          var dLat = deg2rad(lat2 - lat1); // deg2rad below
          var dLon = deg2rad(lon2 - lon1);
          var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) *
              Math.cos(deg2rad(lat2)) *
              Math.sin(dLon / 2) *
              Math.sin(dLon / 2);
          var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
          var d = R * c; // Distance in km
          return d;
        };
        var deg2rad = function deg2rad(deg) {
          return deg * (Math.PI / 180);
        };
        var initStockists = function initStockists() {
          var _window$MAP_COUNTRY,
            _window$FILTER_BY_NAM,
            _window$MAP_LAT,
            _window$MAP_LNG,
            _URLSearchParams$get,
            _window$MAP_LAT2,
            _window$MAP_LNG2;
          var GOOGLE_PUBLIC_KEY = "AIzaSyBRxHQJ9-W9VaKO-axsaDILmiw4kVuxoc0";
          window.Vue.use(vue2_google_maps__WEBPACK_IMPORTED_MODULE_0__, {
            load: {
              key: GOOGLE_PUBLIC_KEY,
              // heyday.co.nz@gmail
              libraries: "places",
            },
          });
          var stockists = new Vue({
            el: "#stockists",
            methods: {
              onSubmit: function onSubmit() {
                var _this = this;
                // if the text is a lat/long, use that
                var regexExp =
                  /^((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)$/gi;
                if (this.location && regexExp.test(this.location)) {
                  this.lat = this.location.split(",")[0];
                  this.lng = this.location.split(",")[1];

                  // geocode the lat/long to get the country
                  var updateUrl =
                    "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                    this.lat +
                    "," +
                    this.lng +
                    "&sensor=false&key=" +
                    "AIzaSyCFODeRlkQpXi6x_78NFbRpym1XwrVpa9w";
                  fetch(updateUrl)
                    .then(function (response) {
                      return response.json();
                    })
                    .then(function (data) {
                      _this.country = data.results[0].address_components
                        .find(function (component) {
                          return component.types.includes("country");
                        })
                        .short_name.toUpperCase();
                      _this.isInAu = _this.country == "AU";
                      _this.isInNz = _this.country == "NZ";
                      _this.triggerSearch(true);
                    });
                }
              },
              generateFilteredStockists: function generateFilteredStockists() {
                var _this2 = this;
                var rebounds =
                  arguments.length > 0 && arguments[0] !== undefined
                    ? arguments[0]
                    : false;
                if (typeof window.stockists === "undefined") {
                  return;
                }
                var addressLat = this.lat;
                var addressLng = this.lng;
                var bounds = new google.maps.LatLngBounds();
                var isInRange = false;
                var stockistsWithDistances = window.stockists.map(function (
                  stockist
                ) {
                  var distance = getDistanceFromLatLonInKm(
                    addressLat,
                    addressLng,
                    stockist.lat,
                    stockist.lng
                  );
                  stockist.distance = distance;
                  if (distance < WARNING_MAX_DISTANCE_KM) {
                    isInRange = true;
                  }
                  return stockist;
                });
                var filtered = stockistsWithDistances.filter(function (
                  stockist
                ) {
                  return (
                    stockist.distance > 0 &&
                    stockist.distance <= MAX_DISTANCE_KM
                  );
                });
                this.hasStockistInRange = isInRange;
                console.log(this.filterByName, "WILL FILTER BY NAME");
                this.filteredStockists = filtered
                  .sort(function (a, b) {
                    return a.distance - b.distance;
                  })
                  .filter(function (stockist) {
                    return _this2.filterByName
                      ? stockist.name
                          .toLowerCase()
                          .includes(_this2.filterByName.toLowerCase())
                      : true;
                  })
                  .splice(0, MAX_RESULTS);
                this.filteredStockists.forEach(function (stockist) {
                  bounds.extend({
                    lat: stockist.lat,
                    lng: stockist.lng,
                  });
                });
                this.loading = false;
                if (this.googleMap) {
                  if (rebounds) {
                    if (this.filteredStockists.length > 0) {
                      this.googleMap.fitBounds(bounds);
                    }
                    this.triggerMove = false;
                    this.googleMap.setCenter(
                      new google.maps.LatLng(addressLat, addressLng)
                    );
                  }
                }
              },
              triggerSearch: function triggerSearch() {
                var rebounds =
                  arguments.length > 0 && arguments[0] !== undefined
                    ? arguments[0]
                    : true;
                this.loading = true;
                this.generateFilteredStockists(rebounds);
                var url = new URL(window.location);
                url.searchParams.set("location", this.lat + "," + this.lng);
                window.history.pushState({}, "", url);
              },
              getDirections: function getDirections(e) {
                return "https://www.google.com/maps/dir/?api=1&destination="
                  .concat(e.lat, ",")
                  .concat(e.lng);
              },
              getTel: function getTel(phone) {
                return "tel:".concat(phone.replaceAll(" ", ""));
              },
              getDistance: function getDistance(stockist) {
                var distance = stockist.distance.toFixed(1);
                return "".concat(distance, "km");
              },
              getHours: function getHours(stockist) {
                var day = new Date().getDay() - 1;
                if (day == -1) {
                  day = 6;
                }
                if (typeof stockist.opening_hours[day] !== "undefined") {
                  var text = stockist.opening_hours[day];
                  if (text.indexOf("Closed") > -1) {
                    return "Closed";
                  } else {
                    var closes = text.split(" – ")[1];
                    console.log(closes);
                    if (!closes) {
                      return '<span class="text-green">Open</span>';
                    }
                    return (
                      '<span class="text-green">Open</span> - Closes ' + closes
                    );
                  }
                }
                return "";
              },
              getPosition: function getPosition(stockist) {
                return {
                  lat: stockist.lat,
                  lng: stockist.lng,
                };
              },
              toggleInfoWindow: function toggleInfoWindow(stockist, idx) {
                this.infoWindowPos = new google.maps.LatLng({
                  lat: stockist.lat,
                  lng: stockist.lng,
                });
                this.infoOptions.content = document.querySelector(
                  '.stockist[data-id="' + idx + '"]'
                ).innerHTML;
                if (this.currentMidx == idx) {
                  this.infoWinOpen = !this.infoWinOpen;
                } else {
                  this.infoWinOpen = true;
                  this.currentMidx = idx;
                }
              },
              useCurrentLocation: function useCurrentLocation(e) {
                var _this3 = this;
                e.preventDefault();
                try {
                  this.loading = true;
                  var options = {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0,
                  };
                  this.location = "My location";
                  var success = function success(pos) {
                    _this3.lat = pos.coords.latitude;
                    _this3.lng = pos.coords.longitude;
                    _this3.triggerSearch(true);
                  };
                  navigator.geolocation.getCurrentPosition(
                    success,
                    function (err) {
                      console.warn(
                        "ERROR(".concat(err.code, "): ").concat(err.message)
                      );
                      _this3.loading = false;
                    },
                    options
                  );
                } catch (e) {
                  console.error(e);
                }
              },
            },
            mounted: function mounted() {
              var _this4 = this;
              this.$refs.mapRef.$mapPromise.then(function (map) {
                _this4.googleMap = map;
                var provided = new URLSearchParams(window.location.search).get(
                  "location"
                );
                if (provided) {
                  _this4.onSubmit();
                } else {
                  _this4.generateFilteredStockists(true);
                }
                var self = _this4;
                google.maps.event.addListener(map, "idle", function () {
                  if (
                    !this.get("dragging") &&
                    this.get("oldCenter") &&
                    this.get("oldCenter") !== this.getCenter()
                  ) {
                    self.lat = this.getCenter().lat();
                    self.lng = this.getCenter().lng();
                    self.triggerSearch(false);
                  }
                  if (!this.get("dragging")) {
                    this.set("oldCenter", this.getCenter());
                  }
                });
                google.maps.event.addListener(map, "dragstart", function () {
                  this.set("dragging", true);
                });
                google.maps.event.addListener(map, "dragend", function () {
                  this.set("dragging", false);
                  google.maps.event.trigger(this, "idle", {});
                });
                var autocomplete = new google.maps.places.Autocomplete(
                  document.querySelector("#autocomplete")
                );
                autocomplete.addListener("place_changed", function () {
                  self.loading = true;
                  var place = autocomplete.getPlace();
                  if (place && place.geometry) {
                    self.lat = place.geometry.location.lat();
                    self.lng = place.geometry.location.lng();
                    self.location = place.formatted_address;
                    self.country = place.address_components
                      .find(function (component) {
                        return component.types.includes("country");
                      })
                      .short_name.toUpperCase();
                    self.isInAu = self.country == "AU";
                    self.isInNz = self.country == "NZ";
                    self.triggerSearch(true);
                  }
                });
              });
            },
            data: {
              stockists: window.stockists,
              filteredStockists: [],
              hasStockistInRange: true,
              loading: true,
              isInNz: window.MAP_COUNTRY == "nz",
              isInAu: window.MAP_COUNTRY == "au",
              country:
                (_window$MAP_COUNTRY = window.MAP_COUNTRY) !== null &&
                _window$MAP_COUNTRY !== void 0
                  ? _window$MAP_COUNTRY
                  : "nz",
              filterByName:
                (_window$FILTER_BY_NAM = window.FILTER_BY_NAME) !== null &&
                _window$FILTER_BY_NAM !== void 0
                  ? _window$FILTER_BY_NAM
                  : false,
              lat:
                (_window$MAP_LAT = window.MAP_LAT) !== null &&
                _window$MAP_LAT !== void 0
                  ? _window$MAP_LAT
                  : -36.8508827,
              lng:
                (_window$MAP_LNG = window.MAP_LNG) !== null &&
                _window$MAP_LNG !== void 0
                  ? _window$MAP_LNG
                  : 174.7644881,
              googleMap: null,
              triggerMove: true,
              location:
                (_URLSearchParams$get = new URLSearchParams(
                  window.location.search
                ).get("location")) !== null && _URLSearchParams$get !== void 0
                  ? _URLSearchParams$get
                  : "",
              mapCenter: {
                lat:
                  (_window$MAP_LAT2 = window.MAP_LAT) !== null &&
                  _window$MAP_LAT2 !== void 0
                    ? _window$MAP_LAT2
                    : -36.8508827,
                lng:
                  (_window$MAP_LNG2 = window.MAP_LNG) !== null &&
                  _window$MAP_LNG2 !== void 0
                    ? _window$MAP_LNG2
                    : 174.7644881,
              },
              infoWindowPos: null,
              infoWinOpen: false,
              currentMidx: null,
              infoOptions: {
                content: "Hello",
                height: 160,
                width: 300,
                pixelOffset: {
                  width: 0,
                  height: -35,
                },
              },
              mapOptions: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                gestureHandling: "cooperative",
                fullscreenControl: true,
                minZoom: 7,
                zoom: 14,
                disableDefaultUi: false,
                styles: [
                  {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                      {
                        color: "#e9e9e9",
                      },
                      {
                        lightness: 17,
                      },
                    ],
                  },
                  {
                    featureType: "landscape",
                    elementType: "geometry",
                    stylers: [
                      {
                        color: "#f5f5f5",
                      },
                      {
                        lightness: 20,
                      },
                    ],
                  },
                  {
                    featureType: "road.highway",
                    elementType: "geometry.fill",
                    stylers: [
                      {
                        color: "#ffffff",
                      },
                      {
                        lightness: 17,
                      },
                    ],
                  },
                  {
                    featureType: "road.highway",
                    elementType: "geometry.stroke",
                    stylers: [
                      {
                        color: "#ffffff",
                      },
                      {
                        lightness: 29,
                      },
                      {
                        weight: 0.2,
                      },
                    ],
                  },
                  {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [
                      {
                        color: "#ffffff",
                      },
                      {
                        lightness: 18,
                      },
                    ],
                  },
                  {
                    featureType: "road.local",
                    elementType: "geometry",
                    stylers: [
                      {
                        color: "#ffffff",
                      },
                      {
                        lightness: 16,
                      },
                    ],
                  },
                  {
                    featureType: "poi",
                    elementType: "geometry",
                    stylers: [
                      {
                        color: "#f5f5f5",
                      },
                      {
                        lightness: 21,
                      },
                    ],
                  },
                  {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [
                      {
                        color: "#dedede",
                      },
                      {
                        lightness: 21,
                      },
                    ],
                  },
                  {
                    elementType: "labels.text.stroke",
                    stylers: [
                      {
                        visibility: "on",
                      },
                      {
                        color: "#ffffff",
                      },
                      {
                        lightness: 16,
                      },
                    ],
                  },
                  {
                    elementType: "labels.text.fill",
                    stylers: [
                      {
                        saturation: 36,
                      },
                      {
                        color: "#333333",
                      },
                      {
                        lightness: 40,
                      },
                    ],
                  },
                  {
                    elementType: "labels.icon",
                    stylers: [
                      {
                        visibility: "off",
                      },
                    ],
                  },
                  {
                    featureType: "transit",
                    elementType: "geometry",
                    stylers: [
                      {
                        color: "#f2f2f2",
                      },
                      {
                        lightness: 19,
                      },
                    ],
                  },
                  {
                    featureType: "administrative",
                    elementType: "geometry.fill",
                    stylers: [
                      {
                        color: "#fefefe",
                      },
                      {
                        lightness: 20,
                      },
                    ],
                  },
                  {
                    featureType: "administrative",
                    elementType: "geometry.stroke",
                    stylers: [
                      {
                        color: "#fefefe",
                      },
                      {
                        lightness: 17,
                      },
                      {
                        weight: 1.2,
                      },
                    ],
                  },
                ],
              },
            },
          });
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          initStockists;

        /***/
      },

    /***/ "./src/modules/accordion/accordion.js":
      /*!********************************************!*\
  !*** ./src/modules/accordion/accordion.js ***!
  \********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! select-dom */ "./node_modules/select-dom/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_1__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");

        console.log("hi!");
        var ACCORDION_QUESTION_SELECTOR = ".js-accordion-question";
        var ACCORDION_CONTENT_SELECTOR = ".js-accordion-content";
        var NO_JS_CLASS = "no-js";
        var ACCORDION_TRIGGER_CLASSES = [
          "p1",
          "accordion-trigger",
          "accordion__trigger",
        ];
        var initAccordionTrigger = function initAccordionTrigger(questionEl) {
          var accordionId = questionEl.getAttribute("data-accordion-id");
          var accordionText = questionEl.textContent;
          if (!accordionId || !accordionText) {
            return;
          }
          questionEl.setAttribute("aria-controls", accordionId);
          questionEl.setAttribute("aria-expanded", "false");
          ACCORDION_TRIGGER_CLASSES.map(function (accordionClass) {
            (0,
            lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(questionEl, accordionClass);
          });
        };
        var handleTriggerAccordion = function handleTriggerAccordion(e) {
          if (!e.target.closest(ACCORDION_QUESTION_SELECTOR)) {
            return;
          }
          var accordionTrigger = e.target;
          console.log(accordionTrigger);
          var isAccordionOpened =
            accordionTrigger.getAttribute("aria-expanded");
          if (isAccordionOpened === "false") {
            openAccordion(accordionTrigger);
          } else {
            closeAccordion(accordionTrigger);
          }
        };
        var openAccordion = function openAccordion(trigger) {
          var accordionId = trigger.getAttribute("aria-controls");
          var accordionContentEl = document.getElementById(accordionId);
          if (!accordionContentEl) {
            return;
          }
          trigger.setAttribute("aria-expanded", "true");
          trigger.setAttribute("aria-disabled", "true");
          accordionContentEl.setAttribute("aria-hidden", "false");
        };
        var closeAccordion = function closeAccordion(trigger) {
          var accordionId = trigger.getAttribute("aria-controls");
          var accordionContentEl = document.getElementById(accordionId);
          if (!accordionContentEl) {
            return;
          }
          trigger.setAttribute("aria-expanded", "false");
          trigger.removeAttribute("aria-disabled", "true");
          accordionContentEl.setAttribute("aria-hidden", "true");
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(el, NO_JS_CLASS);
            var accordionQuestionEls = select_dom__WEBPACK_IMPORTED_MODULE_0__[
              "default"
            ].all(ACCORDION_QUESTION_SELECTOR, el);
            if (accordionQuestionEls.length) {
              accordionQuestionEls.map(function (questionEl) {
                initAccordionTrigger(questionEl);
              });
            }
            var accordionContentEls = select_dom__WEBPACK_IMPORTED_MODULE_0__[
              "default"
            ].all(ACCORDION_CONTENT_SELECTOR, el);
            if (accordionContentEls.length) {
              accordionContentEls.map(function (contentEl) {
                contentEl.setAttribute("aria-hidden", "true");
              });
            }
            dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
              document,
              "click",
              handleTriggerAccordion
            );
          };

        /***/
      },

    /***/ "./src/modules/account-activate-form/account-activate-form.js":
      /*!********************************************************************!*\
  !*** ./src/modules/account-activate-form/account-activate-form.js ***!
  \********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var mixins_validate_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! mixins/validate.js */ "./src/js/mixins/validate.js"
          );

        Vue.component("account-reset-form", {
          data: function data() {
            return {};
          },
          mixins: [mixins_validate_js__WEBPACK_IMPORTED_MODULE_0__["default"]],
        });

        /***/
      },

    /***/ "./src/modules/account-address-item/account-address-item.vue.js":
      /*!**********************************************************************!*\
  !*** ./src/modules/account-address-item/account-address-item.vue.js ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");

        Vue.component("account-address-item", {
          props: [
            "firstName",
            "lastName",
            "company",
            "address1",
            "address2",
            "city",
            "province",
            "zip",
            "country",
            "phone",
            "isDefault",
            "id",
          ],
          data: function data() {
            return {};
          },
          computed: {},
          methods: {
            update: function update() {
              this.$emit(
                "update",
                (0, lib_util__WEBPACK_IMPORTED_MODULE_0__.deepClone)(
                  this.$options.propsData
                )
              );
            },
            remove: function remove() {
              // if (
              //   !confirm('Are you sure that you want to delete this address?')
              // ) return

              var form = document.createElement("form");
              var input = document.createElement("input");
              form.setAttribute("method", "post");
              form.setAttribute("action", "/account/addresses/" + this.id);
              input.setAttribute("type", "hidden");
              input.setAttribute("name", "_method");
              input.setAttribute("value", "delete");
              form.appendChild(input);
              document.body.appendChild(form);
              form.submit();
              document.body.removeChild(form);
            },
          },
        });

        /***/
      },

    /***/ "./src/modules/account-address/account-address.js":
      /*!********************************************************!*\
  !*** ./src/modules/account-address/account-address.js ***!
  \********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var vue_scrollto__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! vue-scrollto */ "./node_modules/vue-scrollto/vue-scrollto.js"
          );
        /* harmony import */ var vue_scrollto__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            vue_scrollto__WEBPACK_IMPORTED_MODULE_0__
          );

        Vue.use(vue_scrollto__WEBPACK_IMPORTED_MODULE_0___default());
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              data: function data() {
                return {
                  activeAddress: {},
                  showNewAddressForm: false,
                };
              },
              methods: {
                toggleNewAddressForm: function toggleNewAddressForm(show) {
                  var _this = this;
                  this.showNewAddressForm = show;
                  show &&
                    this.$nextTick(function () {
                      _this.$scrollTo(_this.$refs["newAddressForm"]);
                    });
                },
                populateAddressForm: function populateAddressForm(data) {
                  this.activeAddress = data;
                  this.toggleNewAddressForm(true);
                },
                showEmptyForm: function showEmptyForm() {
                  for (var key in this.activeAddress) {
                    this["activeAddress"][key] = "";
                  }
                  this.toggleNewAddressForm(true);
                },
              },
            });
          };

        /***/
      },

    /***/ "./src/modules/account-forms/account-forms.js":
      /*!****************************************************!*\
  !*** ./src/modules/account-forms/account-forms.js ***!
  \****************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! query-string */ "./node_modules/query-string/index.js"
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              data: function data() {
                return {
                  activeForm: "login",
                };
              },
              mounted: function mounted() {
                this.convertUrlIDtoQueryString();
                this.changeForm();
              },
              methods: {
                convertUrlIDtoQueryString:
                  function convertUrlIDtoQueryString() {
                    if (~window.location.href.indexOf("#recover")) {
                      window.history.replaceState(
                        null,
                        null,
                        "".concat(window.location.pathname, "?form=recover")
                      );
                    }
                  },
                changeForm: function changeForm() {
                  var form =
                    arguments.length > 0 && arguments[0] !== undefined
                      ? arguments[0]
                      : false;
                  var parsed = query_string__WEBPACK_IMPORTED_MODULE_0__.parse(
                    window.location.search
                  );
                  if (!form && !parsed.form) {
                    return;
                  }
                  if (!form) {
                    form = parsed.form;
                  } else {
                    parsed.form = form;
                  }
                  this.activeForm = form;
                  window.history.replaceState(
                    null,
                    null,
                    ""
                      .concat(window.location.pathname, "?")
                      .concat(
                        query_string__WEBPACK_IMPORTED_MODULE_0__.stringify(
                          parsed
                        )
                      )
                  );
                },
              },
            });
          };

        /***/
      },

    /***/ "./src/modules/account-login-form/account-login-form.vue.js":
      /*!******************************************************************!*\
  !*** ./src/modules/account-login-form/account-login-form.vue.js ***!
  \******************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var mixins_validate_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! mixins/validate.js */ "./src/js/mixins/validate.js"
          );

        Vue.component("account-login-form", {
          data: function data() {
            return {};
          },
          computed: {
            active: function active() {
              return this.$parent.activeForm === "login";
            },
          },
          mixins: [mixins_validate_js__WEBPACK_IMPORTED_MODULE_0__["default"]],
        });

        /***/
      },

    /***/ "./src/modules/account-new-address/account-new-address.vue.js":
      /*!********************************************************************!*\
  !*** ./src/modules/account-new-address/account-new-address.vue.js ***!
  \********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var mixins_validate__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! mixins/validate */ "./src/js/mixins/validate.js"
          );
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! dom-select */ "./node_modules/dom-select/index.js"
          );
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_select__WEBPACK_IMPORTED_MODULE_1__
          );

        var Countries = window.Countries;

        Vue.component("account-new-address", {
          props: [
            "firstName",
            "lastName",
            "company",
            "address1",
            "address2",
            "city",
            "province",
            "zip",
            "country",
            "phone",
            "isDefault",
            "id",
            "toggleNewAddressForm",
          ],
          data: function data() {
            return {
              activeCountry: this.getCountryFromCode(this.country),
            };
          },
          mixins: [mixins_validate__WEBPACK_IMPORTED_MODULE_0__["default"]],
          computed: {
            showProvinceSelect: function showProvinceSelect() {
              return (
                this.activeCountry &&
                Countries[this.activeCountry] &&
                (Countries[this.activeCountry].provinces || []).length
              );
            },
            formAction: function formAction() {
              if (this.id) {
                return "/account/addresses/".concat(this.id);
              } else {
                return "/account/addresses";
              }
            },
          },
          methods: {
            getInitialValue: function getInitialValue(name) {
              var match = name.match(/\[(.*)\]/);
              if (!match[1]) {
                return "";
              }
              var str = match[1];
              switch (str) {
                case "first_name":
                  return this["firstName"] || "";
                case "last_name":
                  return this["lastName"] || "";
                case "country":
                  return this["country"] || "US";
                case "default":
                  return this["isDefault"] || false;
                default:
                  return this[str] || "";
              }
            },
            getCountryFromCode: function getCountryFromCode(value) {
              return Object.keys(Countries).find(function (k) {
                return Countries[k]["code"] === value;
              });
            },
            onInputChange: function onInputChange(_ref) {
              var name = _ref.name,
                value = _ref.value;
              var match = /\D\[(\D+)\]/.exec(name);
              if (!match || !match[1]) {
                return false;
              }
              if (match[1] === "country" && value) {
                this.activeCountry = this.getCountryFromCode(value);
                var country = Countries[this.activeCountry];
                this["zip_required"] = country["zip_required"];
              }
            },
            generateCountryArray: function generateCountryArray() {
              return Object.keys(Countries).map(function (label) {
                return {
                  label: label,
                  value: Countries[label].code,
                };
              });
            },
            generateProvinceArray: function generateProvinceArray() {
              if (!this.showProvinceSelect) {
                return [];
              }
              var opts = Countries[this.activeCountry]["province_codes"];
              return Object.keys(opts).map(function (label) {
                return {
                  label: label,
                  value: opts[label],
                };
              });
            },
            isValidZip: function isValidZip(_ref2) {
              var value = _ref2.value;
              if (this["zip_required"] && !value.length) {
                return false;
              }
              return true;
            },
          },
        });

        /***/
      },

    /***/ "./src/modules/account-recover-form/account-recover-form.vue.js":
      /*!**********************************************************************!*\
  !*** ./src/modules/account-recover-form/account-recover-form.vue.js ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var mixins_validate__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! mixins/validate */ "./src/js/mixins/validate.js"
          );

        Vue.component("account-recover-form", {
          data: function data() {
            return {};
          },
          computed: {
            active: function active() {
              return this.$parent.activeForm === "recover";
            },
          },
          mixins: [mixins_validate__WEBPACK_IMPORTED_MODULE_0__["default"]],
        });

        /***/
      },

    /***/ "./src/modules/account-register-form/account-register-form.vue.js":
      /*!************************************************************************!*\
  !*** ./src/modules/account-register-form/account-register-form.vue.js ***!
  \************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var mixins_validate__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! mixins/validate */ "./src/js/mixins/validate.js"
          );

        Vue.component("account-register-form", {
          data: function data() {
            return {};
          },
          mixins: [mixins_validate__WEBPACK_IMPORTED_MODULE_0__["default"]],
        });

        /***/
      },

    /***/ "./src/modules/account-reset-form/account-reset-form.vue.js":
      /*!******************************************************************!*\
  !*** ./src/modules/account-reset-form/account-reset-form.vue.js ***!
  \******************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var mixins_validate__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! mixins/validate */ "./src/js/mixins/validate.js"
          );

        Vue.component("account-reset-form", {
          data: function data() {
            return {};
          },
          mixins: [mixins_validate__WEBPACK_IMPORTED_MODULE_0__["default"]],
        });

        /***/
      },

    /***/ "./src/modules/callout-interactive/callout-interactive.js":
      /*!****************************************************************!*\
  !*** ./src/modules/callout-interactive/callout-interactive.js ***!
  \****************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! select-dom */ "./node_modules/select-dom/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_1__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }

        var breakpoint = 767;
        var getBottom = function getBottom(button) {
          return "".concat(button.offsetHeight + 20, "px");
        };
        var getLeft = function getLeft(button, tooltip) {
          return "-".concat(
            tooltip.offsetWidth / 2 - button.offsetWidth / 2,
            "px"
          );
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            var tooltipButtons = select_dom__WEBPACK_IMPORTED_MODULE_0__[
              "default"
            ].all(".js-tooltip-button", el);
            var _iterator = _createForOfIteratorHelper(tooltipButtons),
              _step;
            try {
              var _loop = function _loop() {
                var button = _step.value;
                var parentBtn = button.parentNode;
                var tooltip = parentBtn.querySelector(".js-tooltip");
                if (
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(breakpoint)
                ) {
                  tooltip.style.bottom = getBottom(button);
                  tooltip.style.left = getLeft(button, tooltip);
                }
                dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
                  button,
                  "click",
                  function (e) {
                    if (
                      (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.contains)(
                        parentBtn,
                        "active"
                      )
                    ) {
                      (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                        parentBtn,
                        "active"
                      );
                    } else {
                      (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                        parentBtn,
                        "active"
                      );
                    }
                  }
                );
              };
              for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                _loop();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
              document.body,
              "click",
              function (e) {
                if (e.target.closest(".js-tooltip-button")) {
                  return;
                }
                var _iterator2 = _createForOfIteratorHelper(tooltipButtons),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                    var button = _step2.value;
                    var parentBtn = button.parentNode;
                    (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                      parentBtn,
                      "active"
                    );
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
              }
            );
            dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
              window,
              "resize",
              function () {
                var _iterator3 = _createForOfIteratorHelper(tooltipButtons),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                    var button = _step3.value;
                    (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                      button,
                      "active"
                    );
                    var tooltip = button.querySelector(".js-tooltip");
                    if (tooltip) {
                      if (
                        !(0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(
                          breakpoint
                        )
                      ) {
                        tooltip.style.bottom = 0;
                        tooltip.style.left = 0;
                      } else {
                        if (window.innerWidth > 1024) {
                          tooltip.style.bottom = getBottom(button);
                          tooltip.style.left = getLeft(button, tooltip);
                        } else {
                          tooltip.style.bottom = "inherit";
                          tooltip.style.left = 0;
                        }
                      }
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
            );
          };

        /***/
      },

    /***/ "./src/modules/callout-three-up/callout-three-up.js":
      /*!**********************************************************!*\
  !*** ./src/modules/callout-three-up/callout-three-up.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! dom-select */ "./node_modules/dom-select/index.js"
          );
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_select__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_2__
          );
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            var openSlideOut = function openSlideOut(id) {
              (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.set)(
                document.body,
                "showing-slide-out"
              );
              var activeSlideOut =
                dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                  ".js-slide-out.active"
                );
              var slideOut = dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                ".js-slide-out[data-slide-out=".concat(id, "]")
              );
              var slideOutFocus =
                dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                  ".js-slide-out[data-slide-out="
                    .concat(id, "] button, .js-slide-out[data-slide-out=")
                    .concat(id, "] a, .js-slide-out[data-slide-out=")
                    .concat(id, '] [role="button"]')
                );
              activeSlideOut &&
                (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.unset)(
                  activeSlideOut,
                  "active"
                );
              (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.set)(
                slideOut,
                "active"
              );
              slideOutFocus.focus();
            };
            var slideOutCTAs =
              dom_select__WEBPACK_IMPORTED_MODULE_0___default().all(
                ".js-slide-out-cta"
              );
            var _iterator = _createForOfIteratorHelper(slideOutCTAs),
              _step;
            try {
              var _loop = function _loop() {
                var cta = _step.value;
                dom_event__WEBPACK_IMPORTED_MODULE_2___default()(
                  cta,
                  "click",
                  function () {
                    openSlideOut(cta.dataset["slideOut"]);
                  }
                );
              };
              for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                _loop();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          };

        /***/
      },

    /***/ "./src/modules/cart-grid-bb/@actions.js":
      /*!**********************************************!*\
  !*** ./src/modules/cart-grid-bb/@actions.js ***!
  \**********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ actions: () => /* binding */ actions,
          /* harmony export */
        });
        /* harmony import */ var lib_cart__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! lib/cart */ "./src/js/lib/cart.js");

        var actions = {
          getCart: function getCart(_ref, payload) {
            var commit = _ref.commit,
              state = _ref.state;
            commit("setLoading", true);
            return lib_cart__WEBPACK_IMPORTED_MODULE_0__["default"]
              .get()
              .then(function (data) {
                commit("refreshCart", data);
              });
          },
          updateItemQuantity: function updateItemQuantity(_ref2, _ref3) {
            var commit = _ref2.commit,
              state = _ref2.state;
            var quantity = _ref3.quantity,
              id = _ref3.id;
            if (!id) {
              return;
            }
            commit("setLoading", true);
            return lib_cart__WEBPACK_IMPORTED_MODULE_0__["default"]
              .update({
                quantity: quantity,
                id: id,
              })
              .then(function (data) {
                commit("refreshCart", data);
              });
          },
          addToCart: function addToCart(_ref4, _ref5) {
            var dispatch = _ref4.dispatch,
              state = _ref4.state;
            var id = _ref5.id,
              quantity = _ref5.quantity;
            var items = state.app.cart.items;

            // Adds the requested `quantity` to the current item.quantity
            var item = items.find(function (i) {
              return i.variant_id === id;
            });
            var totalQuantity = item ? item.quantity + quantity : quantity;
            return dispatch("updateItemQuantity", {
              id: id,
              quantity: totalQuantity,
            });
          },
        };

        /***/
      },

    /***/ "./src/modules/cart-grid-bb/@getters.js":
      /*!**********************************************!*\
  !*** ./src/modules/cart-grid-bb/@getters.js ***!
  \**********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ getters: () => /* binding */ getters,
          /* harmony export */
        });
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");

        var getters = {
          subtotal: function subtotal(state) {
            return (0, lib_util__WEBPACK_IMPORTED_MODULE_0__.formatPrice)(
              state.app.cart.total_price
            );
          },
        };

        /***/
      },

    /***/ "./src/modules/cart-grid-bb/@mutations.js":
      /*!************************************************!*\
  !*** ./src/modules/cart-grid-bb/@mutations.js ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ mutations: () => /* binding */ mutations,
          /* harmony export */
        });
        var mutations = {
          bootstrap: function bootstrap(state) {
            state.isBootstrapped = true;
          },
          setLoading: function setLoading(state, isLoading) {
            state.loading = isLoading;
          },
          refreshCart: function refreshCart(state, data) {
            state.loading = false;
            if (data.errors) {
              state.app.cart.errors = data.errors;
            } else {
              state.app.cart = data;
            }
          },
          toggleMiniCart: function toggleMiniCart(state) {
            state.app.isMiniCartOpen = !state.app.isMiniCartOpen;
          },
        };

        /***/
      },

    /***/ "./src/modules/cart-grid-bb/@store.js":
      /*!********************************************!*\
  !*** ./src/modules/cart-grid-bb/@store.js ***!
  \********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! vuex */ "./node_modules/vuex/dist/vuex.esm.js"
          );
        /* harmony import */ var _mutations__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./@mutations */ "./src/modules/cart-grid-bb/@mutations.js"
          );
        /* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./@actions */ "./src/modules/cart-grid-bb/@actions.js"
          );
        /* harmony import */ var _getters__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./@getters */ "./src/modules/cart-grid-bb/@getters.js"
          );
        /* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(/*! lib/appState */ "./src/js/lib/appState.js");

        Vue.use(vuex__WEBPACK_IMPORTED_MODULE_4__["default"]);
        var state = {
          app: lib_appState__WEBPACK_IMPORTED_MODULE_3__["default"],
          isBootstrapped: false,
          loading: false,
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          new vuex__WEBPACK_IMPORTED_MODULE_4__["default"].Store({
            state: state,
            actions: _actions__WEBPACK_IMPORTED_MODULE_1__.actions,
            mutations: _mutations__WEBPACK_IMPORTED_MODULE_0__.mutations,
            getters: _getters__WEBPACK_IMPORTED_MODULE_2__.getters,
          });

        /***/
      },

    /***/ "./src/modules/cart-grid-bb/cart-grid-bb.js":
      /*!**************************************************!*\
  !*** ./src/modules/cart-grid-bb/cart-grid-bb.js ***!
  \**************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./@store */ "./src/modules/cart-grid-bb/@store.js"
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              store: _store__WEBPACK_IMPORTED_MODULE_0__["default"],
            });
          };

        /***/
      },

    /***/ "./src/modules/cart-grid-bb/cart-grid-bb.vue.js":
      /*!******************************************************!*\
  !*** ./src/modules/cart-grid-bb/cart-grid-bb.vue.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! vuex */ "./node_modules/vuex/dist/vuex.esm.js"
          );
        /* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! body-scroll-lock */ "./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js"
          );
        /* harmony import */ var _cart_item_cart_item_vue__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../cart-item/cart-item.vue */ "./src/modules/cart-item/cart-item.vue.js"
          );
        /* harmony import */ var _quantity_selector_quantity_selector_vue__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../quantity-selector/quantity-selector.vue */ "./src/modules/quantity-selector/quantity-selector.vue.js"
          );
        /* harmony import */ var _quantity_selector_quantity_selector_vue__WEBPACK_IMPORTED_MODULE_2___default =
          /*#__PURE__*/ __webpack_require__.n(
            _quantity_selector_quantity_selector_vue__WEBPACK_IMPORTED_MODULE_2__
          );
        /* harmony import */ var _image_image_vue__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../image/image.vue */ "./src/modules/image/image.vue.js"
          );
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      "function" == typeof Symbol &&
                      obj.constructor === Symbol &&
                      obj !== Symbol.prototype
                      ? "symbol"
                      : typeof obj;
                  }),
            _typeof(obj)
          );
        }
        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly &&
              (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })),
              keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2
              ? ownKeys(Object(source), !0).forEach(function (key) {
                  _defineProperty(target, key, source[key]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(
                  target,
                  Object.getOwnPropertyDescriptors(source)
                )
              : ownKeys(Object(source)).forEach(function (key) {
                  Object.defineProperty(
                    target,
                    key,
                    Object.getOwnPropertyDescriptor(source, key)
                  );
                });
          }
          return target;
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }

        Vue.component("cart-grid-bb", {
          data: function data() {
            var _window$locale_aware_;
            return {
              baseUrl:
                ((_window$locale_aware_ = window.locale_aware_base_url) ===
                  null || _window$locale_aware_ === void 0
                  ? void 0
                  : _window$locale_aware_.replace("/", "")) || "",
            };
          },
          computed: _objectSpread(
            _objectSpread(
              _objectSpread(
                {},
                (0, vuex__WEBPACK_IMPORTED_MODULE_4__.mapGetters)(["subtotal"])
              ),
              (0, vuex__WEBPACK_IMPORTED_MODULE_4__.mapState)([
                "app",
                "loading",
                "isBootstrapped",
                "isMobile",
              ])
            ),
            {},
            {
              isEmpty: function isEmpty() {
                return this.cart.items.length === 0;
              },
              cart: function cart() {
                return this.app.cart;
              },
              awayFromFree: function awayFromFree() {
                var subtotal = this.cart.total_price;

                // if a [data-sub-item] exists in the cart, then free shipping
                // is impiled and we don't need to show the free shipping message
                var hasSubscription = this.cart.items.find(function (item) {
                  if (
                    item.selling_plan_allocation &&
                    item.selling_plan_allocation.selling_plan.id
                  ) {
                    return true;
                  }
                });
                if (hasSubscription) {
                  return false;
                }
                if (FREE_SHIPPING) {
                  var value = parseInt(FREE_SHIPPING) / 1;
                  var diff = 0;
                  if (subtotal < value) {
                    diff = (value - subtotal) / 100;

                    // format diff to 2 decimal places
                    diff = diff.toFixed(2);

                    // remove .00
                    diff = diff.replace(".00", "");
                  }
                  return diff;
                }
                return false;
              },
            }
          ),
          watch: {
            "app.isMiniCartOpen": function appIsMiniCartOpen(value) {
              if (value) {
                (0,
                body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__.disableBodyScroll)(
                  document.querySelector("#mini-cart")
                );
              } else {
                // remove #cart from the url
                history.pushState("", document.title, window.location.pathname);
                (0,
                body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__.clearAllBodyScrollLocks)();
              }
            },
            "app.lastAdd": function appLastAdd(value) {
              this.getCart();
            },
          },
          methods: _objectSpread(
            _objectSpread(
              _objectSpread(
                {},
                (0, vuex__WEBPACK_IMPORTED_MODULE_4__.mapActions)(["getCart"])
              ),
              (0, vuex__WEBPACK_IMPORTED_MODULE_4__.mapMutations)(["bootstrap"])
            ),
            (0, vuex__WEBPACK_IMPORTED_MODULE_4__.mapMutations)([
              "toggleMiniCart",
            ])
          ),
          mounted: function mounted() {
            this.bootstrap();
          },
        });

        /***/
      },

    /***/ "./src/modules/cart-grid/@actions.js":
      /*!*******************************************!*\
  !*** ./src/modules/cart-grid/@actions.js ***!
  \*******************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ actions: () => /* binding */ actions,
          /* harmony export */
        });
        /* harmony import */ var lib_cart__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! lib/cart */ "./src/js/lib/cart.js");

        var actions = {
          getCart: function getCart(_ref, payload) {
            var commit = _ref.commit,
              state = _ref.state;
            commit("setLoading", true);
            return lib_cart__WEBPACK_IMPORTED_MODULE_0__["default"]
              .get()
              .then(function (data) {
                commit("refreshCart", data);
              })
              ["catch"](function (err) {
                commit("setLoading", false);
              });
          },
          updateItemQuantity: function updateItemQuantity(_ref2, _ref3) {
            var commit = _ref2.commit,
              state = _ref2.state;
            var quantity = _ref3.quantity,
              id = _ref3.id;
            if (!id) {
              return;
            }
            commit("setLoading", true);
            return lib_cart__WEBPACK_IMPORTED_MODULE_0__["default"]
              .update({
                quantity: quantity,
                id: id,
              })
              .then(function (data) {
                commit("refreshCart", data);
              })
              ["catch"](function (err) {
                commit("setLoading", false);
              });
          },
          addToCart: function addToCart(_ref4, _ref5) {
            var dispatch = _ref4.dispatch,
              state = _ref4.state;
            var id = _ref5.id,
              quantity = _ref5.quantity;
            var items = state.app.cart.items;

            // Adds the requested `quantity` to the current item.quantity
            var item = items.find(function (i) {
              return i.variant_id === id;
            });
            var totalQuantity = item ? item.quantity + quantity : quantity;
            return dispatch("updateItemQuantity", {
              id: id,
              quantity: totalQuantity,
            });
          },
        };

        /***/
      },

    /***/ "./src/modules/cart-grid/@getters.js":
      /*!*******************************************!*\
  !*** ./src/modules/cart-grid/@getters.js ***!
  \*******************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ getters: () => /* binding */ getters,
          /* harmony export */
        });
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");

        var getters = {
          subtotal: function subtotal(state) {
            return (0, lib_util__WEBPACK_IMPORTED_MODULE_0__.formatPrice)(
              state.app.cart.total_price
            );
          },
        };

        /***/
      },

    /***/ "./src/modules/cart-grid/@mutations.js":
      /*!*********************************************!*\
  !*** ./src/modules/cart-grid/@mutations.js ***!
  \*********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ mutations: () => /* binding */ mutations,
          /* harmony export */
        });
        var mutations = {
          bootstrap: function bootstrap(state) {
            state.isBootstrapped = true;
          },
          setLoading: function setLoading(state, isLoading) {
            state.loading = isLoading;
          },
          refreshCart: function refreshCart(state, data) {
            state.loading = false;
            if (data.errors) {
              state.app.cart.errors = data.errors;
            } else {
              state.app.cart = data;
            }
          },
          toggleMiniCart: function toggleMiniCart(state) {
            state.app.isMiniCartOpen = !state.app.isMiniCartOpen;
          },
        };

        /***/
      },

    /***/ "./src/modules/cart-grid/@store.js":
      /*!*****************************************!*\
  !*** ./src/modules/cart-grid/@store.js ***!
  \*****************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! vuex */ "./node_modules/vuex/dist/vuex.esm.js"
          );
        /* harmony import */ var _mutations__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./@mutations */ "./src/modules/cart-grid/@mutations.js"
          );
        /* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./@actions */ "./src/modules/cart-grid/@actions.js"
          );
        /* harmony import */ var _getters__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./@getters */ "./src/modules/cart-grid/@getters.js"
          );
        /* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(/*! lib/appState */ "./src/js/lib/appState.js");

        Vue.use(vuex__WEBPACK_IMPORTED_MODULE_4__["default"]);
        var state = {
          app: lib_appState__WEBPACK_IMPORTED_MODULE_3__["default"],
          isBootstrapped: false,
          loading: false,
        };
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          new vuex__WEBPACK_IMPORTED_MODULE_4__["default"].Store({
            state: state,
            actions: _actions__WEBPACK_IMPORTED_MODULE_1__.actions,
            mutations: _mutations__WEBPACK_IMPORTED_MODULE_0__.mutations,
            getters: _getters__WEBPACK_IMPORTED_MODULE_2__.getters,
          });

        /***/
      },

    /***/ "./src/modules/cart-grid/cart-grid.js":
      /*!********************************************!*\
  !*** ./src/modules/cart-grid/cart-grid.js ***!
  \********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./@store */ "./src/modules/cart-grid/@store.js"
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              store: _store__WEBPACK_IMPORTED_MODULE_0__["default"],
            });
          };

        /***/
      },

    /***/ "./src/modules/cart-grid/cart-grid.vue.js":
      /*!************************************************!*\
  !*** ./src/modules/cart-grid/cart-grid.vue.js ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_4__ =
          __webpack_require__(
            /*! vuex */ "./node_modules/vuex/dist/vuex.esm.js"
          );
        /* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! body-scroll-lock */ "./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js"
          );
        /* harmony import */ var _cart_item_cart_item_vue_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ../cart-item/cart-item.vue.js */ "./src/modules/cart-item/cart-item.vue.js"
          );
        /* harmony import */ var _quantity_selector_quantity_selector_vue_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ../quantity-selector/quantity-selector.vue.js */ "./src/modules/quantity-selector/quantity-selector.vue.js"
          );
        /* harmony import */ var _quantity_selector_quantity_selector_vue_js__WEBPACK_IMPORTED_MODULE_2___default =
          /*#__PURE__*/ __webpack_require__.n(
            _quantity_selector_quantity_selector_vue_js__WEBPACK_IMPORTED_MODULE_2__
          );
        /* harmony import */ var _image_image_vue_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../image/image.vue.js */ "./src/modules/image/image.vue.js"
          );
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      "function" == typeof Symbol &&
                      obj.constructor === Symbol &&
                      obj !== Symbol.prototype
                      ? "symbol"
                      : typeof obj;
                  }),
            _typeof(obj)
          );
        }
        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly &&
              (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })),
              keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2
              ? ownKeys(Object(source), !0).forEach(function (key) {
                  _defineProperty(target, key, source[key]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(
                  target,
                  Object.getOwnPropertyDescriptors(source)
                )
              : ownKeys(Object(source)).forEach(function (key) {
                  Object.defineProperty(
                    target,
                    key,
                    Object.getOwnPropertyDescriptor(source, key)
                  );
                });
          }
          return target;
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }

        Vue.component("cart-grid", {
          computed: _objectSpread(
            _objectSpread(
              _objectSpread(
                {},
                (0, vuex__WEBPACK_IMPORTED_MODULE_4__.mapGetters)(["subtotal"])
              ),
              (0, vuex__WEBPACK_IMPORTED_MODULE_4__.mapState)([
                "app",
                "loading",
                "isBootstrapped",
                "isMobile",
              ])
            ),
            {},
            {
              isEmpty: function isEmpty() {
                return this.cart.items.length === 0;
              },
              cart: function cart() {
                return this.app.cart;
              },
            }
          ),
          data: function data() {
            var _window$locale_aware_;
            return {
              baseUrl:
                ((_window$locale_aware_ = window.locale_aware_base_url) ===
                  null || _window$locale_aware_ === void 0
                  ? void 0
                  : _window$locale_aware_.replace("/", "")) || "",
            };
          },
          watch: {
            "app.isMiniCartOpen": function appIsMiniCartOpen(value) {
              if (value) {
                (0,
                body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__.disableBodyScroll)(
                  this.$refs["cart"]
                );
              } else {
                (0,
                body_scroll_lock__WEBPACK_IMPORTED_MODULE_0__.clearAllBodyScrollLocks)();
              }
            },
          },
          methods: _objectSpread(
            _objectSpread(
              {},
              (0, vuex__WEBPACK_IMPORTED_MODULE_4__.mapMutations)(["bootstrap"])
            ),
            (0, vuex__WEBPACK_IMPORTED_MODULE_4__.mapMutations)([
              "toggleMiniCart",
            ])
          ),
          mounted: function mounted() {
            this.bootstrap();
          },
        });

        /***/
      },

    /***/ "./src/modules/cart-item/cart-item.vue.js":
      /*!************************************************!*\
  !*** ./src/modules/cart-item/cart-item.vue.js ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        /* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! lodash/debounce */ "./node_modules/lodash/debounce.js"
          );
        /* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            lodash_debounce__WEBPACK_IMPORTED_MODULE_1__
          );
        /* global CustomEvent */

        Vue.component("cart-item", {
          data: function data() {
            var _window$locale_aware_;
            return {
              itemShowUpsell: false,
              itemShowUpsellShort: false,
              itemSellingPlans: [],
              itemHasCheckedUpsell: false,
              itemConvertingToSellingPlan: false,
              baseUrl:
                ((_window$locale_aware_ = window.locale_aware_base_url) ===
                  null || _window$locale_aware_ === void 0
                  ? void 0
                  : _window$locale_aware_.replace("/", "")) || "",
            };
          },
          props: {
            item: Object,
            image: String,
            title: String,
            price: Number,
            quantity: Number,
            index: Number,
            type: String,
            compare_at_price: Number,
            tags: String,
            variantId: Number,
            variantTitle: String,
            sellingPlanAllocationId: [Number, String],
            sellingPlanName: String,
            itemKey: String,
          },
          methods: {
            updateQuantity:
              lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(function (
                quantity
              ) {
                this.$store.dispatch("updateItemQuantity", {
                  quantity: quantity,
                  id: this.variantId,
                });
                document.dispatchEvent(
                  new CustomEvent("product:added", {
                    detail: {
                      variant: this.item,
                      quantity: quantity,
                      isCart: true,
                    },
                  })
                );
              },
              450),
            editBundle: function editBundle() {
              // hide the page so they don't see the cart change
              document.body.style.display = "none";

              // remove the current bundle from the cart
              this.$store.dispatch("updateItemQuantity", {
                quantity: 0,
                id: this.variantId,
              });

              // take the user back to the bundle page
              window.location.href =
                "/collections/build-your-own-anti-anxious-station?preloadBundle=" +
                this.item.sku;
            },
            remove: function remove() {
              this.$store.dispatch("updateItemQuantity", {
                quantity: 0,
                id: this.variantId,
              });
            },
          },
          computed: {
            formattedPrice: function formattedPrice() {
              return "".concat(
                (0, lib_util__WEBPACK_IMPORTED_MODULE_0__.formatPrice)(
                  this.price
                )
              );
            },
            isGiftCard: function isGiftCard() {
              return this.type.toLowerCase() === "gift card";
            },
            canChangeQuantity: function canChangeQuantity() {
              return this.price > 0;
            },
            isDiscountedPrice: function isDiscountedPrice() {
              return (
                this.compare_at_price && this.compare_at_price > this.price
              );
            },
            totalComparePrice: function totalComparePrice() {
              return "".concat(
                (0, lib_util__WEBPACK_IMPORTED_MODULE_0__.formatPrice)(
                  this.compare_at_price
                )
              );
            },
            totalFormattedPrice: function totalFormattedPrice() {
              return "".concat(
                (0, lib_util__WEBPACK_IMPORTED_MODULE_0__.formatPrice)(
                  this.price * this.quantity
                )
              );
            },
            itemUpsell: function itemUpsell() {
              var _this = this;
              // if this product is a custom bundle then we need to see if they have
              // the max products to get a discount
              if (this.type === "bundle-order") {
                if (this.sku) {
                  var parts = this.sku.split("|");
                  var total = 0;
                  parts.forEach(function (part) {
                    var lines = part.split("@");
                    total += parseInt(lines[0]);
                  });
                  if (total < 4) {
                    this.itemShowUpsellShort = true;
                    var _short = 4 - total;
                    return "Add ".concat(_short, " more item for 15% off");
                  }
                }
                return;
              }
              if (this.sellingPlanAllocationId) {
                // we already have this on subscription. Ensure that we have
                // an automatic discount applied by making a GET fetch
                try {
                  // show loading spinner
                  var cartFooter = document.querySelector(".cart__footer");
                  if (cartFooter) {
                    cartFooter.style.pointerEvents = "none";
                    cartFooter.style.opacity = "0.2";
                  }
                  var _window$location = window.location,
                    host = _window$location.host,
                    protocol = _window$location.protocol;
                  fetch(
                    ""
                      .concat(protocol, "//")
                      .concat(host, "/discount/FREESUBSHIPPING")
                  )
                    .then(function (response) {
                      // enable the page, hide the spinner
                    })
                    ["catch"](function (e) {
                      //
                    })
                    ["finally"](function () {
                      if (cartFooter) {
                        cartFooter.style.pointerEvents = "auto";
                        cartFooter.style.opacity = "1";
                      }
                    });
                } catch (e) {
                  //
                }
                return "";
              }
              var upsellEnabled = true;
              if (!this.itemHasCheckedUpsell) {
                fetch(
                  window.Shopify.routes.root +
                    "products/" +
                    this.item.handle +
                    ".js?locale=" +
                    window.Shopify.locale
                )
                  .then(function (response) {
                    return response.json();
                  })
                  .then(function (product) {
                    if (
                      product.selling_plan_groups &&
                      product.selling_plan_groups.length > 0
                    ) {
                      _this.itemShowUpsell = upsellEnabled ? true : false;
                      _this.itemSellingPlans =
                        product.selling_plan_groups[0].selling_plans;
                    }
                  });
                this.itemHasCheckedUpsell = true;
              }
              if (this.itemConvertingToSellingPlan) {
                return '<div class="cart-item__upsell-inner"><div class="spinner"></div></div>';
              }
              if (!upsellEnabled) {
                // remove cart-item__upsell from the DOM
                var upsellContainer =
                  document.querySelector(".cart-item__upsell");
                if (upsellContainer) {
                  upsellContainer.remove();
                }
              }
              if (upsellEnabled && this.itemShowUpsell) {
                var _div$querySelector;
                var options = this.itemSellingPlans.map(function (plan) {
                  return '<option value="'
                    .concat(plan.id, '">')
                    .concat(plan.name, "</option>");
                });
                var select = document.createElement("select");
                // push a default option onto options array
                options.unshift("<option>Select an option</option>");
                select.innerHTML = options.join("");
                var div = document.createElement("div");
                div.innerHTML =
                  '<div class="cart-item__upsell-inner"><label class="group-label">\n                    <input type="checkbox" name="convert_to_selling_plan" /><div class="group-header">Subscribe and save</div>\n                    </label><div class="plans-container"><i class="fa-solid fa-chevron-down"></i></div></div>';
                (_div$querySelector = div.querySelector(".plans-container")) ===
                  null || _div$querySelector === void 0
                  ? void 0
                  : _div$querySelector.appendChild(select);

                // add body event listening for the select
                document.body.addEventListener("change", function (e) {
                  if (
                    e.target.tagName === "SELECT" &&
                    e.target.closest(".cart-item__upsell-inner")
                  ) {
                    _this.itemConvertingToSellingPlan = true;

                    // disable the add button
                    var cartFooter = document.querySelector(".cart__footer");
                    if (cartFooter) {
                      cartFooter.style.pointerEvents = "none";
                      cartFooter.style.opacity = "0.1";
                    }

                    // remove the current key from the cart
                    fetch(
                      window.Shopify.routes.root +
                        "cart/change.js?quantity=0&id=" +
                        _this.item.id
                    )
                      .then(function (response) {
                        fetch(
                          window.Shopify.routes.root +
                            "cart/add.js?quantity=1&id=" +
                            _this.item.id +
                            "&selling_plan=" +
                            e.target.value
                        )
                          .then(function (response) {
                            return response.json();
                          })
                          .then(function (data) {
                            // add #cart to the URL
                            window.location.hash = "cart";
                            window.location.reload();
                          })
                          ["catch"](function () {
                            window.location.reload();
                          });
                      })
                      ["catch"](function (e) {
                        window.location.reload();
                      });
                  }
                });
                return div.innerHTML;
              } else {
                return "";
              }
            },
          },
        });

        /***/
      },

    /***/ "./src/modules/checkbox/checkbox.vue.js":
      /*!**********************************************!*\
  !*** ./src/modules/checkbox/checkbox.vue.js ***!
  \**********************************************/
      /***/ () => {
        Vue.component("checkbox", {
          props: ["checked", "value", "name", "required"],
          data: function data() {
            return {
              isValid: true,
              isChecked: !!this.checked,
              publicValue: this.value || true,
            };
          },
          methods: {
            validate: function validate() {
              this.isValid =
                !this.required || (this.required && this.isChecked);
              return this.isValid;
            },
            onChange: function onChange() {
              this.isChecked = !this.isChecked;
              var value = this.isChecked ? this.publicValue : false;
              this.$emit("change", {
                name: this.name,
                value: value,
              });
            },
          },
          template:
            '\n  <div class="checkbox__icon" :class="{\'is-active\': isChecked, \'is-error\': !isValid}">\n    <input\n      class="checkbox__icon-el"\n      type="checkbox"\n      :name="name"\n      :value="value"\n      :checked="isChecked"\n      @change="onChange" />\n      <svg class="checkbox__icon-tick" viewBox="0 0 13 9">\n        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-checkmark" x="0" y="0"></use>\n      </svg>\n  </div>\n  ',
        });

        /***/
      },

    /***/ "./src/modules/contact-form/contact-form.vue.js":
      /*!******************************************************!*\
  !*** ./src/modules/contact-form/contact-form.vue.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var mixins_validate__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! mixins/validate */ "./src/js/mixins/validate.js"
          );
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! dom-select */ "./node_modules/dom-select/index.js"
          );
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_select__WEBPACK_IMPORTED_MODULE_1__
          );

        Vue.component("contact-form", {
          data: function data() {
            return {
              isDisabled: true,
            };
          },
          methods: {
            toggleDisabled: function toggleDisabled() {
              var form = dom_select__WEBPACK_IMPORTED_MODULE_1___default()(
                "form",
                this.$el
              );
              if (!form) {
                this.isDisabled = true;
                return;
              }
              var formElements = Array.from(form.elements);
              if (formElements.length) {
                this.isDisabled = formElements.every(function (formEl) {
                  return formEl.value.trim() !== "";
                });
              }
            },
          },
          mixins: [mixins_validate__WEBPACK_IMPORTED_MODULE_0__["default"]],
        });

        /***/
      },

    /***/ "./src/modules/contact/contact.js":
      /*!****************************************!*\
  !*** ./src/modules/contact/contact.js ***!
  \****************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
            });
          };

        /***/
      },

    /***/ "./src/modules/footer/footer.js":
      /*!**************************************!*\
  !*** ./src/modules/footer/footer.js ***!
  \**************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
            });
          };

        /***/
      },

    /***/ "./src/modules/header-cart-icon/header-cart-icon.js":
      /*!**********************************************************!*\
  !*** ./src/modules/header-cart-icon/header-cart-icon.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! lib/appState */ "./src/js/lib/appState.js");

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              data: function data() {
                return {
                  state: lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"],
                };
              },
              methods: {
                toggleMiniCart: function toggleMiniCart() {
                  this.state.isMiniCartOpen = !this.state.isMiniCartOpen;
                },
              },
              computed: {
                itemCount: function itemCount() {
                  return (this.state.cart.items || []).reduce(function (
                    count,
                    item
                  ) {
                    count += Number(item.quantity);
                    return count;
                  },
                  0);
                },
                itemCountText: function itemCountText() {
                  return "Your bag - ".concat(this.itemCount, " items");
                },
              },
            });
          };

        /***/
      },

    /***/ "./src/modules/header-mega/header-mega.js":
      /*!************************************************!*\
  !*** ./src/modules/header-mega/header-mega.js ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! select-dom */ "./node_modules/select-dom/index.js"
          );
        /* harmony import */ var _js_lib_util__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(/*! ../../js/lib/util */ "./src/js/lib/util.js");
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      "function" == typeof Symbol &&
                      obj.constructor === Symbol &&
                      obj !== Symbol.prototype
                      ? "symbol"
                      : typeof obj;
                  }),
            _typeof(obj)
          );
        }
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(
              target,
              _toPropertyKey(descriptor.key),
              descriptor
            );
          }
        }
        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          Object.defineProperty(Constructor, "prototype", { writable: false });
          return Constructor;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }

        // variables
        var off = dom_event__WEBPACK_IMPORTED_MODULE_0___default().off;
        var breakpoint = 999;
        var LOGO_SCROLL_OFFSET = 8;
        var isMobile =
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          );
        // 'close' function - remove is-active and set height to 0.
        var close = function close(links, groups) {
          //
          (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
            groups.concat(links),
            "is-active"
          );
          (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
            document.body,
            "menu-open"
          );
          var _iterator = _createForOfIteratorHelper(groups),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done; ) {
              var group = _step.value;
              group.style.height = "0px";
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        };
        var Header = /*#__PURE__*/ (function () {
          function Header(el) {
            var _this = this;
            _classCallCheck(this, Header);
            this.el = el;
            this.links = select_dom__WEBPACK_IMPORTED_MODULE_1__["default"].all(
              ".js-link",
              el
            );
            this.groups = select_dom__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ].all(".js-subnav", el);
            this.nav = (0, select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
              ".js-nav",
              el
            );
            this.queuedAction = false;
            this.logoLink = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
              ".js-logo-link",
              el
            );
            this.sideLinks = select_dom__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ].all(".js-side-link", el);
            this.subNavLinks = select_dom__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ].all(".js-subnav-link", el);
            this.hideNavigation = this.hideNavigation.bind(this);
            this.toggleSubNavByClick = this.toggleSubNavByClick.bind(this);
            this.resizeHandler = this.resizeHandler.bind(this);
            this.hideActiveMenu = this.hideActiveMenu.bind(this);
            this.openSubNavOnEnter = this.openSubNavOnEnter.bind(this);
            this.openSubNav = this.openSubNav.bind(this);
            this.closeSubNavOnLeave = this.closeSubNavOnLeave.bind(this);
            this.closeSubNav = this.closeSubNav.bind(this);
            this.cancelClose = this.cancelClose.bind(this);
            this.scrollHandler = this.scrollHandler.bind(this);
            this.openParentSubNavOnFocus =
              this.openParentSubNavOnFocus.bind(this);
            this.marketButton = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
              ".market-button",
              el
            );
            this.state = {
              open: false,
              subNavOpen: false,
              logoCompressed: false,
            };
            this.attachEventHandlers();
            this.resizeHandler();
            this.fixHeaderPosition();
            window.openNav = function () {
              var pos =
                arguments.length > 0 && arguments[0] !== undefined
                  ? arguments[0]
                  : 0;
              var link = _this.links[pos];
              var group = (0,
              select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                ".js-subnav",
                link.parentNode
              );
              if (!group) return;
              _this.openSubNav(group, link);
            };
            setInterval(function () {
              _this.fixHeaderPosition();
            }, 400);
          }
          _createClass(Header, [
            {
              key: "attachEventHandlers",
              value: function attachEventHandlers() {
                var _iterator2 = _createForOfIteratorHelper(this.links),
                  _step2;
                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                    var link = _step2.value;
                    dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                      link,
                      "click",
                      this.toggleSubNavByClick
                    );
                    dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                      link,
                      "mouseenter",
                      this.openSubNavOnEnter
                    );
                    dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                      link.parentNode,
                      "mouseleave",
                      this.closeSubNavOnLeave
                    );
                    dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                      link,
                      "focus",
                      this.openSubNavOnEnter
                    );
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }
                if (this.marketButton) {
                  dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                    this.marketButton,
                    "click",
                    this.openMarketModal
                  );
                }
                /* close any subnav that is already open when focusing logo link or side links */
                dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                  this.logoLink,
                  "focus",
                  this.closeSubNav
                );
                var _iterator3 = _createForOfIteratorHelper(this.sideLinks),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
                    var _link = _step3.value;
                    dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                      _link,
                      "focus",
                      this.closeSubNav
                    );
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
                var _iterator4 = _createForOfIteratorHelper(this.subNavLinks),
                  _step4;
                try {
                  for (_iterator4.s(); !(_step4 = _iterator4.n()).done; ) {
                    var _link2 = _step4.value;
                    dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                      _link2,
                      "focus",
                      this.openParentSubNavOnFocus
                    );
                  }
                } catch (err) {
                  _iterator4.e(err);
                } finally {
                  _iterator4.f();
                }
                var _iterator5 = _createForOfIteratorHelper(this.groups),
                  _step5;
                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done; ) {
                    var group = _step5.value;
                    dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                      group,
                      "mouseleave",
                      this.closeSubNavOnLeave
                    );
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }
                dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                  window,
                  "resize",
                  this.resizeHandler
                );
                dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                  window,
                  "scroll",
                  this.scrollHandler
                );
                dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                  window,
                  "click",
                  this.hideActiveMenu
                );
              },
            },
            {
              key: "scrollHandler",
              value: function scrollHandler() {
                var scrollTop = window.scrollY;
                this.fixHeaderPosition();
                if (scrollTop > LOGO_SCROLL_OFFSET) {
                  if (this.state.logoCompressed) return;
                  this.state.logoCompressed = true;
                  this.handleScrolled();
                } else {
                  if (!this.state.logoCompressed) return;
                  this.state.logoCompressed = false;
                  this.handleScrolled();
                }
              },
            },
            {
              key: "fixHeaderPosition",
              value: function fixHeaderPosition() {
                var campaign = document.querySelector(
                  ".CampaignType--floating"
                );
                if (campaign) {
                  this.el.style.top = campaign.clientHeight + "px";
                } else {
                  this.el.style.top = 0;
                }
              },
            },
            {
              key: "handleScrolled",
              value: function handleScrolled() {
                if (this.state.logoCompressed) {
                  (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                    this.el,
                    "header--scrolled"
                  );
                } else {
                  (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                    this.el,
                    "header--scrolled"
                  );
                }
              },
            },
            {
              key: "openMarketModal",
              value: function openMarketModal(e) {
                e.preventDefault();
                (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                  document.body,
                  "showing-modal"
                );
                var modal = (0,
                select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                  ".js-modal[data-modal=region-selector]"
                );
                if (modal) {
                  console.log("opening modal market mega");
                  // make sure the modal's parent is the body
                  if (modal.parentElement !== document.body) {
                    // remove it from the current parent
                    if (modal.parentElement) {
                      modal.parentElement.removeChild(modal);
                    }
                    document.body.appendChild(modal);
                  }
                  setTimeout(function () {
                    (0,
                    _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(modal, "active");
                  }, 100);
                }
              },
            },
            {
              key: "toggleSubNavByClick",
              value: function toggleSubNavByClick(e) {
                e.stopPropagation();
                var link = e.currentTarget;
                var isActive = (0,
                _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.contains)(
                  link,
                  "is-active"
                );
                var group = (0,
                select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                  ".js-subnav",
                  link.parentNode
                );
                var openMenuHeight = group ? group.children[0].offsetHeight : 0;
                var viewportHeight =
                  document.documentElement.clientHeight - this.el.clientHeight;
                if (
                  (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(
                    breakpoint
                  ) ||
                  !group
                ) {
                  // BraveBlog link direct to blog page only if not mobile/tablet
                  if (link.title.trim() === "BraveBlog" && !isMobile) {
                    return;
                  } else {
                    e.preventDefault();
                  }
                  return;
                }
                e.preventDefault();
                this.closeSubNav();
                if (!isActive) {
                  group.style.height = "".concat(
                    Math.min(openMenuHeight, viewportHeight),
                    "px"
                  );
                  (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                    [group, link],
                    "is-active"
                  );
                  (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                    [document.body],
                    "menu-open"
                  );
                }
              },
            },
            {
              key: "openSubNavOnEnter",
              value: function openSubNavOnEnter(e) {
                if (
                  !(0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(
                    breakpoint
                  )
                ) {
                  return;
                }

                /* Close any subnav that is already open */
                this.closeSubNav();
                var link = e.currentTarget;
                var isActive = (0,
                _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.contains)(
                  link,
                  "is-active"
                );
                var group = (0,
                select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                  ".js-subnav",
                  link.parentNode
                );
                if (!group) return;
                if (!isActive) {
                  this.openSubNav(group, link);
                }
              },
            },
            {
              key: "openParentSubNavOnFocus",
              value: function openParentSubNavOnFocus(e) {
                var subnav = e.target.closest(".header-mega__subnav");
                if (!subnav || subnav.classList.contains("is-active")) {
                  return;
                }
                this.openSubNav(
                  subnav,
                  (0, select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                    ".js-link",
                    subnav.parentNode
                  )
                );
              },
            },
            {
              key: "openSubNav",
              value: function openSubNav(group, link) {
                var openMenuHeight = group.children[0].offsetHeight;
                var viewportHeight =
                  document.documentElement.clientHeight - this.el.clientHeight;
                group.style.height = "".concat(
                  Math.min(openMenuHeight, viewportHeight),
                  "px"
                );
                (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                  [group, link, this.el],
                  "is-active"
                );
                (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                  [document.body],
                  "menu-open"
                );
              },
            },
            {
              key: "closeSubNavOnLeave",
              value: function closeSubNavOnLeave(e) {
                var _this2 = this;
                if (
                  !(0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(
                    breakpoint
                  )
                ) {
                  return;
                }
                var link = e.currentTarget;
                var isActive = (0,
                _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.contains)(
                  link,
                  "is-active"
                );
                if (!isActive) {
                  return;
                }
                this.queuedAction = setTimeout(function () {
                  _this2.closeSubNav();
                }, 300);
              },
            },
            {
              key: "closeSubNav",
              value: function closeSubNav() {
                close(this.links, this.groups);
                (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                  this.el,
                  "is-active"
                );
                (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                  document.body,
                  "menu-open"
                );
              },
            },
            {
              key: "cancelClose",
              value: function cancelClose() {
                clearTimeout(this.queuedAction);
              },
            },
            {
              key: "hideNavigation",
              value: function hideNavigation() {
                close(this.links, this.groups);
                (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                  this.nav,
                  "is-active"
                );
                (0, _js_lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                  document.body,
                  "menu-open"
                );
                this.nav.style.height = "0px";
              },
            },
            {
              key: "resizeHandler",
              value: function resizeHandler() {
                /* close navigation on desktop */
                close(this.links, this.groups);
                this.fixHeaderPosition();
              },
            },
            {
              key: "hideActiveMenu",
              value: function hideActiveMenu(e) {
                close(this.links, this.groups);
              },
            },
            {
              key: "destroy",
              value: function destroy() {
                off(this.header, "click", this.toggleSubNav);
                off(window, "resize", this.resizeHandler);
                off(window, "scroll", this.scrollHandler);
                off(window, "click", this.hideActiveMenu);
              },
            },
          ]);
          return Header;
        })();
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Header(el);
          };

        /***/
      },

    /***/ "./src/modules/header-search-icon/header-search-icon.js":
      /*!**************************************************************!*\
  !*** ./src/modules/header-search-icon/header-search-icon.js ***!
  \**************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! lib/appState */ "./src/js/lib/appState.js");

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              data: function data() {
                return {
                  state: lib_appState__WEBPACK_IMPORTED_MODULE_0__["default"],
                };
              },
              methods: {
                toggleSearchOverlay: function toggleSearchOverlay() {
                  this.state.isSearchOpen = !this.state.isSearchOpen;
                },
              },
            });
          };

        /***/
      },

    /***/ "./src/modules/header-search/header-search.js":
      /*!****************************************************!*\
  !*** ./src/modules/header-search/header-search.js ***!
  \****************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var vue_quick_search__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! vue-quick-search */ "./node_modules/vue-quick-search/dist/vueQuickSearch.umd.min.js"
          );
        /* harmony import */ var vue_quick_search__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            vue_quick_search__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! lib/appState */ "./src/js/lib/appState.js");

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              components: {
                "vue-quick-search":
                  vue_quick_search__WEBPACK_IMPORTED_MODULE_0___default(),
              },
              data: function data() {
                return {
                  state: lib_appState__WEBPACK_IMPORTED_MODULE_1__["default"],
                };
              },
              methods: {
                getResults: function getResults(url, next) {
                  next(200, {
                    results: [
                      {
                        url: "http://www.docwinebar.com/",
                        title: "DOC Winebar",
                        image:
                          "https://cdn.shopify.com/s/files/1/0022/6816/8257/products/001_56d55d12-8881-47aa-8fda-0de9d121dfc4_1080x.jpg?v=1537539891",
                      },
                      {
                        url: "http://www.docwinebar.com/",
                        title: "DOC Restaurant",
                        image:
                          "https://static1.squarespace.com/static/5388d91ae4b0813d34318751/t/54270232e4b08dba836b4f6e/1411842612762/IMG_4431.jpg",
                      },
                      {
                        url: "http://www.docwinebar.com/",
                        title: "DOC Beer Hall",
                        image:
                          "https://cdn.shopify.com/s/files/1/0022/6816/8257/products/014_bbc9114b-7f56-442e-8b8e-38d84c46943e_1080x.jpg?v=1539116941",
                      },
                      {
                        url: "http://www.docwinebar.com/",
                        title: "DOC Winebar",
                        image:
                          "https://static1.squarespace.com/static/5388d91ae4b0813d34318751/t/54270232e4b08dba836b4f6e/1411842612762/IMG_4431.jpg",
                      },
                      {
                        url: "http://www.docwinebar.com/",
                        title: "DOC Winebar",
                        image:
                          "https://cdn.shopify.com/s/files/1/0022/6816/8257/products/001_502578ce-1965-4ccd-ae3c-f908dc486cb3_1080x.jpg?v=1539117675",
                      },
                    ],
                    total: 5,
                  });
                },
                hideSearch: function hideSearch() {},
              },
              template:
                '\n    <vue-quick-search\n      :is-active="state.isSearchOpen"\n      :get-results="getResults"\n      :result-limit="4"\n      @hide="hideSearch">\n      <template slot="no-results" slot-scope="props">\n        <div>No results available for {{ props.searchTerm }}</div>\n      </template>\n    </vue-quick-search>\n  ',
            });
          };

        /***/
      },

    /***/ "./src/modules/hero-main/hero-main.js":
      /*!********************************************!*\
  !*** ./src/modules/hero-main/hero-main.js ***!
  \********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! select-dom */ "./node_modules/select-dom/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_1__
          );
        /* harmony import */ var in_viewport__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! in-viewport */ "./node_modules/in-viewport/in-viewport.js"
          );
        /* harmony import */ var in_viewport__WEBPACK_IMPORTED_MODULE_2___default =
          /*#__PURE__*/ __webpack_require__.n(
            in_viewport__WEBPACK_IMPORTED_MODULE_2__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            var parallaxImage = el.dataset.parallaxImage === "true";
            var parallaxContent = el.dataset.parallaxContent === "true";
            var checkInViewport = el.dataset.inviewport === "true";
            var featuredImage = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])(
              ".js-hero-img",
              el
            );
            var breakpoint = 1023;
            var featuredImageShiftScale = 0.3;
            var shift = function shift(target, scale) {
              if (!target) {
                return;
              }
              if (
                !(0, lib_util__WEBPACK_IMPORTED_MODULE_3__.isOver)(breakpoint)
              ) {
                return;
              }
              var y = el.getBoundingClientRect().y;
              if (y > 0 || y < -400) {
                return;
              }
              target.style.transform = "translateY(calc("
                .concat(Math.abs(y), "px * -")
                .concat(scale, "))");
            };
            if (parallaxImage || parallaxContent) {
              if ("IntersectionObserver" in window) {
                var observerOptions = {
                  root: null,
                  rootMargin: "0px",
                };
                var intersectionCallback = function intersectionCallback(
                  entries
                ) {
                  if (entries[0].isIntersecting) {
                    if (parallaxImage) {
                      dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
                        window,
                        "scroll",
                        function () {
                          shift(featuredImage, featuredImageShiftScale);
                        }
                      );
                    }
                  }
                };
                var observer = new window.IntersectionObserver(
                  intersectionCallback,
                  observerOptions
                );
                observer.observe(el);
              }
            }
            if (checkInViewport) {
              in_viewport__WEBPACK_IMPORTED_MODULE_2___default()(
                el,
                {
                  offset: -el.offsetHeight,
                },
                function () {
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_3__.set)(
                    el,
                    "is-active"
                  );
                }
              );
            }
          };

        /***/
      },

    /***/ "./src/modules/hero-product/hero-product.js":
      /*!**************************************************!*\
  !*** ./src/modules/hero-product/hero-product.js ***!
  \**************************************************/
      /***/ () => {
        /***/
      },

    /***/ "./src/modules/hero-secondary/hero-secondary.js":
      /*!******************************************************!*\
  !*** ./src/modules/hero-secondary/hero-secondary.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! select-dom */ "./node_modules/select-dom/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_1__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }

        var breakpoint = 1023;
        var featuredImageShiftScale = 0.16;
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            var parallaxImage = el.dataset.parallaxImage === "true";
            var featuredImages = select_dom__WEBPACK_IMPORTED_MODULE_0__[
              "default"
            ].all(".js-hero-img", el);
            var rollngText = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])(
              ".js-rolling-text",
              el
            );
            if (!featuredImages.length) {
              return;
            }
            var shift = function shift(targets, scale) {
              if (
                !(0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(breakpoint)
              ) {
                return;
              }
              var y = el.getBoundingClientRect().y;
              if (y > window.innerHeight || y < -400) {
                return;
              }
              var _iterator = _createForOfIteratorHelper(targets),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                  var target = _step.value;
                  target.style.transform = "translateY(calc("
                    .concat(-y, "px * ")
                    .concat(-scale, "))");
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            };
            var addStyleBottom = function addStyleBottom() {
              var _iterator2 = _createForOfIteratorHelper(featuredImages),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                  var featuredImage = _step2.value;
                  if (
                    (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(
                      breakpoint
                    )
                  ) {
                    featuredImage.style.bottom = "-85px";
                  } else {
                    featuredImage.style.bottom = "";
                    featuredImage.style.transform = "";
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            };
            if (parallaxImage) {
              if ("IntersectionObserver" in window) {
                addStyleBottom();
                dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
                  window,
                  "resize",
                  addStyleBottom
                );
                var observerOptions = {
                  root: null,
                  rootMargin: "0px",
                };
                var intersectionCallback = function intersectionCallback(
                  entries
                ) {
                  if (entries[0].isIntersecting) {
                    dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
                      window,
                      "scroll",
                      function () {
                        shift(featuredImages, featuredImageShiftScale);
                      }
                    );
                  }
                };
                var observer = new window.IntersectionObserver(
                  intersectionCallback,
                  observerOptions
                );
                observer.observe(el);
              }
            }
            dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
              window,
              "scroll",
              function () {
                if (rollngText) {
                  var viewportOffset = el.getBoundingClientRect().top;
                  var moduleOffset = (viewportOffset / el.clientHeight) * 100;
                  var scrollPercent = 100 - moduleOffset;
                  var step = Math.round(scrollPercent / 25);
                  if (step >= 0 && step < 5) {
                    rollngText.style.transform = "translateY(-".concat(
                      step + 0.1,
                      "em"
                    );
                  }
                }
              }
            );
          };

        /***/
      },

    /***/ "./src/modules/hero/hero.js":
      /*!**********************************!*\
  !*** ./src/modules/hero/hero.js ***!
  \**********************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! select-dom */ "./node_modules/select-dom/index.js"
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_2__
          );

        var breakpoint = 1024;
        var featuredImageShiftScale = 0.3;
        var SHOW_HERO_VIDEO_CLASS = "hero__video-wrapper--is-active";
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            var parallaxImage = el.dataset.parallaxImage === "true";
            var featuredImages = select_dom__WEBPACK_IMPORTED_MODULE_0__[
              "default"
            ].all(".js-hero-img", el);
            var heroVideoTrigger = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])(
              ".js-hero-video-trigger",
              el
            );
            var heroVideoIframe = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])(
              ".js-hero-video-iframe",
              el
            );
            var heroVideoWrapper = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])(
              ".js-hero-video-wrapper",
              el
            );
            var heroVideo = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])(
              ".js-hero-video",
              el
            );
            var closeVideo = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])(
              ".js-hero-video-close",
              el
            );
            var shift = function shift(target, scale) {
              if (
                !(0, lib_util__WEBPACK_IMPORTED_MODULE_1__.isOver)(breakpoint)
              ) {
                return;
              }
              var y = target.getBoundingClientRect().y;
              if (y > 0 || y < -100) {
                return;
              }
              target.style.transform = "translateY(calc("
                .concat(Math.abs(y), "px * -")
                .concat(scale, "))");
            };
            if (parallaxImage && featuredImages.length) {
              if ("IntersectionObserver" in window) {
                var observerOptions = {
                  root: null,
                  rootMargin: "0px",
                };
                var intersectionCallback = function intersectionCallback(
                  entries
                ) {
                  if (entries[0].isIntersecting) {
                    dom_event__WEBPACK_IMPORTED_MODULE_2___default()(
                      window,
                      "scroll",
                      function () {
                        featuredImages.map(function (featuredImage) {
                          shift(featuredImage, featuredImageShiftScale);
                        });
                      }
                    );
                  }
                };
                var observer = new window.IntersectionObserver(
                  intersectionCallback,
                  observerOptions
                );
                observer.observe(el);
              }
            }
            if (
              heroVideoWrapper &&
              heroVideoIframe &&
              heroVideo &&
              heroVideoTrigger
            ) {
              heroVideo.addEventListener("ended", function () {
                (0,
                lib_util__WEBPACK_IMPORTED_MODULE_1__.unset)(heroVideoWrapper, SHOW_HERO_VIDEO_CLASS);
              });
              dom_event__WEBPACK_IMPORTED_MODULE_2___default()(
                heroVideoTrigger,
                "click",
                function () {
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.set)(
                    heroVideoWrapper,
                    SHOW_HERO_VIDEO_CLASS
                  );

                  // ensure heroVideo starts from beginning
                  heroVideo.currentTime = 0;
                  heroVideo.play();
                }
              );
              dom_event__WEBPACK_IMPORTED_MODULE_2___default()(
                closeVideo,
                "click",
                function () {
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.unset)(
                    heroVideoWrapper,
                    SHOW_HERO_VIDEO_CLASS
                  );
                  heroVideo.pause();
                }
              );
            }
          };

        /***/
      },

    /***/ "./src/modules/home-product-three-up/home-product-three-up.js":
      /*!********************************************************************!*\
  !*** ./src/modules/home-product-three-up/home-product-three-up.js ***!
  \********************************************************************/
      /***/ () => {
        /***/
      },

    /***/ "./src/modules/image/image.js":
      /*!************************************!*\
  !*** ./src/modules/image/image.js ***!
  \************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var object_fit_images__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! object-fit-images */ "./node_modules/object-fit-images/dist/ofi.common-js.js"
          );
        /* harmony import */ var object_fit_images__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            object_fit_images__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var layzr_js__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! layzr.js */ "./node_modules/layzr.js/dist/layzr.module.js"
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        /* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! select-dom */ "./node_modules/select-dom/index.js"
          );
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }

        var instance = (0, layzr_js__WEBPACK_IMPORTED_MODULE_1__["default"])({
          normal: "data-normal",
          retina: "data-retina",
          srcset: "data-srcset",
          threshold: 0,
        });
        instance.on("src:before", function (image) {
          var onLoad = function onLoad() {
            var container = image.parentNode || false;
            var sources =
              select_dom__WEBPACK_IMPORTED_MODULE_3__["default"].all(
                "source",
                container
              ) || false;
            if (sources) {
              var _iterator = _createForOfIteratorHelper(sources),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                  var source = _step.value;
                  if (source.hasAttribute("data-srcset")) {
                    source.setAttribute(
                      "srcset",
                      source.getAttribute("data-srcset")
                    );
                    source.removeAttribute("data-srcset");
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
            if (container) {
              (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                container,
                "is-loaded"
              );
            }
            object_fit_images__WEBPACK_IMPORTED_MODULE_0___default()();
          };

          /* For some reason, onLoad events are not firing on picture elements in Safari. */
          var fallbackEvent = setTimeout(onLoad, 500);
          image.onload = function () {
            onLoad();
            clearTimeout(fallbackEvent);
          };
        });
        window.layzr = instance;
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            instance.update().check().handlers(true);
          };

        /***/
      },

    /***/ "./src/modules/image/image.vue.js":
      /*!****************************************!*\
  !*** ./src/modules/image/image.vue.js ***!
  \****************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var object_fit_images__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! object-fit-images */ "./node_modules/object-fit-images/dist/ofi.common-js.js"
          );
        /* harmony import */ var object_fit_images__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            object_fit_images__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var _shopify_theme_images__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! @shopify/theme-images */ "./node_modules/@shopify/theme-images/images.js"
          );
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }

        Vue.component("vue-image", {
          props: {
            src: String,
            sources: Array,
            alt: String,
            css: String,
            size: Number,
            loader: {
              type: Boolean,
              default: false,
            },
            spinner: {
              type: Boolean,
              default: true,
            },
            spinnerSize: {
              type: String,
              default: "lg",
            },
            scale: {
              type: Number,
              default: 1,
            },
          },
          data: function data() {
            return {
              mainImageSrc: "",
              secondaryImgSrc: "",
              states: {
                isLoaded: false,
              },
            };
          },
          computed: {
            imgClasses: function imgClasses() {
              return this.states.isLoaded ? "is-loaded" : "";
            },
            parts: function parts() {
              var arr = this.src.split(new RegExp(".(jpg|jpeg|png|gif)"));
              return {
                originalPath: arr[0],
                filePath: arr[0].replace(new RegExp("_[0-9]*x"), ""),
                ext: arr[1],
                query: arr[2],
              };
            },
            blurSrc: function blurSrc() {
              return this.getSizeSrc(50);
            },
            blurSrcStyle: function blurSrcStyle() {
              return "url(".concat(this.blurSrc, ")");
            },
            sizeSrc: function sizeSrc() {
              return this.size ? this.getSizeSrc(this.size) : this.src;
            },
            spinnerActive: function spinnerActive() {
              return !this.states.isLoaded;
            },
            spinnerClass: function spinnerClass() {
              return "spinner spinner--abs z1 spinner--".concat(
                this.spinnerSize
              );
            },
          },
          mounted: function mounted() {
            if (this.loader) {
              this.loadImage(this.blurSrc);
            }
            if (
              typeof this.$refs["source"] !== "undefined" &&
              this.$refs["source"].length > 0
            ) {
              this.getSrcset(this.$refs["source"]);
            }
          },
          methods: {
            onLoaded: function onLoaded() {
              this.states.isLoaded = true;
              var image = this.$refs.image;
              var scale = this.scale;
              if (!image) {
                return;
              }
              image.setAttribute("width", image.width * scale);
              image.setAttribute("height", image.height * scale);
            },
            getSizeSrc: function getSizeSrc(size) {
              var imageSize = "".concat(size, "x");
              return (0,
              _shopify_theme_images__WEBPACK_IMPORTED_MODULE_1__.getSizedImageUrl)(
                this.src,
                imageSize
              );
            },
            loadImage: function loadImage(src) {
              var onLoad =
                arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : function () {};
              var img = new window.Image();
              img.onload = onLoad;
              img.src = src;
              object_fit_images__WEBPACK_IMPORTED_MODULE_0___default()();
            },
            getSrcset: function getSrcset(sources) {
              var _iterator = _createForOfIteratorHelper(sources),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                  var source = _step.value;
                  if (source.hasAttribute("data-srcset")) {
                    source.setAttribute(
                      "srcset",
                      source.getAttribute("data-srcset")
                    );
                    source.removeAttribute("data-srcset");
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            },
          },
          template:
            '\n    <transition-group name="fade" tag="picture" :class="[\'img\', css, imgClasses]">\n      <source\n        v-for="(source, i) in sources"\n        ref="source"\n        :key="source[\'media\']"\n        :media="source[\'media\']"\n        :data-srcset="source[\'srcset\']">\n        <img\n          ref="image"\n          class="img__el"\n          :src="sizeSrc"\n          :alt="alt"\n          :key="src"\n          @load="onLoaded" />\n      <i\n        v-if="loader"\n        class="img__loader"\n        :key="0"></i>\n      <i\n        v-if="spinner"\n        :class="[spinnerClass, { \'is-active\' : spinnerActive }]"\n        :key="spinnerActive"></i>\n    </transition-group>\n  ',
        });

        /***/
      },

    /***/ "./src/modules/instagram-grid/instagram-grid.js":
      /*!******************************************************!*\
  !*** ./src/modules/instagram-grid/instagram-grid.js ***!
  \******************************************************/
      /***/ () => {
        /***/
      },

    /***/ "./src/modules/loading-animation/loading-animation.js":
      /*!************************************************************!*\
  !*** ./src/modules/loading-animation/loading-animation.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var vivus__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! vivus */ "./node_modules/vivus/dist/vivus.js"
          );
        /* harmony import */ var vivus__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            vivus__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              mounted: function mounted() {
                var animation =
                  new (vivus__WEBPACK_IMPORTED_MODULE_0___default())(
                    "loading-animation-icon",
                    {
                      type: "oneByOne",
                      duration: 50,
                      dashGap: 20,
                      start: "autostart",
                      forceRender: false,
                    },
                    function (myVivus) {
                      if (myVivus.getStatus() === "end") {
                        (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.set)(
                          document.body,
                          "is-loaded"
                        );
                      }
                    }
                  );
              },
            });
          };

        /***/
      },

    /***/ "./src/modules/mini-cart/mini-cart.js":
      /*!********************************************!*\
  !*** ./src/modules/mini-cart/mini-cart.js ***!
  \********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _cart_grid_bb_store__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../cart-grid-bb/@store */ "./src/modules/cart-grid-bb/@store.js"
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              store:
                _cart_grid_bb_store__WEBPACK_IMPORTED_MODULE_0__["default"],
            });
          };

        /***/
      },

    /***/ "./src/modules/mini-cart/mini-cart.vue.js":
      /*!************************************************!*\
  !*** ./src/modules/mini-cart/mini-cart.vue.js ***!
  \************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! vuex */ "./node_modules/vuex/dist/vuex.esm.js"
          );
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      "function" == typeof Symbol &&
                      obj.constructor === Symbol &&
                      obj !== Symbol.prototype
                      ? "symbol"
                      : typeof obj;
                  }),
            _typeof(obj)
          );
        }
        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly &&
              (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })),
              keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2
              ? ownKeys(Object(source), !0).forEach(function (key) {
                  _defineProperty(target, key, source[key]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(
                  target,
                  Object.getOwnPropertyDescriptors(source)
                )
              : ownKeys(Object(source)).forEach(function (key) {
                  Object.defineProperty(
                    target,
                    key,
                    Object.getOwnPropertyDescriptor(source, key)
                  );
                });
          }
          return target;
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }

        Vue.component("mini-cart", {
          computed: _objectSpread(
            _objectSpread(
              {},
              (0, vuex__WEBPACK_IMPORTED_MODULE_0__.mapState)(["app"])
            ),
            {},
            {
              cart: function cart() {
                return this.app.cart;
              },
            }
          ),
          data: function data() {
            var _window$locale_aware_;
            return {
              baseUrl:
                ((_window$locale_aware_ = window.locale_aware_base_url) ===
                  null || _window$locale_aware_ === void 0
                  ? void 0
                  : _window$locale_aware_.replace("/", "")) || "",
            };
          },
          methods: _objectSpread(
            {},
            (0, vuex__WEBPACK_IMPORTED_MODULE_0__.mapMutations)([
              "toggleMiniCart",
            ])
          ),
        });

        /***/
      },

    /***/ "./src/modules/modal/modal.js":
      /*!************************************!*\
  !*** ./src/modules/modal/modal.js ***!
  \************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! dom-select */ "./node_modules/dom-select/index.js"
          );
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_select__WEBPACK_IMPORTED_MODULE_1__
          );
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            if (!el) {
              el = document.querySelector(".js-modal");
            }
            if (!el) {
              return;
            }
            var closeModals =
              dom_select__WEBPACK_IMPORTED_MODULE_1___default().all(
                ".js-modal-close",
                el
              );
            var video = dom_select__WEBPACK_IMPORTED_MODULE_1___default()(
              ".js-modal__video",
              el
            );

            // if video, when video ends, close modal
            if (video) {
              dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                video,
                "ended",
                function () {
                  document.body.classList.remove("showing-modal");
                  el.classList.remove("active");
                }
              );
            }

            // add esc key listener to stop video and hide modals
            dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
              document,
              "keydown",
              function (e) {
                if (e.keyCode === 27) {
                  document.body.classList.remove("showing-modal");
                  el.classList.remove("active");
                  if (video) {
                    video.pause();
                    video.currentTime = 0;
                  }
                }
              }
            );
            var _iterator = _createForOfIteratorHelper(closeModals),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                var closeModal = _step.value;
                dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                  closeModal,
                  "click",
                  function () {
                    document.body.classList.remove("showing-modal");
                    el.classList.remove("active");
                    if (video) {
                      video.pause();
                      video.currentTime = 0;
                    }
                  }
                );
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          };

        /***/
      },

    /***/ "./src/modules/newsletter-form/newsletter-form.vue.js":
      /*!************************************************************!*\
  !*** ./src/modules/newsletter-form/newsletter-form.vue.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var jsonp__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! jsonp */ "./node_modules/jsonp/index.js");
        /* harmony import */ var jsonp__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            jsonp__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var nanoajax__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! nanoajax */ "./node_modules/nanoajax/index.js"
          );
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      "function" == typeof Symbol &&
                      obj.constructor === Symbol &&
                      obj !== Symbol.prototype
                      ? "symbol"
                      : typeof obj;
                  }),
            _typeof(obj)
          );
        }
        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly &&
              (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })),
              keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2
              ? ownKeys(Object(source), !0).forEach(function (key) {
                  _defineProperty(target, key, source[key]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(
                  target,
                  Object.getOwnPropertyDescriptors(source)
                )
              : ownKeys(Object(source)).forEach(function (key) {
                  Object.defineProperty(
                    target,
                    key,
                    Object.getOwnPropertyDescriptor(source, key)
                  );
                });
          }
          return target;
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }

        Vue.component("newsletter-form", {
          props: [
            "provider",
            "mailchimpUrl",
            "klaviyoUrl",
            "klaviyoGroup",
            "errorText",
            "successText",
            "privacyErrorText",
          ],
          data: function data() {
            return {
              callbackFnName: "newsletterSuccess",
              query: _objectSpread(
                {},
                this.provider === "klaviyo" && {
                  g: this.klaviyoGroup,
                }
              ),
              response: false,
              hasError: false,
            };
          },
          methods: {
            onInputChange: function onInputChange(_ref) {
              var name = _ref.name,
                value = _ref.value;
              this.query[name] = value;
            },
            submit: function submit(e) {
              var _this = this;
              e.preventDefault();
              if (
                this.$refs.privacyCheckbox &&
                !this.$refs.privacyCheckbox.checked
              ) {
                this.hasError = true;
                this.response = this.privacyErrorText;
                return;
              }
              var isValid = this.$children.every(function (c) {
                return c.validate();
              });
              if (!isValid) {
                this.response = "";
                this.hasError = true;
                return;
              }
              var query = Object.keys(this.query)
                .map(function (k) {
                  var value = _this.query[k];
                  if (_this.provider === "mailchimp") {
                    value = encodeURIComponent(value);
                  }
                  return "".concat(k, "=").concat(value);
                })
                .join("&");
              if (this.provider === "mailchimp") {
                jsonp__WEBPACK_IMPORTED_MODULE_0___default()(
                  "".concat(this.mailchimpUrl, "&").concat(query),
                  {
                    param: "c",
                  },
                  this.mailchimpResponseHandler
                );
              } else if (this.provider === "klaviyo") {
                nanoajax__WEBPACK_IMPORTED_MODULE_1__.ajax(
                  {
                    body: query,
                    url: this.klaviyoUrl,
                    action: "POST",
                  },
                  this.klaviyoResponseHandler
                );
              }
            },
            mailchimpResponseHandler: function mailchimpResponseHandler(
              err,
              data
            ) {
              if (err) {
                this.response = this.errorText;
                return;
              }
              if (data && data["msg"]) {
                this.response = data["msg"];
              }
            },
            klaviyoResponseHandler: function klaviyoResponseHandler(
              status,
              data
            ) {
              if (Number(status) !== 200) {
                this.response = this.errorText;
                this.hasError = true;
                return;
              }
              var parsed = JSON.parse(data);
              if (parsed && parsed["success"]) {
                this.hasError = false;
                this.response = this.successText;
              } else {
                this.hasError = true;
                this.response = this.errorText;
              }
            },
            isValidEmail: function isValidEmail(_ref2) {
              var value = _ref2.value;
              return /\S+@\S+\.\S+/.test(value);
            },
          },
        });

        /***/
      },

    /***/ "./src/modules/pagination/pagination.vue.js":
      /*!**************************************************!*\
  !*** ./src/modules/pagination/pagination.vue.js ***!
  \**************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! lodash/range */ "./node_modules/lodash/range.js"
          );
        /* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            lodash_range__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var lodash_chunk__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! lodash/chunk */ "./node_modules/lodash/chunk.js"
          );
        /* harmony import */ var lodash_chunk__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            lodash_chunk__WEBPACK_IMPORTED_MODULE_1__
          );

        Vue.component("pagination", {
          props: {
            currentPage: {
              type: Number,
              default: 1,
              required: true,
            },
            totalCount: {
              type: Number,
              default: 0,
              required: true,
            },
            perPage: {
              type: Number,
              default: 1,
              required: true,
            },
            limit: {
              type: Number,
              default: 4,
            },
          },
          computed: {
            totalPage: function totalPage() {
              return (
                Math.floor(this.totalCount / this.perPage) +
                (this.totalCount % this.perPage > 0 ? 1 : 0)
              );
            },
            isShowPrev: function isShowPrev() {
              return this.currentPage > 1;
            },
            isShowNext: function isShowNext() {
              return this.totalPage > 1 && this.currentPage < this.totalPage;
            },
            /**
             * Number value of last page previous chunk
             * @returns {number}
             */
            firstPageOfPrevChunk: function firstPageOfPrevChunk() {
              var currentChunk = Math.floor(
                (this.currentPage - 1) / this.limit
              );
              var prevChunkPage = 0;
              if (currentChunk > 0) {
                var prevChunk = currentChunk - 1;
                prevChunkPage = prevChunk * this.limit + this.limit;
              }
              return prevChunkPage;
            },
            /**
             * Number value of first page number next chunk
             * @returns {number}
             */
            firstPageOfNextChunk: function firstPageOfNextChunk() {
              var currentChunk = Math.floor(
                (this.currentPage - 1) / this.limit
              );
              var nextChunk = currentChunk + 1;
              var nextChunkPage = nextChunk * this.limit + 1;
              if (nextChunkPage <= this.totalPage) {
                return nextChunkPage;
              } else {
                return 0;
              }
            },
            /**
             * Array number of page value
             * @returns {*}
             */
            pages: function pages() {
              var pageLists = [];
              var arrayRangePage =
                lodash_range__WEBPACK_IMPORTED_MODULE_0___default()(
                  1,
                  this.totalPage + 1
                );
              if (this.totalPage <= this.limit || this.limit === 0) {
                pageLists = arrayRangePage;
              } else {
                var chunkPages =
                  lodash_chunk__WEBPACK_IMPORTED_MODULE_1___default()(
                    arrayRangePage,
                    this.limit
                  );
                var currentChunk = Math.floor(
                  (this.currentPage - 1) / this.limit
                );
                pageLists = chunkPages[currentChunk];
              }
              return pageLists;
            },
          },
          methods: {
            // @eventHandler
            handleClickPage: function handleClickPage(page) {
              this.$emit("change", page);
            },
            // @eventHandler
            handleClickPrev: function handleClickPrev() {
              var prev = this.currentPage - 1;
              prev > 0 ? this.$emit("change", prev) : this.$emit("change", 1);
            },
            // @eventHandler
            handleClickNext: function handleClickNext() {
              var next = this.currentPage + 1;
              next <= this.totalPage
                ? this.$emit("change", next)
                : this.$emit("change", this.totalPage);
            },
            /**
             * @ventHandler
             * @description: Trigger custom event `change` on parent component
             * @param: value of next page
             **/
            handleClickDoubleNext: function handleClickDoubleNext(next) {
              if (!next) {
                return;
              }
              this.$emit("change", next);
            },
            /**
             * @ventHandler
             * @description: Trigger custom event `change` on parent component
             * @param: value of previous page
             **/
            handleClickDoublePrev: function handleClickDoublePrev(prev) {
              if (!prev) {
                return;
              }
              this.$emit("change", prev);
            },
          },
        });

        /***/
      },

    /***/ "./src/modules/pdp-product-three-up/pdp-product-three-up.js":
      /*!******************************************************************!*\
  !*** ./src/modules/pdp-product-three-up/pdp-product-three-up.js ***!
  \******************************************************************/
      /***/ () => {
        /***/
      },

    /***/ "./src/modules/product-accordion/product-accordion.js":
      /*!************************************************************!*\
  !*** ./src/modules/product-accordion/product-accordion.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! dom-select */ "./node_modules/dom-select/index.js"
          );
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_select__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_2___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_2__
          );
        /* harmony import */ var body_scroll_lock__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! body-scroll-lock */ "./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js"
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              data: function data() {
                return {
                  product: window.BARREL.product,
                  activeAccordion: false,
                  reviews: "",
                  shopDomain: window.BARREL.shop,
                };
              },
              methods: {
                toggleAccordion: function toggleAccordion(reference) {
                  var scrollTo =
                    arguments.length > 1 && arguments[1] !== undefined
                      ? arguments[1]
                      : true;
                  if (this.activeAccordion === reference) {
                    this.activeAccordion = false;
                  } else {
                    this.activeAccordion = reference;
                  }
                  if (scrollTo) {
                    setTimeout(function () {
                      // scroll reference into view
                      var accordion =
                        dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                          'div[aria-labelledby="'.concat(reference, '"]')
                        );
                      if (accordion) {
                        accordion.scrollIntoView({
                          behavior: "smooth",
                          block: "start",
                          offset: -100,
                        });
                      }
                    }, 100);
                  }
                },
                height: function height(reference) {
                  if (this.activeAccordion !== reference) {
                    return 0;
                  }
                  return (
                    this.$refs[reference].getBoundingClientRect().height + "px"
                  );
                },
                showModal: function showModal(modal) {
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.set)(
                    document.body,
                    "showing-modal"
                  );
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.set)(
                    dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                      ".js-modal[data-modal=".concat(modal, "]")
                    ),
                    "active"
                  );
                },
                hideModal: function hideModal(modal) {
                  console.log("hideModal", modal);
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.unset)(
                    document.body,
                    "showing-modal"
                  );
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.unset)(
                    dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                      ".js-modal[data-modal=".concat(modal, "]")
                    ),
                    "active"
                  );
                },
              },
              mounted: function mounted() {
                if (document.querySelector(".accordion-description")) {
                  this.toggleAccordion("accordion-description", false);
                } else {
                  this.toggleAccordion("accordion-1", false);
                }
                setTimeout(function () {
                  var writeReviewLink =
                    dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                      ".spr-summary-actions-newreview"
                    );
                  var writeReviewModal =
                    dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                      ".spr-form"
                    );
                  var writeReviewWindow =
                    dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                      ".new-review-form"
                    );
                  var span = document.createElement("button");
                  span.className = "close-review-button js-close-review";
                  span.type = "button";
                  writeReviewLink &&
                    dom_event__WEBPACK_IMPORTED_MODULE_2___default()(
                      writeReviewLink,
                      "click",
                      function () {
                        (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.set)(
                          document.body,
                          "showing-modal"
                        );
                        writeReviewWindow.appendChild(span);
                        span.style.top = "".concat(
                          writeReviewWindow.offsetTop + 10,
                          "px"
                        );
                        document
                          .querySelector(".spr-form-contact-name input")
                          .focus();
                      }
                    );
                  writeReviewModal &&
                    dom_event__WEBPACK_IMPORTED_MODULE_2___default()(
                      writeReviewModal,
                      "click",
                      function (e) {
                        if (!e.target.closest(".js-close-review")) {
                          return;
                        }
                        writeReviewWindow.appendChild(span);
                        (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.unset)(
                          document.body,
                          "showing-modal"
                        );
                        writeReviewModal.style.display = "none";
                      }
                    );
                  if (typeof jQuery !== "undefined") {
                    jQuery(document).on("keyup", function (e) {
                      if (e.keyCode === 27) {
                        (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.unset)(
                          document.body,
                          "showing-modal"
                        );
                        writeReviewModal.style.display = "none";
                      }
                    });
                    jQuery(document).on("spr:form:failure", function () {
                      setTimeout(function () {
                        writeReviewWindow =
                          dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                            ".new-review-form"
                          );
                        writeReviewWindow.appendChild(span);
                      }, 200);
                    });
                    jQuery(document).on("spr:form:loaded", function () {
                      writeReviewWindow.appendChild(span);

                      // move the the spr-form element to the body
                      document.body.appendChild(writeReviewModal);

                      // once it's loaded then we need to remove the fixed height if we have one
                      writeReviewWindow.closest(
                        ".product-accordion__body"
                      ).style.maxHeight = "0";
                    });
                    jQuery(document).on("spr:form:success", function () {
                      setTimeout(function () {
                        writeReviewWindow =
                          dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                            ".new-review-form"
                          );
                        writeReviewWindow.appendChild(span);
                        var button = document.createElement("button");
                        button.setAttribute("type", "button");
                        button.className = "close-review-button";
                        button.addEventListener("click", function () {
                          document.querySelector(".spr-form").style.display =
                            "none";
                        });
                        writeReviewWindow.appendChild(button);
                      }, 200);
                    });
                  }
                }, 3000);
                dom_event__WEBPACK_IMPORTED_MODULE_2___default()(
                  window,
                  "resize",
                  function () {
                    var accordionBody =
                      dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                        'div[aria-hidden="true"] .product-accordion__content'
                      );
                    if (accordionBody) {
                      accordionBody.parentNode.style.maxHeight =
                        accordionBody.getBoundingClientRect().height + "px";
                    }
                    var closeReviewEl =
                      dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                        ".js-close-review"
                      );
                    var writeReviewWindow =
                      dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                        ".new-review-form"
                      );
                    if (closeReviewEl && writeReviewWindow) {
                      closeReviewEl.style.top = "".concat(
                        writeReviewWindow.offsetTop + 10,
                        "px"
                      );
                    }
                  }
                );
              },
            });
          };

        /***/
      },

    /***/ "./src/modules/product-card/product-card.vue.js":
      /*!******************************************************!*\
  !*** ./src/modules/product-card/product-card.vue.js ***!
  \******************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var vue_dist_vue__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! vue/dist/vue */ "./node_modules/vue/dist/vue.js"
          );
        /* harmony import */ var vue_dist_vue__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            vue_dist_vue__WEBPACK_IMPORTED_MODULE_1__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      "function" == typeof Symbol &&
                      obj.constructor === Symbol &&
                      obj !== Symbol.prototype
                      ? "symbol"
                      : typeof obj;
                  }),
            _typeof(obj)
          );
        }
        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly &&
              (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })),
              keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2
              ? ownKeys(Object(source), !0).forEach(function (key) {
                  _defineProperty(target, key, source[key]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(
                  target,
                  Object.getOwnPropertyDescriptors(source)
                )
              : ownKeys(Object(source)).forEach(function (key) {
                  Object.defineProperty(
                    target,
                    key,
                    Object.getOwnPropertyDescriptor(source, key)
                  );
                });
          }
          return target;
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }

        var AnimationLoop = function AnimationLoop(hoverContainer) {
          if (hoverContainer.classList.contains("is-mouseover")) {
            hoverContainer.classList.add("is-playing");
          }
        };

        /**
         * This component is used throughout the site,
         * in product carousels and on the PLP page.
         */
        var ProductCard =
          vue_dist_vue__WEBPACK_IMPORTED_MODULE_1___default().component(
            "product-card",
            {
              props: ["product", "decode", "featured"],
              /**
               * Data can come via a JSON string that needs to be
               * decoded, or via an javascript object, passed by a
               * parent component or a Vuex store.
               */
              data: function data() {
                var product;
                if (!!this.decode && this.product) {
                  product = JSON.parse(
                    (0, lib_util__WEBPACK_IMPORTED_MODULE_0__.decode)(
                      this.product
                    )
                  );
                } else {
                  product = this.product || {
                    title: "",
                    price: "",
                    featuredImage: "",
                    variants: [],
                    optionNames: [],
                    metafields: [],
                  };
                }
                return _objectSpread(
                  _objectSpread({}, product),
                  {},
                  {
                    activeOption: "",
                    hover: false,
                  }
                );
              },
              mounted: function mounted() {
                this.activeOption = this.firstOption;
              },
              computed: {
                firstOption: function firstOption() {
                  return (this.options || [])[0];
                },
                optionName: function optionName() {
                  return (this.optionNames || [])[0];
                },
                options: function options() {
                  return this[this.optionName];
                },
                imageSrc: function imageSrc() {
                  return (0,
                  lib_util__WEBPACK_IMPORTED_MODULE_0__.getProductImage)(
                    this.optionName,
                    this.activeOption,
                    this.images,
                    false,
                    this.featuredImage
                  );
                },
                link: function link() {
                  return "/products/"
                    .concat(this.handle)
                    .concat(this.activeVariantUrl);
                },
                activeVariantUrl: function activeVariantUrl() {
                  var _this = this;
                  var firstVariant = this.variants.find(function (_ref) {
                    var _ref$title = _ref.title,
                      title = _ref$title === void 0 ? "" : _ref$title,
                      id = _ref.id;
                    return ~title.indexOf(_this.activeOption);
                  });
                  return firstVariant
                    ? "?variant=".concat(firstVariant.id)
                    : "";
                },
              },
              methods: {
                changeActiveOption: function changeActiveOption(value) {
                  this.activeOption = value;
                },
                mouseoverHandler: function mouseoverHandler() {
                  this.$refs.hoverContainer.classList.add("is-playing");
                  this.$refs.hoverContainer.classList.add("is-mouseover");
                },
                mouseleaveHandler: function mouseleaveHandler() {
                  this.$refs.hoverContainer.classList.remove("is-mouseover");
                },
                AnimationEndHandler: function AnimationEndHandler() {
                  var _this2 = this;
                  this.$refs.hoverContainer.classList.remove("is-playing");
                  setTimeout(function () {
                    AnimationLoop(_this2.$refs.hoverContainer);
                  }, 100);
                },
              },
            }
          );
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ProductCard;

        /***/
      },

    /***/ "./src/modules/product-cross-sell/product-cross-sell.js":
      /*!**************************************************************!*\
  !*** ./src/modules/product-cross-sell/product-cross-sell.js ***!
  \**************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        function _typeof(obj) {
          "@babel/helpers - typeof";
          return (
            (_typeof =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (obj) {
                    return typeof obj;
                  }
                : function (obj) {
                    return obj &&
                      "function" == typeof Symbol &&
                      obj.constructor === Symbol &&
                      obj !== Symbol.prototype
                      ? "symbol"
                      : typeof obj;
                  }),
            _typeof(obj)
          );
        }
        function ownKeys(object, enumerableOnly) {
          var keys = Object.keys(object);
          if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly &&
              (symbols = symbols.filter(function (sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
              })),
              keys.push.apply(keys, symbols);
          }
          return keys;
        }
        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2
              ? ownKeys(Object(source), !0).forEach(function (key) {
                  _defineProperty(target, key, source[key]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(
                  target,
                  Object.getOwnPropertyDescriptors(source)
                )
              : ownKeys(Object(source)).forEach(function (key) {
                  Object.defineProperty(
                    target,
                    key,
                    Object.getOwnPropertyDescriptor(source, key)
                  );
                });
          }
          return target;
        }
        function _defineProperty(obj, key, value) {
          key = _toPropertyKey(key);
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }
        function _toPropertyKey(arg) {
          var key = _toPrimitive(arg, "string");
          return _typeof(key) === "symbol" ? key : String(key);
        }
        function _toPrimitive(input, hint) {
          if (_typeof(input) !== "object" || input === null) return input;
          var prim = input[Symbol.toPrimitive];
          if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return (hint === "string" ? String : Number)(input);
        }

        var AnimationLoop = function AnimationLoop(hoverContainer) {
          if (hoverContainer.classList.contains("is-mouseover")) {
            hoverContainer.classList.add("is-playing");
          }
        };

        /**
         * This component is used throughout the site,
         * in product carousels and on the PLP page.
         */
        Vue.component("product-card", {
          props: ["product", "decode", "featured"],
          /**
           * Data can come via a JSON string that needs to be
           * decoded, or via an javascript object, passed by a
           * parent component or a Vuex store.
           */
          data: function data() {
            var product;
            if (!!this.decode && this.product) {
              product = JSON.parse(
                (0, lib_util__WEBPACK_IMPORTED_MODULE_0__.decode)(this.product)
              );
            } else {
              product = this.product || {
                title: "",
                price: "",
                featuredImage: "",
                variants: [],
                optionNames: [],
                metafields: [],
              };
            }
            return _objectSpread(
              _objectSpread({}, product),
              {},
              {
                activeOption: "",
                hover: false,
              }
            );
          },
          mounted: function mounted() {
            this.activeOption = this.firstOption;
          },
          computed: {
            firstOption: function firstOption() {
              return (this.options || [])[0];
            },
            optionName: function optionName() {
              return (this.optionNames || [])[0];
            },
            options: function options() {
              return this[this.optionName];
            },
            imageSrc: function imageSrc() {
              return (0, lib_util__WEBPACK_IMPORTED_MODULE_0__.getProductImage)(
                this.optionName,
                this.activeOption,
                this.images,
                false,
                this.featuredImage
              );
            },
            link: function link() {
              return "/products/"
                .concat(this.handle)
                .concat(this.activeVariantUrl);
            },
            activeVariantUrl: function activeVariantUrl() {
              var _this = this;
              var firstVariant = this.variants.find(function (_ref) {
                var _ref$title = _ref.title,
                  title = _ref$title === void 0 ? "" : _ref$title,
                  id = _ref.id;
                return ~title.indexOf(_this.activeOption);
              });
              return firstVariant ? "?variant=".concat(firstVariant.id) : "";
            },
          },
          methods: {
            changeActiveOption: function changeActiveOption(value) {
              this.activeOption = value;
            },
            mouseoverHandler: function mouseoverHandler() {
              this.$refs.hoverContainer.classList.add("is-playing");
              this.$refs.hoverContainer.classList.add("is-mouseover");
            },
            mouseleaveHandler: function mouseleaveHandler() {
              this.$refs.hoverContainer.classList.remove("is-mouseover");
            },
            AnimationEndHandler: function AnimationEndHandler() {
              var _this2 = this;
              this.$refs.hoverContainer.classList.remove("is-playing");
              setTimeout(function () {
                AnimationLoop(_this2.$refs.hoverContainer);
              }, 100);
            },
          },
        });

        /***/
      },

    /***/ "./src/modules/product-form/product-form.js":
      /*!**************************************************!*\
  !*** ./src/modules/product-form/product-form.js ***!
  \**************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! dom-select */ "./node_modules/dom-select/index.js"
          );
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_select__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        /* harmony import */ var lib_appState__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(/*! lib/appState */ "./src/js/lib/appState.js");
        /* global CustomEvent */

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              data: function data() {
                var product = window.BARREL.product;
                var selected = product["variants"].find(function (variant) {
                  return variant.available;
                });
                return {
                  state: lib_appState__WEBPACK_IMPORTED_MODULE_2__["default"],
                  product: product,
                  selected: selected,
                  quantity: 1,
                  selectedSellingPlanDiscount: 0,
                  selectedSellingPlanPrice: 0,
                };
              },
              mounted: function mounted() {
                try {
                  this.pickActiveVariant();
                  this.calculateSellingPlanPrice();
                } catch (e) {}
              },
              methods: {
                calculateSellingPlanPrice:
                  function calculateSellingPlanPrice() {
                    var selectedSellingPlan = document.querySelector(
                      'select[name="selling_plan"] option:checked'
                    );
                    if (selectedSellingPlan) {
                      var selectedSellingPlanDiscount = JSON.parse(
                        selectedSellingPlan.dataset.discount
                      );
                      var adjust =
                        selectedSellingPlanDiscount.price_adjustments[0].value;
                      console.log({
                        adjust: adjust,
                        selected: this.selected,
                      });
                      this.selectedSellingPlanDiscount = adjust;
                      var adjusted = (
                        (this.selected.price / 100) *
                        ((100 - adjust) / 100)
                      ).toFixed(2);
                      this.selectedSellingPlanPrice = adjusted.replace(
                        ".00",
                        ""
                      );
                      console.log(adjusted, this.selected.price);
                    }
                  },
                showModal: function showModal(modal) {
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.set)(
                    document.body,
                    "showing-modal"
                  );
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.set)(
                    dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                      ".js-modal[data-modal=".concat(modal, "]")
                    ),
                    "active"
                  );
                },
                triggerNotifyMe: function triggerNotifyMe(e) {
                  e.preventDefault();
                  e.stopPropagation();
                  var outOfStockUrl =
                    dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                      "[data-out-of-stock-url]"
                    ).dataset.outOfStockUrl;

                  // if the out of stock url contains `window.`, then we need to execute it
                  if (outOfStockUrl.includes("window.")) {
                    eval(outOfStockUrl);
                  } else {
                    this.showModal("notify-me");
                  }
                  return false;
                },
                hideModal: function hideModal(modal) {
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.unset)(
                    document.body,
                    "showing-modal"
                  );
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_1__.unset)(
                    dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                      "#notify-me"
                    ),
                    "active"
                  );
                },
                pickActiveVariant: function pickActiveVariant() {
                  var _this = this;
                  var _this$product = this.product,
                    _this$product$variant = _this$product.variants,
                    variants =
                      _this$product$variant === void 0
                        ? []
                        : _this$product$variant,
                    _this$product$options = _this$product.options,
                    options =
                      _this$product$options === void 0
                        ? []
                        : _this$product$options;
                  var _loop = function _loop() {
                    var variant = variants[i];
                    var isMatch = options.every(function (option, _i) {
                      return (
                        variant["option".concat(_i + 1)] ===
                        _this.selected[option]
                      );
                    });
                    if (isMatch) {
                      lib_appState__WEBPACK_IMPORTED_MODULE_2__[
                        "default"
                      ].activeVariant = variant;
                      return "break";
                    }
                  };
                  for (var i = 0; i < variants.length; i++) {
                    var _ret = _loop();
                    if (_ret === "break") break;
                  }
                  if (
                    !lib_appState__WEBPACK_IMPORTED_MODULE_2__["default"]
                      .activeVariant
                  ) {
                    lib_appState__WEBPACK_IMPORTED_MODULE_2__[
                      "default"
                    ].activeVariant = variants[0];
                  }
                },
                updateSelectedOption: function updateSelectedOption(
                  name,
                  value
                ) {
                  Vue.set(this.selected, name, value);
                },
                addToCart: function addToCart() {
                  var _document$querySelect;
                  if (!this.selected) {
                    return;
                  }
                  var form = document.querySelector(".product-form form");
                  var item = this.selected;
                  form.classList.add("loading");
                  var formData = {
                    items: [
                      {
                        id: document.querySelector("input[name=id]").value,
                        quantity:
                          (_document$querySelect = document.querySelector(
                            "input[name=quantity]"
                          ).value) !== null && _document$querySelect !== void 0
                            ? _document$querySelect
                            : 1,
                      },
                    ],
                  };
                  var hasSellingPlanDOM = document.querySelector(
                    'input[name="has_selling_plan"]:checked'
                  );
                  var hasSellingPlan =
                    hasSellingPlanDOM && hasSellingPlanDOM.value === "yes";
                  var selectedSellingPlan = document.querySelector(
                    'select[name="selling_plan"]'
                  );
                  var isSubscription = false;
                  if (hasSellingPlan && selectedSellingPlan) {
                    isSubscription = true;
                    formData.items[0].selling_plan = selectedSellingPlan.value;
                  }

                  // submit the form via fetch

                  fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                  }).then(function (d) {
                    lib_appState__WEBPACK_IMPORTED_MODULE_2__[
                      "default"
                    ].lastAdd = Date.now();
                    lib_appState__WEBPACK_IMPORTED_MODULE_2__[
                      "default"
                    ].isMiniCartOpen = true;
                    form === null || form === void 0
                      ? void 0
                      : form.classList.remove("loading");
                    var q = null;
                    var quantity = 1;
                    if (
                      (q =
                        form === null || form === void 0
                          ? void 0
                          : form.querySelector('input[name="quantity"]'))
                    ) {
                      quantity = q.value || 1;
                    }
                    document.dispatchEvent(
                      new CustomEvent("product:added", {
                        detail: {
                          variant: item,
                          subscription: isSubscription,
                          quantity: quantity,
                        },
                      })
                    );
                  });
                },
              },
            });
          };

        /***/
      },

    /***/ "./src/modules/product-main/product-main.js":
      /*!**************************************************!*\
  !*** ./src/modules/product-main/product-main.js ***!
  \**************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            var klaviyoStarRatingWidget = document.querySelector(
              ".klaviyo-star-rating-widget"
            );
            if (klaviyoStarRatingWidget) {
              // remove the klaviyo-star-rating-widget from the DOM
              klaviyoStarRatingWidget.remove();
              var productFormReviews = document.querySelector(
                ".product-form__reviews"
              );
              if (productFormReviews) {
                productFormReviews.appendChild(klaviyoStarRatingWidget);
              }
            }
          };

        /***/
      },

    /***/ "./src/modules/product-slide-out/product-slide-out.js":
      /*!************************************************************!*\
  !*** ./src/modules/product-slide-out/product-slide-out.js ***!
  \************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! select-dom */ "./node_modules/select-dom/index.js"
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        function _createForOfIteratorHelper(o, allowArrayLike) {
          var it =
            (typeof Symbol !== "undefined" && o[Symbol.iterator]) ||
            o["@@iterator"];
          if (!it) {
            if (
              Array.isArray(o) ||
              (it = _unsupportedIterableToArray(o)) ||
              (allowArrayLike && o && typeof o.length === "number")
            ) {
              if (it) o = it;
              var i = 0;
              var F = function F() {};
              return {
                s: F,
                n: function n() {
                  if (i >= o.length) return { done: true };
                  return { done: false, value: o[i++] };
                },
                e: function e(_e) {
                  throw _e;
                },
                f: F,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var normalCompletion = true,
            didErr = false,
            err;
          return {
            s: function s() {
              it = it.call(o);
            },
            n: function n() {
              var step = it.next();
              normalCompletion = step.done;
              return step;
            },
            e: function e(_e2) {
              didErr = true;
              err = _e2;
            },
            f: function f() {
              try {
                if (!normalCompletion && it["return"] != null) it["return"]();
              } finally {
                if (didErr) throw err;
              }
            },
          };
        }
        function _unsupportedIterableToArray(o, minLen) {
          if (!o) return;
          if (typeof o === "string") return _arrayLikeToArray(o, minLen);
          var n = Object.prototype.toString.call(o).slice(8, -1);
          if (n === "Object" && o.constructor) n = o.constructor.name;
          if (n === "Map" || n === "Set") return Array.from(o);
          if (
            n === "Arguments" ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return _arrayLikeToArray(o, minLen);
        }
        function _arrayLikeToArray(arr, len) {
          if (len == null || len > arr.length) len = arr.length;
          for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
          return arr2;
        }

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            var closeButton = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
              ".js-close",
              el
            );
            var accordionItems = select_dom__WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ].all(".js-accordion-item", el);
            var viewSupplementsLink = (0,
            select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
              ".js-supplement-modal-link",
              el
            );
            dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
              closeButton,
              "click",
              function () {
                (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                  document.body,
                  "showing-slide-out"
                );
                (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(el, "active");
              }
            );
            if (viewSupplementsLink) {
              dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                viewSupplementsLink,
                "click",
                function (e) {
                  e.preventDefault();
                  var slideOutFocus = (0,
                  select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                    '.js-modal[data-modal="supplement-facts"] button, .js-modal[data-modal="supplement-facts"] a, .js-modal[data-modal="supplement-facts"] [role="button"]',
                    el
                  );
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                    document.body,
                    "showing-modal"
                  );
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                    (0, select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                      '.js-modal[data-modal="supplement-facts"]',
                      el
                    ),
                    "active"
                  );
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                    slideOut,
                    "active"
                  );
                  slideOutFocus.focus();
                }
              );
            }
            var reset = function reset() {
              var _iterator = _createForOfIteratorHelper(accordionItems),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done; ) {
                  var item = _step.value;
                  var body = (0,
                  select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                    ".js-accordion-item-body",
                    item
                  );
                  body.style.maxHeight = "0";
                  (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                    item,
                    "is-active"
                  );
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            };
            var _iterator2 = _createForOfIteratorHelper(accordionItems),
              _step2;
            try {
              var _loop = function _loop() {
                var item = _step2.value;
                dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                  item,
                  "click",
                  function () {
                    var content = (0,
                    select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                      ".js-accordion-item-content",
                      item
                    );
                    var body = (0,
                    select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                      ".js-accordion-item-body",
                      item
                    );
                    var button = (0,
                    select_dom__WEBPACK_IMPORTED_MODULE_1__["default"])(
                      "button",
                      item
                    );
                    var wasActive = (0,
                    lib_util__WEBPACK_IMPORTED_MODULE_2__.contains)(
                      item,
                      "is-active"
                    );
                    reset();
                    if (wasActive) {
                      body.style.maxHeight = "0";
                      (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.unset)(
                        item,
                        "is-active"
                      );
                      body.setAttribute("aria-hidden", true);
                      button.setAttribute("aria-expanded", false);
                    } else {
                      body.style.maxHeight = "".concat(
                        content.getBoundingClientRect().height,
                        "px"
                      );
                      (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                        item,
                        "is-active"
                      );
                      body.setAttribute("aria-hidden", false);
                      button.setAttribute("aria-expanded", true);
                    }
                  }
                );
              };
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
                _loop();
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          };

        /***/
      },

    /***/ "./src/modules/product-three-up/product-three-up.js":
      /*!**********************************************************!*\
  !*** ./src/modules/product-three-up/product-three-up.js ***!
  \**********************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! flickity */ "./node_modules/flickity/js/index.js"
          );
        /* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            flickity__WEBPACK_IMPORTED_MODULE_1__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");
        /* harmony import */ var _image_image_vue_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! ../image/image.vue.js */ "./src/modules/image/image.vue.js"
          );

        var breakpoint = 767;
        var third = 100 / 3;
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              data: function data() {
                return {
                  scrollPercent: 0,
                };
              },
              methods: {
                init: function init() {
                  var _this = this;
                  this.$nextTick(function () {
                    _this.$flickity =
                      new (flickity__WEBPACK_IMPORTED_MODULE_1___default())(
                        _this.$refs["carousel"],
                        {
                          cellAlign: "left",
                          initialIndex: 0,
                          prevNextButtons: false,
                          pageDots: true,
                          freeScroll: false,
                          wrapAround: true,
                        }
                      );
                  });
                },
                destroy: function destroy() {
                  this.$flickity.destroy();
                  this.$flickity = null;
                },
                onResize: function onResize() {
                  if (!this.$flickity) {
                    if (
                      !(0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(
                        breakpoint
                      )
                    )
                      this.init();
                  } else {
                    if (
                      (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(
                        breakpoint
                      )
                    )
                      this.destroy();
                  }
                },
                onScroll: function onScroll() {
                  var bgTop =
                    this.$refs["footer-bg"].getBoundingClientRect().top;
                  var docHeight = document.documentElement.clientHeight;
                  var scrollPercent = 100 - (bgTop / docHeight) * 100;
                  if (scrollPercent < 0) {
                    this.scrollPercent = 0;
                  } else if (scrollPercent > 100) {
                    this.scrollPercent = 100;
                  } else {
                    this.scrollPercent = scrollPercent;
                  }
                },
              },
              mounted: function mounted() {
                var _this2 = this;
                this.isMounted = true;
                if (
                  !(0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(breakpoint)
                )
                  this.init();
                dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                  window,
                  "resize",
                  function () {
                    _this2.onResize();
                  }
                );
                if (this.$refs["footer-bg"]) {
                  dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                    window,
                    "scroll",
                    function () {
                      _this2.onScroll();
                    }
                  );
                }
              },
              computed: {
                bgClipPath: function bgClipPath() {
                  var left = null;
                  var right = null;
                  var top = null;
                  var bottom = null;

                  // Offset the scroll by 20% to make animation start and finish earlier
                  var offsetScrollPercent =
                    window.innerHeight + window.scrollY >=
                    document.body.offsetHeight
                      ? this.scrollPercent + 45
                      : this.scrollPercent + 20;
                  if (offsetScrollPercent < third) {
                    left = 50 - ((offsetScrollPercent / third) * 100) / 2;
                    right = 50 + ((offsetScrollPercent / third) * 100) / 2;
                    top = 0;
                    bottom = 2;
                    return "clip-path: polygon("
                      .concat(left, "% ")
                      .concat(top, "%, ")
                      .concat(right, "% ")
                      .concat(top, "%, ")
                      .concat(right, "% ")
                      .concat(bottom, "%, ")
                      .concat(left, "% ")
                      .concat(bottom, "%)");
                  } else if (
                    offsetScrollPercent >= third &&
                    offsetScrollPercent <= 2 * third
                  ) {
                    left = 0;
                    right = 100;
                    top = 0;
                    bottom = (offsetScrollPercent / third) * 100 - 100;
                    return "clip-path: polygon("
                      .concat(left, "% ")
                      .concat(top, "%, ")
                      .concat(right, "% ")
                      .concat(top, "%, ")
                      .concat(right, "% ")
                      .concat(bottom, "%, ")
                      .concat(left, "% ")
                      .concat(bottom, "%)");
                  } else {
                    left = ((offsetScrollPercent - 2 * third) * 3) / 2;
                    right = 100 - ((offsetScrollPercent - 2 * third) * 3) / 2;
                    top = 98;
                    bottom = 100;
                    return "clip-path: polygon(0 0, 0 "
                      .concat(bottom, "%, ")
                      .concat(left, "% ")
                      .concat(bottom, "%, ")
                      .concat(left, "% ")
                      .concat(top, "%, ")
                      .concat(right, "% ")
                      .concat(top, "%, ")
                      .concat(right, "% 100%, ")
                      .concat(right, "% ")
                      .concat(bottom, "%, ")
                      .concat(right, "% ")
                      .concat(bottom, "%, 100% ")
                      .concat(bottom, "%, 100% 0)");
                  }
                },
              },
            });
          };

        /***/
      },

    /***/ "./src/modules/promo-bar/promo-bar.js":
      /*!********************************************!*\
  !*** ./src/modules/promo-bar/promo-bar.js ***!
  \********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var select_dom__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! select-dom */ "./node_modules/select-dom/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_1__
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function () {
            var el = (0, select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])(
              ".js-promo-bar"
            );
            if (!el) {
              return;
            }
            var close = (0, select_dom__WEBPACK_IMPORTED_MODULE_0__["default"])(
              ".js-close",
              el
            );
            var showPromoBar = function showPromoBar() {
              el.classList.remove("is-hidden");
              document.body.classList.add("has-promo-bar");
            };
            var disablePromoBar = function disablePromoBar() {
              // if a user closes the promo bar, give them 24 hours before showing it again
              window.sessionStorage.setItem(
                "closedPromos",
                (new Date().getTime() + 86400000).toString()
              );
              el.classList.add("is-hidden");
              document.body.classList.remove("has-promo-bar");
            };

            // check to make sure its not already closed
            var closed = window.sessionStorage.getItem("closedPromos");
            if (!closed || parseInt(closed) < new Date().getTime()) {
              showPromoBar();
              var i = 0;
              var interval = null;
              var rotate = function rotate() {
                i++;
                if (i >= contents.length) {
                  i = 0;
                }
                contents.forEach(function (content, index) {
                  if (index === i) {
                    content.classList.remove("is-hidden");
                  } else {
                    content.classList.add("is-hidden");
                  }
                });
              };

              // if hovering over the promo bar, pause the rotation
              dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
                el,
                "mouseenter",
                function () {
                  if (interval) {
                    clearInterval(interval);
                  }
                }
              );
              dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
                el,
                "mouseleave",
                function () {
                  interval = setInterval(rotate, 4000);
                }
              );

              // if more that 1 .promo-bar__content elements within the promo bar, show the next one
              // every 4 seconds
              var contents = select_dom__WEBPACK_IMPORTED_MODULE_0__[
                "default"
              ].all(".promo-bar__content", el);
              if (contents.length > 1) {
                interval = setInterval(rotate, 4000);
              }
            }
            dom_event__WEBPACK_IMPORTED_MODULE_1___default()(
              close,
              "click",
              function () {
                disablePromoBar();
              }
            );
          };

        /***/
      },

    /***/ "./src/modules/quantity-selector/quantity-selector.vue.js":
      /*!****************************************************************!*\
  !*** ./src/modules/quantity-selector/quantity-selector.vue.js ***!
  \****************************************************************/
      /***/ () => {
        Vue.component("quantity-selector", {
          props: {
            initial: Number,
            min: {
              type: Number,
              default: 1,
            },
            max: {
              type: Number,
              default: 99,
            },
            ariaLabelledby: {
              type: String,
              default: "Quantity",
            },
          },
          data: function data() {
            return {
              value: this.initial,
            };
          },
          methods: {
            incrementDown: function incrementDown(e) {
              this.value = this.value -= 1;
            },
            incrementUp: function incrementUp(e) {
              this.value = this.value += 1;
            },
          },
          watch: {
            value: function value() {
              if (this.value < this.min) {
                this.value = this.min;
                return;
              }
              if (this.value > this.max) {
                this.value = this.max;
                return;
              }
              this.$emit("change", this.value);
            },
          },
          computed: {},
          template:
            '\n  <div class="quantity-selector">\n    <button\n      class="quantity-selector__action"\n      type="button"\n      v-on:click="incrementDown"\n      :disabled="value <= min"\n      aria-label="Reduce product quantity by one">\n      <svg width="10" height="6" xmlns="http://www.w3.org/2000/svg">\n        <g fill="none" fill-rule="evenodd">\n          <path d="M-.2-4.2H11V7H-.2z"/>\n          <path d="M.6 1.8h9.051V.6H.6z" fill="#161617"/>\n        </g>\n      </svg>\n    </button>\n    <label class="sr-only" for="product-quantity-input" v-text="ariaLabelledby">Quantity</label>\n    <input\n      class="quantity-selector__field p1"\n      type="number"\n      v-model="value"\n      maxlength="2"\n      id="product-quantity-input"\n      name="quantity"\n    >\n    <button\n      class="quantity-selector__action"\n      type="button"\n      v-on:click="incrementUp"\n      :disabled="value >= max"\n      aria-label="Increase product quantity by one">\n      <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">\n        <path d="M4.668.851v3.817H.85v1.167h3.817V9.65h1.167V5.835H9.65V4.668H5.835V.85z" fill="#161617" fill-rule="evenodd"/>\n      </svg>\n    </button>\n  </div>\n  ',
        });

        /***/
      },

    /***/ "./src/modules/select-input/select-input.vue.js":
      /*!******************************************************!*\
  !*** ./src/modules/select-input/select-input.vue.js ***!
  \******************************************************/
      /***/ () => {
        Vue.component("select-input", {
          props: [
            "name",
            "label",
            "getValue",
            "value",
            "error",
            "validator",
            "required",
            "options",
          ],
          data: function data() {
            var data = {
              inputValue: "",
              inputOptions: [],
              isValid: true,
              isActive: false,
              showErrorMessage: false,
            };
            if (this.options && this.options.bind !== "undefined") {
              var options =
                typeof this.options === "function"
                  ? this.options()
                  : this.options;
              data["inputOptions"] = options.map(function (opt) {
                if (
                  typeof opt !== "undefined" &&
                  typeof opt.value === "undefined"
                ) {
                  return {
                    value: opt,
                    label: opt,
                  };
                }
                return opt;
              });
            }
            if (
              this.getValue &&
              this.getValue.bind !== "undefined" &&
              "" + this.getValue(this.name)
            ) {
              data["inputValue"] = this.getValue(this.name);
            } else if (data["inputOptions"].length) {
              data["inputValue"] = data["inputOptions"][0].value;
            }
            return data;
          },
          watch: {
            inputValue: function inputValue() {
              this.$emit("change", {
                value: this.inputValue,
                name: this.name,
              });
            },
          },
          mounted: function mounted() {
            this.$emit("change", {
              value: this.inputValue,
              name: this.name,
            });
          },
          methods: {
            validate: function validate() {
              if (this.validator) {
                this.isValid = this.validator(this.inputValue);
              } else if (this.required && !("" + this.inputValue)) {
                this.isValid = false;
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
            setActive: function setActive() {
              this.isActive = true;
            },
            unsetActive: function unsetActive() {
              if (!this.inputValue) this.isActive = false;
            },
          },
          computed: {},
          template:
            '\n  <div>\n    <div class="select-input__wrap">\n      <label v-if="label" class="select-input__label p2">\n        {{label}}\n      </label>\n      <div class="select-input__el-wrap">\n        <select :name="name" class="select-input__el p2" v-model="inputValue">\n          <template v-if="inputOptions.length">\n            <option\n              v-for="(option, index) in inputOptions"\n              :value="option.value"\n              :selected="(inputValue === option.value)">\n              {{option.label}}\n            </option>\n          </template>\n        </select>\n        <i class="select-input__icon"></i>\n      </div>\n    </div>\n    <transition name="error-fade">\n      <p v-if="!isValid" class="text-input__error red">{{error}}</p>\n    </transition>\n  </div>',
        });

        /***/
      },

    /***/ "./src/modules/splash-layout/splash-layout.js":
      /*!****************************************************!*\
  !*** ./src/modules/splash-layout/splash-layout.js ***!
  \****************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
            });
          };

        /***/
      },

    /***/ "./src/modules/text-input/text-input.vue.js":
      /*!**************************************************!*\
  !*** ./src/modules/text-input/text-input.vue.js ***!
  \**************************************************/
      /***/ () => {
        Vue.component("text-input", {
          props: {
            name: String,
            label: String,
            type: {
              type: String,
              default: "text",
            },
            modifier: {
              type: String,
              default: "default",
            },
            autocorrect: Boolean,
            autocapitalize: Boolean,
            initialValueGetter: Function,
            placeholder: String,
            ariaLabelledby: String,
            error: String,
            required: Boolean,
            validateMethod: Function,
            srOnly: Boolean,
          },
          data: function data() {
            var data = {
              isValid: true,
              isActive: false,
              showErrorMessage: false,
              randomID: "text-input-" + Math.floor(Math.random() * 1000),
            };
            if (
              this.initialValueGetter &&
              this.initialValueGetter.bind !== "undefined"
            ) {
              data["inputValue"] = this.initialValueGetter(this.name);
            } else {
              data["inputValue"] = "";
            }
            return data;
          },
          watch: {
            inputValue: function inputValue() {
              this.$emit("change", {
                value: this.inputValue,
                name: this.name,
              });
            },
          },
          mounted: function mounted() {
            this.$emit("change", {
              value: this.inputValue,
              name: this.name,
            });
            if (this.inputValue) this.setActive();
          },
          methods: {
            validate: function validate() {
              if (this.validateMethod) {
                this.isValid = this.validateMethod({
                  value: this.inputValue,
                  name: this.name,
                });
              } else if (this.required && !this.inputValue) {
                this.isValid = false;
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
            setActive: function setActive() {
              this.isActive = true;
            },
            unsetActive: function unsetActive() {
              if (!this.inputValue) this.isActive = false;
            },
            refresh: function refresh() {
              var _this = this;
              setTimeout(function () {
                _this.inputValue = _this.$refs.input.value;
                if (_this.inputValue) _this.setActive();
              }, 0);
            },
          },
          template:
            '\n  <div class="text-input" :class="\'text-input--\'+modifier">\n    <div class="text-input__wrapper">\n      <label\n        :for="randomID"\n        v-if="label || modifier === \'default\'"\n        :class="[\'text-input__label\', {\'is-active\': isActive, \'h5\': modifier === (\'default\' || \'label\'), \'p2\': modifier === \'newsletter\', \'sr-only\': srOnly}]">\n        {{(label ? label : placeholder)}}\n      </label>\n      <input\n        ref="input"\n        class="text-input__el p1"\n        :id="randomID"\n        :class="{\'text-input__el--error\': !isValid}"\n        :type="type"\n        :name="name"\n        :autocorrect="autocorrect"\n        :autocapitalize="autocapitalize"\n        :placeholder="placeholder"\n        v-model="inputValue"\n        v-on:focus="setActive"\n        v-on:blur="unsetActive" />\n    </div>\n    <transition name="fade">\n      <p v-if="!isValid" class="text-input__error red">{{error}}</p>\n    </transition>\n  </div>',
        });

        /***/
      },

    /***/ "./src/modules/three-up/three-up.js":
      /*!******************************************!*\
  !*** ./src/modules/three-up/three-up.js ***!
  \******************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! dom-event */ "./node_modules/dom-event/index.js"
          );
        /* harmony import */ var dom_event__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_event__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! flickity */ "./node_modules/flickity/js/index.js"
          );
        /* harmony import */ var flickity__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            flickity__WEBPACK_IMPORTED_MODULE_1__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");

        var breakpoint = 767;
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            return new Vue({
              el: el,
              methods: {
                init: function init() {
                  var _this = this;
                  this.$nextTick(function () {
                    _this.$flickity =
                      new (flickity__WEBPACK_IMPORTED_MODULE_1___default())(
                        _this.$refs["carousel"],
                        {
                          cellAlign: "left",
                          initialIndex: 0,
                          prevNextButtons: false,
                          pageDots: true,
                          freeScroll: false,
                          wrapAround: true,
                        }
                      );
                  });
                },
                destroy: function destroy() {
                  this.$flickity.destroy();
                  this.$flickity = null;
                },
                onResize: function onResize() {
                  if (!this.$flickity) {
                    if (
                      !(0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(
                        breakpoint
                      )
                    )
                      this.init();
                  } else {
                    if (
                      (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(
                        breakpoint
                      )
                    )
                      this.destroy();
                  }
                },
              },
              mounted: function mounted() {
                var _this2 = this;
                if (
                  !(0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(breakpoint)
                )
                  this.init();
                dom_event__WEBPACK_IMPORTED_MODULE_0___default()(
                  window,
                  "resize",
                  function () {
                    _this2.onResize();
                  }
                );
              },
            });
          };

        /***/
      },

    /***/ "./src/modules/video/video.js":
      /*!************************************!*\
  !*** ./src/modules/video/video.js ***!
  \************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! dom-select */ "./node_modules/dom-select/index.js"
          );
        /* harmony import */ var dom_select__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            dom_select__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var in_viewport__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! in-viewport */ "./node_modules/in-viewport/in-viewport.js"
          );
        /* harmony import */ var in_viewport__WEBPACK_IMPORTED_MODULE_1___default =
          /*#__PURE__*/ __webpack_require__.n(
            in_viewport__WEBPACK_IMPORTED_MODULE_1__
          );
        /* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(/*! lib/util */ "./src/js/lib/util.js");

        var breakpoint = 768;
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          function (el) {
            var video =
              dom_select__WEBPACK_IMPORTED_MODULE_0___default()(
                ".js-video",
                el
              ) || false;
            if (
              video &&
              (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isOver)(breakpoint)
            ) {
              var src = video.getAttribute("data-src");
              in_viewport__WEBPACK_IMPORTED_MODULE_1___default()(
                video,
                {
                  offset: 300,
                },
                function () {
                  if ((0, lib_util__WEBPACK_IMPORTED_MODULE_2__.isFirefox)()) {
                    video.setAttribute("src", src);
                    (0, lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(
                      el,
                      "is-loaded"
                    );
                  } else {
                    window
                      .fetch(src)
                      .then(function () {
                        video.setAttribute("src", src);
                      })
                      .then(function () {
                        (0,
                        lib_util__WEBPACK_IMPORTED_MODULE_2__.set)(el, "is-loaded");
                      });
                  }
                }
              );
            }
          };

        /***/
      },

    /***/ "./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js ***!
  \*****************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ clearAllBodyScrollLocks: () =>
            /* binding */ clearAllBodyScrollLocks,
          /* harmony export */ disableBodyScroll: () =>
            /* binding */ disableBodyScroll,
          /* harmony export */ enableBodyScroll: () =>
            /* binding */ enableBodyScroll,
          /* harmony export */
        });
        function _toConsumableArray(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }
            return arr2;
          } else {
            return Array.from(arr);
          }
        }

        // Older browsers don't support event options, feature detect it.

        // Adopted and modified solution from Bohdan Didukh (2017)
        // https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

        var hasPassiveEvents = false;
        if (typeof window !== "undefined") {
          var passiveTestOptions = {
            get passive() {
              hasPassiveEvents = true;
              return undefined;
            },
          };
          window.addEventListener("testPassive", null, passiveTestOptions);
          window.removeEventListener("testPassive", null, passiveTestOptions);
        }

        var isIosDevice =
          typeof window !== "undefined" &&
          window.navigator &&
          window.navigator.platform &&
          (/iP(ad|hone|od)/.test(window.navigator.platform) ||
            (window.navigator.platform === "MacIntel" &&
              window.navigator.maxTouchPoints > 1));

        var locks = [];
        var documentListenerAdded = false;
        var initialClientY = -1;
        var previousBodyOverflowSetting = void 0;
        var previousBodyPosition = void 0;
        var previousBodyPaddingRight = void 0;

        // returns true if `el` should be allowed to receive touchmove events.
        var allowTouchMove = function allowTouchMove(el) {
          return locks.some(function (lock) {
            if (
              lock.options.allowTouchMove &&
              lock.options.allowTouchMove(el)
            ) {
              return true;
            }

            return false;
          });
        };

        var preventDefault = function preventDefault(rawEvent) {
          var e = rawEvent || window.event;

          // For the case whereby consumers adds a touchmove event listener to document.
          // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
          // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
          // the touchmove event on document will break.
          if (allowTouchMove(e.target)) {
            return true;
          }

          // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
          if (e.touches.length > 1) return true;

          if (e.preventDefault) e.preventDefault();

          return false;
        };

        var setOverflowHidden = function setOverflowHidden(options) {
          // If previousBodyPaddingRight is already set, don't set it again.
          if (previousBodyPaddingRight === undefined) {
            var _reserveScrollBarGap =
              !!options && options.reserveScrollBarGap === true;
            var scrollBarGap =
              window.innerWidth - document.documentElement.clientWidth;

            if (_reserveScrollBarGap && scrollBarGap > 0) {
              var computedBodyPaddingRight = parseInt(
                window
                  .getComputedStyle(document.body)
                  .getPropertyValue("padding-right"),
                10
              );
              previousBodyPaddingRight = document.body.style.paddingRight;
              document.body.style.paddingRight =
                computedBodyPaddingRight + scrollBarGap + "px";
            }
          }

          // If previousBodyOverflowSetting is already set, don't set it again.
          if (previousBodyOverflowSetting === undefined) {
            previousBodyOverflowSetting = document.body.style.overflow;
            document.body.style.overflow = "hidden";
          }
        };

        var restoreOverflowSetting = function restoreOverflowSetting() {
          if (previousBodyPaddingRight !== undefined) {
            document.body.style.paddingRight = previousBodyPaddingRight;

            // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
            // can be set again.
            previousBodyPaddingRight = undefined;
          }

          if (previousBodyOverflowSetting !== undefined) {
            document.body.style.overflow = previousBodyOverflowSetting;

            // Restore previousBodyOverflowSetting to undefined
            // so setOverflowHidden knows it can be set again.
            previousBodyOverflowSetting = undefined;
          }
        };

        var setPositionFixed = function setPositionFixed() {
          return window.requestAnimationFrame(function () {
            // If previousBodyPosition is already set, don't set it again.
            if (previousBodyPosition === undefined) {
              previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left,
              };

              // Update the dom inside an animation frame
              var _window = window,
                scrollY = _window.scrollY,
                scrollX = _window.scrollX,
                innerHeight = _window.innerHeight;

              document.body.style.position = "fixed";
              document.body.style.top = -scrollY;
              document.body.style.left = -scrollX;

              setTimeout(function () {
                return window.requestAnimationFrame(function () {
                  // Attempt to check if the bottom bar appeared due to the position change
                  var bottomBarHeight = innerHeight - window.innerHeight;
                  if (bottomBarHeight && scrollY >= innerHeight) {
                    // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                  }
                });
              }, 300);
            }
          });
        };

        var restorePositionSetting = function restorePositionSetting() {
          if (previousBodyPosition !== undefined) {
            // Convert the position from "px" to Int
            var y = -parseInt(document.body.style.top, 10);
            var x = -parseInt(document.body.style.left, 10);

            // Restore styles
            document.body.style.position = previousBodyPosition.position;
            document.body.style.top = previousBodyPosition.top;
            document.body.style.left = previousBodyPosition.left;

            // Restore scroll
            window.scrollTo(x, y);

            previousBodyPosition = undefined;
          }
        };

        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
        var isTargetElementTotallyScrolled =
          function isTargetElementTotallyScrolled(targetElement) {
            return targetElement
              ? targetElement.scrollHeight - targetElement.scrollTop <=
                  targetElement.clientHeight
              : false;
          };

        var handleScroll = function handleScroll(event, targetElement) {
          var clientY = event.targetTouches[0].clientY - initialClientY;

          if (allowTouchMove(event.target)) {
            return false;
          }

          if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
            // element is at the top of its scroll.
            return preventDefault(event);
          }

          if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
            // element is at the bottom of its scroll.
            return preventDefault(event);
          }

          event.stopPropagation();
          return true;
        };

        var disableBodyScroll = function disableBodyScroll(
          targetElement,
          options
        ) {
          // targetElement must be provided
          if (!targetElement) {
            // eslint-disable-next-line no-console
            console.error(
              "disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices."
            );
            return;
          }

          // disableBodyScroll must not have been called on this targetElement before
          if (
            locks.some(function (lock) {
              return lock.targetElement === targetElement;
            })
          ) {
            return;
          }

          var lock = {
            targetElement: targetElement,
            options: options || {},
          };

          locks = [].concat(_toConsumableArray(locks), [lock]);

          if (isIosDevice) {
            setPositionFixed();
          } else {
            setOverflowHidden(options);
          }

          if (isIosDevice) {
            targetElement.ontouchstart = function (event) {
              if (event.targetTouches.length === 1) {
                // detect single touch.
                initialClientY = event.targetTouches[0].clientY;
              }
            };
            targetElement.ontouchmove = function (event) {
              if (event.targetTouches.length === 1) {
                // detect single touch.
                handleScroll(event, targetElement);
              }
            };

            if (!documentListenerAdded) {
              document.addEventListener(
                "touchmove",
                preventDefault,
                hasPassiveEvents ? { passive: false } : undefined
              );
              documentListenerAdded = true;
            }
          }
        };

        var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
          if (isIosDevice) {
            // Clear all locks ontouchstart/ontouchmove handlers, and the references.
            locks.forEach(function (lock) {
              lock.targetElement.ontouchstart = null;
              lock.targetElement.ontouchmove = null;
            });

            if (documentListenerAdded) {
              document.removeEventListener(
                "touchmove",
                preventDefault,
                hasPassiveEvents ? { passive: false } : undefined
              );
              documentListenerAdded = false;
            }

            // Reset initial clientY.
            initialClientY = -1;
          }

          if (isIosDevice) {
            restorePositionSetting();
          } else {
            restoreOverflowSetting();
          }

          locks = [];
        };

        var enableBodyScroll = function enableBodyScroll(targetElement) {
          if (!targetElement) {
            // eslint-disable-next-line no-console
            console.error(
              "enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices."
            );
            return;
          }

          locks = locks.filter(function (lock) {
            return lock.targetElement !== targetElement;
          });

          if (isIosDevice) {
            targetElement.ontouchstart = null;
            targetElement.ontouchmove = null;

            if (documentListenerAdded && locks.length === 0) {
              document.removeEventListener(
                "touchmove",
                preventDefault,
                hasPassiveEvents ? { passive: false } : undefined
              );
              documentListenerAdded = false;
            }
          }

          if (isIosDevice) {
            restorePositionSetting();
          } else {
            restoreOverflowSetting();
          }
        };

        /***/
      },

    /***/ "./node_modules/choices.js/public/assets/scripts/choices.js":
      /*!******************************************************************!*\
  !*** ./node_modules/choices.js/public/assets/scripts/choices.js ***!
  \******************************************************************/
      /***/ (module) => {
        /*! choices.js v10.2.0 | © 2022 Josh Johnson | https://github.com/jshjohnson/Choices#readme */
        (function webpackUniversalModuleDefinition(root, factory) {
          if (true) module.exports = factory();
          else {
          }
        })(window, function () {
          return /******/ (function () {
            // webpackBootstrap
            /******/ "use strict";
            /******/ var __webpack_modules__ = {
              /***/ 282: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_632__
              ) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.clearChoices =
                  exports.activateChoices =
                  exports.filterChoices =
                  exports.addChoice =
                    void 0;
                var constants_1 = __nested_webpack_require_632__(883);
                var addChoice = function (_a) {
                  var value = _a.value,
                    label = _a.label,
                    id = _a.id,
                    groupId = _a.groupId,
                    disabled = _a.disabled,
                    elementId = _a.elementId,
                    customProperties = _a.customProperties,
                    placeholder = _a.placeholder,
                    keyCode = _a.keyCode;
                  return {
                    type: constants_1.ACTION_TYPES.ADD_CHOICE,
                    value: value,
                    label: label,
                    id: id,
                    groupId: groupId,
                    disabled: disabled,
                    elementId: elementId,
                    customProperties: customProperties,
                    placeholder: placeholder,
                    keyCode: keyCode,
                  };
                };
                exports.addChoice = addChoice;
                var filterChoices = function (results) {
                  return {
                    type: constants_1.ACTION_TYPES.FILTER_CHOICES,
                    results: results,
                  };
                };
                exports.filterChoices = filterChoices;
                var activateChoices = function (active) {
                  if (active === void 0) {
                    active = true;
                  }
                  return {
                    type: constants_1.ACTION_TYPES.ACTIVATE_CHOICES,
                    active: active,
                  };
                };
                exports.activateChoices = activateChoices;
                var clearChoices = function () {
                  return {
                    type: constants_1.ACTION_TYPES.CLEAR_CHOICES,
                  };
                };
                exports.clearChoices = clearChoices;

                /***/
              },

              /***/ 783: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_2068__
              ) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.addGroup = void 0;
                var constants_1 = __nested_webpack_require_2068__(883);
                var addGroup = function (_a) {
                  var value = _a.value,
                    id = _a.id,
                    active = _a.active,
                    disabled = _a.disabled;
                  return {
                    type: constants_1.ACTION_TYPES.ADD_GROUP,
                    value: value,
                    id: id,
                    active: active,
                    disabled: disabled,
                  };
                };
                exports.addGroup = addGroup;

                /***/
              },

              /***/ 464: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_2595__
              ) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.highlightItem =
                  exports.removeItem =
                  exports.addItem =
                    void 0;
                var constants_1 = __nested_webpack_require_2595__(883);
                var addItem = function (_a) {
                  var value = _a.value,
                    label = _a.label,
                    id = _a.id,
                    choiceId = _a.choiceId,
                    groupId = _a.groupId,
                    customProperties = _a.customProperties,
                    placeholder = _a.placeholder,
                    keyCode = _a.keyCode;
                  return {
                    type: constants_1.ACTION_TYPES.ADD_ITEM,
                    value: value,
                    label: label,
                    id: id,
                    choiceId: choiceId,
                    groupId: groupId,
                    customProperties: customProperties,
                    placeholder: placeholder,
                    keyCode: keyCode,
                  };
                };
                exports.addItem = addItem;
                var removeItem = function (id, choiceId) {
                  return {
                    type: constants_1.ACTION_TYPES.REMOVE_ITEM,
                    id: id,
                    choiceId: choiceId,
                  };
                };
                exports.removeItem = removeItem;
                var highlightItem = function (id, highlighted) {
                  return {
                    type: constants_1.ACTION_TYPES.HIGHLIGHT_ITEM,
                    id: id,
                    highlighted: highlighted,
                  };
                };
                exports.highlightItem = highlightItem;

                /***/
              },

              /***/ 137: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_3779__
              ) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.setIsLoading =
                  exports.resetTo =
                  exports.clearAll =
                    void 0;
                var constants_1 = __nested_webpack_require_3779__(883);
                var clearAll = function () {
                  return {
                    type: constants_1.ACTION_TYPES.CLEAR_ALL,
                  };
                };
                exports.clearAll = clearAll;
                var resetTo = function (state) {
                  return {
                    type: constants_1.ACTION_TYPES.RESET_TO,
                    state: state,
                  };
                };
                exports.resetTo = resetTo;
                var setIsLoading = function (isLoading) {
                  return {
                    type: constants_1.ACTION_TYPES.SET_IS_LOADING,
                    isLoading: isLoading,
                  };
                };
                exports.setIsLoading = setIsLoading;

                /***/
              },

              /***/ 373: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_4494__
              ) {
                var __spreadArray =
                  (this && this.__spreadArray) ||
                  function (to, from, pack) {
                    if (pack || arguments.length === 2)
                      for (var i = 0, l = from.length, ar; i < l; i++) {
                        if (ar || !(i in from)) {
                          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                          ar[i] = from[i];
                        }
                      }
                    return to.concat(ar || Array.prototype.slice.call(from));
                  };
                var __importDefault =
                  (this && this.__importDefault) ||
                  function (mod) {
                    return mod && mod.__esModule
                      ? mod
                      : {
                          default: mod,
                        };
                  };
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                var deepmerge_1 = __importDefault(
                  __nested_webpack_require_4494__(996)
                );
                /* eslint-disable @typescript-eslint/no-explicit-any */
                var fuse_js_1 = __importDefault(
                  __nested_webpack_require_4494__(221)
                );
                var choices_1 = __nested_webpack_require_4494__(282);
                var groups_1 = __nested_webpack_require_4494__(783);
                var items_1 = __nested_webpack_require_4494__(464);
                var misc_1 = __nested_webpack_require_4494__(137);
                var components_1 = __nested_webpack_require_4494__(520);
                var constants_1 = __nested_webpack_require_4494__(883);
                var defaults_1 = __nested_webpack_require_4494__(789);
                var utils_1 = __nested_webpack_require_4494__(799);
                var reducers_1 = __nested_webpack_require_4494__(655);
                var store_1 = __importDefault(
                  __nested_webpack_require_4494__(744)
                );
                var templates_1 = __importDefault(
                  __nested_webpack_require_4494__(686)
                );
                /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */
                var IS_IE11 =
                  "-ms-scroll-limit" in document.documentElement.style &&
                  "-ms-ime-align" in document.documentElement.style;
                var USER_DEFAULTS = {};
                /**
                 * Choices
                 * @author Josh Johnson<josh@joshuajohnson.co.uk>
                 */
                var Choices = /** @class */ (function () {
                  function Choices(element, userConfig) {
                    if (element === void 0) {
                      element = "[data-choice]";
                    }
                    if (userConfig === void 0) {
                      userConfig = {};
                    }
                    var _this = this;
                    if (userConfig.allowHTML === undefined) {
                      console.warn(
                        "Deprecation warning: allowHTML will default to false in a future release. To render HTML in Choices, you will need to set it to true. Setting allowHTML will suppress this message."
                      );
                    }
                    this.config = deepmerge_1.default.all(
                      [
                        defaults_1.DEFAULT_CONFIG,
                        Choices.defaults.options,
                        userConfig,
                      ],
                      // When merging array configs, replace with a copy of the userConfig array,
                      // instead of concatenating with the default array
                      {
                        arrayMerge: function (_, sourceArray) {
                          return __spreadArray([], sourceArray, true);
                        },
                      }
                    );
                    var invalidConfigOptions = (0, utils_1.diff)(
                      this.config,
                      defaults_1.DEFAULT_CONFIG
                    );
                    if (invalidConfigOptions.length) {
                      console.warn(
                        "Unknown config option(s) passed",
                        invalidConfigOptions.join(", ")
                      );
                    }
                    var passedElement =
                      typeof element === "string"
                        ? document.querySelector(element)
                        : element;
                    if (
                      !(
                        passedElement instanceof HTMLInputElement ||
                        passedElement instanceof HTMLSelectElement
                      )
                    ) {
                      throw TypeError(
                        "Expected one of the following types text|select-one|select-multiple"
                      );
                    }
                    this._isTextElement =
                      passedElement.type === constants_1.TEXT_TYPE;
                    this._isSelectOneElement =
                      passedElement.type === constants_1.SELECT_ONE_TYPE;
                    this._isSelectMultipleElement =
                      passedElement.type === constants_1.SELECT_MULTIPLE_TYPE;
                    this._isSelectElement =
                      this._isSelectOneElement || this._isSelectMultipleElement;
                    this.config.searchEnabled =
                      this._isSelectMultipleElement ||
                      this.config.searchEnabled;
                    if (
                      !["auto", "always"].includes(
                        "".concat(this.config.renderSelectedChoices)
                      )
                    ) {
                      this.config.renderSelectedChoices = "auto";
                    }
                    if (
                      userConfig.addItemFilter &&
                      typeof userConfig.addItemFilter !== "function"
                    ) {
                      var re =
                        userConfig.addItemFilter instanceof RegExp
                          ? userConfig.addItemFilter
                          : new RegExp(userConfig.addItemFilter);
                      this.config.addItemFilter = re.test.bind(re);
                    }
                    if (this._isTextElement) {
                      this.passedElement = new components_1.WrappedInput({
                        element: passedElement,
                        classNames: this.config.classNames,
                        delimiter: this.config.delimiter,
                      });
                    } else {
                      this.passedElement = new components_1.WrappedSelect({
                        element: passedElement,
                        classNames: this.config.classNames,
                        template: function (data) {
                          return _this._templates.option(data);
                        },
                      });
                    }
                    this.initialised = false;
                    this._store = new store_1.default();
                    this._initialState = reducers_1.defaultState;
                    this._currentState = reducers_1.defaultState;
                    this._prevState = reducers_1.defaultState;
                    this._currentValue = "";
                    this._canSearch = !!this.config.searchEnabled;
                    this._isScrollingOnIe = false;
                    this._highlightPosition = 0;
                    this._wasTap = true;
                    this._placeholderValue = this._generatePlaceholderValue();
                    this._baseId = (0, utils_1.generateId)(
                      this.passedElement.element,
                      "choices-"
                    );
                    /**
                     * setting direction in cases where it's explicitly set on passedElement
                     * or when calculated direction is different from the document
                     */
                    this._direction = this.passedElement.dir;
                    if (!this._direction) {
                      var elementDirection = window.getComputedStyle(
                        this.passedElement.element
                      ).direction;
                      var documentDirection = window.getComputedStyle(
                        document.documentElement
                      ).direction;
                      if (elementDirection !== documentDirection) {
                        this._direction = elementDirection;
                      }
                    }
                    this._idNames = {
                      itemChoice: "item-choice",
                    };
                    if (this._isSelectElement) {
                      // Assign preset groups from passed element
                      this._presetGroups = this.passedElement.optionGroups;
                      // Assign preset options from passed element
                      this._presetOptions = this.passedElement.options;
                    }
                    // Assign preset choices from passed object
                    this._presetChoices = this.config.choices;
                    // Assign preset items from passed object first
                    this._presetItems = this.config.items;
                    // Add any values passed from attribute
                    if (this.passedElement.value && this._isTextElement) {
                      var splitValues = this.passedElement.value.split(
                        this.config.delimiter
                      );
                      this._presetItems = this._presetItems.concat(splitValues);
                    }
                    // Create array of choices from option elements
                    if (this.passedElement.options) {
                      this.passedElement.options.forEach(function (option) {
                        _this._presetChoices.push({
                          value: option.value,
                          label: option.innerHTML,
                          selected: !!option.selected,
                          disabled:
                            option.disabled || option.parentNode.disabled,
                          placeholder:
                            option.value === "" ||
                            option.hasAttribute("placeholder"),
                          customProperties: (0, utils_1.parseCustomProperties)(
                            option.dataset.customProperties
                          ),
                        });
                      });
                    }
                    this._render = this._render.bind(this);
                    this._onFocus = this._onFocus.bind(this);
                    this._onBlur = this._onBlur.bind(this);
                    this._onKeyUp = this._onKeyUp.bind(this);
                    this._onKeyDown = this._onKeyDown.bind(this);
                    this._onClick = this._onClick.bind(this);
                    this._onTouchMove = this._onTouchMove.bind(this);
                    this._onTouchEnd = this._onTouchEnd.bind(this);
                    this._onMouseDown = this._onMouseDown.bind(this);
                    this._onMouseOver = this._onMouseOver.bind(this);
                    this._onFormReset = this._onFormReset.bind(this);
                    this._onSelectKey = this._onSelectKey.bind(this);
                    this._onEnterKey = this._onEnterKey.bind(this);
                    this._onEscapeKey = this._onEscapeKey.bind(this);
                    this._onDirectionKey = this._onDirectionKey.bind(this);
                    this._onDeleteKey = this._onDeleteKey.bind(this);
                    // If element has already been initialised with Choices, fail silently
                    if (this.passedElement.isActive) {
                      if (!this.config.silent) {
                        console.warn(
                          "Trying to initialise Choices on element already initialised",
                          {
                            element: element,
                          }
                        );
                      }
                      this.initialised = true;
                      return;
                    }
                    // Let's go
                    this.init();
                  }
                  Object.defineProperty(Choices, "defaults", {
                    get: function () {
                      return Object.preventExtensions({
                        get options() {
                          return USER_DEFAULTS;
                        },
                        get templates() {
                          return templates_1.default;
                        },
                      });
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Choices.prototype.init = function () {
                    if (this.initialised) {
                      return;
                    }
                    this._createTemplates();
                    this._createElements();
                    this._createStructure();
                    this._store.subscribe(this._render);
                    this._render();
                    this._addEventListeners();
                    var shouldDisable =
                      !this.config.addItems ||
                      this.passedElement.element.hasAttribute("disabled");
                    if (shouldDisable) {
                      this.disable();
                    }
                    this.initialised = true;
                    var callbackOnInit = this.config.callbackOnInit;
                    // Run callback if it is a function
                    if (
                      callbackOnInit &&
                      typeof callbackOnInit === "function"
                    ) {
                      callbackOnInit.call(this);
                    }
                  };
                  Choices.prototype.destroy = function () {
                    if (!this.initialised) {
                      return;
                    }
                    this._removeEventListeners();
                    this.passedElement.reveal();
                    this.containerOuter.unwrap(this.passedElement.element);
                    this.clearStore();
                    if (this._isSelectElement) {
                      this.passedElement.options = this._presetOptions;
                    }
                    this._templates = templates_1.default;
                    this.initialised = false;
                  };
                  Choices.prototype.enable = function () {
                    if (this.passedElement.isDisabled) {
                      this.passedElement.enable();
                    }
                    if (this.containerOuter.isDisabled) {
                      this._addEventListeners();
                      this.input.enable();
                      this.containerOuter.enable();
                    }
                    return this;
                  };
                  Choices.prototype.disable = function () {
                    if (!this.passedElement.isDisabled) {
                      this.passedElement.disable();
                    }
                    if (!this.containerOuter.isDisabled) {
                      this._removeEventListeners();
                      this.input.disable();
                      this.containerOuter.disable();
                    }
                    return this;
                  };
                  Choices.prototype.highlightItem = function (item, runEvent) {
                    if (runEvent === void 0) {
                      runEvent = true;
                    }
                    if (!item || !item.id) {
                      return this;
                    }
                    var id = item.id,
                      _a = item.groupId,
                      groupId = _a === void 0 ? -1 : _a,
                      _b = item.value,
                      value = _b === void 0 ? "" : _b,
                      _c = item.label,
                      label = _c === void 0 ? "" : _c;
                    var group =
                      groupId >= 0 ? this._store.getGroupById(groupId) : null;
                    this._store.dispatch((0, items_1.highlightItem)(id, true));
                    if (runEvent) {
                      this.passedElement.triggerEvent(
                        constants_1.EVENTS.highlightItem,
                        {
                          id: id,
                          value: value,
                          label: label,
                          groupValue: group && group.value ? group.value : null,
                        }
                      );
                    }
                    return this;
                  };
                  Choices.prototype.unhighlightItem = function (item) {
                    if (!item || !item.id) {
                      return this;
                    }
                    var id = item.id,
                      _a = item.groupId,
                      groupId = _a === void 0 ? -1 : _a,
                      _b = item.value,
                      value = _b === void 0 ? "" : _b,
                      _c = item.label,
                      label = _c === void 0 ? "" : _c;
                    var group =
                      groupId >= 0 ? this._store.getGroupById(groupId) : null;
                    this._store.dispatch((0, items_1.highlightItem)(id, false));
                    this.passedElement.triggerEvent(
                      constants_1.EVENTS.highlightItem,
                      {
                        id: id,
                        value: value,
                        label: label,
                        groupValue: group && group.value ? group.value : null,
                      }
                    );
                    return this;
                  };
                  Choices.prototype.highlightAll = function () {
                    var _this = this;
                    this._store.items.forEach(function (item) {
                      return _this.highlightItem(item);
                    });
                    return this;
                  };
                  Choices.prototype.unhighlightAll = function () {
                    var _this = this;
                    this._store.items.forEach(function (item) {
                      return _this.unhighlightItem(item);
                    });
                    return this;
                  };
                  Choices.prototype.removeActiveItemsByValue = function (
                    value
                  ) {
                    var _this = this;
                    this._store.activeItems
                      .filter(function (item) {
                        return item.value === value;
                      })
                      .forEach(function (item) {
                        return _this._removeItem(item);
                      });
                    return this;
                  };
                  Choices.prototype.removeActiveItems = function (excludedId) {
                    var _this = this;
                    this._store.activeItems
                      .filter(function (_a) {
                        var id = _a.id;
                        return id !== excludedId;
                      })
                      .forEach(function (item) {
                        return _this._removeItem(item);
                      });
                    return this;
                  };
                  Choices.prototype.removeHighlightedItems = function (
                    runEvent
                  ) {
                    var _this = this;
                    if (runEvent === void 0) {
                      runEvent = false;
                    }
                    this._store.highlightedActiveItems.forEach(function (item) {
                      _this._removeItem(item);
                      // If this action was performed by the user
                      // trigger the event
                      if (runEvent) {
                        _this._triggerChange(item.value);
                      }
                    });
                    return this;
                  };
                  Choices.prototype.showDropdown = function (
                    preventInputFocus
                  ) {
                    var _this = this;
                    if (this.dropdown.isActive) {
                      return this;
                    }
                    requestAnimationFrame(function () {
                      _this.dropdown.show();
                      _this.containerOuter.open(
                        _this.dropdown.distanceFromTopWindow
                      );
                      if (!preventInputFocus && _this._canSearch) {
                        _this.input.focus();
                      }
                      _this.passedElement.triggerEvent(
                        constants_1.EVENTS.showDropdown,
                        {}
                      );
                    });
                    return this;
                  };
                  Choices.prototype.hideDropdown = function (preventInputBlur) {
                    var _this = this;
                    if (!this.dropdown.isActive) {
                      return this;
                    }
                    requestAnimationFrame(function () {
                      _this.dropdown.hide();
                      _this.containerOuter.close();
                      if (!preventInputBlur && _this._canSearch) {
                        _this.input.removeActiveDescendant();
                        _this.input.blur();
                      }
                      _this.passedElement.triggerEvent(
                        constants_1.EVENTS.hideDropdown,
                        {}
                      );
                    });
                    return this;
                  };
                  Choices.prototype.getValue = function (valueOnly) {
                    if (valueOnly === void 0) {
                      valueOnly = false;
                    }
                    var values = this._store.activeItems.reduce(function (
                      selectedItems,
                      item
                    ) {
                      var itemValue = valueOnly ? item.value : item;
                      selectedItems.push(itemValue);
                      return selectedItems;
                    },
                    []);
                    return this._isSelectOneElement ? values[0] : values;
                  };
                  Choices.prototype.setValue = function (items) {
                    var _this = this;
                    if (!this.initialised) {
                      return this;
                    }
                    items.forEach(function (value) {
                      return _this._setChoiceOrItem(value);
                    });
                    return this;
                  };
                  Choices.prototype.setChoiceByValue = function (value) {
                    var _this = this;
                    if (!this.initialised || this._isTextElement) {
                      return this;
                    }
                    // If only one value has been passed, convert to array
                    var choiceValue = Array.isArray(value) ? value : [value];
                    // Loop through each value and
                    choiceValue.forEach(function (val) {
                      return _this._findAndSelectChoiceByValue(val);
                    });
                    return this;
                  };
                  /**
                   * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
                   * a value field name and a label field name.
                   * This behaves the same as passing items via the choices option but can be called after initialising Choices.
                   * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
                   * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
                   *
                   * **Input types affected:** select-one, select-multiple
                   *
                   * @example
                   * ```js
                   * const example = new Choices(element);
                   *
                   * example.setChoices([
                   *   {value: 'One', label: 'Label One', disabled: true},
                   *   {value: 'Two', label: 'Label Two', selected: true},
                   *   {value: 'Three', label: 'Label Three'},
                   * ], 'value', 'label', false);
                   * ```
                   *
                   * @example
                   * ```js
                   * const example = new Choices(element);
                   *
                   * example.setChoices(async () => {
                   *   try {
                   *      const items = await fetch('/items');
                   *      return items.json()
                   *   } catch(err) {
                   *      console.error(err)
                   *   }
                   * });
                   * ```
                   *
                   * @example
                   * ```js
                   * const example = new Choices(element);
                   *
                   * example.setChoices([{
                   *   label: 'Group one',
                   *   id: 1,
                   *   disabled: false,
                   *   choices: [
                   *     {value: 'Child One', label: 'Child One', selected: true},
                   *     {value: 'Child Two', label: 'Child Two',  disabled: true},
                   *     {value: 'Child Three', label: 'Child Three'},
                   *   ]
                   * },
                   * {
                   *   label: 'Group two',
                   *   id: 2,
                   *   disabled: false,
                   *   choices: [
                   *     {value: 'Child Four', label: 'Child Four', disabled: true},
                   *     {value: 'Child Five', label: 'Child Five'},
                   *     {value: 'Child Six', label: 'Child Six', customProperties: {
                   *       description: 'Custom description about child six',
                   *       random: 'Another random custom property'
                   *     }},
                   *   ]
                   * }], 'value', 'label', false);
                   * ```
                   */
                  Choices.prototype.setChoices = function (
                    choicesArrayOrFetcher,
                    value,
                    label,
                    replaceChoices
                  ) {
                    var _this = this;
                    if (choicesArrayOrFetcher === void 0) {
                      choicesArrayOrFetcher = [];
                    }
                    if (value === void 0) {
                      value = "value";
                    }
                    if (label === void 0) {
                      label = "label";
                    }
                    if (replaceChoices === void 0) {
                      replaceChoices = false;
                    }
                    if (!this.initialised) {
                      throw new ReferenceError(
                        "setChoices was called on a non-initialized instance of Choices"
                      );
                    }
                    if (!this._isSelectElement) {
                      throw new TypeError(
                        "setChoices can't be used with INPUT based Choices"
                      );
                    }
                    if (typeof value !== "string" || !value) {
                      throw new TypeError(
                        "value parameter must be a name of 'value' field in passed objects"
                      );
                    }
                    // Clear choices if needed
                    if (replaceChoices) {
                      this.clearChoices();
                    }
                    if (typeof choicesArrayOrFetcher === "function") {
                      // it's a choices fetcher function
                      var fetcher_1 = choicesArrayOrFetcher(this);
                      if (
                        typeof Promise === "function" &&
                        fetcher_1 instanceof Promise
                      ) {
                        // that's a promise
                        // eslint-disable-next-line no-promise-executor-return
                        return new Promise(function (resolve) {
                          return requestAnimationFrame(resolve);
                        })
                          .then(function () {
                            return _this._handleLoadingState(true);
                          })
                          .then(function () {
                            return fetcher_1;
                          })
                          .then(function (data) {
                            return _this.setChoices(
                              data,
                              value,
                              label,
                              replaceChoices
                            );
                          })
                          .catch(function (err) {
                            if (!_this.config.silent) {
                              console.error(err);
                            }
                          })
                          .then(function () {
                            return _this._handleLoadingState(false);
                          })
                          .then(function () {
                            return _this;
                          });
                      }
                      // function returned something else than promise, let's check if it's an array of choices
                      if (!Array.isArray(fetcher_1)) {
                        throw new TypeError(
                          ".setChoices first argument function must return either array of choices or Promise, got: ".concat(
                            typeof fetcher_1
                          )
                        );
                      }
                      // recursion with results, it's sync and choices were cleared already
                      return this.setChoices(fetcher_1, value, label, false);
                    }
                    if (!Array.isArray(choicesArrayOrFetcher)) {
                      throw new TypeError(
                        ".setChoices must be called either with array of choices with a function resulting into Promise of array of choices"
                      );
                    }
                    this.containerOuter.removeLoadingState();
                    this._startLoading();
                    choicesArrayOrFetcher.forEach(function (groupOrChoice) {
                      if (groupOrChoice.choices) {
                        _this._addGroup({
                          id: groupOrChoice.id
                            ? parseInt("".concat(groupOrChoice.id), 10)
                            : null,
                          group: groupOrChoice,
                          valueKey: value,
                          labelKey: label,
                        });
                      } else {
                        var choice = groupOrChoice;
                        _this._addChoice({
                          value: choice[value],
                          label: choice[label],
                          isSelected: !!choice.selected,
                          isDisabled: !!choice.disabled,
                          placeholder: !!choice.placeholder,
                          customProperties: choice.customProperties,
                        });
                      }
                    });
                    this._stopLoading();
                    return this;
                  };
                  Choices.prototype.clearChoices = function () {
                    this._store.dispatch((0, choices_1.clearChoices)());
                    return this;
                  };
                  Choices.prototype.clearStore = function () {
                    this._store.dispatch((0, misc_1.clearAll)());
                    return this;
                  };
                  Choices.prototype.clearInput = function () {
                    var shouldSetInputWidth = !this._isSelectOneElement;
                    this.input.clear(shouldSetInputWidth);
                    if (!this._isTextElement && this._canSearch) {
                      this._isSearching = false;
                      this._store.dispatch(
                        (0, choices_1.activateChoices)(true)
                      );
                    }
                    return this;
                  };
                  Choices.prototype._render = function () {
                    if (this._store.isLoading()) {
                      return;
                    }
                    this._currentState = this._store.state;
                    var stateChanged =
                      this._currentState.choices !== this._prevState.choices ||
                      this._currentState.groups !== this._prevState.groups ||
                      this._currentState.items !== this._prevState.items;
                    var shouldRenderChoices = this._isSelectElement;
                    var shouldRenderItems =
                      this._currentState.items !== this._prevState.items;
                    if (!stateChanged) {
                      return;
                    }
                    if (shouldRenderChoices) {
                      this._renderChoices();
                    }
                    if (shouldRenderItems) {
                      this._renderItems();
                    }
                    this._prevState = this._currentState;
                  };
                  Choices.prototype._renderChoices = function () {
                    var _this = this;
                    var _a = this._store,
                      activeGroups = _a.activeGroups,
                      activeChoices = _a.activeChoices;
                    var choiceListFragment = document.createDocumentFragment();
                    this.choiceList.clear();
                    if (this.config.resetScrollPosition) {
                      requestAnimationFrame(function () {
                        return _this.choiceList.scrollToTop();
                      });
                    }
                    // If we have grouped options
                    if (activeGroups.length >= 1 && !this._isSearching) {
                      // If we have a placeholder choice along with groups
                      var activePlaceholders = activeChoices.filter(function (
                        activeChoice
                      ) {
                        return (
                          activeChoice.placeholder === true &&
                          activeChoice.groupId === -1
                        );
                      });
                      if (activePlaceholders.length >= 1) {
                        choiceListFragment = this._createChoicesFragment(
                          activePlaceholders,
                          choiceListFragment
                        );
                      }
                      choiceListFragment = this._createGroupsFragment(
                        activeGroups,
                        activeChoices,
                        choiceListFragment
                      );
                    } else if (activeChoices.length >= 1) {
                      choiceListFragment = this._createChoicesFragment(
                        activeChoices,
                        choiceListFragment
                      );
                    }
                    // If we have choices to show
                    if (
                      choiceListFragment.childNodes &&
                      choiceListFragment.childNodes.length > 0
                    ) {
                      var activeItems = this._store.activeItems;
                      var canAddItem = this._canAddItem(
                        activeItems,
                        this.input.value
                      );
                      // ...and we can select them
                      if (canAddItem.response) {
                        // ...append them and highlight the first choice
                        this.choiceList.append(choiceListFragment);
                        this._highlightChoice();
                      } else {
                        var notice = this._getTemplate(
                          "notice",
                          canAddItem.notice
                        );
                        this.choiceList.append(notice);
                      }
                    } else {
                      // Otherwise show a notice
                      var dropdownItem = void 0;
                      var notice = void 0;
                      if (this._isSearching) {
                        notice =
                          typeof this.config.noResultsText === "function"
                            ? this.config.noResultsText()
                            : this.config.noResultsText;
                        dropdownItem = this._getTemplate(
                          "notice",
                          notice,
                          "no-results"
                        );
                      } else {
                        notice =
                          typeof this.config.noChoicesText === "function"
                            ? this.config.noChoicesText()
                            : this.config.noChoicesText;
                        dropdownItem = this._getTemplate(
                          "notice",
                          notice,
                          "no-choices"
                        );
                      }
                      this.choiceList.append(dropdownItem);
                    }
                  };
                  Choices.prototype._renderItems = function () {
                    var activeItems = this._store.activeItems || [];
                    this.itemList.clear();
                    // Create a fragment to store our list items
                    // (so we don't have to update the DOM for each item)
                    var itemListFragment =
                      this._createItemsFragment(activeItems);
                    // If we have items to add, append them
                    if (itemListFragment.childNodes) {
                      this.itemList.append(itemListFragment);
                    }
                  };
                  Choices.prototype._createGroupsFragment = function (
                    groups,
                    choices,
                    fragment
                  ) {
                    var _this = this;
                    if (fragment === void 0) {
                      fragment = document.createDocumentFragment();
                    }
                    var getGroupChoices = function (group) {
                      return choices.filter(function (choice) {
                        if (_this._isSelectOneElement) {
                          return choice.groupId === group.id;
                        }
                        return (
                          choice.groupId === group.id &&
                          (_this.config.renderSelectedChoices === "always" ||
                            !choice.selected)
                        );
                      });
                    };
                    // If sorting is enabled, filter groups
                    if (this.config.shouldSort) {
                      groups.sort(this.config.sorter);
                    }
                    groups.forEach(function (group) {
                      var groupChoices = getGroupChoices(group);
                      if (groupChoices.length >= 1) {
                        var dropdownGroup = _this._getTemplate(
                          "choiceGroup",
                          group
                        );
                        fragment.appendChild(dropdownGroup);
                        _this._createChoicesFragment(
                          groupChoices,
                          fragment,
                          true
                        );
                      }
                    });
                    return fragment;
                  };
                  Choices.prototype._createChoicesFragment = function (
                    choices,
                    fragment,
                    withinGroup
                  ) {
                    var _this = this;
                    if (fragment === void 0) {
                      fragment = document.createDocumentFragment();
                    }
                    if (withinGroup === void 0) {
                      withinGroup = false;
                    }
                    // Create a fragment to store our list items (so we don't have to update the DOM for each item)
                    var _a = this.config,
                      renderSelectedChoices = _a.renderSelectedChoices,
                      searchResultLimit = _a.searchResultLimit,
                      renderChoiceLimit = _a.renderChoiceLimit;
                    var filter = this._isSearching
                      ? utils_1.sortByScore
                      : this.config.sorter;
                    var appendChoice = function (choice) {
                      var shouldRender =
                        renderSelectedChoices === "auto"
                          ? _this._isSelectOneElement || !choice.selected
                          : true;
                      if (shouldRender) {
                        var dropdownItem = _this._getTemplate(
                          "choice",
                          choice,
                          _this.config.itemSelectText
                        );
                        fragment.appendChild(dropdownItem);
                      }
                    };
                    var rendererableChoices = choices;
                    if (
                      renderSelectedChoices === "auto" &&
                      !this._isSelectOneElement
                    ) {
                      rendererableChoices = choices.filter(function (choice) {
                        return !choice.selected;
                      });
                    }
                    // Split array into placeholders and "normal" choices
                    var _b = rendererableChoices.reduce(
                        function (acc, choice) {
                          if (choice.placeholder) {
                            acc.placeholderChoices.push(choice);
                          } else {
                            acc.normalChoices.push(choice);
                          }
                          return acc;
                        },
                        {
                          placeholderChoices: [],
                          normalChoices: [],
                        }
                      ),
                      placeholderChoices = _b.placeholderChoices,
                      normalChoices = _b.normalChoices;
                    // If sorting is enabled or the user is searching, filter choices
                    if (this.config.shouldSort || this._isSearching) {
                      normalChoices.sort(filter);
                    }
                    var choiceLimit = rendererableChoices.length;
                    // Prepend placeholeder
                    var sortedChoices = this._isSelectOneElement
                      ? __spreadArray(
                          __spreadArray([], placeholderChoices, true),
                          normalChoices,
                          true
                        )
                      : normalChoices;
                    if (this._isSearching) {
                      choiceLimit = searchResultLimit;
                    } else if (
                      renderChoiceLimit &&
                      renderChoiceLimit > 0 &&
                      !withinGroup
                    ) {
                      choiceLimit = renderChoiceLimit;
                    }
                    // Add each choice to dropdown within range
                    for (var i = 0; i < choiceLimit; i += 1) {
                      if (sortedChoices[i]) {
                        appendChoice(sortedChoices[i]);
                      }
                    }
                    return fragment;
                  };
                  Choices.prototype._createItemsFragment = function (
                    items,
                    fragment
                  ) {
                    var _this = this;
                    if (fragment === void 0) {
                      fragment = document.createDocumentFragment();
                    }
                    // Create fragment to add elements to
                    var _a = this.config,
                      shouldSortItems = _a.shouldSortItems,
                      sorter = _a.sorter,
                      removeItemButton = _a.removeItemButton;
                    // If sorting is enabled, filter items
                    if (shouldSortItems && !this._isSelectOneElement) {
                      items.sort(sorter);
                    }
                    if (this._isTextElement) {
                      // Update the value of the hidden input
                      this.passedElement.value = items
                        .map(function (_a) {
                          var value = _a.value;
                          return value;
                        })
                        .join(this.config.delimiter);
                    } else {
                      // Update the options of the hidden input
                      this.passedElement.options = items;
                    }
                    var addItemToFragment = function (item) {
                      // Create new list element
                      var listItem = _this._getTemplate(
                        "item",
                        item,
                        removeItemButton
                      );
                      // Append it to list
                      fragment.appendChild(listItem);
                    };
                    // Add each list item to list
                    items.forEach(addItemToFragment);
                    return fragment;
                  };
                  Choices.prototype._triggerChange = function (value) {
                    if (value === undefined || value === null) {
                      return;
                    }
                    this.passedElement.triggerEvent(constants_1.EVENTS.change, {
                      value: value,
                    });
                  };
                  Choices.prototype._selectPlaceholderChoice = function (
                    placeholderChoice
                  ) {
                    this._addItem({
                      value: placeholderChoice.value,
                      label: placeholderChoice.label,
                      choiceId: placeholderChoice.id,
                      groupId: placeholderChoice.groupId,
                      placeholder: placeholderChoice.placeholder,
                    });
                    this._triggerChange(placeholderChoice.value);
                  };
                  Choices.prototype._handleButtonAction = function (
                    activeItems,
                    element
                  ) {
                    if (
                      !activeItems ||
                      !element ||
                      !this.config.removeItems ||
                      !this.config.removeItemButton
                    ) {
                      return;
                    }
                    var itemId =
                      element.parentNode && element.parentNode.dataset.id;
                    var itemToRemove =
                      itemId &&
                      activeItems.find(function (item) {
                        return item.id === parseInt(itemId, 10);
                      });
                    if (!itemToRemove) {
                      return;
                    }
                    // Remove item associated with button
                    this._removeItem(itemToRemove);
                    this._triggerChange(itemToRemove.value);
                    if (
                      this._isSelectOneElement &&
                      this._store.placeholderChoice
                    ) {
                      this._selectPlaceholderChoice(
                        this._store.placeholderChoice
                      );
                    }
                  };
                  Choices.prototype._handleItemAction = function (
                    activeItems,
                    element,
                    hasShiftKey
                  ) {
                    var _this = this;
                    if (hasShiftKey === void 0) {
                      hasShiftKey = false;
                    }
                    if (
                      !activeItems ||
                      !element ||
                      !this.config.removeItems ||
                      this._isSelectOneElement
                    ) {
                      return;
                    }
                    var passedId = element.dataset.id;
                    // We only want to select one item with a click
                    // so we deselect any items that aren't the target
                    // unless shift is being pressed
                    activeItems.forEach(function (item) {
                      if (
                        item.id === parseInt("".concat(passedId), 10) &&
                        !item.highlighted
                      ) {
                        _this.highlightItem(item);
                      } else if (!hasShiftKey && item.highlighted) {
                        _this.unhighlightItem(item);
                      }
                    });
                    // Focus input as without focus, a user cannot do anything with a
                    // highlighted item
                    this.input.focus();
                  };
                  Choices.prototype._handleChoiceAction = function (
                    activeItems,
                    element
                  ) {
                    if (!activeItems || !element) {
                      return;
                    }
                    // If we are clicking on an option
                    var id = element.dataset.id;
                    var choice = id && this._store.getChoiceById(id);
                    if (!choice) {
                      return;
                    }
                    var passedKeyCode =
                      activeItems[0] && activeItems[0].keyCode
                        ? activeItems[0].keyCode
                        : undefined;
                    var hasActiveDropdown = this.dropdown.isActive;
                    // Update choice keyCode
                    choice.keyCode = passedKeyCode;
                    this.passedElement.triggerEvent(constants_1.EVENTS.choice, {
                      choice: choice,
                    });
                    if (!choice.selected && !choice.disabled) {
                      var canAddItem = this._canAddItem(
                        activeItems,
                        choice.value
                      );
                      if (canAddItem.response) {
                        this._addItem({
                          value: choice.value,
                          label: choice.label,
                          choiceId: choice.id,
                          groupId: choice.groupId,
                          customProperties: choice.customProperties,
                          placeholder: choice.placeholder,
                          keyCode: choice.keyCode,
                        });
                        this._triggerChange(choice.value);
                      }
                    }
                    this.clearInput();
                    // We want to close the dropdown if we are dealing with a single select box
                    if (hasActiveDropdown && this._isSelectOneElement) {
                      this.hideDropdown(true);
                      this.containerOuter.focus();
                    }
                  };
                  Choices.prototype._handleBackspace = function (activeItems) {
                    if (!this.config.removeItems || !activeItems) {
                      return;
                    }
                    var lastItem = activeItems[activeItems.length - 1];
                    var hasHighlightedItems = activeItems.some(function (item) {
                      return item.highlighted;
                    });
                    // If editing the last item is allowed and there are not other selected items,
                    // we can edit the item value. Otherwise if we can remove items, remove all selected items
                    if (
                      this.config.editItems &&
                      !hasHighlightedItems &&
                      lastItem
                    ) {
                      this.input.value = lastItem.value;
                      this.input.setWidth();
                      this._removeItem(lastItem);
                      this._triggerChange(lastItem.value);
                    } else {
                      if (!hasHighlightedItems) {
                        // Highlight last item if none already highlighted
                        this.highlightItem(lastItem, false);
                      }
                      this.removeHighlightedItems(true);
                    }
                  };
                  Choices.prototype._startLoading = function () {
                    this._store.dispatch((0, misc_1.setIsLoading)(true));
                  };
                  Choices.prototype._stopLoading = function () {
                    this._store.dispatch((0, misc_1.setIsLoading)(false));
                  };
                  Choices.prototype._handleLoadingState = function (
                    setLoading
                  ) {
                    if (setLoading === void 0) {
                      setLoading = true;
                    }
                    var placeholderItem = this.itemList.getChild(
                      ".".concat(this.config.classNames.placeholder)
                    );
                    if (setLoading) {
                      this.disable();
                      this.containerOuter.addLoadingState();
                      if (this._isSelectOneElement) {
                        if (!placeholderItem) {
                          placeholderItem = this._getTemplate(
                            "placeholder",
                            this.config.loadingText
                          );
                          if (placeholderItem) {
                            this.itemList.append(placeholderItem);
                          }
                        } else {
                          placeholderItem.innerHTML = this.config.loadingText;
                        }
                      } else {
                        this.input.placeholder = this.config.loadingText;
                      }
                    } else {
                      this.enable();
                      this.containerOuter.removeLoadingState();
                      if (this._isSelectOneElement) {
                        if (placeholderItem) {
                          placeholderItem.innerHTML =
                            this._placeholderValue || "";
                        }
                      } else {
                        this.input.placeholder = this._placeholderValue || "";
                      }
                    }
                  };
                  Choices.prototype._handleSearch = function (value) {
                    if (!this.input.isFocussed) {
                      return;
                    }
                    var choices = this._store.choices;
                    var _a = this.config,
                      searchFloor = _a.searchFloor,
                      searchChoices = _a.searchChoices;
                    var hasUnactiveChoices = choices.some(function (option) {
                      return !option.active;
                    });
                    // Check that we have a value to search and the input was an alphanumeric character
                    if (
                      value !== null &&
                      typeof value !== "undefined" &&
                      value.length >= searchFloor
                    ) {
                      var resultCount = searchChoices
                        ? this._searchChoices(value)
                        : 0;
                      // Trigger search event
                      this.passedElement.triggerEvent(
                        constants_1.EVENTS.search,
                        {
                          value: value,
                          resultCount: resultCount,
                        }
                      );
                    } else if (hasUnactiveChoices) {
                      // Otherwise reset choices to active
                      this._isSearching = false;
                      this._store.dispatch(
                        (0, choices_1.activateChoices)(true)
                      );
                    }
                  };
                  Choices.prototype._canAddItem = function (
                    activeItems,
                    value
                  ) {
                    var canAddItem = true;
                    var notice =
                      typeof this.config.addItemText === "function"
                        ? this.config.addItemText(value)
                        : this.config.addItemText;
                    if (!this._isSelectOneElement) {
                      var isDuplicateValue = (0, utils_1.existsInArray)(
                        activeItems,
                        value
                      );
                      if (
                        this.config.maxItemCount > 0 &&
                        this.config.maxItemCount <= activeItems.length
                      ) {
                        // If there is a max entry limit and we have reached that limit
                        // don't update
                        canAddItem = false;
                        notice =
                          typeof this.config.maxItemText === "function"
                            ? this.config.maxItemText(this.config.maxItemCount)
                            : this.config.maxItemText;
                      }
                      if (
                        !this.config.duplicateItemsAllowed &&
                        isDuplicateValue &&
                        canAddItem
                      ) {
                        canAddItem = false;
                        notice =
                          typeof this.config.uniqueItemText === "function"
                            ? this.config.uniqueItemText(value)
                            : this.config.uniqueItemText;
                      }
                      if (
                        this._isTextElement &&
                        this.config.addItems &&
                        canAddItem &&
                        typeof this.config.addItemFilter === "function" &&
                        !this.config.addItemFilter(value)
                      ) {
                        canAddItem = false;
                        notice =
                          typeof this.config.customAddItemText === "function"
                            ? this.config.customAddItemText(value)
                            : this.config.customAddItemText;
                      }
                    }
                    return {
                      response: canAddItem,
                      notice: notice,
                    };
                  };
                  Choices.prototype._searchChoices = function (value) {
                    var newValue =
                      typeof value === "string" ? value.trim() : value;
                    var currentValue =
                      typeof this._currentValue === "string"
                        ? this._currentValue.trim()
                        : this._currentValue;
                    if (
                      newValue.length < 1 &&
                      newValue === "".concat(currentValue, " ")
                    ) {
                      return 0;
                    }
                    // If new value matches the desired length and is not the same as the current value with a space
                    var haystack = this._store.searchableChoices;
                    var needle = newValue;
                    var options = Object.assign(this.config.fuseOptions, {
                      keys: __spreadArray([], this.config.searchFields, true),
                      includeMatches: true,
                    });
                    var fuse = new fuse_js_1.default(haystack, options);
                    var results = fuse.search(needle); // see https://github.com/krisk/Fuse/issues/303
                    this._currentValue = newValue;
                    this._highlightPosition = 0;
                    this._isSearching = true;
                    this._store.dispatch((0, choices_1.filterChoices)(results));
                    return results.length;
                  };
                  Choices.prototype._addEventListeners = function () {
                    var documentElement = document.documentElement;
                    // capture events - can cancel event processing or propagation
                    documentElement.addEventListener(
                      "touchend",
                      this._onTouchEnd,
                      true
                    );
                    this.containerOuter.element.addEventListener(
                      "keydown",
                      this._onKeyDown,
                      true
                    );
                    this.containerOuter.element.addEventListener(
                      "mousedown",
                      this._onMouseDown,
                      true
                    );
                    // passive events - doesn't call `preventDefault` or `stopPropagation`
                    documentElement.addEventListener("click", this._onClick, {
                      passive: true,
                    });
                    documentElement.addEventListener(
                      "touchmove",
                      this._onTouchMove,
                      {
                        passive: true,
                      }
                    );
                    this.dropdown.element.addEventListener(
                      "mouseover",
                      this._onMouseOver,
                      {
                        passive: true,
                      }
                    );
                    if (this._isSelectOneElement) {
                      this.containerOuter.element.addEventListener(
                        "focus",
                        this._onFocus,
                        {
                          passive: true,
                        }
                      );
                      this.containerOuter.element.addEventListener(
                        "blur",
                        this._onBlur,
                        {
                          passive: true,
                        }
                      );
                    }
                    this.input.element.addEventListener(
                      "keyup",
                      this._onKeyUp,
                      {
                        passive: true,
                      }
                    );
                    this.input.element.addEventListener(
                      "focus",
                      this._onFocus,
                      {
                        passive: true,
                      }
                    );
                    this.input.element.addEventListener("blur", this._onBlur, {
                      passive: true,
                    });
                    if (this.input.element.form) {
                      this.input.element.form.addEventListener(
                        "reset",
                        this._onFormReset,
                        {
                          passive: true,
                        }
                      );
                    }
                    this.input.addEventListeners();
                  };
                  Choices.prototype._removeEventListeners = function () {
                    var documentElement = document.documentElement;
                    documentElement.removeEventListener(
                      "touchend",
                      this._onTouchEnd,
                      true
                    );
                    this.containerOuter.element.removeEventListener(
                      "keydown",
                      this._onKeyDown,
                      true
                    );
                    this.containerOuter.element.removeEventListener(
                      "mousedown",
                      this._onMouseDown,
                      true
                    );
                    documentElement.removeEventListener("click", this._onClick);
                    documentElement.removeEventListener(
                      "touchmove",
                      this._onTouchMove
                    );
                    this.dropdown.element.removeEventListener(
                      "mouseover",
                      this._onMouseOver
                    );
                    if (this._isSelectOneElement) {
                      this.containerOuter.element.removeEventListener(
                        "focus",
                        this._onFocus
                      );
                      this.containerOuter.element.removeEventListener(
                        "blur",
                        this._onBlur
                      );
                    }
                    this.input.element.removeEventListener(
                      "keyup",
                      this._onKeyUp
                    );
                    this.input.element.removeEventListener(
                      "focus",
                      this._onFocus
                    );
                    this.input.element.removeEventListener(
                      "blur",
                      this._onBlur
                    );
                    if (this.input.element.form) {
                      this.input.element.form.removeEventListener(
                        "reset",
                        this._onFormReset
                      );
                    }
                    this.input.removeEventListeners();
                  };
                  Choices.prototype._onKeyDown = function (event) {
                    var keyCode = event.keyCode;
                    var activeItems = this._store.activeItems;
                    var hasFocusedInput = this.input.isFocussed;
                    var hasActiveDropdown = this.dropdown.isActive;
                    var hasItems = this.itemList.hasChildren();
                    var keyString = String.fromCharCode(keyCode);
                    // eslint-disable-next-line no-control-regex
                    var wasPrintableChar = /[^\x00-\x1F]/.test(keyString);
                    var BACK_KEY = constants_1.KEY_CODES.BACK_KEY,
                      DELETE_KEY = constants_1.KEY_CODES.DELETE_KEY,
                      ENTER_KEY = constants_1.KEY_CODES.ENTER_KEY,
                      A_KEY = constants_1.KEY_CODES.A_KEY,
                      ESC_KEY = constants_1.KEY_CODES.ESC_KEY,
                      UP_KEY = constants_1.KEY_CODES.UP_KEY,
                      DOWN_KEY = constants_1.KEY_CODES.DOWN_KEY,
                      PAGE_UP_KEY = constants_1.KEY_CODES.PAGE_UP_KEY,
                      PAGE_DOWN_KEY = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                    if (
                      !this._isTextElement &&
                      !hasActiveDropdown &&
                      wasPrintableChar
                    ) {
                      this.showDropdown();
                      if (!this.input.isFocussed) {
                        /*
          We update the input value with the pressed key as
          the input was not focussed at the time of key press
          therefore does not have the value of the key.
        */
                        this.input.value += event.key.toLowerCase();
                      }
                    }
                    switch (keyCode) {
                      case A_KEY:
                        return this._onSelectKey(event, hasItems);
                      case ENTER_KEY:
                        return this._onEnterKey(
                          event,
                          activeItems,
                          hasActiveDropdown
                        );
                      case ESC_KEY:
                        return this._onEscapeKey(hasActiveDropdown);
                      case UP_KEY:
                      case PAGE_UP_KEY:
                      case DOWN_KEY:
                      case PAGE_DOWN_KEY:
                        return this._onDirectionKey(event, hasActiveDropdown);
                      case DELETE_KEY:
                      case BACK_KEY:
                        return this._onDeleteKey(
                          event,
                          activeItems,
                          hasFocusedInput
                        );
                      default:
                    }
                  };
                  Choices.prototype._onKeyUp = function (_a) {
                    var target = _a.target,
                      keyCode = _a.keyCode;
                    var value = this.input.value;
                    var activeItems = this._store.activeItems;
                    var canAddItem = this._canAddItem(activeItems, value);
                    var backKey = constants_1.KEY_CODES.BACK_KEY,
                      deleteKey = constants_1.KEY_CODES.DELETE_KEY;
                    // We are typing into a text input and have a value, we want to show a dropdown
                    // notice. Otherwise hide the dropdown
                    if (this._isTextElement) {
                      var canShowDropdownNotice = canAddItem.notice && value;
                      if (canShowDropdownNotice) {
                        var dropdownItem = this._getTemplate(
                          "notice",
                          canAddItem.notice
                        );
                        this.dropdown.element.innerHTML =
                          dropdownItem.outerHTML;
                        this.showDropdown(true);
                      } else {
                        this.hideDropdown(true);
                      }
                    } else {
                      var wasRemovalKeyCode =
                        keyCode === backKey || keyCode === deleteKey;
                      var userHasRemovedValue =
                        wasRemovalKeyCode && target && !target.value;
                      var canReactivateChoices =
                        !this._isTextElement && this._isSearching;
                      var canSearch = this._canSearch && canAddItem.response;
                      if (userHasRemovedValue && canReactivateChoices) {
                        this._isSearching = false;
                        this._store.dispatch(
                          (0, choices_1.activateChoices)(true)
                        );
                      } else if (canSearch) {
                        this._handleSearch(this.input.rawValue);
                      }
                    }
                    this._canSearch = this.config.searchEnabled;
                  };
                  Choices.prototype._onSelectKey = function (event, hasItems) {
                    var ctrlKey = event.ctrlKey,
                      metaKey = event.metaKey;
                    var hasCtrlDownKeyPressed = ctrlKey || metaKey;
                    // If CTRL + A or CMD + A have been pressed and there are items to select
                    if (hasCtrlDownKeyPressed && hasItems) {
                      this._canSearch = false;
                      var shouldHightlightAll =
                        this.config.removeItems &&
                        !this.input.value &&
                        this.input.element === document.activeElement;
                      if (shouldHightlightAll) {
                        this.highlightAll();
                      }
                    }
                  };
                  Choices.prototype._onEnterKey = function (
                    event,
                    activeItems,
                    hasActiveDropdown
                  ) {
                    var target = event.target;
                    var enterKey = constants_1.KEY_CODES.ENTER_KEY;
                    var targetWasButton =
                      target && target.hasAttribute("data-button");
                    if (this._isTextElement && target && target.value) {
                      var value = this.input.value;
                      var canAddItem = this._canAddItem(activeItems, value);
                      if (canAddItem.response) {
                        this.hideDropdown(true);
                        this._addItem({
                          value: value,
                        });
                        this._triggerChange(value);
                        this.clearInput();
                      }
                    }
                    if (targetWasButton) {
                      this._handleButtonAction(activeItems, target);
                      event.preventDefault();
                    }
                    if (hasActiveDropdown) {
                      var highlightedChoice = this.dropdown.getChild(
                        ".".concat(this.config.classNames.highlightedState)
                      );
                      if (highlightedChoice) {
                        // add enter keyCode value
                        if (activeItems[0]) {
                          activeItems[0].keyCode = enterKey; // eslint-disable-line no-param-reassign
                        }

                        this._handleChoiceAction(
                          activeItems,
                          highlightedChoice
                        );
                      }
                      event.preventDefault();
                    } else if (this._isSelectOneElement) {
                      this.showDropdown();
                      event.preventDefault();
                    }
                  };
                  Choices.prototype._onEscapeKey = function (
                    hasActiveDropdown
                  ) {
                    if (hasActiveDropdown) {
                      this.hideDropdown(true);
                      this.containerOuter.focus();
                    }
                  };
                  Choices.prototype._onDirectionKey = function (
                    event,
                    hasActiveDropdown
                  ) {
                    var keyCode = event.keyCode,
                      metaKey = event.metaKey;
                    var downKey = constants_1.KEY_CODES.DOWN_KEY,
                      pageUpKey = constants_1.KEY_CODES.PAGE_UP_KEY,
                      pageDownKey = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                    // If up or down key is pressed, traverse through options
                    if (hasActiveDropdown || this._isSelectOneElement) {
                      this.showDropdown();
                      this._canSearch = false;
                      var directionInt =
                        keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
                      var skipKey =
                        metaKey ||
                        keyCode === pageDownKey ||
                        keyCode === pageUpKey;
                      var selectableChoiceIdentifier =
                        "[data-choice-selectable]";
                      var nextEl = void 0;
                      if (skipKey) {
                        if (directionInt > 0) {
                          nextEl = this.dropdown.element.querySelector(
                            "".concat(
                              selectableChoiceIdentifier,
                              ":last-of-type"
                            )
                          );
                        } else {
                          nextEl = this.dropdown.element.querySelector(
                            selectableChoiceIdentifier
                          );
                        }
                      } else {
                        var currentEl = this.dropdown.element.querySelector(
                          ".".concat(this.config.classNames.highlightedState)
                        );
                        if (currentEl) {
                          nextEl = (0, utils_1.getAdjacentEl)(
                            currentEl,
                            selectableChoiceIdentifier,
                            directionInt
                          );
                        } else {
                          nextEl = this.dropdown.element.querySelector(
                            selectableChoiceIdentifier
                          );
                        }
                      }
                      if (nextEl) {
                        // We prevent default to stop the cursor moving
                        // when pressing the arrow
                        if (
                          !(0, utils_1.isScrolledIntoView)(
                            nextEl,
                            this.choiceList.element,
                            directionInt
                          )
                        ) {
                          this.choiceList.scrollToChildElement(
                            nextEl,
                            directionInt
                          );
                        }
                        this._highlightChoice(nextEl);
                      }
                      // Prevent default to maintain cursor position whilst
                      // traversing dropdown options
                      event.preventDefault();
                    }
                  };
                  Choices.prototype._onDeleteKey = function (
                    event,
                    activeItems,
                    hasFocusedInput
                  ) {
                    var target = event.target;
                    // If backspace or delete key is pressed and the input has no value
                    if (
                      !this._isSelectOneElement &&
                      !target.value &&
                      hasFocusedInput
                    ) {
                      this._handleBackspace(activeItems);
                      event.preventDefault();
                    }
                  };
                  Choices.prototype._onTouchMove = function () {
                    if (this._wasTap) {
                      this._wasTap = false;
                    }
                  };
                  Choices.prototype._onTouchEnd = function (event) {
                    var target = (event || event.touches[0]).target;
                    var touchWasWithinContainer =
                      this._wasTap &&
                      this.containerOuter.element.contains(target);
                    if (touchWasWithinContainer) {
                      var containerWasExactTarget =
                        target === this.containerOuter.element ||
                        target === this.containerInner.element;
                      if (containerWasExactTarget) {
                        if (this._isTextElement) {
                          this.input.focus();
                        } else if (this._isSelectMultipleElement) {
                          this.showDropdown();
                        }
                      }
                      // Prevents focus event firing
                      event.stopPropagation();
                    }
                    this._wasTap = true;
                  };
                  /**
                   * Handles mousedown event in capture mode for containetOuter.element
                   */
                  Choices.prototype._onMouseDown = function (event) {
                    var target = event.target;
                    if (!(target instanceof HTMLElement)) {
                      return;
                    }
                    // If we have our mouse down on the scrollbar and are on IE11...
                    if (IS_IE11 && this.choiceList.element.contains(target)) {
                      // check if click was on a scrollbar area
                      var firstChoice =
                        this.choiceList.element.firstElementChild;
                      var isOnScrollbar =
                        this._direction === "ltr"
                          ? event.offsetX >= firstChoice.offsetWidth
                          : event.offsetX < firstChoice.offsetLeft;
                      this._isScrollingOnIe = isOnScrollbar;
                    }
                    if (target === this.input.element) {
                      return;
                    }
                    var item = target.closest(
                      "[data-button],[data-item],[data-choice]"
                    );
                    if (item instanceof HTMLElement) {
                      var hasShiftKey = event.shiftKey;
                      var activeItems = this._store.activeItems;
                      var dataset = item.dataset;
                      if ("button" in dataset) {
                        this._handleButtonAction(activeItems, item);
                      } else if ("item" in dataset) {
                        this._handleItemAction(activeItems, item, hasShiftKey);
                      } else if ("choice" in dataset) {
                        this._handleChoiceAction(activeItems, item);
                      }
                    }
                    event.preventDefault();
                  };
                  /**
                   * Handles mouseover event over this.dropdown
                   * @param {MouseEvent} event
                   */
                  Choices.prototype._onMouseOver = function (_a) {
                    var target = _a.target;
                    if (
                      target instanceof HTMLElement &&
                      "choice" in target.dataset
                    ) {
                      this._highlightChoice(target);
                    }
                  };
                  Choices.prototype._onClick = function (_a) {
                    var target = _a.target;
                    var clickWasWithinContainer =
                      this.containerOuter.element.contains(target);
                    if (clickWasWithinContainer) {
                      if (
                        !this.dropdown.isActive &&
                        !this.containerOuter.isDisabled
                      ) {
                        if (this._isTextElement) {
                          if (document.activeElement !== this.input.element) {
                            this.input.focus();
                          }
                        } else {
                          this.showDropdown();
                          this.containerOuter.focus();
                        }
                      } else if (
                        this._isSelectOneElement &&
                        target !== this.input.element &&
                        !this.dropdown.element.contains(target)
                      ) {
                        this.hideDropdown();
                      }
                    } else {
                      var hasHighlightedItems =
                        this._store.highlightedActiveItems.length > 0;
                      if (hasHighlightedItems) {
                        this.unhighlightAll();
                      }
                      this.containerOuter.removeFocusState();
                      this.hideDropdown(true);
                    }
                  };
                  Choices.prototype._onFocus = function (_a) {
                    var _b;
                    var _this = this;
                    var target = _a.target;
                    var focusWasWithinContainer =
                      target && this.containerOuter.element.contains(target);
                    if (!focusWasWithinContainer) {
                      return;
                    }
                    var focusActions =
                      ((_b = {}),
                      (_b[constants_1.TEXT_TYPE] = function () {
                        if (target === _this.input.element) {
                          _this.containerOuter.addFocusState();
                        }
                      }),
                      (_b[constants_1.SELECT_ONE_TYPE] = function () {
                        _this.containerOuter.addFocusState();
                        if (target === _this.input.element) {
                          _this.showDropdown(true);
                        }
                      }),
                      (_b[constants_1.SELECT_MULTIPLE_TYPE] = function () {
                        if (target === _this.input.element) {
                          _this.showDropdown(true);
                          // If element is a select box, the focused element is the container and the dropdown
                          // isn't already open, focus and show dropdown
                          _this.containerOuter.addFocusState();
                        }
                      }),
                      _b);
                    focusActions[this.passedElement.element.type]();
                  };
                  Choices.prototype._onBlur = function (_a) {
                    var _b;
                    var _this = this;
                    var target = _a.target;
                    var blurWasWithinContainer =
                      target && this.containerOuter.element.contains(target);
                    if (blurWasWithinContainer && !this._isScrollingOnIe) {
                      var activeItems = this._store.activeItems;
                      var hasHighlightedItems_1 = activeItems.some(function (
                        item
                      ) {
                        return item.highlighted;
                      });
                      var blurActions =
                        ((_b = {}),
                        (_b[constants_1.TEXT_TYPE] = function () {
                          if (target === _this.input.element) {
                            _this.containerOuter.removeFocusState();
                            if (hasHighlightedItems_1) {
                              _this.unhighlightAll();
                            }
                            _this.hideDropdown(true);
                          }
                        }),
                        (_b[constants_1.SELECT_ONE_TYPE] = function () {
                          _this.containerOuter.removeFocusState();
                          if (
                            target === _this.input.element ||
                            (target === _this.containerOuter.element &&
                              !_this._canSearch)
                          ) {
                            _this.hideDropdown(true);
                          }
                        }),
                        (_b[constants_1.SELECT_MULTIPLE_TYPE] = function () {
                          if (target === _this.input.element) {
                            _this.containerOuter.removeFocusState();
                            _this.hideDropdown(true);
                            if (hasHighlightedItems_1) {
                              _this.unhighlightAll();
                            }
                          }
                        }),
                        _b);
                      blurActions[this.passedElement.element.type]();
                    } else {
                      // On IE11, clicking the scollbar blurs our input and thus
                      // closes the dropdown. To stop this, we refocus our input
                      // if we know we are on IE *and* are scrolling.
                      this._isScrollingOnIe = false;
                      this.input.element.focus();
                    }
                  };
                  Choices.prototype._onFormReset = function () {
                    this._store.dispatch(
                      (0, misc_1.resetTo)(this._initialState)
                    );
                  };
                  Choices.prototype._highlightChoice = function (el) {
                    var _this = this;
                    if (el === void 0) {
                      el = null;
                    }
                    var choices = Array.from(
                      this.dropdown.element.querySelectorAll(
                        "[data-choice-selectable]"
                      )
                    );
                    if (!choices.length) {
                      return;
                    }
                    var passedEl = el;
                    var highlightedChoices = Array.from(
                      this.dropdown.element.querySelectorAll(
                        ".".concat(this.config.classNames.highlightedState)
                      )
                    );
                    // Remove any highlighted choices
                    highlightedChoices.forEach(function (choice) {
                      choice.classList.remove(
                        _this.config.classNames.highlightedState
                      );
                      choice.setAttribute("aria-selected", "false");
                    });
                    if (passedEl) {
                      this._highlightPosition = choices.indexOf(passedEl);
                    } else {
                      // Highlight choice based on last known highlight location
                      if (choices.length > this._highlightPosition) {
                        // If we have an option to highlight
                        passedEl = choices[this._highlightPosition];
                      } else {
                        // Otherwise highlight the option before
                        passedEl = choices[choices.length - 1];
                      }
                      if (!passedEl) {
                        passedEl = choices[0];
                      }
                    }
                    passedEl.classList.add(
                      this.config.classNames.highlightedState
                    );
                    passedEl.setAttribute("aria-selected", "true");
                    this.passedElement.triggerEvent(
                      constants_1.EVENTS.highlightChoice,
                      {
                        el: passedEl,
                      }
                    );
                    if (this.dropdown.isActive) {
                      // IE11 ignores aria-label and blocks virtual keyboard
                      // if aria-activedescendant is set without a dropdown
                      this.input.setActiveDescendant(passedEl.id);
                      this.containerOuter.setActiveDescendant(passedEl.id);
                    }
                  };
                  Choices.prototype._addItem = function (_a) {
                    var value = _a.value,
                      _b = _a.label,
                      label = _b === void 0 ? null : _b,
                      _c = _a.choiceId,
                      choiceId = _c === void 0 ? -1 : _c,
                      _d = _a.groupId,
                      groupId = _d === void 0 ? -1 : _d,
                      _e = _a.customProperties,
                      customProperties = _e === void 0 ? {} : _e,
                      _f = _a.placeholder,
                      placeholder = _f === void 0 ? false : _f,
                      _g = _a.keyCode,
                      keyCode = _g === void 0 ? -1 : _g;
                    var passedValue =
                      typeof value === "string" ? value.trim() : value;
                    var items = this._store.items;
                    var passedLabel = label || passedValue;
                    var passedOptionId = choiceId || -1;
                    var group =
                      groupId >= 0 ? this._store.getGroupById(groupId) : null;
                    var id = items ? items.length + 1 : 1;
                    // If a prepended value has been passed, prepend it
                    if (this.config.prependValue) {
                      passedValue =
                        this.config.prependValue + passedValue.toString();
                    }
                    // If an appended value has been passed, append it
                    if (this.config.appendValue) {
                      passedValue += this.config.appendValue.toString();
                    }
                    this._store.dispatch(
                      (0, items_1.addItem)({
                        value: passedValue,
                        label: passedLabel,
                        id: id,
                        choiceId: passedOptionId,
                        groupId: groupId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode,
                      })
                    );
                    if (this._isSelectOneElement) {
                      this.removeActiveItems(id);
                    }
                    // Trigger change event
                    this.passedElement.triggerEvent(
                      constants_1.EVENTS.addItem,
                      {
                        id: id,
                        value: passedValue,
                        label: passedLabel,
                        customProperties: customProperties,
                        groupValue: group && group.value ? group.value : null,
                        keyCode: keyCode,
                      }
                    );
                  };
                  Choices.prototype._removeItem = function (item) {
                    var id = item.id,
                      value = item.value,
                      label = item.label,
                      customProperties = item.customProperties,
                      choiceId = item.choiceId,
                      groupId = item.groupId;
                    var group =
                      groupId && groupId >= 0
                        ? this._store.getGroupById(groupId)
                        : null;
                    if (!id || !choiceId) {
                      return;
                    }
                    this._store.dispatch((0, items_1.removeItem)(id, choiceId));
                    this.passedElement.triggerEvent(
                      constants_1.EVENTS.removeItem,
                      {
                        id: id,
                        value: value,
                        label: label,
                        customProperties: customProperties,
                        groupValue: group && group.value ? group.value : null,
                      }
                    );
                  };
                  Choices.prototype._addChoice = function (_a) {
                    var value = _a.value,
                      _b = _a.label,
                      label = _b === void 0 ? null : _b,
                      _c = _a.isSelected,
                      isSelected = _c === void 0 ? false : _c,
                      _d = _a.isDisabled,
                      isDisabled = _d === void 0 ? false : _d,
                      _e = _a.groupId,
                      groupId = _e === void 0 ? -1 : _e,
                      _f = _a.customProperties,
                      customProperties = _f === void 0 ? {} : _f,
                      _g = _a.placeholder,
                      placeholder = _g === void 0 ? false : _g,
                      _h = _a.keyCode,
                      keyCode = _h === void 0 ? -1 : _h;
                    if (typeof value === "undefined" || value === null) {
                      return;
                    }
                    // Generate unique id
                    var choices = this._store.choices;
                    var choiceLabel = label || value;
                    var choiceId = choices ? choices.length + 1 : 1;
                    var choiceElementId = ""
                      .concat(this._baseId, "-")
                      .concat(this._idNames.itemChoice, "-")
                      .concat(choiceId);
                    this._store.dispatch(
                      (0, choices_1.addChoice)({
                        id: choiceId,
                        groupId: groupId,
                        elementId: choiceElementId,
                        value: value,
                        label: choiceLabel,
                        disabled: isDisabled,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode,
                      })
                    );
                    if (isSelected) {
                      this._addItem({
                        value: value,
                        label: choiceLabel,
                        choiceId: choiceId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode,
                      });
                    }
                  };
                  Choices.prototype._addGroup = function (_a) {
                    var _this = this;
                    var group = _a.group,
                      id = _a.id,
                      _b = _a.valueKey,
                      valueKey = _b === void 0 ? "value" : _b,
                      _c = _a.labelKey,
                      labelKey = _c === void 0 ? "label" : _c;
                    var groupChoices = (0, utils_1.isType)("Object", group)
                      ? group.choices
                      : Array.from(group.getElementsByTagName("OPTION"));
                    var groupId =
                      id || Math.floor(new Date().valueOf() * Math.random());
                    var isDisabled = group.disabled ? group.disabled : false;
                    if (groupChoices) {
                      this._store.dispatch(
                        (0, groups_1.addGroup)({
                          value: group.label,
                          id: groupId,
                          active: true,
                          disabled: isDisabled,
                        })
                      );
                      var addGroupChoices = function (choice) {
                        var isOptDisabled =
                          choice.disabled ||
                          (choice.parentNode && choice.parentNode.disabled);
                        _this._addChoice({
                          value: choice[valueKey],
                          label: (0, utils_1.isType)("Object", choice)
                            ? choice[labelKey]
                            : choice.innerHTML,
                          isSelected: choice.selected,
                          isDisabled: isOptDisabled,
                          groupId: groupId,
                          customProperties: choice.customProperties,
                          placeholder: choice.placeholder,
                        });
                      };
                      groupChoices.forEach(addGroupChoices);
                    } else {
                      this._store.dispatch(
                        (0, groups_1.addGroup)({
                          value: group.label,
                          id: group.id,
                          active: false,
                          disabled: group.disabled,
                        })
                      );
                    }
                  };
                  Choices.prototype._getTemplate = function (template) {
                    var _a;
                    var args = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                      args[_i - 1] = arguments[_i];
                    }
                    return (_a = this._templates[template]).call.apply(
                      _a,
                      __spreadArray([this, this.config], args, false)
                    );
                  };
                  Choices.prototype._createTemplates = function () {
                    var callbackOnCreateTemplates =
                      this.config.callbackOnCreateTemplates;
                    var userTemplates = {};
                    if (
                      callbackOnCreateTemplates &&
                      typeof callbackOnCreateTemplates === "function"
                    ) {
                      userTemplates = callbackOnCreateTemplates.call(
                        this,
                        utils_1.strToEl
                      );
                    }
                    this._templates = (0, deepmerge_1.default)(
                      templates_1.default,
                      userTemplates
                    );
                  };
                  Choices.prototype._createElements = function () {
                    this.containerOuter = new components_1.Container({
                      element: this._getTemplate(
                        "containerOuter",
                        this._direction,
                        this._isSelectElement,
                        this._isSelectOneElement,
                        this.config.searchEnabled,
                        this.passedElement.element.type,
                        this.config.labelId
                      ),
                      classNames: this.config.classNames,
                      type: this.passedElement.element.type,
                      position: this.config.position,
                    });
                    this.containerInner = new components_1.Container({
                      element: this._getTemplate("containerInner"),
                      classNames: this.config.classNames,
                      type: this.passedElement.element.type,
                      position: this.config.position,
                    });
                    this.input = new components_1.Input({
                      element: this._getTemplate(
                        "input",
                        this._placeholderValue
                      ),
                      classNames: this.config.classNames,
                      type: this.passedElement.element.type,
                      preventPaste: !this.config.paste,
                    });
                    this.choiceList = new components_1.List({
                      element: this._getTemplate(
                        "choiceList",
                        this._isSelectOneElement
                      ),
                    });
                    this.itemList = new components_1.List({
                      element: this._getTemplate(
                        "itemList",
                        this._isSelectOneElement
                      ),
                    });
                    this.dropdown = new components_1.Dropdown({
                      element: this._getTemplate("dropdown"),
                      classNames: this.config.classNames,
                      type: this.passedElement.element.type,
                    });
                  };
                  Choices.prototype._createStructure = function () {
                    // Hide original element
                    this.passedElement.conceal();
                    // Wrap input in container preserving DOM ordering
                    this.containerInner.wrap(this.passedElement.element);
                    // Wrapper inner container with outer container
                    this.containerOuter.wrap(this.containerInner.element);
                    if (this._isSelectOneElement) {
                      this.input.placeholder =
                        this.config.searchPlaceholderValue || "";
                    } else if (this._placeholderValue) {
                      this.input.placeholder = this._placeholderValue;
                      this.input.setWidth();
                    }
                    this.containerOuter.element.appendChild(
                      this.containerInner.element
                    );
                    this.containerOuter.element.appendChild(
                      this.dropdown.element
                    );
                    this.containerInner.element.appendChild(
                      this.itemList.element
                    );
                    if (!this._isTextElement) {
                      this.dropdown.element.appendChild(
                        this.choiceList.element
                      );
                    }
                    if (!this._isSelectOneElement) {
                      this.containerInner.element.appendChild(
                        this.input.element
                      );
                    } else if (this.config.searchEnabled) {
                      this.dropdown.element.insertBefore(
                        this.input.element,
                        this.dropdown.element.firstChild
                      );
                    }
                    if (this._isSelectElement) {
                      this._highlightPosition = 0;
                      this._isSearching = false;
                      this._startLoading();
                      if (this._presetGroups.length) {
                        this._addPredefinedGroups(this._presetGroups);
                      } else {
                        this._addPredefinedChoices(this._presetChoices);
                      }
                      this._stopLoading();
                    }
                    if (this._isTextElement) {
                      this._addPredefinedItems(this._presetItems);
                    }
                  };
                  Choices.prototype._addPredefinedGroups = function (groups) {
                    var _this = this;
                    // If we have a placeholder option
                    var placeholderChoice =
                      this.passedElement.placeholderOption;
                    if (
                      placeholderChoice &&
                      placeholderChoice.parentNode &&
                      placeholderChoice.parentNode.tagName === "SELECT"
                    ) {
                      this._addChoice({
                        value: placeholderChoice.value,
                        label: placeholderChoice.innerHTML,
                        isSelected: placeholderChoice.selected,
                        isDisabled: placeholderChoice.disabled,
                        placeholder: true,
                      });
                    }
                    groups.forEach(function (group) {
                      return _this._addGroup({
                        group: group,
                        id: group.id || null,
                      });
                    });
                  };
                  Choices.prototype._addPredefinedChoices = function (choices) {
                    var _this = this;
                    // If sorting is enabled or the user is searching, filter choices
                    if (this.config.shouldSort) {
                      choices.sort(this.config.sorter);
                    }
                    var hasSelectedChoice = choices.some(function (choice) {
                      return choice.selected;
                    });
                    var firstEnabledChoiceIndex = choices.findIndex(function (
                      choice
                    ) {
                      return choice.disabled === undefined || !choice.disabled;
                    });
                    choices.forEach(function (choice, index) {
                      var _a = choice.value,
                        value = _a === void 0 ? "" : _a,
                        label = choice.label,
                        customProperties = choice.customProperties,
                        placeholder = choice.placeholder;
                      if (_this._isSelectElement) {
                        // If the choice is actually a group
                        if (choice.choices) {
                          _this._addGroup({
                            group: choice,
                            id: choice.id || null,
                          });
                        } else {
                          /**
                           * If there is a selected choice already or the choice is not the first in
                           * the array, add each choice normally.
                           *
                           * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
                           */
                          var shouldPreselect =
                            _this._isSelectOneElement &&
                            !hasSelectedChoice &&
                            index === firstEnabledChoiceIndex;
                          var isSelected = shouldPreselect
                            ? true
                            : choice.selected;
                          var isDisabled = choice.disabled;
                          _this._addChoice({
                            value: value,
                            label: label,
                            isSelected: !!isSelected,
                            isDisabled: !!isDisabled,
                            placeholder: !!placeholder,
                            customProperties: customProperties,
                          });
                        }
                      } else {
                        _this._addChoice({
                          value: value,
                          label: label,
                          isSelected: !!choice.selected,
                          isDisabled: !!choice.disabled,
                          placeholder: !!choice.placeholder,
                          customProperties: customProperties,
                        });
                      }
                    });
                  };
                  Choices.prototype._addPredefinedItems = function (items) {
                    var _this = this;
                    items.forEach(function (item) {
                      if (typeof item === "object" && item.value) {
                        _this._addItem({
                          value: item.value,
                          label: item.label,
                          choiceId: item.id,
                          customProperties: item.customProperties,
                          placeholder: item.placeholder,
                        });
                      }
                      if (typeof item === "string") {
                        _this._addItem({
                          value: item,
                        });
                      }
                    });
                  };
                  Choices.prototype._setChoiceOrItem = function (item) {
                    var _this = this;
                    var itemType = (0, utils_1.getType)(item).toLowerCase();
                    var handleType = {
                      object: function () {
                        if (!item.value) {
                          return;
                        }
                        // If we are dealing with a select input, we need to create an option first
                        // that is then selected. For text inputs we can just add items normally.
                        if (!_this._isTextElement) {
                          _this._addChoice({
                            value: item.value,
                            label: item.label,
                            isSelected: true,
                            isDisabled: false,
                            customProperties: item.customProperties,
                            placeholder: item.placeholder,
                          });
                        } else {
                          _this._addItem({
                            value: item.value,
                            label: item.label,
                            choiceId: item.id,
                            customProperties: item.customProperties,
                            placeholder: item.placeholder,
                          });
                        }
                      },
                      string: function () {
                        if (!_this._isTextElement) {
                          _this._addChoice({
                            value: item,
                            label: item,
                            isSelected: true,
                            isDisabled: false,
                          });
                        } else {
                          _this._addItem({
                            value: item,
                          });
                        }
                      },
                    };
                    handleType[itemType]();
                  };
                  Choices.prototype._findAndSelectChoiceByValue = function (
                    value
                  ) {
                    var _this = this;
                    var choices = this._store.choices;
                    // Check 'value' property exists and the choice isn't already selected
                    var foundChoice = choices.find(function (choice) {
                      return _this.config.valueComparer(choice.value, value);
                    });
                    if (foundChoice && !foundChoice.selected) {
                      this._addItem({
                        value: foundChoice.value,
                        label: foundChoice.label,
                        choiceId: foundChoice.id,
                        groupId: foundChoice.groupId,
                        customProperties: foundChoice.customProperties,
                        placeholder: foundChoice.placeholder,
                        keyCode: foundChoice.keyCode,
                      });
                    }
                  };
                  Choices.prototype._generatePlaceholderValue = function () {
                    if (
                      this._isSelectElement &&
                      this.passedElement.placeholderOption
                    ) {
                      var placeholderOption =
                        this.passedElement.placeholderOption;
                      return placeholderOption ? placeholderOption.text : null;
                    }
                    var _a = this.config,
                      placeholder = _a.placeholder,
                      placeholderValue = _a.placeholderValue;
                    var dataset = this.passedElement.element.dataset;
                    if (placeholder) {
                      if (placeholderValue) {
                        return placeholderValue;
                      }
                      if (dataset.placeholder) {
                        return dataset.placeholder;
                      }
                    }
                    return null;
                  };
                  return Choices;
                })();
                exports["default"] = Choices;

                /***/
              },

              /***/ 613: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_74916__
              ) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                var utils_1 = __nested_webpack_require_74916__(799);
                var constants_1 = __nested_webpack_require_74916__(883);
                var Container = /** @class */ (function () {
                  function Container(_a) {
                    var element = _a.element,
                      type = _a.type,
                      classNames = _a.classNames,
                      position = _a.position;
                    this.element = element;
                    this.classNames = classNames;
                    this.type = type;
                    this.position = position;
                    this.isOpen = false;
                    this.isFlipped = false;
                    this.isFocussed = false;
                    this.isDisabled = false;
                    this.isLoading = false;
                    this._onFocus = this._onFocus.bind(this);
                    this._onBlur = this._onBlur.bind(this);
                  }
                  Container.prototype.addEventListeners = function () {
                    this.element.addEventListener("focus", this._onFocus);
                    this.element.addEventListener("blur", this._onBlur);
                  };
                  Container.prototype.removeEventListeners = function () {
                    this.element.removeEventListener("focus", this._onFocus);
                    this.element.removeEventListener("blur", this._onBlur);
                  };
                  /**
                   * Determine whether container should be flipped based on passed
                   * dropdown position
                   */
                  Container.prototype.shouldFlip = function (dropdownPos) {
                    if (typeof dropdownPos !== "number") {
                      return false;
                    }
                    // If flip is enabled and the dropdown bottom position is
                    // greater than the window height flip the dropdown.
                    var shouldFlip = false;
                    if (this.position === "auto") {
                      shouldFlip = !window.matchMedia(
                        "(min-height: ".concat(dropdownPos + 1, "px)")
                      ).matches;
                    } else if (this.position === "top") {
                      shouldFlip = true;
                    }
                    return shouldFlip;
                  };
                  Container.prototype.setActiveDescendant = function (
                    activeDescendantID
                  ) {
                    this.element.setAttribute(
                      "aria-activedescendant",
                      activeDescendantID
                    );
                  };
                  Container.prototype.removeActiveDescendant = function () {
                    this.element.removeAttribute("aria-activedescendant");
                  };
                  Container.prototype.open = function (dropdownPos) {
                    this.element.classList.add(this.classNames.openState);
                    this.element.setAttribute("aria-expanded", "true");
                    this.isOpen = true;
                    if (this.shouldFlip(dropdownPos)) {
                      this.element.classList.add(this.classNames.flippedState);
                      this.isFlipped = true;
                    }
                  };
                  Container.prototype.close = function () {
                    this.element.classList.remove(this.classNames.openState);
                    this.element.setAttribute("aria-expanded", "false");
                    this.removeActiveDescendant();
                    this.isOpen = false;
                    // A dropdown flips if it does not have space within the page
                    if (this.isFlipped) {
                      this.element.classList.remove(
                        this.classNames.flippedState
                      );
                      this.isFlipped = false;
                    }
                  };
                  Container.prototype.focus = function () {
                    if (!this.isFocussed) {
                      this.element.focus();
                    }
                  };
                  Container.prototype.addFocusState = function () {
                    this.element.classList.add(this.classNames.focusState);
                  };
                  Container.prototype.removeFocusState = function () {
                    this.element.classList.remove(this.classNames.focusState);
                  };
                  Container.prototype.enable = function () {
                    this.element.classList.remove(
                      this.classNames.disabledState
                    );
                    this.element.removeAttribute("aria-disabled");
                    if (this.type === constants_1.SELECT_ONE_TYPE) {
                      this.element.setAttribute("tabindex", "0");
                    }
                    this.isDisabled = false;
                  };
                  Container.prototype.disable = function () {
                    this.element.classList.add(this.classNames.disabledState);
                    this.element.setAttribute("aria-disabled", "true");
                    if (this.type === constants_1.SELECT_ONE_TYPE) {
                      this.element.setAttribute("tabindex", "-1");
                    }
                    this.isDisabled = true;
                  };
                  Container.prototype.wrap = function (element) {
                    (0, utils_1.wrap)(element, this.element);
                  };
                  Container.prototype.unwrap = function (element) {
                    if (this.element.parentNode) {
                      // Move passed element outside this element
                      this.element.parentNode.insertBefore(
                        element,
                        this.element
                      );
                      // Remove this element
                      this.element.parentNode.removeChild(this.element);
                    }
                  };
                  Container.prototype.addLoadingState = function () {
                    this.element.classList.add(this.classNames.loadingState);
                    this.element.setAttribute("aria-busy", "true");
                    this.isLoading = true;
                  };
                  Container.prototype.removeLoadingState = function () {
                    this.element.classList.remove(this.classNames.loadingState);
                    this.element.removeAttribute("aria-busy");
                    this.isLoading = false;
                  };
                  Container.prototype._onFocus = function () {
                    this.isFocussed = true;
                  };
                  Container.prototype._onBlur = function () {
                    this.isFocussed = false;
                  };
                  return Container;
                })();
                exports["default"] = Container;

                /***/
              },

              /***/ 217: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                var Dropdown = /** @class */ (function () {
                  function Dropdown(_a) {
                    var element = _a.element,
                      type = _a.type,
                      classNames = _a.classNames;
                    this.element = element;
                    this.classNames = classNames;
                    this.type = type;
                    this.isActive = false;
                  }
                  Object.defineProperty(
                    Dropdown.prototype,
                    "distanceFromTopWindow",
                    {
                      /**
                       * Bottom position of dropdown in viewport coordinates
                       */
                      get: function () {
                        return this.element.getBoundingClientRect().bottom;
                      },
                      enumerable: false,
                      configurable: true,
                    }
                  );
                  Dropdown.prototype.getChild = function (selector) {
                    return this.element.querySelector(selector);
                  };
                  /**
                   * Show dropdown to user by adding active state class
                   */
                  Dropdown.prototype.show = function () {
                    this.element.classList.add(this.classNames.activeState);
                    this.element.setAttribute("aria-expanded", "true");
                    this.isActive = true;
                    return this;
                  };
                  /**
                   * Hide dropdown from user
                   */
                  Dropdown.prototype.hide = function () {
                    this.element.classList.remove(this.classNames.activeState);
                    this.element.setAttribute("aria-expanded", "false");
                    this.isActive = false;
                    return this;
                  };
                  return Dropdown;
                })();
                exports["default"] = Dropdown;

                /***/
              },

              /***/ 520: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_81090__
              ) {
                var __importDefault =
                  (this && this.__importDefault) ||
                  function (mod) {
                    return mod && mod.__esModule
                      ? mod
                      : {
                          default: mod,
                        };
                  };
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.WrappedSelect =
                  exports.WrappedInput =
                  exports.List =
                  exports.Input =
                  exports.Container =
                  exports.Dropdown =
                    void 0;
                var dropdown_1 = __importDefault(
                  __nested_webpack_require_81090__(217)
                );
                exports.Dropdown = dropdown_1.default;
                var container_1 = __importDefault(
                  __nested_webpack_require_81090__(613)
                );
                exports.Container = container_1.default;
                var input_1 = __importDefault(
                  __nested_webpack_require_81090__(11)
                );
                exports.Input = input_1.default;
                var list_1 = __importDefault(
                  __nested_webpack_require_81090__(624)
                );
                exports.List = list_1.default;
                var wrapped_input_1 = __importDefault(
                  __nested_webpack_require_81090__(541)
                );
                exports.WrappedInput = wrapped_input_1.default;
                var wrapped_select_1 = __importDefault(
                  __nested_webpack_require_81090__(982)
                );
                exports.WrappedSelect = wrapped_select_1.default;

                /***/
              },

              /***/ 11: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_82125__
              ) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                var utils_1 = __nested_webpack_require_82125__(799);
                var constants_1 = __nested_webpack_require_82125__(883);
                var Input = /** @class */ (function () {
                  function Input(_a) {
                    var element = _a.element,
                      type = _a.type,
                      classNames = _a.classNames,
                      preventPaste = _a.preventPaste;
                    this.element = element;
                    this.type = type;
                    this.classNames = classNames;
                    this.preventPaste = preventPaste;
                    this.isFocussed = this.element.isEqualNode(
                      document.activeElement
                    );
                    this.isDisabled = element.disabled;
                    this._onPaste = this._onPaste.bind(this);
                    this._onInput = this._onInput.bind(this);
                    this._onFocus = this._onFocus.bind(this);
                    this._onBlur = this._onBlur.bind(this);
                  }
                  Object.defineProperty(Input.prototype, "placeholder", {
                    set: function (placeholder) {
                      this.element.placeholder = placeholder;
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(Input.prototype, "value", {
                    get: function () {
                      return (0, utils_1.sanitise)(this.element.value);
                    },
                    set: function (value) {
                      this.element.value = value;
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(Input.prototype, "rawValue", {
                    get: function () {
                      return this.element.value;
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Input.prototype.addEventListeners = function () {
                    this.element.addEventListener("paste", this._onPaste);
                    this.element.addEventListener("input", this._onInput, {
                      passive: true,
                    });
                    this.element.addEventListener("focus", this._onFocus, {
                      passive: true,
                    });
                    this.element.addEventListener("blur", this._onBlur, {
                      passive: true,
                    });
                  };
                  Input.prototype.removeEventListeners = function () {
                    this.element.removeEventListener("input", this._onInput);
                    this.element.removeEventListener("paste", this._onPaste);
                    this.element.removeEventListener("focus", this._onFocus);
                    this.element.removeEventListener("blur", this._onBlur);
                  };
                  Input.prototype.enable = function () {
                    this.element.removeAttribute("disabled");
                    this.isDisabled = false;
                  };
                  Input.prototype.disable = function () {
                    this.element.setAttribute("disabled", "");
                    this.isDisabled = true;
                  };
                  Input.prototype.focus = function () {
                    if (!this.isFocussed) {
                      this.element.focus();
                    }
                  };
                  Input.prototype.blur = function () {
                    if (this.isFocussed) {
                      this.element.blur();
                    }
                  };
                  Input.prototype.clear = function (setWidth) {
                    if (setWidth === void 0) {
                      setWidth = true;
                    }
                    if (this.element.value) {
                      this.element.value = "";
                    }
                    if (setWidth) {
                      this.setWidth();
                    }
                    return this;
                  };
                  /**
                   * Set the correct input width based on placeholder
                   * value or input value
                   */
                  Input.prototype.setWidth = function () {
                    // Resize input to contents or placeholder
                    var _a = this.element,
                      style = _a.style,
                      value = _a.value,
                      placeholder = _a.placeholder;
                    style.minWidth = "".concat(placeholder.length + 1, "ch");
                    style.width = "".concat(value.length + 1, "ch");
                  };
                  Input.prototype.setActiveDescendant = function (
                    activeDescendantID
                  ) {
                    this.element.setAttribute(
                      "aria-activedescendant",
                      activeDescendantID
                    );
                  };
                  Input.prototype.removeActiveDescendant = function () {
                    this.element.removeAttribute("aria-activedescendant");
                  };
                  Input.prototype._onInput = function () {
                    if (this.type !== constants_1.SELECT_ONE_TYPE) {
                      this.setWidth();
                    }
                  };
                  Input.prototype._onPaste = function (event) {
                    if (this.preventPaste) {
                      event.preventDefault();
                    }
                  };
                  Input.prototype._onFocus = function () {
                    this.isFocussed = true;
                  };
                  Input.prototype._onBlur = function () {
                    this.isFocussed = false;
                  };
                  return Input;
                })();
                exports["default"] = Input;

                /***/
              },

              /***/ 624: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_86127__
              ) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                var constants_1 = __nested_webpack_require_86127__(883);
                var List = /** @class */ (function () {
                  function List(_a) {
                    var element = _a.element;
                    this.element = element;
                    this.scrollPos = this.element.scrollTop;
                    this.height = this.element.offsetHeight;
                  }
                  List.prototype.clear = function () {
                    this.element.innerHTML = "";
                  };
                  List.prototype.append = function (node) {
                    this.element.appendChild(node);
                  };
                  List.prototype.getChild = function (selector) {
                    return this.element.querySelector(selector);
                  };
                  List.prototype.hasChildren = function () {
                    return this.element.hasChildNodes();
                  };
                  List.prototype.scrollToTop = function () {
                    this.element.scrollTop = 0;
                  };
                  List.prototype.scrollToChildElement = function (
                    element,
                    direction
                  ) {
                    var _this = this;
                    if (!element) {
                      return;
                    }
                    var listHeight = this.element.offsetHeight;
                    // Scroll position of dropdown
                    var listScrollPosition =
                      this.element.scrollTop + listHeight;
                    var elementHeight = element.offsetHeight;
                    // Distance from bottom of element to top of parent
                    var elementPos = element.offsetTop + elementHeight;
                    // Difference between the element and scroll position
                    var destination =
                      direction > 0
                        ? this.element.scrollTop +
                          elementPos -
                          listScrollPosition
                        : element.offsetTop;
                    requestAnimationFrame(function () {
                      _this._animateScroll(destination, direction);
                    });
                  };
                  List.prototype._scrollDown = function (
                    scrollPos,
                    strength,
                    destination
                  ) {
                    var easing = (destination - scrollPos) / strength;
                    var distance = easing > 1 ? easing : 1;
                    this.element.scrollTop = scrollPos + distance;
                  };
                  List.prototype._scrollUp = function (
                    scrollPos,
                    strength,
                    destination
                  ) {
                    var easing = (scrollPos - destination) / strength;
                    var distance = easing > 1 ? easing : 1;
                    this.element.scrollTop = scrollPos - distance;
                  };
                  List.prototype._animateScroll = function (
                    destination,
                    direction
                  ) {
                    var _this = this;
                    var strength = constants_1.SCROLLING_SPEED;
                    var choiceListScrollTop = this.element.scrollTop;
                    var continueAnimation = false;
                    if (direction > 0) {
                      this._scrollDown(
                        choiceListScrollTop,
                        strength,
                        destination
                      );
                      if (choiceListScrollTop < destination) {
                        continueAnimation = true;
                      }
                    } else {
                      this._scrollUp(
                        choiceListScrollTop,
                        strength,
                        destination
                      );
                      if (choiceListScrollTop > destination) {
                        continueAnimation = true;
                      }
                    }
                    if (continueAnimation) {
                      requestAnimationFrame(function () {
                        _this._animateScroll(destination, direction);
                      });
                    }
                  };
                  return List;
                })();
                exports["default"] = List;

                /***/
              },

              /***/ 730: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_88948__
              ) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                var utils_1 = __nested_webpack_require_88948__(799);
                var WrappedElement = /** @class */ (function () {
                  function WrappedElement(_a) {
                    var element = _a.element,
                      classNames = _a.classNames;
                    this.element = element;
                    this.classNames = classNames;
                    if (
                      !(element instanceof HTMLInputElement) &&
                      !(element instanceof HTMLSelectElement)
                    ) {
                      throw new TypeError("Invalid element passed");
                    }
                    this.isDisabled = false;
                  }
                  Object.defineProperty(WrappedElement.prototype, "isActive", {
                    get: function () {
                      return this.element.dataset.choice === "active";
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(WrappedElement.prototype, "dir", {
                    get: function () {
                      return this.element.dir;
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(WrappedElement.prototype, "value", {
                    get: function () {
                      return this.element.value;
                    },
                    set: function (value) {
                      // you must define setter here otherwise it will be readonly property
                      this.element.value = value;
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  WrappedElement.prototype.conceal = function () {
                    // Hide passed input
                    this.element.classList.add(this.classNames.input);
                    this.element.hidden = true;
                    // Remove element from tab index
                    this.element.tabIndex = -1;
                    // Backup original styles if any
                    var origStyle = this.element.getAttribute("style");
                    if (origStyle) {
                      this.element.setAttribute(
                        "data-choice-orig-style",
                        origStyle
                      );
                    }
                    this.element.setAttribute("data-choice", "active");
                  };
                  WrappedElement.prototype.reveal = function () {
                    // Reinstate passed element
                    this.element.classList.remove(this.classNames.input);
                    this.element.hidden = false;
                    this.element.removeAttribute("tabindex");
                    // Recover original styles if any
                    var origStyle = this.element.getAttribute(
                      "data-choice-orig-style"
                    );
                    if (origStyle) {
                      this.element.removeAttribute("data-choice-orig-style");
                      this.element.setAttribute("style", origStyle);
                    } else {
                      this.element.removeAttribute("style");
                    }
                    this.element.removeAttribute("data-choice");
                    // Re-assign values - this is weird, I know
                    // @todo Figure out why we need to do this
                    this.element.value = this.element.value; // eslint-disable-line no-self-assign
                  };

                  WrappedElement.prototype.enable = function () {
                    this.element.removeAttribute("disabled");
                    this.element.disabled = false;
                    this.isDisabled = false;
                  };
                  WrappedElement.prototype.disable = function () {
                    this.element.setAttribute("disabled", "");
                    this.element.disabled = true;
                    this.isDisabled = true;
                  };
                  WrappedElement.prototype.triggerEvent = function (
                    eventType,
                    data
                  ) {
                    (0, utils_1.dispatchEvent)(this.element, eventType, data);
                  };
                  return WrappedElement;
                })();
                exports["default"] = WrappedElement;

                /***/
              },

              /***/ 541: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_92021__
              ) {
                var __extends =
                  (this && this.__extends) ||
                  (function () {
                    var extendStatics = function (d, b) {
                      extendStatics =
                        Object.setPrototypeOf ||
                        ({
                          __proto__: [],
                        } instanceof Array &&
                          function (d, b) {
                            d.__proto__ = b;
                          }) ||
                        function (d, b) {
                          for (var p in b)
                            if (Object.prototype.hasOwnProperty.call(b, p))
                              d[p] = b[p];
                        };
                      return extendStatics(d, b);
                    };
                    return function (d, b) {
                      if (typeof b !== "function" && b !== null)
                        throw new TypeError(
                          "Class extends value " +
                            String(b) +
                            " is not a constructor or null"
                        );
                      extendStatics(d, b);
                      function __() {
                        this.constructor = d;
                      }
                      d.prototype =
                        b === null
                          ? Object.create(b)
                          : ((__.prototype = b.prototype), new __());
                    };
                  })();
                var __importDefault =
                  (this && this.__importDefault) ||
                  function (mod) {
                    return mod && mod.__esModule
                      ? mod
                      : {
                          default: mod,
                        };
                  };
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                var wrapped_element_1 = __importDefault(
                  __nested_webpack_require_92021__(730)
                );
                var WrappedInput = /** @class */ (function (_super) {
                  __extends(WrappedInput, _super);
                  function WrappedInput(_a) {
                    var element = _a.element,
                      classNames = _a.classNames,
                      delimiter = _a.delimiter;
                    var _this =
                      _super.call(this, {
                        element: element,
                        classNames: classNames,
                      }) || this;
                    _this.delimiter = delimiter;
                    return _this;
                  }
                  Object.defineProperty(WrappedInput.prototype, "value", {
                    get: function () {
                      return this.element.value;
                    },
                    set: function (value) {
                      this.element.setAttribute("value", value);
                      this.element.value = value;
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  return WrappedInput;
                })(wrapped_element_1.default);
                exports["default"] = WrappedInput;

                /***/
              },

              /***/ 982: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_93875__
              ) {
                var __extends =
                  (this && this.__extends) ||
                  (function () {
                    var extendStatics = function (d, b) {
                      extendStatics =
                        Object.setPrototypeOf ||
                        ({
                          __proto__: [],
                        } instanceof Array &&
                          function (d, b) {
                            d.__proto__ = b;
                          }) ||
                        function (d, b) {
                          for (var p in b)
                            if (Object.prototype.hasOwnProperty.call(b, p))
                              d[p] = b[p];
                        };
                      return extendStatics(d, b);
                    };
                    return function (d, b) {
                      if (typeof b !== "function" && b !== null)
                        throw new TypeError(
                          "Class extends value " +
                            String(b) +
                            " is not a constructor or null"
                        );
                      extendStatics(d, b);
                      function __() {
                        this.constructor = d;
                      }
                      d.prototype =
                        b === null
                          ? Object.create(b)
                          : ((__.prototype = b.prototype), new __());
                    };
                  })();
                var __importDefault =
                  (this && this.__importDefault) ||
                  function (mod) {
                    return mod && mod.__esModule
                      ? mod
                      : {
                          default: mod,
                        };
                  };
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                var wrapped_element_1 = __importDefault(
                  __nested_webpack_require_93875__(730)
                );
                var WrappedSelect = /** @class */ (function (_super) {
                  __extends(WrappedSelect, _super);
                  function WrappedSelect(_a) {
                    var element = _a.element,
                      classNames = _a.classNames,
                      template = _a.template;
                    var _this =
                      _super.call(this, {
                        element: element,
                        classNames: classNames,
                      }) || this;
                    _this.template = template;
                    return _this;
                  }
                  Object.defineProperty(
                    WrappedSelect.prototype,
                    "placeholderOption",
                    {
                      get: function () {
                        return (
                          this.element.querySelector('option[value=""]') ||
                          // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                          this.element.querySelector("option[placeholder]")
                        );
                      },
                      enumerable: false,
                      configurable: true,
                    }
                  );
                  Object.defineProperty(
                    WrappedSelect.prototype,
                    "optionGroups",
                    {
                      get: function () {
                        return Array.from(
                          this.element.getElementsByTagName("OPTGROUP")
                        );
                      },
                      enumerable: false,
                      configurable: true,
                    }
                  );
                  Object.defineProperty(WrappedSelect.prototype, "options", {
                    get: function () {
                      return Array.from(this.element.options);
                    },
                    set: function (options) {
                      var _this = this;
                      var fragment = document.createDocumentFragment();
                      var addOptionToFragment = function (data) {
                        // Create a standard select option
                        var option = _this.template(data);
                        // Append it to fragment
                        fragment.appendChild(option);
                      };
                      // Add each list item to list
                      options.forEach(function (optionData) {
                        return addOptionToFragment(optionData);
                      });
                      this.appendDocFragment(fragment);
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  WrappedSelect.prototype.appendDocFragment = function (
                    fragment
                  ) {
                    this.element.innerHTML = "";
                    this.element.appendChild(fragment);
                  };
                  return WrappedSelect;
                })(wrapped_element_1.default);
                exports["default"] = WrappedSelect;

                /***/
              },

              /***/ 883: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.SCROLLING_SPEED =
                  exports.SELECT_MULTIPLE_TYPE =
                  exports.SELECT_ONE_TYPE =
                  exports.TEXT_TYPE =
                  exports.KEY_CODES =
                  exports.ACTION_TYPES =
                  exports.EVENTS =
                    void 0;
                exports.EVENTS = {
                  showDropdown: "showDropdown",
                  hideDropdown: "hideDropdown",
                  change: "change",
                  choice: "choice",
                  search: "search",
                  addItem: "addItem",
                  removeItem: "removeItem",
                  highlightItem: "highlightItem",
                  highlightChoice: "highlightChoice",
                  unhighlightItem: "unhighlightItem",
                };
                exports.ACTION_TYPES = {
                  ADD_CHOICE: "ADD_CHOICE",
                  FILTER_CHOICES: "FILTER_CHOICES",
                  ACTIVATE_CHOICES: "ACTIVATE_CHOICES",
                  CLEAR_CHOICES: "CLEAR_CHOICES",
                  ADD_GROUP: "ADD_GROUP",
                  ADD_ITEM: "ADD_ITEM",
                  REMOVE_ITEM: "REMOVE_ITEM",
                  HIGHLIGHT_ITEM: "HIGHLIGHT_ITEM",
                  CLEAR_ALL: "CLEAR_ALL",
                  RESET_TO: "RESET_TO",
                  SET_IS_LOADING: "SET_IS_LOADING",
                };
                exports.KEY_CODES = {
                  BACK_KEY: 46,
                  DELETE_KEY: 8,
                  ENTER_KEY: 13,
                  A_KEY: 65,
                  ESC_KEY: 27,
                  UP_KEY: 38,
                  DOWN_KEY: 40,
                  PAGE_UP_KEY: 33,
                  PAGE_DOWN_KEY: 34,
                };
                exports.TEXT_TYPE = "text";
                exports.SELECT_ONE_TYPE = "select-one";
                exports.SELECT_MULTIPLE_TYPE = "select-multiple";
                exports.SCROLLING_SPEED = 4;

                /***/
              },

              /***/ 789: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_98200__
              ) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.DEFAULT_CONFIG = exports.DEFAULT_CLASSNAMES = void 0;
                var utils_1 = __nested_webpack_require_98200__(799);
                exports.DEFAULT_CLASSNAMES = {
                  containerOuter: "choices",
                  containerInner: "choices__inner",
                  input: "choices__input",
                  inputCloned: "choices__input--cloned",
                  list: "choices__list",
                  listItems: "choices__list--multiple",
                  listSingle: "choices__list--single",
                  listDropdown: "choices__list--dropdown",
                  item: "choices__item",
                  itemSelectable: "choices__item--selectable",
                  itemDisabled: "choices__item--disabled",
                  itemChoice: "choices__item--choice",
                  placeholder: "choices__placeholder",
                  group: "choices__group",
                  groupHeading: "choices__heading",
                  button: "choices__button",
                  activeState: "is-active",
                  focusState: "is-focused",
                  openState: "is-open",
                  disabledState: "is-disabled",
                  highlightedState: "is-highlighted",
                  selectedState: "is-selected",
                  flippedState: "is-flipped",
                  loadingState: "is-loading",
                  noResults: "has-no-results",
                  noChoices: "has-no-choices",
                };
                exports.DEFAULT_CONFIG = {
                  items: [],
                  choices: [],
                  silent: false,
                  renderChoiceLimit: -1,
                  maxItemCount: -1,
                  addItems: true,
                  addItemFilter: null,
                  removeItems: true,
                  removeItemButton: false,
                  editItems: false,
                  allowHTML: true,
                  duplicateItemsAllowed: true,
                  delimiter: ",",
                  paste: true,
                  searchEnabled: true,
                  searchChoices: true,
                  searchFloor: 1,
                  searchResultLimit: 4,
                  searchFields: ["label", "value"],
                  position: "auto",
                  resetScrollPosition: true,
                  shouldSort: true,
                  shouldSortItems: false,
                  sorter: utils_1.sortByAlpha,
                  placeholder: true,
                  placeholderValue: null,
                  searchPlaceholderValue: null,
                  prependValue: null,
                  appendValue: null,
                  renderSelectedChoices: "auto",
                  loadingText: "Loading...",
                  noResultsText: "No results found",
                  noChoicesText: "No choices to choose from",
                  itemSelectText: "Press to select",
                  uniqueItemText: "Only unique values can be added",
                  customAddItemText:
                    "Only values matching specific conditions can be added",
                  addItemText: function (value) {
                    return 'Press Enter to add <b>"'.concat(
                      (0, utils_1.sanitise)(value),
                      '"</b>'
                    );
                  },
                  maxItemText: function (maxItemCount) {
                    return "Only ".concat(maxItemCount, " values can be added");
                  },
                  valueComparer: function (value1, value2) {
                    return value1 === value2;
                  },
                  fuseOptions: {
                    includeScore: true,
                  },
                  labelId: "",
                  callbackOnInit: null,
                  callbackOnCreateTemplates: null,
                  classNames: exports.DEFAULT_CLASSNAMES,
                };

                /***/
              },

              /***/ 18: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 978: /***/ function (__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 948: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 359: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 285: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 533: /***/ function (__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 187: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_101824__
              ) {
                var __createBinding =
                  (this && this.__createBinding) ||
                  (Object.create
                    ? function (o, m, k, k2) {
                        if (k2 === undefined) k2 = k;
                        var desc = Object.getOwnPropertyDescriptor(m, k);
                        if (
                          !desc ||
                          ("get" in desc
                            ? !m.__esModule
                            : desc.writable || desc.configurable)
                        ) {
                          desc = {
                            enumerable: true,
                            get: function () {
                              return m[k];
                            },
                          };
                        }
                        Object.defineProperty(o, k2, desc);
                      }
                    : function (o, m, k, k2) {
                        if (k2 === undefined) k2 = k;
                        o[k2] = m[k];
                      });
                var __exportStar =
                  (this && this.__exportStar) ||
                  function (m, exports) {
                    for (var p in m)
                      if (
                        p !== "default" &&
                        !Object.prototype.hasOwnProperty.call(exports, p)
                      )
                        __createBinding(exports, m, p);
                  };
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                __exportStar(__nested_webpack_require_101824__(18), exports);
                __exportStar(__nested_webpack_require_101824__(978), exports);
                __exportStar(__nested_webpack_require_101824__(948), exports);
                __exportStar(__nested_webpack_require_101824__(359), exports);
                __exportStar(__nested_webpack_require_101824__(285), exports);
                __exportStar(__nested_webpack_require_101824__(533), exports);
                __exportStar(__nested_webpack_require_101824__(287), exports);
                __exportStar(__nested_webpack_require_101824__(132), exports);
                __exportStar(__nested_webpack_require_101824__(837), exports);
                __exportStar(__nested_webpack_require_101824__(598), exports);
                __exportStar(__nested_webpack_require_101824__(369), exports);
                __exportStar(__nested_webpack_require_101824__(37), exports);
                __exportStar(__nested_webpack_require_101824__(47), exports);
                __exportStar(__nested_webpack_require_101824__(923), exports);
                __exportStar(__nested_webpack_require_101824__(876), exports);

                /***/
              },

              /***/ 287: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 132: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 837: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 598: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 37: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 369: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 47: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 923: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 876: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });

                /***/
              },

              /***/ 799: /***/ function (__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.parseCustomProperties =
                  exports.diff =
                  exports.cloneObject =
                  exports.existsInArray =
                  exports.dispatchEvent =
                  exports.sortByScore =
                  exports.sortByAlpha =
                  exports.strToEl =
                  exports.sanitise =
                  exports.isScrolledIntoView =
                  exports.getAdjacentEl =
                  exports.wrap =
                  exports.isType =
                  exports.getType =
                  exports.generateId =
                  exports.generateChars =
                  exports.getRandomNumber =
                    void 0;
                var getRandomNumber = function (min, max) {
                  return Math.floor(Math.random() * (max - min) + min);
                };
                exports.getRandomNumber = getRandomNumber;
                var generateChars = function (length) {
                  return Array.from(
                    {
                      length: length,
                    },
                    function () {
                      return (0, exports.getRandomNumber)(0, 36).toString(36);
                    }
                  ).join("");
                };
                exports.generateChars = generateChars;
                var generateId = function (element, prefix) {
                  var id =
                    element.id ||
                    (element.name &&
                      ""
                        .concat(element.name, "-")
                        .concat((0, exports.generateChars)(2))) ||
                    (0, exports.generateChars)(4);
                  id = id.replace(/(:|\.|\[|\]|,)/g, "");
                  id = "".concat(prefix, "-").concat(id);
                  return id;
                };
                exports.generateId = generateId;
                var getType = function (obj) {
                  return Object.prototype.toString.call(obj).slice(8, -1);
                };
                exports.getType = getType;
                var isType = function (type, obj) {
                  return (
                    obj !== undefined &&
                    obj !== null &&
                    (0, exports.getType)(obj) === type
                  );
                };
                exports.isType = isType;
                var wrap = function (element, wrapper) {
                  if (wrapper === void 0) {
                    wrapper = document.createElement("div");
                  }
                  if (element.parentNode) {
                    if (element.nextSibling) {
                      element.parentNode.insertBefore(
                        wrapper,
                        element.nextSibling
                      );
                    } else {
                      element.parentNode.appendChild(wrapper);
                    }
                  }
                  return wrapper.appendChild(element);
                };
                exports.wrap = wrap;
                var getAdjacentEl = function (startEl, selector, direction) {
                  if (direction === void 0) {
                    direction = 1;
                  }
                  var prop = "".concat(
                    direction > 0 ? "next" : "previous",
                    "ElementSibling"
                  );
                  var sibling = startEl[prop];
                  while (sibling) {
                    if (sibling.matches(selector)) {
                      return sibling;
                    }
                    sibling = sibling[prop];
                  }
                  return sibling;
                };
                exports.getAdjacentEl = getAdjacentEl;
                var isScrolledIntoView = function (element, parent, direction) {
                  if (direction === void 0) {
                    direction = 1;
                  }
                  if (!element) {
                    return false;
                  }
                  var isVisible;
                  if (direction > 0) {
                    // In view from bottom
                    isVisible =
                      parent.scrollTop + parent.offsetHeight >=
                      element.offsetTop + element.offsetHeight;
                  } else {
                    // In view from top
                    isVisible = element.offsetTop >= parent.scrollTop;
                  }
                  return isVisible;
                };
                exports.isScrolledIntoView = isScrolledIntoView;
                var sanitise = function (value) {
                  if (typeof value !== "string") {
                    return value;
                  }
                  return value
                    .replace(/&/g, "&amp;")
                    .replace(/>/g, "&gt;")
                    .replace(/</g, "&lt;")
                    .replace(/"/g, "&quot;");
                };
                exports.sanitise = sanitise;
                exports.strToEl = (function () {
                  var tmpEl = document.createElement("div");
                  return function (str) {
                    var cleanedInput = str.trim();
                    tmpEl.innerHTML = cleanedInput;
                    var firldChild = tmpEl.children[0];
                    while (tmpEl.firstChild) {
                      tmpEl.removeChild(tmpEl.firstChild);
                    }
                    return firldChild;
                  };
                })();
                var sortByAlpha = function (_a, _b) {
                  var value = _a.value,
                    _c = _a.label,
                    label = _c === void 0 ? value : _c;
                  var value2 = _b.value,
                    _d = _b.label,
                    label2 = _d === void 0 ? value2 : _d;
                  return label.localeCompare(label2, [], {
                    sensitivity: "base",
                    ignorePunctuation: true,
                    numeric: true,
                  });
                };
                exports.sortByAlpha = sortByAlpha;
                var sortByScore = function (a, b) {
                  var _a = a.score,
                    scoreA = _a === void 0 ? 0 : _a;
                  var _b = b.score,
                    scoreB = _b === void 0 ? 0 : _b;
                  return scoreA - scoreB;
                };
                exports.sortByScore = sortByScore;
                var dispatchEvent = function (element, type, customArgs) {
                  if (customArgs === void 0) {
                    customArgs = null;
                  }
                  var event = new CustomEvent(type, {
                    detail: customArgs,
                    bubbles: true,
                    cancelable: true,
                  });
                  return element.dispatchEvent(event);
                };
                exports.dispatchEvent = dispatchEvent;
                var existsInArray = function (array, value, key) {
                  if (key === void 0) {
                    key = "value";
                  }
                  return array.some(function (item) {
                    if (typeof value === "string") {
                      return item[key] === value.trim();
                    }
                    return item[key] === value;
                  });
                };
                exports.existsInArray = existsInArray;
                var cloneObject = function (obj) {
                  return JSON.parse(JSON.stringify(obj));
                };
                exports.cloneObject = cloneObject;
                /**
                 * Returns an array of keys present on the first but missing on the second object
                 */
                var diff = function (a, b) {
                  var aKeys = Object.keys(a).sort();
                  var bKeys = Object.keys(b).sort();
                  return aKeys.filter(function (i) {
                    return bKeys.indexOf(i) < 0;
                  });
                };
                exports.diff = diff;
                var parseCustomProperties = function (customProperties) {
                  if (typeof customProperties !== "undefined") {
                    try {
                      return JSON.parse(customProperties);
                    } catch (e) {
                      return customProperties;
                    }
                  }
                  return {};
                };
                exports.parseCustomProperties = parseCustomProperties;

                /***/
              },

              /***/ 273: /***/ function (__unused_webpack_module, exports) {
                var __spreadArray =
                  (this && this.__spreadArray) ||
                  function (to, from, pack) {
                    if (pack || arguments.length === 2)
                      for (var i = 0, l = from.length, ar; i < l; i++) {
                        if (ar || !(i in from)) {
                          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                          ar[i] = from[i];
                        }
                      }
                    return to.concat(ar || Array.prototype.slice.call(from));
                  };
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function choices(state, action) {
                  if (state === void 0) {
                    state = exports.defaultState;
                  }
                  if (action === void 0) {
                    action = {};
                  }
                  switch (action.type) {
                    case "ADD_CHOICE": {
                      var addChoiceAction = action;
                      var choice = {
                        id: addChoiceAction.id,
                        elementId: addChoiceAction.elementId,
                        groupId: addChoiceAction.groupId,
                        value: addChoiceAction.value,
                        label: addChoiceAction.label || addChoiceAction.value,
                        disabled: addChoiceAction.disabled || false,
                        selected: false,
                        active: true,
                        score: 9999,
                        customProperties: addChoiceAction.customProperties,
                        placeholder: addChoiceAction.placeholder || false,
                      };
                      /*
          A disabled choice appears in the choice dropdown but cannot be selected
          A selected choice has been added to the passed input's value (added as an item)
          An active choice appears within the choice dropdown
        */
                      return __spreadArray(
                        __spreadArray([], state, true),
                        [choice],
                        false
                      );
                    }
                    case "ADD_ITEM": {
                      var addItemAction_1 = action;
                      // When an item is added and it has an associated choice,
                      // we want to disable it so it can't be chosen again
                      if (addItemAction_1.choiceId > -1) {
                        return state.map(function (obj) {
                          var choice = obj;
                          if (
                            choice.id ===
                            parseInt("".concat(addItemAction_1.choiceId), 10)
                          ) {
                            choice.selected = true;
                          }
                          return choice;
                        });
                      }
                      return state;
                    }
                    case "REMOVE_ITEM": {
                      var removeItemAction_1 = action;
                      // When an item is removed and it has an associated choice,
                      // we want to re-enable it so it can be chosen again
                      if (
                        removeItemAction_1.choiceId &&
                        removeItemAction_1.choiceId > -1
                      ) {
                        return state.map(function (obj) {
                          var choice = obj;
                          if (
                            choice.id ===
                            parseInt("".concat(removeItemAction_1.choiceId), 10)
                          ) {
                            choice.selected = false;
                          }
                          return choice;
                        });
                      }
                      return state;
                    }
                    case "FILTER_CHOICES": {
                      var filterChoicesAction_1 = action;
                      return state.map(function (obj) {
                        var choice = obj;
                        // Set active state based on whether choice is
                        // within filtered results
                        choice.active = filterChoicesAction_1.results.some(
                          function (_a) {
                            var item = _a.item,
                              score = _a.score;
                            if (item.id === choice.id) {
                              choice.score = score;
                              return true;
                            }
                            return false;
                          }
                        );
                        return choice;
                      });
                    }
                    case "ACTIVATE_CHOICES": {
                      var activateChoicesAction_1 = action;
                      return state.map(function (obj) {
                        var choice = obj;
                        choice.active = activateChoicesAction_1.active;
                        return choice;
                      });
                    }
                    case "CLEAR_CHOICES": {
                      return exports.defaultState;
                    }
                    default: {
                      return state;
                    }
                  }
                }
                exports["default"] = choices;

                /***/
              },

              /***/ 871: /***/ function (__unused_webpack_module, exports) {
                var __spreadArray =
                  (this && this.__spreadArray) ||
                  function (to, from, pack) {
                    if (pack || arguments.length === 2)
                      for (var i = 0, l = from.length, ar; i < l; i++) {
                        if (ar || !(i in from)) {
                          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                          ar[i] = from[i];
                        }
                      }
                    return to.concat(ar || Array.prototype.slice.call(from));
                  };
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function groups(state, action) {
                  if (state === void 0) {
                    state = exports.defaultState;
                  }
                  if (action === void 0) {
                    action = {};
                  }
                  switch (action.type) {
                    case "ADD_GROUP": {
                      var addGroupAction = action;
                      return __spreadArray(
                        __spreadArray([], state, true),
                        [
                          {
                            id: addGroupAction.id,
                            value: addGroupAction.value,
                            active: addGroupAction.active,
                            disabled: addGroupAction.disabled,
                          },
                        ],
                        false
                      );
                    }
                    case "CLEAR_CHOICES": {
                      return [];
                    }
                    default: {
                      return state;
                    }
                  }
                }
                exports["default"] = groups;

                /***/
              },

              /***/ 655: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_114916__
              ) {
                var __importDefault =
                  (this && this.__importDefault) ||
                  function (mod) {
                    return mod && mod.__esModule
                      ? mod
                      : {
                          default: mod,
                        };
                  };
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.defaultState = void 0;
                var redux_1 = __nested_webpack_require_114916__(791);
                var items_1 = __importDefault(
                  __nested_webpack_require_114916__(52)
                );
                var groups_1 = __importDefault(
                  __nested_webpack_require_114916__(871)
                );
                var choices_1 = __importDefault(
                  __nested_webpack_require_114916__(273)
                );
                var loading_1 = __importDefault(
                  __nested_webpack_require_114916__(502)
                );
                var utils_1 = __nested_webpack_require_114916__(799);
                exports.defaultState = {
                  groups: [],
                  items: [],
                  choices: [],
                  loading: false,
                };
                var appReducer = (0, redux_1.combineReducers)({
                  items: items_1.default,
                  groups: groups_1.default,
                  choices: choices_1.default,
                  loading: loading_1.default,
                });
                var rootReducer = function (passedState, action) {
                  var state = passedState;
                  // If we are clearing all items, groups and options we reassign
                  // state and then pass that state to our proper reducer. This isn't
                  // mutating our actual state
                  // See: http://stackoverflow.com/a/35641992
                  if (action.type === "CLEAR_ALL") {
                    state = exports.defaultState;
                  } else if (action.type === "RESET_TO") {
                    return (0, utils_1.cloneObject)(action.state);
                  }
                  return appReducer(state, action);
                };
                exports["default"] = rootReducer;

                /***/
              },

              /***/ 52: /***/ function (__unused_webpack_module, exports) {
                var __spreadArray =
                  (this && this.__spreadArray) ||
                  function (to, from, pack) {
                    if (pack || arguments.length === 2)
                      for (var i = 0, l = from.length, ar; i < l; i++) {
                        if (ar || !(i in from)) {
                          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                          ar[i] = from[i];
                        }
                      }
                    return to.concat(ar || Array.prototype.slice.call(from));
                  };
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function items(state, action) {
                  if (state === void 0) {
                    state = exports.defaultState;
                  }
                  if (action === void 0) {
                    action = {};
                  }
                  switch (action.type) {
                    case "ADD_ITEM": {
                      var addItemAction = action;
                      // Add object to items array
                      var newState = __spreadArray(
                        __spreadArray([], state, true),
                        [
                          {
                            id: addItemAction.id,
                            choiceId: addItemAction.choiceId,
                            groupId: addItemAction.groupId,
                            value: addItemAction.value,
                            label: addItemAction.label,
                            active: true,
                            highlighted: false,
                            customProperties: addItemAction.customProperties,
                            placeholder: addItemAction.placeholder || false,
                            keyCode: null,
                          },
                        ],
                        false
                      );
                      return newState.map(function (obj) {
                        var item = obj;
                        item.highlighted = false;
                        return item;
                      });
                    }
                    case "REMOVE_ITEM": {
                      // Set item to inactive
                      return state.map(function (obj) {
                        var item = obj;
                        if (item.id === action.id) {
                          item.active = false;
                        }
                        return item;
                      });
                    }
                    case "HIGHLIGHT_ITEM": {
                      var highlightItemAction_1 = action;
                      return state.map(function (obj) {
                        var item = obj;
                        if (item.id === highlightItemAction_1.id) {
                          item.highlighted = highlightItemAction_1.highlighted;
                        }
                        return item;
                      });
                    }
                    default: {
                      return state;
                    }
                  }
                }
                exports["default"] = items;

                /***/
              },

              /***/ 502: /***/ function (__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                exports.defaultState = void 0;
                exports.defaultState = false;
                var general = function (state, action) {
                  if (state === void 0) {
                    state = exports.defaultState;
                  }
                  if (action === void 0) {
                    action = {};
                  }
                  switch (action.type) {
                    case "SET_IS_LOADING": {
                      return action.isLoading;
                    }
                    default: {
                      return state;
                    }
                  }
                };
                exports["default"] = general;

                /***/
              },

              /***/ 744: /***/ function (
                __unused_webpack_module,
                exports,
                __nested_webpack_require_119022__
              ) {
                var __spreadArray =
                  (this && this.__spreadArray) ||
                  function (to, from, pack) {
                    if (pack || arguments.length === 2)
                      for (var i = 0, l = from.length, ar; i < l; i++) {
                        if (ar || !(i in from)) {
                          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                          ar[i] = from[i];
                        }
                      }
                    return to.concat(ar || Array.prototype.slice.call(from));
                  };
                var __importDefault =
                  (this && this.__importDefault) ||
                  function (mod) {
                    return mod && mod.__esModule
                      ? mod
                      : {
                          default: mod,
                        };
                  };
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                /* eslint-disable @typescript-eslint/no-explicit-any */
                var redux_1 = __nested_webpack_require_119022__(791);
                var index_1 = __importDefault(
                  __nested_webpack_require_119022__(655)
                );
                var Store = /** @class */ (function () {
                  function Store() {
                    this._store = (0, redux_1.createStore)(
                      index_1.default,
                      window.__REDUX_DEVTOOLS_EXTENSION__ &&
                        window.__REDUX_DEVTOOLS_EXTENSION__()
                    );
                  }
                  /**
                   * Subscribe store to function call (wrapped Redux method)
                   */
                  Store.prototype.subscribe = function (onChange) {
                    this._store.subscribe(onChange);
                  };
                  /**
                   * Dispatch event to store (wrapped Redux method)
                   */
                  Store.prototype.dispatch = function (action) {
                    this._store.dispatch(action);
                  };
                  Object.defineProperty(Store.prototype, "state", {
                    /**
                     * Get store object (wrapping Redux method)
                     */
                    get: function () {
                      return this._store.getState();
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(Store.prototype, "items", {
                    /**
                     * Get items from store
                     */
                    get: function () {
                      return this.state.items;
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(Store.prototype, "activeItems", {
                    /**
                     * Get active items from store
                     */
                    get: function () {
                      return this.items.filter(function (item) {
                        return item.active === true;
                      });
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(
                    Store.prototype,
                    "highlightedActiveItems",
                    {
                      /**
                       * Get highlighted items from store
                       */
                      get: function () {
                        return this.items.filter(function (item) {
                          return item.active && item.highlighted;
                        });
                      },
                      enumerable: false,
                      configurable: true,
                    }
                  );
                  Object.defineProperty(Store.prototype, "choices", {
                    /**
                     * Get choices from store
                     */
                    get: function () {
                      return this.state.choices;
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(Store.prototype, "activeChoices", {
                    /**
                     * Get active choices from store
                     */
                    get: function () {
                      return this.choices.filter(function (choice) {
                        return choice.active === true;
                      });
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(Store.prototype, "selectableChoices", {
                    /**
                     * Get selectable choices from store
                     */
                    get: function () {
                      return this.choices.filter(function (choice) {
                        return choice.disabled !== true;
                      });
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(Store.prototype, "searchableChoices", {
                    /**
                     * Get choices that can be searched (excluding placeholders)
                     */
                    get: function () {
                      return this.selectableChoices.filter(function (choice) {
                        return choice.placeholder !== true;
                      });
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(Store.prototype, "placeholderChoice", {
                    /**
                     * Get placeholder choice from store
                     */
                    get: function () {
                      return __spreadArray([], this.choices, true)
                        .reverse()
                        .find(function (choice) {
                          return choice.placeholder === true;
                        });
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(Store.prototype, "groups", {
                    /**
                     * Get groups from store
                     */
                    get: function () {
                      return this.state.groups;
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  Object.defineProperty(Store.prototype, "activeGroups", {
                    /**
                     * Get active groups from store
                     */
                    get: function () {
                      var _a = this,
                        groups = _a.groups,
                        choices = _a.choices;
                      return groups.filter(function (group) {
                        var isActive =
                          group.active === true && group.disabled === false;
                        var hasActiveOptions = choices.some(function (choice) {
                          return (
                            choice.active === true && choice.disabled === false
                          );
                        });
                        return isActive && hasActiveOptions;
                      }, []);
                    },
                    enumerable: false,
                    configurable: true,
                  });
                  /**
                   * Get loading state from store
                   */
                  Store.prototype.isLoading = function () {
                    return this.state.loading;
                  };
                  /**
                   * Get single choice by it's ID
                   */
                  Store.prototype.getChoiceById = function (id) {
                    return this.activeChoices.find(function (choice) {
                      return choice.id === parseInt(id, 10);
                    });
                  };
                  /**
                   * Get group by group id
                   */
                  Store.prototype.getGroupById = function (id) {
                    return this.groups.find(function (group) {
                      return group.id === id;
                    });
                  };
                  return Store;
                })();
                exports["default"] = Store;

                /***/
              },

              /***/ 686: /***/ function (__unused_webpack_module, exports) {
                /**
                 * Helpers to create HTML elements used by Choices
                 * Can be overridden by providing `callbackOnCreateTemplates` option
                 */
                Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                var templates = {
                  containerOuter: function (
                    _a,
                    dir,
                    isSelectElement,
                    isSelectOneElement,
                    searchEnabled,
                    passedElementType,
                    labelId
                  ) {
                    var containerOuter = _a.classNames.containerOuter;
                    var div = Object.assign(document.createElement("div"), {
                      className: containerOuter,
                    });
                    div.dataset.type = passedElementType;
                    if (dir) {
                      div.dir = dir;
                    }
                    if (isSelectOneElement) {
                      div.tabIndex = 0;
                    }
                    if (isSelectElement) {
                      div.setAttribute(
                        "role",
                        searchEnabled ? "combobox" : "listbox"
                      );
                      if (searchEnabled) {
                        div.setAttribute("aria-autocomplete", "list");
                      }
                    }
                    div.setAttribute("aria-haspopup", "true");
                    div.setAttribute("aria-expanded", "false");
                    if (labelId) {
                      div.setAttribute("aria-labelledby", labelId);
                    }
                    return div;
                  },
                  containerInner: function (_a) {
                    var containerInner = _a.classNames.containerInner;
                    return Object.assign(document.createElement("div"), {
                      className: containerInner,
                    });
                  },
                  itemList: function (_a, isSelectOneElement) {
                    var _b = _a.classNames,
                      list = _b.list,
                      listSingle = _b.listSingle,
                      listItems = _b.listItems;
                    return Object.assign(document.createElement("div"), {
                      className: ""
                        .concat(list, " ")
                        .concat(isSelectOneElement ? listSingle : listItems),
                    });
                  },
                  placeholder: function (_a, value) {
                    var _b;
                    var allowHTML = _a.allowHTML,
                      placeholder = _a.classNames.placeholder;
                    return Object.assign(
                      document.createElement("div"),
                      ((_b = {
                        className: placeholder,
                      }),
                      (_b[allowHTML ? "innerHTML" : "innerText"] = value),
                      _b)
                    );
                  },
                  item: function (_a, _b, removeItemButton) {
                    var _c, _d;
                    var allowHTML = _a.allowHTML,
                      _e = _a.classNames,
                      item = _e.item,
                      button = _e.button,
                      highlightedState = _e.highlightedState,
                      itemSelectable = _e.itemSelectable,
                      placeholder = _e.placeholder;
                    var id = _b.id,
                      value = _b.value,
                      label = _b.label,
                      customProperties = _b.customProperties,
                      active = _b.active,
                      disabled = _b.disabled,
                      highlighted = _b.highlighted,
                      isPlaceholder = _b.placeholder;
                    var div = Object.assign(
                      document.createElement("div"),
                      ((_c = {
                        className: item,
                      }),
                      (_c[allowHTML ? "innerHTML" : "innerText"] = label),
                      _c)
                    );
                    Object.assign(div.dataset, {
                      item: "",
                      id: id,
                      value: value,
                      customProperties: customProperties,
                    });
                    if (active) {
                      div.setAttribute("aria-selected", "true");
                    }
                    if (disabled) {
                      div.setAttribute("aria-disabled", "true");
                    }
                    if (isPlaceholder) {
                      div.classList.add(placeholder);
                    }
                    div.classList.add(
                      highlighted ? highlightedState : itemSelectable
                    );
                    if (removeItemButton) {
                      if (disabled) {
                        div.classList.remove(itemSelectable);
                      }
                      div.dataset.deletable = "";
                      /** @todo This MUST be localizable, not hardcoded! */
                      var REMOVE_ITEM_TEXT = "Remove item";
                      var removeButton = Object.assign(
                        document.createElement("button"),
                        ((_d = {
                          type: "button",
                          className: button,
                        }),
                        (_d[allowHTML ? "innerHTML" : "innerText"] =
                          REMOVE_ITEM_TEXT),
                        _d)
                      );
                      removeButton.setAttribute(
                        "aria-label",
                        "".concat(REMOVE_ITEM_TEXT, ": '").concat(value, "'")
                      );
                      removeButton.dataset.button = "";
                      div.appendChild(removeButton);
                    }
                    return div;
                  },
                  choiceList: function (_a, isSelectOneElement) {
                    var list = _a.classNames.list;
                    var div = Object.assign(document.createElement("div"), {
                      className: list,
                    });
                    if (!isSelectOneElement) {
                      div.setAttribute("aria-multiselectable", "true");
                    }
                    div.setAttribute("role", "listbox");
                    return div;
                  },
                  choiceGroup: function (_a, _b) {
                    var _c;
                    var allowHTML = _a.allowHTML,
                      _d = _a.classNames,
                      group = _d.group,
                      groupHeading = _d.groupHeading,
                      itemDisabled = _d.itemDisabled;
                    var id = _b.id,
                      value = _b.value,
                      disabled = _b.disabled;
                    var div = Object.assign(document.createElement("div"), {
                      className: ""
                        .concat(group, " ")
                        .concat(disabled ? itemDisabled : ""),
                    });
                    div.setAttribute("role", "group");
                    Object.assign(div.dataset, {
                      group: "",
                      id: id,
                      value: value,
                    });
                    if (disabled) {
                      div.setAttribute("aria-disabled", "true");
                    }
                    div.appendChild(
                      Object.assign(
                        document.createElement("div"),
                        ((_c = {
                          className: groupHeading,
                        }),
                        (_c[allowHTML ? "innerHTML" : "innerText"] = value),
                        _c)
                      )
                    );
                    return div;
                  },
                  choice: function (_a, _b, selectText) {
                    var _c;
                    var allowHTML = _a.allowHTML,
                      _d = _a.classNames,
                      item = _d.item,
                      itemChoice = _d.itemChoice,
                      itemSelectable = _d.itemSelectable,
                      selectedState = _d.selectedState,
                      itemDisabled = _d.itemDisabled,
                      placeholder = _d.placeholder;
                    var id = _b.id,
                      value = _b.value,
                      label = _b.label,
                      groupId = _b.groupId,
                      elementId = _b.elementId,
                      isDisabled = _b.disabled,
                      isSelected = _b.selected,
                      isPlaceholder = _b.placeholder;
                    var div = Object.assign(
                      document.createElement("div"),
                      ((_c = {
                        id: elementId,
                      }),
                      (_c[allowHTML ? "innerHTML" : "innerText"] = label),
                      (_c.className = "".concat(item, " ").concat(itemChoice)),
                      _c)
                    );
                    if (isSelected) {
                      div.classList.add(selectedState);
                    }
                    if (isPlaceholder) {
                      div.classList.add(placeholder);
                    }
                    div.setAttribute(
                      "role",
                      groupId && groupId > 0 ? "treeitem" : "option"
                    );
                    Object.assign(div.dataset, {
                      choice: "",
                      id: id,
                      value: value,
                      selectText: selectText,
                    });
                    if (isDisabled) {
                      div.classList.add(itemDisabled);
                      div.dataset.choiceDisabled = "";
                      div.setAttribute("aria-disabled", "true");
                    } else {
                      div.classList.add(itemSelectable);
                      div.dataset.choiceSelectable = "";
                    }
                    return div;
                  },
                  input: function (_a, placeholderValue) {
                    var _b = _a.classNames,
                      input = _b.input,
                      inputCloned = _b.inputCloned;
                    var inp = Object.assign(document.createElement("input"), {
                      type: "search",
                      name: "search_terms",
                      className: "".concat(input, " ").concat(inputCloned),
                      autocomplete: "off",
                      autocapitalize: "off",
                      spellcheck: false,
                    });
                    inp.setAttribute("role", "textbox");
                    inp.setAttribute("aria-autocomplete", "list");
                    inp.setAttribute("aria-label", placeholderValue);
                    return inp;
                  },
                  dropdown: function (_a) {
                    var _b = _a.classNames,
                      list = _b.list,
                      listDropdown = _b.listDropdown;
                    var div = document.createElement("div");
                    div.classList.add(list, listDropdown);
                    div.setAttribute("aria-expanded", "false");
                    return div;
                  },
                  notice: function (_a, innerText, type) {
                    var _b;
                    var allowHTML = _a.allowHTML,
                      _c = _a.classNames,
                      item = _c.item,
                      itemChoice = _c.itemChoice,
                      noResults = _c.noResults,
                      noChoices = _c.noChoices;
                    if (type === void 0) {
                      type = "";
                    }
                    var classes = [item, itemChoice];
                    if (type === "no-choices") {
                      classes.push(noChoices);
                    } else if (type === "no-results") {
                      classes.push(noResults);
                    }
                    return Object.assign(
                      document.createElement("div"),
                      ((_b = {}),
                      (_b[allowHTML ? "innerHTML" : "innerText"] = innerText),
                      (_b.className = classes.join(" ")),
                      _b)
                    );
                  },
                  option: function (_a) {
                    var label = _a.label,
                      value = _a.value,
                      customProperties = _a.customProperties,
                      active = _a.active,
                      disabled = _a.disabled;
                    var opt = new Option(label, value, false, active);
                    if (customProperties) {
                      opt.dataset.customProperties = "".concat(
                        customProperties
                      );
                    }
                    opt.disabled = !!disabled;
                    return opt;
                  },
                };
                exports["default"] = templates;

                /***/
              },

              /***/ 996: /***/ function (module) {
                var isMergeableObject = function isMergeableObject(value) {
                  return isNonNullObject(value) && !isSpecial(value);
                };

                function isNonNullObject(value) {
                  return !!value && typeof value === "object";
                }

                function isSpecial(value) {
                  var stringValue = Object.prototype.toString.call(value);

                  return (
                    stringValue === "[object RegExp]" ||
                    stringValue === "[object Date]" ||
                    isReactElement(value)
                  );
                }

                // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
                var canUseSymbol = typeof Symbol === "function" && Symbol.for;
                var REACT_ELEMENT_TYPE = canUseSymbol
                  ? Symbol.for("react.element")
                  : 0xeac7;

                function isReactElement(value) {
                  return value.$$typeof === REACT_ELEMENT_TYPE;
                }

                function emptyTarget(val) {
                  return Array.isArray(val) ? [] : {};
                }

                function cloneUnlessOtherwiseSpecified(value, options) {
                  return options.clone !== false &&
                    options.isMergeableObject(value)
                    ? deepmerge(emptyTarget(value), value, options)
                    : value;
                }

                function defaultArrayMerge(target, source, options) {
                  return target.concat(source).map(function (element) {
                    return cloneUnlessOtherwiseSpecified(element, options);
                  });
                }

                function getMergeFunction(key, options) {
                  if (!options.customMerge) {
                    return deepmerge;
                  }
                  var customMerge = options.customMerge(key);
                  return typeof customMerge === "function"
                    ? customMerge
                    : deepmerge;
                }

                function getEnumerableOwnPropertySymbols(target) {
                  return Object.getOwnPropertySymbols
                    ? Object.getOwnPropertySymbols(target).filter(function (
                        symbol
                      ) {
                        return target.propertyIsEnumerable(symbol);
                      })
                    : [];
                }

                function getKeys(target) {
                  return Object.keys(target).concat(
                    getEnumerableOwnPropertySymbols(target)
                  );
                }

                function propertyIsOnObject(object, property) {
                  try {
                    return property in object;
                  } catch (_) {
                    return false;
                  }
                }

                // Protects from prototype poisoning and unexpected merging up the prototype chain.
                function propertyIsUnsafe(target, key) {
                  return (
                    propertyIsOnObject(target, key) && // Properties are safe to merge if they don't exist in the target yet,
                    !(
                      Object.hasOwnProperty.call(target, key) && // unsafe if they exist up the prototype chain,
                      Object.propertyIsEnumerable.call(target, key)
                    )
                  ); // and also unsafe if they're nonenumerable.
                }

                function mergeObject(target, source, options) {
                  var destination = {};
                  if (options.isMergeableObject(target)) {
                    getKeys(target).forEach(function (key) {
                      destination[key] = cloneUnlessOtherwiseSpecified(
                        target[key],
                        options
                      );
                    });
                  }
                  getKeys(source).forEach(function (key) {
                    if (propertyIsUnsafe(target, key)) {
                      return;
                    }

                    if (
                      propertyIsOnObject(target, key) &&
                      options.isMergeableObject(source[key])
                    ) {
                      destination[key] = getMergeFunction(key, options)(
                        target[key],
                        source[key],
                        options
                      );
                    } else {
                      destination[key] = cloneUnlessOtherwiseSpecified(
                        source[key],
                        options
                      );
                    }
                  });
                  return destination;
                }

                function deepmerge(target, source, options) {
                  options = options || {};
                  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
                  options.isMergeableObject =
                    options.isMergeableObject || isMergeableObject;
                  // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
                  // implementations can use it. The caller may not replace it.
                  options.cloneUnlessOtherwiseSpecified =
                    cloneUnlessOtherwiseSpecified;

                  var sourceIsArray = Array.isArray(source);
                  var targetIsArray = Array.isArray(target);
                  var sourceAndTargetTypesMatch =
                    sourceIsArray === targetIsArray;

                  if (!sourceAndTargetTypesMatch) {
                    return cloneUnlessOtherwiseSpecified(source, options);
                  } else if (sourceIsArray) {
                    return options.arrayMerge(target, source, options);
                  } else {
                    return mergeObject(target, source, options);
                  }
                }

                deepmerge.all = function deepmergeAll(array, options) {
                  if (!Array.isArray(array)) {
                    throw new Error("first argument should be an array");
                  }

                  return array.reduce(function (prev, next) {
                    return deepmerge(prev, next, options);
                  }, {});
                };

                var deepmerge_1 = deepmerge;

                module.exports = deepmerge_1;

                /***/
              },

              /***/ 221: /***/ function (
                __unused_webpack_module,
                __webpack_exports__,
                __nested_webpack_require_136441__
              ) {
                __nested_webpack_require_136441__.r(__webpack_exports__);
                /* harmony export */ __nested_webpack_require_136441__.d(
                  __webpack_exports__,
                  {
                    /* harmony export */ default: function () {
                      return /* binding */ Fuse;
                    },
                    /* harmony export */
                  }
                );
                /**
                 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
                 *
                 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
                 * All Rights Reserved. Apache Software License 2.0
                 *
                 * http://www.apache.org/licenses/LICENSE-2.0
                 */

                function isArray(value) {
                  return !Array.isArray
                    ? getTag(value) === "[object Array]"
                    : Array.isArray(value);
                }

                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
                const INFINITY = 1 / 0;
                function baseToString(value) {
                  // Exit early for strings to avoid a performance hit in some environments.
                  if (typeof value == "string") {
                    return value;
                  }
                  let result = value + "";
                  return result == "0" && 1 / value == -INFINITY
                    ? "-0"
                    : result;
                }

                function toString(value) {
                  return value == null ? "" : baseToString(value);
                }

                function isString(value) {
                  return typeof value === "string";
                }

                function isNumber(value) {
                  return typeof value === "number";
                }

                // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
                function isBoolean(value) {
                  return (
                    value === true ||
                    value === false ||
                    (isObjectLike(value) && getTag(value) == "[object Boolean]")
                  );
                }

                function isObject(value) {
                  return typeof value === "object";
                }

                // Checks if `value` is object-like.
                function isObjectLike(value) {
                  return isObject(value) && value !== null;
                }

                function isDefined(value) {
                  return value !== undefined && value !== null;
                }

                function isBlank(value) {
                  return !value.trim().length;
                }

                // Gets the `toStringTag` of `value`.
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
                function getTag(value) {
                  return value == null
                    ? value === undefined
                      ? "[object Undefined]"
                      : "[object Null]"
                    : Object.prototype.toString.call(value);
                }

                const EXTENDED_SEARCH_UNAVAILABLE =
                  "Extended search is not available";

                const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";

                const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) =>
                  `Invalid value for key ${key}`;

                const PATTERN_LENGTH_TOO_LARGE = (max) =>
                  `Pattern length exceeds max of ${max}.`;

                const MISSING_KEY_PROPERTY = (name) =>
                  `Missing ${name} property in key`;

                const INVALID_KEY_WEIGHT_VALUE = (key) =>
                  `Property 'weight' in key '${key}' must be a positive integer`;

                const hasOwn = Object.prototype.hasOwnProperty;

                class KeyStore {
                  constructor(keys) {
                    this._keys = [];
                    this._keyMap = {};

                    let totalWeight = 0;

                    keys.forEach((key) => {
                      let obj = createKey(key);

                      totalWeight += obj.weight;

                      this._keys.push(obj);
                      this._keyMap[obj.id] = obj;

                      totalWeight += obj.weight;
                    });

                    // Normalize weights so that their sum is equal to 1
                    this._keys.forEach((key) => {
                      key.weight /= totalWeight;
                    });
                  }
                  get(keyId) {
                    return this._keyMap[keyId];
                  }
                  keys() {
                    return this._keys;
                  }
                  toJSON() {
                    return JSON.stringify(this._keys);
                  }
                }

                function createKey(key) {
                  let path = null;
                  let id = null;
                  let src = null;
                  let weight = 1;
                  let getFn = null;

                  if (isString(key) || isArray(key)) {
                    src = key;
                    path = createKeyPath(key);
                    id = createKeyId(key);
                  } else {
                    if (!hasOwn.call(key, "name")) {
                      throw new Error(MISSING_KEY_PROPERTY("name"));
                    }

                    const name = key.name;
                    src = name;

                    if (hasOwn.call(key, "weight")) {
                      weight = key.weight;

                      if (weight <= 0) {
                        throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                      }
                    }

                    path = createKeyPath(name);
                    id = createKeyId(name);
                    getFn = key.getFn;
                  }

                  return { path, id, weight, src, getFn };
                }

                function createKeyPath(key) {
                  return isArray(key) ? key : key.split(".");
                }

                function createKeyId(key) {
                  return isArray(key) ? key.join(".") : key;
                }

                function get(obj, path) {
                  let list = [];
                  let arr = false;

                  const deepGet = (obj, path, index) => {
                    if (!isDefined(obj)) {
                      return;
                    }
                    if (!path[index]) {
                      // If there's no path left, we've arrived at the object we care about.
                      list.push(obj);
                    } else {
                      let key = path[index];

                      const value = obj[key];

                      if (!isDefined(value)) {
                        return;
                      }

                      // If we're at the last value in the path, and if it's a string/number/bool,
                      // add it to the list
                      if (
                        index === path.length - 1 &&
                        (isString(value) || isNumber(value) || isBoolean(value))
                      ) {
                        list.push(toString(value));
                      } else if (isArray(value)) {
                        arr = true;
                        // Search each item in the array.
                        for (let i = 0, len = value.length; i < len; i += 1) {
                          deepGet(value[i], path, index + 1);
                        }
                      } else if (path.length) {
                        // An object. Recurse further.
                        deepGet(value, path, index + 1);
                      }
                    }
                  };

                  // Backwards compatibility (since path used to be a string)
                  deepGet(obj, isString(path) ? path.split(".") : path, 0);

                  return arr ? list : list[0];
                }

                const MatchOptions = {
                  // Whether the matches should be included in the result set. When `true`, each record in the result
                  // set will include the indices of the matched characters.
                  // These can consequently be used for highlighting purposes.
                  includeMatches: false,
                  // When `true`, the matching function will continue to the end of a search pattern even if
                  // a perfect match has already been located in the string.
                  findAllMatches: false,
                  // Minimum number of characters that must be matched before a result is considered a match
                  minMatchCharLength: 1,
                };

                const BasicOptions = {
                  // When `true`, the algorithm continues searching to the end of the input even if a perfect
                  // match is found before the end of the same input.
                  isCaseSensitive: false,
                  // When true, the matching function will continue to the end of a search pattern even if
                  includeScore: false,
                  // List of properties that will be searched. This also supports nested properties.
                  keys: [],
                  // Whether to sort the result list, by score
                  shouldSort: true,
                  // Default sort function: sort by ascending score, ascending index
                  sortFn: (a, b) =>
                    a.score === b.score
                      ? a.idx < b.idx
                        ? -1
                        : 1
                      : a.score < b.score
                      ? -1
                      : 1,
                };

                const FuzzyOptions = {
                  // Approximately where in the text is the pattern expected to be found?
                  location: 0,
                  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
                  // (of both letters and location), a threshold of '1.0' would match anything.
                  threshold: 0.6,
                  // Determines how close the match must be to the fuzzy location (specified above).
                  // An exact letter match which is 'distance' characters away from the fuzzy location
                  // would score as a complete mismatch. A distance of '0' requires the match be at
                  // the exact location specified, a threshold of '1000' would require a perfect match
                  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
                  distance: 100,
                };

                const AdvancedOptions = {
                  // When `true`, it enables the use of unix-like search commands
                  useExtendedSearch: false,
                  // The get function to use when fetching an object's properties.
                  // The default will search nested paths *ie foo.bar.baz*
                  getFn: get,
                  // When `true`, search will ignore `location` and `distance`, so it won't matter
                  // where in the string the pattern appears.
                  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
                  ignoreLocation: false,
                  // When `true`, the calculation for the relevance score (used for sorting) will
                  // ignore the field-length norm.
                  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
                  ignoreFieldNorm: false,
                  // The weight to determine how much field length norm effects scoring.
                  fieldNormWeight: 1,
                };

                var Config = {
                  ...BasicOptions,
                  ...MatchOptions,
                  ...FuzzyOptions,
                  ...AdvancedOptions,
                };

                const SPACE = /[^ ]+/g;

                // Field-length norm: the shorter the field, the higher the weight.
                // Set to 3 decimals to reduce index size.
                function norm(weight = 1, mantissa = 3) {
                  const cache = new Map();
                  const m = Math.pow(10, mantissa);

                  return {
                    get(value) {
                      const numTokens = value.match(SPACE).length;

                      if (cache.has(numTokens)) {
                        return cache.get(numTokens);
                      }

                      // Default function is 1/sqrt(x), weight makes that variable
                      const norm = 1 / Math.pow(numTokens, 0.5 * weight);

                      // In place of `toFixed(mantissa)`, for faster computation
                      const n = parseFloat(Math.round(norm * m) / m);

                      cache.set(numTokens, n);

                      return n;
                    },
                    clear() {
                      cache.clear();
                    },
                  };
                }

                class FuseIndex {
                  constructor({
                    getFn = Config.getFn,
                    fieldNormWeight = Config.fieldNormWeight,
                  } = {}) {
                    this.norm = norm(fieldNormWeight, 3);
                    this.getFn = getFn;
                    this.isCreated = false;

                    this.setIndexRecords();
                  }
                  setSources(docs = []) {
                    this.docs = docs;
                  }
                  setIndexRecords(records = []) {
                    this.records = records;
                  }
                  setKeys(keys = []) {
                    this.keys = keys;
                    this._keysMap = {};
                    keys.forEach((key, idx) => {
                      this._keysMap[key.id] = idx;
                    });
                  }
                  create() {
                    if (this.isCreated || !this.docs.length) {
                      return;
                    }

                    this.isCreated = true;

                    // List is Array<String>
                    if (isString(this.docs[0])) {
                      this.docs.forEach((doc, docIndex) => {
                        this._addString(doc, docIndex);
                      });
                    } else {
                      // List is Array<Object>
                      this.docs.forEach((doc, docIndex) => {
                        this._addObject(doc, docIndex);
                      });
                    }

                    this.norm.clear();
                  }
                  // Adds a doc to the end of the index
                  add(doc) {
                    const idx = this.size();

                    if (isString(doc)) {
                      this._addString(doc, idx);
                    } else {
                      this._addObject(doc, idx);
                    }
                  }
                  // Removes the doc at the specified index of the index
                  removeAt(idx) {
                    this.records.splice(idx, 1);

                    // Change ref index of every subsquent doc
                    for (let i = idx, len = this.size(); i < len; i += 1) {
                      this.records[i].i -= 1;
                    }
                  }
                  getValueForItemAtKeyId(item, keyId) {
                    return item[this._keysMap[keyId]];
                  }
                  size() {
                    return this.records.length;
                  }
                  _addString(doc, docIndex) {
                    if (!isDefined(doc) || isBlank(doc)) {
                      return;
                    }

                    let record = {
                      v: doc,
                      i: docIndex,
                      n: this.norm.get(doc),
                    };

                    this.records.push(record);
                  }
                  _addObject(doc, docIndex) {
                    let record = { i: docIndex, $: {} };

                    // Iterate over every key (i.e, path), and fetch the value at that key
                    this.keys.forEach((key, keyIndex) => {
                      let value = key.getFn
                        ? key.getFn(doc)
                        : this.getFn(doc, key.path);

                      if (!isDefined(value)) {
                        return;
                      }

                      if (isArray(value)) {
                        let subRecords = [];
                        const stack = [{ nestedArrIndex: -1, value }];

                        while (stack.length) {
                          const { nestedArrIndex, value } = stack.pop();

                          if (!isDefined(value)) {
                            continue;
                          }

                          if (isString(value) && !isBlank(value)) {
                            let subRecord = {
                              v: value,
                              i: nestedArrIndex,
                              n: this.norm.get(value),
                            };

                            subRecords.push(subRecord);
                          } else if (isArray(value)) {
                            value.forEach((item, k) => {
                              stack.push({
                                nestedArrIndex: k,
                                value: item,
                              });
                            });
                          } else;
                        }
                        record.$[keyIndex] = subRecords;
                      } else if (isString(value) && !isBlank(value)) {
                        let subRecord = {
                          v: value,
                          n: this.norm.get(value),
                        };

                        record.$[keyIndex] = subRecord;
                      }
                    });

                    this.records.push(record);
                  }
                  toJSON() {
                    return {
                      keys: this.keys,
                      records: this.records,
                    };
                  }
                }

                function createIndex(
                  keys,
                  docs,
                  {
                    getFn = Config.getFn,
                    fieldNormWeight = Config.fieldNormWeight,
                  } = {}
                ) {
                  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
                  myIndex.setKeys(keys.map(createKey));
                  myIndex.setSources(docs);
                  myIndex.create();
                  return myIndex;
                }

                function parseIndex(
                  data,
                  {
                    getFn = Config.getFn,
                    fieldNormWeight = Config.fieldNormWeight,
                  } = {}
                ) {
                  const { keys, records } = data;
                  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
                  myIndex.setKeys(keys);
                  myIndex.setIndexRecords(records);
                  return myIndex;
                }

                function computeScore$1(
                  pattern,
                  {
                    errors = 0,
                    currentLocation = 0,
                    expectedLocation = 0,
                    distance = Config.distance,
                    ignoreLocation = Config.ignoreLocation,
                  } = {}
                ) {
                  const accuracy = errors / pattern.length;

                  if (ignoreLocation) {
                    return accuracy;
                  }

                  const proximity = Math.abs(
                    expectedLocation - currentLocation
                  );

                  if (!distance) {
                    // Dodge divide by zero error.
                    return proximity ? 1.0 : accuracy;
                  }

                  return accuracy + proximity / distance;
                }

                function convertMaskToIndices(
                  matchmask = [],
                  minMatchCharLength = Config.minMatchCharLength
                ) {
                  let indices = [];
                  let start = -1;
                  let end = -1;
                  let i = 0;

                  for (let len = matchmask.length; i < len; i += 1) {
                    let match = matchmask[i];
                    if (match && start === -1) {
                      start = i;
                    } else if (!match && start !== -1) {
                      end = i - 1;
                      if (end - start + 1 >= minMatchCharLength) {
                        indices.push([start, end]);
                      }
                      start = -1;
                    }
                  }

                  // (i-1 - start) + 1 => i - start
                  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
                    indices.push([start, i - 1]);
                  }

                  return indices;
                }

                // Machine word size
                const MAX_BITS = 32;

                function search(
                  text,
                  pattern,
                  patternAlphabet,
                  {
                    location = Config.location,
                    distance = Config.distance,
                    threshold = Config.threshold,
                    findAllMatches = Config.findAllMatches,
                    minMatchCharLength = Config.minMatchCharLength,
                    includeMatches = Config.includeMatches,
                    ignoreLocation = Config.ignoreLocation,
                  } = {}
                ) {
                  if (pattern.length > MAX_BITS) {
                    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
                  }

                  const patternLen = pattern.length;
                  // Set starting location at beginning text and initialize the alphabet.
                  const textLen = text.length;
                  // Handle the case when location > text.length
                  const expectedLocation = Math.max(
                    0,
                    Math.min(location, textLen)
                  );
                  // Highest score beyond which we give up.
                  let currentThreshold = threshold;
                  // Is there a nearby exact match? (speedup)
                  let bestLocation = expectedLocation;

                  // Performance: only computer matches when the minMatchCharLength > 1
                  // OR if `includeMatches` is true.
                  const computeMatches =
                    minMatchCharLength > 1 || includeMatches;
                  // A mask of the matches, used for building the indices
                  const matchMask = computeMatches ? Array(textLen) : [];

                  let index;

                  // Get all exact matches, here for speed up
                  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
                    let score = computeScore$1(pattern, {
                      currentLocation: index,
                      expectedLocation,
                      distance,
                      ignoreLocation,
                    });

                    currentThreshold = Math.min(score, currentThreshold);
                    bestLocation = index + patternLen;

                    if (computeMatches) {
                      let i = 0;
                      while (i < patternLen) {
                        matchMask[index + i] = 1;
                        i += 1;
                      }
                    }
                  }

                  // Reset the best location
                  bestLocation = -1;

                  let lastBitArr = [];
                  let finalScore = 1;
                  let binMax = patternLen + textLen;

                  const mask = 1 << (patternLen - 1);

                  for (let i = 0; i < patternLen; i += 1) {
                    // Scan for the best match; each iteration allows for one more error.
                    // Run a binary search to determine how far from the match location we can stray
                    // at this error level.
                    let binMin = 0;
                    let binMid = binMax;

                    while (binMin < binMid) {
                      const score = computeScore$1(pattern, {
                        errors: i,
                        currentLocation: expectedLocation + binMid,
                        expectedLocation,
                        distance,
                        ignoreLocation,
                      });

                      if (score <= currentThreshold) {
                        binMin = binMid;
                      } else {
                        binMax = binMid;
                      }

                      binMid = Math.floor((binMax - binMin) / 2 + binMin);
                    }

                    // Use the result from this iteration as the maximum for the next.
                    binMax = binMid;

                    let start = Math.max(1, expectedLocation - binMid + 1);
                    let finish = findAllMatches
                      ? textLen
                      : Math.min(expectedLocation + binMid, textLen) +
                        patternLen;

                    // Initialize the bit array
                    let bitArr = Array(finish + 2);

                    bitArr[finish + 1] = (1 << i) - 1;

                    for (let j = finish; j >= start; j -= 1) {
                      let currentLocation = j - 1;
                      let charMatch =
                        patternAlphabet[text.charAt(currentLocation)];

                      if (computeMatches) {
                        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
                        matchMask[currentLocation] = +!!charMatch;
                      }

                      // First pass: exact match
                      bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch;

                      // Subsequent passes: fuzzy match
                      if (i) {
                        bitArr[j] |=
                          ((lastBitArr[j + 1] | lastBitArr[j]) << 1) |
                          1 |
                          lastBitArr[j + 1];
                      }

                      if (bitArr[j] & mask) {
                        finalScore = computeScore$1(pattern, {
                          errors: i,
                          currentLocation,
                          expectedLocation,
                          distance,
                          ignoreLocation,
                        });

                        // This match will almost certainly be better than any existing match.
                        // But check anyway.
                        if (finalScore <= currentThreshold) {
                          // Indeed it is
                          currentThreshold = finalScore;
                          bestLocation = currentLocation;

                          // Already passed `loc`, downhill from here on in.
                          if (bestLocation <= expectedLocation) {
                            break;
                          }

                          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                          start = Math.max(
                            1,
                            2 * expectedLocation - bestLocation
                          );
                        }
                      }
                    }

                    // No hope for a (better) match at greater error levels.
                    const score = computeScore$1(pattern, {
                      errors: i + 1,
                      currentLocation: expectedLocation,
                      expectedLocation,
                      distance,
                      ignoreLocation,
                    });

                    if (score > currentThreshold) {
                      break;
                    }

                    lastBitArr = bitArr;
                  }

                  const result = {
                    isMatch: bestLocation >= 0,
                    // Count exact matches (those with a score of 0) to be "almost" exact
                    score: Math.max(0.001, finalScore),
                  };

                  if (computeMatches) {
                    const indices = convertMaskToIndices(
                      matchMask,
                      minMatchCharLength
                    );
                    if (!indices.length) {
                      result.isMatch = false;
                    } else if (includeMatches) {
                      result.indices = indices;
                    }
                  }

                  return result;
                }

                function createPatternAlphabet(pattern) {
                  let mask = {};

                  for (let i = 0, len = pattern.length; i < len; i += 1) {
                    const char = pattern.charAt(i);
                    mask[char] = (mask[char] || 0) | (1 << (len - i - 1));
                  }

                  return mask;
                }

                class BitapSearch {
                  constructor(
                    pattern,
                    {
                      location = Config.location,
                      threshold = Config.threshold,
                      distance = Config.distance,
                      includeMatches = Config.includeMatches,
                      findAllMatches = Config.findAllMatches,
                      minMatchCharLength = Config.minMatchCharLength,
                      isCaseSensitive = Config.isCaseSensitive,
                      ignoreLocation = Config.ignoreLocation,
                    } = {}
                  ) {
                    this.options = {
                      location,
                      threshold,
                      distance,
                      includeMatches,
                      findAllMatches,
                      minMatchCharLength,
                      isCaseSensitive,
                      ignoreLocation,
                    };

                    this.pattern = isCaseSensitive
                      ? pattern
                      : pattern.toLowerCase();

                    this.chunks = [];

                    if (!this.pattern.length) {
                      return;
                    }

                    const addChunk = (pattern, startIndex) => {
                      this.chunks.push({
                        pattern,
                        alphabet: createPatternAlphabet(pattern),
                        startIndex,
                      });
                    };

                    const len = this.pattern.length;

                    if (len > MAX_BITS) {
                      let i = 0;
                      const remainder = len % MAX_BITS;
                      const end = len - remainder;

                      while (i < end) {
                        addChunk(this.pattern.substr(i, MAX_BITS), i);
                        i += MAX_BITS;
                      }

                      if (remainder) {
                        const startIndex = len - MAX_BITS;
                        addChunk(this.pattern.substr(startIndex), startIndex);
                      }
                    } else {
                      addChunk(this.pattern, 0);
                    }
                  }

                  searchIn(text) {
                    const { isCaseSensitive, includeMatches } = this.options;

                    if (!isCaseSensitive) {
                      text = text.toLowerCase();
                    }

                    // Exact match
                    if (this.pattern === text) {
                      let result = {
                        isMatch: true,
                        score: 0,
                      };

                      if (includeMatches) {
                        result.indices = [[0, text.length - 1]];
                      }

                      return result;
                    }

                    // Otherwise, use Bitap algorithm
                    const {
                      location,
                      distance,
                      threshold,
                      findAllMatches,
                      minMatchCharLength,
                      ignoreLocation,
                    } = this.options;

                    let allIndices = [];
                    let totalScore = 0;
                    let hasMatches = false;

                    this.chunks.forEach(({ pattern, alphabet, startIndex }) => {
                      const { isMatch, score, indices } = search(
                        text,
                        pattern,
                        alphabet,
                        {
                          location: location + startIndex,
                          distance,
                          threshold,
                          findAllMatches,
                          minMatchCharLength,
                          includeMatches,
                          ignoreLocation,
                        }
                      );

                      if (isMatch) {
                        hasMatches = true;
                      }

                      totalScore += score;

                      if (isMatch && indices) {
                        allIndices = [...allIndices, ...indices];
                      }
                    });

                    let result = {
                      isMatch: hasMatches,
                      score: hasMatches ? totalScore / this.chunks.length : 1,
                    };

                    if (hasMatches && includeMatches) {
                      result.indices = allIndices;
                    }

                    return result;
                  }
                }

                class BaseMatch {
                  constructor(pattern) {
                    this.pattern = pattern;
                  }
                  static isMultiMatch(pattern) {
                    return getMatch(pattern, this.multiRegex);
                  }
                  static isSingleMatch(pattern) {
                    return getMatch(pattern, this.singleRegex);
                  }
                  search(/*text*/) {}
                }

                function getMatch(pattern, exp) {
                  const matches = pattern.match(exp);
                  return matches ? matches[1] : null;
                }

                // Token: 'file

                class ExactMatch extends BaseMatch {
                  constructor(pattern) {
                    super(pattern);
                  }
                  static get type() {
                    return "exact";
                  }
                  static get multiRegex() {
                    return /^="(.*)"$/;
                  }
                  static get singleRegex() {
                    return /^=(.*)$/;
                  }
                  search(text) {
                    const isMatch = text === this.pattern;

                    return {
                      isMatch,
                      score: isMatch ? 0 : 1,
                      indices: [0, this.pattern.length - 1],
                    };
                  }
                }

                // Token: !fire

                class InverseExactMatch extends BaseMatch {
                  constructor(pattern) {
                    super(pattern);
                  }
                  static get type() {
                    return "inverse-exact";
                  }
                  static get multiRegex() {
                    return /^!"(.*)"$/;
                  }
                  static get singleRegex() {
                    return /^!(.*)$/;
                  }
                  search(text) {
                    const index = text.indexOf(this.pattern);
                    const isMatch = index === -1;

                    return {
                      isMatch,
                      score: isMatch ? 0 : 1,
                      indices: [0, text.length - 1],
                    };
                  }
                }

                // Token: ^file

                class PrefixExactMatch extends BaseMatch {
                  constructor(pattern) {
                    super(pattern);
                  }
                  static get type() {
                    return "prefix-exact";
                  }
                  static get multiRegex() {
                    return /^\^"(.*)"$/;
                  }
                  static get singleRegex() {
                    return /^\^(.*)$/;
                  }
                  search(text) {
                    const isMatch = text.startsWith(this.pattern);

                    return {
                      isMatch,
                      score: isMatch ? 0 : 1,
                      indices: [0, this.pattern.length - 1],
                    };
                  }
                }

                // Token: !^fire

                class InversePrefixExactMatch extends BaseMatch {
                  constructor(pattern) {
                    super(pattern);
                  }
                  static get type() {
                    return "inverse-prefix-exact";
                  }
                  static get multiRegex() {
                    return /^!\^"(.*)"$/;
                  }
                  static get singleRegex() {
                    return /^!\^(.*)$/;
                  }
                  search(text) {
                    const isMatch = !text.startsWith(this.pattern);

                    return {
                      isMatch,
                      score: isMatch ? 0 : 1,
                      indices: [0, text.length - 1],
                    };
                  }
                }

                // Token: .file$

                class SuffixExactMatch extends BaseMatch {
                  constructor(pattern) {
                    super(pattern);
                  }
                  static get type() {
                    return "suffix-exact";
                  }
                  static get multiRegex() {
                    return /^"(.*)"\$$/;
                  }
                  static get singleRegex() {
                    return /^(.*)\$$/;
                  }
                  search(text) {
                    const isMatch = text.endsWith(this.pattern);

                    return {
                      isMatch,
                      score: isMatch ? 0 : 1,
                      indices: [
                        text.length - this.pattern.length,
                        text.length - 1,
                      ],
                    };
                  }
                }

                // Token: !.file$

                class InverseSuffixExactMatch extends BaseMatch {
                  constructor(pattern) {
                    super(pattern);
                  }
                  static get type() {
                    return "inverse-suffix-exact";
                  }
                  static get multiRegex() {
                    return /^!"(.*)"\$$/;
                  }
                  static get singleRegex() {
                    return /^!(.*)\$$/;
                  }
                  search(text) {
                    const isMatch = !text.endsWith(this.pattern);
                    return {
                      isMatch,
                      score: isMatch ? 0 : 1,
                      indices: [0, text.length - 1],
                    };
                  }
                }

                class FuzzyMatch extends BaseMatch {
                  constructor(
                    pattern,
                    {
                      location = Config.location,
                      threshold = Config.threshold,
                      distance = Config.distance,
                      includeMatches = Config.includeMatches,
                      findAllMatches = Config.findAllMatches,
                      minMatchCharLength = Config.minMatchCharLength,
                      isCaseSensitive = Config.isCaseSensitive,
                      ignoreLocation = Config.ignoreLocation,
                    } = {}
                  ) {
                    super(pattern);
                    this._bitapSearch = new BitapSearch(pattern, {
                      location,
                      threshold,
                      distance,
                      includeMatches,
                      findAllMatches,
                      minMatchCharLength,
                      isCaseSensitive,
                      ignoreLocation,
                    });
                  }
                  static get type() {
                    return "fuzzy";
                  }
                  static get multiRegex() {
                    return /^"(.*)"$/;
                  }
                  static get singleRegex() {
                    return /^(.*)$/;
                  }
                  search(text) {
                    return this._bitapSearch.searchIn(text);
                  }
                }

                // Token: 'file

                class IncludeMatch extends BaseMatch {
                  constructor(pattern) {
                    super(pattern);
                  }
                  static get type() {
                    return "include";
                  }
                  static get multiRegex() {
                    return /^'"(.*)"$/;
                  }
                  static get singleRegex() {
                    return /^'(.*)$/;
                  }
                  search(text) {
                    let location = 0;
                    let index;

                    const indices = [];
                    const patternLen = this.pattern.length;

                    // Get all exact matches
                    while (
                      (index = text.indexOf(this.pattern, location)) > -1
                    ) {
                      location = index + patternLen;
                      indices.push([index, location - 1]);
                    }

                    const isMatch = !!indices.length;

                    return {
                      isMatch,
                      score: isMatch ? 0 : 1,
                      indices,
                    };
                  }
                }

                // ❗Order is important. DO NOT CHANGE.
                const searchers = [
                  ExactMatch,
                  IncludeMatch,
                  PrefixExactMatch,
                  InversePrefixExactMatch,
                  InverseSuffixExactMatch,
                  SuffixExactMatch,
                  InverseExactMatch,
                  FuzzyMatch,
                ];

                const searchersLen = searchers.length;

                // Regex to split by spaces, but keep anything in quotes together
                const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
                const OR_TOKEN = "|";

                // Return a 2D array representation of the query, for simpler parsing.
                // Example:
                // "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
                function parseQuery(pattern, options = {}) {
                  return pattern.split(OR_TOKEN).map((item) => {
                    let query = item
                      .trim()
                      .split(SPACE_RE)
                      .filter((item) => item && !!item.trim());

                    let results = [];
                    for (let i = 0, len = query.length; i < len; i += 1) {
                      const queryItem = query[i];

                      // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
                      let found = false;
                      let idx = -1;
                      while (!found && ++idx < searchersLen) {
                        const searcher = searchers[idx];
                        let token = searcher.isMultiMatch(queryItem);
                        if (token) {
                          results.push(new searcher(token, options));
                          found = true;
                        }
                      }

                      if (found) {
                        continue;
                      }

                      // 2. Handle single query matches (i.e, once that are *not* quoted)
                      idx = -1;
                      while (++idx < searchersLen) {
                        const searcher = searchers[idx];
                        let token = searcher.isSingleMatch(queryItem);
                        if (token) {
                          results.push(new searcher(token, options));
                          break;
                        }
                      }
                    }

                    return results;
                  });
                }

                // These extended matchers can return an array of matches, as opposed
                // to a singl match
                const MultiMatchSet = new Set([
                  FuzzyMatch.type,
                  IncludeMatch.type,
                ]);

                /**
                 * Command-like searching
                 * ======================
                 *
                 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
                 * search in a given text.
                 *
                 * Search syntax:
                 *
                 * | Token       | Match type                 | Description                            |
                 * | ----------- | -------------------------- | -------------------------------------- |
                 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
                 * | `=scheme`   | exact-match                | Items that are `scheme`                |
                 * | `'python`   | include-match              | Items that include `python`            |
                 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
                 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
                 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
                 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
                 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
                 *
                 * A single pipe character acts as an OR operator. For example, the following
                 * query matches entries that start with `core` and end with either`go`, `rb`,
                 * or`py`.
                 *
                 * ```
                 * ^core go$ | rb$ | py$
                 * ```
                 */
                class ExtendedSearch {
                  constructor(
                    pattern,
                    {
                      isCaseSensitive = Config.isCaseSensitive,
                      includeMatches = Config.includeMatches,
                      minMatchCharLength = Config.minMatchCharLength,
                      ignoreLocation = Config.ignoreLocation,
                      findAllMatches = Config.findAllMatches,
                      location = Config.location,
                      threshold = Config.threshold,
                      distance = Config.distance,
                    } = {}
                  ) {
                    this.query = null;
                    this.options = {
                      isCaseSensitive,
                      includeMatches,
                      minMatchCharLength,
                      findAllMatches,
                      ignoreLocation,
                      location,
                      threshold,
                      distance,
                    };

                    this.pattern = isCaseSensitive
                      ? pattern
                      : pattern.toLowerCase();
                    this.query = parseQuery(this.pattern, this.options);
                  }

                  static condition(_, options) {
                    return options.useExtendedSearch;
                  }

                  searchIn(text) {
                    const query = this.query;

                    if (!query) {
                      return {
                        isMatch: false,
                        score: 1,
                      };
                    }

                    const { includeMatches, isCaseSensitive } = this.options;

                    text = isCaseSensitive ? text : text.toLowerCase();

                    let numMatches = 0;
                    let allIndices = [];
                    let totalScore = 0;

                    // ORs
                    for (let i = 0, qLen = query.length; i < qLen; i += 1) {
                      const searchers = query[i];

                      // Reset indices
                      allIndices.length = 0;
                      numMatches = 0;

                      // ANDs
                      for (
                        let j = 0, pLen = searchers.length;
                        j < pLen;
                        j += 1
                      ) {
                        const searcher = searchers[j];
                        const { isMatch, indices, score } =
                          searcher.search(text);

                        if (isMatch) {
                          numMatches += 1;
                          totalScore += score;
                          if (includeMatches) {
                            const type = searcher.constructor.type;
                            if (MultiMatchSet.has(type)) {
                              allIndices = [...allIndices, ...indices];
                            } else {
                              allIndices.push(indices);
                            }
                          }
                        } else {
                          totalScore = 0;
                          numMatches = 0;
                          allIndices.length = 0;
                          break;
                        }
                      }

                      // OR condition, so if TRUE, return
                      if (numMatches) {
                        let result = {
                          isMatch: true,
                          score: totalScore / numMatches,
                        };

                        if (includeMatches) {
                          result.indices = allIndices;
                        }

                        return result;
                      }
                    }

                    // Nothing was matched
                    return {
                      isMatch: false,
                      score: 1,
                    };
                  }
                }

                const registeredSearchers = [];

                function register(...args) {
                  registeredSearchers.push(...args);
                }

                function createSearcher(pattern, options) {
                  for (
                    let i = 0, len = registeredSearchers.length;
                    i < len;
                    i += 1
                  ) {
                    let searcherClass = registeredSearchers[i];
                    if (searcherClass.condition(pattern, options)) {
                      return new searcherClass(pattern, options);
                    }
                  }

                  return new BitapSearch(pattern, options);
                }

                const LogicalOperator = {
                  AND: "$and",
                  OR: "$or",
                };

                const KeyType = {
                  PATH: "$path",
                  PATTERN: "$val",
                };

                const isExpression = (query) =>
                  !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);

                const isPath = (query) => !!query[KeyType.PATH];

                const isLeaf = (query) =>
                  !isArray(query) && isObject(query) && !isExpression(query);

                const convertToExplicit = (query) => ({
                  [LogicalOperator.AND]: Object.keys(query).map((key) => ({
                    [key]: query[key],
                  })),
                });

                // When `auto` is `true`, the parse function will infer and initialize and add
                // the appropriate `Searcher` instance
                function parse(query, options, { auto = true } = {}) {
                  const next = (query) => {
                    let keys = Object.keys(query);

                    const isQueryPath = isPath(query);

                    if (
                      !isQueryPath &&
                      keys.length > 1 &&
                      !isExpression(query)
                    ) {
                      return next(convertToExplicit(query));
                    }

                    if (isLeaf(query)) {
                      const key = isQueryPath ? query[KeyType.PATH] : keys[0];

                      const pattern = isQueryPath
                        ? query[KeyType.PATTERN]
                        : query[key];

                      if (!isString(pattern)) {
                        throw new Error(
                          LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key)
                        );
                      }

                      const obj = {
                        keyId: createKeyId(key),
                        pattern,
                      };

                      if (auto) {
                        obj.searcher = createSearcher(pattern, options);
                      }

                      return obj;
                    }

                    let node = {
                      children: [],
                      operator: keys[0],
                    };

                    keys.forEach((key) => {
                      const value = query[key];

                      if (isArray(value)) {
                        value.forEach((item) => {
                          node.children.push(next(item));
                        });
                      }
                    });

                    return node;
                  };

                  if (!isExpression(query)) {
                    query = convertToExplicit(query);
                  }

                  return next(query);
                }

                // Practical scoring function
                function computeScore(
                  results,
                  { ignoreFieldNorm = Config.ignoreFieldNorm }
                ) {
                  results.forEach((result) => {
                    let totalScore = 1;

                    result.matches.forEach(({ key, norm, score }) => {
                      const weight = key ? key.weight : null;

                      totalScore *= Math.pow(
                        score === 0 && weight ? Number.EPSILON : score,
                        (weight || 1) * (ignoreFieldNorm ? 1 : norm)
                      );
                    });

                    result.score = totalScore;
                  });
                }

                function transformMatches(result, data) {
                  const matches = result.matches;
                  data.matches = [];

                  if (!isDefined(matches)) {
                    return;
                  }

                  matches.forEach((match) => {
                    if (!isDefined(match.indices) || !match.indices.length) {
                      return;
                    }

                    const { indices, value } = match;

                    let obj = {
                      indices,
                      value,
                    };

                    if (match.key) {
                      obj.key = match.key.src;
                    }

                    if (match.idx > -1) {
                      obj.refIndex = match.idx;
                    }

                    data.matches.push(obj);
                  });
                }

                function transformScore(result, data) {
                  data.score = result.score;
                }

                function format(
                  results,
                  docs,
                  {
                    includeMatches = Config.includeMatches,
                    includeScore = Config.includeScore,
                  } = {}
                ) {
                  const transformers = [];

                  if (includeMatches) transformers.push(transformMatches);
                  if (includeScore) transformers.push(transformScore);

                  return results.map((result) => {
                    const { idx } = result;

                    const data = {
                      item: docs[idx],
                      refIndex: idx,
                    };

                    if (transformers.length) {
                      transformers.forEach((transformer) => {
                        transformer(result, data);
                      });
                    }

                    return data;
                  });
                }

                class Fuse {
                  constructor(docs, options = {}, index) {
                    this.options = { ...Config, ...options };

                    if (this.options.useExtendedSearch && !true) {
                    }

                    this._keyStore = new KeyStore(this.options.keys);

                    this.setCollection(docs, index);
                  }

                  setCollection(docs, index) {
                    this._docs = docs;

                    if (index && !(index instanceof FuseIndex)) {
                      throw new Error(INCORRECT_INDEX_TYPE);
                    }

                    this._myIndex =
                      index ||
                      createIndex(this.options.keys, this._docs, {
                        getFn: this.options.getFn,
                        fieldNormWeight: this.options.fieldNormWeight,
                      });
                  }

                  add(doc) {
                    if (!isDefined(doc)) {
                      return;
                    }

                    this._docs.push(doc);
                    this._myIndex.add(doc);
                  }

                  remove(predicate = (/* doc, idx */) => false) {
                    const results = [];

                    for (let i = 0, len = this._docs.length; i < len; i += 1) {
                      const doc = this._docs[i];
                      if (predicate(doc, i)) {
                        this.removeAt(i);
                        i -= 1;
                        len -= 1;

                        results.push(doc);
                      }
                    }

                    return results;
                  }

                  removeAt(idx) {
                    this._docs.splice(idx, 1);
                    this._myIndex.removeAt(idx);
                  }

                  getIndex() {
                    return this._myIndex;
                  }

                  search(query, { limit = -1 } = {}) {
                    const {
                      includeMatches,
                      includeScore,
                      shouldSort,
                      sortFn,
                      ignoreFieldNorm,
                    } = this.options;

                    let results = isString(query)
                      ? isString(this._docs[0])
                        ? this._searchStringList(query)
                        : this._searchObjectList(query)
                      : this._searchLogical(query);

                    computeScore(results, { ignoreFieldNorm });

                    if (shouldSort) {
                      results.sort(sortFn);
                    }

                    if (isNumber(limit) && limit > -1) {
                      results = results.slice(0, limit);
                    }

                    return format(results, this._docs, {
                      includeMatches,
                      includeScore,
                    });
                  }

                  _searchStringList(query) {
                    const searcher = createSearcher(query, this.options);
                    const { records } = this._myIndex;
                    const results = [];

                    // Iterate over every string in the index
                    records.forEach(({ v: text, i: idx, n: norm }) => {
                      if (!isDefined(text)) {
                        return;
                      }

                      const { isMatch, score, indices } =
                        searcher.searchIn(text);

                      if (isMatch) {
                        results.push({
                          item: text,
                          idx,
                          matches: [{ score, value: text, norm, indices }],
                        });
                      }
                    });

                    return results;
                  }

                  _searchLogical(query) {
                    const expression = parse(query, this.options);

                    const evaluate = (node, item, idx) => {
                      if (!node.children) {
                        const { keyId, searcher } = node;

                        const matches = this._findMatches({
                          key: this._keyStore.get(keyId),
                          value: this._myIndex.getValueForItemAtKeyId(
                            item,
                            keyId
                          ),
                          searcher,
                        });

                        if (matches && matches.length) {
                          return [
                            {
                              idx,
                              item,
                              matches,
                            },
                          ];
                        }

                        return [];
                      }

                      const res = [];
                      for (
                        let i = 0, len = node.children.length;
                        i < len;
                        i += 1
                      ) {
                        const child = node.children[i];
                        const result = evaluate(child, item, idx);
                        if (result.length) {
                          res.push(...result);
                        } else if (node.operator === LogicalOperator.AND) {
                          return [];
                        }
                      }
                      return res;
                    };

                    const records = this._myIndex.records;
                    const resultMap = {};
                    const results = [];

                    records.forEach(({ $: item, i: idx }) => {
                      if (isDefined(item)) {
                        let expResults = evaluate(expression, item, idx);

                        if (expResults.length) {
                          // Dedupe when adding
                          if (!resultMap[idx]) {
                            resultMap[idx] = { idx, item, matches: [] };
                            results.push(resultMap[idx]);
                          }
                          expResults.forEach(({ matches }) => {
                            resultMap[idx].matches.push(...matches);
                          });
                        }
                      }
                    });

                    return results;
                  }

                  _searchObjectList(query) {
                    const searcher = createSearcher(query, this.options);
                    const { keys, records } = this._myIndex;
                    const results = [];

                    // List is Array<Object>
                    records.forEach(({ $: item, i: idx }) => {
                      if (!isDefined(item)) {
                        return;
                      }

                      let matches = [];

                      // Iterate over every key (i.e, path), and fetch the value at that key
                      keys.forEach((key, keyIndex) => {
                        matches.push(
                          ...this._findMatches({
                            key,
                            value: item[keyIndex],
                            searcher,
                          })
                        );
                      });

                      if (matches.length) {
                        results.push({
                          idx,
                          item,
                          matches,
                        });
                      }
                    });

                    return results;
                  }
                  _findMatches({ key, value, searcher }) {
                    if (!isDefined(value)) {
                      return [];
                    }

                    let matches = [];

                    if (isArray(value)) {
                      value.forEach(({ v: text, i: idx, n: norm }) => {
                        if (!isDefined(text)) {
                          return;
                        }

                        const { isMatch, score, indices } =
                          searcher.searchIn(text);

                        if (isMatch) {
                          matches.push({
                            score,
                            key,
                            value: text,
                            idx,
                            norm,
                            indices,
                          });
                        }
                      });
                    } else {
                      const { v: text, n: norm } = value;

                      const { isMatch, score, indices } =
                        searcher.searchIn(text);

                      if (isMatch) {
                        matches.push({
                          score,
                          key,
                          value: text,
                          norm,
                          indices,
                        });
                      }
                    }

                    return matches;
                  }
                }

                Fuse.version = "6.6.2";
                Fuse.createIndex = createIndex;
                Fuse.parseIndex = parseIndex;
                Fuse.config = Config;

                {
                  Fuse.parseQuery = parse;
                }

                {
                  register(ExtendedSearch);
                }

                /***/
              },

              /***/ 791: /***/ function (
                __unused_webpack_module,
                __webpack_exports__,
                __nested_webpack_require_177999__
              ) {
                // ESM COMPAT FLAG
                __nested_webpack_require_177999__.r(__webpack_exports__);

                // EXPORTS
                __nested_webpack_require_177999__.d(__webpack_exports__, {
                  __DO_NOT_USE__ActionTypes: function () {
                    return /* binding */ ActionTypes;
                  },
                  applyMiddleware: function () {
                    return /* binding */ applyMiddleware;
                  },
                  bindActionCreators: function () {
                    return /* binding */ bindActionCreators;
                  },
                  combineReducers: function () {
                    return /* binding */ combineReducers;
                  },
                  compose: function () {
                    return /* binding */ compose;
                  },
                  createStore: function () {
                    return /* binding */ createStore;
                  },
                  legacy_createStore: function () {
                    return /* binding */ legacy_createStore;
                  },
                }); // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js

                function _typeof(obj) {
                  "@babel/helpers - typeof";

                  return (
                    (_typeof =
                      "function" == typeof Symbol &&
                      "symbol" == typeof Symbol.iterator
                        ? function (obj) {
                            return typeof obj;
                          }
                        : function (obj) {
                            return obj &&
                              "function" == typeof Symbol &&
                              obj.constructor === Symbol &&
                              obj !== Symbol.prototype
                              ? "symbol"
                              : typeof obj;
                          }),
                    _typeof(obj)
                  );
                } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js
                function _toPrimitive(input, hint) {
                  if (_typeof(input) !== "object" || input === null)
                    return input;
                  var prim = input[Symbol.toPrimitive];
                  if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError(
                      "@@toPrimitive must return a primitive value."
                    );
                  }
                  return (hint === "string" ? String : Number)(input);
                } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
                function _toPropertyKey(arg) {
                  var key = _toPrimitive(arg, "string");
                  return _typeof(key) === "symbol" ? key : String(key);
                } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
                function _defineProperty(obj, key, value) {
                  key = _toPropertyKey(key);
                  if (key in obj) {
                    Object.defineProperty(obj, key, {
                      value: value,
                      enumerable: true,
                      configurable: true,
                      writable: true,
                    });
                  } else {
                    obj[key] = value;
                  }
                  return obj;
                } // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
                function ownKeys(object, enumerableOnly) {
                  var keys = Object.keys(object);
                  if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly &&
                      (symbols = symbols.filter(function (sym) {
                        return Object.getOwnPropertyDescriptor(
                          object,
                          sym
                        ).enumerable;
                      })),
                      keys.push.apply(keys, symbols);
                  }
                  return keys;
                }
                function _objectSpread2(target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2
                      ? ownKeys(Object(source), !0).forEach(function (key) {
                          _defineProperty(target, key, source[key]);
                        })
                      : Object.getOwnPropertyDescriptors
                      ? Object.defineProperties(
                          target,
                          Object.getOwnPropertyDescriptors(source)
                        )
                      : ownKeys(Object(source)).forEach(function (key) {
                          Object.defineProperty(
                            target,
                            key,
                            Object.getOwnPropertyDescriptor(source, key)
                          );
                        });
                  }
                  return target;
                } // CONCATENATED MODULE: ./node_modules/redux/es/redux.js
                /**
                 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
                 *
                 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
                 * during build.
                 * @param {number} code
                 */
                function formatProdErrorMessage(code) {
                  return (
                    "Minified Redux error #" +
                    code +
                    "; visit https://redux.js.org/Errors?code=" +
                    code +
                    " for the full message or " +
                    "use the non-minified dev environment for full errors. "
                  );
                }

                // Inlined version of the `symbol-observable` polyfill
                var $$observable = (function () {
                  return (
                    (typeof Symbol === "function" && Symbol.observable) ||
                    "@@observable"
                  );
                })();

                /**
                 * These are private action types reserved by Redux.
                 * For any unknown actions, you must return the current state.
                 * If the current state is undefined, you must return the initial state.
                 * Do not reference these action types directly in your code.
                 */
                var randomString = function randomString() {
                  return Math.random()
                    .toString(36)
                    .substring(7)
                    .split("")
                    .join(".");
                };

                var ActionTypes = {
                  INIT: "@@redux/INIT" + randomString(),
                  REPLACE: "@@redux/REPLACE" + randomString(),
                  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
                    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
                  },
                };

                /**
                 * @param {any} obj The object to inspect.
                 * @returns {boolean} True if the argument appears to be a plain object.
                 */
                function isPlainObject(obj) {
                  if (typeof obj !== "object" || obj === null) return false;
                  var proto = obj;

                  while (Object.getPrototypeOf(proto) !== null) {
                    proto = Object.getPrototypeOf(proto);
                  }

                  return Object.getPrototypeOf(obj) === proto;
                }

                // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
                function miniKindOf(val) {
                  if (val === void 0) return "undefined";
                  if (val === null) return "null";
                  var type = typeof val;

                  switch (type) {
                    case "boolean":
                    case "string":
                    case "number":
                    case "symbol":
                    case "function": {
                      return type;
                    }
                  }

                  if (Array.isArray(val)) return "array";
                  if (isDate(val)) return "date";
                  if (isError(val)) return "error";
                  var constructorName = ctorName(val);

                  switch (constructorName) {
                    case "Symbol":
                    case "Promise":
                    case "WeakMap":
                    case "WeakSet":
                    case "Map":
                    case "Set":
                      return constructorName;
                  } // other

                  return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
                }

                function ctorName(val) {
                  return typeof val.constructor === "function"
                    ? val.constructor.name
                    : null;
                }

                function isError(val) {
                  return (
                    val instanceof Error ||
                    (typeof val.message === "string" &&
                      val.constructor &&
                      typeof val.constructor.stackTraceLimit === "number")
                  );
                }

                function isDate(val) {
                  if (val instanceof Date) return true;
                  return (
                    typeof val.toDateString === "function" &&
                    typeof val.getDate === "function" &&
                    typeof val.setDate === "function"
                  );
                }

                function kindOf(val) {
                  var typeOfVal = typeof val;

                  if (false) {
                  }

                  return typeOfVal;
                }

                /**
                 * @deprecated
                 *
                 * **We recommend using the `configureStore` method
                 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
                 *
                 * Redux Toolkit is our recommended approach for writing Redux logic today,
                 * including store setup, reducers, data fetching, and more.
                 *
                 * **For more details, please read this Redux docs page:**
                 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
                 *
                 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
                 * simplifies setup and helps avoid common bugs.
                 *
                 * You should not be using the `redux` core package by itself today, except for learning purposes.
                 * The `createStore` method from the core `redux` package will not be removed, but we encourage
                 * all users to migrate to using Redux Toolkit for all Redux code.
                 *
                 * If you want to use `createStore` without this visual deprecation warning, use
                 * the `legacy_createStore` import instead:
                 *
                 * `import { legacy_createStore as createStore} from 'redux'`
                 *
                 */

                function createStore(reducer, preloadedState, enhancer) {
                  var _ref2;

                  if (
                    (typeof preloadedState === "function" &&
                      typeof enhancer === "function") ||
                    (typeof enhancer === "function" &&
                      typeof arguments[3] === "function")
                  ) {
                    throw new Error(true ? formatProdErrorMessage(0) : 0);
                  }

                  if (
                    typeof preloadedState === "function" &&
                    typeof enhancer === "undefined"
                  ) {
                    enhancer = preloadedState;
                    preloadedState = undefined;
                  }

                  if (typeof enhancer !== "undefined") {
                    if (typeof enhancer !== "function") {
                      throw new Error(true ? formatProdErrorMessage(1) : 0);
                    }

                    return enhancer(createStore)(reducer, preloadedState);
                  }

                  if (typeof reducer !== "function") {
                    throw new Error(true ? formatProdErrorMessage(2) : 0);
                  }

                  var currentReducer = reducer;
                  var currentState = preloadedState;
                  var currentListeners = [];
                  var nextListeners = currentListeners;
                  var isDispatching = false;
                  /**
                   * This makes a shallow copy of currentListeners so we can use
                   * nextListeners as a temporary list while dispatching.
                   *
                   * This prevents any bugs around consumers calling
                   * subscribe/unsubscribe in the middle of a dispatch.
                   */

                  function ensureCanMutateNextListeners() {
                    if (nextListeners === currentListeners) {
                      nextListeners = currentListeners.slice();
                    }
                  }
                  /**
                   * Reads the state tree managed by the store.
                   *
                   * @returns {any} The current state tree of your application.
                   */

                  function getState() {
                    if (isDispatching) {
                      throw new Error(true ? formatProdErrorMessage(3) : 0);
                    }

                    return currentState;
                  }
                  /**
                   * Adds a change listener. It will be called any time an action is dispatched,
                   * and some part of the state tree may potentially have changed. You may then
                   * call `getState()` to read the current state tree inside the callback.
                   *
                   * You may call `dispatch()` from a change listener, with the following
                   * caveats:
                   *
                   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
                   * If you subscribe or unsubscribe while the listeners are being invoked, this
                   * will not have any effect on the `dispatch()` that is currently in progress.
                   * However, the next `dispatch()` call, whether nested or not, will use a more
                   * recent snapshot of the subscription list.
                   *
                   * 2. The listener should not expect to see all state changes, as the state
                   * might have been updated multiple times during a nested `dispatch()` before
                   * the listener is called. It is, however, guaranteed that all subscribers
                   * registered before the `dispatch()` started will be called with the latest
                   * state by the time it exits.
                   *
                   * @param {Function} listener A callback to be invoked on every dispatch.
                   * @returns {Function} A function to remove this change listener.
                   */

                  function subscribe(listener) {
                    if (typeof listener !== "function") {
                      throw new Error(true ? formatProdErrorMessage(4) : 0);
                    }

                    if (isDispatching) {
                      throw new Error(true ? formatProdErrorMessage(5) : 0);
                    }

                    var isSubscribed = true;
                    ensureCanMutateNextListeners();
                    nextListeners.push(listener);
                    return function unsubscribe() {
                      if (!isSubscribed) {
                        return;
                      }

                      if (isDispatching) {
                        throw new Error(true ? formatProdErrorMessage(6) : 0);
                      }

                      isSubscribed = false;
                      ensureCanMutateNextListeners();
                      var index = nextListeners.indexOf(listener);
                      nextListeners.splice(index, 1);
                      currentListeners = null;
                    };
                  }
                  /**
                   * Dispatches an action. It is the only way to trigger a state change.
                   *
                   * The `reducer` function, used to create the store, will be called with the
                   * current state tree and the given `action`. Its return value will
                   * be considered the **next** state of the tree, and the change listeners
                   * will be notified.
                   *
                   * The base implementation only supports plain object actions. If you want to
                   * dispatch a Promise, an Observable, a thunk, or something else, you need to
                   * wrap your store creating function into the corresponding middleware. For
                   * example, see the documentation for the `redux-thunk` package. Even the
                   * middleware will eventually dispatch plain object actions using this method.
                   *
                   * @param {Object} action A plain object representing “what changed”. It is
                   * a good idea to keep actions serializable so you can record and replay user
                   * sessions, or use the time travelling `redux-devtools`. An action must have
                   * a `type` property which may not be `undefined`. It is a good idea to use
                   * string constants for action types.
                   *
                   * @returns {Object} For convenience, the same action object you dispatched.
                   *
                   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
                   * return something else (for example, a Promise you can await).
                   */

                  function dispatch(action) {
                    if (!isPlainObject(action)) {
                      throw new Error(true ? formatProdErrorMessage(7) : 0);
                    }

                    if (typeof action.type === "undefined") {
                      throw new Error(true ? formatProdErrorMessage(8) : 0);
                    }

                    if (isDispatching) {
                      throw new Error(true ? formatProdErrorMessage(9) : 0);
                    }

                    try {
                      isDispatching = true;
                      currentState = currentReducer(currentState, action);
                    } finally {
                      isDispatching = false;
                    }

                    var listeners = (currentListeners = nextListeners);

                    for (var i = 0; i < listeners.length; i++) {
                      var listener = listeners[i];
                      listener();
                    }

                    return action;
                  }
                  /**
                   * Replaces the reducer currently used by the store to calculate the state.
                   *
                   * You might need this if your app implements code splitting and you want to
                   * load some of the reducers dynamically. You might also need this if you
                   * implement a hot reloading mechanism for Redux.
                   *
                   * @param {Function} nextReducer The reducer for the store to use instead.
                   * @returns {void}
                   */

                  function replaceReducer(nextReducer) {
                    if (typeof nextReducer !== "function") {
                      throw new Error(true ? formatProdErrorMessage(10) : 0);
                    }

                    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
                    // Any reducers that existed in both the new and old rootReducer
                    // will receive the previous state. This effectively populates
                    // the new state tree with any relevant data from the old one.

                    dispatch({
                      type: ActionTypes.REPLACE,
                    });
                  }
                  /**
                   * Interoperability point for observable/reactive libraries.
                   * @returns {observable} A minimal observable of state changes.
                   * For more information, see the observable proposal:
                   * https://github.com/tc39/proposal-observable
                   */

                  function observable() {
                    var _ref;

                    var outerSubscribe = subscribe;
                    return (
                      (_ref = {
                        /**
                         * The minimal observable subscription method.
                         * @param {Object} observer Any object that can be used as an observer.
                         * The observer object should have a `next` method.
                         * @returns {subscription} An object with an `unsubscribe` method that can
                         * be used to unsubscribe the observable from the store, and prevent further
                         * emission of values from the observable.
                         */
                        subscribe: function subscribe(observer) {
                          if (
                            typeof observer !== "object" ||
                            observer === null
                          ) {
                            throw new Error(
                              true ? formatProdErrorMessage(11) : 0
                            );
                          }

                          function observeState() {
                            if (observer.next) {
                              observer.next(getState());
                            }
                          }

                          observeState();
                          var unsubscribe = outerSubscribe(observeState);
                          return {
                            unsubscribe: unsubscribe,
                          };
                        },
                      }),
                      (_ref[$$observable] = function () {
                        return this;
                      }),
                      _ref
                    );
                  } // When a store is created, an "INIT" action is dispatched so that every
                  // reducer returns their initial state. This effectively populates
                  // the initial state tree.

                  dispatch({
                    type: ActionTypes.INIT,
                  });
                  return (
                    (_ref2 = {
                      dispatch: dispatch,
                      subscribe: subscribe,
                      getState: getState,
                      replaceReducer: replaceReducer,
                    }),
                    (_ref2[$$observable] = observable),
                    _ref2
                  );
                }
                /**
                 * Creates a Redux store that holds the state tree.
                 *
                 * **We recommend using `configureStore` from the
                 * `@reduxjs/toolkit` package**, which replaces `createStore`:
                 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
                 *
                 * The only way to change the data in the store is to call `dispatch()` on it.
                 *
                 * There should only be a single store in your app. To specify how different
                 * parts of the state tree respond to actions, you may combine several reducers
                 * into a single reducer function by using `combineReducers`.
                 *
                 * @param {Function} reducer A function that returns the next state tree, given
                 * the current state tree and the action to handle.
                 *
                 * @param {any} [preloadedState] The initial state. You may optionally specify it
                 * to hydrate the state from the server in universal apps, or to restore a
                 * previously serialized user session.
                 * If you use `combineReducers` to produce the root reducer function, this must be
                 * an object with the same shape as `combineReducers` keys.
                 *
                 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
                 * to enhance the store with third-party capabilities such as middleware,
                 * time travel, persistence, etc. The only store enhancer that ships with Redux
                 * is `applyMiddleware()`.
                 *
                 * @returns {Store} A Redux store that lets you read the state, dispatch actions
                 * and subscribe to changes.
                 */

                var legacy_createStore = createStore;

                /**
                 * Prints a warning in the console if it exists.
                 *
                 * @param {String} message The warning message.
                 * @returns {void}
                 */
                function warning(message) {
                  /* eslint-disable no-console */
                  if (
                    typeof console !== "undefined" &&
                    typeof console.error === "function"
                  ) {
                    console.error(message);
                  }
                  /* eslint-enable no-console */

                  try {
                    // This error was thrown as a convenience so that if you enable
                    // "break on all exceptions" in your console,
                    // it would pause the execution at this line.
                    throw new Error(message);
                  } catch (e) {} // eslint-disable-line no-empty
                }

                function getUnexpectedStateShapeWarningMessage(
                  inputState,
                  reducers,
                  action,
                  unexpectedKeyCache
                ) {
                  var reducerKeys = Object.keys(reducers);
                  var argumentName =
                    action && action.type === ActionTypes.INIT
                      ? "preloadedState argument passed to createStore"
                      : "previous state received by the reducer";

                  if (reducerKeys.length === 0) {
                    return (
                      "Store does not have a valid reducer. Make sure the argument passed " +
                      "to combineReducers is an object whose values are reducers."
                    );
                  }

                  if (!isPlainObject(inputState)) {
                    return (
                      "The " +
                      argumentName +
                      ' has unexpected type of "' +
                      kindOf(inputState) +
                      '". Expected argument to be an object with the following ' +
                      ('keys: "' + reducerKeys.join('", "') + '"')
                    );
                  }

                  var unexpectedKeys = Object.keys(inputState).filter(function (
                    key
                  ) {
                    return (
                      !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]
                    );
                  });
                  unexpectedKeys.forEach(function (key) {
                    unexpectedKeyCache[key] = true;
                  });
                  if (action && action.type === ActionTypes.REPLACE) return;

                  if (unexpectedKeys.length > 0) {
                    return (
                      "Unexpected " +
                      (unexpectedKeys.length > 1 ? "keys" : "key") +
                      " " +
                      ('"' +
                        unexpectedKeys.join('", "') +
                        '" found in ' +
                        argumentName +
                        ". ") +
                      "Expected to find one of the known reducer keys instead: " +
                      ('"' +
                        reducerKeys.join('", "') +
                        '". Unexpected keys will be ignored.')
                    );
                  }
                }

                function assertReducerShape(reducers) {
                  Object.keys(reducers).forEach(function (key) {
                    var reducer = reducers[key];
                    var initialState = reducer(undefined, {
                      type: ActionTypes.INIT,
                    });

                    if (typeof initialState === "undefined") {
                      throw new Error(true ? formatProdErrorMessage(12) : 0);
                    }

                    if (
                      typeof reducer(undefined, {
                        type: ActionTypes.PROBE_UNKNOWN_ACTION(),
                      }) === "undefined"
                    ) {
                      throw new Error(true ? formatProdErrorMessage(13) : 0);
                    }
                  });
                }
                /**
                 * Turns an object whose values are different reducer functions, into a single
                 * reducer function. It will call every child reducer, and gather their results
                 * into a single state object, whose keys correspond to the keys of the passed
                 * reducer functions.
                 *
                 * @param {Object} reducers An object whose values correspond to different
                 * reducer functions that need to be combined into one. One handy way to obtain
                 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
                 * undefined for any action. Instead, they should return their initial state
                 * if the state passed to them was undefined, and the current state for any
                 * unrecognized action.
                 *
                 * @returns {Function} A reducer function that invokes every reducer inside the
                 * passed object, and builds a state object with the same shape.
                 */

                function combineReducers(reducers) {
                  var reducerKeys = Object.keys(reducers);
                  var finalReducers = {};

                  for (var i = 0; i < reducerKeys.length; i++) {
                    var key = reducerKeys[i];

                    if (false) {
                    }

                    if (typeof reducers[key] === "function") {
                      finalReducers[key] = reducers[key];
                    }
                  }

                  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
                  // keys multiple times.

                  var unexpectedKeyCache;

                  if (false) {
                  }

                  var shapeAssertionError;

                  try {
                    assertReducerShape(finalReducers);
                  } catch (e) {
                    shapeAssertionError = e;
                  }

                  return function combination(state, action) {
                    if (state === void 0) {
                      state = {};
                    }

                    if (shapeAssertionError) {
                      throw shapeAssertionError;
                    }

                    if (false) {
                      var warningMessage;
                    }

                    var hasChanged = false;
                    var nextState = {};

                    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
                      var _key = finalReducerKeys[_i];
                      var reducer = finalReducers[_key];
                      var previousStateForKey = state[_key];
                      var nextStateForKey = reducer(
                        previousStateForKey,
                        action
                      );

                      if (typeof nextStateForKey === "undefined") {
                        var actionType = action && action.type;
                        throw new Error(true ? formatProdErrorMessage(14) : 0);
                      }

                      nextState[_key] = nextStateForKey;
                      hasChanged =
                        hasChanged || nextStateForKey !== previousStateForKey;
                    }

                    hasChanged =
                      hasChanged ||
                      finalReducerKeys.length !== Object.keys(state).length;
                    return hasChanged ? nextState : state;
                  };
                }

                function bindActionCreator(actionCreator, dispatch) {
                  return function () {
                    return dispatch(actionCreator.apply(this, arguments));
                  };
                }
                /**
                 * Turns an object whose values are action creators, into an object with the
                 * same keys, but with every function wrapped into a `dispatch` call so they
                 * may be invoked directly. This is just a convenience method, as you can call
                 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
                 *
                 * For convenience, you can also pass an action creator as the first argument,
                 * and get a dispatch wrapped function in return.
                 *
                 * @param {Function|Object} actionCreators An object whose values are action
                 * creator functions. One handy way to obtain it is to use ES6 `import * as`
                 * syntax. You may also pass a single function.
                 *
                 * @param {Function} dispatch The `dispatch` function available on your Redux
                 * store.
                 *
                 * @returns {Function|Object} The object mimicking the original object, but with
                 * every action creator wrapped into the `dispatch` call. If you passed a
                 * function as `actionCreators`, the return value will also be a single
                 * function.
                 */

                function bindActionCreators(actionCreators, dispatch) {
                  if (typeof actionCreators === "function") {
                    return bindActionCreator(actionCreators, dispatch);
                  }

                  if (
                    typeof actionCreators !== "object" ||
                    actionCreators === null
                  ) {
                    throw new Error(true ? formatProdErrorMessage(16) : 0);
                  }

                  var boundActionCreators = {};

                  for (var key in actionCreators) {
                    var actionCreator = actionCreators[key];

                    if (typeof actionCreator === "function") {
                      boundActionCreators[key] = bindActionCreator(
                        actionCreator,
                        dispatch
                      );
                    }
                  }

                  return boundActionCreators;
                }

                /**
                 * Composes single-argument functions from right to left. The rightmost
                 * function can take multiple arguments as it provides the signature for
                 * the resulting composite function.
                 *
                 * @param {...Function} funcs The functions to compose.
                 * @returns {Function} A function obtained by composing the argument functions
                 * from right to left. For example, compose(f, g, h) is identical to doing
                 * (...args) => f(g(h(...args))).
                 */
                function compose() {
                  for (
                    var _len = arguments.length,
                      funcs = new Array(_len),
                      _key = 0;
                    _key < _len;
                    _key++
                  ) {
                    funcs[_key] = arguments[_key];
                  }

                  if (funcs.length === 0) {
                    return function (arg) {
                      return arg;
                    };
                  }

                  if (funcs.length === 1) {
                    return funcs[0];
                  }

                  return funcs.reduce(function (a, b) {
                    return function () {
                      return a(b.apply(void 0, arguments));
                    };
                  });
                }

                /**
                 * Creates a store enhancer that applies middleware to the dispatch method
                 * of the Redux store. This is handy for a variety of tasks, such as expressing
                 * asynchronous actions in a concise manner, or logging every action payload.
                 *
                 * See `redux-thunk` package as an example of the Redux middleware.
                 *
                 * Because middleware is potentially asynchronous, this should be the first
                 * store enhancer in the composition chain.
                 *
                 * Note that each middleware will be given the `dispatch` and `getState` functions
                 * as named arguments.
                 *
                 * @param {...Function} middlewares The middleware chain to be applied.
                 * @returns {Function} A store enhancer applying the middleware.
                 */

                function applyMiddleware() {
                  for (
                    var _len = arguments.length,
                      middlewares = new Array(_len),
                      _key = 0;
                    _key < _len;
                    _key++
                  ) {
                    middlewares[_key] = arguments[_key];
                  }

                  return function (createStore) {
                    return function () {
                      var store = createStore.apply(void 0, arguments);

                      var _dispatch = function dispatch() {
                        throw new Error(true ? formatProdErrorMessage(15) : 0);
                      };

                      var middlewareAPI = {
                        getState: store.getState,
                        dispatch: function dispatch() {
                          return _dispatch.apply(void 0, arguments);
                        },
                      };
                      var chain = middlewares.map(function (middleware) {
                        return middleware(middlewareAPI);
                      });
                      _dispatch = compose.apply(void 0, chain)(store.dispatch);
                      return _objectSpread2(
                        _objectSpread2({}, store),
                        {},
                        {
                          dispatch: _dispatch,
                        }
                      );
                    };
                  };
                }

                /*
                 * This is a dummy function to check if the function name has been altered by minification.
                 * If the function has been minified and NODE_ENV !== 'production', warn the user.
                 */

                function isCrushed() {}

                if (false) {
                }

                /***/
              },

              /******/
            };
            /************************************************************************/
            /******/ // The module cache
            /******/ var __webpack_module_cache__ = {};
            /******/
            /******/ // The require function
            /******/ function __nested_webpack_require_204296__(moduleId) {
              /******/ // Check if module is in cache
              /******/ var cachedModule = __webpack_module_cache__[moduleId];
              /******/ if (cachedModule !== undefined) {
                /******/ return cachedModule.exports;
                /******/
              }
              /******/ // Create a new module (and put it into the cache)
              /******/ var module = (__webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {},
                /******/
              });
              /******/
              /******/ // Execute the module function
              /******/ __webpack_modules__[moduleId].call(
                module.exports,
                module,
                module.exports,
                __nested_webpack_require_204296__
              );
              /******/
              /******/ // Return the exports of the module
              /******/ return module.exports;
              /******/
            }
            /******/
            /************************************************************************/
            /******/ /* webpack/runtime/compat get default export */ /******/ !(function () {
              /******/ // getDefaultExport function for compatibility with non-harmony modules
              /******/ __nested_webpack_require_204296__.n = function (module) {
                /******/ var getter =
                  module && module.__esModule
                    ? /******/ function () {
                        return module["default"];
                      }
                    : /******/ function () {
                        return module;
                      };
                /******/ __nested_webpack_require_204296__.d(getter, {
                  a: getter,
                });
                /******/ return getter;
                /******/
              };
              /******/
            })();
            /******/
            /******/ /* webpack/runtime/define property getters */ /******/ !(function () {
              /******/ // define getter functions for harmony exports
              /******/ __nested_webpack_require_204296__.d = function (
                exports,
                definition
              ) {
                /******/ for (var key in definition) {
                  /******/ if (
                    __nested_webpack_require_204296__.o(definition, key) &&
                    !__nested_webpack_require_204296__.o(exports, key)
                  ) {
                    /******/ Object.defineProperty(exports, key, {
                      enumerable: true,
                      get: definition[key],
                    });
                    /******/
                  }
                  /******/
                }
                /******/
              };
              /******/
            })();
            /******/
            /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !(function () {
              /******/ __nested_webpack_require_204296__.o = function (
                obj,
                prop
              ) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
              };
              /******/
            })();
            /******/
            /******/ /* webpack/runtime/make namespace object */ /******/ !(function () {
              /******/ // define __esModule on exports
              /******/ __nested_webpack_require_204296__.r = function (
                exports
              ) {
                /******/ if (
                  typeof Symbol !== "undefined" &&
                  Symbol.toStringTag
                ) {
                  /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module",
                  });
                  /******/
                }
                /******/ Object.defineProperty(exports, "__esModule", {
                  value: true,
                });
                /******/
              };
              /******/
            })();
            /******/
            /************************************************************************/
            var __webpack_exports__ = {};
            // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
            !(function () {
              /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0__ =
                __nested_webpack_require_204296__(373);
              /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default =
                /*#__PURE__*/ __nested_webpack_require_204296__.n(
                  _scripts_choices__WEBPACK_IMPORTED_MODULE_0__
                );
              /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__ =
                __nested_webpack_require_204296__(187);
              /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1___default =
                /*#__PURE__*/ __nested_webpack_require_204296__.n(
                  _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__
                );
              /* harmony import */ var _scripts_constants__WEBPACK_IMPORTED_MODULE_2__ =
                __nested_webpack_require_204296__(883);
              /* harmony import */ var _scripts_defaults__WEBPACK_IMPORTED_MODULE_3__ =
                __nested_webpack_require_204296__(789);
              /* harmony import */ var _scripts_templates__WEBPACK_IMPORTED_MODULE_4__ =
                __nested_webpack_require_204296__(686);

              /* harmony default export */ __webpack_exports__["default"] =
                _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default();
            })();
            __webpack_exports__ = __webpack_exports__["default"];
            /******/ return __webpack_exports__;
            /******/
          })();
        });

        /***/
      },

    /***/ "./node_modules/debug/src/browser.js":
      /*!*******************************************!*\
  !*** ./node_modules/debug/src/browser.js ***!
  \*******************************************/
      /***/ (module, exports, __webpack_require__) => {
        /* provided dependency */ var process = __webpack_require__(
          /*! process/browser.js */ "./node_modules/process/browser.js"
        );
        /**
         * This is the web browser implementation of `debug()`.
         *
         * Expose `debug()` as the module.
         */

        exports = module.exports = __webpack_require__(
          /*! ./debug */ "./node_modules/debug/src/debug.js"
        );
        exports.log = log;
        exports.formatArgs = formatArgs;
        exports.save = save;
        exports.load = load;
        exports.useColors = useColors;
        exports.storage =
          "undefined" != typeof chrome && "undefined" != typeof chrome.storage
            ? chrome.storage.local
            : localstorage();

        /**
         * Colors.
         */

        exports.colors = [
          "lightseagreen",
          "forestgreen",
          "goldenrod",
          "dodgerblue",
          "darkorchid",
          "crimson",
        ];

        /**
         * Currently only WebKit-based Web Inspectors, Firefox >= v31,
         * and the Firebug extension (any Firefox version) are known
         * to support "%c" CSS customizations.
         *
         * TODO: add a `localStorage` variable to explicitly enable/disable colors
         */

        function useColors() {
          // NB: In an Electron preload script, document will be defined but not fully
          // initialized. Since we know we're in Chrome, we'll just detect this case
          // explicitly
          if (
            typeof window !== "undefined" &&
            window.process &&
            window.process.type === "renderer"
          ) {
            return true;
          }

          // is webkit? http://stackoverflow.com/a/16459606/376773
          // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
          return (
            (typeof document !== "undefined" &&
              document.documentElement &&
              document.documentElement.style &&
              document.documentElement.style.WebkitAppearance) ||
            // is firebug? http://stackoverflow.com/a/398120/376773
            (typeof window !== "undefined" &&
              window.console &&
              (window.console.firebug ||
                (window.console.exception && window.console.table))) ||
            // is firefox >= v31?
            // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
            (typeof navigator !== "undefined" &&
              navigator.userAgent &&
              navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) &&
              parseInt(RegExp.$1, 10) >= 31) ||
            // double check webkit in userAgent just in case we are in a worker
            (typeof navigator !== "undefined" &&
              navigator.userAgent &&
              navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))
          );
        }

        /**
         * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
         */

        exports.formatters.j = function (v) {
          try {
            return JSON.stringify(v);
          } catch (err) {
            return "[UnexpectedJSONParseError]: " + err.message;
          }
        };

        /**
         * Colorize log arguments if enabled.
         *
         * @api public
         */

        function formatArgs(args) {
          var useColors = this.useColors;

          args[0] =
            (useColors ? "%c" : "") +
            this.namespace +
            (useColors ? " %c" : " ") +
            args[0] +
            (useColors ? "%c " : " ") +
            "+" +
            exports.humanize(this.diff);

          if (!useColors) return;

          var c = "color: " + this.color;
          args.splice(1, 0, c, "color: inherit");

          // the final "%c" is somewhat tricky, because there could be other
          // arguments passed either before or after the %c, so we need to
          // figure out the correct index to insert the CSS into
          var index = 0;
          var lastC = 0;
          args[0].replace(/%[a-zA-Z%]/g, function (match) {
            if ("%%" === match) return;
            index++;
            if ("%c" === match) {
              // we only are interested in the *last* %c
              // (the user may have provided their own)
              lastC = index;
            }
          });

          args.splice(lastC, 0, c);
        }

        /**
         * Invokes `console.log()` when available.
         * No-op when `console.log` is not a "function".
         *
         * @api public
         */

        function log() {
          // this hackery is required for IE8/9, where
          // the `console.log` function doesn't have 'apply'
          return (
            "object" === typeof console &&
            console.log &&
            Function.prototype.apply.call(console.log, console, arguments)
          );
        }

        /**
         * Save `namespaces`.
         *
         * @param {String} namespaces
         * @api private
         */

        function save(namespaces) {
          try {
            if (null == namespaces) {
              exports.storage.removeItem("debug");
            } else {
              exports.storage.debug = namespaces;
            }
          } catch (e) {}
        }

        /**
         * Load `namespaces`.
         *
         * @return {String} returns the previously persisted debug modes
         * @api private
         */

        function load() {
          var r;
          try {
            r = exports.storage.debug;
          } catch (e) {}

          // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
          if (!r && typeof process !== "undefined" && "env" in process) {
            r = process.env.DEBUG;
          }

          return r;
        }

        /**
         * Enable namespaces listed in `localStorage.debug` initially.
         */

        exports.enable(load());

        /**
         * Localstorage attempts to return the localstorage.
         *
         * This is necessary because safari throws
         * when a user disables cookies/localstorage
         * and you attempt to access it.
         *
         * @return {LocalStorage}
         * @api private
         */

        function localstorage() {
          try {
            return window.localStorage;
          } catch (e) {}
        }

        /***/
      },

    /***/ "./node_modules/debug/src/debug.js":
      /*!*****************************************!*\
  !*** ./node_modules/debug/src/debug.js ***!
  \*****************************************/
      /***/ (module, exports, __webpack_require__) => {
        /**
         * This is the common logic for both the Node.js and web browser
         * implementations of `debug()`.
         *
         * Expose `debug()` as the module.
         */

        exports =
          module.exports =
          createDebug.debug =
          createDebug["default"] =
            createDebug;
        exports.coerce = coerce;
        exports.disable = disable;
        exports.enable = enable;
        exports.enabled = enabled;
        exports.humanize = __webpack_require__(
          /*! ms */ "./node_modules/ms/index.js"
        );

        /**
         * The currently active debug mode names, and names to skip.
         */

        exports.names = [];
        exports.skips = [];

        /**
         * Map of special "%n" handling functions, for the debug "format" argument.
         *
         * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
         */

        exports.formatters = {};

        /**
         * Previous log timestamp.
         */

        var prevTime;

        /**
         * Select a color.
         * @param {String} namespace
         * @return {Number}
         * @api private
         */

        function selectColor(namespace) {
          var hash = 0,
            i;

          for (i in namespace) {
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
          }

          return exports.colors[Math.abs(hash) % exports.colors.length];
        }

        /**
         * Create a debugger with the given `namespace`.
         *
         * @param {String} namespace
         * @return {Function}
         * @api public
         */

        function createDebug(namespace) {
          function debug() {
            // disabled?
            if (!debug.enabled) return;

            var self = debug;

            // set `diff` timestamp
            var curr = +new Date();
            var ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;

            // turn the `arguments` into a proper Array
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; i++) {
              args[i] = arguments[i];
            }

            args[0] = exports.coerce(args[0]);

            if ("string" !== typeof args[0]) {
              // anything else let's inspect with %O
              args.unshift("%O");
            }

            // apply any `formatters` transformations
            var index = 0;
            args[0] = args[0].replace(
              /%([a-zA-Z%])/g,
              function (match, format) {
                // if we encounter an escaped % then don't increase the array index
                if (match === "%%") return match;
                index++;
                var formatter = exports.formatters[format];
                if ("function" === typeof formatter) {
                  var val = args[index];
                  match = formatter.call(self, val);

                  // now we need to remove `args[index]` since it's inlined in the `format`
                  args.splice(index, 1);
                  index--;
                }
                return match;
              }
            );

            // apply env-specific formatting (colors, etc.)
            exports.formatArgs.call(self, args);

            var logFn = debug.log || exports.log || console.log.bind(console);
            logFn.apply(self, args);
          }

          debug.namespace = namespace;
          debug.enabled = exports.enabled(namespace);
          debug.useColors = exports.useColors();
          debug.color = selectColor(namespace);

          // env-specific initialization logic for debug instances
          if ("function" === typeof exports.init) {
            exports.init(debug);
          }

          return debug;
        }

        /**
         * Enables a debug mode by namespaces. This can include modes
         * separated by a colon and wildcards.
         *
         * @param {String} namespaces
         * @api public
         */

        function enable(namespaces) {
          exports.save(namespaces);

          exports.names = [];
          exports.skips = [];

          var split = (typeof namespaces === "string" ? namespaces : "").split(
            /[\s,]+/
          );
          var len = split.length;

          for (var i = 0; i < len; i++) {
            if (!split[i]) continue; // ignore empty strings
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") {
              exports.skips.push(new RegExp("^" + namespaces.substr(1) + "$"));
            } else {
              exports.names.push(new RegExp("^" + namespaces + "$"));
            }
          }
        }

        /**
         * Disable debug output.
         *
         * @api public
         */

        function disable() {
          exports.enable("");
        }

        /**
         * Returns true if the given mode name is enabled, false otherwise.
         *
         * @param {String} name
         * @return {Boolean}
         * @api public
         */

        function enabled(name) {
          var i, len;
          for (i = 0, len = exports.skips.length; i < len; i++) {
            if (exports.skips[i].test(name)) {
              return false;
            }
          }
          for (i = 0, len = exports.names.length; i < len; i++) {
            if (exports.names[i].test(name)) {
              return true;
            }
          }
          return false;
        }

        /**
         * Coerce `val`.
         *
         * @param {Mixed} val
         * @return {Mixed}
         * @api private
         */

        function coerce(val) {
          if (val instanceof Error) return val.stack || val.message;
          return val;
        }

        /***/
      },

    /***/ "./node_modules/decode-uri-component/index.js":
      /*!****************************************************!*\
  !*** ./node_modules/decode-uri-component/index.js ***!
  \****************************************************/
      /***/ (module) => {
        "use strict";

        var token = "%[a-f0-9]{2}";
        var singleMatcher = new RegExp("(" + token + ")|([^%]+?)", "gi");
        var multiMatcher = new RegExp("(" + token + ")+", "gi");

        function decodeComponents(components, split) {
          try {
            // Try to decode the entire string first
            return [decodeURIComponent(components.join(""))];
          } catch (err) {
            // Do nothing
          }

          if (components.length === 1) {
            return components;
          }

          split = split || 1;

          // Split the array in 2 parts
          var left = components.slice(0, split);
          var right = components.slice(split);

          return Array.prototype.concat.call(
            [],
            decodeComponents(left),
            decodeComponents(right)
          );
        }

        function decode(input) {
          try {
            return decodeURIComponent(input);
          } catch (err) {
            var tokens = input.match(singleMatcher) || [];

            for (var i = 1; i < tokens.length; i++) {
              input = decodeComponents(tokens, i).join("");

              tokens = input.match(singleMatcher) || [];
            }

            return input;
          }
        }

        function customDecodeURIComponent(input) {
          // Keep track of all the replacements and prefill the map with the `BOM`
          var replaceMap = {
            "%FE%FF": "\uFFFD\uFFFD",
            "%FF%FE": "\uFFFD\uFFFD",
          };

          var match = multiMatcher.exec(input);
          while (match) {
            try {
              // Decode as big chunks as possible
              replaceMap[match[0]] = decodeURIComponent(match[0]);
            } catch (err) {
              var result = decode(match[0]);

              if (result !== match[0]) {
                replaceMap[match[0]] = result;
              }
            }

            match = multiMatcher.exec(input);
          }

          // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
          replaceMap["%C2"] = "\uFFFD";

          var entries = Object.keys(replaceMap);

          for (var i = 0; i < entries.length; i++) {
            // Replace all decoded components
            var key = entries[i];
            input = input.replace(new RegExp(key, "g"), replaceMap[key]);
          }

          return input;
        }

        module.exports = function (encodedURI) {
          if (typeof encodedURI !== "string") {
            throw new TypeError(
              "Expected `encodedURI` to be of type `string`, got `" +
                typeof encodedURI +
                "`"
            );
          }

          try {
            encodedURI = encodedURI.replace(/\+/g, " ");

            // Try the built in decoder first
            return decodeURIComponent(encodedURI);
          } catch (err) {
            // Fallback to a more advanced decoder
            return customDecodeURIComponent(encodedURI);
          }
        };

        /***/
      },

    /***/ "./node_modules/dom-event/index.js":
      /*!*****************************************!*\
  !*** ./node_modules/dom-event/index.js ***!
  \*****************************************/
      /***/ (module) => {
        module.exports = on;
        module.exports.on = on;
        module.exports.off = off;

        function on(element, event, callback, capture) {
          !element.addEventListener && (event = "on" + event);
          (element.addEventListener || element.attachEvent).call(
            element,
            event,
            callback,
            capture
          );
          return callback;
        }

        function off(element, event, callback, capture) {
          !element.removeEventListener && (event = "on" + event);
          (element.removeEventListener || element.detachEvent).call(
            element,
            event,
            callback,
            capture
          );
          return callback;
        }

        /***/
      },

    /***/ "./node_modules/dom-select/index.js":
      /*!******************************************!*\
  !*** ./node_modules/dom-select/index.js ***!
  \******************************************/
      /***/ (module) => {
        module.exports = one;
        module.exports.all = all;

        function one(selector, parent) {
          parent || (parent = document);
          return parent.querySelector(selector);
        }

        function all(selector, parent) {
          parent || (parent = document);
          var selection = parent.querySelectorAll(selector);
          return Array.prototype.slice.call(selection);
        }

        /***/
      },

    /***/ "./node_modules/ev-emitter/ev-emitter.js":
      /*!***********************************************!*\
  !*** ./node_modules/ev-emitter/ev-emitter.js ***!
  \***********************************************/
      /***/ function (module) {
        /**
         * EvEmitter v2.1.1
         * Lil' event emitter
         * MIT License
         */

        (function (global, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS - Browserify, Webpack
            module.exports = factory();
          } else {
            // Browser globals
            global.EvEmitter = factory();
          }
        })(typeof window != "undefined" ? window : this, function () {
          function EvEmitter() {}

          let proto = EvEmitter.prototype;

          proto.on = function (eventName, listener) {
            if (!eventName || !listener) return this;

            // set events hash
            let events = (this._events = this._events || {});
            // set listeners array
            let listeners = (events[eventName] = events[eventName] || []);
            // only add once
            if (!listeners.includes(listener)) {
              listeners.push(listener);
            }

            return this;
          };

          proto.once = function (eventName, listener) {
            if (!eventName || !listener) return this;

            // add event
            this.on(eventName, listener);
            // set once flag
            // set onceEvents hash
            let onceEvents = (this._onceEvents = this._onceEvents || {});
            // set onceListeners object
            let onceListeners = (onceEvents[eventName] =
              onceEvents[eventName] || {});
            // set flag
            onceListeners[listener] = true;

            return this;
          };

          proto.off = function (eventName, listener) {
            let listeners = this._events && this._events[eventName];
            if (!listeners || !listeners.length) return this;

            let index = listeners.indexOf(listener);
            if (index != -1) {
              listeners.splice(index, 1);
            }

            return this;
          };

          proto.emitEvent = function (eventName, args) {
            let listeners = this._events && this._events[eventName];
            if (!listeners || !listeners.length) return this;

            // copy over to avoid interference if .off() in listener
            listeners = listeners.slice(0);
            args = args || [];
            // once stuff
            let onceListeners = this._onceEvents && this._onceEvents[eventName];

            for (let listener of listeners) {
              let isOnce = onceListeners && onceListeners[listener];
              if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
              }
              // trigger listener
              listener.apply(this, args);
            }

            return this;
          };

          proto.allOff = function () {
            delete this._events;
            delete this._onceEvents;
            return this;
          };

          return EvEmitter;
        });

        /***/
      },

    /***/ "./node_modules/filter-obj/index.js":
      /*!******************************************!*\
  !*** ./node_modules/filter-obj/index.js ***!
  \******************************************/
      /***/ (module) => {
        "use strict";

        module.exports = function (obj, predicate) {
          var ret = {};
          var keys = Object.keys(obj);
          var isArr = Array.isArray(predicate);

          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var val = obj[key];

            if (
              isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)
            ) {
              ret[key] = val;
            }
          }

          return ret;
        };

        /***/
      },

    /***/ "./node_modules/fizzy-ui-utils/utils.js":
      /*!**********************************************!*\
  !*** ./node_modules/fizzy-ui-utils/utils.js ***!
  \**********************************************/
      /***/ function (module) {
        /**
         * Fizzy UI utils v3.0.0
         * MIT license
         */

        (function (global, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(global);
          } else {
            // browser global
            global.fizzyUIUtils = factory(global);
          }
        })(this, function factory(global) {
          let utils = {};

          // ----- extend ----- //

          // extends objects
          utils.extend = function (a, b) {
            return Object.assign(a, b);
          };

          // ----- modulo ----- //

          utils.modulo = function (num, div) {
            return ((num % div) + div) % div;
          };

          // ----- makeArray ----- //

          // turn element or nodeList into an array
          utils.makeArray = function (obj) {
            // use object if already an array
            if (Array.isArray(obj)) return obj;

            // return empty array if undefined or null. #6
            if (obj === null || obj === undefined) return [];

            let isArrayLike =
              typeof obj == "object" && typeof obj.length == "number";
            // convert nodeList to array
            if (isArrayLike) return [...obj];

            // array of single index
            return [obj];
          };

          // ----- removeFrom ----- //

          utils.removeFrom = function (ary, obj) {
            let index = ary.indexOf(obj);
            if (index != -1) {
              ary.splice(index, 1);
            }
          };

          // ----- getParent ----- //

          utils.getParent = function (elem, selector) {
            while (elem.parentNode && elem != document.body) {
              elem = elem.parentNode;
              if (elem.matches(selector)) return elem;
            }
          };

          // ----- getQueryElement ----- //

          // use element as selector string
          utils.getQueryElement = function (elem) {
            if (typeof elem == "string") {
              return document.querySelector(elem);
            }
            return elem;
          };

          // ----- handleEvent ----- //

          // enable .ontype to trigger from .addEventListener( elem, 'type' )
          utils.handleEvent = function (event) {
            let method = "on" + event.type;
            if (this[method]) {
              this[method](event);
            }
          };

          // ----- filterFindElements ----- //

          utils.filterFindElements = function (elems, selector) {
            // make array of elems
            elems = utils.makeArray(elems);

            return (
              elems
                // check that elem is an actual element
                .filter((elem) => elem instanceof HTMLElement)
                .reduce((ffElems, elem) => {
                  // add elem if no selector
                  if (!selector) {
                    ffElems.push(elem);
                    return ffElems;
                  }
                  // filter & find items if we have a selector
                  // filter
                  if (elem.matches(selector)) {
                    ffElems.push(elem);
                  }
                  // find children
                  let childElems = elem.querySelectorAll(selector);
                  // concat childElems to filterFound array
                  ffElems = ffElems.concat(...childElems);
                  return ffElems;
                }, [])
            );
          };

          // ----- debounceMethod ----- //

          utils.debounceMethod = function (_class, methodName, threshold) {
            threshold = threshold || 100;
            // original method
            let method = _class.prototype[methodName];
            let timeoutName = methodName + "Timeout";

            _class.prototype[methodName] = function () {
              clearTimeout(this[timeoutName]);

              let args = arguments;
              this[timeoutName] = setTimeout(() => {
                method.apply(this, args);
                delete this[timeoutName];
              }, threshold);
            };
          };

          // ----- docReady ----- //

          utils.docReady = function (onDocReady) {
            let readyState = document.readyState;
            if (readyState == "complete" || readyState == "interactive") {
              // do async to allow for other scripts to run. metafizzy/flickity#441
              setTimeout(onDocReady);
            } else {
              document.addEventListener("DOMContentLoaded", onDocReady);
            }
          };

          // ----- htmlInit ----- //

          // http://bit.ly/3oYLusc
          utils.toDashed = function (str) {
            return str
              .replace(/(.)([A-Z])/g, function (match, $1, $2) {
                return $1 + "-" + $2;
              })
              .toLowerCase();
          };

          let console = global.console;

          // allow user to initialize classes via [data-namespace] or .js-namespace class
          // htmlInit( Widget, 'widgetName' )
          // options are parsed from data-namespace-options
          utils.htmlInit = function (WidgetClass, namespace) {
            utils.docReady(function () {
              let dashedNamespace = utils.toDashed(namespace);
              let dataAttr = "data-" + dashedNamespace;
              let dataAttrElems = document.querySelectorAll(`[${dataAttr}]`);
              let jQuery = global.jQuery;

              [...dataAttrElems].forEach((elem) => {
                let attr = elem.getAttribute(dataAttr);
                let options;
                try {
                  options = attr && JSON.parse(attr);
                } catch (error) {
                  // log error, do not initialize
                  if (console) {
                    console.error(
                      `Error parsing ${dataAttr} on ${elem.className}: ${error}`
                    );
                  }
                  return;
                }
                // initialize
                let instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) {
                  jQuery.data(elem, namespace, instance);
                }
              });
            });
          };

          // -----  ----- //

          return utils;
        });

        /***/
      },

    /***/ "./node_modules/flickity/js/add-remove-cell.js":
      /*!*****************************************************!*\
  !*** ./node_modules/flickity/js/add-remove-cell.js ***!
  \*****************************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // add, remove cell
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              ),
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity, window.fizzyUIUtils);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity, utils) {
            // append cells to a document fragment
            function getCellsFragment(cells) {
              let fragment = document.createDocumentFragment();
              cells.forEach((cell) => fragment.appendChild(cell.element));
              return fragment;
            }

            // -------------------------- add/remove cell prototype -------------------------- //

            let proto = Flickity.prototype;

            /**
             * Insert, prepend, or append cells
             * @param {[Element, Array, NodeList]} elems - Elements to insert
             * @param {Integer} index - Zero-based number to insert
             */
            proto.insert = function (elems, index) {
              let cells = this._makeCells(elems);
              if (!cells || !cells.length) return;

              let len = this.cells.length;
              // default to append
              index = index === undefined ? len : index;
              // add cells with document fragment
              let fragment = getCellsFragment(cells);
              // append to slider
              let isAppend = index === len;
              if (isAppend) {
                this.slider.appendChild(fragment);
              } else {
                let insertCellElement = this.cells[index].element;
                this.slider.insertBefore(fragment, insertCellElement);
              }
              // add to this.cells
              if (index === 0) {
                // prepend, add to start
                this.cells = cells.concat(this.cells);
              } else if (isAppend) {
                // append, add to end
                this.cells = this.cells.concat(cells);
              } else {
                // insert in this.cells
                let endCells = this.cells.splice(index, len - index);
                this.cells = this.cells.concat(cells).concat(endCells);
              }

              this._sizeCells(cells);
              this.cellChange(index);
              this.positionSliderAtSelected();
            };

            proto.append = function (elems) {
              this.insert(elems, this.cells.length);
            };

            proto.prepend = function (elems) {
              this.insert(elems, 0);
            };

            /**
             * Remove cells
             * @param {[Element, Array, NodeList]} elems - ELements to remove
             */
            proto.remove = function (elems) {
              let cells = this.getCells(elems);
              if (!cells || !cells.length) return;

              let minCellIndex = this.cells.length - 1;
              // remove cells from collection & DOM
              cells.forEach((cell) => {
                cell.remove();
                let index = this.cells.indexOf(cell);
                minCellIndex = Math.min(index, minCellIndex);
                utils.removeFrom(this.cells, cell);
              });

              this.cellChange(minCellIndex);
              this.positionSliderAtSelected();
            };

            /**
             * logic to be run after a cell's size changes
             * @param {Element} elem - cell's element
             */
            proto.cellSizeChange = function (elem) {
              let cell = this.getCell(elem);
              if (!cell) return;

              cell.getSize();

              let index = this.cells.indexOf(cell);
              this.cellChange(index);
              // do not position slider after lazy load
            };

            /**
             * logic any time a cell is changed: added, removed, or size changed
             * @param {Integer} changedCellIndex - index of the changed cell, optional
             */
            proto.cellChange = function (changedCellIndex) {
              let prevSelectedElem = this.selectedElement;
              this._positionCells(changedCellIndex);
              this._updateWrapShiftCells();
              this.setGallerySize();
              // update selectedIndex, try to maintain position & select previous selected element
              let cell = this.getCell(prevSelectedElem);
              if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
              this.selectedIndex = Math.min(
                this.slides.length - 1,
                this.selectedIndex
              );

              this.emitEvent("cellChange", [changedCellIndex]);
              // position slider
              this.select(this.selectedIndex);
            };

            // -----  ----- //

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/animate.js":
      /*!*********************************************!*\
  !*** ./node_modules/flickity/js/animate.js ***!
  \*********************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // animate
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              )
            );
          } else {
            // browser global
            window.Flickity = window.Flickity || {};
            window.Flickity.animatePrototype = factory(window.fizzyUIUtils);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(utils) {
            // -------------------------- animate -------------------------- //

            let proto = {};

            proto.startAnimation = function () {
              if (this.isAnimating) return;

              this.isAnimating = true;
              this.restingFrames = 0;
              this.animate();
            };

            proto.animate = function () {
              this.applyDragForce();
              this.applySelectedAttraction();

              let previousX = this.x;

              this.integratePhysics();
              this.positionSlider();
              this.settle(previousX);
              // animate next frame
              if (this.isAnimating) requestAnimationFrame(() => this.animate());
            };

            proto.positionSlider = function () {
              let x = this.x;
              // wrap position around
              if (this.isWrapping) {
                x = utils.modulo(x, this.slideableWidth) - this.slideableWidth;
                this.shiftWrapCells(x);
              }

              this.setTranslateX(x, this.isAnimating);
              this.dispatchScrollEvent();
            };

            proto.setTranslateX = function (x, is3d) {
              x += this.cursorPosition;
              // reverse if right-to-left and using transform
              if (this.options.rightToLeft) x = -x;
              let translateX = this.getPositionValue(x);
              // use 3D transforms for hardware acceleration on iOS
              // but use 2D when settled, for better font-rendering
              this.slider.style.transform = is3d
                ? `translate3d(${translateX},0,0)`
                : `translateX(${translateX})`;
            };

            proto.dispatchScrollEvent = function () {
              let firstSlide = this.slides[0];
              if (!firstSlide) return;

              let positionX = -this.x - firstSlide.target;
              let progress = positionX / this.slidesWidth;
              this.dispatchEvent("scroll", null, [progress, positionX]);
            };

            proto.positionSliderAtSelected = function () {
              if (!this.cells.length) return;

              this.x = -this.selectedSlide.target;
              this.velocity = 0; // stop wobble
              this.positionSlider();
            };

            proto.getPositionValue = function (position) {
              if (this.options.percentPosition) {
                // percent position, round to 2 digits, like 12.34%
                return (
                  Math.round((position / this.size.innerWidth) * 10000) * 0.01 +
                  "%"
                );
              } else {
                // pixel positioning
                return Math.round(position) + "px";
              }
            };

            proto.settle = function (previousX) {
              // keep track of frames where x hasn't moved
              let isResting =
                !this.isPointerDown &&
                Math.round(this.x * 100) === Math.round(previousX * 100);
              if (isResting) this.restingFrames++;
              // stop animating if resting for 3 or more frames
              if (this.restingFrames > 2) {
                this.isAnimating = false;
                delete this.isFreeScrolling;
                // render position with translateX when settled
                this.positionSlider();
                this.dispatchEvent("settle", null, [this.selectedIndex]);
              }
            };

            proto.shiftWrapCells = function (x) {
              // shift before cells
              let beforeGap = this.cursorPosition + x;
              this._shiftCells(this.beforeShiftCells, beforeGap, -1);
              // shift after cells
              let afterGap =
                this.size.innerWidth -
                (x + this.slideableWidth + this.cursorPosition);
              this._shiftCells(this.afterShiftCells, afterGap, 1);
            };

            proto._shiftCells = function (cells, gap, shift) {
              cells.forEach((cell) => {
                let cellShift = gap > 0 ? shift : 0;
                this._wrapShiftCell(cell, cellShift);
                gap -= cell.size.outerWidth;
              });
            };

            proto._unshiftCells = function (cells) {
              if (!cells || !cells.length) return;

              cells.forEach((cell) => this._wrapShiftCell(cell, 0));
            };

            // @param {Integer} shift - 0, 1, or -1
            proto._wrapShiftCell = function (cell, shift) {
              this._renderCellPosition(
                cell,
                cell.x + this.slideableWidth * shift
              );
            };

            // -------------------------- physics -------------------------- //

            proto.integratePhysics = function () {
              this.x += this.velocity;
              this.velocity *= this.getFrictionFactor();
            };

            proto.applyForce = function (force) {
              this.velocity += force;
            };

            proto.getFrictionFactor = function () {
              return (
                1 -
                this.options[
                  this.isFreeScrolling ? "freeScrollFriction" : "friction"
                ]
              );
            };

            proto.getRestingPosition = function () {
              // my thanks to Steven Wittens, who simplified this math greatly
              return this.x + this.velocity / (1 - this.getFrictionFactor());
            };

            proto.applyDragForce = function () {
              if (!this.isDraggable || !this.isPointerDown) return;

              // change the position to drag position by applying force
              let dragVelocity = this.dragX - this.x;
              let dragForce = dragVelocity - this.velocity;
              this.applyForce(dragForce);
            };

            proto.applySelectedAttraction = function () {
              // do not attract if pointer down or no slides
              let dragDown = this.isDraggable && this.isPointerDown;
              if (dragDown || this.isFreeScrolling || !this.slides.length)
                return;

              let distance = this.selectedSlide.target * -1 - this.x;
              let force = distance * this.options.selectedAttraction;
              this.applyForce(force);
            };

            return proto;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/cell.js":
      /*!******************************************!*\
  !*** ./node_modules/flickity/js/cell.js ***!
  \******************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // Flickity.Cell
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! get-size */ "./node_modules/get-size/get-size.js"
              )
            );
          } else {
            // browser global
            window.Flickity = window.Flickity || {};
            window.Flickity.Cell = factory(window.getSize);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(getSize) {
            const cellClassName = "flickity-cell";

            function Cell(elem) {
              this.element = elem;
              this.element.classList.add(cellClassName);

              this.x = 0;
              this.unselect();
            }

            let proto = Cell.prototype;

            proto.destroy = function () {
              // reset style
              this.unselect();
              this.element.classList.remove(cellClassName);
              this.element.style.transform = "";
              this.element.removeAttribute("aria-hidden");
            };

            proto.getSize = function () {
              this.size = getSize(this.element);
            };

            proto.select = function () {
              this.element.classList.add("is-selected");
              this.element.removeAttribute("aria-hidden");
            };

            proto.unselect = function () {
              this.element.classList.remove("is-selected");
              this.element.setAttribute("aria-hidden", "true");
            };

            proto.remove = function () {
              this.element.remove();
            };

            return Cell;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/core.js":
      /*!******************************************!*\
  !*** ./node_modules/flickity/js/core.js ***!
  \******************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // Flickity main
        /* eslint-disable max-params */
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              window,
              __webpack_require__(
                /*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"
              ),
              __webpack_require__(
                /*! get-size */ "./node_modules/get-size/get-size.js"
              ),
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              ),
              __webpack_require__(
                /*! ./cell */ "./node_modules/flickity/js/cell.js"
              ),
              __webpack_require__(
                /*! ./slide */ "./node_modules/flickity/js/slide.js"
              ),
              __webpack_require__(
                /*! ./animate */ "./node_modules/flickity/js/animate.js"
              )
            );
          } else {
            // browser global
            let _Flickity = window.Flickity;

            window.Flickity = factory(
              window,
              window.EvEmitter,
              window.getSize,
              window.fizzyUIUtils,
              _Flickity.Cell,
              _Flickity.Slide,
              _Flickity.animatePrototype
            );
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(
            window,
            EvEmitter,
            getSize,
            utils,
            Cell,
            Slide,
            animatePrototype
          ) {
            /* eslint-enable max-params */

            // vars
            const { getComputedStyle, console } = window;
            let { jQuery } = window;

            // -------------------------- Flickity -------------------------- //

            // globally unique identifiers
            let GUID = 0;
            // internal store of all Flickity intances
            let instances = {};

            function Flickity(element, options) {
              let queryElement = utils.getQueryElement(element);
              if (!queryElement) {
                if (console)
                  console.error(
                    `Bad element for Flickity: ${queryElement || element}`
                  );
                return;
              }
              this.element = queryElement;
              // do not initialize twice on same element
              if (this.element.flickityGUID) {
                let instance = instances[this.element.flickityGUID];
                if (instance) instance.option(options);
                return instance;
              }

              // add jQuery
              if (jQuery) {
                this.$element = jQuery(this.element);
              }
              // options
              this.options = { ...this.constructor.defaults };
              this.option(options);

              // kick things off
              this._create();
            }

            Flickity.defaults = {
              accessibility: true,
              // adaptiveHeight: false,
              cellAlign: "center",
              // cellSelector: undefined,
              // contain: false,
              freeScrollFriction: 0.075, // friction when free-scrolling
              friction: 0.28, // friction when selecting
              namespaceJQueryEvents: true,
              // initialIndex: 0,
              percentPosition: true,
              resize: true,
              selectedAttraction: 0.025,
              setGallerySize: true,
              // watchCSS: false,
              // wrapAround: false
            };

            // hash of methods triggered on _create()
            Flickity.create = {};

            let proto = Flickity.prototype;
            // inherit EventEmitter
            Object.assign(proto, EvEmitter.prototype);

            proto._create = function () {
              let { resize, watchCSS, rightToLeft } = this.options;
              // add id for Flickity.data
              let id = (this.guid = ++GUID);
              this.element.flickityGUID = id; // expando
              instances[id] = this; // associate via id
              // initial properties
              this.selectedIndex = 0;
              // how many frames slider has been in same position
              this.restingFrames = 0;
              // initial physics properties
              this.x = 0;
              this.velocity = 0;
              this.beginMargin = rightToLeft ? "marginRight" : "marginLeft";
              this.endMargin = rightToLeft ? "marginLeft" : "marginRight";
              // create viewport & slider
              this.viewport = document.createElement("div");
              this.viewport.className = "flickity-viewport";
              this._createSlider();
              // used for keyboard navigation
              this.focusableElems = [this.element];

              if (resize || watchCSS) {
                window.addEventListener("resize", this);
              }

              // add listeners from on option
              for (let eventName in this.options.on) {
                let listener = this.options.on[eventName];
                this.on(eventName, listener);
              }

              for (let method in Flickity.create) {
                Flickity.create[method].call(this);
              }

              if (watchCSS) {
                this.watchCSS();
              } else {
                this.activate();
              }
            };

            /**
             * set options
             * @param {Object} opts - options to extend
             */
            proto.option = function (opts) {
              Object.assign(this.options, opts);
            };

            proto.activate = function () {
              if (this.isActive) return;

              this.isActive = true;
              this.element.classList.add("flickity-enabled");
              if (this.options.rightToLeft) {
                this.element.classList.add("flickity-rtl");
              }

              this.getSize();
              // move initial cell elements so they can be loaded as cells
              let cellElems = this._filterFindCellElements(
                this.element.children
              );
              this.slider.append(...cellElems);
              this.viewport.append(this.slider);
              this.element.append(this.viewport);
              // get cells from children
              this.reloadCells();

              if (this.options.accessibility) {
                // allow element to focusable
                this.element.tabIndex = 0;
                // listen for key presses
                this.element.addEventListener("keydown", this);
              }

              this.emitEvent("activate");
              this.selectInitialIndex();
              // flag for initial activation, for using initialIndex
              this.isInitActivated = true;
              // ready event. #493
              this.dispatchEvent("ready");
            };

            // slider positions the cells
            proto._createSlider = function () {
              // slider element does all the positioning
              let slider = document.createElement("div");
              slider.className = "flickity-slider";
              this.slider = slider;
            };

            proto._filterFindCellElements = function (elems) {
              return utils.filterFindElements(elems, this.options.cellSelector);
            };

            // goes through all children
            proto.reloadCells = function () {
              // collection of item elements
              this.cells = this._makeCells(this.slider.children);
              this.positionCells();
              this._updateWrapShiftCells();
              this.setGallerySize();
            };

            /**
             * turn elements into Flickity.Cells
             * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
             * @returns {Array} items - collection of new Flickity Cells
             */
            proto._makeCells = function (elems) {
              let cellElems = this._filterFindCellElements(elems);

              // create new Cells for collection
              return cellElems.map((cellElem) => new Cell(cellElem));
            };

            proto.getLastCell = function () {
              return this.cells[this.cells.length - 1];
            };

            proto.getLastSlide = function () {
              return this.slides[this.slides.length - 1];
            };

            // positions all cells
            proto.positionCells = function () {
              // size all cells
              this._sizeCells(this.cells);
              // position all cells
              this._positionCells(0);
            };

            /**
             * position certain cells
             * @param {Integer} index - which cell to start with
             */
            proto._positionCells = function (index) {
              index = index || 0;
              // also measure maxCellHeight
              // start 0 if positioning all cells
              this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
              let cellX = 0;
              // get cellX
              if (index > 0) {
                let startCell = this.cells[index - 1];
                cellX = startCell.x + startCell.size.outerWidth;
              }

              this.cells.slice(index).forEach((cell) => {
                cell.x = cellX;
                this._renderCellPosition(cell, cellX);
                cellX += cell.size.outerWidth;
                this.maxCellHeight = Math.max(
                  cell.size.outerHeight,
                  this.maxCellHeight
                );
              });
              // keep track of cellX for wrap-around
              this.slideableWidth = cellX;
              // slides
              this.updateSlides();
              // contain slides target
              this._containSlides();
              // update slidesWidth
              this.slidesWidth = this.cells.length
                ? this.getLastSlide().target - this.slides[0].target
                : 0;
            };

            proto._renderCellPosition = function (cell, x) {
              // render position of cell with in slider
              let sideOffset = this.options.rightToLeft ? -1 : 1;
              let renderX = x * sideOffset;
              if (this.options.percentPosition)
                renderX *= this.size.innerWidth / cell.size.width;
              let positionValue = this.getPositionValue(renderX);
              cell.element.style.transform = `translateX( ${positionValue} )`;
            };

            /**
             * cell.getSize() on multiple cells
             * @param {Array} cells - cells to size
             */
            proto._sizeCells = function (cells) {
              cells.forEach((cell) => cell.getSize());
            };

            // --------------------------  -------------------------- //

            proto.updateSlides = function () {
              this.slides = [];
              if (!this.cells.length) return;

              let { beginMargin, endMargin } = this;
              let slide = new Slide(beginMargin, endMargin, this.cellAlign);
              this.slides.push(slide);

              let canCellFit = this._getCanCellFit();

              this.cells.forEach((cell, i) => {
                // just add cell if first cell in slide
                if (!slide.cells.length) {
                  slide.addCell(cell);
                  return;
                }

                let slideWidth =
                  slide.outerWidth -
                  slide.firstMargin +
                  (cell.size.outerWidth - cell.size[endMargin]);

                if (canCellFit(i, slideWidth)) {
                  slide.addCell(cell);
                } else {
                  // doesn't fit, new slide
                  slide.updateTarget();

                  slide = new Slide(beginMargin, endMargin, this.cellAlign);
                  this.slides.push(slide);
                  slide.addCell(cell);
                }
              });
              // last slide
              slide.updateTarget();
              // update .selectedSlide
              this.updateSelectedSlide();
            };

            proto._getCanCellFit = function () {
              let { groupCells } = this.options;
              if (!groupCells) return () => false;

              if (typeof groupCells == "number") {
                // group by number. 3 -> [0,1,2], [3,4,5], ...
                let number = parseInt(groupCells, 10);
                return (i) => i % number !== 0;
              }
              // default, group by width of slide
              let percent = 1;
              // parse '75%
              let percentMatch =
                typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
              if (percentMatch) percent = parseInt(percentMatch[1], 10) / 100;
              let groupWidth = (this.size.innerWidth + 1) * percent;
              return (i, slideWidth) => slideWidth <= groupWidth;
            };

            // alias _init for jQuery plugin .flickity()
            proto._init = proto.reposition = function () {
              this.positionCells();
              this.positionSliderAtSelected();
            };

            proto.getSize = function () {
              this.size = getSize(this.element);
              this.setCellAlign();
              this.cursorPosition = this.size.innerWidth * this.cellAlign;
            };

            let cellAlignShorthands = {
              left: 0,
              center: 0.5,
              right: 1,
            };

            proto.setCellAlign = function () {
              let { cellAlign, rightToLeft } = this.options;
              let shorthand = cellAlignShorthands[cellAlign];
              this.cellAlign = shorthand !== undefined ? shorthand : cellAlign;
              if (rightToLeft) this.cellAlign = 1 - this.cellAlign;
            };

            proto.setGallerySize = function () {
              if (!this.options.setGallerySize) return;

              let height =
                this.options.adaptiveHeight && this.selectedSlide
                  ? this.selectedSlide.height
                  : this.maxCellHeight;
              this.viewport.style.height = `${height}px`;
            };

            proto._updateWrapShiftCells = function () {
              // update isWrapping
              this.isWrapping = this.getIsWrapping();
              // only for wrap-around
              if (!this.isWrapping) return;

              // unshift previous cells
              this._unshiftCells(this.beforeShiftCells);
              this._unshiftCells(this.afterShiftCells);
              // get before cells
              // initial gap
              let beforeGapX = this.cursorPosition;
              let lastIndex = this.cells.length - 1;
              this.beforeShiftCells = this._getGapCells(
                beforeGapX,
                lastIndex,
                -1
              );
              // get after cells
              // ending gap between last cell and end of gallery viewport
              let afterGapX = this.size.innerWidth - this.cursorPosition;
              // start cloning at first cell, working forwards
              this.afterShiftCells = this._getGapCells(afterGapX, 0, 1);
            };

            proto.getIsWrapping = function () {
              let { wrapAround } = this.options;
              if (!wrapAround || this.slides.length < 2) return false;

              if (wrapAround !== "fill") return true;
              // check that slides can fit

              let gapWidth = this.slideableWidth - this.size.innerWidth;
              if (gapWidth > this.size.innerWidth) return true; // gap * 2x big, all good
              // check that content width - shifting cell is bigger than viewport width
              for (let cell of this.cells) {
                if (cell.size.outerWidth > gapWidth) return false;
              }
              return true;
            };

            proto._getGapCells = function (gapX, cellIndex, increment) {
              // keep adding cells until the cover the initial gap
              let cells = [];
              while (gapX > 0) {
                let cell = this.cells[cellIndex];
                if (!cell) break;

                cells.push(cell);
                cellIndex += increment;
                gapX -= cell.size.outerWidth;
              }
              return cells;
            };

            // ----- contain & wrap ----- //

            // contain cell targets so no excess sliding
            proto._containSlides = function () {
              let isContaining =
                this.options.contain && !this.isWrapping && this.cells.length;
              if (!isContaining) return;

              let contentWidth =
                this.slideableWidth - this.getLastCell().size[this.endMargin];
              // content is less than gallery size
              let isContentSmaller = contentWidth < this.size.innerWidth;
              if (isContentSmaller) {
                // all cells fit inside gallery
                this.slides.forEach((slide) => {
                  slide.target = contentWidth * this.cellAlign;
                });
              } else {
                // contain to bounds
                let beginBound =
                  this.cursorPosition + this.cells[0].size[this.beginMargin];
                let endBound =
                  contentWidth - this.size.innerWidth * (1 - this.cellAlign);
                this.slides.forEach((slide) => {
                  slide.target = Math.max(slide.target, beginBound);
                  slide.target = Math.min(slide.target, endBound);
                });
              }
            };

            // ----- events ----- //

            /**
             * emits events via eventEmitter and jQuery events
             * @param {String} type - name of event
             * @param {Event} event - original event
             * @param {Array} args - extra arguments
             */
            proto.dispatchEvent = function (type, event, args) {
              let emitArgs = event ? [event].concat(args) : args;
              this.emitEvent(type, emitArgs);

              if (jQuery && this.$element) {
                // default trigger with type if no event
                type += this.options.namespaceJQueryEvents ? ".flickity" : "";
                let $event = type;
                if (event) {
                  // create jQuery event
                  let jQEvent = new jQuery.Event(event);
                  jQEvent.type = type;
                  $event = jQEvent;
                }
                this.$element.trigger($event, args);
              }
            };

            const unidraggerEvents = [
              "dragStart",
              "dragMove",
              "dragEnd",
              "pointerDown",
              "pointerMove",
              "pointerEnd",
              "staticClick",
            ];

            let _emitEvent = proto.emitEvent;
            proto.emitEvent = function (eventName, args) {
              if (eventName === "staticClick") {
                // add cellElem and cellIndex args to staticClick
                let clickedCell = this.getParentCell(args[0].target);
                let cellElem = clickedCell && clickedCell.element;
                let cellIndex = clickedCell && this.cells.indexOf(clickedCell);
                args = args.concat(cellElem, cellIndex);
              }
              // do regular thing
              _emitEvent.call(this, eventName, args);
              // duck-punch in jQuery events for Unidragger events
              let isUnidraggerEvent = unidraggerEvents.includes(eventName);
              if (!isUnidraggerEvent || !jQuery || !this.$element) return;

              eventName += this.options.namespaceJQueryEvents
                ? ".flickity"
                : "";
              let event = args.shift(0);
              let jQEvent = new jQuery.Event(event);
              jQEvent.type = eventName;
              this.$element.trigger(jQEvent, args);
            };

            // -------------------------- select -------------------------- //

            /**
             * @param {Integer} index - index of the slide
             * @param {Boolean} isWrap - will wrap-around to last/first if at the end
             * @param {Boolean} isInstant - will immediately set position at selected cell
             */
            proto.select = function (index, isWrap, isInstant) {
              if (!this.isActive) return;

              index = parseInt(index, 10);
              this._wrapSelect(index);

              if (this.isWrapping || isWrap) {
                index = utils.modulo(index, this.slides.length);
              }
              // bail if invalid index
              if (!this.slides[index]) return;

              let prevIndex = this.selectedIndex;
              this.selectedIndex = index;
              this.updateSelectedSlide();
              if (isInstant) {
                this.positionSliderAtSelected();
              } else {
                this.startAnimation();
              }
              if (this.options.adaptiveHeight) {
                this.setGallerySize();
              }
              // events
              this.dispatchEvent("select", null, [index]);
              // change event if new index
              if (index !== prevIndex) {
                this.dispatchEvent("change", null, [index]);
              }
            };

            // wraps position for wrapAround, to move to closest slide. #113
            proto._wrapSelect = function (index) {
              if (!this.isWrapping) return;

              const {
                selectedIndex,
                slideableWidth,
                slides: { length },
              } = this;
              // shift index for wrap, do not wrap dragSelect
              if (!this.isDragSelect) {
                let wrapIndex = utils.modulo(index, length);
                // go to shortest
                let delta = Math.abs(wrapIndex - selectedIndex);
                let backWrapDelta = Math.abs(
                  wrapIndex + length - selectedIndex
                );
                let forewardWrapDelta = Math.abs(
                  wrapIndex - length - selectedIndex
                );
                if (backWrapDelta < delta) {
                  index += length;
                } else if (forewardWrapDelta < delta) {
                  index -= length;
                }
              }

              // wrap position so slider is within normal area
              if (index < 0) {
                this.x -= slideableWidth;
              } else if (index >= length) {
                this.x += slideableWidth;
              }
            };

            proto.previous = function (isWrap, isInstant) {
              this.select(this.selectedIndex - 1, isWrap, isInstant);
            };

            proto.next = function (isWrap, isInstant) {
              this.select(this.selectedIndex + 1, isWrap, isInstant);
            };

            proto.updateSelectedSlide = function () {
              let slide = this.slides[this.selectedIndex];
              // selectedIndex could be outside of slides, if triggered before resize()
              if (!slide) return;

              // unselect previous selected slide
              this.unselectSelectedSlide();
              // update new selected slide
              this.selectedSlide = slide;
              slide.select();
              this.selectedCells = slide.cells;
              this.selectedElements = slide.getCellElements();
              // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
              this.selectedCell = slide.cells[0];
              this.selectedElement = this.selectedElements[0];
            };

            proto.unselectSelectedSlide = function () {
              if (this.selectedSlide) this.selectedSlide.unselect();
            };

            proto.selectInitialIndex = function () {
              let initialIndex = this.options.initialIndex;
              // already activated, select previous selectedIndex
              if (this.isInitActivated) {
                this.select(this.selectedIndex, false, true);
                return;
              }
              // select with selector string
              if (initialIndex && typeof initialIndex == "string") {
                let cell = this.queryCell(initialIndex);
                if (cell) {
                  this.selectCell(initialIndex, false, true);
                  return;
                }
              }

              let index = 0;
              // select with number
              if (initialIndex && this.slides[initialIndex]) {
                index = initialIndex;
              }
              // select instantly
              this.select(index, false, true);
            };

            /**
             * select slide from number or cell element
             * @param {[Element, Number]} value - zero-based index or element to select
             * @param {Boolean} isWrap - enables wrapping around for extra index
             * @param {Boolean} isInstant - disables slide animation
             */
            proto.selectCell = function (value, isWrap, isInstant) {
              // get cell
              let cell = this.queryCell(value);
              if (!cell) return;

              let index = this.getCellSlideIndex(cell);
              this.select(index, isWrap, isInstant);
            };

            proto.getCellSlideIndex = function (cell) {
              // get index of slide that has cell
              let cellSlide = this.slides.find((slide) =>
                slide.cells.includes(cell)
              );
              return this.slides.indexOf(cellSlide);
            };

            // -------------------------- get cells -------------------------- //

            /**
             * get Flickity.Cell, given an Element
             * @param {Element} elem - matching cell element
             * @returns {Flickity.Cell} cell - matching cell
             */
            proto.getCell = function (elem) {
              // loop through cells to get the one that matches
              for (let cell of this.cells) {
                if (cell.element === elem) return cell;
              }
            };

            /**
             * get collection of Flickity.Cells, given Elements
             * @param {[Element, Array, NodeList]} elems - multiple elements
             * @returns {Array} cells - Flickity.Cells
             */
            proto.getCells = function (elems) {
              elems = utils.makeArray(elems);
              return elems.map((elem) => this.getCell(elem)).filter(Boolean);
            };

            /**
             * get cell elements
             * @returns {Array} cellElems
             */
            proto.getCellElements = function () {
              return this.cells.map((cell) => cell.element);
            };

            /**
             * get parent cell from an element
             * @param {Element} elem - child element
             * @returns {Flickit.Cell} cell - parent cell
             */
            proto.getParentCell = function (elem) {
              // first check if elem is cell
              let cell = this.getCell(elem);
              if (cell) return cell;

              // try to get parent cell elem
              let closest = elem.closest(".flickity-slider > *");
              return this.getCell(closest);
            };

            /**
             * get cells adjacent to a slide
             * @param {Integer} adjCount - number of adjacent slides
             * @param {Integer} index - index of slide to start
             * @returns {Array} cells - array of Flickity.Cells
             */
            proto.getAdjacentCellElements = function (adjCount, index) {
              if (!adjCount) return this.selectedSlide.getCellElements();

              index = index === undefined ? this.selectedIndex : index;

              let len = this.slides.length;
              if (1 + adjCount * 2 >= len) {
                return this.getCellElements(); // get all
              }

              let cellElems = [];
              for (let i = index - adjCount; i <= index + adjCount; i++) {
                let slideIndex = this.isWrapping ? utils.modulo(i, len) : i;
                let slide = this.slides[slideIndex];
                if (slide) {
                  cellElems = cellElems.concat(slide.getCellElements());
                }
              }
              return cellElems;
            };

            /**
             * select slide from number or cell element
             * @param {[Element, String, Number]} selector - element, selector string, or index
             * @returns {Flickity.Cell} - matching cell
             */
            proto.queryCell = function (selector) {
              if (typeof selector == "number") {
                // use number as index
                return this.cells[selector];
              }
              // do not select invalid selectors from hash: #123, #/. #791
              let isSelectorString =
                typeof selector == "string" && !selector.match(/^[#.]?[\d/]/);
              if (isSelectorString) {
                // use string as selector, get element
                selector = this.element.querySelector(selector);
              }
              // get cell from element
              return this.getCell(selector);
            };

            // -------------------------- events -------------------------- //

            proto.uiChange = function () {
              this.emitEvent("uiChange");
            };

            // ----- resize ----- //

            proto.onresize = function () {
              this.watchCSS();
              this.resize();
            };

            utils.debounceMethod(Flickity, "onresize", 150);

            proto.resize = function () {
              // #1177 disable resize behavior when animating or dragging for iOS 15
              if (!this.isActive || this.isAnimating || this.isDragging) return;
              this.getSize();
              // wrap values
              if (this.isWrapping) {
                this.x = utils.modulo(this.x, this.slideableWidth);
              }
              this.positionCells();
              this._updateWrapShiftCells();
              this.setGallerySize();
              this.emitEvent("resize");
              // update selected index for group slides, instant
              // TODO: position can be lost between groups of various numbers
              let selectedElement =
                this.selectedElements && this.selectedElements[0];
              this.selectCell(selectedElement, false, true);
            };

            // watches the :after property, activates/deactivates
            proto.watchCSS = function () {
              if (!this.options.watchCSS) return;

              let afterContent = getComputedStyle(
                this.element,
                ":after"
              ).content;
              // activate if :after { content: 'flickity' }
              if (afterContent.includes("flickity")) {
                this.activate();
              } else {
                this.deactivate();
              }
            };

            // ----- keydown ----- //

            // go previous/next if left/right keys pressed
            proto.onkeydown = function (event) {
              let { activeElement } = document;
              let handler = Flickity.keyboardHandlers[event.key];
              // only work if element is in focus
              if (!this.options.accessibility || !activeElement || !handler)
                return;

              let isFocused = this.focusableElems.some(
                (elem) => activeElement === elem
              );
              if (isFocused) handler.call(this);
            };

            Flickity.keyboardHandlers = {
              ArrowLeft: function () {
                this.uiChange();
                let leftMethod = this.options.rightToLeft ? "next" : "previous";
                this[leftMethod]();
              },
              ArrowRight: function () {
                this.uiChange();
                let rightMethod = this.options.rightToLeft
                  ? "previous"
                  : "next";
                this[rightMethod]();
              },
            };

            // ----- focus ----- //

            proto.focus = function () {
              this.element.focus({ preventScroll: true });
            };

            // -------------------------- destroy -------------------------- //

            // deactivate all Flickity functionality, but keep stuff available
            proto.deactivate = function () {
              if (!this.isActive) return;

              this.element.classList.remove("flickity-enabled");
              this.element.classList.remove("flickity-rtl");
              this.unselectSelectedSlide();
              // destroy cells
              this.cells.forEach((cell) => cell.destroy());
              this.viewport.remove();
              // move child elements back into element
              this.element.append(...this.slider.children);
              if (this.options.accessibility) {
                this.element.removeAttribute("tabIndex");
                this.element.removeEventListener("keydown", this);
              }
              // set flags
              this.isActive = false;
              this.emitEvent("deactivate");
            };

            proto.destroy = function () {
              this.deactivate();
              window.removeEventListener("resize", this);
              this.allOff();
              this.emitEvent("destroy");
              if (jQuery && this.$element) {
                jQuery.removeData(this.element, "flickity");
              }
              delete this.element.flickityGUID;
              delete instances[this.guid];
            };

            // -------------------------- prototype -------------------------- //

            Object.assign(proto, animatePrototype);

            // -------------------------- extras -------------------------- //

            /**
             * get Flickity instance from element
             * @param {[Element, String]} elem - element or selector string
             * @returns {Flickity} - Flickity instance
             */
            Flickity.data = function (elem) {
              elem = utils.getQueryElement(elem);
              if (elem) return instances[elem.flickityGUID];
            };

            utils.htmlInit(Flickity, "flickity");

            let { jQueryBridget } = window;
            if (jQuery && jQueryBridget) {
              jQueryBridget("flickity", Flickity, jQuery);
            }

            // set internal jQuery, for Webpack + jQuery v3, #478
            Flickity.setJQuery = function (jq) {
              jQuery = jq;
            };

            Flickity.Cell = Cell;
            Flickity.Slide = Slide;

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/drag.js":
      /*!******************************************!*\
  !*** ./node_modules/flickity/js/drag.js ***!
  \******************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // drag
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              window,
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              ),
              __webpack_require__(
                /*! unidragger */ "./node_modules/unidragger/unidragger.js"
              ),
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              )
            );
          } else {
            // browser global
            window.Flickity = factory(
              window,
              window.Flickity,
              window.Unidragger,
              window.fizzyUIUtils
            );
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(window, Flickity, Unidragger, utils) {
            // ----- defaults ----- //

            Object.assign(Flickity.defaults, {
              draggable: ">1",
              dragThreshold: 3,
            });

            // -------------------------- drag prototype -------------------------- //

            let proto = Flickity.prototype;
            Object.assign(proto, Unidragger.prototype); // inherit Unidragger
            proto.touchActionValue = "";

            // --------------------------  -------------------------- //

            Flickity.create.drag = function () {
              this.on("activate", this.onActivateDrag);
              this.on("uiChange", this._uiChangeDrag);
              this.on("deactivate", this.onDeactivateDrag);
              this.on("cellChange", this.updateDraggable);
              this.on("pointerDown", this.handlePointerDown);
              this.on("pointerUp", this.handlePointerUp);
              this.on("pointerDown", this.handlePointerDone);
              this.on("dragStart", this.handleDragStart);
              this.on("dragMove", this.handleDragMove);
              this.on("dragEnd", this.handleDragEnd);
              this.on("staticClick", this.handleStaticClick);
              // TODO updateDraggable on resize? if groupCells & slides change
            };

            proto.onActivateDrag = function () {
              this.handles = [this.viewport];
              this.bindHandles();
              this.updateDraggable();
            };

            proto.onDeactivateDrag = function () {
              this.unbindHandles();
              this.element.classList.remove("is-draggable");
            };

            proto.updateDraggable = function () {
              // disable dragging if less than 2 slides. #278
              if (this.options.draggable === ">1") {
                this.isDraggable = this.slides.length > 1;
              } else {
                this.isDraggable = this.options.draggable;
              }
              this.element.classList.toggle("is-draggable", this.isDraggable);
            };

            proto._uiChangeDrag = function () {
              delete this.isFreeScrolling;
            };

            // -------------------------- pointer events -------------------------- //

            proto.handlePointerDown = function (event) {
              if (!this.isDraggable) {
                // proceed for staticClick
                this.bindActivePointerEvents(event);
                return;
              }

              let isTouchStart = event.type === "touchstart";
              let isTouchPointer = event.pointerType === "touch";
              let isFocusNode = event.target.matches("input, textarea, select");
              if (!isTouchStart && !isTouchPointer && !isFocusNode)
                event.preventDefault();
              if (!isFocusNode) this.focus();
              // blur
              if (document.activeElement !== this.element)
                document.activeElement.blur();
              // stop if it was moving
              this.dragX = this.x;
              this.viewport.classList.add("is-pointer-down");
              // track scrolling
              this.pointerDownScroll = getScrollPosition();
              window.addEventListener("scroll", this);
              this.bindActivePointerEvents(event);
            };

            // ----- move ----- //

            proto.hasDragStarted = function (moveVector) {
              return Math.abs(moveVector.x) > this.options.dragThreshold;
            };

            // ----- up ----- //

            proto.handlePointerUp = function () {
              delete this.isTouchScrolling;
              this.viewport.classList.remove("is-pointer-down");
            };

            proto.handlePointerDone = function () {
              window.removeEventListener("scroll", this);
              delete this.pointerDownScroll;
            };

            // -------------------------- dragging -------------------------- //

            proto.handleDragStart = function () {
              if (!this.isDraggable) return;

              this.dragStartPosition = this.x;
              this.startAnimation();
              window.removeEventListener("scroll", this);
            };

            proto.handleDragMove = function (event, pointer, moveVector) {
              if (!this.isDraggable) return;

              event.preventDefault();

              this.previousDragX = this.dragX;
              // reverse if right-to-left
              let direction = this.options.rightToLeft ? -1 : 1;
              // wrap around move. #589
              if (this.isWrapping) moveVector.x %= this.slideableWidth;
              let dragX = this.dragStartPosition + moveVector.x * direction;

              if (!this.isWrapping) {
                // slow drag
                let originBound = Math.max(
                  -this.slides[0].target,
                  this.dragStartPosition
                );
                dragX =
                  dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
                let endBound = Math.min(
                  -this.getLastSlide().target,
                  this.dragStartPosition
                );
                dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
              }

              this.dragX = dragX;
              this.dragMoveTime = new Date();
            };

            proto.handleDragEnd = function () {
              if (!this.isDraggable) return;

              let { freeScroll } = this.options;
              if (freeScroll) this.isFreeScrolling = true;
              // set selectedIndex based on where flick will end up
              let index = this.dragEndRestingSelect();

              if (freeScroll && !this.isWrapping) {
                // if free-scroll & not wrap around
                // do not free-scroll if going outside of bounding slides
                // so bounding slides can attract slider, and keep it in bounds
                let restingX = this.getRestingPosition();
                this.isFreeScrolling =
                  -restingX > this.slides[0].target &&
                  -restingX < this.getLastSlide().target;
              } else if (!freeScroll && index === this.selectedIndex) {
                // boost selection if selected index has not changed
                index += this.dragEndBoostSelect();
              }
              delete this.previousDragX;
              // apply selection
              // HACK, set flag so dragging stays in correct direction
              this.isDragSelect = this.isWrapping;
              this.select(index);
              delete this.isDragSelect;
            };

            proto.dragEndRestingSelect = function () {
              let restingX = this.getRestingPosition();
              // how far away from selected slide
              let distance = Math.abs(
                this.getSlideDistance(-restingX, this.selectedIndex)
              );
              // get closet resting going up and going down
              let positiveResting = this._getClosestResting(
                restingX,
                distance,
                1
              );
              let negativeResting = this._getClosestResting(
                restingX,
                distance,
                -1
              );
              // use closer resting for wrap-around
              return positiveResting.distance < negativeResting.distance
                ? positiveResting.index
                : negativeResting.index;
            };

            /**
             * given resting X and distance to selected cell
             * get the distance and index of the closest cell
             * @param {Number} restingX - estimated post-flick resting position
             * @param {Number} distance - distance to selected cell
             * @param {Integer} increment - +1 or -1, going up or down
             * @returns {Object} - { distance: {Number}, index: {Integer} }
             */
            proto._getClosestResting = function (
              restingX,
              distance,
              increment
            ) {
              let index = this.selectedIndex;
              let minDistance = Infinity;
              let condition =
                this.options.contain && !this.isWrapping
                  ? // if containing, keep going if distance is equal to minDistance
                    (dist, minDist) => dist <= minDist
                  : (dist, minDist) => dist < minDist;

              while (condition(distance, minDistance)) {
                // measure distance to next cell
                index += increment;
                minDistance = distance;
                distance = this.getSlideDistance(-restingX, index);
                if (distance === null) break;

                distance = Math.abs(distance);
              }
              return {
                distance: minDistance,
                // selected was previous index
                index: index - increment,
              };
            };

            /**
             * measure distance between x and a slide target
             * @param {Number} x - horizontal position
             * @param {Integer} index - slide index
             * @returns {Number} - slide distance
             */
            proto.getSlideDistance = function (x, index) {
              let len = this.slides.length;
              // wrap around if at least 2 slides
              let isWrapAround = this.options.wrapAround && len > 1;
              let slideIndex = isWrapAround ? utils.modulo(index, len) : index;
              let slide = this.slides[slideIndex];
              if (!slide) return null;

              // add distance for wrap-around slides
              let wrap = isWrapAround
                ? this.slideableWidth * Math.floor(index / len)
                : 0;
              return x - (slide.target + wrap);
            };

            proto.dragEndBoostSelect = function () {
              // do not boost if no previousDragX or dragMoveTime
              if (
                this.previousDragX === undefined ||
                !this.dragMoveTime ||
                // or if drag was held for 100 ms
                new Date() - this.dragMoveTime > 100
              ) {
                return 0;
              }

              let distance = this.getSlideDistance(
                -this.dragX,
                this.selectedIndex
              );
              let delta = this.previousDragX - this.dragX;
              if (distance > 0 && delta > 0) {
                // boost to next if moving towards the right, and positive velocity
                return 1;
              } else if (distance < 0 && delta < 0) {
                // boost to previous if moving towards the left, and negative velocity
                return -1;
              }
              return 0;
            };

            // ----- scroll ----- //

            proto.onscroll = function () {
              let scroll = getScrollPosition();
              let scrollMoveX = this.pointerDownScroll.x - scroll.x;
              let scrollMoveY = this.pointerDownScroll.y - scroll.y;
              // cancel click/tap if scroll is too much
              if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
                this.pointerDone();
              }
            };

            // ----- utils ----- //

            function getScrollPosition() {
              return {
                x: window.pageXOffset,
                y: window.pageYOffset,
              };
            }

            // -----  ----- //

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/imagesloaded.js":
      /*!**************************************************!*\
  !*** ./node_modules/flickity/js/imagesloaded.js ***!
  \**************************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // imagesloaded
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              ),
              __webpack_require__(
                /*! imagesloaded */ "./node_modules/imagesloaded/imagesloaded.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity, window.imagesLoaded);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity, imagesLoaded) {
            Flickity.create.imagesLoaded = function () {
              this.on("activate", this.imagesLoaded);
            };

            Flickity.prototype.imagesLoaded = function () {
              if (!this.options.imagesLoaded) return;

              let onImagesLoadedProgress = (instance, image) => {
                let cell = this.getParentCell(image.img);
                this.cellSizeChange(cell && cell.element);
                if (!this.options.freeScroll) this.positionSliderAtSelected();
              };
              imagesLoaded(this.slider).on("progress", onImagesLoadedProgress);
            };

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/index.js":
      /*!*******************************************!*\
  !*** ./node_modules/flickity/js/index.js ***!
  \*******************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        /*!
         * Flickity v3.0.0
         * Touch, responsive, flickable carousels
         *
         * Licensed GPLv3 for open source use
         * or Flickity Commercial License for commercial use
         *
         * https://flickity.metafizzy.co
         * Copyright 2015-2022 Metafizzy
         */

        if (true && module.exports) {
          const Flickity = __webpack_require__(
            /*! ./core */ "./node_modules/flickity/js/core.js"
          );
          __webpack_require__(
            /*! ./drag */ "./node_modules/flickity/js/drag.js"
          );
          __webpack_require__(
            /*! ./prev-next-button */ "./node_modules/flickity/js/prev-next-button.js"
          );
          __webpack_require__(
            /*! ./page-dots */ "./node_modules/flickity/js/page-dots.js"
          );
          __webpack_require__(
            /*! ./player */ "./node_modules/flickity/js/player.js"
          );
          __webpack_require__(
            /*! ./add-remove-cell */ "./node_modules/flickity/js/add-remove-cell.js"
          );
          __webpack_require__(
            /*! ./lazyload */ "./node_modules/flickity/js/lazyload.js"
          );
          __webpack_require__(
            /*! ./imagesloaded */ "./node_modules/flickity/js/imagesloaded.js"
          );

          module.exports = Flickity;
        }

        /***/
      },

    /***/ "./node_modules/flickity/js/lazyload.js":
      /*!**********************************************!*\
  !*** ./node_modules/flickity/js/lazyload.js ***!
  \**********************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // lazyload
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              ),
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity, window.fizzyUIUtils);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity, utils) {
            const lazyAttr = "data-flickity-lazyload";
            const lazySrcAttr = `${lazyAttr}-src`;
            const lazySrcsetAttr = `${lazyAttr}-srcset`;
            const imgSelector =
              `img[${lazyAttr}], img[${lazySrcAttr}], ` +
              `img[${lazySrcsetAttr}], source[${lazySrcsetAttr}]`;

            Flickity.create.lazyLoad = function () {
              this.on("select", this.lazyLoad);

              this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this);
            };

            let proto = Flickity.prototype;

            proto.lazyLoad = function () {
              let { lazyLoad } = this.options;
              if (!lazyLoad) return;

              // get adjacent cells, use lazyLoad option for adjacent count
              let adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
              // lazy load images
              this.getAdjacentCellElements(adjCount)
                .map(getCellLazyImages)
                .flat()
                .forEach(
                  (img) => new LazyLoader(img, this.handleLazyLoadComplete)
                );
            };

            function getCellLazyImages(cellElem) {
              // check if cell element is lazy image
              if (cellElem.matches("img")) {
                let cellAttr = cellElem.getAttribute(lazyAttr);
                let cellSrcAttr = cellElem.getAttribute(lazySrcAttr);
                let cellSrcsetAttr = cellElem.getAttribute(lazySrcsetAttr);
                if (cellAttr || cellSrcAttr || cellSrcsetAttr) {
                  return cellElem;
                }
              }
              // select lazy images in cell
              return [...cellElem.querySelectorAll(imgSelector)];
            }

            proto.onLazyLoadComplete = function (img, event) {
              let cell = this.getParentCell(img);
              let cellElem = cell && cell.element;
              this.cellSizeChange(cellElem);

              this.dispatchEvent("lazyLoad", event, cellElem);
            };

            // -------------------------- LazyLoader -------------------------- //

            /**
             * class to handle loading images
             * @param {Image} img - Image element
             * @param {Function} onComplete - callback function
             */
            function LazyLoader(img, onComplete) {
              this.img = img;
              this.onComplete = onComplete;
              this.load();
            }

            LazyLoader.prototype.handleEvent = utils.handleEvent;

            LazyLoader.prototype.load = function () {
              this.img.addEventListener("load", this);
              this.img.addEventListener("error", this);
              // get src & srcset
              let src =
                this.img.getAttribute(lazyAttr) ||
                this.img.getAttribute(lazySrcAttr);
              let srcset = this.img.getAttribute(lazySrcsetAttr);
              // set src & serset
              this.img.src = src;
              if (srcset) this.img.setAttribute("srcset", srcset);
              // remove attr
              this.img.removeAttribute(lazyAttr);
              this.img.removeAttribute(lazySrcAttr);
              this.img.removeAttribute(lazySrcsetAttr);
            };

            LazyLoader.prototype.onload = function (event) {
              this.complete(event, "flickity-lazyloaded");
            };

            LazyLoader.prototype.onerror = function (event) {
              this.complete(event, "flickity-lazyerror");
            };

            LazyLoader.prototype.complete = function (event, className) {
              // unbind events
              this.img.removeEventListener("load", this);
              this.img.removeEventListener("error", this);
              let mediaElem = this.img.parentNode.matches("picture")
                ? this.img.parentNode
                : this.img;
              mediaElem.classList.add(className);

              this.onComplete(this.img, event);
            };

            // -----  ----- //

            Flickity.LazyLoader = LazyLoader;

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/page-dots.js":
      /*!***********************************************!*\
  !*** ./node_modules/flickity/js/page-dots.js ***!
  \***********************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // page dots
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              ),
              __webpack_require__(
                /*! fizzy-ui-utils */ "./node_modules/fizzy-ui-utils/utils.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity, window.fizzyUIUtils);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity, utils) {
            // -------------------------- PageDots -------------------------- //

            function PageDots() {
              // create holder element
              this.holder = document.createElement("div");
              this.holder.className = "flickity-page-dots";
              // create dots, array of elements
              this.dots = [];
            }

            PageDots.prototype.setDots = function (slidesLength) {
              // get difference between number of slides and number of dots
              let delta = slidesLength - this.dots.length;
              if (delta > 0) {
                this.addDots(delta);
              } else if (delta < 0) {
                this.removeDots(-delta);
              }
            };

            PageDots.prototype.addDots = function (count) {
              let newDots = new Array(count).fill().map((item, i) => {
                let dot = document.createElement("button");
                dot.setAttribute("type", "button");
                let num = i + 1 + this.dots.length;
                dot.className = "flickity-page-dot";
                dot.textContent = `View slide ${num}`;
                return dot;
              });

              this.holder.append(...newDots);
              this.dots = this.dots.concat(newDots);
            };

            PageDots.prototype.removeDots = function (count) {
              // remove from this.dots collection
              let removeDots = this.dots.splice(
                this.dots.length - count,
                count
              );
              // remove from DOM
              removeDots.forEach((dot) => dot.remove());
            };

            PageDots.prototype.updateSelected = function (index) {
              // remove selected class on previous
              if (this.selectedDot) {
                this.selectedDot.classList.remove("is-selected");
                this.selectedDot.removeAttribute("aria-current");
              }
              // don't proceed if no dots
              if (!this.dots.length) return;

              this.selectedDot = this.dots[index];
              this.selectedDot.classList.add("is-selected");
              this.selectedDot.setAttribute("aria-current", "step");
            };

            Flickity.PageDots = PageDots;

            // -------------------------- Flickity -------------------------- //

            Object.assign(Flickity.defaults, {
              pageDots: true,
            });

            Flickity.create.pageDots = function () {
              if (!this.options.pageDots) return;

              this.pageDots = new PageDots();
              this.handlePageDotsClick = this.onPageDotsClick.bind(this);
              // events
              this.on("activate", this.activatePageDots);
              this.on("select", this.updateSelectedPageDots);
              this.on("cellChange", this.updatePageDots);
              this.on("resize", this.updatePageDots);
              this.on("deactivate", this.deactivatePageDots);
            };

            let proto = Flickity.prototype;

            proto.activatePageDots = function () {
              this.pageDots.setDots(this.slides.length);
              this.focusableElems.push(...this.pageDots.dots);
              this.pageDots.holder.addEventListener(
                "click",
                this.handlePageDotsClick
              );
              this.element.append(this.pageDots.holder);
            };

            proto.onPageDotsClick = function (event) {
              let index = this.pageDots.dots.indexOf(event.target);
              if (index === -1) return; // only dot clicks

              this.uiChange();
              this.select(index);
            };

            proto.updateSelectedPageDots = function () {
              this.pageDots.updateSelected(this.selectedIndex);
            };

            proto.updatePageDots = function () {
              this.pageDots.dots.forEach((dot) => {
                utils.removeFrom(this.focusableElems, dot);
              });
              this.pageDots.setDots(this.slides.length);
              this.focusableElems.push(...this.pageDots.dots);
            };

            proto.deactivatePageDots = function () {
              this.pageDots.holder.remove();
              this.pageDots.holder.removeEventListener(
                "click",
                this.handlePageDotsClick
              );
            };

            // -----  ----- //

            Flickity.PageDots = PageDots;

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/player.js":
      /*!********************************************!*\
  !*** ./node_modules/flickity/js/player.js ***!
  \********************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // player & autoPlay
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity) {
            // -------------------------- Player -------------------------- //

            function Player(autoPlay, onTick) {
              this.autoPlay = autoPlay;
              this.onTick = onTick;
              this.state = "stopped";
              // visibility change event handler
              this.onVisibilityChange = this.visibilityChange.bind(this);
              this.onVisibilityPlay = this.visibilityPlay.bind(this);
            }

            // start play
            Player.prototype.play = function () {
              if (this.state === "playing") return;

              // do not play if page is hidden, start playing when page is visible
              let isPageHidden = document.hidden;
              if (isPageHidden) {
                document.addEventListener(
                  "visibilitychange",
                  this.onVisibilityPlay
                );
                return;
              }

              this.state = "playing";
              // listen to visibility change
              document.addEventListener(
                "visibilitychange",
                this.onVisibilityChange
              );
              // start ticking
              this.tick();
            };

            Player.prototype.tick = function () {
              // do not tick if not playing
              if (this.state !== "playing") return;

              // default to 3 seconds
              let time =
                typeof this.autoPlay == "number" ? this.autoPlay : 3000;
              // HACK: reset ticks if stopped and started within interval
              this.clear();
              this.timeout = setTimeout(() => {
                this.onTick();
                this.tick();
              }, time);
            };

            Player.prototype.stop = function () {
              this.state = "stopped";
              this.clear();
              // remove visibility change event
              document.removeEventListener(
                "visibilitychange",
                this.onVisibilityChange
              );
            };

            Player.prototype.clear = function () {
              clearTimeout(this.timeout);
            };

            Player.prototype.pause = function () {
              if (this.state === "playing") {
                this.state = "paused";
                this.clear();
              }
            };

            Player.prototype.unpause = function () {
              // re-start play if paused
              if (this.state === "paused") this.play();
            };

            // pause if page visibility is hidden, unpause if visible
            Player.prototype.visibilityChange = function () {
              let isPageHidden = document.hidden;
              this[isPageHidden ? "pause" : "unpause"]();
            };

            Player.prototype.visibilityPlay = function () {
              this.play();
              document.removeEventListener(
                "visibilitychange",
                this.onVisibilityPlay
              );
            };

            // -------------------------- Flickity -------------------------- //

            Object.assign(Flickity.defaults, {
              pauseAutoPlayOnHover: true,
            });

            Flickity.create.player = function () {
              this.player = new Player(this.options.autoPlay, () => {
                this.next(true);
              });

              this.on("activate", this.activatePlayer);
              this.on("uiChange", this.stopPlayer);
              this.on("pointerDown", this.stopPlayer);
              this.on("deactivate", this.deactivatePlayer);
            };

            let proto = Flickity.prototype;

            proto.activatePlayer = function () {
              if (!this.options.autoPlay) return;

              this.player.play();
              this.element.addEventListener("mouseenter", this);
            };

            // Player API, don't hate the ... thanks I know where the door is

            proto.playPlayer = function () {
              this.player.play();
            };

            proto.stopPlayer = function () {
              this.player.stop();
            };

            proto.pausePlayer = function () {
              this.player.pause();
            };

            proto.unpausePlayer = function () {
              this.player.unpause();
            };

            proto.deactivatePlayer = function () {
              this.player.stop();
              this.element.removeEventListener("mouseenter", this);
            };

            // ----- mouseenter/leave ----- //

            // pause auto-play on hover
            proto.onmouseenter = function () {
              if (!this.options.pauseAutoPlayOnHover) return;

              this.player.pause();
              this.element.addEventListener("mouseleave", this);
            };

            // resume auto-play on hover off
            proto.onmouseleave = function () {
              this.player.unpause();
              this.element.removeEventListener("mouseleave", this);
            };

            // -----  ----- //

            Flickity.Player = Player;

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/prev-next-button.js":
      /*!******************************************************!*\
  !*** ./node_modules/flickity/js/prev-next-button.js ***!
  \******************************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        // prev/next buttons
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              __webpack_require__(
                /*! ./core */ "./node_modules/flickity/js/core.js"
              )
            );
          } else {
            // browser global
            factory(window.Flickity);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(Flickity) {
            const svgURI = "http://www.w3.org/2000/svg";

            // -------------------------- PrevNextButton -------------------------- //

            function PrevNextButton(increment, direction, arrowShape) {
              this.increment = increment;
              this.direction = direction;
              this.isPrevious = increment === "previous";
              this.isLeft = direction === "left";
              this._create(arrowShape);
            }

            PrevNextButton.prototype._create = function (arrowShape) {
              // properties
              let element = (this.element = document.createElement("button"));
              element.className = `flickity-button flickity-prev-next-button ${this.increment}`;
              let label = this.isPrevious ? "Previous" : "Next";
              // prevent button from submitting form https://stackoverflow.com/a/10836076/182183
              element.setAttribute("type", "button");
              element.setAttribute("aria-label", label);
              // init as disabled
              this.disable();
              // create arrow
              let svg = this.createSVG(label, arrowShape);
              element.append(svg);
            };

            PrevNextButton.prototype.createSVG = function (label, arrowShape) {
              let svg = document.createElementNS(svgURI, "svg");
              svg.setAttribute("class", "flickity-button-icon");
              svg.setAttribute("viewBox", "0 0 100 100");
              // add title #1189
              let title = document.createElementNS(svgURI, "title");
              title.append(label);
              // add path
              let path = document.createElementNS(svgURI, "path");
              let pathMovements = getArrowMovements(arrowShape);
              path.setAttribute("d", pathMovements);
              path.setAttribute("class", "arrow");
              // rotate arrow
              if (!this.isLeft) {
                path.setAttribute(
                  "transform",
                  "translate(100, 100) rotate(180)"
                );
              }
              svg.append(title, path);
              return svg;
            };

            // get SVG path movmement
            function getArrowMovements(shape) {
              // use shape as movement if string
              if (typeof shape == "string") return shape;

              let { x0, x1, x2, x3, y1, y2 } = shape;

              // create movement string
              return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
            }

            // -----  ----- //

            PrevNextButton.prototype.enable = function () {
              this.element.removeAttribute("disabled");
            };

            PrevNextButton.prototype.disable = function () {
              this.element.setAttribute("disabled", true);
            };

            // -------------------------- Flickity prototype -------------------------- //

            Object.assign(Flickity.defaults, {
              prevNextButtons: true,
              arrowShape: {
                x0: 10,
                x1: 60,
                y1: 50,
                x2: 70,
                y2: 40,
                x3: 30,
              },
            });

            Flickity.create.prevNextButtons = function () {
              if (!this.options.prevNextButtons) return;

              let { rightToLeft, arrowShape } = this.options;
              let prevDirection = rightToLeft ? "right" : "left";
              let nextDirection = rightToLeft ? "left" : "right";
              this.prevButton = new PrevNextButton(
                "previous",
                prevDirection,
                arrowShape
              );
              this.nextButton = new PrevNextButton(
                "next",
                nextDirection,
                arrowShape
              );
              this.focusableElems.push(this.prevButton.element);
              this.focusableElems.push(this.nextButton.element);

              this.handlePrevButtonClick = () => {
                this.uiChange();
                this.previous();
              };

              this.handleNextButtonClick = () => {
                this.uiChange();
                this.next();
              };

              this.on("activate", this.activatePrevNextButtons);
              this.on("select", this.updatePrevNextButtons);
            };

            let proto = Flickity.prototype;

            proto.updatePrevNextButtons = function () {
              let lastIndex = this.slides.length ? this.slides.length - 1 : 0;
              this.updatePrevNextButton(this.prevButton, 0);
              this.updatePrevNextButton(this.nextButton, lastIndex);
            };

            proto.updatePrevNextButton = function (button, disabledIndex) {
              // enable is wrapAround and at least 2 slides
              if (this.isWrapping && this.slides.length > 1) {
                button.enable();
                return;
              }

              let isEnabled = this.selectedIndex !== disabledIndex;
              button[isEnabled ? "enable" : "disable"]();
              // if disabling button that is focused,
              // shift focus to element to maintain keyboard accessibility
              let isDisabledFocused =
                !isEnabled && document.activeElement === button.element;
              if (isDisabledFocused) this.focus();
            };

            proto.activatePrevNextButtons = function () {
              this.prevButton.element.addEventListener(
                "click",
                this.handlePrevButtonClick
              );
              this.nextButton.element.addEventListener(
                "click",
                this.handleNextButtonClick
              );
              this.element.append(
                this.prevButton.element,
                this.nextButton.element
              );
              this.on("deactivate", this.deactivatePrevNextButtons);
            };

            proto.deactivatePrevNextButtons = function () {
              this.prevButton.element.remove();
              this.nextButton.element.remove();
              this.prevButton.element.removeEventListener(
                "click",
                this.handlePrevButtonClick
              );
              this.nextButton.element.removeEventListener(
                "click",
                this.handleNextButtonClick
              );
              this.off("deactivate", this.deactivatePrevNextButtons);
            };

            // --------------------------  -------------------------- //

            Flickity.PrevNextButton = PrevNextButton;

            return Flickity;
          }
        );

        /***/
      },

    /***/ "./node_modules/flickity/js/slide.js":
      /*!*******************************************!*\
  !*** ./node_modules/flickity/js/slide.js ***!
  \*******************************************/
      /***/ function (module) {
        // slide
        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory();
          } else {
            // browser global
            window.Flickity = window.Flickity || {};
            window.Flickity.Slide = factory();
          }
        })(typeof window != "undefined" ? window : this, function factory() {
          function Slide(beginMargin, endMargin, cellAlign) {
            this.beginMargin = beginMargin;
            this.endMargin = endMargin;
            this.cellAlign = cellAlign;
            this.cells = [];
            this.outerWidth = 0;
            this.height = 0;
          }

          let proto = Slide.prototype;

          proto.addCell = function (cell) {
            this.cells.push(cell);
            this.outerWidth += cell.size.outerWidth;
            this.height = Math.max(cell.size.outerHeight, this.height);
            // first cell stuff
            if (this.cells.length === 1) {
              this.x = cell.x; // x comes from first cell
              this.firstMargin = cell.size[this.beginMargin];
            }
          };

          proto.updateTarget = function () {
            let lastCell = this.getLastCell();
            let lastMargin = lastCell ? lastCell.size[this.endMargin] : 0;
            let slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
            this.target =
              this.x + this.firstMargin + slideWidth * this.cellAlign;
          };

          proto.getLastCell = function () {
            return this.cells[this.cells.length - 1];
          };

          proto.select = function () {
            this.cells.forEach((cell) => cell.select());
          };

          proto.unselect = function () {
            this.cells.forEach((cell) => cell.unselect());
          };

          proto.getCellElements = function () {
            return this.cells.map((cell) => cell.element);
          };

          return Slide;
        });

        /***/
      },

    /***/ "./node_modules/get-size/get-size.js":
      /*!*******************************************!*\
  !*** ./node_modules/get-size/get-size.js ***!
  \*******************************************/
      /***/ (module) => {
        /*!
         * Infinite Scroll v2.0.4
         * measure size of elements
         * MIT license
         */

        (function (window, factory) {
          if (true && module.exports) {
            // CommonJS
            module.exports = factory();
          } else {
            // browser global
            window.getSize = factory();
          }
        })(window, function factory() {
          // -------------------------- helpers -------------------------- //

          // get a number from a string, not a percentage
          function getStyleSize(value) {
            let num = parseFloat(value);
            // not a percent like '100%', and a number
            let isValid = value.indexOf("%") == -1 && !isNaN(num);
            return isValid && num;
          }

          // -------------------------- measurements -------------------------- //

          let measurements = [
            "paddingLeft",
            "paddingRight",
            "paddingTop",
            "paddingBottom",
            "marginLeft",
            "marginRight",
            "marginTop",
            "marginBottom",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth",
            "borderBottomWidth",
          ];

          let measurementsLength = measurements.length;

          function getZeroSize() {
            let size = {
              width: 0,
              height: 0,
              innerWidth: 0,
              innerHeight: 0,
              outerWidth: 0,
              outerHeight: 0,
            };
            measurements.forEach((measurement) => {
              size[measurement] = 0;
            });
            return size;
          }

          // -------------------------- getSize -------------------------- //

          function getSize(elem) {
            // use querySeletor if elem is string
            if (typeof elem == "string") elem = document.querySelector(elem);

            // do not proceed on non-objects
            let isElement = elem && typeof elem == "object" && elem.nodeType;
            if (!isElement) return;

            let style = getComputedStyle(elem);

            // if hidden, everything is 0
            if (style.display == "none") return getZeroSize();

            let size = {};
            size.width = elem.offsetWidth;
            size.height = elem.offsetHeight;

            let isBorderBox = (size.isBorderBox =
              style.boxSizing == "border-box");

            // get all measurements
            measurements.forEach((measurement) => {
              let value = style[measurement];
              let num = parseFloat(value);
              // any 'auto', 'medium' value will be 0
              size[measurement] = !isNaN(num) ? num : 0;
            });

            let paddingWidth = size.paddingLeft + size.paddingRight;
            let paddingHeight = size.paddingTop + size.paddingBottom;
            let marginWidth = size.marginLeft + size.marginRight;
            let marginHeight = size.marginTop + size.marginBottom;
            let borderWidth = size.borderLeftWidth + size.borderRightWidth;
            let borderHeight = size.borderTopWidth + size.borderBottomWidth;

            // overwrite width and height if we can get it from style
            let styleWidth = getStyleSize(style.width);
            if (styleWidth !== false) {
              size.width =
                styleWidth +
                // add padding and border unless it's already including it
                (isBorderBox ? 0 : paddingWidth + borderWidth);
            }

            let styleHeight = getStyleSize(style.height);
            if (styleHeight !== false) {
              size.height =
                styleHeight +
                // add padding and border unless it's already including it
                (isBorderBox ? 0 : paddingHeight + borderHeight);
            }

            size.innerWidth = size.width - (paddingWidth + borderWidth);
            size.innerHeight = size.height - (paddingHeight + borderHeight);

            size.outerWidth = size.width + marginWidth;
            size.outerHeight = size.height + marginHeight;

            return size;
          }

          return getSize;
        });

        /***/
      },

    /***/ "./node_modules/imagesloaded/imagesloaded.js":
      /*!***************************************************!*\
  !*** ./node_modules/imagesloaded/imagesloaded.js ***!
  \***************************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        /*!
         * imagesLoaded v5.0.0
         * JavaScript is all like "You images are done yet or what?"
         * MIT License
         */

        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              window,
              __webpack_require__(
                /*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"
              )
            );
          } else {
            // browser global
            window.imagesLoaded = factory(window, window.EvEmitter);
          }
        })(
          typeof window !== "undefined" ? window : this,
          function factory(window, EvEmitter) {
            let $ = window.jQuery;
            let console = window.console;

            // -------------------------- helpers -------------------------- //

            // turn element or nodeList into an array
            function makeArray(obj) {
              // use object if already an array
              if (Array.isArray(obj)) return obj;

              let isArrayLike =
                typeof obj == "object" && typeof obj.length == "number";
              // convert nodeList to array
              if (isArrayLike) return [...obj];

              // array of single index
              return [obj];
            }

            // -------------------------- imagesLoaded -------------------------- //

            /**
             * @param {[Array, Element, NodeList, String]} elem
             * @param {[Object, Function]} options - if function, use as callback
             * @param {Function} onAlways - callback function
             * @returns {ImagesLoaded}
             */
            function ImagesLoaded(elem, options, onAlways) {
              // coerce ImagesLoaded() without new, to be new ImagesLoaded()
              if (!(this instanceof ImagesLoaded)) {
                return new ImagesLoaded(elem, options, onAlways);
              }
              // use elem as selector string
              let queryElem = elem;
              if (typeof elem == "string") {
                queryElem = document.querySelectorAll(elem);
              }
              // bail if bad element
              if (!queryElem) {
                console.error(
                  `Bad element for imagesLoaded ${queryElem || elem}`
                );
                return;
              }

              this.elements = makeArray(queryElem);
              this.options = {};
              // shift arguments if no options set
              if (typeof options == "function") {
                onAlways = options;
              } else {
                Object.assign(this.options, options);
              }

              if (onAlways) this.on("always", onAlways);

              this.getImages();
              // add jQuery Deferred object
              if ($) this.jqDeferred = new $.Deferred();

              // HACK check async to allow time to bind listeners
              setTimeout(this.check.bind(this));
            }

            ImagesLoaded.prototype = Object.create(EvEmitter.prototype);

            ImagesLoaded.prototype.getImages = function () {
              this.images = [];

              // filter & find items if we have an item selector
              this.elements.forEach(this.addElementImages, this);
            };

            const elementNodeTypes = [1, 9, 11];

            /**
             * @param {Node} elem
             */
            ImagesLoaded.prototype.addElementImages = function (elem) {
              // filter siblings
              if (elem.nodeName === "IMG") {
                this.addImage(elem);
              }
              // get background image on element
              if (this.options.background === true) {
                this.addElementBackgroundImages(elem);
              }

              // find children
              // no non-element nodes, #143
              let { nodeType } = elem;
              if (!nodeType || !elementNodeTypes.includes(nodeType)) return;

              let childImgs = elem.querySelectorAll("img");
              // concat childElems to filterFound array
              for (let img of childImgs) {
                this.addImage(img);
              }

              // get child background images
              if (typeof this.options.background == "string") {
                let children = elem.querySelectorAll(this.options.background);
                for (let child of children) {
                  this.addElementBackgroundImages(child);
                }
              }
            };

            const reURL = /url\((['"])?(.*?)\1\)/gi;

            ImagesLoaded.prototype.addElementBackgroundImages = function (
              elem
            ) {
              let style = getComputedStyle(elem);
              // Firefox returns null if in a hidden iframe https://bugzil.la/548397
              if (!style) return;

              // get url inside url("...")
              let matches = reURL.exec(style.backgroundImage);
              while (matches !== null) {
                let url = matches && matches[2];
                if (url) {
                  this.addBackground(url, elem);
                }
                matches = reURL.exec(style.backgroundImage);
              }
            };

            /**
             * @param {Image} img
             */
            ImagesLoaded.prototype.addImage = function (img) {
              let loadingImage = new LoadingImage(img);
              this.images.push(loadingImage);
            };

            ImagesLoaded.prototype.addBackground = function (url, elem) {
              let background = new Background(url, elem);
              this.images.push(background);
            };

            ImagesLoaded.prototype.check = function () {
              this.progressedCount = 0;
              this.hasAnyBroken = false;
              // complete if no images
              if (!this.images.length) {
                this.complete();
                return;
              }

              /* eslint-disable-next-line func-style */
              let onProgress = (image, elem, message) => {
                // HACK - Chrome triggers event before object properties have changed. #83
                setTimeout(() => {
                  this.progress(image, elem, message);
                });
              };

              this.images.forEach(function (loadingImage) {
                loadingImage.once("progress", onProgress);
                loadingImage.check();
              });
            };

            ImagesLoaded.prototype.progress = function (image, elem, message) {
              this.progressedCount++;
              this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
              // progress event
              this.emitEvent("progress", [this, image, elem]);
              if (this.jqDeferred && this.jqDeferred.notify) {
                this.jqDeferred.notify(this, image);
              }
              // check if completed
              if (this.progressedCount === this.images.length) {
                this.complete();
              }

              if (this.options.debug && console) {
                console.log(`progress: ${message}`, image, elem);
              }
            };

            ImagesLoaded.prototype.complete = function () {
              let eventName = this.hasAnyBroken ? "fail" : "done";
              this.isComplete = true;
              this.emitEvent(eventName, [this]);
              this.emitEvent("always", [this]);
              if (this.jqDeferred) {
                let jqMethod = this.hasAnyBroken ? "reject" : "resolve";
                this.jqDeferred[jqMethod](this);
              }
            };

            // --------------------------  -------------------------- //

            function LoadingImage(img) {
              this.img = img;
            }

            LoadingImage.prototype = Object.create(EvEmitter.prototype);

            LoadingImage.prototype.check = function () {
              // If complete is true and browser supports natural sizes,
              // try to check for image status manually.
              let isComplete = this.getIsImageComplete();
              if (isComplete) {
                // report based on naturalWidth
                this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
                return;
              }

              // If none of the checks above matched, simulate loading on detached element.
              this.proxyImage = new Image();
              // add crossOrigin attribute. #204
              if (this.img.crossOrigin) {
                this.proxyImage.crossOrigin = this.img.crossOrigin;
              }
              this.proxyImage.addEventListener("load", this);
              this.proxyImage.addEventListener("error", this);
              // bind to image as well for Firefox. #191
              this.img.addEventListener("load", this);
              this.img.addEventListener("error", this);
              this.proxyImage.src = this.img.currentSrc || this.img.src;
            };

            LoadingImage.prototype.getIsImageComplete = function () {
              // check for non-zero, non-undefined naturalWidth
              // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
              return this.img.complete && this.img.naturalWidth;
            };

            LoadingImage.prototype.confirm = function (isLoaded, message) {
              this.isLoaded = isLoaded;
              let { parentNode } = this.img;
              // emit progress with parent <picture> or self <img>
              let elem =
                parentNode.nodeName === "PICTURE" ? parentNode : this.img;
              this.emitEvent("progress", [this, elem, message]);
            };

            // ----- events ----- //

            // trigger specified handler for event type
            LoadingImage.prototype.handleEvent = function (event) {
              let method = "on" + event.type;
              if (this[method]) {
                this[method](event);
              }
            };

            LoadingImage.prototype.onload = function () {
              this.confirm(true, "onload");
              this.unbindEvents();
            };

            LoadingImage.prototype.onerror = function () {
              this.confirm(false, "onerror");
              this.unbindEvents();
            };

            LoadingImage.prototype.unbindEvents = function () {
              this.proxyImage.removeEventListener("load", this);
              this.proxyImage.removeEventListener("error", this);
              this.img.removeEventListener("load", this);
              this.img.removeEventListener("error", this);
            };

            // -------------------------- Background -------------------------- //

            function Background(url, element) {
              this.url = url;
              this.element = element;
              this.img = new Image();
            }

            // inherit LoadingImage prototype
            Background.prototype = Object.create(LoadingImage.prototype);

            Background.prototype.check = function () {
              this.img.addEventListener("load", this);
              this.img.addEventListener("error", this);
              this.img.src = this.url;
              // check if image is already complete
              let isComplete = this.getIsImageComplete();
              if (isComplete) {
                this.confirm(this.img.naturalWidth !== 0, "naturalWidth");
                this.unbindEvents();
              }
            };

            Background.prototype.unbindEvents = function () {
              this.img.removeEventListener("load", this);
              this.img.removeEventListener("error", this);
            };

            Background.prototype.confirm = function (isLoaded, message) {
              this.isLoaded = isLoaded;
              this.emitEvent("progress", [this, this.element, message]);
            };

            // -------------------------- jQuery -------------------------- //

            ImagesLoaded.makeJQueryPlugin = function (jQuery) {
              jQuery = jQuery || window.jQuery;
              if (!jQuery) return;

              // set local variable
              $ = jQuery;
              // $().imagesLoaded()
              $.fn.imagesLoaded = function (options, onAlways) {
                let instance = new ImagesLoaded(this, options, onAlways);
                return instance.jqDeferred.promise($(this));
              };
            };
            // try making plugin
            ImagesLoaded.makeJQueryPlugin();

            // --------------------------  -------------------------- //

            return ImagesLoaded;
          }
        );

        /***/
      },

    /***/ "./node_modules/in-viewport/in-viewport.js":
      /*!*************************************************!*\
  !*** ./node_modules/in-viewport/in-viewport.js ***!
  \*************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        module.exports = inViewport;

        var instances = [];
        var supportsMutationObserver =
          typeof __webpack_require__.g.MutationObserver === "function";

        function inViewport(elt, params, cb) {
          var opts = {
            container: __webpack_require__.g.document.body,
            offset: 0,
            debounce: 15,
            failsafe: 150,
          };

          if (params === undefined || typeof params === "function") {
            cb = params;
            params = {};
          }

          var container = (opts.container = params.container || opts.container);
          var offset = (opts.offset = params.offset || opts.offset);
          var debounceValue = (opts.debounce =
            params.debounce || opts.debounce);
          var failsafe = (opts.failsafe = params.failsafe || opts.failsafe);

          // ensure backward compatibility with failsafe as boolean
          if (failsafe === true) {
            failsafe = 150;
          } else if (failsafe === false) {
            failsafe = 0;
          }

          // failsafe check always needs to be higher than debounceValue
          if (failsafe > 0 && failsafe < debounceValue) {
            failsafe = debounceValue + 50;
          }

          for (var i = 0; i < instances.length; i++) {
            if (
              instances[i].container === container &&
              instances[i]._debounce === debounceValue &&
              instances[i]._failsafe === failsafe
            ) {
              return instances[i].isInViewport(elt, offset, cb);
            }
          }

          return instances[
            instances.push(
              createInViewport(container, debounceValue, failsafe)
            ) - 1
          ].isInViewport(elt, offset, cb);
        }

        function addEvent(el, type, fn) {
          if (el.attachEvent) {
            el.attachEvent("on" + type, fn);
          } else {
            el.addEventListener(type, fn, false);
          }
        }

        function debounce(func, wait, immediate) {
          var timeout;
          return function () {
            var context = this,
              args = arguments;
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);

            function later() {
              timeout = null;
              if (!immediate) func.apply(context, args);
            }
          };
        }

        // https://github.com/jquery/sizzle/blob/3136f48b90e3edc84cbaaa6f6f7734ef03775a07/sizzle.js#L708
        var contains = function () {
          if (!__webpack_require__.g.document) {
            return true;
          }
          return __webpack_require__.g.document.documentElement
            .compareDocumentPosition
            ? function (a, b) {
                return !!(a.compareDocumentPosition(b) & 16);
              }
            : __webpack_require__.g.document.documentElement.contains
            ? function (a, b) {
                return a !== b && (a.contains ? a.contains(b) : false);
              }
            : function (a, b) {
                while ((b = b.parentNode)) {
                  if (b === a) {
                    return true;
                  }
                }
                return false;
              };
        };

        function createInViewport(container, debounceValue, failsafe) {
          var watches = createWatches();

          var scrollContainer =
            container === __webpack_require__.g.document.body
              ? __webpack_require__.g
              : container;
          var debouncedCheck = debounce(
            watches.checkAll(watchInViewport),
            debounceValue
          );

          addEvent(scrollContainer, "scroll", debouncedCheck);

          if (scrollContainer === __webpack_require__.g) {
            addEvent(__webpack_require__.g, "resize", debouncedCheck);
          }

          if (supportsMutationObserver) {
            observeDOM(watches, container, debouncedCheck);
          }

          // failsafe check, every X we check for visible images
          // usecase: a hidden parent containing eleements
          // when the parent becomes visible, we have no event that the children
          // became visible
          if (failsafe > 0) {
            setInterval(debouncedCheck, failsafe);
          }

          function isInViewport(elt, offset, cb) {
            if (!cb) {
              return isVisible(elt, offset);
            }

            var remote = createRemote(elt, offset, cb);
            remote.watch();
            return remote;
          }

          function createRemote(elt, offset, cb) {
            function watch() {
              watches.add(elt, offset, cb);
            }

            function dispose() {
              watches.remove(elt);
            }

            return {
              watch: watch,
              dispose: dispose,
            };
          }

          function watchInViewport(elt, offset, cb) {
            if (isVisible(elt, offset)) {
              watches.remove(elt);
              cb(elt);
            }
          }

          function isVisible(elt, offset) {
            if (!elt) {
              return false;
            }

            if (
              !contains(__webpack_require__.g.document.documentElement, elt) ||
              !contains(
                __webpack_require__.g.document.documentElement,
                container
              )
            ) {
              return false;
            }

            // Check if the element is visible
            // https://github.com/jquery/jquery/blob/740e190223d19a114d5373758127285d14d6b71e/src/css/hiddenVisibleSelectors.js
            if (!elt.offsetWidth || !elt.offsetHeight) {
              return false;
            }

            var eltRect = elt.getBoundingClientRect();
            var viewport = {};

            if (container === __webpack_require__.g.document.body) {
              viewport = {
                top: -offset,
                left: -offset,
                right:
                  __webpack_require__.g.document.documentElement.clientWidth +
                  offset,
                bottom:
                  __webpack_require__.g.document.documentElement.clientHeight +
                  offset,
              };
            } else {
              var containerRect = container.getBoundingClientRect();
              viewport = {
                top: containerRect.top - offset,
                left: containerRect.left - offset,
                right: containerRect.right + offset,
                bottom: containerRect.bottom + offset,
              };
            }

            // The element must overlap with the visible part of the viewport
            var visible =
              eltRect.right >= viewport.left &&
              eltRect.left <= viewport.right &&
              eltRect.bottom >= viewport.top &&
              eltRect.top <= viewport.bottom;

            return visible;
          }

          return {
            container: container,
            isInViewport: isInViewport,
            _debounce: debounceValue,
            _failsafe: failsafe,
          };
        }

        function createWatches() {
          var watches = [];

          function add(elt, offset, cb) {
            if (!isWatched(elt)) {
              watches.push([elt, offset, cb]);
            }
          }

          function remove(elt) {
            var pos = indexOf(elt);
            if (pos !== -1) {
              watches.splice(pos, 1);
            }
          }

          function indexOf(elt) {
            for (var i = watches.length - 1; i >= 0; i--) {
              if (watches[i][0] === elt) {
                return i;
              }
            }
            return -1;
          }

          function isWatched(elt) {
            return indexOf(elt) !== -1;
          }

          function checkAll(cb) {
            return function () {
              for (var i = watches.length - 1; i >= 0; i--) {
                cb.apply(this, watches[i]);
              }
            };
          }

          return {
            add: add,
            remove: remove,
            isWatched: isWatched,
            checkAll: checkAll,
          };
        }

        function observeDOM(watches, container, cb) {
          var observer = new MutationObserver(watch);
          var filter = Array.prototype.filter;
          var concat = Array.prototype.concat;

          observer.observe(container, {
            childList: true,
            subtree: true,
            // changes like style/width/height/display will be catched
            attributes: true,
          });

          function watch(mutations) {
            // some new DOM nodes where previously watched
            // we should check their positions
            if (mutations.some(knownNodes) === true) {
              setTimeout(cb, 0);
            }
          }

          function knownNodes(mutation) {
            var nodes = concat.call(
              [],
              Array.prototype.slice.call(mutation.addedNodes),
              mutation.target
            );
            return filter.call(nodes, watches.isWatched).length > 0;
          }
        }

        /***/
      },

    /***/ "./node_modules/jsonp/index.js":
      /*!*************************************!*\
  !*** ./node_modules/jsonp/index.js ***!
  \*************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        /**
         * Module dependencies
         */

        var debug = __webpack_require__(
          /*! debug */ "./node_modules/debug/src/browser.js"
        )("jsonp");

        /**
         * Module exports.
         */

        module.exports = jsonp;

        /**
         * Callback index.
         */

        var count = 0;

        /**
         * Noop function.
         */

        function noop() {}

        /**
         * JSONP handler
         *
         * Options:
         *  - param {String} qs parameter (`callback`)
         *  - prefix {String} qs parameter (`__jp`)
         *  - name {String} qs parameter (`prefix` + incr)
         *  - timeout {Number} how long after a timeout error is emitted (`60000`)
         *
         * @param {String} url
         * @param {Object|Function} optional options / callback
         * @param {Function} optional callback
         */

        function jsonp(url, opts, fn) {
          if ("function" == typeof opts) {
            fn = opts;
            opts = {};
          }
          if (!opts) opts = {};

          var prefix = opts.prefix || "__jp";

          // use the callback name that was passed if one was provided.
          // otherwise generate a unique name by incrementing our counter.
          var id = opts.name || prefix + count++;

          var param = opts.param || "callback";
          var timeout = null != opts.timeout ? opts.timeout : 60000;
          var enc = encodeURIComponent;
          var target =
            document.getElementsByTagName("script")[0] || document.head;
          var script;
          var timer;

          if (timeout) {
            timer = setTimeout(function () {
              cleanup();
              if (fn) fn(new Error("Timeout"));
            }, timeout);
          }

          function cleanup() {
            if (script.parentNode) script.parentNode.removeChild(script);
            window[id] = noop;
            if (timer) clearTimeout(timer);
          }

          function cancel() {
            if (window[id]) {
              cleanup();
            }
          }

          window[id] = function (data) {
            debug("jsonp got", data);
            cleanup();
            if (fn) fn(null, data);
          };

          // add qs component
          url += (~url.indexOf("?") ? "&" : "?") + param + "=" + enc(id);
          url = url.replace("?&", "?");

          debug('jsonp req "%s"', url);

          // create script
          script = document.createElement("script");
          script.src = url;
          target.parentNode.insertBefore(script, target);

          return cancel;
        }

        /***/
      },

    /***/ "./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=85ca06a4&lang=css&":
      /*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=85ca06a4&lang=css& ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
      /***/ (module, __webpack_exports__, __webpack_require__) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _laravel_mix_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../../../laravel-mix/node_modules/css-loader/dist/runtime/api.js */ "./node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js"
          );
        /* harmony import */ var _laravel_mix_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _laravel_mix_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__
          );
        // Imports

        var ___CSS_LOADER_EXPORT___ =
          _laravel_mix_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(
            function (i) {
              return i[1];
            }
          );
        // Module
        ___CSS_LOADER_EXPORT___.push([
          module.id,
          "\n.vue-map-container {\n  position: relative;\n}\n.vue-map-container .vue-map {\n  left: 0; right: 0; top: 0; bottom: 0;\n  position: absolute;\n}\n.vue-map-hidden {\n  display: none;\n}\n",
          "",
        ]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ___CSS_LOADER_EXPORT___;

        /***/
      },

    /***/ "./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css&":
      /*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css& ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
      /***/ (module, __webpack_exports__, __webpack_require__) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _laravel_mix_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ../../../laravel-mix/node_modules/css-loader/dist/runtime/api.js */ "./node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js"
          );
        /* harmony import */ var _laravel_mix_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _laravel_mix_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__
          );
        // Imports

        var ___CSS_LOADER_EXPORT___ =
          _laravel_mix_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(
            function (i) {
              return i[1];
            }
          );
        // Module
        ___CSS_LOADER_EXPORT___.push([
          module.id,
          "\n.vue-street-view-pano-container {\n  position: relative;\n}\n.vue-street-view-pano-container .vue-street-view-pano {\n  left: 0; right: 0; top: 0; bottom: 0;\n  position: absolute;\n}\n",
          "",
        ]);
        // Exports
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          ___CSS_LOADER_EXPORT___;

        /***/
      },

    /***/ "./node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js":
      /*!******************************************************************************!*\
  !*** ./node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js ***!
  \******************************************************************************/
      /***/ (module) => {
        "use strict";

        /*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
        // css base code, injected by the css-loader
        // eslint-disable-next-line func-names
        module.exports = function (cssWithMappingToString) {
          var list = []; // return the list of modules as css string

          list.toString = function toString() {
            return this.map(function (item) {
              var content = cssWithMappingToString(item);

              if (item[2]) {
                return "@media ".concat(item[2], " {").concat(content, "}");
              }

              return content;
            }).join("");
          }; // import a list of modules into the list
          // eslint-disable-next-line func-names

          list.i = function (modules, mediaQuery, dedupe) {
            if (typeof modules === "string") {
              // eslint-disable-next-line no-param-reassign
              modules = [[null, modules, ""]];
            }

            var alreadyImportedModules = {};

            if (dedupe) {
              for (var i = 0; i < this.length; i++) {
                // eslint-disable-next-line prefer-destructuring
                var id = this[i][0];

                if (id != null) {
                  alreadyImportedModules[id] = true;
                }
              }
            }

            for (var _i = 0; _i < modules.length; _i++) {
              var item = [].concat(modules[_i]);

              if (dedupe && alreadyImportedModules[item[0]]) {
                // eslint-disable-next-line no-continue
                continue;
              }

              if (mediaQuery) {
                if (!item[2]) {
                  item[2] = mediaQuery;
                } else {
                  item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
                }
              }

              list.push(item);
            }
          };

          return list;
        };

        /***/
      },

    /***/ "./node_modules/layzr.js/dist/layzr.module.js":
      /*!****************************************************!*\
  !*** ./node_modules/layzr.js/dist/layzr.module.js ***!
  \****************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i];

              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }

            return target;
          };

        var knot = function knot() {
          var extended =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : {};

          var events = Object.create(null);

          function on(name, handler) {
            events[name] = events[name] || [];
            events[name].push(handler);
            return this;
          }

          function once(name, handler) {
            handler._once = true;
            on(name, handler);
            return this;
          }

          function off(name) {
            var handler =
              arguments.length > 1 && arguments[1] !== undefined
                ? arguments[1]
                : false;

            handler
              ? events[name].splice(events[name].indexOf(handler), 1)
              : delete events[name];

            return this;
          }

          function emit(name) {
            var _this = this;

            for (
              var _len = arguments.length,
                args = Array(_len > 1 ? _len - 1 : 0),
                _key = 1;
              _key < _len;
              _key++
            ) {
              args[_key - 1] = arguments[_key];
            }

            // cache the events, to avoid consequences of mutation
            var cache = events[name] && events[name].slice();

            // only fire handlers if they exist
            cache &&
              cache.forEach(function (handler) {
                // remove handlers added with 'once'
                handler._once && off(name, handler);

                // set 'this' context, pass args to handlers
                handler.apply(_this, args);
              });

            return this;
          }

          return _extends({}, extended, {
            on: on,
            once: once,
            off: off,
            emit: emit,
          });
        };

        var layzr = function () {
          var options =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : {};

          // private

          var prevLoc = getLoc();
          var ticking = void 0;

          var nodes = void 0;
          var windowHeight = void 0;

          // options

          var settings = {
            normal: options.normal || "data-normal",
            retina: options.retina || "data-retina",
            srcset: options.srcset || "data-srcset",
            threshold: options.threshold || 0,
          };

          // feature detection
          // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/img/srcset.js

          var srcset =
            document.body.classList.contains("srcset") ||
            "srcset" in document.createElement("img");

          // device pixel ratio
          // not supported in IE10 - https://msdn.microsoft.com/en-us/library/dn265030(v=vs.85).aspx

          var dpr =
            window.devicePixelRatio ||
            window.screen.deviceXDPI / window.screen.logicalXDPI;

          // instance

          var instance = knot({
            handlers: handlers,
            check: check,
            update: update,
          });

          return instance;

          // location helper

          function getLoc() {
            return window.scrollY || window.pageYOffset;
          }

          // debounce helpers

          function requestScroll() {
            prevLoc = getLoc();
            requestFrame();
          }

          function requestFrame() {
            if (!ticking) {
              window.requestAnimationFrame(function () {
                return check();
              });
              ticking = true;
            }
          }

          // offset helper

          function getOffset(node) {
            return node.getBoundingClientRect().top + prevLoc;
          }

          // in viewport helper

          function inViewport(node) {
            var viewTop = prevLoc;
            var viewBot = viewTop + windowHeight;

            var nodeTop = getOffset(node);
            var nodeBot = nodeTop + node.offsetHeight;

            var offset = (settings.threshold / 100) * windowHeight;

            return nodeBot >= viewTop - offset && nodeTop <= viewBot + offset;
          }

          // source helper

          function setSource(node) {
            instance.emit("src:before", node);

            // prefer srcset, fallback to pixel density
            if (srcset && node.hasAttribute(settings.srcset)) {
              node.setAttribute("srcset", node.getAttribute(settings.srcset));
            } else {
              var retina = dpr > 1 && node.getAttribute(settings.retina);
              node.setAttribute(
                "src",
                retina || node.getAttribute(settings.normal)
              );
            }

            instance.emit("src:after", node);
            [settings.normal, settings.retina, settings.srcset].forEach(
              function (attr) {
                return node.removeAttribute(attr);
              }
            );

            update();
          }

          // API

          function handlers(flag) {
            var action = flag ? "addEventListener" : "removeEventListener";
            ["scroll", "resize"].forEach(function (event) {
              return window[action](event, requestScroll);
            });
            return this;
          }

          function check() {
            windowHeight = window.innerHeight;

            nodes.forEach(function (node) {
              return inViewport(node) && setSource(node);
            });

            ticking = false;
            return this;
          }

          function update() {
            nodes = Array.prototype.slice.call(
              document.querySelectorAll("[" + settings.normal + "]")
            );
            return this;
          }
        };

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = layzr;

        /***/
      },

    /***/ "./node_modules/lodash/_Symbol.js":
      /*!****************************************!*\
  !*** ./node_modules/lodash/_Symbol.js ***!
  \****************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var root = __webpack_require__(
          /*! ./_root */ "./node_modules/lodash/_root.js"
        );

        /** Built-in value references. */
        var Symbol = root.Symbol;

        module.exports = Symbol;

        /***/
      },

    /***/ "./node_modules/lodash/_baseGetTag.js":
      /*!********************************************!*\
  !*** ./node_modules/lodash/_baseGetTag.js ***!
  \********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var Symbol = __webpack_require__(
            /*! ./_Symbol */ "./node_modules/lodash/_Symbol.js"
          ),
          getRawTag = __webpack_require__(
            /*! ./_getRawTag */ "./node_modules/lodash/_getRawTag.js"
          ),
          objectToString = __webpack_require__(
            /*! ./_objectToString */ "./node_modules/lodash/_objectToString.js"
          );

        /** `Object#toString` result references. */
        var nullTag = "[object Null]",
          undefinedTag = "[object Undefined]";

        /** Built-in value references. */
        var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

        /**
         * The base implementation of `getTag` without fallbacks for buggy environments.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the `toStringTag`.
         */
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object(value)
            ? getRawTag(value)
            : objectToString(value);
        }

        module.exports = baseGetTag;

        /***/
      },

    /***/ "./node_modules/lodash/_baseRange.js":
      /*!*******************************************!*\
  !*** ./node_modules/lodash/_baseRange.js ***!
  \*******************************************/
      /***/ (module) => {
        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeCeil = Math.ceil,
          nativeMax = Math.max;

        /**
         * The base implementation of `_.range` and `_.rangeRight` which doesn't
         * coerce arguments.
         *
         * @private
         * @param {number} start The start of the range.
         * @param {number} end The end of the range.
         * @param {number} step The value to increment or decrement by.
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Array} Returns the range of numbers.
         */
        function baseRange(start, end, step, fromRight) {
          var index = -1,
            length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
            result = Array(length);

          while (length--) {
            result[fromRight ? length : ++index] = start;
            start += step;
          }
          return result;
        }

        module.exports = baseRange;

        /***/
      },

    /***/ "./node_modules/lodash/_baseSlice.js":
      /*!*******************************************!*\
  !*** ./node_modules/lodash/_baseSlice.js ***!
  \*******************************************/
      /***/ (module) => {
        /**
         * The base implementation of `_.slice` without an iteratee call guard.
         *
         * @private
         * @param {Array} array The array to slice.
         * @param {number} [start=0] The start position.
         * @param {number} [end=array.length] The end position.
         * @returns {Array} Returns the slice of `array`.
         */
        function baseSlice(array, start, end) {
          var index = -1,
            length = array.length;

          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : (end - start) >>> 0;
          start >>>= 0;

          var result = Array(length);
          while (++index < length) {
            result[index] = array[index + start];
          }
          return result;
        }

        module.exports = baseSlice;

        /***/
      },

    /***/ "./node_modules/lodash/_baseTrim.js":
      /*!******************************************!*\
  !*** ./node_modules/lodash/_baseTrim.js ***!
  \******************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var trimmedEndIndex = __webpack_require__(
          /*! ./_trimmedEndIndex */ "./node_modules/lodash/_trimmedEndIndex.js"
        );

        /** Used to match leading whitespace. */
        var reTrimStart = /^\s+/;

        /**
         * The base implementation of `_.trim`.
         *
         * @private
         * @param {string} string The string to trim.
         * @returns {string} Returns the trimmed string.
         */
        function baseTrim(string) {
          return string
            ? string
                .slice(0, trimmedEndIndex(string) + 1)
                .replace(reTrimStart, "")
            : string;
        }

        module.exports = baseTrim;

        /***/
      },

    /***/ "./node_modules/lodash/_createRange.js":
      /*!*********************************************!*\
  !*** ./node_modules/lodash/_createRange.js ***!
  \*********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var baseRange = __webpack_require__(
            /*! ./_baseRange */ "./node_modules/lodash/_baseRange.js"
          ),
          isIterateeCall = __webpack_require__(
            /*! ./_isIterateeCall */ "./node_modules/lodash/_isIterateeCall.js"
          ),
          toFinite = __webpack_require__(
            /*! ./toFinite */ "./node_modules/lodash/toFinite.js"
          );

        /**
         * Creates a `_.range` or `_.rangeRight` function.
         *
         * @private
         * @param {boolean} [fromRight] Specify iterating from right to left.
         * @returns {Function} Returns the new range function.
         */
        function createRange(fromRight) {
          return function (start, end, step) {
            if (
              step &&
              typeof step != "number" &&
              isIterateeCall(start, end, step)
            ) {
              end = step = undefined;
            }
            // Ensure the sign of `-0` is preserved.
            start = toFinite(start);
            if (end === undefined) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }

        module.exports = createRange;

        /***/
      },

    /***/ "./node_modules/lodash/_freeGlobal.js":
      /*!********************************************!*\
  !*** ./node_modules/lodash/_freeGlobal.js ***!
  \********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        /** Detect free variable `global` from Node.js. */
        var freeGlobal =
          typeof __webpack_require__.g == "object" &&
          __webpack_require__.g &&
          __webpack_require__.g.Object === Object &&
          __webpack_require__.g;

        module.exports = freeGlobal;

        /***/
      },

    /***/ "./node_modules/lodash/_getRawTag.js":
      /*!*******************************************!*\
  !*** ./node_modules/lodash/_getRawTag.js ***!
  \*******************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var Symbol = __webpack_require__(
          /*! ./_Symbol */ "./node_modules/lodash/_Symbol.js"
        );

        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /** Used to check objects for own properties. */
        var hasOwnProperty = objectProto.hasOwnProperty;

        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;

        /** Built-in value references. */
        var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

        /**
         * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
         *
         * @private
         * @param {*} value The value to query.
         * @returns {string} Returns the raw `toStringTag`.
         */
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];

          try {
            value[symToStringTag] = undefined;
            var unmasked = true;
          } catch (e) {}

          var result = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result;
        }

        module.exports = getRawTag;

        /***/
      },

    /***/ "./node_modules/lodash/_isIndex.js":
      /*!*****************************************!*\
  !*** ./node_modules/lodash/_isIndex.js ***!
  \*****************************************/
      /***/ (module) => {
        /** Used as references for various `Number` constants. */
        var MAX_SAFE_INTEGER = 9007199254740991;

        /** Used to detect unsigned integer values. */
        var reIsUint = /^(?:0|[1-9]\d*)$/;

        /**
         * Checks if `value` is a valid array-like index.
         *
         * @private
         * @param {*} value The value to check.
         * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
         * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
         */
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;

          return (
            !!length &&
            (type == "number" || (type != "symbol" && reIsUint.test(value))) &&
            value > -1 &&
            value % 1 == 0 &&
            value < length
          );
        }

        module.exports = isIndex;

        /***/
      },

    /***/ "./node_modules/lodash/_isIterateeCall.js":
      /*!************************************************!*\
  !*** ./node_modules/lodash/_isIterateeCall.js ***!
  \************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var eq = __webpack_require__(/*! ./eq */ "./node_modules/lodash/eq.js"),
          isArrayLike = __webpack_require__(
            /*! ./isArrayLike */ "./node_modules/lodash/isArrayLike.js"
          ),
          isIndex = __webpack_require__(
            /*! ./_isIndex */ "./node_modules/lodash/_isIndex.js"
          ),
          isObject = __webpack_require__(
            /*! ./isObject */ "./node_modules/lodash/isObject.js"
          );

        /**
         * Checks if the given arguments are from an iteratee call.
         *
         * @private
         * @param {*} value The potential iteratee value argument.
         * @param {*} index The potential iteratee index or key argument.
         * @param {*} object The potential iteratee object argument.
         * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
         *  else `false`.
         */
        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }
          var type = typeof index;
          if (
            type == "number"
              ? isArrayLike(object) && isIndex(index, object.length)
              : type == "string" && index in object
          ) {
            return eq(object[index], value);
          }
          return false;
        }

        module.exports = isIterateeCall;

        /***/
      },

    /***/ "./node_modules/lodash/_objectToString.js":
      /*!************************************************!*\
  !*** ./node_modules/lodash/_objectToString.js ***!
  \************************************************/
      /***/ (module) => {
        /** Used for built-in method references. */
        var objectProto = Object.prototype;

        /**
         * Used to resolve the
         * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
         * of values.
         */
        var nativeObjectToString = objectProto.toString;

        /**
         * Converts `value` to a string using `Object.prototype.toString`.
         *
         * @private
         * @param {*} value The value to convert.
         * @returns {string} Returns the converted string.
         */
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }

        module.exports = objectToString;

        /***/
      },

    /***/ "./node_modules/lodash/_root.js":
      /*!**************************************!*\
  !*** ./node_modules/lodash/_root.js ***!
  \**************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var freeGlobal = __webpack_require__(
          /*! ./_freeGlobal */ "./node_modules/lodash/_freeGlobal.js"
        );

        /** Detect free variable `self`. */
        var freeSelf =
          typeof self == "object" && self && self.Object === Object && self;

        /** Used as a reference to the global object. */
        var root = freeGlobal || freeSelf || Function("return this")();

        module.exports = root;

        /***/
      },

    /***/ "./node_modules/lodash/_trimmedEndIndex.js":
      /*!*************************************************!*\
  !*** ./node_modules/lodash/_trimmedEndIndex.js ***!
  \*************************************************/
      /***/ (module) => {
        /** Used to match a single whitespace character. */
        var reWhitespace = /\s/;

        /**
         * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
         * character of `string`.
         *
         * @private
         * @param {string} string The string to inspect.
         * @returns {number} Returns the index of the last non-whitespace character.
         */
        function trimmedEndIndex(string) {
          var index = string.length;

          while (index-- && reWhitespace.test(string.charAt(index))) {}
          return index;
        }

        module.exports = trimmedEndIndex;

        /***/
      },

    /***/ "./node_modules/lodash/chunk.js":
      /*!**************************************!*\
  !*** ./node_modules/lodash/chunk.js ***!
  \**************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var baseSlice = __webpack_require__(
            /*! ./_baseSlice */ "./node_modules/lodash/_baseSlice.js"
          ),
          isIterateeCall = __webpack_require__(
            /*! ./_isIterateeCall */ "./node_modules/lodash/_isIterateeCall.js"
          ),
          toInteger = __webpack_require__(
            /*! ./toInteger */ "./node_modules/lodash/toInteger.js"
          );

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeCeil = Math.ceil,
          nativeMax = Math.max;

        /**
         * Creates an array of elements split into groups the length of `size`.
         * If `array` can't be split evenly, the final chunk will be the remaining
         * elements.
         *
         * @static
         * @memberOf _
         * @since 3.0.0
         * @category Array
         * @param {Array} array The array to process.
         * @param {number} [size=1] The length of each chunk
         * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
         * @returns {Array} Returns the new array of chunks.
         * @example
         *
         * _.chunk(['a', 'b', 'c', 'd'], 2);
         * // => [['a', 'b'], ['c', 'd']]
         *
         * _.chunk(['a', 'b', 'c', 'd'], 3);
         * // => [['a', 'b', 'c'], ['d']]
         */
        function chunk(array, size, guard) {
          if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
            size = 1;
          } else {
            size = nativeMax(toInteger(size), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size < 1) {
            return [];
          }
          var index = 0,
            resIndex = 0,
            result = Array(nativeCeil(length / size));

          while (index < length) {
            result[resIndex++] = baseSlice(array, index, (index += size));
          }
          return result;
        }

        module.exports = chunk;

        /***/
      },

    /***/ "./node_modules/lodash/debounce.js":
      /*!*****************************************!*\
  !*** ./node_modules/lodash/debounce.js ***!
  \*****************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var isObject = __webpack_require__(
            /*! ./isObject */ "./node_modules/lodash/isObject.js"
          ),
          now = __webpack_require__(
            /*! ./now */ "./node_modules/lodash/now.js"
          ),
          toNumber = __webpack_require__(
            /*! ./toNumber */ "./node_modules/lodash/toNumber.js"
          );

        /** Error message constants. */
        var FUNC_ERROR_TEXT = "Expected a function";

        /* Built-in method references for those with the same name as other `lodash` methods. */
        var nativeMax = Math.max,
          nativeMin = Math.min;

        /**
         * Creates a debounced function that delays invoking `func` until after `wait`
         * milliseconds have elapsed since the last time the debounced function was
         * invoked. The debounced function comes with a `cancel` method to cancel
         * delayed `func` invocations and a `flush` method to immediately invoke them.
         * Provide `options` to indicate whether `func` should be invoked on the
         * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
         * with the last arguments provided to the debounced function. Subsequent
         * calls to the debounced function return the result of the last `func`
         * invocation.
         *
         * **Note:** If `leading` and `trailing` options are `true`, `func` is
         * invoked on the trailing edge of the timeout only if the debounced function
         * is invoked more than once during the `wait` timeout.
         *
         * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
         * until to the next tick, similar to `setTimeout` with a timeout of `0`.
         *
         * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
         * for details over the differences between `_.debounce` and `_.throttle`.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Function
         * @param {Function} func The function to debounce.
         * @param {number} [wait=0] The number of milliseconds to delay.
         * @param {Object} [options={}] The options object.
         * @param {boolean} [options.leading=false]
         *  Specify invoking on the leading edge of the timeout.
         * @param {number} [options.maxWait]
         *  The maximum time `func` is allowed to be delayed before it's invoked.
         * @param {boolean} [options.trailing=true]
         *  Specify invoking on the trailing edge of the timeout.
         * @returns {Function} Returns the new debounced function.
         * @example
         *
         * // Avoid costly calculations while the window size is in flux.
         * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
         *
         * // Invoke `sendMail` when clicked, debouncing subsequent calls.
         * jQuery(element).on('click', _.debounce(sendMail, 300, {
         *   'leading': true,
         *   'trailing': false
         * }));
         *
         * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
         * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
         * var source = new EventSource('/stream');
         * jQuery(source).on('message', debounced);
         *
         * // Cancel the trailing debounced invocation.
         * jQuery(window).on('popstate', debounced.cancel);
         */
        function debounce(func, wait, options) {
          var lastArgs,
            lastThis,
            maxWait,
            result,
            timerId,
            lastCallTime,
            lastInvokeTime = 0,
            leading = false,
            maxing = false,
            trailing = true;

          if (typeof func != "function") {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing
              ? nativeMax(toNumber(options.maxWait) || 0, wait)
              : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }

          function invokeFunc(time) {
            var args = lastArgs,
              thisArg = lastThis;

            lastArgs = lastThis = undefined;
            lastInvokeTime = time;
            result = func.apply(thisArg, args);
            return result;
          }

          function leadingEdge(time) {
            // Reset any `maxWait` timer.
            lastInvokeTime = time;
            // Start the timer for the trailing edge.
            timerId = setTimeout(timerExpired, wait);
            // Invoke the leading edge.
            return leading ? invokeFunc(time) : result;
          }

          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime,
              timeWaiting = wait - timeSinceLastCall;

            return maxing
              ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
              : timeWaiting;
          }

          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime;

            // Either this is the first call, activity has stopped and we're at the
            // trailing edge, the system time has gone backwards and we're treating
            // it as the trailing edge, or we've hit the `maxWait` limit.
            return (
              lastCallTime === undefined ||
              timeSinceLastCall >= wait ||
              timeSinceLastCall < 0 ||
              (maxing && timeSinceLastInvoke >= maxWait)
            );
          }

          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            // Restart the timer.
            timerId = setTimeout(timerExpired, remainingWait(time));
          }

          function trailingEdge(time) {
            timerId = undefined;

            // Only invoke if we have `lastArgs` which means `func` has been
            // debounced at least once.
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined;
            return result;
          }

          function cancel() {
            if (timerId !== undefined) {
              clearTimeout(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined;
          }

          function flush() {
            return timerId === undefined ? result : trailingEdge(now());
          }

          function debounced() {
            var time = now(),
              isInvoking = shouldInvoke(time);

            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;

            if (isInvoking) {
              if (timerId === undefined) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined) {
              timerId = setTimeout(timerExpired, wait);
            }
            return result;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }

        module.exports = debounce;

        /***/
      },

    /***/ "./node_modules/lodash/eq.js":
      /*!***********************************!*\
  !*** ./node_modules/lodash/eq.js ***!
  \***********************************/
      /***/ (module) => {
        /**
         * Performs a
         * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
         * comparison between two values to determine if they are equivalent.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to compare.
         * @param {*} other The other value to compare.
         * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
         * @example
         *
         * var object = { 'a': 1 };
         * var other = { 'a': 1 };
         *
         * _.eq(object, object);
         * // => true
         *
         * _.eq(object, other);
         * // => false
         *
         * _.eq('a', 'a');
         * // => true
         *
         * _.eq('a', Object('a'));
         * // => false
         *
         * _.eq(NaN, NaN);
         * // => true
         */
        function eq(value, other) {
          return value === other || (value !== value && other !== other);
        }

        module.exports = eq;

        /***/
      },

    /***/ "./node_modules/lodash/isArrayLike.js":
      /*!********************************************!*\
  !*** ./node_modules/lodash/isArrayLike.js ***!
  \********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var isFunction = __webpack_require__(
            /*! ./isFunction */ "./node_modules/lodash/isFunction.js"
          ),
          isLength = __webpack_require__(
            /*! ./isLength */ "./node_modules/lodash/isLength.js"
          );

        /**
         * Checks if `value` is array-like. A value is considered array-like if it's
         * not a function and has a `value.length` that's an integer greater than or
         * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
         * @example
         *
         * _.isArrayLike([1, 2, 3]);
         * // => true
         *
         * _.isArrayLike(document.body.children);
         * // => true
         *
         * _.isArrayLike('abc');
         * // => true
         *
         * _.isArrayLike(_.noop);
         * // => false
         */
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }

        module.exports = isArrayLike;

        /***/
      },

    /***/ "./node_modules/lodash/isFunction.js":
      /*!*******************************************!*\
  !*** ./node_modules/lodash/isFunction.js ***!
  \*******************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var baseGetTag = __webpack_require__(
            /*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"
          ),
          isObject = __webpack_require__(
            /*! ./isObject */ "./node_modules/lodash/isObject.js"
          );

        /** `Object#toString` result references. */
        var asyncTag = "[object AsyncFunction]",
          funcTag = "[object Function]",
          genTag = "[object GeneratorFunction]",
          proxyTag = "[object Proxy]";

        /**
         * Checks if `value` is classified as a `Function` object.
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a function, else `false`.
         * @example
         *
         * _.isFunction(_);
         * // => true
         *
         * _.isFunction(/abc/);
         * // => false
         */
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          // The use of `Object#toString` avoids issues with the `typeof` operator
          // in Safari 9 which returns 'object' for typed arrays and other constructors.
          var tag = baseGetTag(value);
          return (
            tag == funcTag ||
            tag == genTag ||
            tag == asyncTag ||
            tag == proxyTag
          );
        }

        module.exports = isFunction;

        /***/
      },

    /***/ "./node_modules/lodash/isLength.js":
      /*!*****************************************!*\
  !*** ./node_modules/lodash/isLength.js ***!
  \*****************************************/
      /***/ (module) => {
        /** Used as references for various `Number` constants. */
        var MAX_SAFE_INTEGER = 9007199254740991;

        /**
         * Checks if `value` is a valid array-like length.
         *
         * **Note:** This method is loosely based on
         * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
         * @example
         *
         * _.isLength(3);
         * // => true
         *
         * _.isLength(Number.MIN_VALUE);
         * // => false
         *
         * _.isLength(Infinity);
         * // => false
         *
         * _.isLength('3');
         * // => false
         */
        function isLength(value) {
          return (
            typeof value == "number" &&
            value > -1 &&
            value % 1 == 0 &&
            value <= MAX_SAFE_INTEGER
          );
        }

        module.exports = isLength;

        /***/
      },

    /***/ "./node_modules/lodash/isObject.js":
      /*!*****************************************!*\
  !*** ./node_modules/lodash/isObject.js ***!
  \*****************************************/
      /***/ (module) => {
        /**
         * Checks if `value` is the
         * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
         * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
         *
         * @static
         * @memberOf _
         * @since 0.1.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is an object, else `false`.
         * @example
         *
         * _.isObject({});
         * // => true
         *
         * _.isObject([1, 2, 3]);
         * // => true
         *
         * _.isObject(_.noop);
         * // => true
         *
         * _.isObject(null);
         * // => false
         */
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }

        module.exports = isObject;

        /***/
      },

    /***/ "./node_modules/lodash/isObjectLike.js":
      /*!*********************************************!*\
  !*** ./node_modules/lodash/isObjectLike.js ***!
  \*********************************************/
      /***/ (module) => {
        /**
         * Checks if `value` is object-like. A value is object-like if it's not `null`
         * and has a `typeof` result of "object".
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
         * @example
         *
         * _.isObjectLike({});
         * // => true
         *
         * _.isObjectLike([1, 2, 3]);
         * // => true
         *
         * _.isObjectLike(_.noop);
         * // => false
         *
         * _.isObjectLike(null);
         * // => false
         */
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }

        module.exports = isObjectLike;

        /***/
      },

    /***/ "./node_modules/lodash/isSymbol.js":
      /*!*****************************************!*\
  !*** ./node_modules/lodash/isSymbol.js ***!
  \*****************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var baseGetTag = __webpack_require__(
            /*! ./_baseGetTag */ "./node_modules/lodash/_baseGetTag.js"
          ),
          isObjectLike = __webpack_require__(
            /*! ./isObjectLike */ "./node_modules/lodash/isObjectLike.js"
          );

        /** `Object#toString` result references. */
        var symbolTag = "[object Symbol]";

        /**
         * Checks if `value` is classified as a `Symbol` primitive or object.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to check.
         * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
         * @example
         *
         * _.isSymbol(Symbol.iterator);
         * // => true
         *
         * _.isSymbol('abc');
         * // => false
         */
        function isSymbol(value) {
          return (
            typeof value == "symbol" ||
            (isObjectLike(value) && baseGetTag(value) == symbolTag)
          );
        }

        module.exports = isSymbol;

        /***/
      },

    /***/ "./node_modules/lodash/now.js":
      /*!************************************!*\
  !*** ./node_modules/lodash/now.js ***!
  \************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var root = __webpack_require__(
          /*! ./_root */ "./node_modules/lodash/_root.js"
        );

        /**
         * Gets the timestamp of the number of milliseconds that have elapsed since
         * the Unix epoch (1 January 1970 00:00:00 UTC).
         *
         * @static
         * @memberOf _
         * @since 2.4.0
         * @category Date
         * @returns {number} Returns the timestamp.
         * @example
         *
         * _.defer(function(stamp) {
         *   console.log(_.now() - stamp);
         * }, _.now());
         * // => Logs the number of milliseconds it took for the deferred invocation.
         */
        var now = function () {
          return root.Date.now();
        };

        module.exports = now;

        /***/
      },

    /***/ "./node_modules/lodash/range.js":
      /*!**************************************!*\
  !*** ./node_modules/lodash/range.js ***!
  \**************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var createRange = __webpack_require__(
          /*! ./_createRange */ "./node_modules/lodash/_createRange.js"
        );

        /**
         * Creates an array of numbers (positive and/or negative) progressing from
         * `start` up to, but not including, `end`. A step of `-1` is used if a negative
         * `start` is specified without an `end` or `step`. If `end` is not specified,
         * it's set to `start` with `start` then set to `0`.
         *
         * **Note:** JavaScript follows the IEEE-754 standard for resolving
         * floating-point values which can produce unexpected results.
         *
         * @static
         * @since 0.1.0
         * @memberOf _
         * @category Util
         * @param {number} [start=0] The start of the range.
         * @param {number} end The end of the range.
         * @param {number} [step=1] The value to increment or decrement by.
         * @returns {Array} Returns the range of numbers.
         * @see _.inRange, _.rangeRight
         * @example
         *
         * _.range(4);
         * // => [0, 1, 2, 3]
         *
         * _.range(-4);
         * // => [0, -1, -2, -3]
         *
         * _.range(1, 5);
         * // => [1, 2, 3, 4]
         *
         * _.range(0, 20, 5);
         * // => [0, 5, 10, 15]
         *
         * _.range(0, -4, -1);
         * // => [0, -1, -2, -3]
         *
         * _.range(1, 4, 0);
         * // => [1, 1, 1]
         *
         * _.range(0);
         * // => []
         */
        var range = createRange();

        module.exports = range;

        /***/
      },

    /***/ "./node_modules/lodash/toFinite.js":
      /*!*****************************************!*\
  !*** ./node_modules/lodash/toFinite.js ***!
  \*****************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var toNumber = __webpack_require__(
          /*! ./toNumber */ "./node_modules/lodash/toNumber.js"
        );

        /** Used as references for various `Number` constants. */
        var INFINITY = 1 / 0,
          MAX_INTEGER = 1.7976931348623157e308;

        /**
         * Converts `value` to a finite number.
         *
         * @static
         * @memberOf _
         * @since 4.12.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted number.
         * @example
         *
         * _.toFinite(3.2);
         * // => 3.2
         *
         * _.toFinite(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toFinite(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toFinite('3.2');
         * // => 3.2
         */
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }

        module.exports = toFinite;

        /***/
      },

    /***/ "./node_modules/lodash/toInteger.js":
      /*!******************************************!*\
  !*** ./node_modules/lodash/toInteger.js ***!
  \******************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var toFinite = __webpack_require__(
          /*! ./toFinite */ "./node_modules/lodash/toFinite.js"
        );

        /**
         * Converts `value` to an integer.
         *
         * **Note:** This method is loosely based on
         * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to convert.
         * @returns {number} Returns the converted integer.
         * @example
         *
         * _.toInteger(3.2);
         * // => 3
         *
         * _.toInteger(Number.MIN_VALUE);
         * // => 0
         *
         * _.toInteger(Infinity);
         * // => 1.7976931348623157e+308
         *
         * _.toInteger('3.2');
         * // => 3
         */
        function toInteger(value) {
          var result = toFinite(value),
            remainder = result % 1;

          return result === result
            ? remainder
              ? result - remainder
              : result
            : 0;
        }

        module.exports = toInteger;

        /***/
      },

    /***/ "./node_modules/lodash/toNumber.js":
      /*!*****************************************!*\
  !*** ./node_modules/lodash/toNumber.js ***!
  \*****************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var baseTrim = __webpack_require__(
            /*! ./_baseTrim */ "./node_modules/lodash/_baseTrim.js"
          ),
          isObject = __webpack_require__(
            /*! ./isObject */ "./node_modules/lodash/isObject.js"
          ),
          isSymbol = __webpack_require__(
            /*! ./isSymbol */ "./node_modules/lodash/isSymbol.js"
          );

        /** Used as references for various `Number` constants. */
        var NAN = 0 / 0;

        /** Used to detect bad signed hexadecimal string values. */
        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

        /** Used to detect binary string values. */
        var reIsBinary = /^0b[01]+$/i;

        /** Used to detect octal string values. */
        var reIsOctal = /^0o[0-7]+$/i;

        /** Built-in method references without a dependency on `root`. */
        var freeParseInt = parseInt;

        /**
         * Converts `value` to a number.
         *
         * @static
         * @memberOf _
         * @since 4.0.0
         * @category Lang
         * @param {*} value The value to process.
         * @returns {number} Returns the number.
         * @example
         *
         * _.toNumber(3.2);
         * // => 3.2
         *
         * _.toNumber(Number.MIN_VALUE);
         * // => 5e-324
         *
         * _.toNumber(Infinity);
         * // => Infinity
         *
         * _.toNumber('3.2');
         * // => 3.2
         */
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject(value)) {
            var other =
              typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value)
            ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
            : reIsBadHex.test(value)
            ? NAN
            : +value;
        }

        module.exports = toNumber;

        /***/
      },

    /***/ "./src/css/main.scss":
      /*!***************************!*\
  !*** ./src/css/main.scss ***!
  \***************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        // extracted by mini-css-extract-plugin

        /***/
      },

    /***/ "./node_modules/ms/index.js":
      /*!**********************************!*\
  !*** ./node_modules/ms/index.js ***!
  \**********************************/
      /***/ (module) => {
        /**
         * Helpers.
         */

        var s = 1000;
        var m = s * 60;
        var h = m * 60;
        var d = h * 24;
        var y = d * 365.25;

        /**
         * Parse or format the given `val`.
         *
         * Options:
         *
         *  - `long` verbose formatting [false]
         *
         * @param {String|Number} val
         * @param {Object} [options]
         * @throws {Error} throw an error if val is not a non-empty string or a number
         * @return {String|Number}
         * @api public
         */

        module.exports = function (val, options) {
          options = options || {};
          var type = typeof val;
          if (type === "string" && val.length > 0) {
            return parse(val);
          } else if (type === "number" && isNaN(val) === false) {
            return options.long ? fmtLong(val) : fmtShort(val);
          }
          throw new Error(
            "val is not a non-empty string or a valid number. val=" +
              JSON.stringify(val)
          );
        };

        /**
         * Parse the given `str` and return milliseconds.
         *
         * @param {String} str
         * @return {Number}
         * @api private
         */

        function parse(str) {
          str = String(str);
          if (str.length > 100) {
            return;
          }
          var match =
            /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
              str
            );
          if (!match) {
            return;
          }
          var n = parseFloat(match[1]);
          var type = (match[2] || "ms").toLowerCase();
          switch (type) {
            case "years":
            case "year":
            case "yrs":
            case "yr":
            case "y":
              return n * y;
            case "days":
            case "day":
            case "d":
              return n * d;
            case "hours":
            case "hour":
            case "hrs":
            case "hr":
            case "h":
              return n * h;
            case "minutes":
            case "minute":
            case "mins":
            case "min":
            case "m":
              return n * m;
            case "seconds":
            case "second":
            case "secs":
            case "sec":
            case "s":
              return n * s;
            case "milliseconds":
            case "millisecond":
            case "msecs":
            case "msec":
            case "ms":
              return n;
            default:
              return undefined;
          }
        }

        /**
         * Short format for `ms`.
         *
         * @param {Number} ms
         * @return {String}
         * @api private
         */

        function fmtShort(ms) {
          if (ms >= d) {
            return Math.round(ms / d) + "d";
          }
          if (ms >= h) {
            return Math.round(ms / h) + "h";
          }
          if (ms >= m) {
            return Math.round(ms / m) + "m";
          }
          if (ms >= s) {
            return Math.round(ms / s) + "s";
          }
          return ms + "ms";
        }

        /**
         * Long format for `ms`.
         *
         * @param {Number} ms
         * @return {String}
         * @api private
         */

        function fmtLong(ms) {
          return (
            plural(ms, d, "day") ||
            plural(ms, h, "hour") ||
            plural(ms, m, "minute") ||
            plural(ms, s, "second") ||
            ms + " ms"
          );
        }

        /**
         * Pluralization helper.
         */

        function plural(ms, n, name) {
          if (ms < n) {
            return;
          }
          if (ms < n * 1.5) {
            return Math.floor(ms / n) + " " + name;
          }
          return Math.ceil(ms / n) + " " + name + "s";
        }

        /***/
      },

    /***/ "./node_modules/nanoajax/index.js":
      /*!****************************************!*\
  !*** ./node_modules/nanoajax/index.js ***!
  \****************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        // Best place to find information on XHR features is:
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest

        var reqfields = [
          "responseType",
          "withCredentials",
          "timeout",
          "onprogress",
        ];

        // Simple and small ajax function
        // Takes a parameters object and a callback function
        // Parameters:
        //  - url: string, required
        //  - headers: object of `{header_name: header_value, ...}`
        //  - body:
        //      + string (sets content type to 'application/x-www-form-urlencoded' if not set in headers)
        //      + FormData (doesn't set content type so that browser will set as appropriate)
        //  - method: 'GET', 'POST', etc. Defaults to 'GET' or 'POST' based on body
        //  - cors: If your using cross-origin, you will need this true for IE8-9
        //
        // The following parameters are passed onto the xhr object.
        // IMPORTANT NOTE: The caller is responsible for compatibility checking.
        //  - responseType: string, various compatability, see xhr docs for enum options
        //  - withCredentials: boolean, IE10+, CORS only
        //  - timeout: long, ms timeout, IE8+
        //  - onprogress: callback, IE10+
        //
        // Callback function prototype:
        //  - statusCode from request
        //  - response
        //    + if responseType set and supported by browser, this is an object of some type (see docs)
        //    + otherwise if request completed, this is the string text of the response
        //    + if request is aborted, this is "Abort"
        //    + if request times out, this is "Timeout"
        //    + if request errors before completing (probably a CORS issue), this is "Error"
        //  - request object
        //
        // Returns the request object. So you can call .abort() or other methods
        //
        // DEPRECATIONS:
        //  - Passing a string instead of the params object has been removed!
        //
        exports.ajax = function (params, callback) {
          // Any variable used more than once is var'd here because
          // minification will munge the variables whereas it can't munge
          // the object access.
          var headers = params.headers || {},
            body = params.body,
            method = params.method || (body ? "POST" : "GET"),
            called = false;

          var req = getRequest(params.cors);

          function cb(statusCode, responseText) {
            return function () {
              if (!called) {
                callback(
                  req.status === undefined ? statusCode : req.status,
                  req.status === 0
                    ? "Error"
                    : req.response || req.responseText || responseText,
                  req
                );
                called = true;
              }
            };
          }

          req.open(method, params.url, true);

          var success = (req.onload = cb(200));
          req.onreadystatechange = function () {
            if (req.readyState === 4) success();
          };
          req.onerror = cb(null, "Error");
          req.ontimeout = cb(null, "Timeout");
          req.onabort = cb(null, "Abort");

          if (body) {
            setDefault(headers, "X-Requested-With", "XMLHttpRequest");

            if (
              !__webpack_require__.g.FormData ||
              !(body instanceof __webpack_require__.g.FormData)
            ) {
              setDefault(
                headers,
                "Content-Type",
                "application/x-www-form-urlencoded"
              );
            }
          }

          for (var i = 0, len = reqfields.length, field; i < len; i++) {
            field = reqfields[i];
            if (params[field] !== undefined) req[field] = params[field];
          }

          for (var field in headers)
            req.setRequestHeader(field, headers[field]);

          req.send(body);

          return req;
        };

        function getRequest(cors) {
          // XDomainRequest is only way to do CORS in IE 8 and 9
          // But XDomainRequest isn't standards-compatible
          // Notably, it doesn't allow cookies to be sent or set by servers
          // IE 10+ is standards-compatible in its XMLHttpRequest
          // but IE 10 can still have an XDomainRequest object, so we don't want to use it
          if (
            cors &&
            __webpack_require__.g.XDomainRequest &&
            !/MSIE 1/.test(navigator.userAgent)
          )
            return new XDomainRequest();
          if (__webpack_require__.g.XMLHttpRequest) return new XMLHttpRequest();
        }

        function setDefault(obj, key, value) {
          obj[key] = obj[key] || value;
        }

        /***/
      },

    /***/ "./node_modules/object-fit-images/dist/ofi.common-js.js":
      /*!**************************************************************!*\
  !*** ./node_modules/object-fit-images/dist/ofi.common-js.js ***!
  \**************************************************************/
      /***/ (module) => {
        "use strict";
        /*! npm.im/object-fit-images 3.2.4 */

        var OFI = "bfred-it:object-fit-images";
        var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
        var testImg =
          typeof Image === "undefined"
            ? { style: { "object-position": 1 } }
            : new Image();
        var supportsObjectFit = "object-fit" in testImg.style;
        var supportsObjectPosition = "object-position" in testImg.style;
        var supportsOFI = "background-size" in testImg.style;
        var supportsCurrentSrc = typeof testImg.currentSrc === "string";
        var nativeGetAttribute = testImg.getAttribute;
        var nativeSetAttribute = testImg.setAttribute;
        var autoModeEnabled = false;

        function createPlaceholder(w, h) {
          return (
            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" +
            w +
            "' height='" +
            h +
            "'%3E%3C/svg%3E"
          );
        }

        function polyfillCurrentSrc(el) {
          if (el.srcset && !supportsCurrentSrc && window.picturefill) {
            var pf = window.picturefill._;
            // parse srcset with picturefill where currentSrc isn't available
            if (!el[pf.ns] || !el[pf.ns].evaled) {
              // force synchronous srcset parsing
              pf.fillImg(el, { reselect: true });
            }

            if (!el[pf.ns].curSrc) {
              // force picturefill to parse srcset
              el[pf.ns].supported = false;
              pf.fillImg(el, { reselect: true });
            }

            // retrieve parsed currentSrc, if any
            el.currentSrc = el[pf.ns].curSrc || el.src;
          }
        }

        function getStyle(el) {
          var style = getComputedStyle(el).fontFamily;
          var parsed;
          var props = {};
          while ((parsed = propRegex.exec(style)) !== null) {
            props[parsed[1]] = parsed[2];
          }
          return props;
        }

        function setPlaceholder(img, width, height) {
          // Default: fill width, no height
          var placeholder = createPlaceholder(width || 1, height || 0);

          // Only set placeholder if it's different
          if (nativeGetAttribute.call(img, "src") !== placeholder) {
            nativeSetAttribute.call(img, "src", placeholder);
          }
        }

        function onImageReady(img, callback) {
          // naturalWidth is only available when the image headers are loaded,
          // this loop will poll it every 100ms.
          if (img.naturalWidth) {
            callback(img);
          } else {
            setTimeout(onImageReady, 100, img, callback);
          }
        }

        function fixOne(el) {
          var style = getStyle(el);
          var ofi = el[OFI];
          style["object-fit"] = style["object-fit"] || "fill"; // default value

          // Avoid running where unnecessary, unless OFI had already done its deed
          if (!ofi.img) {
            // fill is the default behavior so no action is necessary
            if (style["object-fit"] === "fill") {
              return;
            }

            // Where object-fit is supported and object-position isn't (Safari < 10)
            if (
              !ofi.skipTest && // unless user wants to apply regardless of browser support
              supportsObjectFit && // if browser already supports object-fit
              !style["object-position"] // unless object-position is used
            ) {
              return;
            }
          }

          // keep a clone in memory while resetting the original to a blank
          if (!ofi.img) {
            ofi.img = new Image(el.width, el.height);
            ofi.img.srcset =
              nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
            ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

            // preserve for any future cloneNode calls
            // https://github.com/bfred-it/object-fit-images/issues/53
            nativeSetAttribute.call(el, "data-ofi-src", el.src);
            if (el.srcset) {
              nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
            }

            setPlaceholder(
              el,
              el.naturalWidth || el.width,
              el.naturalHeight || el.height
            );

            // remove srcset because it overrides src
            if (el.srcset) {
              el.srcset = "";
            }
            try {
              keepSrcUsable(el);
            } catch (err) {
              if (window.console) {
                console.warn("https://bit.ly/ofi-old-browser");
              }
            }
          }

          polyfillCurrentSrc(ofi.img);

          el.style.backgroundImage =
            'url("' +
            (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') +
            '")';
          el.style.backgroundPosition = style["object-position"] || "center";
          el.style.backgroundRepeat = "no-repeat";
          el.style.backgroundOrigin = "content-box";

          if (/scale-down/.test(style["object-fit"])) {
            onImageReady(ofi.img, function () {
              if (
                ofi.img.naturalWidth > el.width ||
                ofi.img.naturalHeight > el.height
              ) {
                el.style.backgroundSize = "contain";
              } else {
                el.style.backgroundSize = "auto";
              }
            });
          } else {
            el.style.backgroundSize = style["object-fit"]
              .replace("none", "auto")
              .replace("fill", "100% 100%");
          }

          onImageReady(ofi.img, function (img) {
            setPlaceholder(el, img.naturalWidth, img.naturalHeight);
          });
        }

        function keepSrcUsable(el) {
          var descriptors = {
            get: function get(prop) {
              return el[OFI].img[prop ? prop : "src"];
            },
            set: function set(value, prop) {
              el[OFI].img[prop ? prop : "src"] = value;
              nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
              fixOne(el);
              return value;
            },
          };
          Object.defineProperty(el, "src", descriptors);
          Object.defineProperty(el, "currentSrc", {
            get: function () {
              return descriptors.get("currentSrc");
            },
          });
          Object.defineProperty(el, "srcset", {
            get: function () {
              return descriptors.get("srcset");
            },
            set: function (ss) {
              return descriptors.set(ss, "srcset");
            },
          });
        }

        function hijackAttributes() {
          function getOfiImageMaybe(el, name) {
            return el[OFI] &&
              el[OFI].img &&
              (name === "src" || name === "srcset")
              ? el[OFI].img
              : el;
          }
          if (!supportsObjectPosition) {
            HTMLImageElement.prototype.getAttribute = function (name) {
              return nativeGetAttribute.call(
                getOfiImageMaybe(this, name),
                name
              );
            };

            HTMLImageElement.prototype.setAttribute = function (name, value) {
              return nativeSetAttribute.call(
                getOfiImageMaybe(this, name),
                name,
                String(value)
              );
            };
          }
        }

        function fix(imgs, opts) {
          var startAutoMode = !autoModeEnabled && !imgs;
          opts = opts || {};
          imgs = imgs || "img";

          if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
            return false;
          }

          // use imgs as a selector or just select all images
          if (imgs === "img") {
            imgs = document.getElementsByTagName("img");
          } else if (typeof imgs === "string") {
            imgs = document.querySelectorAll(imgs);
          } else if (!("length" in imgs)) {
            imgs = [imgs];
          }

          // apply fix to all
          for (var i = 0; i < imgs.length; i++) {
            imgs[i][OFI] = imgs[i][OFI] || {
              skipTest: opts.skipTest,
            };
            fixOne(imgs[i]);
          }

          if (startAutoMode) {
            document.body.addEventListener(
              "load",
              function (e) {
                if (e.target.tagName === "IMG") {
                  fix(e.target, {
                    skipTest: opts.skipTest,
                  });
                }
              },
              true
            );
            autoModeEnabled = true;
            imgs = "img"; // reset to a generic selector for watchMQ
          }

          // if requested, watch media queries for object-fit change
          if (opts.watchMQ) {
            window.addEventListener(
              "resize",
              fix.bind(null, imgs, {
                skipTest: opts.skipTest,
              })
            );
          }
        }

        fix.supportsObjectFit = supportsObjectFit;
        fix.supportsObjectPosition = supportsObjectPosition;

        hijackAttributes();

        module.exports = fix;

        /***/
      },

    /***/ "./node_modules/process/browser.js":
      /*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
      /***/ (module) => {
        // shim for using process in browser
        var process = (module.exports = {});

        // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        var cachedSetTimeout;
        var cachedClearTimeout;

        function defaultSetTimout() {
          throw new Error("setTimeout has not been defined");
        }
        function defaultClearTimeout() {
          throw new Error("clearTimeout has not been defined");
        }
        (function () {
          try {
            if (typeof setTimeout === "function") {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }
          try {
            if (typeof clearTimeout === "function") {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        })();
        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
          }
          // if setTimeout wasn't available but was latter defined
          if (
            (cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) &&
            setTimeout
          ) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }
        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
          }
          // if clearTimeout wasn't available but was latter defined
          if (
            (cachedClearTimeout === defaultClearTimeout ||
              !cachedClearTimeout) &&
            clearTimeout
          ) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }
          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }
        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;

        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }
          draining = false;
          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }
          if (queue.length) {
            drainQueue();
          }
        }

        function drainQueue() {
          if (draining) {
            return;
          }
          var timeout = runTimeout(cleanUpNextTick);
          draining = true;

          var len = queue.length;
          while (len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }
            queueIndex = -1;
            len = queue.length;
          }
          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }

        process.nextTick = function (fun) {
          var args = new Array(arguments.length - 1);
          if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }
          queue.push(new Item(fun, args));
          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        };

        // v8 likes predictible objects
        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }
        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };
        process.title = "browser";
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ""; // empty string to avoid regexp issues
        process.versions = {};

        function noop() {}

        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;

        process.listeners = function (name) {
          return [];
        };

        process.binding = function (name) {
          throw new Error("process.binding is not supported");
        };

        process.cwd = function () {
          return "/";
        };
        process.chdir = function (dir) {
          throw new Error("process.chdir is not supported");
        };
        process.umask = function () {
          return 0;
        };

        /***/
      },

    /***/ "./node_modules/query-string/index.js":
      /*!********************************************!*\
  !*** ./node_modules/query-string/index.js ***!
  \********************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        const strictUriEncode = __webpack_require__(
          /*! strict-uri-encode */ "./node_modules/strict-uri-encode/index.js"
        );
        const decodeComponent = __webpack_require__(
          /*! decode-uri-component */ "./node_modules/decode-uri-component/index.js"
        );
        const splitOnFirst = __webpack_require__(
          /*! split-on-first */ "./node_modules/split-on-first/index.js"
        );
        const filterObject = __webpack_require__(
          /*! filter-obj */ "./node_modules/filter-obj/index.js"
        );

        const isNullOrUndefined = (value) =>
          value === null || value === undefined;

        const encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");

        function encoderForArrayFormat(options) {
          switch (options.arrayFormat) {
            case "index":
              return (key) => (result, value) => {
                const index = result.length;

                if (
                  value === undefined ||
                  (options.skipNull && value === null) ||
                  (options.skipEmptyString && value === "")
                ) {
                  return result;
                }

                if (value === null) {
                  return [
                    ...result,
                    [encode(key, options), "[", index, "]"].join(""),
                  ];
                }

                return [
                  ...result,
                  [
                    encode(key, options),
                    "[",
                    encode(index, options),
                    "]=",
                    encode(value, options),
                  ].join(""),
                ];
              };

            case "bracket":
              return (key) => (result, value) => {
                if (
                  value === undefined ||
                  (options.skipNull && value === null) ||
                  (options.skipEmptyString && value === "")
                ) {
                  return result;
                }

                if (value === null) {
                  return [...result, [encode(key, options), "[]"].join("")];
                }

                return [
                  ...result,
                  [encode(key, options), "[]=", encode(value, options)].join(
                    ""
                  ),
                ];
              };

            case "colon-list-separator":
              return (key) => (result, value) => {
                if (
                  value === undefined ||
                  (options.skipNull && value === null) ||
                  (options.skipEmptyString && value === "")
                ) {
                  return result;
                }

                if (value === null) {
                  return [...result, [encode(key, options), ":list="].join("")];
                }

                return [
                  ...result,
                  [encode(key, options), ":list=", encode(value, options)].join(
                    ""
                  ),
                ];
              };

            case "comma":
            case "separator":
            case "bracket-separator": {
              const keyValueSep =
                options.arrayFormat === "bracket-separator" ? "[]=" : "=";

              return (key) => (result, value) => {
                if (
                  value === undefined ||
                  (options.skipNull && value === null) ||
                  (options.skipEmptyString && value === "")
                ) {
                  return result;
                }

                // Translate null to an empty string so that it doesn't serialize as 'null'
                value = value === null ? "" : value;

                if (result.length === 0) {
                  return [
                    [
                      encode(key, options),
                      keyValueSep,
                      encode(value, options),
                    ].join(""),
                  ];
                }

                return [
                  [result, encode(value, options)].join(
                    options.arrayFormatSeparator
                  ),
                ];
              };
            }

            default:
              return (key) => (result, value) => {
                if (
                  value === undefined ||
                  (options.skipNull && value === null) ||
                  (options.skipEmptyString && value === "")
                ) {
                  return result;
                }

                if (value === null) {
                  return [...result, encode(key, options)];
                }

                return [
                  ...result,
                  [encode(key, options), "=", encode(value, options)].join(""),
                ];
              };
          }
        }

        function parserForArrayFormat(options) {
          let result;

          switch (options.arrayFormat) {
            case "index":
              return (key, value, accumulator) => {
                result = /\[(\d*)\]$/.exec(key);

                key = key.replace(/\[\d*\]$/, "");

                if (!result) {
                  accumulator[key] = value;
                  return;
                }

                if (accumulator[key] === undefined) {
                  accumulator[key] = {};
                }

                accumulator[key][result[1]] = value;
              };

            case "bracket":
              return (key, value, accumulator) => {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");

                if (!result) {
                  accumulator[key] = value;
                  return;
                }

                if (accumulator[key] === undefined) {
                  accumulator[key] = [value];
                  return;
                }

                accumulator[key] = [].concat(accumulator[key], value);
              };

            case "colon-list-separator":
              return (key, value, accumulator) => {
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");

                if (!result) {
                  accumulator[key] = value;
                  return;
                }

                if (accumulator[key] === undefined) {
                  accumulator[key] = [value];
                  return;
                }

                accumulator[key] = [].concat(accumulator[key], value);
              };

            case "comma":
            case "separator":
              return (key, value, accumulator) => {
                const isArray =
                  typeof value === "string" &&
                  value.includes(options.arrayFormatSeparator);
                const isEncodedArray =
                  typeof value === "string" &&
                  !isArray &&
                  decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? decode(value, options) : value;
                const newValue =
                  isArray || isEncodedArray
                    ? value
                        .split(options.arrayFormatSeparator)
                        .map((item) => decode(item, options))
                    : value === null
                    ? value
                    : decode(value, options);
                accumulator[key] = newValue;
              };

            case "bracket-separator":
              return (key, value, accumulator) => {
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");

                if (!isArray) {
                  accumulator[key] = value ? decode(value, options) : value;
                  return;
                }

                const arrayValue =
                  value === null
                    ? []
                    : value
                        .split(options.arrayFormatSeparator)
                        .map((item) => decode(item, options));

                if (accumulator[key] === undefined) {
                  accumulator[key] = arrayValue;
                  return;
                }

                accumulator[key] = [].concat(accumulator[key], arrayValue);
              };

            default:
              return (key, value, accumulator) => {
                if (accumulator[key] === undefined) {
                  accumulator[key] = value;
                  return;
                }

                accumulator[key] = [].concat(accumulator[key], value);
              };
          }
        }

        function validateArrayFormatSeparator(value) {
          if (typeof value !== "string" || value.length !== 1) {
            throw new TypeError(
              "arrayFormatSeparator must be single character string"
            );
          }
        }

        function encode(value, options) {
          if (options.encode) {
            return options.strict
              ? strictUriEncode(value)
              : encodeURIComponent(value);
          }

          return value;
        }

        function decode(value, options) {
          if (options.decode) {
            return decodeComponent(value);
          }

          return value;
        }

        function keysSorter(input) {
          if (Array.isArray(input)) {
            return input.sort();
          }

          if (typeof input === "object") {
            return keysSorter(Object.keys(input))
              .sort((a, b) => Number(a) - Number(b))
              .map((key) => input[key]);
          }

          return input;
        }

        function removeHash(input) {
          const hashStart = input.indexOf("#");
          if (hashStart !== -1) {
            input = input.slice(0, hashStart);
          }

          return input;
        }

        function getHash(url) {
          let hash = "";
          const hashStart = url.indexOf("#");
          if (hashStart !== -1) {
            hash = url.slice(hashStart);
          }

          return hash;
        }

        function extract(input) {
          input = removeHash(input);
          const queryStart = input.indexOf("?");
          if (queryStart === -1) {
            return "";
          }

          return input.slice(queryStart + 1);
        }

        function parseValue(value, options) {
          if (
            options.parseNumbers &&
            !Number.isNaN(Number(value)) &&
            typeof value === "string" &&
            value.trim() !== ""
          ) {
            value = Number(value);
          } else if (
            options.parseBooleans &&
            value !== null &&
            (value.toLowerCase() === "true" || value.toLowerCase() === "false")
          ) {
            value = value.toLowerCase() === "true";
          }

          return value;
        }

        function parse(query, options) {
          options = Object.assign(
            {
              decode: true,
              sort: true,
              arrayFormat: "none",
              arrayFormatSeparator: ",",
              parseNumbers: false,
              parseBooleans: false,
            },
            options
          );

          validateArrayFormatSeparator(options.arrayFormatSeparator);

          const formatter = parserForArrayFormat(options);

          // Create an object with no prototype
          const ret = Object.create(null);

          if (typeof query !== "string") {
            return ret;
          }

          query = query.trim().replace(/^[?#&]/, "");

          if (!query) {
            return ret;
          }

          for (const param of query.split("&")) {
            if (param === "") {
              continue;
            }

            let [key, value] = splitOnFirst(
              options.decode ? param.replace(/\+/g, " ") : param,
              "="
            );

            // Missing `=` should be `null`:
            // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
            value =
              value === undefined
                ? null
                : ["comma", "separator", "bracket-separator"].includes(
                    options.arrayFormat
                  )
                ? value
                : decode(value, options);
            formatter(decode(key, options), value, ret);
          }

          for (const key of Object.keys(ret)) {
            const value = ret[key];
            if (typeof value === "object" && value !== null) {
              for (const k of Object.keys(value)) {
                value[k] = parseValue(value[k], options);
              }
            } else {
              ret[key] = parseValue(value, options);
            }
          }

          if (options.sort === false) {
            return ret;
          }

          return (
            options.sort === true
              ? Object.keys(ret).sort()
              : Object.keys(ret).sort(options.sort)
          ).reduce((result, key) => {
            const value = ret[key];
            if (
              Boolean(value) &&
              typeof value === "object" &&
              !Array.isArray(value)
            ) {
              // Sort object keys, not values
              result[key] = keysSorter(value);
            } else {
              result[key] = value;
            }

            return result;
          }, Object.create(null));
        }

        exports.extract = extract;
        exports.parse = parse;

        exports.stringify = (object, options) => {
          if (!object) {
            return "";
          }

          options = Object.assign(
            {
              encode: true,
              strict: true,
              arrayFormat: "none",
              arrayFormatSeparator: ",",
            },
            options
          );

          validateArrayFormatSeparator(options.arrayFormatSeparator);

          const shouldFilter = (key) =>
            (options.skipNull && isNullOrUndefined(object[key])) ||
            (options.skipEmptyString && object[key] === "");

          const formatter = encoderForArrayFormat(options);

          const objectCopy = {};

          for (const key of Object.keys(object)) {
            if (!shouldFilter(key)) {
              objectCopy[key] = object[key];
            }
          }

          const keys = Object.keys(objectCopy);

          if (options.sort !== false) {
            keys.sort(options.sort);
          }

          return keys
            .map((key) => {
              const value = object[key];

              if (value === undefined) {
                return "";
              }

              if (value === null) {
                return encode(key, options);
              }

              if (Array.isArray(value)) {
                if (
                  value.length === 0 &&
                  options.arrayFormat === "bracket-separator"
                ) {
                  return encode(key, options) + "[]";
                }

                return value.reduce(formatter(key), []).join("&");
              }

              return encode(key, options) + "=" + encode(value, options);
            })
            .filter((x) => x.length > 0)
            .join("&");
        };

        exports.parseUrl = (url, options) => {
          options = Object.assign(
            {
              decode: true,
            },
            options
          );

          const [url_, hash] = splitOnFirst(url, "#");

          return Object.assign(
            {
              url: url_.split("?")[0] || "",
              query: parse(extract(url), options),
            },
            options && options.parseFragmentIdentifier && hash
              ? { fragmentIdentifier: decode(hash, options) }
              : {}
          );
        };

        exports.stringifyUrl = (object, options) => {
          options = Object.assign(
            {
              encode: true,
              strict: true,
              [encodeFragmentIdentifier]: true,
            },
            options
          );

          const url = removeHash(object.url).split("?")[0] || "";
          const queryFromUrl = exports.extract(object.url);
          const parsedQueryFromUrl = exports.parse(queryFromUrl, {
            sort: false,
          });

          const query = Object.assign(parsedQueryFromUrl, object.query);
          let queryString = exports.stringify(query, options);
          if (queryString) {
            queryString = `?${queryString}`;
          }

          let hash = getHash(object.url);
          if (object.fragmentIdentifier) {
            hash = `#${
              options[encodeFragmentIdentifier]
                ? encode(object.fragmentIdentifier, options)
                : object.fragmentIdentifier
            }`;
          }

          return `${url}${queryString}${hash}`;
        };

        exports.pick = (input, filter, options) => {
          options = Object.assign(
            {
              parseFragmentIdentifier: true,
              [encodeFragmentIdentifier]: false,
            },
            options
          );

          const { url, query, fragmentIdentifier } = exports.parseUrl(
            input,
            options
          );
          return exports.stringifyUrl(
            {
              url,
              query: filterObject(query, filter),
              fragmentIdentifier,
            },
            options
          );
        };

        exports.exclude = (input, filter, options) => {
          const exclusionFilter = Array.isArray(filter)
            ? (key) => !filter.includes(key)
            : (key, value) => !filter(key, value);

          return exports.pick(input, exclusionFilter, options);
        };

        /***/
      },

    /***/ "./node_modules/split-on-first/index.js":
      /*!**********************************************!*\
  !*** ./node_modules/split-on-first/index.js ***!
  \**********************************************/
      /***/ (module) => {
        "use strict";

        module.exports = (string, separator) => {
          if (!(typeof string === "string" && typeof separator === "string")) {
            throw new TypeError(
              "Expected the arguments to be of type `string`"
            );
          }

          if (separator === "") {
            return [string];
          }

          const separatorIndex = string.indexOf(separator);

          if (separatorIndex === -1) {
            return [string];
          }

          return [
            string.slice(0, separatorIndex),
            string.slice(separatorIndex + separator.length),
          ];
        };

        /***/
      },

    /***/ "./node_modules/strict-uri-encode/index.js":
      /*!*************************************************!*\
  !*** ./node_modules/strict-uri-encode/index.js ***!
  \*************************************************/
      /***/ (module) => {
        "use strict";

        module.exports = (str) =>
          encodeURIComponent(str).replace(
            /[!'()*]/g,
            (x) => `%${x.charCodeAt(0).toString(16).toUpperCase()}`
          );

        /***/
      },

    /***/ "./node_modules/style-loader/dist/cjs.js!./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=85ca06a4&lang=css&":
      /*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/style-loader/dist/cjs.js!./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=85ca06a4&lang=css& ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! !../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"
          );
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var _laravel_mix_node_modules_css_loader_dist_cjs_js_clonedRuleSet_9_use_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_dist_cjs_js_clonedRuleSet_9_use_2_vue_loader_lib_index_js_vue_loader_options_map_vue_vue_type_style_index_0_id_85ca06a4_lang_css___WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! !!../../../laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!../../../vue-loader/lib/loaders/stylePostLoader.js!../../../postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!../../../vue-loader/lib/index.js??vue-loader-options!./map.vue?vue&type=style&index=0&id=85ca06a4&lang=css& */ "./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=85ca06a4&lang=css&"
          );

        var options = {};

        options.insert = "head";
        options.singleton = false;

        var update =
          _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(
            _laravel_mix_node_modules_css_loader_dist_cjs_js_clonedRuleSet_9_use_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_dist_cjs_js_clonedRuleSet_9_use_2_vue_loader_lib_index_js_vue_loader_options_map_vue_vue_type_style_index_0_id_85ca06a4_lang_css___WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ],
            options
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _laravel_mix_node_modules_css_loader_dist_cjs_js_clonedRuleSet_9_use_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_dist_cjs_js_clonedRuleSet_9_use_2_vue_loader_lib_index_js_vue_loader_options_map_vue_vue_type_style_index_0_id_85ca06a4_lang_css___WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ].locals || {};

        /***/
      },

    /***/ "./node_modules/style-loader/dist/cjs.js!./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css&":
      /*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/style-loader/dist/cjs.js!./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css& ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! !../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js"
          );
        /* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default =
          /*#__PURE__*/ __webpack_require__.n(
            _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__
          );
        /* harmony import */ var _laravel_mix_node_modules_css_loader_dist_cjs_js_clonedRuleSet_9_use_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_dist_cjs_js_clonedRuleSet_9_use_2_vue_loader_lib_index_js_vue_loader_options_streetViewPanorama_vue_vue_type_style_index_0_id_ed35740a_lang_css___WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! !!../../../laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!../../../vue-loader/lib/loaders/stylePostLoader.js!../../../postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!../../../vue-loader/lib/index.js??vue-loader-options!./streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css& */ "./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css&"
          );

        var options = {};

        options.insert = "head";
        options.singleton = false;

        var update =
          _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(
            _laravel_mix_node_modules_css_loader_dist_cjs_js_clonedRuleSet_9_use_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_dist_cjs_js_clonedRuleSet_9_use_2_vue_loader_lib_index_js_vue_loader_options_streetViewPanorama_vue_vue_type_style_index_0_id_ed35740a_lang_css___WEBPACK_IMPORTED_MODULE_1__[
              "default"
            ],
            options
          );

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _laravel_mix_node_modules_css_loader_dist_cjs_js_clonedRuleSet_9_use_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_dist_cjs_js_clonedRuleSet_9_use_2_vue_loader_lib_index_js_vue_loader_options_streetViewPanorama_vue_vue_type_style_index_0_id_ed35740a_lang_css___WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ].locals || {};

        /***/
      },

    /***/ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
      /*!****************************************************************************!*\
  !*** ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js ***!
  \****************************************************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        "use strict";

        var isOldIE = (function isOldIE() {
          var memo;
          return function memorize() {
            if (typeof memo === "undefined") {
              // Test for IE <= 9 as proposed by Browserhacks
              // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
              // Tests for existence of standard globals is to allow style-loader
              // to operate correctly into non-standard environments
              // @see https://github.com/webpack-contrib/style-loader/issues/177
              memo = Boolean(
                window && document && document.all && !window.atob
              );
            }

            return memo;
          };
        })();

        var getTarget = (function getTarget() {
          var memo = {};
          return function memorize(target) {
            if (typeof memo[target] === "undefined") {
              var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

              if (
                window.HTMLIFrameElement &&
                styleTarget instanceof window.HTMLIFrameElement
              ) {
                try {
                  // This will throw an exception if access to iframe is blocked
                  // due to cross-origin restrictions
                  styleTarget = styleTarget.contentDocument.head;
                } catch (e) {
                  // istanbul ignore next
                  styleTarget = null;
                }
              }

              memo[target] = styleTarget;
            }

            return memo[target];
          };
        })();

        var stylesInDom = [];

        function getIndexByIdentifier(identifier) {
          var result = -1;

          for (var i = 0; i < stylesInDom.length; i++) {
            if (stylesInDom[i].identifier === identifier) {
              result = i;
              break;
            }
          }

          return result;
        }

        function modulesToDom(list, options) {
          var idCountMap = {};
          var identifiers = [];

          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            var id = options.base ? item[0] + options.base : item[0];
            var count = idCountMap[id] || 0;
            var identifier = "".concat(id, " ").concat(count);
            idCountMap[id] = count + 1;
            var index = getIndexByIdentifier(identifier);
            var obj = {
              css: item[1],
              media: item[2],
              sourceMap: item[3],
            };

            if (index !== -1) {
              stylesInDom[index].references++;
              stylesInDom[index].updater(obj);
            } else {
              stylesInDom.push({
                identifier: identifier,
                updater: addStyle(obj, options),
                references: 1,
              });
            }

            identifiers.push(identifier);
          }

          return identifiers;
        }

        function insertStyleElement(options) {
          var style = document.createElement("style");
          var attributes = options.attributes || {};

          if (typeof attributes.nonce === "undefined") {
            var nonce = true ? __webpack_require__.nc : 0;

            if (nonce) {
              attributes.nonce = nonce;
            }
          }

          Object.keys(attributes).forEach(function (key) {
            style.setAttribute(key, attributes[key]);
          });

          if (typeof options.insert === "function") {
            options.insert(style);
          } else {
            var target = getTarget(options.insert || "head");

            if (!target) {
              throw new Error(
                "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
              );
            }

            target.appendChild(style);
          }

          return style;
        }

        function removeStyleElement(style) {
          // istanbul ignore if
          if (style.parentNode === null) {
            return false;
          }

          style.parentNode.removeChild(style);
        }
        /* istanbul ignore next  */

        var replaceText = (function replaceText() {
          var textStore = [];
          return function replace(index, replacement) {
            textStore[index] = replacement;
            return textStore.filter(Boolean).join("\n");
          };
        })();

        function applyToSingletonTag(style, index, remove, obj) {
          var css = remove
            ? ""
            : obj.media
            ? "@media ".concat(obj.media, " {").concat(obj.css, "}")
            : obj.css; // For old IE

          /* istanbul ignore if  */

          if (style.styleSheet) {
            style.styleSheet.cssText = replaceText(index, css);
          } else {
            var cssNode = document.createTextNode(css);
            var childNodes = style.childNodes;

            if (childNodes[index]) {
              style.removeChild(childNodes[index]);
            }

            if (childNodes.length) {
              style.insertBefore(cssNode, childNodes[index]);
            } else {
              style.appendChild(cssNode);
            }
          }
        }

        function applyToTag(style, options, obj) {
          var css = obj.css;
          var media = obj.media;
          var sourceMap = obj.sourceMap;

          if (media) {
            style.setAttribute("media", media);
          } else {
            style.removeAttribute("media");
          }

          if (sourceMap && typeof btoa !== "undefined") {
            css +=
              "\n/*# sourceMappingURL=data:application/json;base64,".concat(
                btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))),
                " */"
              );
          } // For old IE

          /* istanbul ignore if  */

          if (style.styleSheet) {
            style.styleSheet.cssText = css;
          } else {
            while (style.firstChild) {
              style.removeChild(style.firstChild);
            }

            style.appendChild(document.createTextNode(css));
          }
        }

        var singleton = null;
        var singletonCounter = 0;

        function addStyle(obj, options) {
          var style;
          var update;
          var remove;

          if (options.singleton) {
            var styleIndex = singletonCounter++;
            style = singleton || (singleton = insertStyleElement(options));
            update = applyToSingletonTag.bind(null, style, styleIndex, false);
            remove = applyToSingletonTag.bind(null, style, styleIndex, true);
          } else {
            style = insertStyleElement(options);
            update = applyToTag.bind(null, style, options);

            remove = function remove() {
              removeStyleElement(style);
            };
          }

          update(obj);
          return function updateStyle(newObj) {
            if (newObj) {
              if (
                newObj.css === obj.css &&
                newObj.media === obj.media &&
                newObj.sourceMap === obj.sourceMap
              ) {
                return;
              }

              update((obj = newObj));
            } else {
              remove();
            }
          };
        }

        module.exports = function (list, options) {
          options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
          // tags it will allow on a page

          if (!options.singleton && typeof options.singleton !== "boolean") {
            options.singleton = isOldIE();
          }

          list = list || [];
          var lastIdentifiers = modulesToDom(list, options);
          return function update(newList) {
            newList = newList || [];

            if (Object.prototype.toString.call(newList) !== "[object Array]") {
              return;
            }

            for (var i = 0; i < lastIdentifiers.length; i++) {
              var identifier = lastIdentifiers[i];
              var index = getIndexByIdentifier(identifier);
              stylesInDom[index].references--;
            }

            var newLastIdentifiers = modulesToDom(newList, options);

            for (var _i = 0; _i < lastIdentifiers.length; _i++) {
              var _identifier = lastIdentifiers[_i];

              var _index = getIndexByIdentifier(_identifier);

              if (stylesInDom[_index].references === 0) {
                stylesInDom[_index].updater();

                stylesInDom.splice(_index, 1);
              }
            }

            lastIdentifiers = newLastIdentifiers;
          };
        };

        /***/
      },

    /***/ "./node_modules/tippy.js/dist/tippy.esm.js":
      /*!*************************************************!*\
  !*** ./node_modules/tippy.js/dist/tippy.esm.js ***!
  \*************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ animateFill: () => /* binding */ animateFill,
          /* harmony export */ createSingleton: () =>
            /* binding */ createSingleton,
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */ delegate: () => /* binding */ delegate,
          /* harmony export */ followCursor: () => /* binding */ followCursor,
          /* harmony export */ hideAll: () => /* binding */ hideAll,
          /* harmony export */ inlinePositioning: () =>
            /* binding */ inlinePositioning,
          /* harmony export */ roundArrow: () => /* binding */ ROUND_ARROW,
          /* harmony export */ sticky: () => /* binding */ sticky,
          /* harmony export */
        });
        /* harmony import */ var _popperjs_core__WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! @popperjs/core */ "./node_modules/@popperjs/core/lib/popper.js"
          );
        /* harmony import */ var _popperjs_core__WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! @popperjs/core */ "./node_modules/@popperjs/core/lib/modifiers/applyStyles.js"
          );
        /**!
         * tippy.js v6.3.7
         * (c) 2017-2021 atomiks
         * MIT License
         */

        var ROUND_ARROW =
          '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
        var BOX_CLASS = "tippy-box";
        var CONTENT_CLASS = "tippy-content";
        var BACKDROP_CLASS = "tippy-backdrop";
        var ARROW_CLASS = "tippy-arrow";
        var SVG_ARROW_CLASS = "tippy-svg-arrow";
        var TOUCH_OPTIONS = {
          passive: true,
          capture: true,
        };
        var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
          return document.body;
        };

        function hasOwnProperty(obj, key) {
          return {}.hasOwnProperty.call(obj, key);
        }
        function getValueAtIndexOrReturn(value, index, defaultValue) {
          if (Array.isArray(value)) {
            var v = value[index];
            return v == null
              ? Array.isArray(defaultValue)
                ? defaultValue[index]
                : defaultValue
              : v;
          }

          return value;
        }
        function isType(value, type) {
          var str = {}.toString.call(value);
          return str.indexOf("[object") === 0 && str.indexOf(type + "]") > -1;
        }
        function invokeWithArgsOrReturn(value, args) {
          return typeof value === "function"
            ? value.apply(void 0, args)
            : value;
        }
        function debounce(fn, ms) {
          // Avoid wrapping in `setTimeout` if ms is 0 anyway
          if (ms === 0) {
            return fn;
          }

          var timeout;
          return function (arg) {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
              fn(arg);
            }, ms);
          };
        }
        function removeProperties(obj, keys) {
          var clone = Object.assign({}, obj);
          keys.forEach(function (key) {
            delete clone[key];
          });
          return clone;
        }
        function splitBySpaces(value) {
          return value.split(/\s+/).filter(Boolean);
        }
        function normalizeToArray(value) {
          return [].concat(value);
        }
        function pushIfUnique(arr, value) {
          if (arr.indexOf(value) === -1) {
            arr.push(value);
          }
        }
        function unique(arr) {
          return arr.filter(function (item, index) {
            return arr.indexOf(item) === index;
          });
        }
        function getBasePlacement(placement) {
          return placement.split("-")[0];
        }
        function arrayFrom(value) {
          return [].slice.call(value);
        }
        function removeUndefinedProps(obj) {
          return Object.keys(obj).reduce(function (acc, key) {
            if (obj[key] !== undefined) {
              acc[key] = obj[key];
            }

            return acc;
          }, {});
        }

        function div() {
          return document.createElement("div");
        }
        function isElement(value) {
          return ["Element", "Fragment"].some(function (type) {
            return isType(value, type);
          });
        }
        function isNodeList(value) {
          return isType(value, "NodeList");
        }
        function isMouseEvent(value) {
          return isType(value, "MouseEvent");
        }
        function isReferenceElement(value) {
          return !!(value && value._tippy && value._tippy.reference === value);
        }
        function getArrayOfElements(value) {
          if (isElement(value)) {
            return [value];
          }

          if (isNodeList(value)) {
            return arrayFrom(value);
          }

          if (Array.isArray(value)) {
            return value;
          }

          return arrayFrom(document.querySelectorAll(value));
        }
        function setTransitionDuration(els, value) {
          els.forEach(function (el) {
            if (el) {
              el.style.transitionDuration = value + "ms";
            }
          });
        }
        function setVisibilityState(els, state) {
          els.forEach(function (el) {
            if (el) {
              el.setAttribute("data-state", state);
            }
          });
        }
        function getOwnerDocument(elementOrElements) {
          var _element$ownerDocumen;

          var _normalizeToArray = normalizeToArray(elementOrElements),
            element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body

          return element != null &&
            (_element$ownerDocumen = element.ownerDocument) != null &&
            _element$ownerDocumen.body
            ? element.ownerDocument
            : document;
        }
        function isCursorOutsideInteractiveBorder(popperTreeData, event) {
          var clientX = event.clientX,
            clientY = event.clientY;
          return popperTreeData.every(function (_ref) {
            var popperRect = _ref.popperRect,
              popperState = _ref.popperState,
              props = _ref.props;
            var interactiveBorder = props.interactiveBorder;
            var basePlacement = getBasePlacement(popperState.placement);
            var offsetData = popperState.modifiersData.offset;

            if (!offsetData) {
              return true;
            }

            var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
            var bottomDistance =
              basePlacement === "top" ? offsetData.bottom.y : 0;
            var leftDistance =
              basePlacement === "right" ? offsetData.left.x : 0;
            var rightDistance =
              basePlacement === "left" ? offsetData.right.x : 0;
            var exceedsTop =
              popperRect.top - clientY + topDistance > interactiveBorder;
            var exceedsBottom =
              clientY - popperRect.bottom - bottomDistance > interactiveBorder;
            var exceedsLeft =
              popperRect.left - clientX + leftDistance > interactiveBorder;
            var exceedsRight =
              clientX - popperRect.right - rightDistance > interactiveBorder;
            return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
          });
        }
        function updateTransitionEndListener(box, action, listener) {
          var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
          // `webkitTransitionEnd`...

          ["transitionend", "webkitTransitionEnd"].forEach(function (event) {
            box[method](event, listener);
          });
        }
        /**
         * Compared to xxx.contains, this function works for dom structures with shadow
         * dom
         */

        function actualContains(parent, child) {
          var target = child;

          while (target) {
            var _target$getRootNode;

            if (parent.contains(target)) {
              return true;
            }

            target =
              target.getRootNode == null
                ? void 0
                : (_target$getRootNode = target.getRootNode()) == null
                ? void 0
                : _target$getRootNode.host;
          }

          return false;
        }

        var currentInput = {
          isTouch: false,
        };
        var lastMouseMoveTime = 0;
        /**
         * When a `touchstart` event is fired, it's assumed the user is using touch
         * input. We'll bind a `mousemove` event listener to listen for mouse input in
         * the future. This way, the `isTouch` property is fully dynamic and will handle
         * hybrid devices that use a mix of touch + mouse input.
         */

        function onDocumentTouchStart() {
          if (currentInput.isTouch) {
            return;
          }

          currentInput.isTouch = true;

          if (window.performance) {
            document.addEventListener("mousemove", onDocumentMouseMove);
          }
        }
        /**
         * When two `mousemove` event are fired consecutively within 20ms, it's assumed
         * the user is using mouse input again. `mousemove` can fire on touch devices as
         * well, but very rarely that quickly.
         */

        function onDocumentMouseMove() {
          var now = performance.now();

          if (now - lastMouseMoveTime < 20) {
            currentInput.isTouch = false;
            document.removeEventListener("mousemove", onDocumentMouseMove);
          }

          lastMouseMoveTime = now;
        }
        /**
         * When an element is in focus and has a tippy, leaving the tab/window and
         * returning causes it to show again. For mouse users this is unexpected, but
         * for keyboard use it makes sense.
         * TODO: find a better technique to solve this problem
         */

        function onWindowBlur() {
          var activeElement = document.activeElement;

          if (isReferenceElement(activeElement)) {
            var instance = activeElement._tippy;

            if (activeElement.blur && !instance.state.isVisible) {
              activeElement.blur();
            }
          }
        }
        function bindGlobalEventListeners() {
          document.addEventListener(
            "touchstart",
            onDocumentTouchStart,
            TOUCH_OPTIONS
          );
          window.addEventListener("blur", onWindowBlur);
        }

        var isBrowser =
          typeof window !== "undefined" && typeof document !== "undefined";
        var isIE11 = isBrowser // @ts-ignore
          ? !!window.msCrypto
          : false;

        function createMemoryLeakWarning(method) {
          var txt = method === "destroy" ? "n already-" : " ";
          return [
            method +
              "() was called on a" +
              txt +
              "destroyed instance. This is a no-op but",
            "indicates a potential memory leak.",
          ].join(" ");
        }
        function clean(value) {
          var spacesAndTabs = /[ \t]{2,}/g;
          var lineStartWithSpaces = /^[ \t]*/gm;
          return value
            .replace(spacesAndTabs, " ")
            .replace(lineStartWithSpaces, "")
            .trim();
        }

        function getDevMessage(message) {
          return clean(
            "\n  %ctippy.js\n\n  %c" +
              clean(message) +
              "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  "
          );
        }

        function getFormattedMessage(message) {
          return [
            getDevMessage(message), // title
            "color: #00C584; font-size: 1.3em; font-weight: bold;", // message
            "line-height: 1.5", // footer
            "color: #a6a095;",
          ];
        } // Assume warnings and errors never have the same message

        var visitedMessages;

        if (true) {
          resetVisitedMessages();
        }

        function resetVisitedMessages() {
          visitedMessages = new Set();
        }
        function warnWhen(condition, message) {
          if (condition && !visitedMessages.has(message)) {
            var _console;

            visitedMessages.add(message);

            (_console = console).warn.apply(
              _console,
              getFormattedMessage(message)
            );
          }
        }
        function errorWhen(condition, message) {
          if (condition && !visitedMessages.has(message)) {
            var _console2;

            visitedMessages.add(message);

            (_console2 = console).error.apply(
              _console2,
              getFormattedMessage(message)
            );
          }
        }
        function validateTargets(targets) {
          var didPassFalsyValue = !targets;
          var didPassPlainObject =
            Object.prototype.toString.call(targets) === "[object Object]" &&
            !targets.addEventListener;
          errorWhen(
            didPassFalsyValue,
            [
              "tippy() was passed",
              "`" + String(targets) + "`",
              "as its targets (first) argument. Valid types are: String, Element,",
              "Element[], or NodeList.",
            ].join(" ")
          );
          errorWhen(
            didPassPlainObject,
            [
              "tippy() was passed a plain object which is not supported as an argument",
              "for virtual positioning. Use props.getReferenceClientRect instead.",
            ].join(" ")
          );
        }

        var pluginProps = {
          animateFill: false,
          followCursor: false,
          inlinePositioning: false,
          sticky: false,
        };
        var renderProps = {
          allowHTML: false,
          animation: "fade",
          arrow: true,
          content: "",
          inertia: false,
          maxWidth: 350,
          role: "tooltip",
          theme: "",
          zIndex: 9999,
        };
        var defaultProps = Object.assign(
          {
            appendTo: TIPPY_DEFAULT_APPEND_TO,
            aria: {
              content: "auto",
              expanded: "auto",
            },
            delay: 0,
            duration: [300, 250],
            getReferenceClientRect: null,
            hideOnClick: true,
            ignoreAttributes: false,
            interactive: false,
            interactiveBorder: 2,
            interactiveDebounce: 0,
            moveTransition: "",
            offset: [0, 10],
            onAfterUpdate: function onAfterUpdate() {},
            onBeforeUpdate: function onBeforeUpdate() {},
            onCreate: function onCreate() {},
            onDestroy: function onDestroy() {},
            onHidden: function onHidden() {},
            onHide: function onHide() {},
            onMount: function onMount() {},
            onShow: function onShow() {},
            onShown: function onShown() {},
            onTrigger: function onTrigger() {},
            onUntrigger: function onUntrigger() {},
            onClickOutside: function onClickOutside() {},
            placement: "top",
            plugins: [],
            popperOptions: {},
            render: null,
            showOnCreate: false,
            touch: true,
            trigger: "mouseenter focus",
            triggerTarget: null,
          },
          pluginProps,
          renderProps
        );
        var defaultKeys = Object.keys(defaultProps);
        var setDefaultProps = function setDefaultProps(partialProps) {
          /* istanbul ignore else */
          if (true) {
            validateProps(partialProps, []);
          }

          var keys = Object.keys(partialProps);
          keys.forEach(function (key) {
            defaultProps[key] = partialProps[key];
          });
        };
        function getExtendedPassedProps(passedProps) {
          var plugins = passedProps.plugins || [];
          var pluginProps = plugins.reduce(function (acc, plugin) {
            var name = plugin.name,
              defaultValue = plugin.defaultValue;

            if (name) {
              var _name;

              acc[name] =
                passedProps[name] !== undefined
                  ? passedProps[name]
                  : (_name = defaultProps[name]) != null
                  ? _name
                  : defaultValue;
            }

            return acc;
          }, {});
          return Object.assign({}, passedProps, pluginProps);
        }
        function getDataAttributeProps(reference, plugins) {
          var propKeys = plugins
            ? Object.keys(
                getExtendedPassedProps(
                  Object.assign({}, defaultProps, {
                    plugins: plugins,
                  })
                )
              )
            : defaultKeys;
          var props = propKeys.reduce(function (acc, key) {
            var valueAsString = (
              reference.getAttribute("data-tippy-" + key) || ""
            ).trim();

            if (!valueAsString) {
              return acc;
            }

            if (key === "content") {
              acc[key] = valueAsString;
            } else {
              try {
                acc[key] = JSON.parse(valueAsString);
              } catch (e) {
                acc[key] = valueAsString;
              }
            }

            return acc;
          }, {});
          return props;
        }
        function evaluateProps(reference, props) {
          var out = Object.assign(
            {},
            props,
            {
              content: invokeWithArgsOrReturn(props.content, [reference]),
            },
            props.ignoreAttributes
              ? {}
              : getDataAttributeProps(reference, props.plugins)
          );
          out.aria = Object.assign({}, defaultProps.aria, out.aria);
          out.aria = {
            expanded:
              out.aria.expanded === "auto"
                ? props.interactive
                : out.aria.expanded,
            content:
              out.aria.content === "auto"
                ? props.interactive
                  ? null
                  : "describedby"
                : out.aria.content,
          };
          return out;
        }
        function validateProps(partialProps, plugins) {
          if (partialProps === void 0) {
            partialProps = {};
          }

          if (plugins === void 0) {
            plugins = [];
          }

          var keys = Object.keys(partialProps);
          keys.forEach(function (prop) {
            var nonPluginProps = removeProperties(
              defaultProps,
              Object.keys(pluginProps)
            );
            var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

            if (didPassUnknownProp) {
              didPassUnknownProp =
                plugins.filter(function (plugin) {
                  return plugin.name === prop;
                }).length === 0;
            }

            warnWhen(
              didPassUnknownProp,
              [
                "`" + prop + "`",
                "is not a valid prop. You may have spelled it incorrectly, or if it's",
                "a plugin, forgot to pass it in an array as props.plugins.",
                "\n\n",
                "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n",
                "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/",
              ].join(" ")
            );
          });
        }

        var innerHTML = function innerHTML() {
          return "innerHTML";
        };

        function dangerouslySetInnerHTML(element, html) {
          element[innerHTML()] = html;
        }

        function createArrowElement(value) {
          var arrow = div();

          if (value === true) {
            arrow.className = ARROW_CLASS;
          } else {
            arrow.className = SVG_ARROW_CLASS;

            if (isElement(value)) {
              arrow.appendChild(value);
            } else {
              dangerouslySetInnerHTML(arrow, value);
            }
          }

          return arrow;
        }

        function setContent(content, props) {
          if (isElement(props.content)) {
            dangerouslySetInnerHTML(content, "");
            content.appendChild(props.content);
          } else if (typeof props.content !== "function") {
            if (props.allowHTML) {
              dangerouslySetInnerHTML(content, props.content);
            } else {
              content.textContent = props.content;
            }
          }
        }
        function getChildren(popper) {
          var box = popper.firstElementChild;
          var boxChildren = arrayFrom(box.children);
          return {
            box: box,
            content: boxChildren.find(function (node) {
              return node.classList.contains(CONTENT_CLASS);
            }),
            arrow: boxChildren.find(function (node) {
              return (
                node.classList.contains(ARROW_CLASS) ||
                node.classList.contains(SVG_ARROW_CLASS)
              );
            }),
            backdrop: boxChildren.find(function (node) {
              return node.classList.contains(BACKDROP_CLASS);
            }),
          };
        }
        function render(instance) {
          var popper = div();
          var box = div();
          box.className = BOX_CLASS;
          box.setAttribute("data-state", "hidden");
          box.setAttribute("tabindex", "-1");
          var content = div();
          content.className = CONTENT_CLASS;
          content.setAttribute("data-state", "hidden");
          setContent(content, instance.props);
          popper.appendChild(box);
          box.appendChild(content);
          onUpdate(instance.props, instance.props);

          function onUpdate(prevProps, nextProps) {
            var _getChildren = getChildren(popper),
              box = _getChildren.box,
              content = _getChildren.content,
              arrow = _getChildren.arrow;

            if (nextProps.theme) {
              box.setAttribute("data-theme", nextProps.theme);
            } else {
              box.removeAttribute("data-theme");
            }

            if (typeof nextProps.animation === "string") {
              box.setAttribute("data-animation", nextProps.animation);
            } else {
              box.removeAttribute("data-animation");
            }

            if (nextProps.inertia) {
              box.setAttribute("data-inertia", "");
            } else {
              box.removeAttribute("data-inertia");
            }

            box.style.maxWidth =
              typeof nextProps.maxWidth === "number"
                ? nextProps.maxWidth + "px"
                : nextProps.maxWidth;

            if (nextProps.role) {
              box.setAttribute("role", nextProps.role);
            } else {
              box.removeAttribute("role");
            }

            if (
              prevProps.content !== nextProps.content ||
              prevProps.allowHTML !== nextProps.allowHTML
            ) {
              setContent(content, instance.props);
            }

            if (nextProps.arrow) {
              if (!arrow) {
                box.appendChild(createArrowElement(nextProps.arrow));
              } else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild(createArrowElement(nextProps.arrow));
              }
            } else if (arrow) {
              box.removeChild(arrow);
            }
          }

          return {
            popper: popper,
            onUpdate: onUpdate,
          };
        } // Runtime check to identify if the render function is the default one; this
        // way we can apply default CSS transitions logic and it can be tree-shaken away

        render.$$tippy = true;

        var idCounter = 1;
        var mouseMoveListeners = []; // Used by `hideAll()`

        var mountedInstances = [];
        function createTippy(reference, passedProps) {
          var props = evaluateProps(
            reference,
            Object.assign(
              {},
              defaultProps,
              getExtendedPassedProps(removeUndefinedProps(passedProps))
            )
          ); // ===========================================================================
          // 🔒 Private members
          // ===========================================================================

          var showTimeout;
          var hideTimeout;
          var scheduleHideAnimationFrame;
          var isVisibleFromClick = false;
          var didHideDueToDocumentMouseDown = false;
          var didTouchMove = false;
          var ignoreOnFirstUpdate = false;
          var lastTriggerEvent;
          var currentTransitionEndListener;
          var onFirstUpdate;
          var listeners = [];
          var debouncedOnMouseMove = debounce(
            onMouseMove,
            props.interactiveDebounce
          );
          var currentTarget; // ===========================================================================
          // 🔑 Public members
          // ===========================================================================

          var id = idCounter++;
          var popperInstance = null;
          var plugins = unique(props.plugins);
          var state = {
            // Is the instance currently enabled?
            isEnabled: true,
            // Is the tippy currently showing and not transitioning out?
            isVisible: false,
            // Has the instance been destroyed?
            isDestroyed: false,
            // Is the tippy currently mounted to the DOM?
            isMounted: false,
            // Has the tippy finished transitioning in?
            isShown: false,
          };
          var instance = {
            // properties
            id: id,
            reference: reference,
            popper: div(),
            popperInstance: popperInstance,
            props: props,
            state: state,
            plugins: plugins,
            // methods
            clearDelayTimeouts: clearDelayTimeouts,
            setProps: setProps,
            setContent: setContent,
            show: show,
            hide: hide,
            hideWithInteractivity: hideWithInteractivity,
            enable: enable,
            disable: disable,
            unmount: unmount,
            destroy: destroy,
          }; // TODO: Investigate why this early return causes a TDZ error in the tests —
          // it doesn't seem to happen in the browser

          /* istanbul ignore if */

          if (!props.render) {
            if (true) {
              errorWhen(true, "render() function has not been supplied.");
            }

            return instance;
          } // ===========================================================================
          // Initial mutations
          // ===========================================================================

          var _props$render = props.render(instance),
            popper = _props$render.popper,
            onUpdate = _props$render.onUpdate;

          popper.setAttribute("data-tippy-root", "");
          popper.id = "tippy-" + instance.id;
          instance.popper = popper;
          reference._tippy = instance;
          popper._tippy = instance;
          var pluginsHooks = plugins.map(function (plugin) {
            return plugin.fn(instance);
          });
          var hasAriaExpanded = reference.hasAttribute("aria-expanded");
          addListeners();
          handleAriaExpandedAttribute();
          handleStyles();
          invokeHook("onCreate", [instance]);

          if (props.showOnCreate) {
            scheduleShow();
          } // Prevent a tippy with a delay from hiding if the cursor left then returned
          // before it started hiding

          popper.addEventListener("mouseenter", function () {
            if (instance.props.interactive && instance.state.isVisible) {
              instance.clearDelayTimeouts();
            }
          });
          popper.addEventListener("mouseleave", function () {
            if (
              instance.props.interactive &&
              instance.props.trigger.indexOf("mouseenter") >= 0
            ) {
              getDocument().addEventListener("mousemove", debouncedOnMouseMove);
            }
          });
          return instance; // ===========================================================================
          // 🔒 Private methods
          // ===========================================================================

          function getNormalizedTouchSettings() {
            var touch = instance.props.touch;
            return Array.isArray(touch) ? touch : [touch, 0];
          }

          function getIsCustomTouchBehavior() {
            return getNormalizedTouchSettings()[0] === "hold";
          }

          function getIsDefaultRenderFn() {
            var _instance$props$rende;

            // @ts-ignore
            return !!(
              (_instance$props$rende = instance.props.render) != null &&
              _instance$props$rende.$$tippy
            );
          }

          function getCurrentTarget() {
            return currentTarget || reference;
          }

          function getDocument() {
            var parent = getCurrentTarget().parentNode;
            return parent ? getOwnerDocument(parent) : document;
          }

          function getDefaultTemplateChildren() {
            return getChildren(popper);
          }

          function getDelay(isShow) {
            // For touch or keyboard input, force `0` delay for UX reasons
            // Also if the instance is mounted but not visible (transitioning out),
            // ignore delay
            if (
              (instance.state.isMounted && !instance.state.isVisible) ||
              currentInput.isTouch ||
              (lastTriggerEvent && lastTriggerEvent.type === "focus")
            ) {
              return 0;
            }

            return getValueAtIndexOrReturn(
              instance.props.delay,
              isShow ? 0 : 1,
              defaultProps.delay
            );
          }

          function handleStyles(fromHide) {
            if (fromHide === void 0) {
              fromHide = false;
            }

            popper.style.pointerEvents =
              instance.props.interactive && !fromHide ? "" : "none";
            popper.style.zIndex = "" + instance.props.zIndex;
          }

          function invokeHook(hook, args, shouldInvokePropsHook) {
            if (shouldInvokePropsHook === void 0) {
              shouldInvokePropsHook = true;
            }

            pluginsHooks.forEach(function (pluginHooks) {
              if (pluginHooks[hook]) {
                pluginHooks[hook].apply(pluginHooks, args);
              }
            });

            if (shouldInvokePropsHook) {
              var _instance$props;

              (_instance$props = instance.props)[hook].apply(
                _instance$props,
                args
              );
            }
          }

          function handleAriaContentAttribute() {
            var aria = instance.props.aria;

            if (!aria.content) {
              return;
            }

            var attr = "aria-" + aria.content;
            var id = popper.id;
            var nodes = normalizeToArray(
              instance.props.triggerTarget || reference
            );
            nodes.forEach(function (node) {
              var currentValue = node.getAttribute(attr);

              if (instance.state.isVisible) {
                node.setAttribute(
                  attr,
                  currentValue ? currentValue + " " + id : id
                );
              } else {
                var nextValue =
                  currentValue && currentValue.replace(id, "").trim();

                if (nextValue) {
                  node.setAttribute(attr, nextValue);
                } else {
                  node.removeAttribute(attr);
                }
              }
            });
          }

          function handleAriaExpandedAttribute() {
            if (hasAriaExpanded || !instance.props.aria.expanded) {
              return;
            }

            var nodes = normalizeToArray(
              instance.props.triggerTarget || reference
            );
            nodes.forEach(function (node) {
              if (instance.props.interactive) {
                node.setAttribute(
                  "aria-expanded",
                  instance.state.isVisible && node === getCurrentTarget()
                    ? "true"
                    : "false"
                );
              } else {
                node.removeAttribute("aria-expanded");
              }
            });
          }

          function cleanupInteractiveMouseListeners() {
            getDocument().removeEventListener(
              "mousemove",
              debouncedOnMouseMove
            );
            mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
              return listener !== debouncedOnMouseMove;
            });
          }

          function onDocumentPress(event) {
            // Moved finger to scroll instead of an intentional tap outside
            if (currentInput.isTouch) {
              if (didTouchMove || event.type === "mousedown") {
                return;
              }
            }

            var actualTarget =
              (event.composedPath && event.composedPath()[0]) || event.target; // Clicked on interactive popper

            if (
              instance.props.interactive &&
              actualContains(popper, actualTarget)
            ) {
              return;
            } // Clicked on the event listeners target

            if (
              normalizeToArray(instance.props.triggerTarget || reference).some(
                function (el) {
                  return actualContains(el, actualTarget);
                }
              )
            ) {
              if (currentInput.isTouch) {
                return;
              }

              if (
                instance.state.isVisible &&
                instance.props.trigger.indexOf("click") >= 0
              ) {
                return;
              }
            } else {
              invokeHook("onClickOutside", [instance, event]);
            }

            if (instance.props.hideOnClick === true) {
              instance.clearDelayTimeouts();
              instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
              // currentTarget. This lets a tippy with `focus` trigger know that it
              // should not show

              didHideDueToDocumentMouseDown = true;
              setTimeout(function () {
                didHideDueToDocumentMouseDown = false;
              }); // The listener gets added in `scheduleShow()`, but this may be hiding it
              // before it shows, and hide()'s early bail-out behavior can prevent it
              // from being cleaned up

              if (!instance.state.isMounted) {
                removeDocumentPress();
              }
            }
          }

          function onTouchMove() {
            didTouchMove = true;
          }

          function onTouchStart() {
            didTouchMove = false;
          }

          function addDocumentPress() {
            var doc = getDocument();
            doc.addEventListener("mousedown", onDocumentPress, true);
            doc.addEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
            doc.addEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
            doc.addEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
          }

          function removeDocumentPress() {
            var doc = getDocument();
            doc.removeEventListener("mousedown", onDocumentPress, true);
            doc.removeEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
            doc.removeEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
            doc.removeEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
          }

          function onTransitionedOut(duration, callback) {
            onTransitionEnd(duration, function () {
              if (
                !instance.state.isVisible &&
                popper.parentNode &&
                popper.parentNode.contains(popper)
              ) {
                callback();
              }
            });
          }

          function onTransitionedIn(duration, callback) {
            onTransitionEnd(duration, callback);
          }

          function onTransitionEnd(duration, callback) {
            var box = getDefaultTemplateChildren().box;

            function listener(event) {
              if (event.target === box) {
                updateTransitionEndListener(box, "remove", listener);
                callback();
              }
            } // Make callback synchronous if duration is 0
            // `transitionend` won't fire otherwise

            if (duration === 0) {
              return callback();
            }

            updateTransitionEndListener(
              box,
              "remove",
              currentTransitionEndListener
            );
            updateTransitionEndListener(box, "add", listener);
            currentTransitionEndListener = listener;
          }

          function on(eventType, handler, options) {
            if (options === void 0) {
              options = false;
            }

            var nodes = normalizeToArray(
              instance.props.triggerTarget || reference
            );
            nodes.forEach(function (node) {
              node.addEventListener(eventType, handler, options);
              listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options,
              });
            });
          }

          function addListeners() {
            if (getIsCustomTouchBehavior()) {
              on("touchstart", onTrigger, {
                passive: true,
              });
              on("touchend", onMouseLeave, {
                passive: true,
              });
            }

            splitBySpaces(instance.props.trigger).forEach(function (eventType) {
              if (eventType === "manual") {
                return;
              }

              on(eventType, onTrigger);

              switch (eventType) {
                case "mouseenter":
                  on("mouseleave", onMouseLeave);
                  break;

                case "focus":
                  on(isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
                  break;

                case "focusin":
                  on("focusout", onBlurOrFocusOut);
                  break;
              }
            });
          }

          function removeListeners() {
            listeners.forEach(function (_ref) {
              var node = _ref.node,
                eventType = _ref.eventType,
                handler = _ref.handler,
                options = _ref.options;
              node.removeEventListener(eventType, handler, options);
            });
            listeners = [];
          }

          function onTrigger(event) {
            var _lastTriggerEvent;

            var shouldScheduleClickHide = false;

            if (
              !instance.state.isEnabled ||
              isEventListenerStopped(event) ||
              didHideDueToDocumentMouseDown
            ) {
              return;
            }

            var wasFocused =
              ((_lastTriggerEvent = lastTriggerEvent) == null
                ? void 0
                : _lastTriggerEvent.type) === "focus";
            lastTriggerEvent = event;
            currentTarget = event.currentTarget;
            handleAriaExpandedAttribute();

            if (!instance.state.isVisible && isMouseEvent(event)) {
              // If scrolling, `mouseenter` events can be fired if the cursor lands
              // over a new target, but `mousemove` events don't get fired. This
              // causes interactive tooltips to get stuck open until the cursor is
              // moved
              mouseMoveListeners.forEach(function (listener) {
                return listener(event);
              });
            } // Toggle show/hide when clicking click-triggered tooltips

            if (
              event.type === "click" &&
              (instance.props.trigger.indexOf("mouseenter") < 0 ||
                isVisibleFromClick) &&
              instance.props.hideOnClick !== false &&
              instance.state.isVisible
            ) {
              shouldScheduleClickHide = true;
            } else {
              scheduleShow(event);
            }

            if (event.type === "click") {
              isVisibleFromClick = !shouldScheduleClickHide;
            }

            if (shouldScheduleClickHide && !wasFocused) {
              scheduleHide(event);
            }
          }

          function onMouseMove(event) {
            var target = event.target;
            var isCursorOverReferenceOrPopper =
              getCurrentTarget().contains(target) || popper.contains(target);

            if (event.type === "mousemove" && isCursorOverReferenceOrPopper) {
              return;
            }

            var popperTreeData = getNestedPopperTree()
              .concat(popper)
              .map(function (popper) {
                var _instance$popperInsta;

                var instance = popper._tippy;
                var state =
                  (_instance$popperInsta = instance.popperInstance) == null
                    ? void 0
                    : _instance$popperInsta.state;

                if (state) {
                  return {
                    popperRect: popper.getBoundingClientRect(),
                    popperState: state,
                    props: props,
                  };
                }

                return null;
              })
              .filter(Boolean);

            if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
              cleanupInteractiveMouseListeners();
              scheduleHide(event);
            }
          }

          function onMouseLeave(event) {
            var shouldBail =
              isEventListenerStopped(event) ||
              (instance.props.trigger.indexOf("click") >= 0 &&
                isVisibleFromClick);

            if (shouldBail) {
              return;
            }

            if (instance.props.interactive) {
              instance.hideWithInteractivity(event);
              return;
            }

            scheduleHide(event);
          }

          function onBlurOrFocusOut(event) {
            if (
              instance.props.trigger.indexOf("focusin") < 0 &&
              event.target !== getCurrentTarget()
            ) {
              return;
            } // If focus was moved to within the popper

            if (
              instance.props.interactive &&
              event.relatedTarget &&
              popper.contains(event.relatedTarget)
            ) {
              return;
            }

            scheduleHide(event);
          }

          function isEventListenerStopped(event) {
            return currentInput.isTouch
              ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0
              : false;
          }

          function createPopperInstance() {
            destroyPopperInstance();
            var _instance$props2 = instance.props,
              popperOptions = _instance$props2.popperOptions,
              placement = _instance$props2.placement,
              offset = _instance$props2.offset,
              getReferenceClientRect = _instance$props2.getReferenceClientRect,
              moveTransition = _instance$props2.moveTransition;
            var arrow = getIsDefaultRenderFn()
              ? getChildren(popper).arrow
              : null;
            var computedReference = getReferenceClientRect
              ? {
                  getBoundingClientRect: getReferenceClientRect,
                  contextElement:
                    getReferenceClientRect.contextElement || getCurrentTarget(),
                }
              : reference;
            var tippyModifier = {
              name: "$$tippy",
              enabled: true,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function fn(_ref2) {
                var state = _ref2.state;

                if (getIsDefaultRenderFn()) {
                  var _getDefaultTemplateCh = getDefaultTemplateChildren(),
                    box = _getDefaultTemplateCh.box;

                  ["placement", "reference-hidden", "escaped"].forEach(
                    function (attr) {
                      if (attr === "placement") {
                        box.setAttribute("data-placement", state.placement);
                      } else {
                        if (state.attributes.popper["data-popper-" + attr]) {
                          box.setAttribute("data-" + attr, "");
                        } else {
                          box.removeAttribute("data-" + attr);
                        }
                      }
                    }
                  );
                  state.attributes.popper = {};
                }
              },
            };
            var modifiers = [
              {
                name: "offset",
                options: {
                  offset: offset,
                },
              },
              {
                name: "preventOverflow",
                options: {
                  padding: {
                    top: 2,
                    bottom: 2,
                    left: 5,
                    right: 5,
                  },
                },
              },
              {
                name: "flip",
                options: {
                  padding: 5,
                },
              },
              {
                name: "computeStyles",
                options: {
                  adaptive: !moveTransition,
                },
              },
              tippyModifier,
            ];

            if (getIsDefaultRenderFn() && arrow) {
              modifiers.push({
                name: "arrow",
                options: {
                  element: arrow,
                  padding: 3,
                },
              });
            }

            modifiers.push.apply(
              modifiers,
              (popperOptions == null ? void 0 : popperOptions.modifiers) || []
            );
            instance.popperInstance = (0,
            _popperjs_core__WEBPACK_IMPORTED_MODULE_0__.createPopper)(
              computedReference,
              popper,
              Object.assign({}, popperOptions, {
                placement: placement,
                onFirstUpdate: onFirstUpdate,
                modifiers: modifiers,
              })
            );
          }

          function destroyPopperInstance() {
            if (instance.popperInstance) {
              instance.popperInstance.destroy();
              instance.popperInstance = null;
            }
          }

          function mount() {
            var appendTo = instance.props.appendTo;
            var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
            // it's directly after the reference element so the elements inside the
            // tippy can be tabbed to
            // If there are clipping issues, the user can specify a different appendTo
            // and ensure focus management is handled correctly manually

            var node = getCurrentTarget();

            if (
              (instance.props.interactive &&
                appendTo === TIPPY_DEFAULT_APPEND_TO) ||
              appendTo === "parent"
            ) {
              parentNode = node.parentNode;
            } else {
              parentNode = invokeWithArgsOrReturn(appendTo, [node]);
            } // The popper element needs to exist on the DOM before its position can be
            // updated as Popper needs to read its dimensions

            if (!parentNode.contains(popper)) {
              parentNode.appendChild(popper);
            }

            instance.state.isMounted = true;
            createPopperInstance();
            /* istanbul ignore else */

            if (true) {
              // Accessibility check
              warnWhen(
                instance.props.interactive &&
                  appendTo === defaultProps.appendTo &&
                  node.nextElementSibling !== popper,
                [
                  "Interactive tippy element may not be accessible via keyboard",
                  "navigation because it is not directly after the reference element",
                  "in the DOM source order.",
                  "\n\n",
                  "Using a wrapper <div> or <span> tag around the reference element",
                  "solves this by creating a new parentNode context.",
                  "\n\n",
                  "Specifying `appendTo: document.body` silences this warning, but it",
                  "assumes you are using a focus management solution to handle",
                  "keyboard navigation.",
                  "\n\n",
                  "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity",
                ].join(" ")
              );
            }
          }

          function getNestedPopperTree() {
            return arrayFrom(popper.querySelectorAll("[data-tippy-root]"));
          }

          function scheduleShow(event) {
            instance.clearDelayTimeouts();

            if (event) {
              invokeHook("onTrigger", [instance, event]);
            }

            addDocumentPress();
            var delay = getDelay(true);

            var _getNormalizedTouchSe = getNormalizedTouchSettings(),
              touchValue = _getNormalizedTouchSe[0],
              touchDelay = _getNormalizedTouchSe[1];

            if (currentInput.isTouch && touchValue === "hold" && touchDelay) {
              delay = touchDelay;
            }

            if (delay) {
              showTimeout = setTimeout(function () {
                instance.show();
              }, delay);
            } else {
              instance.show();
            }
          }

          function scheduleHide(event) {
            instance.clearDelayTimeouts();
            invokeHook("onUntrigger", [instance, event]);

            if (!instance.state.isVisible) {
              removeDocumentPress();
              return;
            } // For interactive tippies, scheduleHide is added to a document.body handler
            // from onMouseLeave so must intercept scheduled hides from mousemove/leave
            // events when trigger contains mouseenter and click, and the tip is
            // currently shown as a result of a click.

            if (
              instance.props.trigger.indexOf("mouseenter") >= 0 &&
              instance.props.trigger.indexOf("click") >= 0 &&
              ["mouseleave", "mousemove"].indexOf(event.type) >= 0 &&
              isVisibleFromClick
            ) {
              return;
            }

            var delay = getDelay(false);

            if (delay) {
              hideTimeout = setTimeout(function () {
                if (instance.state.isVisible) {
                  instance.hide();
                }
              }, delay);
            } else {
              // Fixes a `transitionend` problem when it fires 1 frame too
              // late sometimes, we don't want hide() to be called.
              scheduleHideAnimationFrame = requestAnimationFrame(function () {
                instance.hide();
              });
            }
          } // ===========================================================================
          // 🔑 Public methods
          // ===========================================================================

          function enable() {
            instance.state.isEnabled = true;
          }

          function disable() {
            // Disabling the instance should also hide it
            // https://github.com/atomiks/tippy.js-react/issues/106
            instance.hide();
            instance.state.isEnabled = false;
          }

          function clearDelayTimeouts() {
            clearTimeout(showTimeout);
            clearTimeout(hideTimeout);
            cancelAnimationFrame(scheduleHideAnimationFrame);
          }

          function setProps(partialProps) {
            /* istanbul ignore else */
            if (true) {
              warnWhen(
                instance.state.isDestroyed,
                createMemoryLeakWarning("setProps")
              );
            }

            if (instance.state.isDestroyed) {
              return;
            }

            invokeHook("onBeforeUpdate", [instance, partialProps]);
            removeListeners();
            var prevProps = instance.props;
            var nextProps = evaluateProps(
              reference,
              Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
                ignoreAttributes: true,
              })
            );
            instance.props = nextProps;
            addListeners();

            if (
              prevProps.interactiveDebounce !== nextProps.interactiveDebounce
            ) {
              cleanupInteractiveMouseListeners();
              debouncedOnMouseMove = debounce(
                onMouseMove,
                nextProps.interactiveDebounce
              );
            } // Ensure stale aria-expanded attributes are removed

            if (prevProps.triggerTarget && !nextProps.triggerTarget) {
              normalizeToArray(prevProps.triggerTarget).forEach(function (
                node
              ) {
                node.removeAttribute("aria-expanded");
              });
            } else if (nextProps.triggerTarget) {
              reference.removeAttribute("aria-expanded");
            }

            handleAriaExpandedAttribute();
            handleStyles();

            if (onUpdate) {
              onUpdate(prevProps, nextProps);
            }

            if (instance.popperInstance) {
              createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
              // and the nested ones get re-rendered first.
              // https://github.com/atomiks/tippyjs-react/issues/177
              // TODO: find a cleaner / more efficient solution(!)

              getNestedPopperTree().forEach(function (nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(
                  nestedPopper._tippy.popperInstance.forceUpdate
                );
              });
            }

            invokeHook("onAfterUpdate", [instance, partialProps]);
          }

          function setContent(content) {
            instance.setProps({
              content: content,
            });
          }

          function show() {
            /* istanbul ignore else */
            if (true) {
              warnWhen(
                instance.state.isDestroyed,
                createMemoryLeakWarning("show")
              );
            } // Early bail-out

            var isAlreadyVisible = instance.state.isVisible;
            var isDestroyed = instance.state.isDestroyed;
            var isDisabled = !instance.state.isEnabled;
            var isTouchAndTouchDisabled =
              currentInput.isTouch && !instance.props.touch;
            var duration = getValueAtIndexOrReturn(
              instance.props.duration,
              0,
              defaultProps.duration
            );

            if (
              isAlreadyVisible ||
              isDestroyed ||
              isDisabled ||
              isTouchAndTouchDisabled
            ) {
              return;
            } // Normalize `disabled` behavior across browsers.
            // Firefox allows events on disabled elements, but Chrome doesn't.
            // Using a wrapper element (i.e. <span>) is recommended.

            if (getCurrentTarget().hasAttribute("disabled")) {
              return;
            }

            invokeHook("onShow", [instance], false);

            if (instance.props.onShow(instance) === false) {
              return;
            }

            instance.state.isVisible = true;

            if (getIsDefaultRenderFn()) {
              popper.style.visibility = "visible";
            }

            handleStyles();
            addDocumentPress();

            if (!instance.state.isMounted) {
              popper.style.transition = "none";
            } // If flipping to the opposite side after hiding at least once, the
            // animation will use the wrong placement without resetting the duration

            if (getIsDefaultRenderFn()) {
              var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
                box = _getDefaultTemplateCh2.box,
                content = _getDefaultTemplateCh2.content;

              setTransitionDuration([box, content], 0);
            }

            onFirstUpdate = function onFirstUpdate() {
              var _instance$popperInsta2;

              if (!instance.state.isVisible || ignoreOnFirstUpdate) {
                return;
              }

              ignoreOnFirstUpdate = true; // reflow

              void popper.offsetHeight;
              popper.style.transition = instance.props.moveTransition;

              if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
                  _box = _getDefaultTemplateCh3.box,
                  _content = _getDefaultTemplateCh3.content;

                setTransitionDuration([_box, _content], duration);
                setVisibilityState([_box, _content], "visible");
              }

              handleAriaContentAttribute();
              handleAriaExpandedAttribute();
              pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
              // popper has been positioned for the first time

              (_instance$popperInsta2 = instance.popperInstance) == null
                ? void 0
                : _instance$popperInsta2.forceUpdate();
              invokeHook("onMount", [instance]);

              if (instance.props.animation && getIsDefaultRenderFn()) {
                onTransitionedIn(duration, function () {
                  instance.state.isShown = true;
                  invokeHook("onShown", [instance]);
                });
              }
            };

            mount();
          }

          function hide() {
            /* istanbul ignore else */
            if (true) {
              warnWhen(
                instance.state.isDestroyed,
                createMemoryLeakWarning("hide")
              );
            } // Early bail-out

            var isAlreadyHidden = !instance.state.isVisible;
            var isDestroyed = instance.state.isDestroyed;
            var isDisabled = !instance.state.isEnabled;
            var duration = getValueAtIndexOrReturn(
              instance.props.duration,
              1,
              defaultProps.duration
            );

            if (isAlreadyHidden || isDestroyed || isDisabled) {
              return;
            }

            invokeHook("onHide", [instance], false);

            if (instance.props.onHide(instance) === false) {
              return;
            }

            instance.state.isVisible = false;
            instance.state.isShown = false;
            ignoreOnFirstUpdate = false;
            isVisibleFromClick = false;

            if (getIsDefaultRenderFn()) {
              popper.style.visibility = "hidden";
            }

            cleanupInteractiveMouseListeners();
            removeDocumentPress();
            handleStyles(true);

            if (getIsDefaultRenderFn()) {
              var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
                box = _getDefaultTemplateCh4.box,
                content = _getDefaultTemplateCh4.content;

              if (instance.props.animation) {
                setTransitionDuration([box, content], duration);
                setVisibilityState([box, content], "hidden");
              }
            }

            handleAriaContentAttribute();
            handleAriaExpandedAttribute();

            if (instance.props.animation) {
              if (getIsDefaultRenderFn()) {
                onTransitionedOut(duration, instance.unmount);
              }
            } else {
              instance.unmount();
            }
          }

          function hideWithInteractivity(event) {
            /* istanbul ignore else */
            if (true) {
              warnWhen(
                instance.state.isDestroyed,
                createMemoryLeakWarning("hideWithInteractivity")
              );
            }

            getDocument().addEventListener("mousemove", debouncedOnMouseMove);
            pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
            debouncedOnMouseMove(event);
          }

          function unmount() {
            /* istanbul ignore else */
            if (true) {
              warnWhen(
                instance.state.isDestroyed,
                createMemoryLeakWarning("unmount")
              );
            }

            if (instance.state.isVisible) {
              instance.hide();
            }

            if (!instance.state.isMounted) {
              return;
            }

            destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
            // tree by default. This seems mainly for interactive tippies, but we should
            // find a workaround if possible

            getNestedPopperTree().forEach(function (nestedPopper) {
              nestedPopper._tippy.unmount();
            });

            if (popper.parentNode) {
              popper.parentNode.removeChild(popper);
            }

            mountedInstances = mountedInstances.filter(function (i) {
              return i !== instance;
            });
            instance.state.isMounted = false;
            invokeHook("onHidden", [instance]);
          }

          function destroy() {
            /* istanbul ignore else */
            if (true) {
              warnWhen(
                instance.state.isDestroyed,
                createMemoryLeakWarning("destroy")
              );
            }

            if (instance.state.isDestroyed) {
              return;
            }

            instance.clearDelayTimeouts();
            instance.unmount();
            removeListeners();
            delete reference._tippy;
            instance.state.isDestroyed = true;
            invokeHook("onDestroy", [instance]);
          }
        }

        function tippy(targets, optionalProps) {
          if (optionalProps === void 0) {
            optionalProps = {};
          }

          var plugins = defaultProps.plugins.concat(
            optionalProps.plugins || []
          );
          /* istanbul ignore else */

          if (true) {
            validateTargets(targets);
            validateProps(optionalProps, plugins);
          }

          bindGlobalEventListeners();
          var passedProps = Object.assign({}, optionalProps, {
            plugins: plugins,
          });
          var elements = getArrayOfElements(targets);
          /* istanbul ignore else */

          if (true) {
            var isSingleContentElement = isElement(passedProps.content);
            var isMoreThanOneReferenceElement = elements.length > 1;
            warnWhen(
              isSingleContentElement && isMoreThanOneReferenceElement,
              [
                "tippy() was passed an Element as the `content` prop, but more than",
                "one tippy instance was created by this invocation. This means the",
                "content element will only be appended to the last tippy instance.",
                "\n\n",
                "Instead, pass the .innerHTML of the element, or use a function that",
                "returns a cloned version of the element instead.",
                "\n\n",
                "1) content: element.innerHTML\n",
                "2) content: () => element.cloneNode(true)",
              ].join(" ")
            );
          }

          var instances = elements.reduce(function (acc, reference) {
            var instance = reference && createTippy(reference, passedProps);

            if (instance) {
              acc.push(instance);
            }

            return acc;
          }, []);
          return isElement(targets) ? instances[0] : instances;
        }

        tippy.defaultProps = defaultProps;
        tippy.setDefaultProps = setDefaultProps;
        tippy.currentInput = currentInput;
        var hideAll = function hideAll(_temp) {
          var _ref = _temp === void 0 ? {} : _temp,
            excludedReferenceOrInstance = _ref.exclude,
            duration = _ref.duration;

          mountedInstances.forEach(function (instance) {
            var isExcluded = false;

            if (excludedReferenceOrInstance) {
              isExcluded = isReferenceElement(excludedReferenceOrInstance)
                ? instance.reference === excludedReferenceOrInstance
                : instance.popper === excludedReferenceOrInstance.popper;
            }

            if (!isExcluded) {
              var originalDuration = instance.props.duration;
              instance.setProps({
                duration: duration,
              });
              instance.hide();

              if (!instance.state.isDestroyed) {
                instance.setProps({
                  duration: originalDuration,
                });
              }
            }
          });
        };

        // every time the popper is destroyed (i.e. a new target), removing the styles
        // and causing transitions to break for singletons when the console is open, but
        // most notably for non-transform styles being used, `gpuAcceleration: false`.

        var applyStylesModifier = Object.assign(
          {},
          _popperjs_core__WEBPACK_IMPORTED_MODULE_1__["default"],
          {
            effect: function effect(_ref) {
              var state = _ref.state;
              var initialStyles = {
                popper: {
                  position: state.options.strategy,
                  left: "0",
                  top: "0",
                  margin: "0",
                },
                arrow: {
                  position: "absolute",
                },
                reference: {},
              };
              Object.assign(state.elements.popper.style, initialStyles.popper);
              state.styles = initialStyles;

              if (state.elements.arrow) {
                Object.assign(state.elements.arrow.style, initialStyles.arrow);
              } // intentionally return no cleanup function
              // return () => { ... }
            },
          }
        );

        var createSingleton = function createSingleton(
          tippyInstances,
          optionalProps
        ) {
          var _optionalProps$popper;

          if (optionalProps === void 0) {
            optionalProps = {};
          }

          /* istanbul ignore else */
          if (true) {
            errorWhen(
              !Array.isArray(tippyInstances),
              [
                "The first argument passed to createSingleton() must be an array of",
                "tippy instances. The passed value was",
                String(tippyInstances),
              ].join(" ")
            );
          }

          var individualInstances = tippyInstances;
          var references = [];
          var triggerTargets = [];
          var currentTarget;
          var overrides = optionalProps.overrides;
          var interceptSetPropsCleanups = [];
          var shownOnCreate = false;

          function setTriggerTargets() {
            triggerTargets = individualInstances
              .map(function (instance) {
                return normalizeToArray(
                  instance.props.triggerTarget || instance.reference
                );
              })
              .reduce(function (acc, item) {
                return acc.concat(item);
              }, []);
          }

          function setReferences() {
            references = individualInstances.map(function (instance) {
              return instance.reference;
            });
          }

          function enableInstances(isEnabled) {
            individualInstances.forEach(function (instance) {
              if (isEnabled) {
                instance.enable();
              } else {
                instance.disable();
              }
            });
          }

          function interceptSetProps(singleton) {
            return individualInstances.map(function (instance) {
              var originalSetProps = instance.setProps;

              instance.setProps = function (props) {
                originalSetProps(props);

                if (instance.reference === currentTarget) {
                  singleton.setProps(props);
                }
              };

              return function () {
                instance.setProps = originalSetProps;
              };
            });
          } // have to pass singleton, as it maybe undefined on first call

          function prepareInstance(singleton, target) {
            var index = triggerTargets.indexOf(target); // bail-out

            if (target === currentTarget) {
              return;
            }

            currentTarget = target;
            var overrideProps = (overrides || [])
              .concat("content")
              .reduce(function (acc, prop) {
                acc[prop] = individualInstances[index].props[prop];
                return acc;
              }, {});
            singleton.setProps(
              Object.assign({}, overrideProps, {
                getReferenceClientRect:
                  typeof overrideProps.getReferenceClientRect === "function"
                    ? overrideProps.getReferenceClientRect
                    : function () {
                        var _references$index;

                        return (_references$index = references[index]) == null
                          ? void 0
                          : _references$index.getBoundingClientRect();
                      },
              })
            );
          }

          enableInstances(false);
          setReferences();
          setTriggerTargets();
          var plugin = {
            fn: function fn() {
              return {
                onDestroy: function onDestroy() {
                  enableInstances(true);
                },
                onHidden: function onHidden() {
                  currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                  if (instance.props.showOnCreate && !shownOnCreate) {
                    shownOnCreate = true;
                    currentTarget = null;
                  }
                },
                onShow: function onShow(instance) {
                  if (instance.props.showOnCreate && !shownOnCreate) {
                    shownOnCreate = true;
                    prepareInstance(instance, references[0]);
                  }
                },
                onTrigger: function onTrigger(instance, event) {
                  prepareInstance(instance, event.currentTarget);
                },
              };
            },
          };
          var singleton = tippy(
            div(),
            Object.assign({}, removeProperties(optionalProps, ["overrides"]), {
              plugins: [plugin].concat(optionalProps.plugins || []),
              triggerTarget: triggerTargets,
              popperOptions: Object.assign({}, optionalProps.popperOptions, {
                modifiers: [].concat(
                  ((_optionalProps$popper = optionalProps.popperOptions) == null
                    ? void 0
                    : _optionalProps$popper.modifiers) || [],
                  [applyStylesModifier]
                ),
              }),
            })
          );
          var originalShow = singleton.show;

          singleton.show = function (target) {
            originalShow(); // first time, showOnCreate or programmatic call with no params
            // default to showing first instance

            if (!currentTarget && target == null) {
              return prepareInstance(singleton, references[0]);
            } // triggered from event (do nothing as prepareInstance already called by onTrigger)
            // programmatic call with no params when already visible (do nothing again)

            if (currentTarget && target == null) {
              return;
            } // target is index of instance

            if (typeof target === "number") {
              return (
                references[target] &&
                prepareInstance(singleton, references[target])
              );
            } // target is a child tippy instance

            if (individualInstances.indexOf(target) >= 0) {
              var ref = target.reference;
              return prepareInstance(singleton, ref);
            } // target is a ReferenceElement

            if (references.indexOf(target) >= 0) {
              return prepareInstance(singleton, target);
            }
          };

          singleton.showNext = function () {
            var first = references[0];

            if (!currentTarget) {
              return singleton.show(0);
            }

            var index = references.indexOf(currentTarget);
            singleton.show(references[index + 1] || first);
          };

          singleton.showPrevious = function () {
            var last = references[references.length - 1];

            if (!currentTarget) {
              return singleton.show(last);
            }

            var index = references.indexOf(currentTarget);
            var target = references[index - 1] || last;
            singleton.show(target);
          };

          var originalSetProps = singleton.setProps;

          singleton.setProps = function (props) {
            overrides = props.overrides || overrides;
            originalSetProps(props);
          };

          singleton.setInstances = function (nextInstances) {
            enableInstances(true);
            interceptSetPropsCleanups.forEach(function (fn) {
              return fn();
            });
            individualInstances = nextInstances;
            enableInstances(false);
            setReferences();
            setTriggerTargets();
            interceptSetPropsCleanups = interceptSetProps(singleton);
            singleton.setProps({
              triggerTarget: triggerTargets,
            });
          };

          interceptSetPropsCleanups = interceptSetProps(singleton);
          return singleton;
        };

        var BUBBLING_EVENTS_MAP = {
          mouseover: "mouseenter",
          focusin: "focus",
          click: "click",
        };
        /**
         * Creates a delegate instance that controls the creation of tippy instances
         * for child elements (`target` CSS selector).
         */

        function delegate(targets, props) {
          /* istanbul ignore else */
          if (true) {
            errorWhen(
              !(props && props.target),
              [
                "You must specity a `target` prop indicating a CSS selector string matching",
                "the target elements that should receive a tippy.",
              ].join(" ")
            );
          }

          var listeners = [];
          var childTippyInstances = [];
          var disabled = false;
          var target = props.target;
          var nativeProps = removeProperties(props, ["target"]);
          var parentProps = Object.assign({}, nativeProps, {
            trigger: "manual",
            touch: false,
          });
          var childProps = Object.assign(
            {
              touch: defaultProps.touch,
            },
            nativeProps,
            {
              showOnCreate: true,
            }
          );
          var returnValue = tippy(targets, parentProps);
          var normalizedReturnValue = normalizeToArray(returnValue);

          function onTrigger(event) {
            if (!event.target || disabled) {
              return;
            }

            var targetNode = event.target.closest(target);

            if (!targetNode) {
              return;
            } // Get relevant trigger with fallbacks:
            // 1. Check `data-tippy-trigger` attribute on target node
            // 2. Fallback to `trigger` passed to `delegate()`
            // 3. Fallback to `defaultProps.trigger`

            var trigger =
              targetNode.getAttribute("data-tippy-trigger") ||
              props.trigger ||
              defaultProps.trigger; // @ts-ignore

            if (targetNode._tippy) {
              return;
            }

            if (
              event.type === "touchstart" &&
              typeof childProps.touch === "boolean"
            ) {
              return;
            }

            if (
              event.type !== "touchstart" &&
              trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0
            ) {
              return;
            }

            var instance = tippy(targetNode, childProps);

            if (instance) {
              childTippyInstances = childTippyInstances.concat(instance);
            }
          }

          function on(node, eventType, handler, options) {
            if (options === void 0) {
              options = false;
            }

            node.addEventListener(eventType, handler, options);
            listeners.push({
              node: node,
              eventType: eventType,
              handler: handler,
              options: options,
            });
          }

          function addEventListeners(instance) {
            var reference = instance.reference;
            on(reference, "touchstart", onTrigger, TOUCH_OPTIONS);
            on(reference, "mouseover", onTrigger);
            on(reference, "focusin", onTrigger);
            on(reference, "click", onTrigger);
          }

          function removeEventListeners() {
            listeners.forEach(function (_ref) {
              var node = _ref.node,
                eventType = _ref.eventType,
                handler = _ref.handler,
                options = _ref.options;
              node.removeEventListener(eventType, handler, options);
            });
            listeners = [];
          }

          function applyMutations(instance) {
            var originalDestroy = instance.destroy;
            var originalEnable = instance.enable;
            var originalDisable = instance.disable;

            instance.destroy = function (shouldDestroyChildInstances) {
              if (shouldDestroyChildInstances === void 0) {
                shouldDestroyChildInstances = true;
              }

              if (shouldDestroyChildInstances) {
                childTippyInstances.forEach(function (instance) {
                  instance.destroy();
                });
              }

              childTippyInstances = [];
              removeEventListeners();
              originalDestroy();
            };

            instance.enable = function () {
              originalEnable();
              childTippyInstances.forEach(function (instance) {
                return instance.enable();
              });
              disabled = false;
            };

            instance.disable = function () {
              originalDisable();
              childTippyInstances.forEach(function (instance) {
                return instance.disable();
              });
              disabled = true;
            };

            addEventListeners(instance);
          }

          normalizedReturnValue.forEach(applyMutations);
          return returnValue;
        }

        var animateFill = {
          name: "animateFill",
          defaultValue: false,
          fn: function fn(instance) {
            var _instance$props$rende;

            // @ts-ignore
            if (
              !(
                (_instance$props$rende = instance.props.render) != null &&
                _instance$props$rende.$$tippy
              )
            ) {
              if (true) {
                errorWhen(
                  instance.props.animateFill,
                  "The `animateFill` plugin requires the default render function."
                );
              }

              return {};
            }

            var _getChildren = getChildren(instance.popper),
              box = _getChildren.box,
              content = _getChildren.content;

            var backdrop = instance.props.animateFill
              ? createBackdropElement()
              : null;
            return {
              onCreate: function onCreate() {
                if (backdrop) {
                  box.insertBefore(backdrop, box.firstElementChild);
                  box.setAttribute("data-animatefill", "");
                  box.style.overflow = "hidden";
                  instance.setProps({
                    arrow: false,
                    animation: "shift-away",
                  });
                }
              },
              onMount: function onMount() {
                if (backdrop) {
                  var transitionDuration = box.style.transitionDuration;
                  var duration = Number(transitionDuration.replace("ms", "")); // The content should fade in after the backdrop has mostly filled the
                  // tooltip element. `clip-path` is the other alternative but is not
                  // well-supported and is buggy on some devices.

                  content.style.transitionDelay =
                    Math.round(duration / 10) + "ms";
                  backdrop.style.transitionDuration = transitionDuration;
                  setVisibilityState([backdrop], "visible");
                }
              },
              onShow: function onShow() {
                if (backdrop) {
                  backdrop.style.transitionDuration = "0ms";
                }
              },
              onHide: function onHide() {
                if (backdrop) {
                  setVisibilityState([backdrop], "hidden");
                }
              },
            };
          },
        };

        function createBackdropElement() {
          var backdrop = div();
          backdrop.className = BACKDROP_CLASS;
          setVisibilityState([backdrop], "hidden");
          return backdrop;
        }

        var mouseCoords = {
          clientX: 0,
          clientY: 0,
        };
        var activeInstances = [];

        function storeMouseCoords(_ref) {
          var clientX = _ref.clientX,
            clientY = _ref.clientY;
          mouseCoords = {
            clientX: clientX,
            clientY: clientY,
          };
        }

        function addMouseCoordsListener(doc) {
          doc.addEventListener("mousemove", storeMouseCoords);
        }

        function removeMouseCoordsListener(doc) {
          doc.removeEventListener("mousemove", storeMouseCoords);
        }

        var followCursor = {
          name: "followCursor",
          defaultValue: false,
          fn: function fn(instance) {
            var reference = instance.reference;
            var doc = getOwnerDocument(
              instance.props.triggerTarget || reference
            );
            var isInternalUpdate = false;
            var wasFocusEvent = false;
            var isUnmounted = true;
            var prevProps = instance.props;

            function getIsInitialBehavior() {
              return (
                instance.props.followCursor === "initial" &&
                instance.state.isVisible
              );
            }

            function addListener() {
              doc.addEventListener("mousemove", onMouseMove);
            }

            function removeListener() {
              doc.removeEventListener("mousemove", onMouseMove);
            }

            function unsetGetReferenceClientRect() {
              isInternalUpdate = true;
              instance.setProps({
                getReferenceClientRect: null,
              });
              isInternalUpdate = false;
            }

            function onMouseMove(event) {
              // If the instance is interactive, avoid updating the position unless it's
              // over the reference element
              var isCursorOverReference = event.target
                ? reference.contains(event.target)
                : true;
              var followCursor = instance.props.followCursor;
              var clientX = event.clientX,
                clientY = event.clientY;
              var rect = reference.getBoundingClientRect();
              var relativeX = clientX - rect.left;
              var relativeY = clientY - rect.top;

              if (isCursorOverReference || !instance.props.interactive) {
                instance.setProps({
                  // @ts-ignore - unneeded DOMRect properties
                  getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;

                    if (followCursor === "initial") {
                      x = rect.left + relativeX;
                      y = rect.top + relativeY;
                    }

                    var top = followCursor === "horizontal" ? rect.top : y;
                    var right = followCursor === "vertical" ? rect.right : x;
                    var bottom =
                      followCursor === "horizontal" ? rect.bottom : y;
                    var left = followCursor === "vertical" ? rect.left : x;
                    return {
                      width: right - left,
                      height: bottom - top,
                      top: top,
                      right: right,
                      bottom: bottom,
                      left: left,
                    };
                  },
                });
              }
            }

            function create() {
              if (instance.props.followCursor) {
                activeInstances.push({
                  instance: instance,
                  doc: doc,
                });
                addMouseCoordsListener(doc);
              }
            }

            function destroy() {
              activeInstances = activeInstances.filter(function (data) {
                return data.instance !== instance;
              });

              if (
                activeInstances.filter(function (data) {
                  return data.doc === doc;
                }).length === 0
              ) {
                removeMouseCoordsListener(doc);
              }
            }

            return {
              onCreate: create,
              onDestroy: destroy,
              onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
              },
              onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;

                if (isInternalUpdate) {
                  return;
                }

                if (
                  followCursor !== undefined &&
                  prevProps.followCursor !== followCursor
                ) {
                  destroy();

                  if (followCursor) {
                    create();

                    if (
                      instance.state.isMounted &&
                      !wasFocusEvent &&
                      !getIsInitialBehavior()
                    ) {
                      addListener();
                    }
                  } else {
                    removeListener();
                    unsetGetReferenceClientRect();
                  }
                }
              },
              onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                  if (isUnmounted) {
                    onMouseMove(mouseCoords);
                    isUnmounted = false;
                  }

                  if (!getIsInitialBehavior()) {
                    addListener();
                  }
                }
              },
              onTrigger: function onTrigger(_, event) {
                if (isMouseEvent(event)) {
                  mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY,
                  };
                }

                wasFocusEvent = event.type === "focus";
              },
              onHidden: function onHidden() {
                if (instance.props.followCursor) {
                  unsetGetReferenceClientRect();
                  removeListener();
                  isUnmounted = true;
                }
              },
            };
          },
        };

        function getProps(props, modifier) {
          var _props$popperOptions;

          return {
            popperOptions: Object.assign({}, props.popperOptions, {
              modifiers: [].concat(
                (
                  ((_props$popperOptions = props.popperOptions) == null
                    ? void 0
                    : _props$popperOptions.modifiers) || []
                ).filter(function (_ref) {
                  var name = _ref.name;
                  return name !== modifier.name;
                }),
                [modifier]
              ),
            }),
          };
        }

        var inlinePositioning = {
          name: "inlinePositioning",
          defaultValue: false,
          fn: function fn(instance) {
            var reference = instance.reference;

            function isEnabled() {
              return !!instance.props.inlinePositioning;
            }

            var placement;
            var cursorRectIndex = -1;
            var isInternalUpdate = false;
            var triedPlacements = [];
            var modifier = {
              name: "tippyInlinePositioning",
              enabled: true,
              phase: "afterWrite",
              fn: function fn(_ref2) {
                var state = _ref2.state;

                if (isEnabled()) {
                  if (triedPlacements.indexOf(state.placement) !== -1) {
                    triedPlacements = [];
                  }

                  if (
                    placement !== state.placement &&
                    triedPlacements.indexOf(state.placement) === -1
                  ) {
                    triedPlacements.push(state.placement);
                    instance.setProps({
                      // @ts-ignore - unneeded DOMRect properties
                      getReferenceClientRect:
                        function getReferenceClientRect() {
                          return _getReferenceClientRect(state.placement);
                        },
                    });
                  }

                  placement = state.placement;
                }
              },
            };

            function _getReferenceClientRect(placement) {
              return getInlineBoundingClientRect(
                getBasePlacement(placement),
                reference.getBoundingClientRect(),
                arrayFrom(reference.getClientRects()),
                cursorRectIndex
              );
            }

            function setInternalProps(partialProps) {
              isInternalUpdate = true;
              instance.setProps(partialProps);
              isInternalUpdate = false;
            }

            function addModifier() {
              if (!isInternalUpdate) {
                setInternalProps(getProps(instance.props, modifier));
              }
            }

            return {
              onCreate: addModifier,
              onAfterUpdate: addModifier,
              onTrigger: function onTrigger(_, event) {
                if (isMouseEvent(event)) {
                  var rects = arrayFrom(instance.reference.getClientRects());
                  var cursorRect = rects.find(function (rect) {
                    return (
                      rect.left - 2 <= event.clientX &&
                      rect.right + 2 >= event.clientX &&
                      rect.top - 2 <= event.clientY &&
                      rect.bottom + 2 >= event.clientY
                    );
                  });
                  var index = rects.indexOf(cursorRect);
                  cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
              },
              onHidden: function onHidden() {
                cursorRectIndex = -1;
              },
            };
          },
        };
        function getInlineBoundingClientRect(
          currentBasePlacement,
          boundingRect,
          clientRects,
          cursorRectIndex
        ) {
          // Not an inline element, or placement is not yet known
          if (clientRects.length < 2 || currentBasePlacement === null) {
            return boundingRect;
          } // There are two rects and they are disjoined

          if (
            clientRects.length === 2 &&
            cursorRectIndex >= 0 &&
            clientRects[0].left > clientRects[1].right
          ) {
            return clientRects[cursorRectIndex] || boundingRect;
          }

          switch (currentBasePlacement) {
            case "top":
            case "bottom": {
              var firstRect = clientRects[0];
              var lastRect = clientRects[clientRects.length - 1];
              var isTop = currentBasePlacement === "top";
              var top = firstRect.top;
              var bottom = lastRect.bottom;
              var left = isTop ? firstRect.left : lastRect.left;
              var right = isTop ? firstRect.right : lastRect.right;
              var width = right - left;
              var height = bottom - top;
              return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height,
              };
            }

            case "left":
            case "right": {
              var minLeft = Math.min.apply(
                Math,
                clientRects.map(function (rects) {
                  return rects.left;
                })
              );
              var maxRight = Math.max.apply(
                Math,
                clientRects.map(function (rects) {
                  return rects.right;
                })
              );
              var measureRects = clientRects.filter(function (rect) {
                return currentBasePlacement === "left"
                  ? rect.left === minLeft
                  : rect.right === maxRight;
              });
              var _top = measureRects[0].top;
              var _bottom = measureRects[measureRects.length - 1].bottom;
              var _left = minLeft;
              var _right = maxRight;

              var _width = _right - _left;

              var _height = _bottom - _top;

              return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height,
              };
            }

            default: {
              return boundingRect;
            }
          }
        }

        var sticky = {
          name: "sticky",
          defaultValue: false,
          fn: function fn(instance) {
            var reference = instance.reference,
              popper = instance.popper;

            function getReference() {
              return instance.popperInstance
                ? instance.popperInstance.state.elements.reference
                : reference;
            }

            function shouldCheck(value) {
              return (
                instance.props.sticky === true ||
                instance.props.sticky === value
              );
            }

            var prevRefRect = null;
            var prevPopRect = null;

            function updatePosition() {
              var currentRefRect = shouldCheck("reference")
                ? getReference().getBoundingClientRect()
                : null;
              var currentPopRect = shouldCheck("popper")
                ? popper.getBoundingClientRect()
                : null;

              if (
                (currentRefRect &&
                  areRectsDifferent(prevRefRect, currentRefRect)) ||
                (currentPopRect &&
                  areRectsDifferent(prevPopRect, currentPopRect))
              ) {
                if (instance.popperInstance) {
                  instance.popperInstance.update();
                }
              }

              prevRefRect = currentRefRect;
              prevPopRect = currentPopRect;

              if (instance.state.isMounted) {
                requestAnimationFrame(updatePosition);
              }
            }

            return {
              onMount: function onMount() {
                if (instance.props.sticky) {
                  updatePosition();
                }
              },
            };
          },
        };

        function areRectsDifferent(rectA, rectB) {
          if (rectA && rectB) {
            return (
              rectA.top !== rectB.top ||
              rectA.right !== rectB.right ||
              rectA.bottom !== rectB.bottom ||
              rectA.left !== rectB.left
            );
          }

          return true;
        }

        tippy.setDefaultProps({
          render: render,
        });

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = tippy;

        //# sourceMappingURL=tippy.esm.js.map

        /***/
      },

    /***/ "./node_modules/unidragger/unidragger.js":
      /*!***********************************************!*\
  !*** ./node_modules/unidragger/unidragger.js ***!
  \***********************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        /*!
         * Unidragger v3.0.1
         * Draggable base class
         * MIT license
         */

        (function (window, factory) {
          // universal module definition
          if (true && module.exports) {
            // CommonJS
            module.exports = factory(
              window,
              __webpack_require__(
                /*! ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"
              )
            );
          } else {
            // browser global
            window.Unidragger = factory(window, window.EvEmitter);
          }
        })(
          typeof window != "undefined" ? window : this,
          function factory(window, EvEmitter) {
            function Unidragger() {}

            // inherit EvEmitter
            let proto = (Unidragger.prototype = Object.create(
              EvEmitter.prototype
            ));

            // ----- bind start ----- //

            // trigger handler methods for events
            proto.handleEvent = function (event) {
              let method = "on" + event.type;
              if (this[method]) {
                this[method](event);
              }
            };

            let startEvent, activeEvents;
            if ("ontouchstart" in window) {
              // HACK prefer Touch Events as you can preventDefault on touchstart to
              // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
              startEvent = "touchstart";
              activeEvents = ["touchmove", "touchend", "touchcancel"];
            } else if (window.PointerEvent) {
              // Pointer Events
              startEvent = "pointerdown";
              activeEvents = ["pointermove", "pointerup", "pointercancel"];
            } else {
              // mouse events
              startEvent = "mousedown";
              activeEvents = ["mousemove", "mouseup"];
            }

            // prototype so it can be overwriteable by Flickity
            proto.touchActionValue = "none";

            proto.bindHandles = function () {
              this._bindHandles("addEventListener", this.touchActionValue);
            };

            proto.unbindHandles = function () {
              this._bindHandles("removeEventListener", "");
            };

            /**
             * Add or remove start event
             * @param {String} bindMethod - addEventListener or removeEventListener
             * @param {String} touchAction - value for touch-action CSS property
             */
            proto._bindHandles = function (bindMethod, touchAction) {
              this.handles.forEach((handle) => {
                handle[bindMethod](startEvent, this);
                handle[bindMethod]("click", this);
                // touch-action: none to override browser touch gestures. metafizzy/flickity#540
                if (window.PointerEvent) handle.style.touchAction = touchAction;
              });
            };

            proto.bindActivePointerEvents = function () {
              activeEvents.forEach((eventName) => {
                window.addEventListener(eventName, this);
              });
            };

            proto.unbindActivePointerEvents = function () {
              activeEvents.forEach((eventName) => {
                window.removeEventListener(eventName, this);
              });
            };

            // ----- event handler helpers ----- //

            // trigger method with matching pointer
            proto.withPointer = function (methodName, event) {
              if (event.pointerId === this.pointerIdentifier) {
                this[methodName](event, event);
              }
            };

            // trigger method with matching touch
            proto.withTouch = function (methodName, event) {
              let touch;
              for (let changedTouch of event.changedTouches) {
                if (changedTouch.identifier === this.pointerIdentifier) {
                  touch = changedTouch;
                }
              }
              if (touch) this[methodName](event, touch);
            };

            // ----- start event ----- //

            proto.onmousedown = function (event) {
              this.pointerDown(event, event);
            };

            proto.ontouchstart = function (event) {
              this.pointerDown(event, event.changedTouches[0]);
            };

            proto.onpointerdown = function (event) {
              this.pointerDown(event, event);
            };

            // nodes that have text fields
            const cursorNodes = ["TEXTAREA", "INPUT", "SELECT", "OPTION"];
            // input types that do not have text fields
            const clickTypes = [
              "radio",
              "checkbox",
              "button",
              "submit",
              "image",
              "file",
            ];

            /**
             * any time you set `event, pointer` it refers to:
             * @param {Event} event
             * @param {Event | Touch} pointer
             */
            proto.pointerDown = function (event, pointer) {
              // dismiss multi-touch taps, right clicks, and clicks on text fields
              let isCursorNode = cursorNodes.includes(event.target.nodeName);
              let isClickType = clickTypes.includes(event.target.type);
              let isOkayElement = !isCursorNode || isClickType;
              let isOkay =
                !this.isPointerDown && !event.button && isOkayElement;
              if (!isOkay) return;

              this.isPointerDown = true;
              // save pointer identifier to match up touch events
              this.pointerIdentifier =
                pointer.pointerId !== undefined
                  ? // pointerId for pointer events, touch.indentifier for touch events
                    pointer.pointerId
                  : pointer.identifier;
              // track position for move
              this.pointerDownPointer = {
                pageX: pointer.pageX,
                pageY: pointer.pageY,
              };

              this.bindActivePointerEvents();
              this.emitEvent("pointerDown", [event, pointer]);
            };

            // ----- move ----- //

            proto.onmousemove = function (event) {
              this.pointerMove(event, event);
            };

            proto.onpointermove = function (event) {
              this.withPointer("pointerMove", event);
            };

            proto.ontouchmove = function (event) {
              this.withTouch("pointerMove", event);
            };

            proto.pointerMove = function (event, pointer) {
              let moveVector = {
                x: pointer.pageX - this.pointerDownPointer.pageX,
                y: pointer.pageY - this.pointerDownPointer.pageY,
              };
              this.emitEvent("pointerMove", [event, pointer, moveVector]);
              // start drag if pointer has moved far enough to start drag
              let isDragStarting =
                !this.isDragging && this.hasDragStarted(moveVector);
              if (isDragStarting) this.dragStart(event, pointer);
              if (this.isDragging) this.dragMove(event, pointer, moveVector);
            };

            // condition if pointer has moved far enough to start drag
            proto.hasDragStarted = function (moveVector) {
              return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
            };

            // ----- drag ----- //

            proto.dragStart = function (event, pointer) {
              this.isDragging = true;
              this.isPreventingClicks = true; // set flag to prevent clicks
              this.emitEvent("dragStart", [event, pointer]);
            };

            proto.dragMove = function (event, pointer, moveVector) {
              this.emitEvent("dragMove", [event, pointer, moveVector]);
            };

            // ----- end ----- //

            proto.onmouseup = function (event) {
              this.pointerUp(event, event);
            };

            proto.onpointerup = function (event) {
              this.withPointer("pointerUp", event);
            };

            proto.ontouchend = function (event) {
              this.withTouch("pointerUp", event);
            };

            proto.pointerUp = function (event, pointer) {
              this.pointerDone();
              this.emitEvent("pointerUp", [event, pointer]);

              if (this.isDragging) {
                this.dragEnd(event, pointer);
              } else {
                // pointer didn't move enough for drag to start
                this.staticClick(event, pointer);
              }
            };

            proto.dragEnd = function (event, pointer) {
              this.isDragging = false; // reset flag
              // re-enable clicking async
              setTimeout(() => delete this.isPreventingClicks);

              this.emitEvent("dragEnd", [event, pointer]);
            };

            // triggered on pointer up & pointer cancel
            proto.pointerDone = function () {
              this.isPointerDown = false;
              delete this.pointerIdentifier;
              this.unbindActivePointerEvents();
              this.emitEvent("pointerDone");
            };

            // ----- cancel ----- //

            proto.onpointercancel = function (event) {
              this.withPointer("pointerCancel", event);
            };

            proto.ontouchcancel = function (event) {
              this.withTouch("pointerCancel", event);
            };

            proto.pointerCancel = function (event, pointer) {
              this.pointerDone();
              this.emitEvent("pointerCancel", [event, pointer]);
            };

            // ----- click ----- //

            // handle all clicks and prevent clicks when dragging
            proto.onclick = function (event) {
              if (this.isPreventingClicks) event.preventDefault();
            };

            // triggered after pointer down & up with no/tiny movement
            proto.staticClick = function (event, pointer) {
              // ignore emulated mouse up clicks
              let isMouseup = event.type === "mouseup";
              if (isMouseup && this.isIgnoringMouseUp) return;

              this.emitEvent("staticClick", [event, pointer]);

              // set flag for emulated clicks 300ms after touchend
              if (isMouseup) {
                this.isIgnoringMouseUp = true;
                // reset flag after 400ms
                setTimeout(() => {
                  delete this.isIgnoringMouseUp;
                }, 400);
              }
            };

            // -----  ----- //

            return Unidragger;
          }
        );

        /***/
      },

    /***/ "./node_modules/vivus/dist/vivus.js":
      /*!******************************************!*\
  !*** ./node_modules/vivus/dist/vivus.js ***!
  \******************************************/
      /***/ (module, exports) => {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        /**
         * vivus - JavaScript library to make drawing animation on SVG
         * @version v0.4.6
         * @link https://github.com/maxwellito/vivus
         * @license MIT
         */

        (function () {
          "use strict";

          /**
           * Pathformer
           * Beta version
           *
           * Take any SVG version 1.1 and transform
           * child elements to 'path' elements
           *
           * This code is purely forked from
           * https://github.com/Waest/SVGPathConverter
           */

          /**
           * Class constructor
           *
           * @param {DOM|String} element Dom element of the SVG or id of it
           */
          function Pathformer(element) {
            // Test params
            if (typeof element === "undefined") {
              throw new Error(
                'Pathformer [constructor]: "element" parameter is required'
              );
            }

            // Set the element
            if (element.constructor === String) {
              element = document.getElementById(element);
              if (!element) {
                throw new Error(
                  'Pathformer [constructor]: "element" parameter is not related to an existing ID'
                );
              }
            }
            if (
              element instanceof window.SVGElement ||
              element instanceof window.SVGGElement ||
              /^svg$/i.test(element.nodeName)
            ) {
              this.el = element;
            } else {
              throw new Error(
                'Pathformer [constructor]: "element" parameter must be a string or a SVGelement'
              );
            }

            // Start
            this.scan(element);
          }

          /**
           * List of tags which can be transformed
           * to path elements
           *
           * @type {Array}
           */
          Pathformer.prototype.TYPES = [
            "line",
            "ellipse",
            "circle",
            "polygon",
            "polyline",
            "rect",
          ];

          /**
           * List of attribute names which contain
           * data. This array list them to check if
           * they contain bad values, like percentage.
           *
           * @type {Array}
           */
          Pathformer.prototype.ATTR_WATCH = [
            "cx",
            "cy",
            "points",
            "r",
            "rx",
            "ry",
            "x",
            "x1",
            "x2",
            "y",
            "y1",
            "y2",
          ];

          /**
           * Finds the elements compatible for transform
           * and apply the liked method
           *
           * @param  {object} options Object from the constructor
           */
          Pathformer.prototype.scan = function (svg) {
            var fn,
              element,
              pathData,
              pathDom,
              elements = svg.querySelectorAll(this.TYPES.join(","));

            for (var i = 0; i < elements.length; i++) {
              element = elements[i];
              fn = this[element.tagName.toLowerCase() + "ToPath"];
              pathData = fn(this.parseAttr(element.attributes));
              pathDom = this.pathMaker(element, pathData);
              element.parentNode.replaceChild(pathDom, element);
            }
          };

          /**
           * Read `line` element to extract and transform
           * data, to make it ready for a `path` object.
           *
           * @param  {DOMelement} element Line element to transform
           * @return {object}             Data for a `path` element
           */
          Pathformer.prototype.lineToPath = function (element) {
            var newElement = {},
              x1 = element.x1 || 0,
              y1 = element.y1 || 0,
              x2 = element.x2 || 0,
              y2 = element.y2 || 0;

            newElement.d = "M" + x1 + "," + y1 + "L" + x2 + "," + y2;
            return newElement;
          };

          /**
           * Read `rect` element to extract and transform
           * data, to make it ready for a `path` object.
           * The radius-border is not taken in charge yet.
           * (your help is more than welcomed)
           *
           * @param  {DOMelement} element Rect element to transform
           * @return {object}             Data for a `path` element
           */
          Pathformer.prototype.rectToPath = function (element) {
            var newElement = {},
              x = parseFloat(element.x) || 0,
              y = parseFloat(element.y) || 0,
              width = parseFloat(element.width) || 0,
              height = parseFloat(element.height) || 0;

            if (element.rx || element.ry) {
              var rx = parseInt(element.rx, 10) || -1,
                ry = parseInt(element.ry, 10) || -1;
              rx = Math.min(Math.max(rx < 0 ? ry : rx, 0), width / 2);
              ry = Math.min(Math.max(ry < 0 ? rx : ry, 0), height / 2);

              newElement.d =
                "M " +
                (x + rx) +
                "," +
                y +
                " " +
                "L " +
                (x + width - rx) +
                "," +
                y +
                " " +
                "A " +
                rx +
                "," +
                ry +
                ",0,0,1," +
                (x + width) +
                "," +
                (y + ry) +
                " " +
                "L " +
                (x + width) +
                "," +
                (y + height - ry) +
                " " +
                "A " +
                rx +
                "," +
                ry +
                ",0,0,1," +
                (x + width - rx) +
                "," +
                (y + height) +
                " " +
                "L " +
                (x + rx) +
                "," +
                (y + height) +
                " " +
                "A " +
                rx +
                "," +
                ry +
                ",0,0,1," +
                x +
                "," +
                (y + height - ry) +
                " " +
                "L " +
                x +
                "," +
                (y + ry) +
                " " +
                "A " +
                rx +
                "," +
                ry +
                ",0,0,1," +
                (x + rx) +
                "," +
                y;
            } else {
              newElement.d =
                "M" +
                x +
                " " +
                y +
                " " +
                "L" +
                (x + width) +
                " " +
                y +
                " " +
                "L" +
                (x + width) +
                " " +
                (y + height) +
                " " +
                "L" +
                x +
                " " +
                (y + height) +
                " Z";
            }
            return newElement;
          };

          /**
           * Read `polyline` element to extract and transform
           * data, to make it ready for a `path` object.
           *
           * @param  {DOMelement} element Polyline element to transform
           * @return {object}             Data for a `path` element
           */
          Pathformer.prototype.polylineToPath = function (element) {
            var newElement = {},
              points = element.points.trim().split(" "),
              i,
              path;

            // Reformatting if points are defined without commas
            if (element.points.indexOf(",") === -1) {
              var formattedPoints = [];
              for (i = 0; i < points.length; i += 2) {
                formattedPoints.push(points[i] + "," + points[i + 1]);
              }
              points = formattedPoints;
            }

            // Generate the path.d value
            path = "M" + points[0];
            for (i = 1; i < points.length; i++) {
              if (points[i].indexOf(",") !== -1) {
                path += "L" + points[i];
              }
            }
            newElement.d = path;
            return newElement;
          };

          /**
           * Read `polygon` element to extract and transform
           * data, to make it ready for a `path` object.
           * This method rely on polylineToPath, because the
           * logic is similar. The path created is just closed,
           * so it needs an 'Z' at the end.
           *
           * @param  {DOMelement} element Polygon element to transform
           * @return {object}             Data for a `path` element
           */
          Pathformer.prototype.polygonToPath = function (element) {
            var newElement = Pathformer.prototype.polylineToPath(element);

            newElement.d += "Z";
            return newElement;
          };

          /**
           * Read `ellipse` element to extract and transform
           * data, to make it ready for a `path` object.
           *
           * @param  {DOMelement} element ellipse element to transform
           * @return {object}             Data for a `path` element
           */
          Pathformer.prototype.ellipseToPath = function (element) {
            var newElement = {},
              rx = parseFloat(element.rx) || 0,
              ry = parseFloat(element.ry) || 0,
              cx = parseFloat(element.cx) || 0,
              cy = parseFloat(element.cy) || 0,
              startX = cx - rx,
              startY = cy,
              endX = parseFloat(cx) + parseFloat(rx),
              endY = cy;

            newElement.d =
              "M" +
              startX +
              "," +
              startY +
              "A" +
              rx +
              "," +
              ry +
              " 0,1,1 " +
              endX +
              "," +
              endY +
              "A" +
              rx +
              "," +
              ry +
              " 0,1,1 " +
              startX +
              "," +
              endY;
            return newElement;
          };

          /**
           * Read `circle` element to extract and transform
           * data, to make it ready for a `path` object.
           *
           * @param  {DOMelement} element Circle element to transform
           * @return {object}             Data for a `path` element
           */
          Pathformer.prototype.circleToPath = function (element) {
            var newElement = {},
              r = parseFloat(element.r) || 0,
              cx = parseFloat(element.cx) || 0,
              cy = parseFloat(element.cy) || 0,
              startX = cx - r,
              startY = cy,
              endX = parseFloat(cx) + parseFloat(r),
              endY = cy;

            newElement.d =
              "M" +
              startX +
              "," +
              startY +
              "A" +
              r +
              "," +
              r +
              " 0,1,1 " +
              endX +
              "," +
              endY +
              "A" +
              r +
              "," +
              r +
              " 0,1,1 " +
              startX +
              "," +
              endY;
            return newElement;
          };

          /**
           * Create `path` elements form original element
           * and prepared objects
           *
           * @param  {DOMelement} element  Original element to transform
           * @param  {object} pathData     Path data (from `toPath` methods)
           * @return {DOMelement}          Path element
           */
          Pathformer.prototype.pathMaker = function (element, pathData) {
            var i,
              attr,
              pathTag = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "path"
              );
            for (i = 0; i < element.attributes.length; i++) {
              attr = element.attributes[i];
              if (this.ATTR_WATCH.indexOf(attr.name) === -1) {
                pathTag.setAttribute(attr.name, attr.value);
              }
            }
            for (i in pathData) {
              pathTag.setAttribute(i, pathData[i]);
            }
            return pathTag;
          };

          /**
           * Parse attributes of a DOM element to
           * get an object of attribute => value
           *
           * @param  {NamedNodeMap} attributes Attributes object from DOM element to parse
           * @return {object}                  Object of attributes
           */
          Pathformer.prototype.parseAttr = function (element) {
            var attr,
              output = {};
            for (var i = 0; i < element.length; i++) {
              attr = element[i];
              // Check if no data attribute contains '%', or the transformation is impossible
              if (
                this.ATTR_WATCH.indexOf(attr.name) !== -1 &&
                attr.value.indexOf("%") !== -1
              ) {
                throw new Error(
                  "Pathformer [parseAttr]: a SVG shape got values in percentage. This cannot be transformed into 'path' tags. Please use 'viewBox'."
                );
              }
              output[attr.name] = attr.value;
            }
            return output;
          };

          ("use strict");

          var setupEnv, requestAnimFrame, cancelAnimFrame, parsePositiveInt;

          /**
           * Vivus
           * Beta version
           *
           * Take any SVG and make the animation
           * to give give the impression of live drawing
           *
           * This in more than just inspired from codrops
           * At that point, it's a pure fork.
           */

          /**
           * Class constructor
           * option structure
           *   type: 'delayed'|'sync'|'oneByOne'|'script' (to know if the items must be drawn synchronously or not, default: delayed)
           *   duration: <int> (in frames)
           *   start: 'inViewport'|'manual'|'autostart' (start automatically the animation, default: inViewport)
           *   delay: <int> (delay between the drawing of first and last path)
           *   dashGap <integer> whitespace extra margin between dashes
           *   pathTimingFunction <function> timing animation function for each path element of the SVG
           *   animTimingFunction <function> timing animation function for the complete SVG
           *   forceRender <boolean> force the browser to re-render all updated path items
           *   selfDestroy <boolean> removes all extra styling on the SVG, and leaves it as original
           *
           * The attribute 'type' is by default on 'delayed'.
           *  - 'delayed'
           *    all paths are draw at the same time but with a
           *    little delay between them before start
           *  - 'sync'
           *    all path are start and finish at the same time
           *  - 'oneByOne'
           *    only one path is draw at the time
           *    the end of the first one will trigger the draw
           *    of the next one
           *
           * All these values can be overwritten individually
           * for each path item in the SVG
           * The value of frames will always take the advantage of
           * the duration value.
           * If you fail somewhere, an error will be thrown.
           * Good luck.
           *
           * @constructor
           * @this {Vivus}
           * @param {DOM|String}   element  Dom element of the SVG or id of it
           * @param {Object}       options  Options about the animation
           * @param {Function}     callback Callback for the end of the animation
           */
          function Vivus(element, options, callback) {
            setupEnv();

            // Setup
            this.isReady = false;
            this.setElement(element, options);
            this.setOptions(options);
            this.setCallback(callback);

            if (this.isReady) {
              this.init();
            }
          }

          /**
           * Timing functions
           **************************************
           *
           * Default functions to help developers.
           * It always take a number as parameter (between 0 to 1) then
           * return a number (between 0 and 1)
           */
          Vivus.LINEAR = function (x) {
            return x;
          };
          Vivus.EASE = function (x) {
            return -Math.cos(x * Math.PI) / 2 + 0.5;
          };
          Vivus.EASE_OUT = function (x) {
            return 1 - Math.pow(1 - x, 3);
          };
          Vivus.EASE_IN = function (x) {
            return Math.pow(x, 3);
          };
          Vivus.EASE_OUT_BOUNCE = function (x) {
            var base = -Math.cos(x * (0.5 * Math.PI)) + 1,
              rate = Math.pow(base, 1.5),
              rateR = Math.pow(1 - x, 2),
              progress = -Math.abs(Math.cos(rate * (2.5 * Math.PI))) + 1;
            return 1 - rateR + progress * rateR;
          };

          /**
           * Setters
           **************************************
           */

          /**
           * Check and set the element in the instance
           * The method will not return anything, but will throw an
           * error if the parameter is invalid
           *
           * @param {DOM|String}   element  SVG Dom element or id of it
           */
          Vivus.prototype.setElement = function (element, options) {
            var onLoad, self;

            // Basic check
            if (typeof element === "undefined") {
              throw new Error(
                'Vivus [constructor]: "element" parameter is required'
              );
            }

            // Set the element
            if (element.constructor === String) {
              element = document.getElementById(element);
              if (!element) {
                throw new Error(
                  'Vivus [constructor]: "element" parameter is not related to an existing ID'
                );
              }
            }
            this.parentEl = element;

            // Load the SVG with XMLHttpRequest and extract the SVG
            if (options && options.file) {
              self = this;
              onLoad = function () {
                var domSandbox = document.createElement("div");
                domSandbox.innerHTML = this.responseText;

                var svgTag = domSandbox.querySelector("svg");
                if (!svgTag) {
                  throw new Error(
                    "Vivus [load]: Cannot find the SVG in the loaded file : " +
                      options.file
                  );
                }

                self.el = svgTag;
                self.el.setAttribute("width", "100%");
                self.el.setAttribute("height", "100%");
                self.parentEl.appendChild(self.el);
                self.isReady = true;
                self.init();
                self = null;
              };

              var oReq = new window.XMLHttpRequest();
              oReq.addEventListener("load", onLoad);
              oReq.open("GET", options.file);
              oReq.send();
              return;
            }

            switch (element.constructor) {
              case window.SVGSVGElement:
              case window.SVGElement:
              case window.SVGGElement:
                this.el = element;
                this.isReady = true;
                break;

              case window.HTMLObjectElement:
                self = this;
                onLoad = function (e) {
                  if (self.isReady) {
                    return;
                  }
                  self.el =
                    element.contentDocument &&
                    element.contentDocument.querySelector("svg");
                  if (!self.el && e) {
                    throw new Error(
                      "Vivus [constructor]: object loaded does not contain any SVG"
                    );
                  } else if (self.el) {
                    if (element.getAttribute("built-by-vivus")) {
                      self.parentEl.insertBefore(self.el, element);
                      self.parentEl.removeChild(element);
                      self.el.setAttribute("width", "100%");
                      self.el.setAttribute("height", "100%");
                    }
                    self.isReady = true;
                    self.init();
                    self = null;
                  }
                };

                if (!onLoad()) {
                  element.addEventListener("load", onLoad);
                }
                break;

              default:
                throw new Error(
                  'Vivus [constructor]: "element" parameter is not valid (or miss the "file" attribute)'
                );
            }
          };

          /**
           * Set up user option to the instance
           * The method will not return anything, but will throw an
           * error if the parameter is invalid
           *
           * @param  {object} options Object from the constructor
           */
          Vivus.prototype.setOptions = function (options) {
            var allowedTypes = [
              "delayed",
              "sync",
              "async",
              "nsync",
              "oneByOne",
              "scenario",
              "scenario-sync",
            ];
            var allowedStarts = ["inViewport", "manual", "autostart"];

            // Basic check
            if (options !== undefined && options.constructor !== Object) {
              throw new Error(
                'Vivus [constructor]: "options" parameter must be an object'
              );
            } else {
              options = options || {};
            }

            // Set the animation type
            if (options.type && allowedTypes.indexOf(options.type) === -1) {
              throw new Error(
                "Vivus [constructor]: " +
                  options.type +
                  " is not an existing animation `type`"
              );
            } else {
              this.type = options.type || allowedTypes[0];
            }

            // Set the start type
            if (options.start && allowedStarts.indexOf(options.start) === -1) {
              throw new Error(
                "Vivus [constructor]: " +
                  options.start +
                  " is not an existing `start` option"
              );
            } else {
              this.start = options.start || allowedStarts[0];
            }

            this.isIE =
              window.navigator.userAgent.indexOf("MSIE") !== -1 ||
              window.navigator.userAgent.indexOf("Trident/") !== -1 ||
              window.navigator.userAgent.indexOf("Edge/") !== -1;
            this.duration = parsePositiveInt(options.duration, 120);
            this.delay = parsePositiveInt(options.delay, null);
            this.dashGap = parsePositiveInt(options.dashGap, 1);
            this.forceRender = options.hasOwnProperty("forceRender")
              ? !!options.forceRender
              : this.isIE;
            this.reverseStack = !!options.reverseStack;
            this.selfDestroy = !!options.selfDestroy;
            this.onReady = options.onReady;
            this.map = [];
            this.frameLength =
              this.currentFrame =
              this.delayUnit =
              this.speed =
              this.handle =
                null;

            this.ignoreInvisible = options.hasOwnProperty("ignoreInvisible")
              ? !!options.ignoreInvisible
              : false;

            this.animTimingFunction =
              options.animTimingFunction || Vivus.LINEAR;
            this.pathTimingFunction =
              options.pathTimingFunction || Vivus.LINEAR;

            if (this.delay >= this.duration) {
              throw new Error(
                "Vivus [constructor]: delay must be shorter than duration"
              );
            }
          };

          /**
           * Set up callback to the instance
           * The method will not return enything, but will throw an
           * error if the parameter is invalid
           *
           * @param  {Function} callback Callback for the animation end
           */
          Vivus.prototype.setCallback = function (callback) {
            // Basic check
            if (!!callback && callback.constructor !== Function) {
              throw new Error(
                'Vivus [constructor]: "callback" parameter must be a function'
              );
            }
            this.callback = callback || function () {};
          };

          /**
           * Core
           **************************************
           */

          /**
           * Map the svg, path by path.
           * The method return nothing, it just fill the
           * `map` array. Each item in this array represent
           * a path element from the SVG, with informations for
           * the animation.
           *
           * ```
           * [
           *   {
           *     el: <DOMobj> the path element
           *     length: <number> length of the path line
           *     startAt: <number> time start of the path animation (in frames)
           *     duration: <number> path animation duration (in frames)
           *   },
           *   ...
           * ]
           * ```
           *
           */
          Vivus.prototype.mapping = function () {
            var i,
              paths,
              path,
              pAttrs,
              pathObj,
              totalLength,
              lengthMeter,
              timePoint,
              scale,
              hasNonScale;
            timePoint = totalLength = lengthMeter = 0;
            paths = this.el.querySelectorAll("path");
            hasNonScale = false;

            for (i = 0; i < paths.length; i++) {
              path = paths[i];
              if (this.isInvisible(path)) {
                continue;
              }

              pathObj = {
                el: path,
                length: 0,
                startAt: 0,
                duration: 0,
                isResizeSensitive: false,
              };

              // If vector effect is non-scaling-stroke, the total length won't match the rendered length
              // so we need to calculate the scale and apply it
              if (path.getAttribute("vector-effect") === "non-scaling-stroke") {
                var rect = path.getBoundingClientRect();
                var box = path.getBBox();
                scale = Math.max(
                  rect.width / box.width,
                  rect.height / box.height
                );
                pathObj.isResizeSensitive = true;
                hasNonScale = true;
              } else {
                scale = 1;
              }
              pathObj.length = Math.ceil(path.getTotalLength() * scale);

              // Test if the path length is correct
              if (isNaN(pathObj.length)) {
                if (window.console && console.warn) {
                  console.warn(
                    "Vivus [mapping]: cannot retrieve a path element length",
                    path
                  );
                }
                continue;
              }
              this.map.push(pathObj);
              path.style.strokeDasharray =
                pathObj.length + " " + (pathObj.length + this.dashGap * 2);
              path.style.strokeDashoffset = pathObj.length + this.dashGap;
              pathObj.length += this.dashGap;
              totalLength += pathObj.length;

              this.renderPath(i);
            }

            // Show a warning for non-scaling elements
            if (hasNonScale) {
              console.warn(
                "Vivus: this SVG contains non-scaling-strokes. You should call instance.recalc() when the SVG is resized or you will encounter unwanted behaviour. See https://github.com/maxwellito/vivus#non-scaling for more info."
              );
            }

            totalLength = totalLength === 0 ? 1 : totalLength;
            this.delay = this.delay === null ? this.duration / 3 : this.delay;
            this.delayUnit =
              this.delay / (paths.length > 1 ? paths.length - 1 : 1);

            // Reverse stack if asked
            if (this.reverseStack) {
              this.map.reverse();
            }

            for (i = 0; i < this.map.length; i++) {
              pathObj = this.map[i];

              switch (this.type) {
                case "delayed":
                  pathObj.startAt = this.delayUnit * i;
                  pathObj.duration = this.duration - this.delay;
                  break;

                case "oneByOne":
                  pathObj.startAt = (lengthMeter / totalLength) * this.duration;
                  pathObj.duration =
                    (pathObj.length / totalLength) * this.duration;
                  break;

                case "sync":
                case "async":
                case "nsync":
                  pathObj.startAt = 0;
                  pathObj.duration = this.duration;
                  break;

                case "scenario-sync":
                  path = pathObj.el;
                  pAttrs = this.parseAttr(path);
                  pathObj.startAt =
                    timePoint +
                    (parsePositiveInt(pAttrs["data-delay"], this.delayUnit) ||
                      0);
                  pathObj.duration = parsePositiveInt(
                    pAttrs["data-duration"],
                    this.duration
                  );
                  timePoint =
                    pAttrs["data-async"] !== undefined
                      ? pathObj.startAt
                      : pathObj.startAt + pathObj.duration;
                  this.frameLength = Math.max(
                    this.frameLength,
                    pathObj.startAt + pathObj.duration
                  );
                  break;

                case "scenario":
                  path = pathObj.el;
                  pAttrs = this.parseAttr(path);
                  pathObj.startAt =
                    parsePositiveInt(pAttrs["data-start"], this.delayUnit) || 0;
                  pathObj.duration = parsePositiveInt(
                    pAttrs["data-duration"],
                    this.duration
                  );
                  this.frameLength = Math.max(
                    this.frameLength,
                    pathObj.startAt + pathObj.duration
                  );
                  break;
              }
              lengthMeter += pathObj.length;
              this.frameLength = this.frameLength || this.duration;
            }
          };

          /**
           * Public method to re-evaluate line length for non-scaling lines
           * path elements.
           */
          Vivus.prototype.recalc = function () {
            if (this.mustRecalcScale) {
              return;
            }
            this.mustRecalcScale = requestAnimFrame(
              function () {
                this.performLineRecalc();
              }.bind(this)
            );
          };

          /**
           * Private method to re-evaluate line length on non-scaling
           * path elements. Then call for a trace to update the SVG.
           */
          Vivus.prototype.performLineRecalc = function () {
            var pathObj, path, rect, box, scale;
            for (var i = 0; i < this.map.length; i++) {
              pathObj = this.map[i];
              if (pathObj.isResizeSensitive) {
                path = pathObj.el;
                rect = path.getBoundingClientRect();
                box = path.getBBox();
                scale = Math.max(
                  rect.width / box.width,
                  rect.height / box.height
                );
                pathObj.length = Math.ceil(path.getTotalLength() * scale);
                path.style.strokeDasharray =
                  pathObj.length + " " + (pathObj.length + this.dashGap * 2);
              }
            }
            this.trace();
            this.mustRecalcScale = null;
          };

          /**
           * Interval method to draw the SVG from current
           * position of the animation. It update the value of
           * `currentFrame` and re-trace the SVG.
           *
           * It use this.handle to store the requestAnimationFrame
           * and clear it one the animation is stopped. So this
           * attribute can be used to know if the animation is
           * playing.
           *
           * Once the animation at the end, this method will
           * trigger the Vivus callback.
           *
           */
          Vivus.prototype.draw = function () {
            var self = this;
            this.currentFrame += this.speed;

            if (this.currentFrame <= 0) {
              this.stop();
              this.reset();
            } else if (this.currentFrame >= this.frameLength) {
              this.stop();
              this.currentFrame = this.frameLength;
              this.trace();
              if (this.selfDestroy) {
                this.destroy();
              }
            } else {
              this.trace();
              this.handle = requestAnimFrame(function () {
                self.draw();
              });
              return;
            }

            this.callback(this);
            if (this.instanceCallback) {
              this.instanceCallback(this);
              this.instanceCallback = null;
            }
          };

          /**
           * Draw the SVG at the current instant from the
           * `currentFrame` value. Here is where most of the magic is.
           * The trick is to use the `strokeDashoffset` style property.
           *
           * For optimisation reasons, a new property called `progress`
           * is added in each item of `map`. This one contain the current
           * progress of the path element. Only if the new value is different
           * the new value will be applied to the DOM element. This
           * method save a lot of resources to re-render the SVG. And could
           * be improved if the animation couldn't be played forward.
           *
           */
          Vivus.prototype.trace = function () {
            var i, progress, path, currentFrame;
            currentFrame =
              this.animTimingFunction(this.currentFrame / this.frameLength) *
              this.frameLength;
            for (i = 0; i < this.map.length; i++) {
              path = this.map[i];
              progress = (currentFrame - path.startAt) / path.duration;
              progress = this.pathTimingFunction(
                Math.max(0, Math.min(1, progress))
              );
              if (path.progress !== progress) {
                path.progress = progress;
                path.el.style.strokeDashoffset = Math.floor(
                  path.length * (1 - progress)
                );
                this.renderPath(i);
              }
            }
          };

          /**
           * Method forcing the browser to re-render a path element
           * from it's index in the map. Depending on the `forceRender`
           * value.
           * The trick is to replace the path element by it's clone.
           * This practice is not recommended because it's asking more
           * ressources, too much DOM manupulation..
           * but it's the only way to let the magic happen on IE.
           * By default, this fallback is only applied on IE.
           *
           * @param  {Number} index Path index
           */
          Vivus.prototype.renderPath = function (index) {
            if (this.forceRender && this.map && this.map[index]) {
              var pathObj = this.map[index],
                newPath = pathObj.el.cloneNode(true);
              pathObj.el.parentNode.replaceChild(newPath, pathObj.el);
              pathObj.el = newPath;
            }
          };

          /**
           * When the SVG object is loaded and ready,
           * this method will continue the initialisation.
           *
           * This this mainly due to the case of passing an
           * object tag in the constructor. It will wait
           * the end of the loading to initialise.
           *
           */
          Vivus.prototype.init = function () {
            // Set object variables
            this.frameLength = 0;
            this.currentFrame = 0;
            this.map = [];

            // Start
            new Pathformer(this.el);
            this.mapping();
            this.starter();

            if (this.onReady) {
              this.onReady(this);
            }
          };

          /**
           * Trigger to start of the animation.
           * Depending on the `start` value, a different script
           * will be applied.
           *
           * If the `start` value is not valid, an error will be thrown.
           * Even if technically, this is impossible.
           *
           */
          Vivus.prototype.starter = function () {
            switch (this.start) {
              case "manual":
                return;

              case "autostart":
                this.play();
                break;

              case "inViewport":
                var self = this,
                  listener = function () {
                    if (self.isInViewport(self.parentEl, 1)) {
                      self.play();
                      window.removeEventListener("scroll", listener);
                    }
                  };
                window.addEventListener("scroll", listener);
                listener();
                break;
            }
          };

          /**
           * Controls
           **************************************
           */

          /**
           * Get the current status of the animation between
           * three different states: 'start', 'progress', 'end'.
           * @return {string} Instance status
           */
          Vivus.prototype.getStatus = function () {
            return this.currentFrame === 0
              ? "start"
              : this.currentFrame === this.frameLength
              ? "end"
              : "progress";
          };

          /**
           * Reset the instance to the initial state : undraw
           * Be careful, it just reset the animation, if you're
           * playing the animation, this won't stop it. But just
           * make it start from start.
           *
           */
          Vivus.prototype.reset = function () {
            return this.setFrameProgress(0);
          };

          /**
           * Set the instance to the final state : drawn
           * Be careful, it just set the animation, if you're
           * playing the animation on rewind, this won't stop it.
           * But just make it start from the end.
           *
           */
          Vivus.prototype.finish = function () {
            return this.setFrameProgress(1);
          };

          /**
           * Set the level of progress of the drawing.
           *
           * @param {number} progress Level of progress to set
           */
          Vivus.prototype.setFrameProgress = function (progress) {
            progress = Math.min(1, Math.max(0, progress));
            this.currentFrame = Math.round(this.frameLength * progress);
            this.trace();
            return this;
          };

          /**
           * Play the animation at the desired speed.
           * Speed must be a valid number (no zero).
           * By default, the speed value is 1.
           * But a negative value is accepted to go forward.
           *
           * And works with float too.
           * But don't forget we are in JavaScript, se be nice
           * with him and give him a 1/2^x value.
           *
           * @param  {number} speed Animation speed [optional]
           */
          Vivus.prototype.play = function (speed, callback) {
            this.instanceCallback = null;

            if (speed && typeof speed === "function") {
              this.instanceCallback = speed; // first parameter is actually the callback function
              speed = null;
            } else if (speed && typeof speed !== "number") {
              throw new Error("Vivus [play]: invalid speed");
            }
            // if the first parameter wasn't the callback, check if the seconds was
            if (
              callback &&
              typeof callback === "function" &&
              !this.instanceCallback
            ) {
              this.instanceCallback = callback;
            }

            this.speed = speed || 1;
            if (!this.handle) {
              this.draw();
            }
            return this;
          };

          /**
           * Stop the current animation, if on progress.
           * Should not trigger any error.
           *
           */
          Vivus.prototype.stop = function () {
            if (this.handle) {
              cancelAnimFrame(this.handle);
              this.handle = null;
            }
            return this;
          };

          /**
           * Destroy the instance.
           * Remove all bad styling attributes on all
           * path tags
           *
           */
          Vivus.prototype.destroy = function () {
            this.stop();
            var i, path;
            for (i = 0; i < this.map.length; i++) {
              path = this.map[i];
              path.el.style.strokeDashoffset = null;
              path.el.style.strokeDasharray = null;
              this.renderPath(i);
            }
          };

          /**
           * Utils methods
           * include methods from Codrops
           **************************************
           */

          /**
           * Method to best guess if a path should added into
           * the animation or not.
           *
           * 1. Use the `data-vivus-ignore` attribute if set
           * 2. Check if the instance must ignore invisible paths
           * 3. Check if the path is visible
           *
           * For now the visibility checking is unstable.
           * It will be used for a beta phase.
           *
           * Other improvments are planned. Like detecting
           * is the path got a stroke or a valid opacity.
           */
          Vivus.prototype.isInvisible = function (el) {
            var rect,
              ignoreAttr = el.getAttribute("data-ignore");

            if (ignoreAttr !== null) {
              return ignoreAttr !== "false";
            }

            if (this.ignoreInvisible) {
              rect = el.getBoundingClientRect();
              return !rect.width && !rect.height;
            } else {
              return false;
            }
          };

          /**
           * Parse attributes of a DOM element to
           * get an object of {attributeName => attributeValue}
           *
           * @param  {object} element DOM element to parse
           * @return {object}         Object of attributes
           */
          Vivus.prototype.parseAttr = function (element) {
            var attr,
              output = {};
            if (element && element.attributes) {
              for (var i = 0; i < element.attributes.length; i++) {
                attr = element.attributes[i];
                output[attr.name] = attr.value;
              }
            }
            return output;
          };

          /**
           * Reply if an element is in the page viewport
           *
           * @param  {object} el Element to observe
           * @param  {number} h  Percentage of height
           * @return {boolean}
           */
          Vivus.prototype.isInViewport = function (el, h) {
            var scrolled = this.scrollY(),
              viewed = scrolled + this.getViewportH(),
              elBCR = el.getBoundingClientRect(),
              elHeight = elBCR.height,
              elTop = scrolled + elBCR.top,
              elBottom = elTop + elHeight;

            // if 0, the element is considered in the viewport as soon as it enters.
            // if 1, the element is considered in the viewport only when it's fully inside
            // value in percentage (1 >= h >= 0)
            h = h || 0;

            return elTop + elHeight * h <= viewed && elBottom >= scrolled;
          };

          /**
           * Get the viewport height in pixels
           *
           * @return {integer} Viewport height
           */
          Vivus.prototype.getViewportH = function () {
            var client = this.docElem.clientHeight,
              inner = window.innerHeight;

            if (client < inner) {
              return inner;
            } else {
              return client;
            }
          };

          /**
           * Get the page Y offset
           *
           * @return {integer} Page Y offset
           */
          Vivus.prototype.scrollY = function () {
            return window.pageYOffset || this.docElem.scrollTop;
          };

          setupEnv = function () {
            if (Vivus.prototype.docElem) {
              return;
            }

            /**
             * Alias for document element
             *
             * @type {DOMelement}
             */
            Vivus.prototype.docElem = window.document.documentElement;

            /**
             * Alias for `requestAnimationFrame` or
             * `setTimeout` function for deprecated browsers.
             *
             */
            requestAnimFrame = (function () {
              return (
                window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                function (/* function */ callback) {
                  return window.setTimeout(callback, 1000 / 60);
                }
              );
            })();

            /**
             * Alias for `cancelAnimationFrame` or
             * `cancelTimeout` function for deprecated browsers.
             *
             */
            cancelAnimFrame = (function () {
              return (
                window.cancelAnimationFrame ||
                window.webkitCancelAnimationFrame ||
                window.mozCancelAnimationFrame ||
                window.oCancelAnimationFrame ||
                window.msCancelAnimationFrame ||
                function (id) {
                  return window.clearTimeout(id);
                }
              );
            })();
          };

          /**
           * Parse string to integer.
           * If the number is not positive or null
           * the method will return the default value
           * or 0 if undefined
           *
           * @param {string} value String to parse
           * @param {*} defaultValue Value to return if the result parsed is invalid
           * @return {number}
           *
           */
          parsePositiveInt = function (value, defaultValue) {
            var output = parseInt(value, 10);
            return output >= 0 ? output : defaultValue;
          };

          if (true) {
            // AMD. Register as an anonymous module.
            !((__WEBPACK_AMD_DEFINE_ARRAY__ = []),
            (__WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return Vivus;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined &&
              (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {
          }
        })();

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/autocomplete.vue":
      /*!************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/autocomplete.vue ***!
  \************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _autocomplete_vue_vue_type_template_id_2c922d06___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./autocomplete.vue?vue&type=template&id=2c922d06& */ "./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=template&id=2c922d06&"
          );
        /* harmony import */ var _autocomplete_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./autocomplete.vue?vue&type=script&lang=js& */ "./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=script&lang=js&"
          );
        /* harmony import */ var _vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! !../../../vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
          );

        /* normalize component */
        var component = (0,
        _vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[
          "default"
        ])(
          _autocomplete_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ],
          _autocomplete_vue_vue_type_template_id_2c922d06___WEBPACK_IMPORTED_MODULE_0__.render,
          _autocomplete_vue_vue_type_template_id_2c922d06___WEBPACK_IMPORTED_MODULE_0__.staticRenderFns,
          false,
          null,
          null,
          null
        );

        /* hot reload */
        if (false) {
          var api;
        }
        component.options.__file =
          "node_modules/vue2-google-maps/dist/components/autocomplete.vue";
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          component.exports;

        /***/
      },

    /***/ "./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=script&lang=js&":
      /*!************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=script&lang=js& ***!
  \************************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          (function (x) {
            return x.default || x;
          })(
            __webpack_require__(
              /*! ./autocompleteImpl.js */ "./node_modules/vue2-google-maps/dist/components/autocompleteImpl.js"
            )
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/infoWindow.vue":
      /*!**********************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/infoWindow.vue ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _infoWindow_vue_vue_type_template_id_17fc7ddc___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./infoWindow.vue?vue&type=template&id=17fc7ddc& */ "./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=template&id=17fc7ddc&"
          );
        /* harmony import */ var _infoWindow_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./infoWindow.vue?vue&type=script&lang=js& */ "./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=script&lang=js&"
          );
        /* harmony import */ var _vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! !../../../vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
          );

        /* normalize component */
        var component = (0,
        _vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[
          "default"
        ])(
          _infoWindow_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ],
          _infoWindow_vue_vue_type_template_id_17fc7ddc___WEBPACK_IMPORTED_MODULE_0__.render,
          _infoWindow_vue_vue_type_template_id_17fc7ddc___WEBPACK_IMPORTED_MODULE_0__.staticRenderFns,
          false,
          null,
          null,
          null
        );

        /* hot reload */
        if (false) {
          var api;
        }
        component.options.__file =
          "node_modules/vue2-google-maps/dist/components/infoWindow.vue";
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          component.exports;

        /***/
      },

    /***/ "./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=script&lang=js&":
      /*!**********************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=script&lang=js& ***!
  \**********************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          (function (x) {
            return x.default || x;
          })(
            __webpack_require__(
              /*! ./infoWindowImpl.js */ "./node_modules/vue2-google-maps/dist/components/infoWindowImpl.js"
            )
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/map.vue":
      /*!***************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/map.vue ***!
  \***************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _map_vue_vue_type_template_id_85ca06a4___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./map.vue?vue&type=template&id=85ca06a4& */ "./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=template&id=85ca06a4&"
          );
        /* harmony import */ var _map_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./map.vue?vue&type=script&lang=js& */ "./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=script&lang=js&"
          );
        /* harmony import */ var _map_vue_vue_type_style_index_0_id_85ca06a4_lang_css___WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./map.vue?vue&type=style&index=0&id=85ca06a4&lang=css& */ "./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=85ca06a4&lang=css&"
          );
        /* harmony import */ var _vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! !../../../vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
          );

        /* normalize component */

        var component = (0,
        _vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[
          "default"
        ])(
          _map_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ],
          _map_vue_vue_type_template_id_85ca06a4___WEBPACK_IMPORTED_MODULE_0__.render,
          _map_vue_vue_type_template_id_85ca06a4___WEBPACK_IMPORTED_MODULE_0__.staticRenderFns,
          false,
          null,
          null,
          null
        );

        /* hot reload */
        if (false) {
          var api;
        }
        component.options.__file =
          "node_modules/vue2-google-maps/dist/components/map.vue";
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          component.exports;

        /***/
      },

    /***/ "./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=script&lang=js&":
      /*!***************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=script&lang=js& ***!
  \***************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          (function (x) {
            return x.default || x;
          })(
            __webpack_require__(
              /*! ./mapImpl.js */ "./node_modules/vue2-google-maps/dist/components/mapImpl.js"
            )
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/placeInput.vue":
      /*!**********************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/placeInput.vue ***!
  \**********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ __esModule: () =>
            /* reexport safe */ _placeInputImpl_js_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__.__esModule,
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _placeInput_vue_vue_type_template_id_c1ab87be___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./placeInput.vue?vue&type=template&id=c1ab87be& */ "./node_modules/vue2-google-maps/dist/components/placeInput.vue?vue&type=template&id=c1ab87be&"
          );
        /* harmony import */ var _placeInputImpl_js_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./placeInputImpl.js?vue&type=script&lang=js& */ "./node_modules/vue2-google-maps/dist/components/placeInputImpl.js?vue&type=script&lang=js&?79b4"
          );
        /* harmony import */ var _vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! !../../../vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
          );

        /* normalize component */
        var component = (0,
        _vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[
          "default"
        ])(
          _placeInputImpl_js_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ],
          _placeInput_vue_vue_type_template_id_c1ab87be___WEBPACK_IMPORTED_MODULE_0__.render,
          _placeInput_vue_vue_type_template_id_c1ab87be___WEBPACK_IMPORTED_MODULE_0__.staticRenderFns,
          false,
          null,
          null,
          null
        );

        /* hot reload */
        if (false) {
          var api;
        }
        component.options.__file =
          "node_modules/vue2-google-maps/dist/components/placeInput.vue";
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          component.exports;

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue":
      /*!******************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue ***!
  \******************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _streetViewPanorama_vue_vue_type_template_id_ed35740a___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! ./streetViewPanorama.vue?vue&type=template&id=ed35740a& */ "./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=template&id=ed35740a&"
          );
        /* harmony import */ var _streetViewPanorama_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ =
          __webpack_require__(
            /*! ./streetViewPanorama.vue?vue&type=script&lang=js& */ "./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=script&lang=js&"
          );
        /* harmony import */ var _streetViewPanorama_vue_vue_type_style_index_0_id_ed35740a_lang_css___WEBPACK_IMPORTED_MODULE_2__ =
          __webpack_require__(
            /*! ./streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css& */ "./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css&"
          );
        /* harmony import */ var _vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ =
          __webpack_require__(
            /*! !../../../vue-loader/lib/runtime/componentNormalizer.js */ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js"
          );

        /* normalize component */

        var component = (0,
        _vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[
          "default"
        ])(
          _streetViewPanorama_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[
            "default"
          ],
          _streetViewPanorama_vue_vue_type_template_id_ed35740a___WEBPACK_IMPORTED_MODULE_0__.render,
          _streetViewPanorama_vue_vue_type_template_id_ed35740a___WEBPACK_IMPORTED_MODULE_0__.staticRenderFns,
          false,
          null,
          null,
          null
        );

        /* hot reload */
        if (false) {
          var api;
        }
        component.options.__file =
          "node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue";
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          component.exports;

        /***/
      },

    /***/ "./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=script&lang=js&":
      /*!******************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=script&lang=js& ***!
  \******************************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          (function (x) {
            return x.default || x;
          })(
            __webpack_require__(
              /*! ./streetViewPanoramaImpl.js */ "./node_modules/vue2-google-maps/dist/components/streetViewPanoramaImpl.js"
            )
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=85ca06a4&lang=css&":
      /*!************************************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=85ca06a4&lang=css& ***!
  \************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var _style_loader_dist_cjs_js_laravel_mix_node_modules_css_loader_dist_cjs_js_clonedRuleSet_9_use_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_dist_cjs_js_clonedRuleSet_9_use_2_vue_loader_lib_index_js_vue_loader_options_map_vue_vue_type_style_index_0_id_85ca06a4_lang_css___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../style-loader/dist/cjs.js!../../../laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!../../../vue-loader/lib/loaders/stylePostLoader.js!../../../postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!../../../vue-loader/lib/index.js??vue-loader-options!./map.vue?vue&type=style&index=0&id=85ca06a4&lang=css& */ "./node_modules/style-loader/dist/cjs.js!./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=style&index=0&id=85ca06a4&lang=css&"
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css&":
      /*!***************************************************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css& ***!
  \***************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony import */ var _style_loader_dist_cjs_js_laravel_mix_node_modules_css_loader_dist_cjs_js_clonedRuleSet_9_use_1_vue_loader_lib_loaders_stylePostLoader_js_postcss_loader_dist_cjs_js_clonedRuleSet_9_use_2_vue_loader_lib_index_js_vue_loader_options_streetViewPanorama_vue_vue_type_style_index_0_id_ed35740a_lang_css___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../style-loader/dist/cjs.js!../../../laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!../../../vue-loader/lib/loaders/stylePostLoader.js!../../../postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!../../../vue-loader/lib/index.js??vue-loader-options!./streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css& */ "./node_modules/style-loader/dist/cjs.js!./node_modules/laravel-mix/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=style&index=0&id=ed35740a&lang=css&"
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=script&lang=js&":
      /*!*************************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=script&lang=js& ***!
  \*************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _vue_loader_lib_index_js_vue_loader_options_autocomplete_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../vue-loader/lib/index.js??vue-loader-options!./autocomplete.vue?vue&type=script&lang=js& */ "./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=script&lang=js&"
          );
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _vue_loader_lib_index_js_vue_loader_options_autocomplete_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[
            "default"
          ];

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=script&lang=js&":
      /*!***********************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=script&lang=js& ***!
  \***********************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _vue_loader_lib_index_js_vue_loader_options_infoWindow_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../vue-loader/lib/index.js??vue-loader-options!./infoWindow.vue?vue&type=script&lang=js& */ "./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=script&lang=js&"
          );
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _vue_loader_lib_index_js_vue_loader_options_infoWindow_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[
            "default"
          ];

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=script&lang=js&":
      /*!****************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=script&lang=js& ***!
  \****************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _vue_loader_lib_index_js_vue_loader_options_map_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../vue-loader/lib/index.js??vue-loader-options!./map.vue?vue&type=script&lang=js& */ "./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=script&lang=js&"
          );
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _vue_loader_lib_index_js_vue_loader_options_map_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[
            "default"
          ];

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=script&lang=js&":
      /*!*******************************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=script&lang=js& ***!
  \*******************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _vue_loader_lib_index_js_vue_loader_options_streetViewPanorama_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../vue-loader/lib/index.js??vue-loader-options!./streetViewPanorama.vue?vue&type=script&lang=js& */ "./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=script&lang=js&"
          );
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _vue_loader_lib_index_js_vue_loader_options_streetViewPanorama_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[
            "default"
          ];

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=template&id=2c922d06&":
      /*!*******************************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=template&id=2c922d06& ***!
  \*******************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ render: () =>
            /* reexport safe */ _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_autocomplete_vue_vue_type_template_id_2c922d06___WEBPACK_IMPORTED_MODULE_0__.render,
          /* harmony export */ staticRenderFns: () =>
            /* reexport safe */ _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_autocomplete_vue_vue_type_template_id_2c922d06___WEBPACK_IMPORTED_MODULE_0__.staticRenderFns,
          /* harmony export */
        });
        /* harmony import */ var _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_autocomplete_vue_vue_type_template_id_2c922d06___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../../vue-loader/lib/index.js??vue-loader-options!./autocomplete.vue?vue&type=template&id=2c922d06& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=template&id=2c922d06&"
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=template&id=17fc7ddc&":
      /*!*****************************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=template&id=17fc7ddc& ***!
  \*****************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ render: () =>
            /* reexport safe */ _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_infoWindow_vue_vue_type_template_id_17fc7ddc___WEBPACK_IMPORTED_MODULE_0__.render,
          /* harmony export */ staticRenderFns: () =>
            /* reexport safe */ _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_infoWindow_vue_vue_type_template_id_17fc7ddc___WEBPACK_IMPORTED_MODULE_0__.staticRenderFns,
          /* harmony export */
        });
        /* harmony import */ var _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_infoWindow_vue_vue_type_template_id_17fc7ddc___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../../vue-loader/lib/index.js??vue-loader-options!./infoWindow.vue?vue&type=template&id=17fc7ddc& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=template&id=17fc7ddc&"
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=template&id=85ca06a4&":
      /*!**********************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=template&id=85ca06a4& ***!
  \**********************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ render: () =>
            /* reexport safe */ _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_map_vue_vue_type_template_id_85ca06a4___WEBPACK_IMPORTED_MODULE_0__.render,
          /* harmony export */ staticRenderFns: () =>
            /* reexport safe */ _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_map_vue_vue_type_template_id_85ca06a4___WEBPACK_IMPORTED_MODULE_0__.staticRenderFns,
          /* harmony export */
        });
        /* harmony import */ var _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_map_vue_vue_type_template_id_85ca06a4___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../../vue-loader/lib/index.js??vue-loader-options!./map.vue?vue&type=template&id=85ca06a4& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=template&id=85ca06a4&"
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/placeInput.vue?vue&type=template&id=c1ab87be&":
      /*!*****************************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/placeInput.vue?vue&type=template&id=c1ab87be& ***!
  \*****************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ render: () =>
            /* reexport safe */ _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_placeInput_vue_vue_type_template_id_c1ab87be___WEBPACK_IMPORTED_MODULE_0__.render,
          /* harmony export */ staticRenderFns: () =>
            /* reexport safe */ _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_placeInput_vue_vue_type_template_id_c1ab87be___WEBPACK_IMPORTED_MODULE_0__.staticRenderFns,
          /* harmony export */
        });
        /* harmony import */ var _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_placeInput_vue_vue_type_template_id_c1ab87be___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../../vue-loader/lib/index.js??vue-loader-options!./placeInput.vue?vue&type=template&id=c1ab87be& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/placeInput.vue?vue&type=template&id=c1ab87be&"
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=template&id=ed35740a&":
      /*!*************************************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=template&id=ed35740a& ***!
  \*************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ render: () =>
            /* reexport safe */ _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_streetViewPanorama_vue_vue_type_template_id_ed35740a___WEBPACK_IMPORTED_MODULE_0__.render,
          /* harmony export */ staticRenderFns: () =>
            /* reexport safe */ _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_streetViewPanorama_vue_vue_type_template_id_ed35740a___WEBPACK_IMPORTED_MODULE_0__.staticRenderFns,
          /* harmony export */
        });
        /* harmony import */ var _vue_loader_lib_loaders_templateLoader_js_ruleSet_1_rules_2_vue_loader_lib_index_js_vue_loader_options_streetViewPanorama_vue_vue_type_template_id_ed35740a___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!../../../vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!../../../vue-loader/lib/index.js??vue-loader-options!./streetViewPanorama.vue?vue&type=template&id=ed35740a& */ "./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=template&id=ed35740a&"
          );

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/placeInputImpl.js?vue&type=script&lang=js&?79b4":
      /*!**************************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/placeInputImpl.js?vue&type=script&lang=js& ***!
  \**************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ __esModule: () =>
            /* reexport safe */ _placeInputImpl_js_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__.__esModule,
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        /* harmony import */ var _placeInputImpl_js_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ =
          __webpack_require__(
            /*! -!./placeInputImpl.js?vue&type=script&lang=js& */ "./node_modules/vue2-google-maps/dist/components/placeInputImpl.js?vue&type=script&lang=js&?0ebb"
          );
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ =
          _placeInputImpl_js_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[
            "default"
          ];

        /***/
      },

    /***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=template&id=2c922d06&":
      /*!***********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/autocomplete.vue?vue&type=template&id=2c922d06& ***!
  \***********************************************************************************************************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ render: () => /* binding */ render,
          /* harmony export */ staticRenderFns: () =>
            /* binding */ staticRenderFns,
          /* harmony export */
        });
        var render = function render() {
          var _vm = this,
            _c = _vm._self._c,
            _setup = _vm._self._setupProxy;
          return _c(
            "input",
            _vm._g(
              _vm._b({ ref: "input" }, "input", _vm.$attrs, false),
              _vm.$listeners
            )
          );
        };
        var staticRenderFns = [];
        render._withStripped = true;

        /***/
      },

    /***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=template&id=17fc7ddc&":
      /*!*********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/infoWindow.vue?vue&type=template&id=17fc7ddc& ***!
  \*********************************************************************************************************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ render: () => /* binding */ render,
          /* harmony export */ staticRenderFns: () =>
            /* binding */ staticRenderFns,
          /* harmony export */
        });
        var render = function render() {
          var _vm = this,
            _c = _vm._self._c,
            _setup = _vm._self._setupProxy;
          return _c("div", [
            _c("div", { ref: "flyaway" }, [_vm._t("default")], 2),
          ]);
        };
        var staticRenderFns = [];
        render._withStripped = true;

        /***/
      },

    /***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=template&id=85ca06a4&":
      /*!**************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/map.vue?vue&type=template&id=85ca06a4& ***!
  \**************************************************************************************************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ render: () => /* binding */ render,
          /* harmony export */ staticRenderFns: () =>
            /* binding */ staticRenderFns,
          /* harmony export */
        });
        var render = function render() {
          var _vm = this,
            _c = _vm._self._c,
            _setup = _vm._self._setupProxy;
          return _c(
            "div",
            { staticClass: "vue-map-container" },
            [
              _c("div", { ref: "vue-map", staticClass: "vue-map" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vue-map-hidden" },
                [_vm._t("default")],
                2
              ),
              _vm._v(" "),
              _vm._t("visible"),
            ],
            2
          );
        };
        var staticRenderFns = [];
        render._withStripped = true;

        /***/
      },

    /***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/placeInput.vue?vue&type=template&id=c1ab87be&":
      /*!*********************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/placeInput.vue?vue&type=template&id=c1ab87be& ***!
  \*********************************************************************************************************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ render: () => /* binding */ render,
          /* harmony export */ staticRenderFns: () =>
            /* binding */ staticRenderFns,
          /* harmony export */
        });
        var render = function render() {
          var _vm = this,
            _c = _vm._self._c,
            _setup = _vm._self._setupProxy;
          return _c("label", [
            _c("span", { domProps: { textContent: _vm._s(_vm.label) } }),
            _vm._v(" "),
            _c("input", {
              ref: "input",
              class: _vm.className,
              attrs: { type: "text", placeholder: _vm.placeholder },
            }),
          ]);
        };
        var staticRenderFns = [];
        render._withStripped = true;

        /***/
      },

    /***/ "./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=template&id=ed35740a&":
      /*!*****************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/loaders/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/lib/index.js??vue-loader-options!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue?vue&type=template&id=ed35740a& ***!
  \*****************************************************************************************************************************************************************************************************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ render: () => /* binding */ render,
          /* harmony export */ staticRenderFns: () =>
            /* binding */ staticRenderFns,
          /* harmony export */
        });
        var render = function render() {
          var _vm = this,
            _c = _vm._self._c,
            _setup = _vm._self._setupProxy;
          return _c(
            "div",
            { staticClass: "vue-street-view-pano-container" },
            [
              _c("div", {
                ref: "vue-street-view-pano",
                staticClass: "vue-street-view-pano",
              }),
              _vm._v(" "),
              _vm._t("default"),
            ],
            2
          );
        };
        var staticRenderFns = [];
        render._withStripped = true;

        /***/
      },

    /***/ "./node_modules/vue-loader/lib/runtime/componentNormalizer.js":
      /*!********************************************************************!*\
  !*** ./node_modules/vue-loader/lib/runtime/componentNormalizer.js ***!
  \********************************************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => /* binding */ normalizeComponent,
          /* harmony export */
        });
        /* globals __VUE_SSR_CONTEXT__ */

        // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
        // This module is a runtime utility for cleaner component module output and will
        // be included in the final webpack user bundle.

        function normalizeComponent(
          scriptExports,
          render,
          staticRenderFns,
          functionalTemplate,
          injectStyles,
          scopeId,
          moduleIdentifier /* server only */,
          shadowMode /* vue-cli only */
        ) {
          // Vue.extend constructor export interop
          var options =
            typeof scriptExports === "function"
              ? scriptExports.options
              : scriptExports;

          // render functions
          if (render) {
            options.render = render;
            options.staticRenderFns = staticRenderFns;
            options._compiled = true;
          }

          // functional template
          if (functionalTemplate) {
            options.functional = true;
          }

          // scopedId
          if (scopeId) {
            options._scopeId = "data-v-" + scopeId;
          }

          var hook;
          if (moduleIdentifier) {
            // server build
            hook = function (context) {
              // 2.3 injection
              context =
                context || // cached call
                (this.$vnode && this.$vnode.ssrContext) || // stateful
                (this.parent &&
                  this.parent.$vnode &&
                  this.parent.$vnode.ssrContext); // functional
              // 2.2 with runInNewContext: true
              if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
                context = __VUE_SSR_CONTEXT__;
              }
              // inject component styles
              if (injectStyles) {
                injectStyles.call(this, context);
              }
              // register component module identifier for async chunk inferrence
              if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
              }
            };
            // used by ssr in case component is cached and beforeCreate
            // never gets called
            options._ssrRegister = hook;
          } else if (injectStyles) {
            hook = shadowMode
              ? function () {
                  injectStyles.call(
                    this,
                    (options.functional ? this.parent : this).$root.$options
                      .shadowRoot
                  );
                }
              : injectStyles;
          }

          if (hook) {
            if (options.functional) {
              // for template-only hot-reload because in that case the render fn doesn't
              // go through the normalizer
              options._injectStyles = hook;
              // register for functional component in vue file
              var originalRender = options.render;
              options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
              };
            } else {
              // inject component registration as beforeCreate hook
              var existing = options.beforeCreate;
              options.beforeCreate = existing
                ? [].concat(existing, hook)
                : [hook];
            }
          }

          return {
            exports: scriptExports,
            options: options,
          };
        }

        /***/
      },

    /***/ "./node_modules/vue-quick-search/dist/vueQuickSearch.umd.min.js":
      /*!**********************************************************************!*\
  !*** ./node_modules/vue-quick-search/dist/vueQuickSearch.umd.min.js ***!
  \**********************************************************************/
      /***/ function (module) {
        (function (t, e) {
          true ? (module.exports = e()) : 0;
        })("undefined" !== typeof self ? self : this, function () {
          return (function (t) {
            var e = {};
            function n(r) {
              if (e[r]) return e[r].exports;
              var o = (e[r] = { i: r, l: !1, exports: {} });
              return (
                t[r].call(o.exports, o, o.exports, n), (o.l = !0), o.exports
              );
            }
            return (
              (n.m = t),
              (n.c = e),
              (n.d = function (t, e, r) {
                n.o(t, e) ||
                  Object.defineProperty(t, e, { enumerable: !0, get: r });
              }),
              (n.r = function (t) {
                "undefined" !== typeof Symbol &&
                  Symbol.toStringTag &&
                  Object.defineProperty(t, Symbol.toStringTag, {
                    value: "Module",
                  }),
                  Object.defineProperty(t, "__esModule", { value: !0 });
              }),
              (n.t = function (t, e) {
                if ((1 & e && (t = n(t)), 8 & e)) return t;
                if (4 & e && "object" === typeof t && t && t.__esModule)
                  return t;
                var r = Object.create(null);
                if (
                  (n.r(r),
                  Object.defineProperty(r, "default", {
                    enumerable: !0,
                    value: t,
                  }),
                  2 & e && "string" != typeof t)
                )
                  for (var o in t)
                    n.d(
                      r,
                      o,
                      function (e) {
                        return t[e];
                      }.bind(null, o)
                    );
                return r;
              }),
              (n.n = function (t) {
                var e =
                  t && t.__esModule
                    ? function () {
                        return t["default"];
                      }
                    : function () {
                        return t;
                      };
                return n.d(e, "a", e), e;
              }),
              (n.o = function (t, e) {
                return Object.prototype.hasOwnProperty.call(t, e);
              }),
              (n.p = ""),
              n((n.s = "34d8"))
            );
          })({
            "03a5": function (t, e, n) {
              var r = n("3fea"),
                o = n("1a7f"),
                i = n("aae2"),
                u = n("994d"),
                s = n("62f8"),
                a = n("e41e"),
                c = Object.getOwnPropertyDescriptor;
              e.f = n("74a4")
                ? c
                : function (t, e) {
                    if (((t = i(t)), (e = u(e, !0)), a))
                      try {
                        return c(t, e);
                      } catch (t) {}
                    if (s(t, e)) return o(!r.f.call(t, e), t[e]);
                  };
            },
            "0503": function (t, e) {
              var n = 0,
                r = Math.random();
              t.exports = function (t) {
                return "Symbol(".concat(
                  void 0 === t ? "" : t,
                  ")_",
                  (++n + r).toString(36)
                );
              };
            },
            "0b0c": function (t, e) {
              t.exports = "\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff";
            },
            1579: function (t, e, n) {
              var r = n("62f8"),
                o = n("aae2"),
                i = n("59b4")(!1),
                u = n("d481")("IE_PROTO");
              t.exports = function (t, e) {
                var n,
                  s = o(t),
                  a = 0,
                  c = [];
                for (n in s) n != u && r(s, n) && c.push(n);
                while (e.length > a)
                  r(s, (n = e[a++])) && (~i(c, n) || c.push(n));
                return c;
              };
            },
            "1a7f": function (t, e) {
              t.exports = function (t, e) {
                return {
                  enumerable: !(1 & t),
                  configurable: !(2 & t),
                  writable: !(4 & t),
                  value: e,
                };
              };
            },
            "1e2b": function (t, e, n) {
              var r = n("2b0f"),
                o = n("7325"),
                i = n("62f8"),
                u = n("0503")("src"),
                s = "toString",
                a = Function[s],
                c = ("" + a).split(s);
              (n("87f3").inspectSource = function (t) {
                return a.call(t);
              }),
                (t.exports = function (t, e, n, s) {
                  var a = "function" == typeof n;
                  a && (i(n, "name") || o(n, "name", e)),
                    t[e] !== n &&
                      (a &&
                        (i(n, u) ||
                          o(n, u, t[e] ? "" + t[e] : c.join(String(e)))),
                      t === r
                        ? (t[e] = n)
                        : s
                        ? t[e]
                          ? (t[e] = n)
                          : o(t, e, n)
                        : (delete t[e], o(t, e, n)));
                })(Function.prototype, s, function () {
                  return ("function" == typeof this && this[u]) || a.call(this);
                });
            },
            "1e32": function (t, e, n) {
              var r = n("46a4"),
                o = n("833a"),
                i = n("cb6e");
              t.exports = n("74a4")
                ? Object.defineProperties
                : function (t, e) {
                    o(t);
                    var n,
                      u = i(e),
                      s = u.length,
                      a = 0;
                    while (s > a) r.f(t, (n = u[a++]), e[n]);
                    return t;
                  };
            },
            2677: function (t, e, n) {
              var r = n("833a"),
                o = n("1e32"),
                i = n("b070"),
                u = n("d481")("IE_PROTO"),
                s = function () {},
                a = "prototype",
                c = function () {
                  var t,
                    e = n("4436")("iframe"),
                    r = i.length,
                    o = "<",
                    u = ">";
                  (e.style.display = "none"),
                    n("4bf7").appendChild(e),
                    (e.src = "javascript:"),
                    (t = e.contentWindow.document),
                    t.open(),
                    t.write(
                      o + "script" + u + "document.F=Object" + o + "/script" + u
                    ),
                    t.close(),
                    (c = t.F);
                  while (r--) delete c[a][i[r]];
                  return c();
                };
              t.exports =
                Object.create ||
                function (t, e) {
                  var n;
                  return (
                    null !== t
                      ? ((s[a] = r(t)),
                        (n = new s()),
                        (s[a] = null),
                        (n[u] = t))
                      : (n = c()),
                    void 0 === e ? n : o(n, e)
                  );
                };
            },
            "2b0f": function (t, e) {
              var n = (t.exports =
                "undefined" != typeof window && window.Math == Math
                  ? window
                  : "undefined" != typeof self && self.Math == Math
                  ? self
                  : Function("return this")());
              "number" == typeof __g && (__g = n);
            },
            "2df0": function (t, e) {
              t.exports = function (t) {
                if ("function" != typeof t)
                  throw TypeError(t + " is not a function!");
                return t;
              };
            },
            "34d8": function (t, e, n) {
              "use strict";
              n.r(e);
              n("3e97");
              var r = function () {
                  var t = this,
                    e = t.$createElement,
                    n = t._self._c || e;
                  return n("transition", { attrs: { name: "vue-qs" } }, [
                    t.isActive
                      ? n(
                          "div",
                          {
                            staticClass: "vue-qs",
                            on: {
                              click: function (e) {
                                return (
                                  e.stopPropagation(), t.stopPropagation(e)
                                );
                              },
                            },
                          },
                          [
                            n("div", { staticClass: "vue-qs__inner" }, [
                              n(
                                "form",
                                {
                                  ref: "form",
                                  staticClass: "vue-qs__form",
                                  attrs: { action: t.formAction },
                                  on: {
                                    submit: function (e) {
                                      e.preventDefault(), t.onExit(e, "submit");
                                    },
                                  },
                                },
                                [
                                  n(
                                    "button",
                                    {
                                      staticClass: "vue-qs__submit",
                                      attrs: {
                                        type: "submit",
                                        title: t.formSubmitTitle,
                                        "aria-label": t.formSubmitTitle,
                                      },
                                    },
                                    [
                                      t._t("submit-button", [
                                        n(
                                          "i",
                                          {
                                            staticClass: "vue-qs__submit-icon",
                                          },
                                          [
                                            n(
                                              "svg",
                                              {
                                                staticClass: "vue-qs__svg",
                                                attrs: {
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                  viewBox: "0 0 14.9 14.9",
                                                },
                                              },
                                              [
                                                n("path", {
                                                  attrs: {
                                                    fill: "currentColor",
                                                    d: "M14.9 13.7c0 .3-.1.6-.3.8s-.5.3-.8.3c-.3 0-.6-.1-.8-.3l-3.1-3.1c-1.1.7-2.3 1.1-3.6 1.1-.9 0-1.7-.2-2.4-.5-.8-.3-1.4-.8-2-1.3s-1-1.2-1.3-2C.2 8 0 7.1 0 6.3c0-.9.2-1.7.5-2.4.3-.8.8-1.4 1.3-2S3 .9 3.8.6C4.6.2 5.4 0 6.3 0S8 .2 8.7.5c.8.3 1.4.8 2 1.3s1 1.2 1.3 2c.3.8.5 1.6.5 2.4 0 1.3-.4 2.5-1.1 3.6l3.1 3.1c.2.2.4.5.4.8zM9.1 9.1c.8-.8 1.2-1.7 1.2-2.8 0-1.1-.4-2-1.2-2.8-.8-.8-1.7-1.2-2.8-1.2s-2 .4-2.8 1.2c-.8.7-1.2 1.7-1.2 2.8 0 1.1.4 2 1.2 2.8.8.8 1.7 1.2 2.8 1.2s2-.4 2.8-1.2z",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                  t._t("form-inputs"),
                                  n(
                                    "div",
                                    { staticClass: "vue-qs__input-wrapper" },
                                    [
                                      t.shouldShowLabel
                                        ? n("label", {
                                            staticClass: "vue-qs__input-label",
                                            attrs: { for: t.formInputName },
                                            domProps: {
                                              textContent: t._s(
                                                t.formInputLabel
                                              ),
                                            },
                                          })
                                        : t._e(),
                                      "checkbox" !== t.formInputType ||
                                      t.isSubmitting
                                        ? "radio" !== t.formInputType ||
                                          t.isSubmitting
                                          ? t.isSubmitting
                                            ? t._e()
                                            : n("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: t.searchTerm,
                                                    expression: "searchTerm",
                                                  },
                                                ],
                                                ref: "input",
                                                staticClass: "vue-qs__input-el",
                                                attrs: {
                                                  name: t.formInputName,
                                                  autocomplete: "off",
                                                  autocorrect: "off",
                                                  autocapitalize: "off",
                                                  spellcheck: "false",
                                                  type: t.formInputType,
                                                },
                                                domProps: {
                                                  value: t.searchTerm,
                                                },
                                                on: {
                                                  focus: t.onInputFocus,
                                                  blur: t.onInputBlur,
                                                  input: function (e) {
                                                    e.target.composing ||
                                                      (t.searchTerm =
                                                        e.target.value);
                                                  },
                                                },
                                              })
                                          : n("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: t.searchTerm,
                                                  expression: "searchTerm",
                                                },
                                              ],
                                              ref: "input",
                                              staticClass: "vue-qs__input-el",
                                              attrs: {
                                                name: t.formInputName,
                                                autocomplete: "off",
                                                autocorrect: "off",
                                                autocapitalize: "off",
                                                spellcheck: "false",
                                                type: "radio",
                                              },
                                              domProps: {
                                                checked: t._q(
                                                  t.searchTerm,
                                                  null
                                                ),
                                              },
                                              on: {
                                                focus: t.onInputFocus,
                                                blur: t.onInputBlur,
                                                change: function (e) {
                                                  t.searchTerm = null;
                                                },
                                              },
                                            })
                                        : n("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: t.searchTerm,
                                                expression: "searchTerm",
                                              },
                                            ],
                                            ref: "input",
                                            staticClass: "vue-qs__input-el",
                                            attrs: {
                                              name: t.formInputName,
                                              autocomplete: "off",
                                              autocorrect: "off",
                                              autocapitalize: "off",
                                              spellcheck: "false",
                                              type: "checkbox",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                t.searchTerm
                                              )
                                                ? t._i(t.searchTerm, null) > -1
                                                : t.searchTerm,
                                            },
                                            on: {
                                              focus: t.onInputFocus,
                                              blur: t.onInputBlur,
                                              change: function (e) {
                                                var n = t.searchTerm,
                                                  r = e.target,
                                                  o = !!r.checked;
                                                if (Array.isArray(n)) {
                                                  var i = null,
                                                    u = t._i(n, i);
                                                  r.checked
                                                    ? u < 0 &&
                                                      (t.searchTerm = n.concat([
                                                        i,
                                                      ]))
                                                    : u > -1 &&
                                                      (t.searchTerm = n
                                                        .slice(0, u)
                                                        .concat(
                                                          n.slice(u + 1)
                                                        ));
                                                } else t.searchTerm = o;
                                              },
                                            },
                                          }),
                                      t.isSubmitting
                                        ? n("input", {
                                            attrs: {
                                              type: "hidden",
                                              name: t.formInputName,
                                            },
                                            domProps: {
                                              value: t.fullSearchQuery,
                                            },
                                          })
                                        : t._e(),
                                    ]
                                  ),
                                ],
                                2
                              ),
                              t.isActive && !t.initialState
                                ? n(
                                    "div",
                                    { staticClass: "vuwe-is__dropdown" },
                                    [
                                      n(
                                        "div",
                                        {
                                          staticClass:
                                            "vue-qs__results-wrapper",
                                        },
                                        [
                                          n(
                                            "div",
                                            {
                                              staticClass:
                                                "vue-qs__results-overflow",
                                            },
                                            [
                                              n(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "vue-qs__results",
                                                },
                                                t._l(
                                                  t.stubbedResults,
                                                  function (e, r) {
                                                    return n(
                                                      "li",
                                                      {
                                                        key: "vue-qs-" + r,
                                                        staticClass:
                                                          "vue-qs__result",
                                                        on: {
                                                          click: function (n) {
                                                            n.preventDefault(),
                                                              t.onExit(
                                                                n,
                                                                "href",
                                                                e.url
                                                              );
                                                          },
                                                        },
                                                      },
                                                      [
                                                        t._t(
                                                          "result",
                                                          [
                                                            n(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "vue-qs__result-link",
                                                                attrs: {
                                                                  href: e.url,
                                                                },
                                                              },
                                                              [
                                                                n(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "vue-qs__result-image",
                                                                  },
                                                                  [
                                                                    n("img", {
                                                                      staticClass:
                                                                        "vue-qs__result-image-el",
                                                                      attrs: {
                                                                        src: e.image,
                                                                      },
                                                                    }),
                                                                  ]
                                                                ),
                                                                n("span", {
                                                                  staticClass:
                                                                    "vue-qs__result-title",
                                                                  domProps: {
                                                                    innerHTML:
                                                                      t._s(
                                                                        e.title
                                                                      ),
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                          ],
                                                          { item: e }
                                                        ),
                                                      ],
                                                      2
                                                    );
                                                  }
                                                )
                                              ),
                                            ]
                                          ),
                                          t.filteredResults.length >
                                          t.resultLimit
                                            ? n(
                                                "div",
                                                {
                                                  staticClass:
                                                    "vue-qs__results-footer",
                                                  on: {
                                                    click: function (e) {
                                                      e.preventDefault(),
                                                        t.onExit(
                                                          e,
                                                          "href",
                                                          t.activeSearchUrl
                                                        );
                                                    },
                                                  },
                                                },
                                                [
                                                  t._t(
                                                    "results-footer",
                                                    [
                                                      n(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: t.activeSearchUrl,
                                                          },
                                                        },
                                                        [
                                                          t._v(
                                                            "\n                See all results " +
                                                              t._s(
                                                                t.resultsCount
                                                              ) +
                                                              "\n              "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    {
                                                      activeSearchUrl:
                                                        t.activeSearchUrl,
                                                      resultsCount:
                                                        t.resultsCount,
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            : t._e(),
                                        ]
                                      ),
                                      0 == t.filteredResults.length &&
                                      t.searchTerm
                                        ? n(
                                            "div",
                                            {
                                              staticClass:
                                                "vue-qs__sans-results",
                                            },
                                            [
                                              t.isLoading
                                                ? n(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "vue-qs__sans-results-loading",
                                                    },
                                                    [
                                                      t._t("loading", [
                                                        t._v("Loading.."),
                                                      ]),
                                                    ],
                                                    2
                                                  )
                                                : n(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "vue-qs__sans-results-empty",
                                                    },
                                                    [
                                                      t._t(
                                                        "no-results",
                                                        [
                                                          t._v(
                                                            "\n              Your search for "
                                                          ),
                                                          n("strong", [
                                                            t._v(
                                                              t._s(t.searchTerm)
                                                            ),
                                                          ]),
                                                          t._v(
                                                            " did not yield any results.\n            "
                                                          ),
                                                        ],
                                                        {
                                                          searchTerm:
                                                            t.searchTerm,
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  ),
                                            ]
                                          )
                                        : t._e(),
                                    ]
                                  )
                                : t._e(),
                            ]),
                          ]
                        )
                      : t._e(),
                  ]);
                },
                o = [],
                i = (n("5387"), n("a860"), n("f56a"), n("5625"), n("db8f")),
                u = n.n(i);
              function s(t, e) {
                u.a.ajax({ url: t }, e);
              }
              var a = {
                  name: "vue-quick-search",
                  props: {
                    isActive: { type: Boolean, default: !1 },
                    url: { type: String, default: "/search/term/|val|" },
                    formAction: { type: String, default: "/search" },
                    formInputName: { type: String, default: "q" },
                    formInputLabel: {
                      type: String,
                      default: "Search by keyword, style, etc...",
                    },
                    formSubmitTitle: {
                      type: String,
                      default: "Fetch search results",
                    },
                    formInputType: { type: String, default: "text" },
                    filterResults: {
                      type: Function,
                      default: function (t) {
                        return t;
                      },
                    },
                    filterAJAXUrl: {
                      type: Function,
                      default: function (t) {
                        return t;
                      },
                    },
                    getResults: { type: Function, default: s },
                    resultLimit: { type: Number, default: 5 },
                    exitDelay: { type: Number, default: 300 },
                    hijackSubmit: {
                      type: Function,
                      default: function (t) {
                        t.submit();
                      },
                    },
                    decodeResponse: {
                      type: Function,
                      default: function (t) {
                        return (
                          "string" === typeof t && (t = JSON.parse(t)),
                          { results: t.results || [], total: t["total"] || 0 }
                        );
                      },
                    },
                  },
                  data: function () {
                    return {
                      initialState: !0,
                      searchTerm: "",
                      resultsCount: 0,
                      results: [],
                      activeAjaxRequest: !1,
                      inputFocused: !1,
                      isLoading: !1,
                      isSubmitting: !1,
                    };
                  },
                  watch: {
                    searchTerm: function () {
                      this.prepareGetResults();
                    },
                  },
                  computed: {
                    activeSearchUrl: function () {
                      var t = new RegExp("(.[^?]*)[?](.*)"),
                        e = this.url.replace("|val|", this.searchTerm),
                        n = e.match(t);
                      return n
                        ? ""
                            .concat(n[1] ? n[1] : "")
                            .concat(
                              n[2] ? "?".concat(encodeURIComponent(n[2])) : ""
                            )
                        : e;
                    },
                    filteredResults: function () {
                      for (var t = [], e = 0; e < this.results.length; e++)
                        this.filterResults(this.results[e]) &&
                          t.push(this.results[e]);
                      return t;
                    },
                    stubbedResults: function () {
                      return 0 === this.resultLimit
                        ? this.filteredResults
                        : this.filteredResults.slice(0, this.resultLimit);
                    },
                    shouldShowLabel: function () {
                      return !this.searchTerm;
                    },
                    fullSearchQuery: function () {
                      var t = this.url.replace("|val|", this.searchTerm),
                        e = new RegExp(
                          "".concat(this.formInputName, "=(.[^&]*)")
                        ),
                        n = t.match(e);
                      return n[1];
                    },
                  },
                  methods: {
                    prepareGetResults: function () {
                      (this.isLoading = !0),
                        this.initialState && (this.initialState = !1),
                        this.activeAjaxRequest &&
                          this.activeAjaxRequest.abort();
                      var t = "".concat(
                        this.url.replace("|val|", this.searchTerm)
                      );
                      this.getResults(this.filterAJAXUrl(t), this.onResponse);
                    },
                    onResponse: function (t, e) {
                      if (
                        ("Abort" !== e &&
                          "Error" !== e &&
                          (this.isLoading = !1),
                        200 === Number(t))
                      )
                        try {
                          var n = this.decodeResponse(e),
                            r = n.results,
                            o = void 0 === r ? [] : r,
                            i = n.total,
                            u = void 0 === i ? 0 : i;
                          (this.results = o), (this.resultsCount = u);
                        } catch (t) {
                          this.$emit("error", t);
                        }
                    },
                    onExit: function (t) {
                      var e = this,
                        n =
                          arguments.length > 1 &&
                          void 0 !== arguments[1] &&
                          arguments[1],
                        r =
                          arguments.length > 2 &&
                          void 0 !== arguments[2] &&
                          arguments[2];
                      this.$emit("exit", this.searchTerm),
                        n &&
                          setTimeout(function () {
                            "submit" === n &&
                              ((e.isSubmitting = !0),
                              e.$nextTick(function () {
                                e.hijackSubmit(
                                  e.$refs["form"],
                                  e.activeSearchUrl
                                );
                              })),
                              "href" === n && (window.location.href = r);
                          }, this.exitDelay);
                    },
                    onInputFocus: function (t) {
                      this.$emit("focus", t), (this.inputFocused = !0);
                    },
                    onInputBlur: function (t) {
                      this.$emit("blur", t), (this.inputFocused = !1);
                    },
                    onClickOutside: function (t) {
                      this.$el.contains(t.target) ||
                        this.$el === t.target ||
                        this.$emit("hide", !0);
                    },
                    stopPropagation: function () {
                      return !1;
                    },
                  },
                  updated: function () {
                    var t = this;
                    this.isActive &&
                      this.$nextTick(function () {
                        t.$refs.input && t.$refs.input.focus();
                      });
                  },
                  mounted: function () {
                    document.addEventListener("click", this.onClickOutside);
                  },
                  beforeDestroy: function () {
                    document.removeEventListener("click", this.onClickOutside);
                  },
                },
                c = a;
              n("eafa");
              function f(t, e, n, r, o, i, u, s) {
                var a,
                  c = "function" === typeof t ? t.options : t;
                if (
                  (e &&
                    ((c.render = e),
                    (c.staticRenderFns = n),
                    (c._compiled = !0)),
                  r && (c.functional = !0),
                  i && (c._scopeId = "data-v-" + i),
                  u
                    ? ((a = function (t) {
                        (t =
                          t ||
                          (this.$vnode && this.$vnode.ssrContext) ||
                          (this.parent &&
                            this.parent.$vnode &&
                            this.parent.$vnode.ssrContext)),
                          t ||
                            "undefined" === typeof __VUE_SSR_CONTEXT__ ||
                            (t = __VUE_SSR_CONTEXT__),
                          o && o.call(this, t),
                          t &&
                            t._registeredComponents &&
                            t._registeredComponents.add(u);
                      }),
                      (c._ssrRegister = a))
                    : o &&
                      (a = s
                        ? function () {
                            o.call(this, this.$root.$options.shadowRoot);
                          }
                        : o),
                  a)
                )
                  if (c.functional) {
                    c._injectStyles = a;
                    var f = c.render;
                    c.render = function (t, e) {
                      return a.call(e), f(t, e);
                    };
                  } else {
                    var l = c.beforeCreate;
                    c.beforeCreate = l ? [].concat(l, a) : [a];
                  }
                return { exports: t, options: c };
              }
              var l = f(c, r, o, !1, null, null, null);
              l.options.__file = "vue-quick-search.vue";
              var p = l.exports;
              e["default"] = p;
            },
            "3c83": function (t, e, n) {
              var r = n("b91d"),
                o = n("4740"),
                i = n("3f3e"),
                u = n("0b0c"),
                s = "[" + u + "]",
                a = "​",
                c = RegExp("^" + s + s + "*"),
                f = RegExp(s + s + "*$"),
                l = function (t, e, n) {
                  var o = {},
                    s = i(function () {
                      return !!u[t]() || a[t]() != a;
                    }),
                    c = (o[t] = s ? e(p) : u[t]);
                  n && (o[n] = c), r(r.P + r.F * s, "String", o);
                },
                p = (l.trim = function (t, e) {
                  return (
                    (t = String(o(t))),
                    1 & e && (t = t.replace(c, "")),
                    2 & e && (t = t.replace(f, "")),
                    t
                  );
                });
              t.exports = l;
            },
            "3e97": function (t, e, n) {
              var r;
              "undefined" !== typeof window &&
                (r = window.document.currentScript) &&
                (r = r.src.match(/(.+\/)[^/]+\.js$/)) &&
                (n.p = r[1]);
            },
            "3f3e": function (t, e) {
              t.exports = function (t) {
                try {
                  return !!t();
                } catch (t) {
                  return !0;
                }
              };
            },
            "3f5f": function (t, e, n) {
              "use strict";
              var r = n("7325"),
                o = n("1e2b"),
                i = n("3f3e"),
                u = n("4740"),
                s = n("4175");
              t.exports = function (t, e, n) {
                var a = s(t),
                  c = n(u, a, ""[t]),
                  f = c[0],
                  l = c[1];
                i(function () {
                  var e = {};
                  return (
                    (e[a] = function () {
                      return 7;
                    }),
                    7 != ""[t](e)
                  );
                }) &&
                  (o(String.prototype, t, f),
                  r(
                    RegExp.prototype,
                    a,
                    2 == e
                      ? function (t, e) {
                          return l.call(t, this, e);
                        }
                      : function (t) {
                          return l.call(t, this);
                        }
                  ));
              };
            },
            "3fea": function (t, e) {
              e.f = {}.propertyIsEnumerable;
            },
            4175: function (t, e, n) {
              var r = n("7ae6")("wks"),
                o = n("0503"),
                i = n("2b0f").Symbol,
                u = "function" == typeof i,
                s = (t.exports = function (t) {
                  return (
                    r[t] || (r[t] = (u && i[t]) || (u ? i : o)("Symbol." + t))
                  );
                });
              s.store = r;
            },
            "428b": function (t, e, n) {
              var r = n("5a5f");
              t.exports = Object("z").propertyIsEnumerable(0)
                ? Object
                : function (t) {
                    return "String" == r(t) ? t.split("") : Object(t);
                  };
            },
            4436: function (t, e, n) {
              var r = n("4906"),
                o = n("2b0f").document,
                i = r(o) && r(o.createElement);
              t.exports = function (t) {
                return i ? o.createElement(t) : {};
              };
            },
            "451a": function (t, e, n) {},
            "459f": function (t, e, n) {
              var r = n("4906"),
                o = n("5a5f"),
                i = n("4175")("match");
              t.exports = function (t) {
                var e;
                return r(t) && (void 0 !== (e = t[i]) ? !!e : "RegExp" == o(t));
              };
            },
            "46a4": function (t, e, n) {
              var r = n("833a"),
                o = n("e41e"),
                i = n("994d"),
                u = Object.defineProperty;
              e.f = n("74a4")
                ? Object.defineProperty
                : function (t, e, n) {
                    if ((r(t), (e = i(e, !0)), r(n), o))
                      try {
                        return u(t, e, n);
                      } catch (t) {}
                    if ("get" in n || "set" in n)
                      throw TypeError("Accessors not supported!");
                    return "value" in n && (t[e] = n.value), t;
                  };
            },
            4740: function (t, e) {
              t.exports = function (t) {
                if (void 0 == t) throw TypeError("Can't call method on  " + t);
                return t;
              };
            },
            4906: function (t, e) {
              t.exports = function (t) {
                return "object" === typeof t
                  ? null !== t
                  : "function" === typeof t;
              };
            },
            "4bf7": function (t, e, n) {
              var r = n("2b0f").document;
              t.exports = r && r.documentElement;
            },
            "4d90": function (t, e, n) {
              "use strict";
              var r = n("833a");
              t.exports = function () {
                var t = r(this),
                  e = "";
                return (
                  t.global && (e += "g"),
                  t.ignoreCase && (e += "i"),
                  t.multiline && (e += "m"),
                  t.unicode && (e += "u"),
                  t.sticky && (e += "y"),
                  e
                );
              };
            },
            5387: function (t, e, n) {
              n("3f5f")("match", 1, function (t, e, n) {
                return [
                  function (n) {
                    "use strict";
                    var r = t(this),
                      o = void 0 == n ? void 0 : n[e];
                    return void 0 !== o
                      ? o.call(n, r)
                      : new RegExp(n)[e](String(r));
                  },
                  n,
                ];
              });
            },
            5625: function (t, e, n) {
              "use strict";
              var r = n("2b0f"),
                o = n("62f8"),
                i = n("5a5f"),
                u = n("62fb"),
                s = n("994d"),
                a = n("3f3e"),
                c = n("a414").f,
                f = n("03a5").f,
                l = n("46a4").f,
                p = n("3c83").trim,
                d = "Number",
                v = r[d],
                h = v,
                m = v.prototype,
                b = i(n("2677")(m)) == d,
                _ = "trim" in String.prototype,
                y = function (t) {
                  var e = s(t, !1);
                  if ("string" == typeof e && e.length > 2) {
                    e = _ ? e.trim() : p(e, 3);
                    var n,
                      r,
                      o,
                      i = e.charCodeAt(0);
                    if (43 === i || 45 === i) {
                      if (((n = e.charCodeAt(2)), 88 === n || 120 === n))
                        return NaN;
                    } else if (48 === i) {
                      switch (e.charCodeAt(1)) {
                        case 66:
                        case 98:
                          (r = 2), (o = 49);
                          break;
                        case 79:
                        case 111:
                          (r = 8), (o = 55);
                          break;
                        default:
                          return +e;
                      }
                      for (
                        var u, a = e.slice(2), c = 0, f = a.length;
                        c < f;
                        c++
                      )
                        if (((u = a.charCodeAt(c)), u < 48 || u > o))
                          return NaN;
                      return parseInt(a, r);
                    }
                  }
                  return +e;
                };
              if (!v(" 0o1") || !v("0b1") || v("+0x1")) {
                v = function (t) {
                  var e = arguments.length < 1 ? 0 : t,
                    n = this;
                  return n instanceof v &&
                    (b
                      ? a(function () {
                          m.valueOf.call(n);
                        })
                      : i(n) != d)
                    ? u(new h(y(e)), n, v)
                    : y(e);
                };
                for (
                  var g,
                    x = n("74a4")
                      ? c(h)
                      : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(
                          ","
                        ),
                    S = 0;
                  x.length > S;
                  S++
                )
                  o(h, (g = x[S])) && !o(v, g) && l(v, g, f(h, g));
                (v.prototype = m), (m.constructor = v), n("1e2b")(r, d, v);
              }
            },
            "59b4": function (t, e, n) {
              var r = n("aae2"),
                o = n("7730"),
                i = n("c5a8");
              t.exports = function (t) {
                return function (e, n, u) {
                  var s,
                    a = r(e),
                    c = o(a.length),
                    f = i(u, c);
                  if (t && n != n) {
                    while (c > f) if (((s = a[f++]), s != s)) return !0;
                  } else
                    for (; c > f; f++)
                      if ((t || f in a) && a[f] === n) return t || f || 0;
                  return !t && -1;
                };
              };
            },
            "5a5f": function (t, e) {
              var n = {}.toString;
              t.exports = function (t) {
                return n.call(t).slice(8, -1);
              };
            },
            "5d5e": function (t, e) {
              t.exports = !1;
            },
            "62f8": function (t, e) {
              var n = {}.hasOwnProperty;
              t.exports = function (t, e) {
                return n.call(t, e);
              };
            },
            "62fb": function (t, e, n) {
              var r = n("4906"),
                o = n("d998").set;
              t.exports = function (t, e, n) {
                var i,
                  u = e.constructor;
                return (
                  u !== n &&
                    "function" == typeof u &&
                    (i = u.prototype) !== n.prototype &&
                    r(i) &&
                    o &&
                    o(t, i),
                  t
                );
              };
            },
            7325: function (t, e, n) {
              var r = n("46a4"),
                o = n("1a7f");
              t.exports = n("74a4")
                ? function (t, e, n) {
                    return r.f(t, e, o(1, n));
                  }
                : function (t, e, n) {
                    return (t[e] = n), t;
                  };
            },
            "74a4": function (t, e, n) {
              t.exports = !n("3f3e")(function () {
                return (
                  7 !=
                  Object.defineProperty({}, "a", {
                    get: function () {
                      return 7;
                    },
                  }).a
                );
              });
            },
            7730: function (t, e, n) {
              var r = n("f74a"),
                o = Math.min;
              t.exports = function (t) {
                return t > 0 ? o(r(t), 9007199254740991) : 0;
              };
            },
            "7ae6": function (t, e, n) {
              var r = n("87f3"),
                o = n("2b0f"),
                i = "__core-js_shared__",
                u = o[i] || (o[i] = {});
              (t.exports = function (t, e) {
                return u[t] || (u[t] = void 0 !== e ? e : {});
              })("versions", []).push({
                version: r.version,
                mode: n("5d5e") ? "pure" : "global",
                copyright: "© 2018 Denis Pushkarev (zloirock.ru)",
              });
            },
            "833a": function (t, e, n) {
              var r = n("4906");
              t.exports = function (t) {
                if (!r(t)) throw TypeError(t + " is not an object!");
                return t;
              };
            },
            "87f3": function (t, e) {
              var n = (t.exports = { version: "2.5.7" });
              "number" == typeof __e && (__e = n);
            },
            8868: function (t, e) {
              var n;
              n = (function () {
                return this;
              })();
              try {
                n = n || Function("return this")() || (0, eval)("this");
              } catch (t) {
                "object" === typeof window && (n = window);
              }
              t.exports = n;
            },
            "994d": function (t, e, n) {
              var r = n("4906");
              t.exports = function (t, e) {
                if (!r(t)) return t;
                var n, o;
                if (
                  e &&
                  "function" == typeof (n = t.toString) &&
                  !r((o = n.call(t)))
                )
                  return o;
                if ("function" == typeof (n = t.valueOf) && !r((o = n.call(t))))
                  return o;
                if (
                  !e &&
                  "function" == typeof (n = t.toString) &&
                  !r((o = n.call(t)))
                )
                  return o;
                throw TypeError("Can't convert object to primitive value");
              };
            },
            a414: function (t, e, n) {
              var r = n("1579"),
                o = n("b070").concat("length", "prototype");
              e.f =
                Object.getOwnPropertyNames ||
                function (t) {
                  return r(t, o);
                };
            },
            a860: function (t, e, n) {
              n("3f5f")("replace", 2, function (t, e, n) {
                return [
                  function (r, o) {
                    "use strict";
                    var i = t(this),
                      u = void 0 == r ? void 0 : r[e];
                    return void 0 !== u
                      ? u.call(r, i, o)
                      : n.call(String(i), r, o);
                  },
                  n,
                ];
              });
            },
            aae2: function (t, e, n) {
              var r = n("428b"),
                o = n("4740");
              t.exports = function (t) {
                return r(o(t));
              };
            },
            b070: function (t, e) {
              t.exports =
                "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
                  ","
                );
            },
            b91d: function (t, e, n) {
              var r = n("2b0f"),
                o = n("87f3"),
                i = n("7325"),
                u = n("1e2b"),
                s = n("d38d"),
                a = "prototype",
                c = function (t, e, n) {
                  var f,
                    l,
                    p,
                    d,
                    v = t & c.F,
                    h = t & c.G,
                    m = t & c.S,
                    b = t & c.P,
                    _ = t & c.B,
                    y = h ? r : m ? r[e] || (r[e] = {}) : (r[e] || {})[a],
                    g = h ? o : o[e] || (o[e] = {}),
                    x = g[a] || (g[a] = {});
                  for (f in (h && (n = e), n))
                    (l = !v && y && void 0 !== y[f]),
                      (p = (l ? y : n)[f]),
                      (d =
                        _ && l
                          ? s(p, r)
                          : b && "function" == typeof p
                          ? s(Function.call, p)
                          : p),
                      y && u(y, f, p, t & c.U),
                      g[f] != p && i(g, f, d),
                      b && x[f] != p && (x[f] = p);
                };
              (r.core = o),
                (c.F = 1),
                (c.G = 2),
                (c.S = 4),
                (c.P = 8),
                (c.B = 16),
                (c.W = 32),
                (c.U = 64),
                (c.R = 128),
                (t.exports = c);
            },
            bb63: function (t, e, n) {
              "use strict";
              var r = n("2b0f"),
                o = n("46a4"),
                i = n("74a4"),
                u = n("4175")("species");
              t.exports = function (t) {
                var e = r[t];
                i &&
                  e &&
                  !e[u] &&
                  o.f(e, u, {
                    configurable: !0,
                    get: function () {
                      return this;
                    },
                  });
              };
            },
            c5a8: function (t, e, n) {
              var r = n("f74a"),
                o = Math.max,
                i = Math.min;
              t.exports = function (t, e) {
                return (t = r(t)), t < 0 ? o(t + e, 0) : i(t, e);
              };
            },
            cb6e: function (t, e, n) {
              var r = n("1579"),
                o = n("b070");
              t.exports =
                Object.keys ||
                function (t) {
                  return r(t, o);
                };
            },
            d38d: function (t, e, n) {
              var r = n("2df0");
              t.exports = function (t, e, n) {
                if ((r(t), void 0 === e)) return t;
                switch (n) {
                  case 1:
                    return function (n) {
                      return t.call(e, n);
                    };
                  case 2:
                    return function (n, r) {
                      return t.call(e, n, r);
                    };
                  case 3:
                    return function (n, r, o) {
                      return t.call(e, n, r, o);
                    };
                }
                return function () {
                  return t.apply(e, arguments);
                };
              };
            },
            d481: function (t, e, n) {
              var r = n("7ae6")("keys"),
                o = n("0503");
              t.exports = function (t) {
                return r[t] || (r[t] = o(t));
              };
            },
            d998: function (t, e, n) {
              var r = n("4906"),
                o = n("833a"),
                i = function (t, e) {
                  if ((o(t), !r(e) && null !== e))
                    throw TypeError(e + ": can't set as prototype!");
                };
              t.exports = {
                set:
                  Object.setPrototypeOf ||
                  ("__proto__" in {}
                    ? (function (t, e, r) {
                        try {
                          (r = n("d38d")(
                            Function.call,
                            n("03a5").f(Object.prototype, "__proto__").set,
                            2
                          )),
                            r(t, []),
                            (e = !(t instanceof Array));
                        } catch (t) {
                          e = !0;
                        }
                        return function (t, n) {
                          return i(t, n), e ? (t.__proto__ = n) : r(t, n), t;
                        };
                      })({}, !1)
                    : void 0),
                check: i,
              };
            },
            db8f: function (t, e, n) {
              (function (t) {
                var n = [
                  "responseType",
                  "withCredentials",
                  "timeout",
                  "onprogress",
                ];
                function r(e) {
                  return e &&
                    t.XDomainRequest &&
                    !/MSIE 1/.test(navigator.userAgent)
                    ? new XDomainRequest()
                    : t.XMLHttpRequest
                    ? new XMLHttpRequest()
                    : void 0;
                }
                function o(t, e, n) {
                  t[e] = t[e] || n;
                }
                e.ajax = function (e, i) {
                  var u = e.headers || {},
                    s = e.body,
                    a = e.method || (s ? "POST" : "GET"),
                    c = !1,
                    f = r(e.cors);
                  function l(t, e) {
                    return function () {
                      c ||
                        (i(
                          void 0 === f.status ? t : f.status,
                          0 === f.status
                            ? "Error"
                            : f.response || f.responseText || e,
                          f
                        ),
                        (c = !0));
                    };
                  }
                  f.open(a, e.url, !0);
                  var p = (f.onload = l(200));
                  (f.onreadystatechange = function () {
                    4 === f.readyState && p();
                  }),
                    (f.onerror = l(null, "Error")),
                    (f.ontimeout = l(null, "Timeout")),
                    (f.onabort = l(null, "Abort")),
                    s &&
                      (o(u, "X-Requested-With", "XMLHttpRequest"),
                      (t.FormData && s instanceof t.FormData) ||
                        o(
                          u,
                          "Content-Type",
                          "application/x-www-form-urlencoded"
                        ));
                  for (var d = 0, v = n.length; d < v; d++)
                    (h = n[d]), void 0 !== e[h] && (f[h] = e[h]);
                  for (var h in u) f.setRequestHeader(h, u[h]);
                  return f.send(s), f;
                };
              }).call(this, n("8868"));
            },
            e41e: function (t, e, n) {
              t.exports =
                !n("74a4") &&
                !n("3f3e")(function () {
                  return (
                    7 !=
                    Object.defineProperty(n("4436")("div"), "a", {
                      get: function () {
                        return 7;
                      },
                    }).a
                  );
                });
            },
            eafa: function (t, e, n) {
              "use strict";
              var r = n("451a"),
                o = n.n(r);
              o.a;
            },
            f56a: function (t, e, n) {
              var r = n("2b0f"),
                o = n("62fb"),
                i = n("46a4").f,
                u = n("a414").f,
                s = n("459f"),
                a = n("4d90"),
                c = r.RegExp,
                f = c,
                l = c.prototype,
                p = /a/g,
                d = /a/g,
                v = new c(p) !== p;
              if (
                n("74a4") &&
                (!v ||
                  n("3f3e")(function () {
                    return (
                      (d[n("4175")("match")] = !1),
                      c(p) != p || c(d) == d || "/a/i" != c(p, "i")
                    );
                  }))
              ) {
                c = function (t, e) {
                  var n = this instanceof c,
                    r = s(t),
                    i = void 0 === e;
                  return !n && r && t.constructor === c && i
                    ? t
                    : o(
                        v
                          ? new f(r && !i ? t.source : t, e)
                          : f(
                              (r = t instanceof c) ? t.source : t,
                              r && i ? a.call(t) : e
                            ),
                        n ? this : l,
                        c
                      );
                };
                for (
                  var h = function (t) {
                      (t in c) ||
                        i(c, t, {
                          configurable: !0,
                          get: function () {
                            return f[t];
                          },
                          set: function (e) {
                            f[t] = e;
                          },
                        });
                    },
                    m = u(f),
                    b = 0;
                  m.length > b;

                )
                  h(m[b++]);
                (l.constructor = c),
                  (c.prototype = l),
                  n("1e2b")(r, "RegExp", c);
              }
              n("bb63")("RegExp");
            },
            f74a: function (t, e) {
              var n = Math.ceil,
                r = Math.floor;
              t.exports = function (t) {
                return isNaN((t = +t)) ? 0 : (t > 0 ? r : n)(t);
              };
            },
          })["default"];
        });
        //# sourceMappingURL=vueQuickSearch.umd.min.js.map

        /***/
      },

    /***/ "./node_modules/vue-scrollto/vue-scrollto.js":
      /*!***************************************************!*\
  !*** ./node_modules/vue-scrollto/vue-scrollto.js ***!
  \***************************************************/
      /***/ function (module) {
        /*!
         * vue-scrollto v2.20.0
         * (c) 2019 Randjelovic Igor
         * @license MIT
         */
        (function (global, factory) {
          true ? (module.exports = factory()) : 0;
        })(this, function () {
          "use strict";

          function _typeof(obj) {
            "@babel/helpers - typeof";

            if (
              typeof Symbol === "function" &&
              typeof Symbol.iterator === "symbol"
            ) {
              _typeof = function (obj) {
                return typeof obj;
              };
            } else {
              _typeof = function (obj) {
                return obj &&
                  typeof Symbol === "function" &&
                  obj.constructor === Symbol &&
                  obj !== Symbol.prototype
                  ? "symbol"
                  : typeof obj;
              };
            }

            return _typeof(obj);
          }

          function _extends() {
            _extends =
              Object.assign ||
              function (target) {
                for (var i = 1; i < arguments.length; i++) {
                  var source = arguments[i];

                  for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                      target[key] = source[key];
                    }
                  }
                }

                return target;
              };

            return _extends.apply(this, arguments);
          }

          /**
           * https://github.com/gre/bezier-easing
           * BezierEasing - use bezier curve for transition easing function
           * by Gaëtan Renaudeau 2014 - 2015 – MIT License
           */

          // These values are established by empiricism with tests (tradeoff: performance VS precision)
          var NEWTON_ITERATIONS = 4;
          var NEWTON_MIN_SLOPE = 0.001;
          var SUBDIVISION_PRECISION = 0.0000001;
          var SUBDIVISION_MAX_ITERATIONS = 10;

          var kSplineTableSize = 11;
          var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

          var float32ArraySupported = typeof Float32Array === "function";

          function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
          }
          function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
          }
          function C(aA1) {
            return 3.0 * aA1;
          }

          // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
          function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
          }

          // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
          function getSlope(aT, aA1, aA2) {
            return (
              3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1)
            );
          }

          function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX,
              currentT,
              i = 0;
            do {
              currentT = aA + (aB - aA) / 2.0;
              currentX = calcBezier(currentT, mX1, mX2) - aX;
              if (currentX > 0.0) {
                aB = currentT;
              } else {
                aA = currentT;
              }
            } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
          }

          function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
              var currentSlope = getSlope(aGuessT, mX1, mX2);
              if (currentSlope === 0.0) {
                return aGuessT;
              }
              var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
              aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
          }

          function LinearEasing(x) {
            return x;
          }

          var src = function bezier(mX1, mY1, mX2, mY2) {
            if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
              throw new Error("bezier x values must be in [0, 1] range");
            }

            if (mX1 === mY1 && mX2 === mY2) {
              return LinearEasing;
            }

            // Precompute samples table
            var sampleValues = float32ArraySupported
              ? new Float32Array(kSplineTableSize)
              : new Array(kSplineTableSize);
            for (var i = 0; i < kSplineTableSize; ++i) {
              sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            }

            function getTForX(aX) {
              var intervalStart = 0.0;
              var currentSample = 1;
              var lastSample = kSplineTableSize - 1;

              for (
                ;
                currentSample !== lastSample &&
                sampleValues[currentSample] <= aX;
                ++currentSample
              ) {
                intervalStart += kSampleStepSize;
              }
              --currentSample;

              // Interpolate to provide an initial guess for t
              var dist =
                (aX - sampleValues[currentSample]) /
                (sampleValues[currentSample + 1] - sampleValues[currentSample]);
              var guessForT = intervalStart + dist * kSampleStepSize;

              var initialSlope = getSlope(guessForT, mX1, mX2);
              if (initialSlope >= NEWTON_MIN_SLOPE) {
                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
              } else if (initialSlope === 0.0) {
                return guessForT;
              } else {
                return binarySubdivide(
                  aX,
                  intervalStart,
                  intervalStart + kSampleStepSize,
                  mX1,
                  mX2
                );
              }
            }

            return function BezierEasing(x) {
              // Because JavaScript number are imprecise, we should guarantee the extremes are right.
              if (x === 0) {
                return 0;
              }
              if (x === 1) {
                return 1;
              }
              return calcBezier(getTForX(x), mY1, mY2);
            };
          };

          var easings = {
            ease: [0.25, 0.1, 0.25, 1.0],
            linear: [0.0, 0.0, 1.0, 1.0],
            "ease-in": [0.42, 0.0, 1.0, 1.0],
            "ease-out": [0.0, 0.0, 0.58, 1.0],
            "ease-in-out": [0.42, 0.0, 0.58, 1.0],
          };

          // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
          var supportsPassive = false;

          try {
            var opts = Object.defineProperty({}, "passive", {
              get: function get() {
                supportsPassive = true;
              },
            });
            window.addEventListener("test", null, opts);
          } catch (e) {}

          var _ = {
            $: function $(selector) {
              if (typeof selector !== "string") {
                return selector;
              }

              return document.querySelector(selector);
            },
            on: function on(element, events, handler) {
              var opts =
                arguments.length > 3 && arguments[3] !== undefined
                  ? arguments[3]
                  : {
                      passive: false,
                    };

              if (!(events instanceof Array)) {
                events = [events];
              }

              for (var i = 0; i < events.length; i++) {
                element.addEventListener(
                  events[i],
                  handler,
                  supportsPassive ? opts : false
                );
              }
            },
            off: function off(element, events, handler) {
              if (!(events instanceof Array)) {
                events = [events];
              }

              for (var i = 0; i < events.length; i++) {
                element.removeEventListener(events[i], handler);
              }
            },
            cumulativeOffset: function cumulativeOffset(element) {
              var top = 0;
              var left = 0;

              do {
                top += element.offsetTop || 0;
                left += element.offsetLeft || 0;
                element = element.offsetParent;
              } while (element);

              return {
                top: top,
                left: left,
              };
            },
          };

          var abortEvents = [
            "mousedown",
            "wheel",
            "DOMMouseScroll",
            "mousewheel",
            "keyup",
            "touchmove",
          ];
          var defaults = {
            container: "body",
            duration: 500,
            lazy: true,
            easing: "ease",
            offset: 0,
            force: true,
            cancelable: true,
            onStart: false,
            onDone: false,
            onCancel: false,
            x: false,
            y: true,
          };
          function setDefaults(options) {
            defaults = _extends({}, defaults, options);
          }
          var scroller = function scroller() {
            var element; // element to scroll to

            var container; // container to scroll

            var duration; // duration of the scrolling

            var easing; // easing to be used when scrolling

            var lazy; // checks the target position at each step

            var offset; // offset to be added (subtracted)

            var force; // force scroll, even if element is visible

            var cancelable; // indicates if user can cancel the scroll or not.

            var onStart; // callback when scrolling is started

            var onDone; // callback when scrolling is done

            var onCancel; // callback when scrolling is canceled / aborted

            var x; // scroll on x axis

            var y; // scroll on y axis

            var initialX; // initial X of container

            var targetX; // target X of container

            var initialY; // initial Y of container

            var targetY; // target Y of container

            var diffX; // difference

            var diffY; // difference

            var abort; // is scrolling aborted

            var cumulativeOffsetContainer;
            var cumulativeOffsetElement;
            var abortEv; // event that aborted scrolling

            var abortFn = function abortFn(e) {
              if (!cancelable) return;
              abortEv = e;
              abort = true;
            };

            var easingFn;
            var timeStart; // time when scrolling started

            var timeElapsed; // time elapsed since scrolling started

            var progress; // progress

            function scrollTop(container) {
              var scrollTop = container.scrollTop;

              if (container.tagName.toLowerCase() === "body") {
                // in firefox body.scrollTop always returns 0
                // thus if we are trying to get scrollTop on a body tag
                // we need to get it from the documentElement
                scrollTop = scrollTop || document.documentElement.scrollTop;
              }

              return scrollTop;
            }

            function scrollLeft(container) {
              var scrollLeft = container.scrollLeft;

              if (container.tagName.toLowerCase() === "body") {
                // in firefox body.scrollLeft always returns 0
                // thus if we are trying to get scrollLeft on a body tag
                // we need to get it from the documentElement
                scrollLeft = scrollLeft || document.documentElement.scrollLeft;
              }

              return scrollLeft;
            }

            function recalculateTargets() {
              cumulativeOffsetContainer = _.cumulativeOffset(container);
              cumulativeOffsetElement = _.cumulativeOffset(element);

              if (x) {
                targetX =
                  cumulativeOffsetElement.left -
                  cumulativeOffsetContainer.left +
                  offset;
                diffX = targetX - initialX;
              }

              if (y) {
                targetY =
                  cumulativeOffsetElement.top -
                  cumulativeOffsetContainer.top +
                  offset;
                diffY = targetY - initialY;
              }
            }

            function step(timestamp) {
              if (abort) return done();
              if (!timeStart) timeStart = timestamp; // When a site has a lot of media that can be loaded asynchronously,
              // the targetY/targetX may end up in the wrong place during scrolling.
              // So we will check this at each step

              if (!lazy) {
                recalculateTargets();
              }

              timeElapsed = timestamp - timeStart;
              progress = Math.min(timeElapsed / duration, 1);
              progress = easingFn(progress);
              topLeft(
                container,
                initialY + diffY * progress,
                initialX + diffX * progress
              );
              timeElapsed < duration
                ? window.requestAnimationFrame(step)
                : done();
            }

            function done() {
              if (!abort) topLeft(container, targetY, targetX);
              timeStart = false;

              _.off(container, abortEvents, abortFn);

              if (abort && onCancel) onCancel(abortEv, element);
              if (!abort && onDone) onDone(element);
            }

            function topLeft(element, top, left) {
              if (y) element.scrollTop = top;
              if (x) element.scrollLeft = left;

              if (element.tagName.toLowerCase() === "body") {
                // in firefox body.scrollTop doesn't scroll the page
                // thus if we are trying to scrollTop on a body tag
                // we need to scroll on the documentElement
                if (y) document.documentElement.scrollTop = top;
                if (x) document.documentElement.scrollLeft = left;
              }
            }

            function scrollTo(target, _duration) {
              var options =
                arguments.length > 2 && arguments[2] !== undefined
                  ? arguments[2]
                  : {};

              if (_typeof(_duration) === "object") {
                options = _duration;
              } else if (typeof _duration === "number") {
                options.duration = _duration;
              }

              element = _.$(target);

              if (!element) {
                return console.warn(
                  "[vue-scrollto warn]: Trying to scroll to an element that is not on the page: " +
                    target
                );
              }

              container = _.$(options.container || defaults.container);
              duration = options.hasOwnProperty("duration")
                ? options.duration
                : defaults.duration;
              lazy = options.hasOwnProperty("lazy")
                ? options.lazy
                : defaults.lazy;
              easing = options.easing || defaults.easing;
              offset = options.hasOwnProperty("offset")
                ? options.offset
                : defaults.offset;
              force = options.hasOwnProperty("force")
                ? options.force !== false
                : defaults.force;
              cancelable = options.hasOwnProperty("cancelable")
                ? options.cancelable !== false
                : defaults.cancelable;
              onStart = options.onStart || defaults.onStart;
              onDone = options.onDone || defaults.onDone;
              onCancel = options.onCancel || defaults.onCancel;
              x = options.x === undefined ? defaults.x : options.x;
              y = options.y === undefined ? defaults.y : options.y;

              if (typeof offset === "function") {
                offset = offset(element, container);
              }

              initialX = scrollLeft(container);
              initialY = scrollTop(container); // calculates cumulative offsets and targetX/Y + diffX/Y

              recalculateTargets();
              abort = false;

              if (!force) {
                // When the container is the default (body) we need to use the viewport
                // height, not the entire body height
                var containerHeight =
                  container.tagName.toLowerCase() === "body"
                    ? document.documentElement.clientHeight ||
                      window.innerHeight
                    : container.offsetHeight;
                var containerTop = initialY;
                var containerBottom = containerTop + containerHeight;
                var elementTop = targetY - offset;
                var elementBottom = elementTop + element.offsetHeight;

                if (
                  elementTop >= containerTop &&
                  elementBottom <= containerBottom
                ) {
                  // make sure to call the onDone callback even if there is no need to
                  // scroll the container. Fixes #111 (ref #118)
                  if (onDone) onDone(element);
                  return;
                }
              }

              if (onStart) onStart(element);

              if (!diffY && !diffX) {
                if (onDone) onDone(element);
                return;
              }

              if (typeof easing === "string") {
                easing = easings[easing] || easings["ease"];
              }

              easingFn = src.apply(src, easing);

              _.on(container, abortEvents, abortFn, {
                passive: true,
              });

              window.requestAnimationFrame(step);
              return function () {
                abortEv = null;
                abort = true;
              };
            }

            return scrollTo;
          };

          var _scroller = scroller();

          var bindings = []; // store binding data

          function deleteBinding(el) {
            for (var i = 0; i < bindings.length; ++i) {
              if (bindings[i].el === el) {
                bindings.splice(i, 1);
                return true;
              }
            }

            return false;
          }

          function findBinding(el) {
            for (var i = 0; i < bindings.length; ++i) {
              if (bindings[i].el === el) {
                return bindings[i];
              }
            }
          }

          function getBinding(el) {
            var binding = findBinding(el);

            if (binding) {
              return binding;
            }

            bindings.push(
              (binding = {
                el: el,
                binding: {},
              })
            );
            return binding;
          }

          function handleClick(e) {
            var ctx = getBinding(this).binding;
            if (!ctx.value) return;
            e.preventDefault();

            if (typeof ctx.value === "string") {
              return _scroller(ctx.value);
            }

            _scroller(ctx.value.el || ctx.value.element, ctx.value);
          }

          var directiveHooks = {
            bind: function bind(el, binding) {
              getBinding(el).binding = binding;

              _.on(el, "click", handleClick);
            },
            unbind: function unbind(el) {
              deleteBinding(el);

              _.off(el, "click", handleClick);
            },
            update: function update(el, binding) {
              getBinding(el).binding = binding;
            },
          };
          var VueScrollTo = {
            bind: directiveHooks.bind,
            unbind: directiveHooks.unbind,
            update: directiveHooks.update,
            beforeMount: directiveHooks.bind,
            unmounted: directiveHooks.unbind,
            updated: directiveHooks.update,
            scrollTo: _scroller,
            bindings: bindings,
          };

          var install = function install(Vue, options) {
            if (options) setDefaults(options);
            Vue.directive("scroll-to", VueScrollTo);
            var properties = Vue.config.globalProperties || Vue.prototype;
            properties.$scrollTo = VueScrollTo.scrollTo;
          };

          if (typeof window !== "undefined" && window.Vue) {
            window.VueScrollTo = VueScrollTo;
            window.VueScrollTo.setDefaults = setDefaults;
            window.VueScrollTo.scroller = scroller;
            if (window.Vue.use) window.Vue.use(install);
          }

          VueScrollTo.install = install;

          return VueScrollTo;
        });

        /***/
      },

    /***/ "./node_modules/vue/dist/vue.js":
      /*!**************************************!*\
  !*** ./node_modules/vue/dist/vue.js ***!
  \**************************************/
      /***/ function (module, __unused_webpack_exports, __webpack_require__) {
        /*!
         * Vue.js v2.7.14
         * (c) 2014-2022 Evan You
         * Released under the MIT License.
         */
        (function (global, factory) {
          true ? (module.exports = factory()) : 0;
        })(this, function () {
          "use strict";

          var emptyObject = Object.freeze({});
          var isArray = Array.isArray;
          // These helpers produce better VM code in JS engines due to their
          // explicitness and function inlining.
          function isUndef(v) {
            return v === undefined || v === null;
          }
          function isDef(v) {
            return v !== undefined && v !== null;
          }
          function isTrue(v) {
            return v === true;
          }
          function isFalse(v) {
            return v === false;
          }
          /**
           * Check if value is primitive.
           */
          function isPrimitive(value) {
            return (
              typeof value === "string" ||
              typeof value === "number" ||
              // $flow-disable-line
              typeof value === "symbol" ||
              typeof value === "boolean"
            );
          }
          function isFunction(value) {
            return typeof value === "function";
          }
          /**
           * Quick object check - this is primarily used to tell
           * objects from primitive values when we know the value
           * is a JSON-compliant type.
           */
          function isObject(obj) {
            return obj !== null && typeof obj === "object";
          }
          /**
           * Get the raw type string of a value, e.g., [object Object].
           */
          var _toString = Object.prototype.toString;
          function toRawType(value) {
            return _toString.call(value).slice(8, -1);
          }
          /**
           * Strict object type check. Only returns true
           * for plain JavaScript objects.
           */
          function isPlainObject(obj) {
            return _toString.call(obj) === "[object Object]";
          }
          function isRegExp(v) {
            return _toString.call(v) === "[object RegExp]";
          }
          /**
           * Check if val is a valid array index.
           */
          function isValidArrayIndex(val) {
            var n = parseFloat(String(val));
            return n >= 0 && Math.floor(n) === n && isFinite(val);
          }
          function isPromise(val) {
            return (
              isDef(val) &&
              typeof val.then === "function" &&
              typeof val.catch === "function"
            );
          }
          /**
           * Convert a value to a string that is actually rendered.
           */
          function toString(val) {
            return val == null
              ? ""
              : Array.isArray(val) ||
                (isPlainObject(val) && val.toString === _toString)
              ? JSON.stringify(val, null, 2)
              : String(val);
          }
          /**
           * Convert an input value to a number for persistence.
           * If the conversion fails, return original string.
           */
          function toNumber(val) {
            var n = parseFloat(val);
            return isNaN(n) ? val : n;
          }
          /**
           * Make a map and return a function for checking if a key
           * is in that map.
           */
          function makeMap(str, expectsLowerCase) {
            var map = Object.create(null);
            var list = str.split(",");
            for (var i = 0; i < list.length; i++) {
              map[list[i]] = true;
            }
            return expectsLowerCase
              ? function (val) {
                  return map[val.toLowerCase()];
                }
              : function (val) {
                  return map[val];
                };
          }
          /**
           * Check if a tag is a built-in tag.
           */
          var isBuiltInTag = makeMap("slot,component", true);
          /**
           * Check if an attribute is a reserved attribute.
           */
          var isReservedAttribute = makeMap("key,ref,slot,slot-scope,is");
          /**
           * Remove an item from an array.
           */
          function remove$2(arr, item) {
            var len = arr.length;
            if (len) {
              // fast path for the only / last item
              if (item === arr[len - 1]) {
                arr.length = len - 1;
                return;
              }
              var index = arr.indexOf(item);
              if (index > -1) {
                return arr.splice(index, 1);
              }
            }
          }
          /**
           * Check whether an object has the property.
           */
          var hasOwnProperty = Object.prototype.hasOwnProperty;
          function hasOwn(obj, key) {
            return hasOwnProperty.call(obj, key);
          }
          /**
           * Create a cached version of a pure function.
           */
          function cached(fn) {
            var cache = Object.create(null);
            return function cachedFn(str) {
              var hit = cache[str];
              return hit || (cache[str] = fn(str));
            };
          }
          /**
           * Camelize a hyphen-delimited string.
           */
          var camelizeRE = /-(\w)/g;
          var camelize = cached(function (str) {
            return str.replace(camelizeRE, function (_, c) {
              return c ? c.toUpperCase() : "";
            });
          });
          /**
           * Capitalize a string.
           */
          var capitalize = cached(function (str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
          });
          /**
           * Hyphenate a camelCase string.
           */
          var hyphenateRE = /\B([A-Z])/g;
          var hyphenate = cached(function (str) {
            return str.replace(hyphenateRE, "-$1").toLowerCase();
          });
          /**
           * Simple bind polyfill for environments that do not support it,
           * e.g., PhantomJS 1.x. Technically, we don't need this anymore
           * since native bind is now performant enough in most browsers.
           * But removing it would mean breaking code that was able to run in
           * PhantomJS 1.x, so this must be kept for backward compatibility.
           */
          /* istanbul ignore next */
          function polyfillBind(fn, ctx) {
            function boundFn(a) {
              var l = arguments.length;
              return l
                ? l > 1
                  ? fn.apply(ctx, arguments)
                  : fn.call(ctx, a)
                : fn.call(ctx);
            }
            boundFn._length = fn.length;
            return boundFn;
          }
          function nativeBind(fn, ctx) {
            return fn.bind(ctx);
          }
          // @ts-expect-error bind cannot be `undefined`
          var bind$1 = Function.prototype.bind ? nativeBind : polyfillBind;
          /**
           * Convert an Array-like object to a real Array.
           */
          function toArray(list, start) {
            start = start || 0;
            var i = list.length - start;
            var ret = new Array(i);
            while (i--) {
              ret[i] = list[i + start];
            }
            return ret;
          }
          /**
           * Mix properties into target object.
           */
          function extend(to, _from) {
            for (var key in _from) {
              to[key] = _from[key];
            }
            return to;
          }
          /**
           * Merge an Array of Objects into a single Object.
           */
          function toObject(arr) {
            var res = {};
            for (var i = 0; i < arr.length; i++) {
              if (arr[i]) {
                extend(res, arr[i]);
              }
            }
            return res;
          }
          /* eslint-disable no-unused-vars */
          /**
           * Perform no operation.
           * Stubbing args to make Flow happy without leaving useless transpiled code
           * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
           */
          function noop(a, b, c) {}
          /**
           * Always return false.
           */
          var no = function (a, b, c) {
            return false;
          };
          /* eslint-enable no-unused-vars */
          /**
           * Return the same value.
           */
          var identity = function (_) {
            return _;
          };
          /**
           * Generate a string containing static keys from compiler modules.
           */
          function genStaticKeys$1(modules) {
            return modules
              .reduce(function (keys, m) {
                return keys.concat(m.staticKeys || []);
              }, [])
              .join(",");
          }
          /**
           * Check if two values are loosely equal - that is,
           * if they are plain objects, do they have the same shape?
           */
          function looseEqual(a, b) {
            if (a === b) return true;
            var isObjectA = isObject(a);
            var isObjectB = isObject(b);
            if (isObjectA && isObjectB) {
              try {
                var isArrayA = Array.isArray(a);
                var isArrayB = Array.isArray(b);
                if (isArrayA && isArrayB) {
                  return (
                    a.length === b.length &&
                    a.every(function (e, i) {
                      return looseEqual(e, b[i]);
                    })
                  );
                } else if (a instanceof Date && b instanceof Date) {
                  return a.getTime() === b.getTime();
                } else if (!isArrayA && !isArrayB) {
                  var keysA = Object.keys(a);
                  var keysB = Object.keys(b);
                  return (
                    keysA.length === keysB.length &&
                    keysA.every(function (key) {
                      return looseEqual(a[key], b[key]);
                    })
                  );
                } else {
                  /* istanbul ignore next */
                  return false;
                }
              } catch (e) {
                /* istanbul ignore next */
                return false;
              }
            } else if (!isObjectA && !isObjectB) {
              return String(a) === String(b);
            } else {
              return false;
            }
          }
          /**
           * Return the first index at which a loosely equal value can be
           * found in the array (if value is a plain object, the array must
           * contain an object of the same shape), or -1 if it is not present.
           */
          function looseIndexOf(arr, val) {
            for (var i = 0; i < arr.length; i++) {
              if (looseEqual(arr[i], val)) return i;
            }
            return -1;
          }
          /**
           * Ensure a function is called only once.
           */
          function once(fn) {
            var called = false;
            return function () {
              if (!called) {
                called = true;
                fn.apply(this, arguments);
              }
            };
          }
          // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
          function hasChanged(x, y) {
            if (x === y) {
              return x === 0 && 1 / x !== 1 / y;
            } else {
              return x === x || y === y;
            }
          }

          var SSR_ATTR = "data-server-rendered";
          var ASSET_TYPES = ["component", "directive", "filter"];
          var LIFECYCLE_HOOKS = [
            "beforeCreate",
            "created",
            "beforeMount",
            "mounted",
            "beforeUpdate",
            "updated",
            "beforeDestroy",
            "destroyed",
            "activated",
            "deactivated",
            "errorCaptured",
            "serverPrefetch",
            "renderTracked",
            "renderTriggered",
          ];

          var config = {
            /**
             * Option merge strategies (used in core/util/options)
             */
            // $flow-disable-line
            optionMergeStrategies: Object.create(null),
            /**
             * Whether to suppress warnings.
             */
            silent: false,
            /**
             * Show production mode tip message on boot?
             */
            productionTip: true,
            /**
             * Whether to enable devtools
             */
            devtools: true,
            /**
             * Whether to record perf
             */
            performance: false,
            /**
             * Error handler for watcher errors
             */
            errorHandler: null,
            /**
             * Warn handler for watcher warns
             */
            warnHandler: null,
            /**
             * Ignore certain custom elements
             */
            ignoredElements: [],
            /**
             * Custom user key aliases for v-on
             */
            // $flow-disable-line
            keyCodes: Object.create(null),
            /**
             * Check if a tag is reserved so that it cannot be registered as a
             * component. This is platform-dependent and may be overwritten.
             */
            isReservedTag: no,
            /**
             * Check if an attribute is reserved so that it cannot be used as a component
             * prop. This is platform-dependent and may be overwritten.
             */
            isReservedAttr: no,
            /**
             * Check if a tag is an unknown element.
             * Platform-dependent.
             */
            isUnknownElement: no,
            /**
             * Get the namespace of an element
             */
            getTagNamespace: noop,
            /**
             * Parse the real tag name for the specific platform.
             */
            parsePlatformTagName: identity,
            /**
             * Check if an attribute must be bound using property, e.g. value
             * Platform-dependent.
             */
            mustUseProp: no,
            /**
             * Perform updates asynchronously. Intended to be used by Vue Test Utils
             * This will significantly reduce performance if set to false.
             */
            async: true,
            /**
             * Exposed for legacy reasons
             */
            _lifecycleHooks: LIFECYCLE_HOOKS,
          };

          /**
           * unicode letters used for parsing html tags, component names and property paths.
           * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
           * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
           */
          var unicodeRegExp =
            /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
          /**
           * Check if a string starts with $ or _
           */
          function isReserved(str) {
            var c = (str + "").charCodeAt(0);
            return c === 0x24 || c === 0x5f;
          }
          /**
           * Define a property.
           */
          function def(obj, key, val, enumerable) {
            Object.defineProperty(obj, key, {
              value: val,
              enumerable: !!enumerable,
              writable: true,
              configurable: true,
            });
          }
          /**
           * Parse simple path.
           */
          var bailRE = new RegExp("[^".concat(unicodeRegExp.source, ".$_\\d]"));
          function parsePath(path) {
            if (bailRE.test(path)) {
              return;
            }
            var segments = path.split(".");
            return function (obj) {
              for (var i = 0; i < segments.length; i++) {
                if (!obj) return;
                obj = obj[segments[i]];
              }
              return obj;
            };
          }

          // can we use __proto__?
          var hasProto = "__proto__" in {};
          // Browser environment sniffing
          var inBrowser = typeof window !== "undefined";
          var UA = inBrowser && window.navigator.userAgent.toLowerCase();
          var isIE = UA && /msie|trident/.test(UA);
          var isIE9 = UA && UA.indexOf("msie 9.0") > 0;
          var isEdge = UA && UA.indexOf("edge/") > 0;
          UA && UA.indexOf("android") > 0;
          var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
          UA && /chrome\/\d+/.test(UA) && !isEdge;
          UA && /phantomjs/.test(UA);
          var isFF = UA && UA.match(/firefox\/(\d+)/);
          // Firefox has a "watch" function on Object.prototype...
          // @ts-expect-error firebox support
          var nativeWatch = {}.watch;
          var supportsPassive = false;
          if (inBrowser) {
            try {
              var opts = {};
              Object.defineProperty(opts, "passive", {
                get: function () {
                  /* istanbul ignore next */
                  supportsPassive = true;
                },
              }); // https://github.com/facebook/flow/issues/285
              window.addEventListener("test-passive", null, opts);
            } catch (e) {}
          }
          // this needs to be lazy-evaled because vue may be required before
          // vue-server-renderer can set VUE_ENV
          var _isServer;
          var isServerRendering = function () {
            if (_isServer === undefined) {
              /* istanbul ignore if */
              if (!inBrowser && typeof __webpack_require__.g !== "undefined") {
                // detect presence of vue-server-renderer and avoid
                // Webpack shimming the process
                _isServer =
                  __webpack_require__.g["process"] &&
                  __webpack_require__.g["process"].env.VUE_ENV === "server";
              } else {
                _isServer = false;
              }
            }
            return _isServer;
          };
          // detect devtools
          var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
          /* istanbul ignore next */
          function isNative(Ctor) {
            return (
              typeof Ctor === "function" && /native code/.test(Ctor.toString())
            );
          }
          var hasSymbol =
            typeof Symbol !== "undefined" &&
            isNative(Symbol) &&
            typeof Reflect !== "undefined" &&
            isNative(Reflect.ownKeys);
          var _Set; // $flow-disable-line
          /* istanbul ignore if */ if (
            typeof Set !== "undefined" &&
            isNative(Set)
          ) {
            // use native Set when available.
            _Set = Set;
          } else {
            // a non-standard Set polyfill that only works with primitive keys.
            _Set = /** @class */ (function () {
              function Set() {
                this.set = Object.create(null);
              }
              Set.prototype.has = function (key) {
                return this.set[key] === true;
              };
              Set.prototype.add = function (key) {
                this.set[key] = true;
              };
              Set.prototype.clear = function () {
                this.set = Object.create(null);
              };
              return Set;
            })();
          }

          var currentInstance = null;
          /**
           * This is exposed for compatibility with v3 (e.g. some functions in VueUse
           * relies on it). Do not use this internally, just use `currentInstance`.
           *
           * @internal this function needs manual type declaration because it relies
           * on previously manually authored types from Vue 2
           */
          function getCurrentInstance() {
            return currentInstance && { proxy: currentInstance };
          }
          /**
           * @internal
           */
          function setCurrentInstance(vm) {
            if (vm === void 0) {
              vm = null;
            }
            if (!vm) currentInstance && currentInstance._scope.off();
            currentInstance = vm;
            vm && vm._scope.on();
          }

          /**
           * @internal
           */
          var VNode = /** @class */ (function () {
            function VNode(
              tag,
              data,
              children,
              text,
              elm,
              context,
              componentOptions,
              asyncFactory
            ) {
              this.tag = tag;
              this.data = data;
              this.children = children;
              this.text = text;
              this.elm = elm;
              this.ns = undefined;
              this.context = context;
              this.fnContext = undefined;
              this.fnOptions = undefined;
              this.fnScopeId = undefined;
              this.key = data && data.key;
              this.componentOptions = componentOptions;
              this.componentInstance = undefined;
              this.parent = undefined;
              this.raw = false;
              this.isStatic = false;
              this.isRootInsert = true;
              this.isComment = false;
              this.isCloned = false;
              this.isOnce = false;
              this.asyncFactory = asyncFactory;
              this.asyncMeta = undefined;
              this.isAsyncPlaceholder = false;
            }
            Object.defineProperty(VNode.prototype, "child", {
              // DEPRECATED: alias for componentInstance for backwards compat.
              /* istanbul ignore next */
              get: function () {
                return this.componentInstance;
              },
              enumerable: false,
              configurable: true,
            });
            return VNode;
          })();
          var createEmptyVNode = function (text) {
            if (text === void 0) {
              text = "";
            }
            var node = new VNode();
            node.text = text;
            node.isComment = true;
            return node;
          };
          function createTextVNode(val) {
            return new VNode(undefined, undefined, undefined, String(val));
          }
          // optimized shallow clone
          // used for static nodes and slot nodes because they may be reused across
          // multiple renders, cloning them avoids errors when DOM manipulations rely
          // on their elm reference.
          function cloneVNode(vnode) {
            var cloned = new VNode(
              vnode.tag,
              vnode.data,
              // #7975
              // clone children array to avoid mutating original in case of cloning
              // a child.
              vnode.children && vnode.children.slice(),
              vnode.text,
              vnode.elm,
              vnode.context,
              vnode.componentOptions,
              vnode.asyncFactory
            );
            cloned.ns = vnode.ns;
            cloned.isStatic = vnode.isStatic;
            cloned.key = vnode.key;
            cloned.isComment = vnode.isComment;
            cloned.fnContext = vnode.fnContext;
            cloned.fnOptions = vnode.fnOptions;
            cloned.fnScopeId = vnode.fnScopeId;
            cloned.asyncMeta = vnode.asyncMeta;
            cloned.isCloned = true;
            return cloned;
          }

          /* not type checking this file because flow doesn't play well with Proxy */
          var initProxy;
          {
            var allowedGlobals_1 = makeMap(
              "Infinity,undefined,NaN,isFinite,isNaN," +
                "parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent," +
                "Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt," +
                "require" // for Webpack/Browserify
            );
            var warnNonPresent_1 = function (target, key) {
              warn$2(
                'Property or method "'.concat(
                  key,
                  '" is not defined on the instance but '
                ) +
                  "referenced during render. Make sure that this property is reactive, " +
                  "either in the data option, or for class-based components, by " +
                  "initializing the property. " +
                  "See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.",
                target
              );
            };
            var warnReservedPrefix_1 = function (target, key) {
              warn$2(
                'Property "'
                  .concat(key, '" must be accessed with "$data.')
                  .concat(key, '" because ') +
                  'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
                  "prevent conflicts with Vue internals. " +
                  "See: https://v2.vuejs.org/v2/api/#data",
                target
              );
            };
            var hasProxy_1 = typeof Proxy !== "undefined" && isNative(Proxy);
            if (hasProxy_1) {
              var isBuiltInModifier_1 = makeMap(
                "stop,prevent,self,ctrl,shift,alt,meta,exact"
              );
              config.keyCodes = new Proxy(config.keyCodes, {
                set: function (target, key, value) {
                  if (isBuiltInModifier_1(key)) {
                    warn$2(
                      "Avoid overwriting built-in modifier in config.keyCodes: .".concat(
                        key
                      )
                    );
                    return false;
                  } else {
                    target[key] = value;
                    return true;
                  }
                },
              });
            }
            var hasHandler_1 = {
              has: function (target, key) {
                var has = key in target;
                var isAllowed =
                  allowedGlobals_1(key) ||
                  (typeof key === "string" &&
                    key.charAt(0) === "_" &&
                    !(key in target.$data));
                if (!has && !isAllowed) {
                  if (key in target.$data) warnReservedPrefix_1(target, key);
                  else warnNonPresent_1(target, key);
                }
                return has || !isAllowed;
              },
            };
            var getHandler_1 = {
              get: function (target, key) {
                if (typeof key === "string" && !(key in target)) {
                  if (key in target.$data) warnReservedPrefix_1(target, key);
                  else warnNonPresent_1(target, key);
                }
                return target[key];
              },
            };
            initProxy = function initProxy(vm) {
              if (hasProxy_1) {
                // determine which proxy handler to use
                var options = vm.$options;
                var handlers =
                  options.render && options.render._withStripped
                    ? getHandler_1
                    : hasHandler_1;
                vm._renderProxy = new Proxy(vm, handlers);
              } else {
                vm._renderProxy = vm;
              }
            };
          }

          /******************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

          var __assign = function () {
            __assign =
              Object.assign ||
              function __assign(t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                  s = arguments[i];
                  for (var p in s)
                    if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
              };
            return __assign.apply(this, arguments);
          };

          var uid$2 = 0;
          var pendingCleanupDeps = [];
          var cleanupDeps = function () {
            for (var i = 0; i < pendingCleanupDeps.length; i++) {
              var dep = pendingCleanupDeps[i];
              dep.subs = dep.subs.filter(function (s) {
                return s;
              });
              dep._pending = false;
            }
            pendingCleanupDeps.length = 0;
          };
          /**
           * A dep is an observable that can have multiple
           * directives subscribing to it.
           * @internal
           */
          var Dep = /** @class */ (function () {
            function Dep() {
              // pending subs cleanup
              this._pending = false;
              this.id = uid$2++;
              this.subs = [];
            }
            Dep.prototype.addSub = function (sub) {
              this.subs.push(sub);
            };
            Dep.prototype.removeSub = function (sub) {
              // #12696 deps with massive amount of subscribers are extremely slow to
              // clean up in Chromium
              // to workaround this, we unset the sub for now, and clear them on
              // next scheduler flush.
              this.subs[this.subs.indexOf(sub)] = null;
              if (!this._pending) {
                this._pending = true;
                pendingCleanupDeps.push(this);
              }
            };
            Dep.prototype.depend = function (info) {
              if (Dep.target) {
                Dep.target.addDep(this);
                if (info && Dep.target.onTrack) {
                  Dep.target.onTrack(__assign({ effect: Dep.target }, info));
                }
              }
            };
            Dep.prototype.notify = function (info) {
              // stabilize the subscriber list first
              var subs = this.subs.filter(function (s) {
                return s;
              });
              if (!config.async) {
                // subs aren't sorted in scheduler if not running async
                // we need to sort them now to make sure they fire in correct
                // order
                subs.sort(function (a, b) {
                  return a.id - b.id;
                });
              }
              for (var i = 0, l = subs.length; i < l; i++) {
                var sub = subs[i];
                if (info) {
                  sub.onTrigger &&
                    sub.onTrigger(__assign({ effect: subs[i] }, info));
                }
                sub.update();
              }
            };
            return Dep;
          })();
          // The current target watcher being evaluated.
          // This is globally unique because only one watcher
          // can be evaluated at a time.
          Dep.target = null;
          var targetStack = [];
          function pushTarget(target) {
            targetStack.push(target);
            Dep.target = target;
          }
          function popTarget() {
            targetStack.pop();
            Dep.target = targetStack[targetStack.length - 1];
          }

          /*
           * not type checking this file because flow doesn't play well with
           * dynamically accessing methods on Array prototype
           */
          var arrayProto = Array.prototype;
          var arrayMethods = Object.create(arrayProto);
          var methodsToPatch = [
            "push",
            "pop",
            "shift",
            "unshift",
            "splice",
            "sort",
            "reverse",
          ];
          /**
           * Intercept mutating methods and emit events
           */
          methodsToPatch.forEach(function (method) {
            // cache original method
            var original = arrayProto[method];
            def(arrayMethods, method, function mutator() {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
              }
              var result = original.apply(this, args);
              var ob = this.__ob__;
              var inserted;
              switch (method) {
                case "push":
                case "unshift":
                  inserted = args;
                  break;
                case "splice":
                  inserted = args.slice(2);
                  break;
              }
              if (inserted) ob.observeArray(inserted);
              // notify change
              {
                ob.dep.notify({
                  type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */,
                  target: this,
                  key: method,
                });
              }
              return result;
            });
          });

          var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
          var NO_INIITIAL_VALUE = {};
          /**
           * In some cases we may want to disable observation inside a component's
           * update computation.
           */
          var shouldObserve = true;
          function toggleObserving(value) {
            shouldObserve = value;
          }
          // ssr mock dep
          var mockDep = {
            notify: noop,
            depend: noop,
            addSub: noop,
            removeSub: noop,
          };
          /**
           * Observer class that is attached to each observed
           * object. Once attached, the observer converts the target
           * object's property keys into getter/setters that
           * collect dependencies and dispatch updates.
           */
          var Observer = /** @class */ (function () {
            function Observer(value, shallow, mock) {
              if (shallow === void 0) {
                shallow = false;
              }
              if (mock === void 0) {
                mock = false;
              }
              this.value = value;
              this.shallow = shallow;
              this.mock = mock;
              // this.value = value
              this.dep = mock ? mockDep : new Dep();
              this.vmCount = 0;
              def(value, "__ob__", this);
              if (isArray(value)) {
                if (!mock) {
                  if (hasProto) {
                    value.__proto__ = arrayMethods;
                    /* eslint-enable no-proto */
                  } else {
                    for (var i = 0, l = arrayKeys.length; i < l; i++) {
                      var key = arrayKeys[i];
                      def(value, key, arrayMethods[key]);
                    }
                  }
                }
                if (!shallow) {
                  this.observeArray(value);
                }
              } else {
                /**
                 * Walk through all properties and convert them into
                 * getter/setters. This method should only be called when
                 * value type is Object.
                 */
                var keys = Object.keys(value);
                for (var i = 0; i < keys.length; i++) {
                  var key = keys[i];
                  defineReactive(
                    value,
                    key,
                    NO_INIITIAL_VALUE,
                    undefined,
                    shallow,
                    mock
                  );
                }
              }
            }
            /**
             * Observe a list of Array items.
             */
            Observer.prototype.observeArray = function (value) {
              for (var i = 0, l = value.length; i < l; i++) {
                observe(value[i], false, this.mock);
              }
            };
            return Observer;
          })();
          // helpers
          /**
           * Attempt to create an observer instance for a value,
           * returns the new observer if successfully observed,
           * or the existing observer if the value already has one.
           */
          function observe(value, shallow, ssrMockReactivity) {
            if (
              value &&
              hasOwn(value, "__ob__") &&
              value.__ob__ instanceof Observer
            ) {
              return value.__ob__;
            }
            if (
              shouldObserve &&
              (ssrMockReactivity || !isServerRendering()) &&
              (isArray(value) || isPlainObject(value)) &&
              Object.isExtensible(value) &&
              !value.__v_skip /* ReactiveFlags.SKIP */ &&
              !isRef(value) &&
              !(value instanceof VNode)
            ) {
              return new Observer(value, shallow, ssrMockReactivity);
            }
          }
          /**
           * Define a reactive property on an Object.
           */
          function defineReactive(obj, key, val, customSetter, shallow, mock) {
            var dep = new Dep();
            var property = Object.getOwnPropertyDescriptor(obj, key);
            if (property && property.configurable === false) {
              return;
            }
            // cater for pre-defined getter/setters
            var getter = property && property.get;
            var setter = property && property.set;
            if (
              (!getter || setter) &&
              (val === NO_INIITIAL_VALUE || arguments.length === 2)
            ) {
              val = obj[key];
            }
            var childOb = !shallow && observe(val, false, mock);
            Object.defineProperty(obj, key, {
              enumerable: true,
              configurable: true,
              get: function reactiveGetter() {
                var value = getter ? getter.call(obj) : val;
                if (Dep.target) {
                  {
                    dep.depend({
                      target: obj,
                      type: "get" /* TrackOpTypes.GET */,
                      key: key,
                    });
                  }
                  if (childOb) {
                    childOb.dep.depend();
                    if (isArray(value)) {
                      dependArray(value);
                    }
                  }
                }
                return isRef(value) && !shallow ? value.value : value;
              },
              set: function reactiveSetter(newVal) {
                var value = getter ? getter.call(obj) : val;
                if (!hasChanged(value, newVal)) {
                  return;
                }
                if (customSetter) {
                  customSetter();
                }
                if (setter) {
                  setter.call(obj, newVal);
                } else if (getter) {
                  // #7981: for accessor properties without setter
                  return;
                } else if (!shallow && isRef(value) && !isRef(newVal)) {
                  value.value = newVal;
                  return;
                } else {
                  val = newVal;
                }
                childOb = !shallow && observe(newVal, false, mock);
                {
                  dep.notify({
                    type: "set" /* TriggerOpTypes.SET */,
                    target: obj,
                    key: key,
                    newValue: newVal,
                    oldValue: value,
                  });
                }
              },
            });
            return dep;
          }
          function set(target, key, val) {
            if (isUndef(target) || isPrimitive(target)) {
              warn$2(
                "Cannot set reactive property on undefined, null, or primitive value: ".concat(
                  target
                )
              );
            }
            if (isReadonly(target)) {
              warn$2(
                'Set operation on key "'.concat(
                  key,
                  '" failed: target is readonly.'
                )
              );
              return;
            }
            var ob = target.__ob__;
            if (isArray(target) && isValidArrayIndex(key)) {
              target.length = Math.max(target.length, key);
              target.splice(key, 1, val);
              // when mocking for SSR, array methods are not hijacked
              if (ob && !ob.shallow && ob.mock) {
                observe(val, false, true);
              }
              return val;
            }
            if (key in target && !(key in Object.prototype)) {
              target[key] = val;
              return val;
            }
            if (target._isVue || (ob && ob.vmCount)) {
              warn$2(
                "Avoid adding reactive properties to a Vue instance or its root $data " +
                  "at runtime - declare it upfront in the data option."
              );
              return val;
            }
            if (!ob) {
              target[key] = val;
              return val;
            }
            defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
            {
              ob.dep.notify({
                type: "add" /* TriggerOpTypes.ADD */,
                target: target,
                key: key,
                newValue: val,
                oldValue: undefined,
              });
            }
            return val;
          }
          function del(target, key) {
            if (isUndef(target) || isPrimitive(target)) {
              warn$2(
                "Cannot delete reactive property on undefined, null, or primitive value: ".concat(
                  target
                )
              );
            }
            if (isArray(target) && isValidArrayIndex(key)) {
              target.splice(key, 1);
              return;
            }
            var ob = target.__ob__;
            if (target._isVue || (ob && ob.vmCount)) {
              warn$2(
                "Avoid deleting properties on a Vue instance or its root $data " +
                  "- just set it to null."
              );
              return;
            }
            if (isReadonly(target)) {
              warn$2(
                'Delete operation on key "'.concat(
                  key,
                  '" failed: target is readonly.'
                )
              );
              return;
            }
            if (!hasOwn(target, key)) {
              return;
            }
            delete target[key];
            if (!ob) {
              return;
            }
            {
              ob.dep.notify({
                type: "delete" /* TriggerOpTypes.DELETE */,
                target: target,
                key: key,
              });
            }
          }
          /**
           * Collect dependencies on array elements when the array is touched, since
           * we cannot intercept array element access like property getters.
           */
          function dependArray(value) {
            for (var e = void 0, i = 0, l = value.length; i < l; i++) {
              e = value[i];
              if (e && e.__ob__) {
                e.__ob__.dep.depend();
              }
              if (isArray(e)) {
                dependArray(e);
              }
            }
          }

          function reactive(target) {
            makeReactive(target, false);
            return target;
          }
          /**
           * Return a shallowly-reactive copy of the original object, where only the root
           * level properties are reactive. It also does not auto-unwrap refs (even at the
           * root level).
           */
          function shallowReactive(target) {
            makeReactive(target, true);
            def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
            return target;
          }
          function makeReactive(target, shallow) {
            // if trying to observe a readonly proxy, return the readonly version.
            if (!isReadonly(target)) {
              {
                if (isArray(target)) {
                  warn$2(
                    "Avoid using Array as root value for "
                      .concat(
                        shallow ? "shallowReactive()" : "reactive()",
                        " as it cannot be tracked in watch() or watchEffect(). Use "
                      )
                      .concat(
                        shallow ? "shallowRef()" : "ref()",
                        " instead. This is a Vue-2-only limitation."
                      )
                  );
                }
                var existingOb = target && target.__ob__;
                if (existingOb && existingOb.shallow !== shallow) {
                  warn$2(
                    "Target is already a "
                      .concat(
                        existingOb.shallow ? "" : "non-",
                        "shallow reactive object, and cannot be converted to "
                      )
                      .concat(shallow ? "" : "non-", "shallow.")
                  );
                }
              }
              var ob = observe(
                target,
                shallow,
                isServerRendering() /* ssr mock reactivity */
              );
              if (!ob) {
                if (target == null || isPrimitive(target)) {
                  warn$2(
                    "value cannot be made reactive: ".concat(String(target))
                  );
                }
                if (isCollectionType(target)) {
                  warn$2(
                    "Vue 2 does not support reactive collection types such as Map or Set."
                  );
                }
              }
            }
          }
          function isReactive(value) {
            if (isReadonly(value)) {
              return isReactive(value["__v_raw" /* ReactiveFlags.RAW */]);
            }
            return !!(value && value.__ob__);
          }
          function isShallow(value) {
            return !!(value && value.__v_isShallow);
          }
          function isReadonly(value) {
            return !!(value && value.__v_isReadonly);
          }
          function isProxy(value) {
            return isReactive(value) || isReadonly(value);
          }
          function toRaw(observed) {
            var raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */];
            return raw ? toRaw(raw) : observed;
          }
          function markRaw(value) {
            // non-extensible objects won't be observed anyway
            if (Object.isExtensible(value)) {
              def(value, "__v_skip" /* ReactiveFlags.SKIP */, true);
            }
            return value;
          }
          /**
           * @internal
           */
          function isCollectionType(value) {
            var type = toRawType(value);
            return (
              type === "Map" ||
              type === "WeakMap" ||
              type === "Set" ||
              type === "WeakSet"
            );
          }

          /**
           * @internal
           */
          var RefFlag = "__v_isRef";
          function isRef(r) {
            return !!(r && r.__v_isRef === true);
          }
          function ref$1(value) {
            return createRef(value, false);
          }
          function shallowRef(value) {
            return createRef(value, true);
          }
          function createRef(rawValue, shallow) {
            if (isRef(rawValue)) {
              return rawValue;
            }
            var ref = {};
            def(ref, RefFlag, true);
            def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, shallow);
            def(
              ref,
              "dep",
              defineReactive(
                ref,
                "value",
                rawValue,
                null,
                shallow,
                isServerRendering()
              )
            );
            return ref;
          }
          function triggerRef(ref) {
            if (!ref.dep) {
              warn$2("received object is not a triggerable ref.");
            }
            {
              ref.dep &&
                ref.dep.notify({
                  type: "set" /* TriggerOpTypes.SET */,
                  target: ref,
                  key: "value",
                });
            }
          }
          function unref(ref) {
            return isRef(ref) ? ref.value : ref;
          }
          function proxyRefs(objectWithRefs) {
            if (isReactive(objectWithRefs)) {
              return objectWithRefs;
            }
            var proxy = {};
            var keys = Object.keys(objectWithRefs);
            for (var i = 0; i < keys.length; i++) {
              proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
            }
            return proxy;
          }
          function proxyWithRefUnwrap(target, source, key) {
            Object.defineProperty(target, key, {
              enumerable: true,
              configurable: true,
              get: function () {
                var val = source[key];
                if (isRef(val)) {
                  return val.value;
                } else {
                  var ob = val && val.__ob__;
                  if (ob) ob.dep.depend();
                  return val;
                }
              },
              set: function (value) {
                var oldValue = source[key];
                if (isRef(oldValue) && !isRef(value)) {
                  oldValue.value = value;
                } else {
                  source[key] = value;
                }
              },
            });
          }
          function customRef(factory) {
            var dep = new Dep();
            var _a = factory(
                function () {
                  {
                    dep.depend({
                      target: ref,
                      type: "get" /* TrackOpTypes.GET */,
                      key: "value",
                    });
                  }
                },
                function () {
                  {
                    dep.notify({
                      target: ref,
                      type: "set" /* TriggerOpTypes.SET */,
                      key: "value",
                    });
                  }
                }
              ),
              get = _a.get,
              set = _a.set;
            var ref = {
              get value() {
                return get();
              },
              set value(newVal) {
                set(newVal);
              },
            };
            def(ref, RefFlag, true);
            return ref;
          }
          function toRefs(object) {
            if (!isReactive(object)) {
              warn$2(
                "toRefs() expects a reactive object but received a plain one."
              );
            }
            var ret = isArray(object) ? new Array(object.length) : {};
            for (var key in object) {
              ret[key] = toRef(object, key);
            }
            return ret;
          }
          function toRef(object, key, defaultValue) {
            var val = object[key];
            if (isRef(val)) {
              return val;
            }
            var ref = {
              get value() {
                var val = object[key];
                return val === undefined ? defaultValue : val;
              },
              set value(newVal) {
                object[key] = newVal;
              },
            };
            def(ref, RefFlag, true);
            return ref;
          }

          var rawToReadonlyFlag = "__v_rawToReadonly";
          var rawToShallowReadonlyFlag = "__v_rawToShallowReadonly";
          function readonly(target) {
            return createReadonly(target, false);
          }
          function createReadonly(target, shallow) {
            if (!isPlainObject(target)) {
              {
                if (isArray(target)) {
                  warn$2("Vue 2 does not support readonly arrays.");
                } else if (isCollectionType(target)) {
                  warn$2(
                    "Vue 2 does not support readonly collection types such as Map or Set."
                  );
                } else {
                  warn$2(
                    "value cannot be made readonly: ".concat(typeof target)
                  );
                }
              }
              return target;
            }
            if (!Object.isExtensible(target)) {
              warn$2(
                "Vue 2 does not support creating readonly proxy for non-extensible object."
              );
            }
            // already a readonly object
            if (isReadonly(target)) {
              return target;
            }
            // already has a readonly proxy
            var existingFlag = shallow
              ? rawToShallowReadonlyFlag
              : rawToReadonlyFlag;
            var existingProxy = target[existingFlag];
            if (existingProxy) {
              return existingProxy;
            }
            var proxy = Object.create(Object.getPrototypeOf(target));
            def(target, existingFlag, proxy);
            def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, true);
            def(proxy, "__v_raw" /* ReactiveFlags.RAW */, target);
            if (isRef(target)) {
              def(proxy, RefFlag, true);
            }
            if (shallow || isShallow(target)) {
              def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
            }
            var keys = Object.keys(target);
            for (var i = 0; i < keys.length; i++) {
              defineReadonlyProperty(proxy, target, keys[i], shallow);
            }
            return proxy;
          }
          function defineReadonlyProperty(proxy, target, key, shallow) {
            Object.defineProperty(proxy, key, {
              enumerable: true,
              configurable: true,
              get: function () {
                var val = target[key];
                return shallow || !isPlainObject(val) ? val : readonly(val);
              },
              set: function () {
                warn$2(
                  'Set operation on key "'.concat(
                    key,
                    '" failed: target is readonly.'
                  )
                );
              },
            });
          }
          /**
           * Returns a reactive-copy of the original object, where only the root level
           * properties are readonly, and does NOT unwrap refs nor recursively convert
           * returned properties.
           * This is used for creating the props proxy object for stateful components.
           */
          function shallowReadonly(target) {
            return createReadonly(target, true);
          }

          function computed(getterOrOptions, debugOptions) {
            var getter;
            var setter;
            var onlyGetter = isFunction(getterOrOptions);
            if (onlyGetter) {
              getter = getterOrOptions;
              setter = function () {
                warn$2("Write operation failed: computed value is readonly");
              };
            } else {
              getter = getterOrOptions.get;
              setter = getterOrOptions.set;
            }
            var watcher = isServerRendering()
              ? null
              : new Watcher(currentInstance, getter, noop, { lazy: true });
            if (watcher && debugOptions) {
              watcher.onTrack = debugOptions.onTrack;
              watcher.onTrigger = debugOptions.onTrigger;
            }
            var ref = {
              // some libs rely on the presence effect for checking computed refs
              // from normal refs, but the implementation doesn't matter
              effect: watcher,
              get value() {
                if (watcher) {
                  if (watcher.dirty) {
                    watcher.evaluate();
                  }
                  if (Dep.target) {
                    if (Dep.target.onTrack) {
                      Dep.target.onTrack({
                        effect: Dep.target,
                        target: ref,
                        type: "get" /* TrackOpTypes.GET */,
                        key: "value",
                      });
                    }
                    watcher.depend();
                  }
                  return watcher.value;
                } else {
                  return getter();
                }
              },
              set value(newVal) {
                setter(newVal);
              },
            };
            def(ref, RefFlag, true);
            def(
              ref,
              "__v_isReadonly" /* ReactiveFlags.IS_READONLY */,
              onlyGetter
            );
            return ref;
          }

          var mark;
          var measure;
          {
            var perf_1 = inBrowser && window.performance;
            /* istanbul ignore if */
            if (
              perf_1 &&
              // @ts-ignore
              perf_1.mark &&
              // @ts-ignore
              perf_1.measure &&
              // @ts-ignore
              perf_1.clearMarks &&
              // @ts-ignore
              perf_1.clearMeasures
            ) {
              mark = function (tag) {
                return perf_1.mark(tag);
              };
              measure = function (name, startTag, endTag) {
                perf_1.measure(name, startTag, endTag);
                perf_1.clearMarks(startTag);
                perf_1.clearMarks(endTag);
                // perf.clearMeasures(name)
              };
            }
          }

          var normalizeEvent = cached(function (name) {
            var passive = name.charAt(0) === "&";
            name = passive ? name.slice(1) : name;
            var once = name.charAt(0) === "~"; // Prefixed last, checked first
            name = once ? name.slice(1) : name;
            var capture = name.charAt(0) === "!";
            name = capture ? name.slice(1) : name;
            return {
              name: name,
              once: once,
              capture: capture,
              passive: passive,
            };
          });
          function createFnInvoker(fns, vm) {
            function invoker() {
              var fns = invoker.fns;
              if (isArray(fns)) {
                var cloned = fns.slice();
                for (var i = 0; i < cloned.length; i++) {
                  invokeWithErrorHandling(
                    cloned[i],
                    null,
                    arguments,
                    vm,
                    "v-on handler"
                  );
                }
              } else {
                // return handler return value for single handlers
                return invokeWithErrorHandling(
                  fns,
                  null,
                  arguments,
                  vm,
                  "v-on handler"
                );
              }
            }
            invoker.fns = fns;
            return invoker;
          }
          function updateListeners(
            on,
            oldOn,
            add,
            remove,
            createOnceHandler,
            vm
          ) {
            var name, cur, old, event;
            for (name in on) {
              cur = on[name];
              old = oldOn[name];
              event = normalizeEvent(name);
              if (isUndef(cur)) {
                warn$2(
                  'Invalid handler for event "'.concat(event.name, '": got ') +
                    String(cur),
                  vm
                );
              } else if (isUndef(old)) {
                if (isUndef(cur.fns)) {
                  cur = on[name] = createFnInvoker(cur, vm);
                }
                if (isTrue(event.once)) {
                  cur = on[name] = createOnceHandler(
                    event.name,
                    cur,
                    event.capture
                  );
                }
                add(
                  event.name,
                  cur,
                  event.capture,
                  event.passive,
                  event.params
                );
              } else if (cur !== old) {
                old.fns = cur;
                on[name] = old;
              }
            }
            for (name in oldOn) {
              if (isUndef(on[name])) {
                event = normalizeEvent(name);
                remove(event.name, oldOn[name], event.capture);
              }
            }
          }

          function mergeVNodeHook(def, hookKey, hook) {
            if (def instanceof VNode) {
              def = def.data.hook || (def.data.hook = {});
            }
            var invoker;
            var oldHook = def[hookKey];
            function wrappedHook() {
              hook.apply(this, arguments);
              // important: remove merged hook to ensure it's called only once
              // and prevent memory leak
              remove$2(invoker.fns, wrappedHook);
            }
            if (isUndef(oldHook)) {
              // no existing hook
              invoker = createFnInvoker([wrappedHook]);
            } else {
              /* istanbul ignore if */
              if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
                // already a merged invoker
                invoker = oldHook;
                invoker.fns.push(wrappedHook);
              } else {
                // existing plain hook
                invoker = createFnInvoker([oldHook, wrappedHook]);
              }
            }
            invoker.merged = true;
            def[hookKey] = invoker;
          }

          function extractPropsFromVNodeData(data, Ctor, tag) {
            // we are only extracting raw values here.
            // validation and default values are handled in the child
            // component itself.
            var propOptions = Ctor.options.props;
            if (isUndef(propOptions)) {
              return;
            }
            var res = {};
            var attrs = data.attrs,
              props = data.props;
            if (isDef(attrs) || isDef(props)) {
              for (var key in propOptions) {
                var altKey = hyphenate(key);
                {
                  var keyInLowerCase = key.toLowerCase();
                  if (
                    key !== keyInLowerCase &&
                    attrs &&
                    hasOwn(attrs, keyInLowerCase)
                  ) {
                    tip(
                      'Prop "'.concat(
                        keyInLowerCase,
                        '" is passed to component '
                      ) +
                        "".concat(
                          formatComponentName(
                            // @ts-expect-error tag is string
                            tag || Ctor
                          ),
                          ", but the declared prop name is"
                        ) +
                        ' "'.concat(key, '". ') +
                        "Note that HTML attributes are case-insensitive and camelCased " +
                        "props need to use their kebab-case equivalents when using in-DOM " +
                        'templates. You should probably use "'
                          .concat(altKey, '" instead of "')
                          .concat(key, '".')
                    );
                  }
                }
                checkProp(res, props, key, altKey, true) ||
                  checkProp(res, attrs, key, altKey, false);
              }
            }
            return res;
          }
          function checkProp(res, hash, key, altKey, preserve) {
            if (isDef(hash)) {
              if (hasOwn(hash, key)) {
                res[key] = hash[key];
                if (!preserve) {
                  delete hash[key];
                }
                return true;
              } else if (hasOwn(hash, altKey)) {
                res[key] = hash[altKey];
                if (!preserve) {
                  delete hash[altKey];
                }
                return true;
              }
            }
            return false;
          }

          // The template compiler attempts to minimize the need for normalization by
          // statically analyzing the template at compile time.
          //
          // For plain HTML markup, normalization can be completely skipped because the
          // generated render function is guaranteed to return Array<VNode>. There are
          // two cases where extra normalization is needed:
          // 1. When the children contains components - because a functional component
          // may return an Array instead of a single root. In this case, just a simple
          // normalization is needed - if any child is an Array, we flatten the whole
          // thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
          // because functional components already normalize their own children.
          function simpleNormalizeChildren(children) {
            for (var i = 0; i < children.length; i++) {
              if (isArray(children[i])) {
                return Array.prototype.concat.apply([], children);
              }
            }
            return children;
          }
          // 2. When the children contains constructs that always generated nested Arrays,
          // e.g. <template>, <slot>, v-for, or when the children is provided by user
          // with hand-written render functions / JSX. In such cases a full normalization
          // is needed to cater to all possible types of children values.
          function normalizeChildren(children) {
            return isPrimitive(children)
              ? [createTextVNode(children)]
              : isArray(children)
              ? normalizeArrayChildren(children)
              : undefined;
          }
          function isTextNode(node) {
            return isDef(node) && isDef(node.text) && isFalse(node.isComment);
          }
          function normalizeArrayChildren(children, nestedIndex) {
            var res = [];
            var i, c, lastIndex, last;
            for (i = 0; i < children.length; i++) {
              c = children[i];
              if (isUndef(c) || typeof c === "boolean") continue;
              lastIndex = res.length - 1;
              last = res[lastIndex];
              //  nested
              if (isArray(c)) {
                if (c.length > 0) {
                  c = normalizeArrayChildren(
                    c,
                    "".concat(nestedIndex || "", "_").concat(i)
                  );
                  // merge adjacent text nodes
                  if (isTextNode(c[0]) && isTextNode(last)) {
                    res[lastIndex] = createTextVNode(last.text + c[0].text);
                    c.shift();
                  }
                  res.push.apply(res, c);
                }
              } else if (isPrimitive(c)) {
                if (isTextNode(last)) {
                  // merge adjacent text nodes
                  // this is necessary for SSR hydration because text nodes are
                  // essentially merged when rendered to HTML strings
                  res[lastIndex] = createTextVNode(last.text + c);
                } else if (c !== "") {
                  // convert primitive to vnode
                  res.push(createTextVNode(c));
                }
              } else {
                if (isTextNode(c) && isTextNode(last)) {
                  // merge adjacent text nodes
                  res[lastIndex] = createTextVNode(last.text + c.text);
                } else {
                  // default key for nested array children (likely generated by v-for)
                  if (
                    isTrue(children._isVList) &&
                    isDef(c.tag) &&
                    isUndef(c.key) &&
                    isDef(nestedIndex)
                  ) {
                    c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
                  }
                  res.push(c);
                }
              }
            }
            return res;
          }

          var SIMPLE_NORMALIZE = 1;
          var ALWAYS_NORMALIZE = 2;
          // wrapper function for providing a more flexible interface
          // without getting yelled at by flow
          function createElement$1(
            context,
            tag,
            data,
            children,
            normalizationType,
            alwaysNormalize
          ) {
            if (isArray(data) || isPrimitive(data)) {
              normalizationType = children;
              children = data;
              data = undefined;
            }
            if (isTrue(alwaysNormalize)) {
              normalizationType = ALWAYS_NORMALIZE;
            }
            return _createElement(
              context,
              tag,
              data,
              children,
              normalizationType
            );
          }
          function _createElement(
            context,
            tag,
            data,
            children,
            normalizationType
          ) {
            if (isDef(data) && isDef(data.__ob__)) {
              warn$2(
                "Avoid using observed data object as vnode data: ".concat(
                  JSON.stringify(data),
                  "\n"
                ) + "Always create fresh vnode data objects in each render!",
                context
              );
              return createEmptyVNode();
            }
            // object syntax in v-bind
            if (isDef(data) && isDef(data.is)) {
              tag = data.is;
            }
            if (!tag) {
              // in case of component :is set to falsy value
              return createEmptyVNode();
            }
            // warn against non-primitive key
            if (isDef(data) && isDef(data.key) && !isPrimitive(data.key)) {
              warn$2(
                "Avoid using non-primitive value as key, " +
                  "use string/number value instead.",
                context
              );
            }
            // support single function children as default scoped slot
            if (isArray(children) && isFunction(children[0])) {
              data = data || {};
              data.scopedSlots = { default: children[0] };
              children.length = 0;
            }
            if (normalizationType === ALWAYS_NORMALIZE) {
              children = normalizeChildren(children);
            } else if (normalizationType === SIMPLE_NORMALIZE) {
              children = simpleNormalizeChildren(children);
            }
            var vnode, ns;
            if (typeof tag === "string") {
              var Ctor = void 0;
              ns =
                (context.$vnode && context.$vnode.ns) ||
                config.getTagNamespace(tag);
              if (config.isReservedTag(tag)) {
                // platform built-in elements
                if (
                  isDef(data) &&
                  isDef(data.nativeOn) &&
                  data.tag !== "component"
                ) {
                  warn$2(
                    "The .native modifier for v-on is only valid on components but it was used on <".concat(
                      tag,
                      ">."
                    ),
                    context
                  );
                }
                vnode = new VNode(
                  config.parsePlatformTagName(tag),
                  data,
                  children,
                  undefined,
                  undefined,
                  context
                );
              } else if (
                (!data || !data.pre) &&
                isDef(
                  (Ctor = resolveAsset(context.$options, "components", tag))
                )
              ) {
                // component
                vnode = createComponent(Ctor, data, context, children, tag);
              } else {
                // unknown or unlisted namespaced elements
                // check at runtime because it may get assigned a namespace when its
                // parent normalizes children
                vnode = new VNode(
                  tag,
                  data,
                  children,
                  undefined,
                  undefined,
                  context
                );
              }
            } else {
              // direct component options / constructor
              vnode = createComponent(tag, data, context, children);
            }
            if (isArray(vnode)) {
              return vnode;
            } else if (isDef(vnode)) {
              if (isDef(ns)) applyNS(vnode, ns);
              if (isDef(data)) registerDeepBindings(data);
              return vnode;
            } else {
              return createEmptyVNode();
            }
          }
          function applyNS(vnode, ns, force) {
            vnode.ns = ns;
            if (vnode.tag === "foreignObject") {
              // use default namespace inside foreignObject
              ns = undefined;
              force = true;
            }
            if (isDef(vnode.children)) {
              for (var i = 0, l = vnode.children.length; i < l; i++) {
                var child = vnode.children[i];
                if (
                  isDef(child.tag) &&
                  (isUndef(child.ns) || (isTrue(force) && child.tag !== "svg"))
                ) {
                  applyNS(child, ns, force);
                }
              }
            }
          }
          // ref #5318
          // necessary to ensure parent re-render when deep bindings like :style and
          // :class are used on slot nodes
          function registerDeepBindings(data) {
            if (isObject(data.style)) {
              traverse(data.style);
            }
            if (isObject(data.class)) {
              traverse(data.class);
            }
          }

          /**
           * Runtime helper for rendering v-for lists.
           */
          function renderList(val, render) {
            var ret = null,
              i,
              l,
              keys,
              key;
            if (isArray(val) || typeof val === "string") {
              ret = new Array(val.length);
              for (i = 0, l = val.length; i < l; i++) {
                ret[i] = render(val[i], i);
              }
            } else if (typeof val === "number") {
              ret = new Array(val);
              for (i = 0; i < val; i++) {
                ret[i] = render(i + 1, i);
              }
            } else if (isObject(val)) {
              if (hasSymbol && val[Symbol.iterator]) {
                ret = [];
                var iterator = val[Symbol.iterator]();
                var result = iterator.next();
                while (!result.done) {
                  ret.push(render(result.value, ret.length));
                  result = iterator.next();
                }
              } else {
                keys = Object.keys(val);
                ret = new Array(keys.length);
                for (i = 0, l = keys.length; i < l; i++) {
                  key = keys[i];
                  ret[i] = render(val[key], key, i);
                }
              }
            }
            if (!isDef(ret)) {
              ret = [];
            }
            ret._isVList = true;
            return ret;
          }

          /**
           * Runtime helper for rendering <slot>
           */
          function renderSlot(name, fallbackRender, props, bindObject) {
            var scopedSlotFn = this.$scopedSlots[name];
            var nodes;
            if (scopedSlotFn) {
              // scoped slot
              props = props || {};
              if (bindObject) {
                if (!isObject(bindObject)) {
                  warn$2(
                    "slot v-bind without argument expects an Object",
                    this
                  );
                }
                props = extend(extend({}, bindObject), props);
              }
              nodes =
                scopedSlotFn(props) ||
                (isFunction(fallbackRender)
                  ? fallbackRender()
                  : fallbackRender);
            } else {
              nodes =
                this.$slots[name] ||
                (isFunction(fallbackRender)
                  ? fallbackRender()
                  : fallbackRender);
            }
            var target = props && props.slot;
            if (target) {
              return this.$createElement("template", { slot: target }, nodes);
            } else {
              return nodes;
            }
          }

          /**
           * Runtime helper for resolving filters
           */
          function resolveFilter(id) {
            return resolveAsset(this.$options, "filters", id, true) || identity;
          }

          function isKeyNotMatch(expect, actual) {
            if (isArray(expect)) {
              return expect.indexOf(actual) === -1;
            } else {
              return expect !== actual;
            }
          }
          /**
           * Runtime helper for checking keyCodes from config.
           * exposed as Vue.prototype._k
           * passing in eventKeyName as last argument separately for backwards compat
           */
          function checkKeyCodes(
            eventKeyCode,
            key,
            builtInKeyCode,
            eventKeyName,
            builtInKeyName
          ) {
            var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
            if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
              return isKeyNotMatch(builtInKeyName, eventKeyName);
            } else if (mappedKeyCode) {
              return isKeyNotMatch(mappedKeyCode, eventKeyCode);
            } else if (eventKeyName) {
              return hyphenate(eventKeyName) !== key;
            }
            return eventKeyCode === undefined;
          }

          /**
           * Runtime helper for merging v-bind="object" into a VNode's data.
           */
          function bindObjectProps(data, tag, value, asProp, isSync) {
            if (value) {
              if (!isObject(value)) {
                warn$2(
                  "v-bind without argument expects an Object or Array value",
                  this
                );
              } else {
                if (isArray(value)) {
                  value = toObject(value);
                }
                var hash = void 0;
                var _loop_1 = function (key) {
                  if (
                    key === "class" ||
                    key === "style" ||
                    isReservedAttribute(key)
                  ) {
                    hash = data;
                  } else {
                    var type = data.attrs && data.attrs.type;
                    hash =
                      asProp || config.mustUseProp(tag, type, key)
                        ? data.domProps || (data.domProps = {})
                        : data.attrs || (data.attrs = {});
                  }
                  var camelizedKey = camelize(key);
                  var hyphenatedKey = hyphenate(key);
                  if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                      var on = data.on || (data.on = {});
                      on["update:".concat(key)] = function ($event) {
                        value[key] = $event;
                      };
                    }
                  }
                };
                for (var key in value) {
                  _loop_1(key);
                }
              }
            }
            return data;
          }

          /**
           * Runtime helper for rendering static trees.
           */
          function renderStatic(index, isInFor) {
            var cached = this._staticTrees || (this._staticTrees = []);
            var tree = cached[index];
            // if has already-rendered static tree and not inside v-for,
            // we can reuse the same tree.
            if (tree && !isInFor) {
              return tree;
            }
            // otherwise, render a fresh tree.
            tree = cached[index] = this.$options.staticRenderFns[index].call(
              this._renderProxy,
              this._c,
              this // for render fns generated for functional component templates
            );
            markStatic$1(tree, "__static__".concat(index), false);
            return tree;
          }
          /**
           * Runtime helper for v-once.
           * Effectively it means marking the node as static with a unique key.
           */
          function markOnce(tree, index, key) {
            markStatic$1(
              tree,
              "__once__".concat(index).concat(key ? "_".concat(key) : ""),
              true
            );
            return tree;
          }
          function markStatic$1(tree, key, isOnce) {
            if (isArray(tree)) {
              for (var i = 0; i < tree.length; i++) {
                if (tree[i] && typeof tree[i] !== "string") {
                  markStaticNode(
                    tree[i],
                    "".concat(key, "_").concat(i),
                    isOnce
                  );
                }
              }
            } else {
              markStaticNode(tree, key, isOnce);
            }
          }
          function markStaticNode(node, key, isOnce) {
            node.isStatic = true;
            node.key = key;
            node.isOnce = isOnce;
          }

          function bindObjectListeners(data, value) {
            if (value) {
              if (!isPlainObject(value)) {
                warn$2("v-on without argument expects an Object value", this);
              } else {
                var on = (data.on = data.on ? extend({}, data.on) : {});
                for (var key in value) {
                  var existing = on[key];
                  var ours = value[key];
                  on[key] = existing ? [].concat(existing, ours) : ours;
                }
              }
            }
            return data;
          }

          function resolveScopedSlots(
            fns,
            res,
            // the following are added in 2.6
            hasDynamicKeys,
            contentHashKey
          ) {
            res = res || { $stable: !hasDynamicKeys };
            for (var i = 0; i < fns.length; i++) {
              var slot = fns[i];
              if (isArray(slot)) {
                resolveScopedSlots(slot, res, hasDynamicKeys);
              } else if (slot) {
                // marker for reverse proxying v-slot without scope on this.$slots
                // @ts-expect-error
                if (slot.proxy) {
                  // @ts-expect-error
                  slot.fn.proxy = true;
                }
                res[slot.key] = slot.fn;
              }
            }
            if (contentHashKey) {
              res.$key = contentHashKey;
            }
            return res;
          }

          // helper to process dynamic keys for dynamic arguments in v-bind and v-on.
          function bindDynamicKeys(baseObj, values) {
            for (var i = 0; i < values.length; i += 2) {
              var key = values[i];
              if (typeof key === "string" && key) {
                baseObj[values[i]] = values[i + 1];
              } else if (key !== "" && key !== null) {
                // null is a special value for explicitly removing a binding
                warn$2(
                  "Invalid value for dynamic directive argument (expected string or null): ".concat(
                    key
                  ),
                  this
                );
              }
            }
            return baseObj;
          }
          // helper to dynamically append modifier runtime markers to event names.
          // ensure only append when value is already string, otherwise it will be cast
          // to string and cause the type check to miss.
          function prependModifier(value, symbol) {
            return typeof value === "string" ? symbol + value : value;
          }

          function installRenderHelpers(target) {
            target._o = markOnce;
            target._n = toNumber;
            target._s = toString;
            target._l = renderList;
            target._t = renderSlot;
            target._q = looseEqual;
            target._i = looseIndexOf;
            target._m = renderStatic;
            target._f = resolveFilter;
            target._k = checkKeyCodes;
            target._b = bindObjectProps;
            target._v = createTextVNode;
            target._e = createEmptyVNode;
            target._u = resolveScopedSlots;
            target._g = bindObjectListeners;
            target._d = bindDynamicKeys;
            target._p = prependModifier;
          }

          /**
           * Runtime helper for resolving raw children VNodes into a slot object.
           */
          function resolveSlots(children, context) {
            if (!children || !children.length) {
              return {};
            }
            var slots = {};
            for (var i = 0, l = children.length; i < l; i++) {
              var child = children[i];
              var data = child.data;
              // remove slot attribute if the node is resolved as a Vue slot node
              if (data && data.attrs && data.attrs.slot) {
                delete data.attrs.slot;
              }
              // named slots should only be respected if the vnode was rendered in the
              // same context.
              if (
                (child.context === context || child.fnContext === context) &&
                data &&
                data.slot != null
              ) {
                var name_1 = data.slot;
                var slot = slots[name_1] || (slots[name_1] = []);
                if (child.tag === "template") {
                  slot.push.apply(slot, child.children || []);
                } else {
                  slot.push(child);
                }
              } else {
                (slots.default || (slots.default = [])).push(child);
              }
            }
            // ignore slots that contains only whitespace
            for (var name_2 in slots) {
              if (slots[name_2].every(isWhitespace)) {
                delete slots[name_2];
              }
            }
            return slots;
          }
          function isWhitespace(node) {
            return (node.isComment && !node.asyncFactory) || node.text === " ";
          }

          function isAsyncPlaceholder(node) {
            // @ts-expect-error not really boolean type
            return node.isComment && node.asyncFactory;
          }

          function normalizeScopedSlots(
            ownerVm,
            scopedSlots,
            normalSlots,
            prevScopedSlots
          ) {
            var res;
            var hasNormalSlots = Object.keys(normalSlots).length > 0;
            var isStable = scopedSlots
              ? !!scopedSlots.$stable
              : !hasNormalSlots;
            var key = scopedSlots && scopedSlots.$key;
            if (!scopedSlots) {
              res = {};
            } else if (scopedSlots._normalized) {
              // fast path 1: child component re-render only, parent did not change
              return scopedSlots._normalized;
            } else if (
              isStable &&
              prevScopedSlots &&
              prevScopedSlots !== emptyObject &&
              key === prevScopedSlots.$key &&
              !hasNormalSlots &&
              !prevScopedSlots.$hasNormal
            ) {
              // fast path 2: stable scoped slots w/ no normal slots to proxy,
              // only need to normalize once
              return prevScopedSlots;
            } else {
              res = {};
              for (var key_1 in scopedSlots) {
                if (scopedSlots[key_1] && key_1[0] !== "$") {
                  res[key_1] = normalizeScopedSlot(
                    ownerVm,
                    normalSlots,
                    key_1,
                    scopedSlots[key_1]
                  );
                }
              }
            }
            // expose normal slots on scopedSlots
            for (var key_2 in normalSlots) {
              if (!(key_2 in res)) {
                res[key_2] = proxyNormalSlot(normalSlots, key_2);
              }
            }
            // avoriaz seems to mock a non-extensible $scopedSlots object
            // and when that is passed down this would cause an error
            if (scopedSlots && Object.isExtensible(scopedSlots)) {
              scopedSlots._normalized = res;
            }
            def(res, "$stable", isStable);
            def(res, "$key", key);
            def(res, "$hasNormal", hasNormalSlots);
            return res;
          }
          function normalizeScopedSlot(vm, normalSlots, key, fn) {
            var normalized = function () {
              var cur = currentInstance;
              setCurrentInstance(vm);
              var res = arguments.length ? fn.apply(null, arguments) : fn({});
              res =
                res && typeof res === "object" && !isArray(res)
                  ? [res] // single vnode
                  : normalizeChildren(res);
              var vnode = res && res[0];
              setCurrentInstance(cur);
              return res &&
                (!vnode ||
                  (res.length === 1 &&
                    vnode.isComment &&
                    !isAsyncPlaceholder(vnode))) // #9658, #10391
                ? undefined
                : res;
            };
            // this is a slot using the new v-slot syntax without scope. although it is
            // compiled as a scoped slot, render fn users would expect it to be present
            // on this.$slots because the usage is semantically a normal slot.
            if (fn.proxy) {
              Object.defineProperty(normalSlots, key, {
                get: normalized,
                enumerable: true,
                configurable: true,
              });
            }
            return normalized;
          }
          function proxyNormalSlot(slots, key) {
            return function () {
              return slots[key];
            };
          }

          function initSetup(vm) {
            var options = vm.$options;
            var setup = options.setup;
            if (setup) {
              var ctx = (vm._setupContext = createSetupContext(vm));
              setCurrentInstance(vm);
              pushTarget();
              var setupResult = invokeWithErrorHandling(
                setup,
                null,
                [vm._props || shallowReactive({}), ctx],
                vm,
                "setup"
              );
              popTarget();
              setCurrentInstance();
              if (isFunction(setupResult)) {
                // render function
                // @ts-ignore
                options.render = setupResult;
              } else if (isObject(setupResult)) {
                // bindings
                if (setupResult instanceof VNode) {
                  warn$2(
                    "setup() should not return VNodes directly - " +
                      "return a render function instead."
                  );
                }
                vm._setupState = setupResult;
                // __sfc indicates compiled bindings from <script setup>
                if (!setupResult.__sfc) {
                  for (var key in setupResult) {
                    if (!isReserved(key)) {
                      proxyWithRefUnwrap(vm, setupResult, key);
                    } else {
                      warn$2(
                        "Avoid using variables that start with _ or $ in setup()."
                      );
                    }
                  }
                } else {
                  // exposed for compiled render fn
                  var proxy = (vm._setupProxy = {});
                  for (var key in setupResult) {
                    if (key !== "__sfc") {
                      proxyWithRefUnwrap(proxy, setupResult, key);
                    }
                  }
                }
              } else if (setupResult !== undefined) {
                warn$2(
                  "setup() should return an object. Received: ".concat(
                    setupResult === null ? "null" : typeof setupResult
                  )
                );
              }
            }
          }
          function createSetupContext(vm) {
            var exposeCalled = false;
            return {
              get attrs() {
                if (!vm._attrsProxy) {
                  var proxy = (vm._attrsProxy = {});
                  def(proxy, "_v_attr_proxy", true);
                  syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, "$attrs");
                }
                return vm._attrsProxy;
              },
              get listeners() {
                if (!vm._listenersProxy) {
                  var proxy = (vm._listenersProxy = {});
                  syncSetupProxy(
                    proxy,
                    vm.$listeners,
                    emptyObject,
                    vm,
                    "$listeners"
                  );
                }
                return vm._listenersProxy;
              },
              get slots() {
                return initSlotsProxy(vm);
              },
              emit: bind$1(vm.$emit, vm),
              expose: function (exposed) {
                {
                  if (exposeCalled) {
                    warn$2(
                      "expose() should be called only once per setup().",
                      vm
                    );
                  }
                  exposeCalled = true;
                }
                if (exposed) {
                  Object.keys(exposed).forEach(function (key) {
                    return proxyWithRefUnwrap(vm, exposed, key);
                  });
                }
              },
            };
          }
          function syncSetupProxy(to, from, prev, instance, type) {
            var changed = false;
            for (var key in from) {
              if (!(key in to)) {
                changed = true;
                defineProxyAttr(to, key, instance, type);
              } else if (from[key] !== prev[key]) {
                changed = true;
              }
            }
            for (var key in to) {
              if (!(key in from)) {
                changed = true;
                delete to[key];
              }
            }
            return changed;
          }
          function defineProxyAttr(proxy, key, instance, type) {
            Object.defineProperty(proxy, key, {
              enumerable: true,
              configurable: true,
              get: function () {
                return instance[type][key];
              },
            });
          }
          function initSlotsProxy(vm) {
            if (!vm._slotsProxy) {
              syncSetupSlots((vm._slotsProxy = {}), vm.$scopedSlots);
            }
            return vm._slotsProxy;
          }
          function syncSetupSlots(to, from) {
            for (var key in from) {
              to[key] = from[key];
            }
            for (var key in to) {
              if (!(key in from)) {
                delete to[key];
              }
            }
          }
          /**
           * @internal use manual type def because public setup context type relies on
           * legacy VNode types
           */
          function useSlots() {
            return getContext().slots;
          }
          /**
           * @internal use manual type def because public setup context type relies on
           * legacy VNode types
           */
          function useAttrs() {
            return getContext().attrs;
          }
          /**
           * Vue 2 only
           * @internal use manual type def because public setup context type relies on
           * legacy VNode types
           */
          function useListeners() {
            return getContext().listeners;
          }
          function getContext() {
            if (!currentInstance) {
              warn$2("useContext() called without active instance.");
            }
            var vm = currentInstance;
            return (
              vm._setupContext || (vm._setupContext = createSetupContext(vm))
            );
          }
          /**
           * Runtime helper for merging default declarations. Imported by compiled code
           * only.
           * @internal
           */
          function mergeDefaults(raw, defaults) {
            var props = isArray(raw)
              ? raw.reduce(function (normalized, p) {
                  return (normalized[p] = {}), normalized;
                }, {})
              : raw;
            for (var key in defaults) {
              var opt = props[key];
              if (opt) {
                if (isArray(opt) || isFunction(opt)) {
                  props[key] = { type: opt, default: defaults[key] };
                } else {
                  opt.default = defaults[key];
                }
              } else if (opt === null) {
                props[key] = { default: defaults[key] };
              } else {
                warn$2(
                  'props default key "'.concat(
                    key,
                    '" has no corresponding declaration.'
                  )
                );
              }
            }
            return props;
          }

          function initRender(vm) {
            vm._vnode = null; // the root of the child tree
            vm._staticTrees = null; // v-once cached trees
            var options = vm.$options;
            var parentVnode = (vm.$vnode = options._parentVnode); // the placeholder node in parent tree
            var renderContext = parentVnode && parentVnode.context;
            vm.$slots = resolveSlots(options._renderChildren, renderContext);
            vm.$scopedSlots = parentVnode
              ? normalizeScopedSlots(
                  vm.$parent,
                  parentVnode.data.scopedSlots,
                  vm.$slots
                )
              : emptyObject;
            // bind the createElement fn to this instance
            // so that we get proper render context inside it.
            // args order: tag, data, children, normalizationType, alwaysNormalize
            // internal version is used by render functions compiled from templates
            // @ts-expect-error
            vm._c = function (a, b, c, d) {
              return createElement$1(vm, a, b, c, d, false);
            };
            // normalization is always applied for the public version, used in
            // user-written render functions.
            // @ts-expect-error
            vm.$createElement = function (a, b, c, d) {
              return createElement$1(vm, a, b, c, d, true);
            };
            // $attrs & $listeners are exposed for easier HOC creation.
            // they need to be reactive so that HOCs using them are always updated
            var parentData = parentVnode && parentVnode.data;
            /* istanbul ignore else */
            {
              defineReactive(
                vm,
                "$attrs",
                (parentData && parentData.attrs) || emptyObject,
                function () {
                  !isUpdatingChildComponent &&
                    warn$2("$attrs is readonly.", vm);
                },
                true
              );
              defineReactive(
                vm,
                "$listeners",
                options._parentListeners || emptyObject,
                function () {
                  !isUpdatingChildComponent &&
                    warn$2("$listeners is readonly.", vm);
                },
                true
              );
            }
          }
          var currentRenderingInstance = null;
          function renderMixin(Vue) {
            // install runtime convenience helpers
            installRenderHelpers(Vue.prototype);
            Vue.prototype.$nextTick = function (fn) {
              return nextTick(fn, this);
            };
            Vue.prototype._render = function () {
              var vm = this;
              var _a = vm.$options,
                render = _a.render,
                _parentVnode = _a._parentVnode;
              if (_parentVnode && vm._isMounted) {
                vm.$scopedSlots = normalizeScopedSlots(
                  vm.$parent,
                  _parentVnode.data.scopedSlots,
                  vm.$slots,
                  vm.$scopedSlots
                );
                if (vm._slotsProxy) {
                  syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
                }
              }
              // set parent vnode. this allows render functions to have access
              // to the data on the placeholder node.
              vm.$vnode = _parentVnode;
              // render self
              var vnode;
              try {
                // There's no need to maintain a stack because all render fns are called
                // separately from one another. Nested component's render fns are called
                // when parent component is patched.
                setCurrentInstance(vm);
                currentRenderingInstance = vm;
                vnode = render.call(vm._renderProxy, vm.$createElement);
              } catch (e) {
                handleError(e, vm, "render");
                // return error render result,
                // or previous vnode to prevent render error causing blank component
                /* istanbul ignore else */
                if (vm.$options.renderError) {
                  try {
                    vnode = vm.$options.renderError.call(
                      vm._renderProxy,
                      vm.$createElement,
                      e
                    );
                  } catch (e) {
                    handleError(e, vm, "renderError");
                    vnode = vm._vnode;
                  }
                } else {
                  vnode = vm._vnode;
                }
              } finally {
                currentRenderingInstance = null;
                setCurrentInstance();
              }
              // if the returned array contains only a single node, allow it
              if (isArray(vnode) && vnode.length === 1) {
                vnode = vnode[0];
              }
              // return empty vnode in case the render function errored out
              if (!(vnode instanceof VNode)) {
                if (isArray(vnode)) {
                  warn$2(
                    "Multiple root nodes returned from render function. Render function " +
                      "should return a single root node.",
                    vm
                  );
                }
                vnode = createEmptyVNode();
              }
              // set parent
              vnode.parent = _parentVnode;
              return vnode;
            };
          }

          function ensureCtor(comp, base) {
            if (
              comp.__esModule ||
              (hasSymbol && comp[Symbol.toStringTag] === "Module")
            ) {
              comp = comp.default;
            }
            return isObject(comp) ? base.extend(comp) : comp;
          }
          function createAsyncPlaceholder(
            factory,
            data,
            context,
            children,
            tag
          ) {
            var node = createEmptyVNode();
            node.asyncFactory = factory;
            node.asyncMeta = {
              data: data,
              context: context,
              children: children,
              tag: tag,
            };
            return node;
          }
          function resolveAsyncComponent(factory, baseCtor) {
            if (isTrue(factory.error) && isDef(factory.errorComp)) {
              return factory.errorComp;
            }
            if (isDef(factory.resolved)) {
              return factory.resolved;
            }
            var owner = currentRenderingInstance;
            if (
              owner &&
              isDef(factory.owners) &&
              factory.owners.indexOf(owner) === -1
            ) {
              // already pending
              factory.owners.push(owner);
            }
            if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
              return factory.loadingComp;
            }
            if (owner && !isDef(factory.owners)) {
              var owners_1 = (factory.owners = [owner]);
              var sync_1 = true;
              var timerLoading_1 = null;
              var timerTimeout_1 = null;
              owner.$on("hook:destroyed", function () {
                return remove$2(owners_1, owner);
              });
              var forceRender_1 = function (renderCompleted) {
                for (var i = 0, l = owners_1.length; i < l; i++) {
                  owners_1[i].$forceUpdate();
                }
                if (renderCompleted) {
                  owners_1.length = 0;
                  if (timerLoading_1 !== null) {
                    clearTimeout(timerLoading_1);
                    timerLoading_1 = null;
                  }
                  if (timerTimeout_1 !== null) {
                    clearTimeout(timerTimeout_1);
                    timerTimeout_1 = null;
                  }
                }
              };
              var resolve = once(function (res) {
                // cache resolved
                factory.resolved = ensureCtor(res, baseCtor);
                // invoke callbacks only if this is not a synchronous resolve
                // (async resolves are shimmed as synchronous during SSR)
                if (!sync_1) {
                  forceRender_1(true);
                } else {
                  owners_1.length = 0;
                }
              });
              var reject_1 = once(function (reason) {
                warn$2(
                  "Failed to resolve async component: ".concat(
                    String(factory)
                  ) + (reason ? "\nReason: ".concat(reason) : "")
                );
                if (isDef(factory.errorComp)) {
                  factory.error = true;
                  forceRender_1(true);
                }
              });
              var res_1 = factory(resolve, reject_1);
              if (isObject(res_1)) {
                if (isPromise(res_1)) {
                  // () => Promise
                  if (isUndef(factory.resolved)) {
                    res_1.then(resolve, reject_1);
                  }
                } else if (isPromise(res_1.component)) {
                  res_1.component.then(resolve, reject_1);
                  if (isDef(res_1.error)) {
                    factory.errorComp = ensureCtor(res_1.error, baseCtor);
                  }
                  if (isDef(res_1.loading)) {
                    factory.loadingComp = ensureCtor(res_1.loading, baseCtor);
                    if (res_1.delay === 0) {
                      factory.loading = true;
                    } else {
                      // @ts-expect-error NodeJS timeout type
                      timerLoading_1 = setTimeout(function () {
                        timerLoading_1 = null;
                        if (
                          isUndef(factory.resolved) &&
                          isUndef(factory.error)
                        ) {
                          factory.loading = true;
                          forceRender_1(false);
                        }
                      }, res_1.delay || 200);
                    }
                  }
                  if (isDef(res_1.timeout)) {
                    // @ts-expect-error NodeJS timeout type
                    timerTimeout_1 = setTimeout(function () {
                      timerTimeout_1 = null;
                      if (isUndef(factory.resolved)) {
                        reject_1("timeout (".concat(res_1.timeout, "ms)"));
                      }
                    }, res_1.timeout);
                  }
                }
              }
              sync_1 = false;
              // return in case resolved synchronously
              return factory.loading ? factory.loadingComp : factory.resolved;
            }
          }

          function getFirstComponentChild(children) {
            if (isArray(children)) {
              for (var i = 0; i < children.length; i++) {
                var c = children[i];
                if (
                  isDef(c) &&
                  (isDef(c.componentOptions) || isAsyncPlaceholder(c))
                ) {
                  return c;
                }
              }
            }
          }

          function initEvents(vm) {
            vm._events = Object.create(null);
            vm._hasHookEvent = false;
            // init parent attached events
            var listeners = vm.$options._parentListeners;
            if (listeners) {
              updateComponentListeners(vm, listeners);
            }
          }
          var target$1;
          function add$1(event, fn) {
            target$1.$on(event, fn);
          }
          function remove$1(event, fn) {
            target$1.$off(event, fn);
          }
          function createOnceHandler$1(event, fn) {
            var _target = target$1;
            return function onceHandler() {
              var res = fn.apply(null, arguments);
              if (res !== null) {
                _target.$off(event, onceHandler);
              }
            };
          }
          function updateComponentListeners(vm, listeners, oldListeners) {
            target$1 = vm;
            updateListeners(
              listeners,
              oldListeners || {},
              add$1,
              remove$1,
              createOnceHandler$1,
              vm
            );
            target$1 = undefined;
          }
          function eventsMixin(Vue) {
            var hookRE = /^hook:/;
            Vue.prototype.$on = function (event, fn) {
              var vm = this;
              if (isArray(event)) {
                for (var i = 0, l = event.length; i < l; i++) {
                  vm.$on(event[i], fn);
                }
              } else {
                (vm._events[event] || (vm._events[event] = [])).push(fn);
                // optimize hook:event cost by using a boolean flag marked at registration
                // instead of a hash lookup
                if (hookRE.test(event)) {
                  vm._hasHookEvent = true;
                }
              }
              return vm;
            };
            Vue.prototype.$once = function (event, fn) {
              var vm = this;
              function on() {
                vm.$off(event, on);
                fn.apply(vm, arguments);
              }
              on.fn = fn;
              vm.$on(event, on);
              return vm;
            };
            Vue.prototype.$off = function (event, fn) {
              var vm = this;
              // all
              if (!arguments.length) {
                vm._events = Object.create(null);
                return vm;
              }
              // array of events
              if (isArray(event)) {
                for (var i_1 = 0, l = event.length; i_1 < l; i_1++) {
                  vm.$off(event[i_1], fn);
                }
                return vm;
              }
              // specific event
              var cbs = vm._events[event];
              if (!cbs) {
                return vm;
              }
              if (!fn) {
                vm._events[event] = null;
                return vm;
              }
              // specific handler
              var cb;
              var i = cbs.length;
              while (i--) {
                cb = cbs[i];
                if (cb === fn || cb.fn === fn) {
                  cbs.splice(i, 1);
                  break;
                }
              }
              return vm;
            };
            Vue.prototype.$emit = function (event) {
              var vm = this;
              {
                var lowerCaseEvent = event.toLowerCase();
                if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
                  tip(
                    'Event "'.concat(
                      lowerCaseEvent,
                      '" is emitted in component '
                    ) +
                      ""
                        .concat(
                          formatComponentName(vm),
                          ' but the handler is registered for "'
                        )
                        .concat(event, '". ') +
                      "Note that HTML attributes are case-insensitive and you cannot use " +
                      "v-on to listen to camelCase events when using in-DOM templates. " +
                      'You should probably use "'
                        .concat(hyphenate(event), '" instead of "')
                        .concat(event, '".')
                  );
                }
              }
              var cbs = vm._events[event];
              if (cbs) {
                cbs = cbs.length > 1 ? toArray(cbs) : cbs;
                var args = toArray(arguments, 1);
                var info = 'event handler for "'.concat(event, '"');
                for (var i = 0, l = cbs.length; i < l; i++) {
                  invokeWithErrorHandling(cbs[i], vm, args, vm, info);
                }
              }
              return vm;
            };
          }

          var activeInstance = null;
          var isUpdatingChildComponent = false;
          function setActiveInstance(vm) {
            var prevActiveInstance = activeInstance;
            activeInstance = vm;
            return function () {
              activeInstance = prevActiveInstance;
            };
          }
          function initLifecycle(vm) {
            var options = vm.$options;
            // locate first non-abstract parent
            var parent = options.parent;
            if (parent && !options.abstract) {
              while (parent.$options.abstract && parent.$parent) {
                parent = parent.$parent;
              }
              parent.$children.push(vm);
            }
            vm.$parent = parent;
            vm.$root = parent ? parent.$root : vm;
            vm.$children = [];
            vm.$refs = {};
            vm._provided = parent ? parent._provided : Object.create(null);
            vm._watcher = null;
            vm._inactive = null;
            vm._directInactive = false;
            vm._isMounted = false;
            vm._isDestroyed = false;
            vm._isBeingDestroyed = false;
          }
          function lifecycleMixin(Vue) {
            Vue.prototype._update = function (vnode, hydrating) {
              var vm = this;
              var prevEl = vm.$el;
              var prevVnode = vm._vnode;
              var restoreActiveInstance = setActiveInstance(vm);
              vm._vnode = vnode;
              // Vue.prototype.__patch__ is injected in entry points
              // based on the rendering backend used.
              if (!prevVnode) {
                // initial render
                vm.$el = vm.__patch__(
                  vm.$el,
                  vnode,
                  hydrating,
                  false /* removeOnly */
                );
              } else {
                // updates
                vm.$el = vm.__patch__(prevVnode, vnode);
              }
              restoreActiveInstance();
              // update __vue__ reference
              if (prevEl) {
                prevEl.__vue__ = null;
              }
              if (vm.$el) {
                vm.$el.__vue__ = vm;
              }
              // if parent is an HOC, update its $el as well
              var wrapper = vm;
              while (
                wrapper &&
                wrapper.$vnode &&
                wrapper.$parent &&
                wrapper.$vnode === wrapper.$parent._vnode
              ) {
                wrapper.$parent.$el = wrapper.$el;
                wrapper = wrapper.$parent;
              }
              // updated hook is called by the scheduler to ensure that children are
              // updated in a parent's updated hook.
            };
            Vue.prototype.$forceUpdate = function () {
              var vm = this;
              if (vm._watcher) {
                vm._watcher.update();
              }
            };
            Vue.prototype.$destroy = function () {
              var vm = this;
              if (vm._isBeingDestroyed) {
                return;
              }
              callHook$1(vm, "beforeDestroy");
              vm._isBeingDestroyed = true;
              // remove self from parent
              var parent = vm.$parent;
              if (
                parent &&
                !parent._isBeingDestroyed &&
                !vm.$options.abstract
              ) {
                remove$2(parent.$children, vm);
              }
              // teardown scope. this includes both the render watcher and other
              // watchers created
              vm._scope.stop();
              // remove reference from data ob
              // frozen object may not have observer.
              if (vm._data.__ob__) {
                vm._data.__ob__.vmCount--;
              }
              // call the last hook...
              vm._isDestroyed = true;
              // invoke destroy hooks on current rendered tree
              vm.__patch__(vm._vnode, null);
              // fire destroyed hook
              callHook$1(vm, "destroyed");
              // turn off all instance listeners.
              vm.$off();
              // remove __vue__ reference
              if (vm.$el) {
                vm.$el.__vue__ = null;
              }
              // release circular reference (#6759)
              if (vm.$vnode) {
                vm.$vnode.parent = null;
              }
            };
          }
          function mountComponent(vm, el, hydrating) {
            vm.$el = el;
            if (!vm.$options.render) {
              // @ts-expect-error invalid type
              vm.$options.render = createEmptyVNode;
              {
                /* istanbul ignore if */
                if (
                  (vm.$options.template &&
                    vm.$options.template.charAt(0) !== "#") ||
                  vm.$options.el ||
                  el
                ) {
                  warn$2(
                    "You are using the runtime-only build of Vue where the template " +
                      "compiler is not available. Either pre-compile the templates into " +
                      "render functions, or use the compiler-included build.",
                    vm
                  );
                } else {
                  warn$2(
                    "Failed to mount component: template or render function not defined.",
                    vm
                  );
                }
              }
            }
            callHook$1(vm, "beforeMount");
            var updateComponent;
            /* istanbul ignore if */
            if (config.performance && mark) {
              updateComponent = function () {
                var name = vm._name;
                var id = vm._uid;
                var startTag = "vue-perf-start:".concat(id);
                var endTag = "vue-perf-end:".concat(id);
                mark(startTag);
                var vnode = vm._render();
                mark(endTag);
                measure("vue ".concat(name, " render"), startTag, endTag);
                mark(startTag);
                vm._update(vnode, hydrating);
                mark(endTag);
                measure("vue ".concat(name, " patch"), startTag, endTag);
              };
            } else {
              updateComponent = function () {
                vm._update(vm._render(), hydrating);
              };
            }
            var watcherOptions = {
              before: function () {
                if (vm._isMounted && !vm._isDestroyed) {
                  callHook$1(vm, "beforeUpdate");
                }
              },
            };
            {
              watcherOptions.onTrack = function (e) {
                return callHook$1(vm, "renderTracked", [e]);
              };
              watcherOptions.onTrigger = function (e) {
                return callHook$1(vm, "renderTriggered", [e]);
              };
            }
            // we set this to vm._watcher inside the watcher's constructor
            // since the watcher's initial patch may call $forceUpdate (e.g. inside child
            // component's mounted hook), which relies on vm._watcher being already defined
            new Watcher(
              vm,
              updateComponent,
              noop,
              watcherOptions,
              true /* isRenderWatcher */
            );
            hydrating = false;
            // flush buffer for flush: "pre" watchers queued in setup()
            var preWatchers = vm._preWatchers;
            if (preWatchers) {
              for (var i = 0; i < preWatchers.length; i++) {
                preWatchers[i].run();
              }
            }
            // manually mounted instance, call mounted on self
            // mounted is called for render-created child components in its inserted hook
            if (vm.$vnode == null) {
              vm._isMounted = true;
              callHook$1(vm, "mounted");
            }
            return vm;
          }
          function updateChildComponent(
            vm,
            propsData,
            listeners,
            parentVnode,
            renderChildren
          ) {
            {
              isUpdatingChildComponent = true;
            }
            // determine whether component has slot children
            // we need to do this before overwriting $options._renderChildren.
            // check if there are dynamic scopedSlots (hand-written or compiled but with
            // dynamic slot names). Static scoped slots compiled from template has the
            // "$stable" marker.
            var newScopedSlots = parentVnode.data.scopedSlots;
            var oldScopedSlots = vm.$scopedSlots;
            var hasDynamicScopedSlot = !!(
              (newScopedSlots && !newScopedSlots.$stable) ||
              (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
              (newScopedSlots &&
                vm.$scopedSlots.$key !== newScopedSlots.$key) ||
              (!newScopedSlots && vm.$scopedSlots.$key)
            );
            // Any static slot children from the parent may have changed during parent's
            // update. Dynamic scoped slots may also have changed. In such cases, a forced
            // update is necessary to ensure correctness.
            var needsForceUpdate = !!(
              renderChildren || // has new static slots
              vm.$options._renderChildren || // has old static slots
              hasDynamicScopedSlot
            );
            var prevVNode = vm.$vnode;
            vm.$options._parentVnode = parentVnode;
            vm.$vnode = parentVnode; // update vm's placeholder node without re-render
            if (vm._vnode) {
              // update child tree's parent
              vm._vnode.parent = parentVnode;
            }
            vm.$options._renderChildren = renderChildren;
            // update $attrs and $listeners hash
            // these are also reactive so they may trigger child update if the child
            // used them during render
            var attrs = parentVnode.data.attrs || emptyObject;
            if (vm._attrsProxy) {
              // force update if attrs are accessed and has changed since it may be
              // passed to a child component.
              if (
                syncSetupProxy(
                  vm._attrsProxy,
                  attrs,
                  (prevVNode.data && prevVNode.data.attrs) || emptyObject,
                  vm,
                  "$attrs"
                )
              ) {
                needsForceUpdate = true;
              }
            }
            vm.$attrs = attrs;
            // update listeners
            listeners = listeners || emptyObject;
            var prevListeners = vm.$options._parentListeners;
            if (vm._listenersProxy) {
              syncSetupProxy(
                vm._listenersProxy,
                listeners,
                prevListeners || emptyObject,
                vm,
                "$listeners"
              );
            }
            vm.$listeners = vm.$options._parentListeners = listeners;
            updateComponentListeners(vm, listeners, prevListeners);
            // update props
            if (propsData && vm.$options.props) {
              toggleObserving(false);
              var props = vm._props;
              var propKeys = vm.$options._propKeys || [];
              for (var i = 0; i < propKeys.length; i++) {
                var key = propKeys[i];
                var propOptions = vm.$options.props; // wtf flow?
                props[key] = validateProp(key, propOptions, propsData, vm);
              }
              toggleObserving(true);
              // keep a copy of raw propsData
              vm.$options.propsData = propsData;
            }
            // resolve slots + force update if has children
            if (needsForceUpdate) {
              vm.$slots = resolveSlots(renderChildren, parentVnode.context);
              vm.$forceUpdate();
            }
            {
              isUpdatingChildComponent = false;
            }
          }
          function isInInactiveTree(vm) {
            while (vm && (vm = vm.$parent)) {
              if (vm._inactive) return true;
            }
            return false;
          }
          function activateChildComponent(vm, direct) {
            if (direct) {
              vm._directInactive = false;
              if (isInInactiveTree(vm)) {
                return;
              }
            } else if (vm._directInactive) {
              return;
            }
            if (vm._inactive || vm._inactive === null) {
              vm._inactive = false;
              for (var i = 0; i < vm.$children.length; i++) {
                activateChildComponent(vm.$children[i]);
              }
              callHook$1(vm, "activated");
            }
          }
          function deactivateChildComponent(vm, direct) {
            if (direct) {
              vm._directInactive = true;
              if (isInInactiveTree(vm)) {
                return;
              }
            }
            if (!vm._inactive) {
              vm._inactive = true;
              for (var i = 0; i < vm.$children.length; i++) {
                deactivateChildComponent(vm.$children[i]);
              }
              callHook$1(vm, "deactivated");
            }
          }
          function callHook$1(vm, hook, args, setContext) {
            if (setContext === void 0) {
              setContext = true;
            }
            // #7573 disable dep collection when invoking lifecycle hooks
            pushTarget();
            var prev = currentInstance;
            setContext && setCurrentInstance(vm);
            var handlers = vm.$options[hook];
            var info = "".concat(hook, " hook");
            if (handlers) {
              for (var i = 0, j = handlers.length; i < j; i++) {
                invokeWithErrorHandling(
                  handlers[i],
                  vm,
                  args || null,
                  vm,
                  info
                );
              }
            }
            if (vm._hasHookEvent) {
              vm.$emit("hook:" + hook);
            }
            setContext && setCurrentInstance(prev);
            popTarget();
          }

          var MAX_UPDATE_COUNT = 100;
          var queue = [];
          var activatedChildren = [];
          var has = {};
          var circular = {};
          var waiting = false;
          var flushing = false;
          var index$1 = 0;
          /**
           * Reset the scheduler's state.
           */
          function resetSchedulerState() {
            index$1 = queue.length = activatedChildren.length = 0;
            has = {};
            {
              circular = {};
            }
            waiting = flushing = false;
          }
          // Async edge case #6566 requires saving the timestamp when event listeners are
          // attached. However, calling performance.now() has a perf overhead especially
          // if the page has thousands of event listeners. Instead, we take a timestamp
          // every time the scheduler flushes and use that for all event listeners
          // attached during that flush.
          var currentFlushTimestamp = 0;
          // Async edge case fix requires storing an event listener's attach timestamp.
          var getNow = Date.now;
          // Determine what event timestamp the browser is using. Annoyingly, the
          // timestamp can either be hi-res (relative to page load) or low-res
          // (relative to UNIX epoch), so in order to compare time we have to use the
          // same timestamp type when saving the flush timestamp.
          // All IE versions use low-res event timestamps, and have problematic clock
          // implementations (#9632)
          if (inBrowser && !isIE) {
            var performance_1 = window.performance;
            if (
              performance_1 &&
              typeof performance_1.now === "function" &&
              getNow() > document.createEvent("Event").timeStamp
            ) {
              // if the event timestamp, although evaluated AFTER the Date.now(), is
              // smaller than it, it means the event is using a hi-res timestamp,
              // and we need to use the hi-res version for event listener timestamps as
              // well.
              getNow = function () {
                return performance_1.now();
              };
            }
          }
          var sortCompareFn = function (a, b) {
            if (a.post) {
              if (!b.post) return 1;
            } else if (b.post) {
              return -1;
            }
            return a.id - b.id;
          };
          /**
           * Flush both queues and run the watchers.
           */
          function flushSchedulerQueue() {
            currentFlushTimestamp = getNow();
            flushing = true;
            var watcher, id;
            // Sort queue before flush.
            // This ensures that:
            // 1. Components are updated from parent to child. (because parent is always
            //    created before the child)
            // 2. A component's user watchers are run before its render watcher (because
            //    user watchers are created before the render watcher)
            // 3. If a component is destroyed during a parent component's watcher run,
            //    its watchers can be skipped.
            queue.sort(sortCompareFn);
            // do not cache length because more watchers might be pushed
            // as we run existing watchers
            for (index$1 = 0; index$1 < queue.length; index$1++) {
              watcher = queue[index$1];
              if (watcher.before) {
                watcher.before();
              }
              id = watcher.id;
              has[id] = null;
              watcher.run();
              // in dev build, check and stop circular updates.
              if (has[id] != null) {
                circular[id] = (circular[id] || 0) + 1;
                if (circular[id] > MAX_UPDATE_COUNT) {
                  warn$2(
                    "You may have an infinite update loop " +
                      (watcher.user
                        ? 'in watcher with expression "'.concat(
                            watcher.expression,
                            '"'
                          )
                        : "in a component render function."),
                    watcher.vm
                  );
                  break;
                }
              }
            }
            // keep copies of post queues before resetting state
            var activatedQueue = activatedChildren.slice();
            var updatedQueue = queue.slice();
            resetSchedulerState();
            // call component updated and activated hooks
            callActivatedHooks(activatedQueue);
            callUpdatedHooks(updatedQueue);
            cleanupDeps();
            // devtool hook
            /* istanbul ignore if */
            if (devtools && config.devtools) {
              devtools.emit("flush");
            }
          }
          function callUpdatedHooks(queue) {
            var i = queue.length;
            while (i--) {
              var watcher = queue[i];
              var vm = watcher.vm;
              if (
                vm &&
                vm._watcher === watcher &&
                vm._isMounted &&
                !vm._isDestroyed
              ) {
                callHook$1(vm, "updated");
              }
            }
          }
          /**
           * Queue a kept-alive component that was activated during patch.
           * The queue will be processed after the entire tree has been patched.
           */
          function queueActivatedComponent(vm) {
            // setting _inactive to false here so that a render function can
            // rely on checking whether it's in an inactive tree (e.g. router-view)
            vm._inactive = false;
            activatedChildren.push(vm);
          }
          function callActivatedHooks(queue) {
            for (var i = 0; i < queue.length; i++) {
              queue[i]._inactive = true;
              activateChildComponent(queue[i], true /* true */);
            }
          }
          /**
           * Push a watcher into the watcher queue.
           * Jobs with duplicate IDs will be skipped unless it's
           * pushed when the queue is being flushed.
           */
          function queueWatcher(watcher) {
            var id = watcher.id;
            if (has[id] != null) {
              return;
            }
            if (watcher === Dep.target && watcher.noRecurse) {
              return;
            }
            has[id] = true;
            if (!flushing) {
              queue.push(watcher);
            } else {
              // if already flushing, splice the watcher based on its id
              // if already past its id, it will be run next immediately.
              var i = queue.length - 1;
              while (i > index$1 && queue[i].id > watcher.id) {
                i--;
              }
              queue.splice(i + 1, 0, watcher);
            }
            // queue the flush
            if (!waiting) {
              waiting = true;
              if (!config.async) {
                flushSchedulerQueue();
                return;
              }
              nextTick(flushSchedulerQueue);
            }
          }

          var WATCHER = "watcher";
          var WATCHER_CB = "".concat(WATCHER, " callback");
          var WATCHER_GETTER = "".concat(WATCHER, " getter");
          var WATCHER_CLEANUP = "".concat(WATCHER, " cleanup");
          // Simple effect.
          function watchEffect(effect, options) {
            return doWatch(effect, null, options);
          }
          function watchPostEffect(effect, options) {
            return doWatch(
              effect,
              null,
              __assign(__assign({}, options), { flush: "post" })
            );
          }
          function watchSyncEffect(effect, options) {
            return doWatch(
              effect,
              null,
              __assign(__assign({}, options), { flush: "sync" })
            );
          }
          // initial value for watchers to trigger on undefined initial values
          var INITIAL_WATCHER_VALUE = {};
          // implementation
          function watch(source, cb, options) {
            if (typeof cb !== "function") {
              warn$2(
                "`watch(fn, options?)` signature has been moved to a separate API. " +
                  "Use `watchEffect(fn, options?)` instead. `watch` now only " +
                  "supports `watch(source, cb, options?) signature."
              );
            }
            return doWatch(source, cb, options);
          }
          function doWatch(source, cb, _a) {
            var _b = _a === void 0 ? emptyObject : _a,
              immediate = _b.immediate,
              deep = _b.deep,
              _c = _b.flush,
              flush = _c === void 0 ? "pre" : _c,
              onTrack = _b.onTrack,
              onTrigger = _b.onTrigger;
            if (!cb) {
              if (immediate !== undefined) {
                warn$2(
                  'watch() "immediate" option is only respected when using the ' +
                    "watch(source, callback, options?) signature."
                );
              }
              if (deep !== undefined) {
                warn$2(
                  'watch() "deep" option is only respected when using the ' +
                    "watch(source, callback, options?) signature."
                );
              }
            }
            var warnInvalidSource = function (s) {
              warn$2(
                "Invalid watch source: ".concat(
                  s,
                  ". A watch source can only be a getter/effect "
                ) +
                  "function, a ref, a reactive object, or an array of these types."
              );
            };
            var instance = currentInstance;
            var call = function (fn, type, args) {
              if (args === void 0) {
                args = null;
              }
              return invokeWithErrorHandling(fn, null, args, instance, type);
            };
            var getter;
            var forceTrigger = false;
            var isMultiSource = false;
            if (isRef(source)) {
              getter = function () {
                return source.value;
              };
              forceTrigger = isShallow(source);
            } else if (isReactive(source)) {
              getter = function () {
                source.__ob__.dep.depend();
                return source;
              };
              deep = true;
            } else if (isArray(source)) {
              isMultiSource = true;
              forceTrigger = source.some(function (s) {
                return isReactive(s) || isShallow(s);
              });
              getter = function () {
                return source.map(function (s) {
                  if (isRef(s)) {
                    return s.value;
                  } else if (isReactive(s)) {
                    return traverse(s);
                  } else if (isFunction(s)) {
                    return call(s, WATCHER_GETTER);
                  } else {
                    warnInvalidSource(s);
                  }
                });
              };
            } else if (isFunction(source)) {
              if (cb) {
                // getter with cb
                getter = function () {
                  return call(source, WATCHER_GETTER);
                };
              } else {
                // no cb -> simple effect
                getter = function () {
                  if (instance && instance._isDestroyed) {
                    return;
                  }
                  if (cleanup) {
                    cleanup();
                  }
                  return call(source, WATCHER, [onCleanup]);
                };
              }
            } else {
              getter = noop;
              warnInvalidSource(source);
            }
            if (cb && deep) {
              var baseGetter_1 = getter;
              getter = function () {
                return traverse(baseGetter_1());
              };
            }
            var cleanup;
            var onCleanup = function (fn) {
              cleanup = watcher.onStop = function () {
                call(fn, WATCHER_CLEANUP);
              };
            };
            // in SSR there is no need to setup an actual effect, and it should be noop
            // unless it's eager
            if (isServerRendering()) {
              // we will also not call the invalidate callback (+ runner is not set up)
              onCleanup = noop;
              if (!cb) {
                getter();
              } else if (immediate) {
                call(cb, WATCHER_CB, [
                  getter(),
                  isMultiSource ? [] : undefined,
                  onCleanup,
                ]);
              }
              return noop;
            }
            var watcher = new Watcher(currentInstance, getter, noop, {
              lazy: true,
            });
            watcher.noRecurse = !cb;
            var oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
            // overwrite default run
            watcher.run = function () {
              if (!watcher.active) {
                return;
              }
              if (cb) {
                // watch(source, cb)
                var newValue = watcher.get();
                if (
                  deep ||
                  forceTrigger ||
                  (isMultiSource
                    ? newValue.some(function (v, i) {
                        return hasChanged(v, oldValue[i]);
                      })
                    : hasChanged(newValue, oldValue))
                ) {
                  // cleanup before running cb again
                  if (cleanup) {
                    cleanup();
                  }
                  call(cb, WATCHER_CB, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup,
                  ]);
                  oldValue = newValue;
                }
              } else {
                // watchEffect
                watcher.get();
              }
            };
            if (flush === "sync") {
              watcher.update = watcher.run;
            } else if (flush === "post") {
              watcher.post = true;
              watcher.update = function () {
                return queueWatcher(watcher);
              };
            } else {
              // pre
              watcher.update = function () {
                if (
                  instance &&
                  instance === currentInstance &&
                  !instance._isMounted
                ) {
                  // pre-watcher triggered before
                  var buffer =
                    instance._preWatchers || (instance._preWatchers = []);
                  if (buffer.indexOf(watcher) < 0) buffer.push(watcher);
                } else {
                  queueWatcher(watcher);
                }
              };
            }
            {
              watcher.onTrack = onTrack;
              watcher.onTrigger = onTrigger;
            }
            // initial run
            if (cb) {
              if (immediate) {
                watcher.run();
              } else {
                oldValue = watcher.get();
              }
            } else if (flush === "post" && instance) {
              instance.$once("hook:mounted", function () {
                return watcher.get();
              });
            } else {
              watcher.get();
            }
            return function () {
              watcher.teardown();
            };
          }

          var activeEffectScope;
          var EffectScope = /** @class */ (function () {
            function EffectScope(detached) {
              if (detached === void 0) {
                detached = false;
              }
              this.detached = detached;
              /**
               * @internal
               */
              this.active = true;
              /**
               * @internal
               */
              this.effects = [];
              /**
               * @internal
               */
              this.cleanups = [];
              this.parent = activeEffectScope;
              if (!detached && activeEffectScope) {
                this.index =
                  (
                    activeEffectScope.scopes || (activeEffectScope.scopes = [])
                  ).push(this) - 1;
              }
            }
            EffectScope.prototype.run = function (fn) {
              if (this.active) {
                var currentEffectScope = activeEffectScope;
                try {
                  activeEffectScope = this;
                  return fn();
                } finally {
                  activeEffectScope = currentEffectScope;
                }
              } else {
                warn$2("cannot run an inactive effect scope.");
              }
            };
            /**
             * This should only be called on non-detached scopes
             * @internal
             */
            EffectScope.prototype.on = function () {
              activeEffectScope = this;
            };
            /**
             * This should only be called on non-detached scopes
             * @internal
             */
            EffectScope.prototype.off = function () {
              activeEffectScope = this.parent;
            };
            EffectScope.prototype.stop = function (fromParent) {
              if (this.active) {
                var i = void 0,
                  l = void 0;
                for (i = 0, l = this.effects.length; i < l; i++) {
                  this.effects[i].teardown();
                }
                for (i = 0, l = this.cleanups.length; i < l; i++) {
                  this.cleanups[i]();
                }
                if (this.scopes) {
                  for (i = 0, l = this.scopes.length; i < l; i++) {
                    this.scopes[i].stop(true);
                  }
                }
                // nested scope, dereference from parent to avoid memory leaks
                if (!this.detached && this.parent && !fromParent) {
                  // optimized O(1) removal
                  var last = this.parent.scopes.pop();
                  if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                  }
                }
                this.parent = undefined;
                this.active = false;
              }
            };
            return EffectScope;
          })();
          function effectScope(detached) {
            return new EffectScope(detached);
          }
          /**
           * @internal
           */
          function recordEffectScope(effect, scope) {
            if (scope === void 0) {
              scope = activeEffectScope;
            }
            if (scope && scope.active) {
              scope.effects.push(effect);
            }
          }
          function getCurrentScope() {
            return activeEffectScope;
          }
          function onScopeDispose(fn) {
            if (activeEffectScope) {
              activeEffectScope.cleanups.push(fn);
            } else {
              warn$2(
                "onScopeDispose() is called when there is no active effect scope" +
                  " to be associated with."
              );
            }
          }

          function provide(key, value) {
            if (!currentInstance) {
              {
                warn$2("provide() can only be used inside setup().");
              }
            } else {
              // TS doesn't allow symbol as index type
              resolveProvided(currentInstance)[key] = value;
            }
          }
          function resolveProvided(vm) {
            // by default an instance inherits its parent's provides object
            // but when it needs to provide values of its own, it creates its
            // own provides object using parent provides object as prototype.
            // this way in `inject` we can simply look up injections from direct
            // parent and let the prototype chain do the work.
            var existing = vm._provided;
            var parentProvides = vm.$parent && vm.$parent._provided;
            if (parentProvides === existing) {
              return (vm._provided = Object.create(parentProvides));
            } else {
              return existing;
            }
          }
          function inject(key, defaultValue, treatDefaultAsFactory) {
            if (treatDefaultAsFactory === void 0) {
              treatDefaultAsFactory = false;
            }
            // fallback to `currentRenderingInstance` so that this can be called in
            // a functional component
            var instance = currentInstance;
            if (instance) {
              // #2400
              // to support `app.use` plugins,
              // fallback to appContext's `provides` if the instance is at root
              var provides = instance.$parent && instance.$parent._provided;
              if (provides && key in provides) {
                // TS doesn't allow symbol as index type
                return provides[key];
              } else if (arguments.length > 1) {
                return treatDefaultAsFactory && isFunction(defaultValue)
                  ? defaultValue.call(instance)
                  : defaultValue;
              } else {
                warn$2('injection "'.concat(String(key), '" not found.'));
              }
            } else {
              warn$2(
                "inject() can only be used inside setup() or functional components."
              );
            }
          }

          /**
           * @internal this function needs manual public type declaration because it relies
           * on previously manually authored types from Vue 2
           */
          function h(type, props, children) {
            if (!currentInstance) {
              warn$2(
                "globally imported h() can only be invoked when there is an active " +
                  "component instance, e.g. synchronously in a component's render or setup function."
              );
            }
            return createElement$1(
              currentInstance,
              type,
              props,
              children,
              2,
              true
            );
          }

          function handleError(err, vm, info) {
            // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
            // See: https://github.com/vuejs/vuex/issues/1505
            pushTarget();
            try {
              if (vm) {
                var cur = vm;
                while ((cur = cur.$parent)) {
                  var hooks = cur.$options.errorCaptured;
                  if (hooks) {
                    for (var i = 0; i < hooks.length; i++) {
                      try {
                        var capture =
                          hooks[i].call(cur, err, vm, info) === false;
                        if (capture) return;
                      } catch (e) {
                        globalHandleError(e, cur, "errorCaptured hook");
                      }
                    }
                  }
                }
              }
              globalHandleError(err, vm, info);
            } finally {
              popTarget();
            }
          }
          function invokeWithErrorHandling(handler, context, args, vm, info) {
            var res;
            try {
              res = args ? handler.apply(context, args) : handler.call(context);
              if (res && !res._isVue && isPromise(res) && !res._handled) {
                res.catch(function (e) {
                  return handleError(e, vm, info + " (Promise/async)");
                });
                res._handled = true;
              }
            } catch (e) {
              handleError(e, vm, info);
            }
            return res;
          }
          function globalHandleError(err, vm, info) {
            if (config.errorHandler) {
              try {
                return config.errorHandler.call(null, err, vm, info);
              } catch (e) {
                // if the user intentionally throws the original error in the handler,
                // do not log it twice
                if (e !== err) {
                  logError(e, null, "config.errorHandler");
                }
              }
            }
            logError(err, vm, info);
          }
          function logError(err, vm, info) {
            {
              warn$2(
                "Error in ".concat(info, ': "').concat(err.toString(), '"'),
                vm
              );
            }
            /* istanbul ignore else */
            if (inBrowser && typeof console !== "undefined") {
              console.error(err);
            } else {
              throw err;
            }
          }

          /* globals MutationObserver */
          var isUsingMicroTask = false;
          var callbacks = [];
          var pending = false;
          function flushCallbacks() {
            pending = false;
            var copies = callbacks.slice(0);
            callbacks.length = 0;
            for (var i = 0; i < copies.length; i++) {
              copies[i]();
            }
          }
          // Here we have async deferring wrappers using microtasks.
          // In 2.5 we used (macro) tasks (in combination with microtasks).
          // However, it has subtle problems when state is changed right before repaint
          // (e.g. #6813, out-in transitions).
          // Also, using (macro) tasks in event handler would cause some weird behaviors
          // that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
          // So we now use microtasks everywhere, again.
          // A major drawback of this tradeoff is that there are some scenarios
          // where microtasks have too high a priority and fire in between supposedly
          // sequential events (e.g. #4521, #6690, which have workarounds)
          // or even between bubbling of the same event (#6566).
          var timerFunc;
          // The nextTick behavior leverages the microtask queue, which can be accessed
          // via either native Promise.then or MutationObserver.
          // MutationObserver has wider support, however it is seriously bugged in
          // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
          // completely stops working after triggering a few times... so, if native
          // Promise is available, we will use it:
          /* istanbul ignore next, $flow-disable-line */
          if (typeof Promise !== "undefined" && isNative(Promise)) {
            var p_1 = Promise.resolve();
            timerFunc = function () {
              p_1.then(flushCallbacks);
              // In problematic UIWebViews, Promise.then doesn't completely break, but
              // it can get stuck in a weird state where callbacks are pushed into the
              // microtask queue but the queue isn't being flushed, until the browser
              // needs to do some other work, e.g. handle a timer. Therefore we can
              // "force" the microtask queue to be flushed by adding an empty timer.
              if (isIOS) setTimeout(noop);
            };
            isUsingMicroTask = true;
          } else if (
            !isIE &&
            typeof MutationObserver !== "undefined" &&
            (isNative(MutationObserver) ||
              // PhantomJS and iOS 7.x
              MutationObserver.toString() ===
                "[object MutationObserverConstructor]")
          ) {
            // Use MutationObserver where native Promise is not available,
            // e.g. PhantomJS, iOS7, Android 4.4
            // (#6466 MutationObserver is unreliable in IE11)
            var counter_1 = 1;
            var observer = new MutationObserver(flushCallbacks);
            var textNode_1 = document.createTextNode(String(counter_1));
            observer.observe(textNode_1, {
              characterData: true,
            });
            timerFunc = function () {
              counter_1 = (counter_1 + 1) % 2;
              textNode_1.data = String(counter_1);
            };
            isUsingMicroTask = true;
          } else if (
            typeof setImmediate !== "undefined" &&
            isNative(setImmediate)
          ) {
            // Fallback to setImmediate.
            // Technically it leverages the (macro) task queue,
            // but it is still a better choice than setTimeout.
            timerFunc = function () {
              setImmediate(flushCallbacks);
            };
          } else {
            // Fallback to setTimeout.
            timerFunc = function () {
              setTimeout(flushCallbacks, 0);
            };
          }
          /**
           * @internal
           */
          function nextTick(cb, ctx) {
            var _resolve;
            callbacks.push(function () {
              if (cb) {
                try {
                  cb.call(ctx);
                } catch (e) {
                  handleError(e, ctx, "nextTick");
                }
              } else if (_resolve) {
                _resolve(ctx);
              }
            });
            if (!pending) {
              pending = true;
              timerFunc();
            }
            // $flow-disable-line
            if (!cb && typeof Promise !== "undefined") {
              return new Promise(function (resolve) {
                _resolve = resolve;
              });
            }
          }

          function useCssModule(name) {
            /* istanbul ignore else */
            {
              {
                warn$2("useCssModule() is not supported in the global build.");
              }
              return emptyObject;
            }
          }

          /**
           * Runtime helper for SFC's CSS variable injection feature.
           * @private
           */
          function useCssVars(getter) {
            if (!inBrowser && !false) return;
            var instance = currentInstance;
            if (!instance) {
              warn$2(
                "useCssVars is called without current active component instance."
              );
              return;
            }
            watchPostEffect(function () {
              var el = instance.$el;
              var vars = getter(instance, instance._setupProxy);
              if (el && el.nodeType === 1) {
                var style = el.style;
                for (var key in vars) {
                  style.setProperty("--".concat(key), vars[key]);
                }
              }
            });
          }

          /**
           * v3-compatible async component API.
           * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
           * because it relies on existing manual types
           */
          function defineAsyncComponent(source) {
            if (isFunction(source)) {
              source = { loader: source };
            }
            var loader = source.loader,
              loadingComponent = source.loadingComponent,
              errorComponent = source.errorComponent,
              _a = source.delay,
              delay = _a === void 0 ? 200 : _a,
              timeout = source.timeout, // undefined = never times out
              _b = source.suspensible, // undefined = never times out
              suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
              userOnError = source.onError;
            if (suspensible) {
              warn$2(
                "The suspensiblbe option for async components is not supported in Vue2. It is ignored."
              );
            }
            var pendingRequest = null;
            var retries = 0;
            var retry = function () {
              retries++;
              pendingRequest = null;
              return load();
            };
            var load = function () {
              var thisRequest;
              return (
                pendingRequest ||
                (thisRequest = pendingRequest =
                  loader()
                    .catch(function (err) {
                      err = err instanceof Error ? err : new Error(String(err));
                      if (userOnError) {
                        return new Promise(function (resolve, reject) {
                          var userRetry = function () {
                            return resolve(retry());
                          };
                          var userFail = function () {
                            return reject(err);
                          };
                          userOnError(err, userRetry, userFail, retries + 1);
                        });
                      } else {
                        throw err;
                      }
                    })
                    .then(function (comp) {
                      if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                      }
                      if (!comp) {
                        warn$2(
                          "Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value."
                        );
                      }
                      // interop module default
                      if (
                        comp &&
                        (comp.__esModule ||
                          comp[Symbol.toStringTag] === "Module")
                      ) {
                        comp = comp.default;
                      }
                      if (comp && !isObject(comp) && !isFunction(comp)) {
                        throw new Error(
                          "Invalid async component load result: ".concat(comp)
                        );
                      }
                      return comp;
                    }))
              );
            };
            return function () {
              var component = load();
              return {
                component: component,
                delay: delay,
                timeout: timeout,
                error: errorComponent,
                loading: loadingComponent,
              };
            };
          }

          function createLifeCycle(hookName) {
            return function (fn, target) {
              if (target === void 0) {
                target = currentInstance;
              }
              if (!target) {
                warn$2(
                  "".concat(
                    formatName(hookName),
                    " is called when there is no active component instance to be "
                  ) +
                    "associated with. " +
                    "Lifecycle injection APIs can only be used during execution of setup()."
                );
                return;
              }
              return injectHook(target, hookName, fn);
            };
          }
          function formatName(name) {
            if (name === "beforeDestroy") {
              name = "beforeUnmount";
            } else if (name === "destroyed") {
              name = "unmounted";
            }
            return "on".concat(name[0].toUpperCase() + name.slice(1));
          }
          function injectHook(instance, hookName, fn) {
            var options = instance.$options;
            options[hookName] = mergeLifecycleHook(options[hookName], fn);
          }
          var onBeforeMount = createLifeCycle("beforeMount");
          var onMounted = createLifeCycle("mounted");
          var onBeforeUpdate = createLifeCycle("beforeUpdate");
          var onUpdated = createLifeCycle("updated");
          var onBeforeUnmount = createLifeCycle("beforeDestroy");
          var onUnmounted = createLifeCycle("destroyed");
          var onActivated = createLifeCycle("activated");
          var onDeactivated = createLifeCycle("deactivated");
          var onServerPrefetch = createLifeCycle("serverPrefetch");
          var onRenderTracked = createLifeCycle("renderTracked");
          var onRenderTriggered = createLifeCycle("renderTriggered");
          var injectErrorCapturedHook = createLifeCycle("errorCaptured");
          function onErrorCaptured(hook, target) {
            if (target === void 0) {
              target = currentInstance;
            }
            injectErrorCapturedHook(hook, target);
          }

          /**
           * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
           */
          var version = "2.7.14";
          /**
           * @internal type is manually declared in <root>/types/v3-define-component.d.ts
           */
          function defineComponent(options) {
            return options;
          }

          var vca = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            version: version,
            defineComponent: defineComponent,
            ref: ref$1,
            shallowRef: shallowRef,
            isRef: isRef,
            toRef: toRef,
            toRefs: toRefs,
            unref: unref,
            proxyRefs: proxyRefs,
            customRef: customRef,
            triggerRef: triggerRef,
            reactive: reactive,
            isReactive: isReactive,
            isReadonly: isReadonly,
            isShallow: isShallow,
            isProxy: isProxy,
            shallowReactive: shallowReactive,
            markRaw: markRaw,
            toRaw: toRaw,
            readonly: readonly,
            shallowReadonly: shallowReadonly,
            computed: computed,
            watch: watch,
            watchEffect: watchEffect,
            watchPostEffect: watchPostEffect,
            watchSyncEffect: watchSyncEffect,
            EffectScope: EffectScope,
            effectScope: effectScope,
            onScopeDispose: onScopeDispose,
            getCurrentScope: getCurrentScope,
            provide: provide,
            inject: inject,
            h: h,
            getCurrentInstance: getCurrentInstance,
            useSlots: useSlots,
            useAttrs: useAttrs,
            useListeners: useListeners,
            mergeDefaults: mergeDefaults,
            nextTick: nextTick,
            set: set,
            del: del,
            useCssModule: useCssModule,
            useCssVars: useCssVars,
            defineAsyncComponent: defineAsyncComponent,
            onBeforeMount: onBeforeMount,
            onMounted: onMounted,
            onBeforeUpdate: onBeforeUpdate,
            onUpdated: onUpdated,
            onBeforeUnmount: onBeforeUnmount,
            onUnmounted: onUnmounted,
            onActivated: onActivated,
            onDeactivated: onDeactivated,
            onServerPrefetch: onServerPrefetch,
            onRenderTracked: onRenderTracked,
            onRenderTriggered: onRenderTriggered,
            onErrorCaptured: onErrorCaptured,
          });

          var seenObjects = new _Set();
          /**
           * Recursively traverse an object to evoke all converted
           * getters, so that every nested property inside the object
           * is collected as a "deep" dependency.
           */
          function traverse(val) {
            _traverse(val, seenObjects);
            seenObjects.clear();
            return val;
          }
          function _traverse(val, seen) {
            var i, keys;
            var isA = isArray(val);
            if (
              (!isA && !isObject(val)) ||
              val.__v_skip /* ReactiveFlags.SKIP */ ||
              Object.isFrozen(val) ||
              val instanceof VNode
            ) {
              return;
            }
            if (val.__ob__) {
              var depId = val.__ob__.dep.id;
              if (seen.has(depId)) {
                return;
              }
              seen.add(depId);
            }
            if (isA) {
              i = val.length;
              while (i--) _traverse(val[i], seen);
            } else if (isRef(val)) {
              _traverse(val.value, seen);
            } else {
              keys = Object.keys(val);
              i = keys.length;
              while (i--) _traverse(val[keys[i]], seen);
            }
          }

          var uid$1 = 0;
          /**
           * A watcher parses an expression, collects dependencies,
           * and fires callback when the expression value changes.
           * This is used for both the $watch() api and directives.
           * @internal
           */
          var Watcher = /** @class */ (function () {
            function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
              recordEffectScope(
                this,
                // if the active effect scope is manually created (not a component scope),
                // prioritize it
                activeEffectScope && !activeEffectScope._vm
                  ? activeEffectScope
                  : vm
                  ? vm._scope
                  : undefined
              );
              if ((this.vm = vm) && isRenderWatcher) {
                vm._watcher = this;
              }
              // options
              if (options) {
                this.deep = !!options.deep;
                this.user = !!options.user;
                this.lazy = !!options.lazy;
                this.sync = !!options.sync;
                this.before = options.before;
                {
                  this.onTrack = options.onTrack;
                  this.onTrigger = options.onTrigger;
                }
              } else {
                this.deep = this.user = this.lazy = this.sync = false;
              }
              this.cb = cb;
              this.id = ++uid$1; // uid for batching
              this.active = true;
              this.post = false;
              this.dirty = this.lazy; // for lazy watchers
              this.deps = [];
              this.newDeps = [];
              this.depIds = new _Set();
              this.newDepIds = new _Set();
              this.expression = expOrFn.toString();
              // parse expression for getter
              if (isFunction(expOrFn)) {
                this.getter = expOrFn;
              } else {
                this.getter = parsePath(expOrFn);
                if (!this.getter) {
                  this.getter = noop;
                  warn$2(
                    'Failed watching path: "'.concat(expOrFn, '" ') +
                      "Watcher only accepts simple dot-delimited paths. " +
                      "For full control, use a function instead.",
                    vm
                  );
                }
              }
              this.value = this.lazy ? undefined : this.get();
            }
            /**
             * Evaluate the getter, and re-collect dependencies.
             */
            Watcher.prototype.get = function () {
              pushTarget(this);
              var value;
              var vm = this.vm;
              try {
                value = this.getter.call(vm, vm);
              } catch (e) {
                if (this.user) {
                  handleError(
                    e,
                    vm,
                    'getter for watcher "'.concat(this.expression, '"')
                  );
                } else {
                  throw e;
                }
              } finally {
                // "touch" every property so they are all tracked as
                // dependencies for deep watching
                if (this.deep) {
                  traverse(value);
                }
                popTarget();
                this.cleanupDeps();
              }
              return value;
            };
            /**
             * Add a dependency to this directive.
             */
            Watcher.prototype.addDep = function (dep) {
              var id = dep.id;
              if (!this.newDepIds.has(id)) {
                this.newDepIds.add(id);
                this.newDeps.push(dep);
                if (!this.depIds.has(id)) {
                  dep.addSub(this);
                }
              }
            };
            /**
             * Clean up for dependency collection.
             */
            Watcher.prototype.cleanupDeps = function () {
              var i = this.deps.length;
              while (i--) {
                var dep = this.deps[i];
                if (!this.newDepIds.has(dep.id)) {
                  dep.removeSub(this);
                }
              }
              var tmp = this.depIds;
              this.depIds = this.newDepIds;
              this.newDepIds = tmp;
              this.newDepIds.clear();
              tmp = this.deps;
              this.deps = this.newDeps;
              this.newDeps = tmp;
              this.newDeps.length = 0;
            };
            /**
             * Subscriber interface.
             * Will be called when a dependency changes.
             */
            Watcher.prototype.update = function () {
              /* istanbul ignore else */
              if (this.lazy) {
                this.dirty = true;
              } else if (this.sync) {
                this.run();
              } else {
                queueWatcher(this);
              }
            };
            /**
             * Scheduler job interface.
             * Will be called by the scheduler.
             */
            Watcher.prototype.run = function () {
              if (this.active) {
                var value = this.get();
                if (
                  value !== this.value ||
                  // Deep watchers and watchers on Object/Arrays should fire even
                  // when the value is the same, because the value may
                  // have mutated.
                  isObject(value) ||
                  this.deep
                ) {
                  // set new value
                  var oldValue = this.value;
                  this.value = value;
                  if (this.user) {
                    var info = 'callback for watcher "'.concat(
                      this.expression,
                      '"'
                    );
                    invokeWithErrorHandling(
                      this.cb,
                      this.vm,
                      [value, oldValue],
                      this.vm,
                      info
                    );
                  } else {
                    this.cb.call(this.vm, value, oldValue);
                  }
                }
              }
            };
            /**
             * Evaluate the value of the watcher.
             * This only gets called for lazy watchers.
             */
            Watcher.prototype.evaluate = function () {
              this.value = this.get();
              this.dirty = false;
            };
            /**
             * Depend on all deps collected by this watcher.
             */
            Watcher.prototype.depend = function () {
              var i = this.deps.length;
              while (i--) {
                this.deps[i].depend();
              }
            };
            /**
             * Remove self from all dependencies' subscriber list.
             */
            Watcher.prototype.teardown = function () {
              if (this.vm && !this.vm._isBeingDestroyed) {
                remove$2(this.vm._scope.effects, this);
              }
              if (this.active) {
                var i = this.deps.length;
                while (i--) {
                  this.deps[i].removeSub(this);
                }
                this.active = false;
                if (this.onStop) {
                  this.onStop();
                }
              }
            };
            return Watcher;
          })();

          var sharedPropertyDefinition = {
            enumerable: true,
            configurable: true,
            get: noop,
            set: noop,
          };
          function proxy(target, sourceKey, key) {
            sharedPropertyDefinition.get = function proxyGetter() {
              return this[sourceKey][key];
            };
            sharedPropertyDefinition.set = function proxySetter(val) {
              this[sourceKey][key] = val;
            };
            Object.defineProperty(target, key, sharedPropertyDefinition);
          }
          function initState(vm) {
            var opts = vm.$options;
            if (opts.props) initProps$1(vm, opts.props);
            // Composition API
            initSetup(vm);
            if (opts.methods) initMethods(vm, opts.methods);
            if (opts.data) {
              initData(vm);
            } else {
              var ob = observe((vm._data = {}));
              ob && ob.vmCount++;
            }
            if (opts.computed) initComputed$1(vm, opts.computed);
            if (opts.watch && opts.watch !== nativeWatch) {
              initWatch(vm, opts.watch);
            }
          }
          function initProps$1(vm, propsOptions) {
            var propsData = vm.$options.propsData || {};
            var props = (vm._props = shallowReactive({}));
            // cache prop keys so that future props updates can iterate using Array
            // instead of dynamic object key enumeration.
            var keys = (vm.$options._propKeys = []);
            var isRoot = !vm.$parent;
            // root instance props should be converted
            if (!isRoot) {
              toggleObserving(false);
            }
            var _loop_1 = function (key) {
              keys.push(key);
              var value = validateProp(key, propsOptions, propsData, vm);
              /* istanbul ignore else */
              {
                var hyphenatedKey = hyphenate(key);
                if (
                  isReservedAttribute(hyphenatedKey) ||
                  config.isReservedAttr(hyphenatedKey)
                ) {
                  warn$2(
                    '"'.concat(
                      hyphenatedKey,
                      '" is a reserved attribute and cannot be used as component prop.'
                    ),
                    vm
                  );
                }
                defineReactive(props, key, value, function () {
                  if (!isRoot && !isUpdatingChildComponent) {
                    warn$2(
                      "Avoid mutating a prop directly since the value will be " +
                        "overwritten whenever the parent component re-renders. " +
                        "Instead, use a data or computed property based on the prop's " +
                        'value. Prop being mutated: "'.concat(key, '"'),
                      vm
                    );
                  }
                });
              }
              // static props are already proxied on the component's prototype
              // during Vue.extend(). We only need to proxy props defined at
              // instantiation here.
              if (!(key in vm)) {
                proxy(vm, "_props", key);
              }
            };
            for (var key in propsOptions) {
              _loop_1(key);
            }
            toggleObserving(true);
          }
          function initData(vm) {
            var data = vm.$options.data;
            data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
            if (!isPlainObject(data)) {
              data = {};
              warn$2(
                "data functions should return an object:\n" +
                  "https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function",
                vm
              );
            }
            // proxy data on instance
            var keys = Object.keys(data);
            var props = vm.$options.props;
            var methods = vm.$options.methods;
            var i = keys.length;
            while (i--) {
              var key = keys[i];
              {
                if (methods && hasOwn(methods, key)) {
                  warn$2(
                    'Method "'.concat(
                      key,
                      '" has already been defined as a data property.'
                    ),
                    vm
                  );
                }
              }
              if (props && hasOwn(props, key)) {
                warn$2(
                  'The data property "'.concat(
                    key,
                    '" is already declared as a prop. '
                  ) + "Use prop default value instead.",
                  vm
                );
              } else if (!isReserved(key)) {
                proxy(vm, "_data", key);
              }
            }
            // observe data
            var ob = observe(data);
            ob && ob.vmCount++;
          }
          function getData(data, vm) {
            // #7573 disable dep collection when invoking data getters
            pushTarget();
            try {
              return data.call(vm, vm);
            } catch (e) {
              handleError(e, vm, "data()");
              return {};
            } finally {
              popTarget();
            }
          }
          var computedWatcherOptions = { lazy: true };
          function initComputed$1(vm, computed) {
            // $flow-disable-line
            var watchers = (vm._computedWatchers = Object.create(null));
            // computed properties are just getters during SSR
            var isSSR = isServerRendering();
            for (var key in computed) {
              var userDef = computed[key];
              var getter = isFunction(userDef) ? userDef : userDef.get;
              if (getter == null) {
                warn$2(
                  'Getter is missing for computed property "'.concat(key, '".'),
                  vm
                );
              }
              if (!isSSR) {
                // create internal watcher for the computed property.
                watchers[key] = new Watcher(
                  vm,
                  getter || noop,
                  noop,
                  computedWatcherOptions
                );
              }
              // component-defined computed properties are already defined on the
              // component prototype. We only need to define computed properties defined
              // at instantiation here.
              if (!(key in vm)) {
                defineComputed(vm, key, userDef);
              } else {
                if (key in vm.$data) {
                  warn$2(
                    'The computed property "'.concat(
                      key,
                      '" is already defined in data.'
                    ),
                    vm
                  );
                } else if (vm.$options.props && key in vm.$options.props) {
                  warn$2(
                    'The computed property "'.concat(
                      key,
                      '" is already defined as a prop.'
                    ),
                    vm
                  );
                } else if (vm.$options.methods && key in vm.$options.methods) {
                  warn$2(
                    'The computed property "'.concat(
                      key,
                      '" is already defined as a method.'
                    ),
                    vm
                  );
                }
              }
            }
          }
          function defineComputed(target, key, userDef) {
            var shouldCache = !isServerRendering();
            if (isFunction(userDef)) {
              sharedPropertyDefinition.get = shouldCache
                ? createComputedGetter(key)
                : createGetterInvoker(userDef);
              sharedPropertyDefinition.set = noop;
            } else {
              sharedPropertyDefinition.get = userDef.get
                ? shouldCache && userDef.cache !== false
                  ? createComputedGetter(key)
                  : createGetterInvoker(userDef.get)
                : noop;
              sharedPropertyDefinition.set = userDef.set || noop;
            }
            if (sharedPropertyDefinition.set === noop) {
              sharedPropertyDefinition.set = function () {
                warn$2(
                  'Computed property "'.concat(
                    key,
                    '" was assigned to but it has no setter.'
                  ),
                  this
                );
              };
            }
            Object.defineProperty(target, key, sharedPropertyDefinition);
          }
          function createComputedGetter(key) {
            return function computedGetter() {
              var watcher =
                this._computedWatchers && this._computedWatchers[key];
              if (watcher) {
                if (watcher.dirty) {
                  watcher.evaluate();
                }
                if (Dep.target) {
                  if (Dep.target.onTrack) {
                    Dep.target.onTrack({
                      effect: Dep.target,
                      target: this,
                      type: "get" /* TrackOpTypes.GET */,
                      key: key,
                    });
                  }
                  watcher.depend();
                }
                return watcher.value;
              }
            };
          }
          function createGetterInvoker(fn) {
            return function computedGetter() {
              return fn.call(this, this);
            };
          }
          function initMethods(vm, methods) {
            var props = vm.$options.props;
            for (var key in methods) {
              {
                if (typeof methods[key] !== "function") {
                  warn$2(
                    'Method "'
                      .concat(key, '" has type "')
                      .concat(
                        typeof methods[key],
                        '" in the component definition. '
                      ) + "Did you reference the function correctly?",
                    vm
                  );
                }
                if (props && hasOwn(props, key)) {
                  warn$2(
                    'Method "'.concat(
                      key,
                      '" has already been defined as a prop.'
                    ),
                    vm
                  );
                }
                if (key in vm && isReserved(key)) {
                  warn$2(
                    'Method "'.concat(
                      key,
                      '" conflicts with an existing Vue instance method. '
                    ) +
                      "Avoid defining component methods that start with _ or $."
                  );
                }
              }
              vm[key] =
                typeof methods[key] !== "function"
                  ? noop
                  : bind$1(methods[key], vm);
            }
          }
          function initWatch(vm, watch) {
            for (var key in watch) {
              var handler = watch[key];
              if (isArray(handler)) {
                for (var i = 0; i < handler.length; i++) {
                  createWatcher(vm, key, handler[i]);
                }
              } else {
                createWatcher(vm, key, handler);
              }
            }
          }
          function createWatcher(vm, expOrFn, handler, options) {
            if (isPlainObject(handler)) {
              options = handler;
              handler = handler.handler;
            }
            if (typeof handler === "string") {
              handler = vm[handler];
            }
            return vm.$watch(expOrFn, handler, options);
          }
          function stateMixin(Vue) {
            // flow somehow has problems with directly declared definition object
            // when using Object.defineProperty, so we have to procedurally build up
            // the object here.
            var dataDef = {};
            dataDef.get = function () {
              return this._data;
            };
            var propsDef = {};
            propsDef.get = function () {
              return this._props;
            };
            {
              dataDef.set = function () {
                warn$2(
                  "Avoid replacing instance root $data. " +
                    "Use nested data properties instead.",
                  this
                );
              };
              propsDef.set = function () {
                warn$2("$props is readonly.", this);
              };
            }
            Object.defineProperty(Vue.prototype, "$data", dataDef);
            Object.defineProperty(Vue.prototype, "$props", propsDef);
            Vue.prototype.$set = set;
            Vue.prototype.$delete = del;
            Vue.prototype.$watch = function (expOrFn, cb, options) {
              var vm = this;
              if (isPlainObject(cb)) {
                return createWatcher(vm, expOrFn, cb, options);
              }
              options = options || {};
              options.user = true;
              var watcher = new Watcher(vm, expOrFn, cb, options);
              if (options.immediate) {
                var info = 'callback for immediate watcher "'.concat(
                  watcher.expression,
                  '"'
                );
                pushTarget();
                invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
                popTarget();
              }
              return function unwatchFn() {
                watcher.teardown();
              };
            };
          }

          function initProvide(vm) {
            var provideOption = vm.$options.provide;
            if (provideOption) {
              var provided = isFunction(provideOption)
                ? provideOption.call(vm)
                : provideOption;
              if (!isObject(provided)) {
                return;
              }
              var source = resolveProvided(vm);
              // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
              // iterate the keys ourselves.
              var keys = hasSymbol
                ? Reflect.ownKeys(provided)
                : Object.keys(provided);
              for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                Object.defineProperty(
                  source,
                  key,
                  Object.getOwnPropertyDescriptor(provided, key)
                );
              }
            }
          }
          function initInjections(vm) {
            var result = resolveInject(vm.$options.inject, vm);
            if (result) {
              toggleObserving(false);
              Object.keys(result).forEach(function (key) {
                /* istanbul ignore else */
                {
                  defineReactive(vm, key, result[key], function () {
                    warn$2(
                      "Avoid mutating an injected value directly since the changes will be " +
                        "overwritten whenever the provided component re-renders. " +
                        'injection being mutated: "'.concat(key, '"'),
                      vm
                    );
                  });
                }
              });
              toggleObserving(true);
            }
          }
          function resolveInject(inject, vm) {
            if (inject) {
              // inject is :any because flow is not smart enough to figure out cached
              var result = Object.create(null);
              var keys = hasSymbol
                ? Reflect.ownKeys(inject)
                : Object.keys(inject);
              for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                // #6574 in case the inject object is observed...
                if (key === "__ob__") continue;
                var provideKey = inject[key].from;
                if (provideKey in vm._provided) {
                  result[key] = vm._provided[provideKey];
                } else if ("default" in inject[key]) {
                  var provideDefault = inject[key].default;
                  result[key] = isFunction(provideDefault)
                    ? provideDefault.call(vm)
                    : provideDefault;
                } else {
                  warn$2('Injection "'.concat(key, '" not found'), vm);
                }
              }
              return result;
            }
          }

          var uid = 0;
          function initMixin$1(Vue) {
            Vue.prototype._init = function (options) {
              var vm = this;
              // a uid
              vm._uid = uid++;
              var startTag, endTag;
              /* istanbul ignore if */
              if (config.performance && mark) {
                startTag = "vue-perf-start:".concat(vm._uid);
                endTag = "vue-perf-end:".concat(vm._uid);
                mark(startTag);
              }
              // a flag to mark this as a Vue instance without having to do instanceof
              // check
              vm._isVue = true;
              // avoid instances from being observed
              vm.__v_skip = true;
              // effect scope
              vm._scope = new EffectScope(true /* detached */);
              vm._scope._vm = true;
              // merge options
              if (options && options._isComponent) {
                // optimize internal component instantiation
                // since dynamic options merging is pretty slow, and none of the
                // internal component options needs special treatment.
                initInternalComponent(vm, options);
              } else {
                vm.$options = mergeOptions(
                  resolveConstructorOptions(vm.constructor),
                  options || {},
                  vm
                );
              }
              /* istanbul ignore else */
              {
                initProxy(vm);
              }
              // expose real self
              vm._self = vm;
              initLifecycle(vm);
              initEvents(vm);
              initRender(vm);
              callHook$1(vm, "beforeCreate", undefined, false /* setContext */);
              initInjections(vm); // resolve injections before data/props
              initState(vm);
              initProvide(vm); // resolve provide after data/props
              callHook$1(vm, "created");
              /* istanbul ignore if */
              if (config.performance && mark) {
                vm._name = formatComponentName(vm, false);
                mark(endTag);
                measure("vue ".concat(vm._name, " init"), startTag, endTag);
              }
              if (vm.$options.el) {
                vm.$mount(vm.$options.el);
              }
            };
          }
          function initInternalComponent(vm, options) {
            var opts = (vm.$options = Object.create(vm.constructor.options));
            // doing this because it's faster than dynamic enumeration.
            var parentVnode = options._parentVnode;
            opts.parent = options.parent;
            opts._parentVnode = parentVnode;
            var vnodeComponentOptions = parentVnode.componentOptions;
            opts.propsData = vnodeComponentOptions.propsData;
            opts._parentListeners = vnodeComponentOptions.listeners;
            opts._renderChildren = vnodeComponentOptions.children;
            opts._componentTag = vnodeComponentOptions.tag;
            if (options.render) {
              opts.render = options.render;
              opts.staticRenderFns = options.staticRenderFns;
            }
          }
          function resolveConstructorOptions(Ctor) {
            var options = Ctor.options;
            if (Ctor.super) {
              var superOptions = resolveConstructorOptions(Ctor.super);
              var cachedSuperOptions = Ctor.superOptions;
              if (superOptions !== cachedSuperOptions) {
                // super option changed,
                // need to resolve new options.
                Ctor.superOptions = superOptions;
                // check if there are any late-modified/attached options (#4976)
                var modifiedOptions = resolveModifiedOptions(Ctor);
                // update base extend options
                if (modifiedOptions) {
                  extend(Ctor.extendOptions, modifiedOptions);
                }
                options = Ctor.options = mergeOptions(
                  superOptions,
                  Ctor.extendOptions
                );
                if (options.name) {
                  options.components[options.name] = Ctor;
                }
              }
            }
            return options;
          }
          function resolveModifiedOptions(Ctor) {
            var modified;
            var latest = Ctor.options;
            var sealed = Ctor.sealedOptions;
            for (var key in latest) {
              if (latest[key] !== sealed[key]) {
                if (!modified) modified = {};
                modified[key] = latest[key];
              }
            }
            return modified;
          }

          function FunctionalRenderContext(
            data,
            props,
            children,
            parent,
            Ctor
          ) {
            var _this = this;
            var options = Ctor.options;
            // ensure the createElement function in functional components
            // gets a unique context - this is necessary for correct named slot check
            var contextVm;
            if (hasOwn(parent, "_uid")) {
              contextVm = Object.create(parent);
              contextVm._original = parent;
            } else {
              // the context vm passed in is a functional context as well.
              // in this case we want to make sure we are able to get a hold to the
              // real context instance.
              contextVm = parent;
              // @ts-ignore
              parent = parent._original;
            }
            var isCompiled = isTrue(options._compiled);
            var needNormalization = !isCompiled;
            this.data = data;
            this.props = props;
            this.children = children;
            this.parent = parent;
            this.listeners = data.on || emptyObject;
            this.injections = resolveInject(options.inject, parent);
            this.slots = function () {
              if (!_this.$slots) {
                normalizeScopedSlots(
                  parent,
                  data.scopedSlots,
                  (_this.$slots = resolveSlots(children, parent))
                );
              }
              return _this.$slots;
            };
            Object.defineProperty(this, "scopedSlots", {
              enumerable: true,
              get: function () {
                return normalizeScopedSlots(
                  parent,
                  data.scopedSlots,
                  this.slots()
                );
              },
            });
            // support for compiled functional template
            if (isCompiled) {
              // exposing $options for renderStatic()
              this.$options = options;
              // pre-resolve slots for renderSlot()
              this.$slots = this.slots();
              this.$scopedSlots = normalizeScopedSlots(
                parent,
                data.scopedSlots,
                this.$slots
              );
            }
            if (options._scopeId) {
              this._c = function (a, b, c, d) {
                var vnode = createElement$1(
                  contextVm,
                  a,
                  b,
                  c,
                  d,
                  needNormalization
                );
                if (vnode && !isArray(vnode)) {
                  vnode.fnScopeId = options._scopeId;
                  vnode.fnContext = parent;
                }
                return vnode;
              };
            } else {
              this._c = function (a, b, c, d) {
                return createElement$1(
                  contextVm,
                  a,
                  b,
                  c,
                  d,
                  needNormalization
                );
              };
            }
          }
          installRenderHelpers(FunctionalRenderContext.prototype);
          function createFunctionalComponent(
            Ctor,
            propsData,
            data,
            contextVm,
            children
          ) {
            var options = Ctor.options;
            var props = {};
            var propOptions = options.props;
            if (isDef(propOptions)) {
              for (var key in propOptions) {
                props[key] = validateProp(
                  key,
                  propOptions,
                  propsData || emptyObject
                );
              }
            } else {
              if (isDef(data.attrs)) mergeProps(props, data.attrs);
              if (isDef(data.props)) mergeProps(props, data.props);
            }
            var renderContext = new FunctionalRenderContext(
              data,
              props,
              children,
              contextVm,
              Ctor
            );
            var vnode = options.render.call(
              null,
              renderContext._c,
              renderContext
            );
            if (vnode instanceof VNode) {
              return cloneAndMarkFunctionalResult(
                vnode,
                data,
                renderContext.parent,
                options,
                renderContext
              );
            } else if (isArray(vnode)) {
              var vnodes = normalizeChildren(vnode) || [];
              var res = new Array(vnodes.length);
              for (var i = 0; i < vnodes.length; i++) {
                res[i] = cloneAndMarkFunctionalResult(
                  vnodes[i],
                  data,
                  renderContext.parent,
                  options,
                  renderContext
                );
              }
              return res;
            }
          }
          function cloneAndMarkFunctionalResult(
            vnode,
            data,
            contextVm,
            options,
            renderContext
          ) {
            // #7817 clone node before setting fnContext, otherwise if the node is reused
            // (e.g. it was from a cached normal slot) the fnContext causes named slots
            // that should not be matched to match.
            var clone = cloneVNode(vnode);
            clone.fnContext = contextVm;
            clone.fnOptions = options;
            {
              (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext =
                renderContext;
            }
            if (data.slot) {
              (clone.data || (clone.data = {})).slot = data.slot;
            }
            return clone;
          }
          function mergeProps(to, from) {
            for (var key in from) {
              to[camelize(key)] = from[key];
            }
          }

          function getComponentName(options) {
            return options.name || options.__name || options._componentTag;
          }
          // inline hooks to be invoked on component VNodes during patch
          var componentVNodeHooks = {
            init: function (vnode, hydrating) {
              if (
                vnode.componentInstance &&
                !vnode.componentInstance._isDestroyed &&
                vnode.data.keepAlive
              ) {
                // kept-alive components, treat as a patch
                var mountedNode = vnode; // work around flow
                componentVNodeHooks.prepatch(mountedNode, mountedNode);
              } else {
                var child = (vnode.componentInstance =
                  createComponentInstanceForVnode(vnode, activeInstance));
                child.$mount(hydrating ? vnode.elm : undefined, hydrating);
              }
            },
            prepatch: function (oldVnode, vnode) {
              var options = vnode.componentOptions;
              var child = (vnode.componentInstance =
                oldVnode.componentInstance);
              updateChildComponent(
                child,
                options.propsData, // updated props
                options.listeners, // updated listeners
                vnode, // new parent vnode
                options.children // new children
              );
            },
            insert: function (vnode) {
              var context = vnode.context,
                componentInstance = vnode.componentInstance;
              if (!componentInstance._isMounted) {
                componentInstance._isMounted = true;
                callHook$1(componentInstance, "mounted");
              }
              if (vnode.data.keepAlive) {
                if (context._isMounted) {
                  // vue-router#1212
                  // During updates, a kept-alive component's child components may
                  // change, so directly walking the tree here may call activated hooks
                  // on incorrect children. Instead we push them into a queue which will
                  // be processed after the whole patch process ended.
                  queueActivatedComponent(componentInstance);
                } else {
                  activateChildComponent(componentInstance, true /* direct */);
                }
              }
            },
            destroy: function (vnode) {
              var componentInstance = vnode.componentInstance;
              if (!componentInstance._isDestroyed) {
                if (!vnode.data.keepAlive) {
                  componentInstance.$destroy();
                } else {
                  deactivateChildComponent(
                    componentInstance,
                    true /* direct */
                  );
                }
              }
            },
          };
          var hooksToMerge = Object.keys(componentVNodeHooks);
          function createComponent(Ctor, data, context, children, tag) {
            if (isUndef(Ctor)) {
              return;
            }
            var baseCtor = context.$options._base;
            // plain options object: turn it into a constructor
            if (isObject(Ctor)) {
              Ctor = baseCtor.extend(Ctor);
            }
            // if at this stage it's not a constructor or an async component factory,
            // reject.
            if (typeof Ctor !== "function") {
              {
                warn$2(
                  "Invalid Component definition: ".concat(String(Ctor)),
                  context
                );
              }
              return;
            }
            // async component
            var asyncFactory;
            // @ts-expect-error
            if (isUndef(Ctor.cid)) {
              asyncFactory = Ctor;
              Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
              if (Ctor === undefined) {
                // return a placeholder node for async component, which is rendered
                // as a comment node but preserves all the raw information for the node.
                // the information will be used for async server-rendering and hydration.
                return createAsyncPlaceholder(
                  asyncFactory,
                  data,
                  context,
                  children,
                  tag
                );
              }
            }
            data = data || {};
            // resolve constructor options in case global mixins are applied after
            // component constructor creation
            resolveConstructorOptions(Ctor);
            // transform component v-model data into props & events
            if (isDef(data.model)) {
              // @ts-expect-error
              transformModel(Ctor.options, data);
            }
            // extract props
            // @ts-expect-error
            var propsData = extractPropsFromVNodeData(data, Ctor, tag);
            // functional component
            // @ts-expect-error
            if (isTrue(Ctor.options.functional)) {
              return createFunctionalComponent(
                Ctor,
                propsData,
                data,
                context,
                children
              );
            }
            // extract listeners, since these needs to be treated as
            // child component listeners instead of DOM listeners
            var listeners = data.on;
            // replace with listeners with .native modifier
            // so it gets processed during parent component patch.
            data.on = data.nativeOn;
            // @ts-expect-error
            if (isTrue(Ctor.options.abstract)) {
              // abstract components do not keep anything
              // other than props & listeners & slot
              // work around flow
              var slot = data.slot;
              data = {};
              if (slot) {
                data.slot = slot;
              }
            }
            // install component management hooks onto the placeholder node
            installComponentHooks(data);
            // return a placeholder vnode
            // @ts-expect-error
            var name = getComponentName(Ctor.options) || tag;
            var vnode = new VNode(
              // @ts-expect-error
              "vue-component-"
                .concat(Ctor.cid)
                .concat(name ? "-".concat(name) : ""),
              data,
              undefined,
              undefined,
              undefined,
              context,
              // @ts-expect-error
              {
                Ctor: Ctor,
                propsData: propsData,
                listeners: listeners,
                tag: tag,
                children: children,
              },
              asyncFactory
            );
            return vnode;
          }
          function createComponentInstanceForVnode(
            // we know it's MountedComponentVNode but flow doesn't
            vnode,
            // activeInstance in lifecycle state
            parent
          ) {
            var options = {
              _isComponent: true,
              _parentVnode: vnode,
              parent: parent,
            };
            // check inline-template render functions
            var inlineTemplate = vnode.data.inlineTemplate;
            if (isDef(inlineTemplate)) {
              options.render = inlineTemplate.render;
              options.staticRenderFns = inlineTemplate.staticRenderFns;
            }
            return new vnode.componentOptions.Ctor(options);
          }
          function installComponentHooks(data) {
            var hooks = data.hook || (data.hook = {});
            for (var i = 0; i < hooksToMerge.length; i++) {
              var key = hooksToMerge[i];
              var existing = hooks[key];
              var toMerge = componentVNodeHooks[key];
              // @ts-expect-error
              if (existing !== toMerge && !(existing && existing._merged)) {
                hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
              }
            }
          }
          function mergeHook(f1, f2) {
            var merged = function (a, b) {
              // flow complains about extra args which is why we use any
              f1(a, b);
              f2(a, b);
            };
            merged._merged = true;
            return merged;
          }
          // transform component v-model info (value and callback) into
          // prop and event handler respectively.
          function transformModel(options, data) {
            var prop = (options.model && options.model.prop) || "value";
            var event = (options.model && options.model.event) || "input";
            (data.attrs || (data.attrs = {}))[prop] = data.model.value;
            var on = data.on || (data.on = {});
            var existing = on[event];
            var callback = data.model.callback;
            if (isDef(existing)) {
              if (
                isArray(existing)
                  ? existing.indexOf(callback) === -1
                  : existing !== callback
              ) {
                on[event] = [callback].concat(existing);
              }
            } else {
              on[event] = callback;
            }
          }

          var warn$2 = noop;
          var tip = noop;
          var generateComponentTrace; // work around flow check
          var formatComponentName;
          {
            var hasConsole_1 = typeof console !== "undefined";
            var classifyRE_1 = /(?:^|[-_])(\w)/g;
            var classify_1 = function (str) {
              return str
                .replace(classifyRE_1, function (c) {
                  return c.toUpperCase();
                })
                .replace(/[-_]/g, "");
            };
            warn$2 = function (msg, vm) {
              if (vm === void 0) {
                vm = currentInstance;
              }
              var trace = vm ? generateComponentTrace(vm) : "";
              if (config.warnHandler) {
                config.warnHandler.call(null, msg, vm, trace);
              } else if (hasConsole_1 && !config.silent) {
                console.error("[Vue warn]: ".concat(msg).concat(trace));
              }
            };
            tip = function (msg, vm) {
              if (hasConsole_1 && !config.silent) {
                console.warn(
                  "[Vue tip]: ".concat(msg) +
                    (vm ? generateComponentTrace(vm) : "")
                );
              }
            };
            formatComponentName = function (vm, includeFile) {
              if (vm.$root === vm) {
                return "<Root>";
              }
              var options =
                isFunction(vm) && vm.cid != null
                  ? vm.options
                  : vm._isVue
                  ? vm.$options || vm.constructor.options
                  : vm;
              var name = getComponentName(options);
              var file = options.__file;
              if (!name && file) {
                var match = file.match(/([^/\\]+)\.vue$/);
                name = match && match[1];
              }
              return (
                (name ? "<".concat(classify_1(name), ">") : "<Anonymous>") +
                (file && includeFile !== false ? " at ".concat(file) : "")
              );
            };
            var repeat_1 = function (str, n) {
              var res = "";
              while (n) {
                if (n % 2 === 1) res += str;
                if (n > 1) str += str;
                n >>= 1;
              }
              return res;
            };
            generateComponentTrace = function (vm) {
              if (vm._isVue && vm.$parent) {
                var tree = [];
                var currentRecursiveSequence = 0;
                while (vm) {
                  if (tree.length > 0) {
                    var last = tree[tree.length - 1];
                    if (last.constructor === vm.constructor) {
                      currentRecursiveSequence++;
                      vm = vm.$parent;
                      continue;
                    } else if (currentRecursiveSequence > 0) {
                      tree[tree.length - 1] = [last, currentRecursiveSequence];
                      currentRecursiveSequence = 0;
                    }
                  }
                  tree.push(vm);
                  vm = vm.$parent;
                }
                return (
                  "\n\nfound in\n\n" +
                  tree
                    .map(function (vm, i) {
                      return ""
                        .concat(i === 0 ? "---> " : repeat_1(" ", 5 + i * 2))
                        .concat(
                          isArray(vm)
                            ? ""
                                .concat(formatComponentName(vm[0]), "... (")
                                .concat(vm[1], " recursive calls)")
                            : formatComponentName(vm)
                        );
                    })
                    .join("\n")
                );
              } else {
                return "\n\n(found in ".concat(formatComponentName(vm), ")");
              }
            };
          }

          /**
           * Option overwriting strategies are functions that handle
           * how to merge a parent option value and a child option
           * value into the final value.
           */
          var strats = config.optionMergeStrategies;
          /**
           * Options with restrictions
           */
          {
            strats.el = strats.propsData = function (parent, child, vm, key) {
              if (!vm) {
                warn$2(
                  'option "'.concat(
                    key,
                    '" can only be used during instance '
                  ) + "creation with the `new` keyword."
                );
              }
              return defaultStrat(parent, child);
            };
          }
          /**
           * Helper that recursively merges two data objects together.
           */
          function mergeData(to, from, recursive) {
            if (recursive === void 0) {
              recursive = true;
            }
            if (!from) return to;
            var key, toVal, fromVal;
            var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
            for (var i = 0; i < keys.length; i++) {
              key = keys[i];
              // in case the object is already observed...
              if (key === "__ob__") continue;
              toVal = to[key];
              fromVal = from[key];
              if (!recursive || !hasOwn(to, key)) {
                set(to, key, fromVal);
              } else if (
                toVal !== fromVal &&
                isPlainObject(toVal) &&
                isPlainObject(fromVal)
              ) {
                mergeData(toVal, fromVal);
              }
            }
            return to;
          }
          /**
           * Data
           */
          function mergeDataOrFn(parentVal, childVal, vm) {
            if (!vm) {
              // in a Vue.extend merge, both should be functions
              if (!childVal) {
                return parentVal;
              }
              if (!parentVal) {
                return childVal;
              }
              // when parentVal & childVal are both present,
              // we need to return a function that returns the
              // merged result of both functions... no need to
              // check if parentVal is a function here because
              // it has to be a function to pass previous merges.
              return function mergedDataFn() {
                return mergeData(
                  isFunction(childVal) ? childVal.call(this, this) : childVal,
                  isFunction(parentVal) ? parentVal.call(this, this) : parentVal
                );
              };
            } else {
              return function mergedInstanceDataFn() {
                // instance merge
                var instanceData = isFunction(childVal)
                  ? childVal.call(vm, vm)
                  : childVal;
                var defaultData = isFunction(parentVal)
                  ? parentVal.call(vm, vm)
                  : parentVal;
                if (instanceData) {
                  return mergeData(instanceData, defaultData);
                } else {
                  return defaultData;
                }
              };
            }
          }
          strats.data = function (parentVal, childVal, vm) {
            if (!vm) {
              if (childVal && typeof childVal !== "function") {
                warn$2(
                  'The "data" option should be a function ' +
                    "that returns a per-instance value in component " +
                    "definitions.",
                  vm
                );
                return parentVal;
              }
              return mergeDataOrFn(parentVal, childVal);
            }
            return mergeDataOrFn(parentVal, childVal, vm);
          };
          /**
           * Hooks and props are merged as arrays.
           */
          function mergeLifecycleHook(parentVal, childVal) {
            var res = childVal
              ? parentVal
                ? parentVal.concat(childVal)
                : isArray(childVal)
                ? childVal
                : [childVal]
              : parentVal;
            return res ? dedupeHooks(res) : res;
          }
          function dedupeHooks(hooks) {
            var res = [];
            for (var i = 0; i < hooks.length; i++) {
              if (res.indexOf(hooks[i]) === -1) {
                res.push(hooks[i]);
              }
            }
            return res;
          }
          LIFECYCLE_HOOKS.forEach(function (hook) {
            strats[hook] = mergeLifecycleHook;
          });
          /**
           * Assets
           *
           * When a vm is present (instance creation), we need to do
           * a three-way merge between constructor options, instance
           * options and parent options.
           */
          function mergeAssets(parentVal, childVal, vm, key) {
            var res = Object.create(parentVal || null);
            if (childVal) {
              assertObjectType(key, childVal, vm);
              return extend(res, childVal);
            } else {
              return res;
            }
          }
          ASSET_TYPES.forEach(function (type) {
            strats[type + "s"] = mergeAssets;
          });
          /**
           * Watchers.
           *
           * Watchers hashes should not overwrite one
           * another, so we merge them as arrays.
           */
          strats.watch = function (parentVal, childVal, vm, key) {
            // work around Firefox's Object.prototype.watch...
            //@ts-expect-error work around
            if (parentVal === nativeWatch) parentVal = undefined;
            //@ts-expect-error work around
            if (childVal === nativeWatch) childVal = undefined;
            /* istanbul ignore if */
            if (!childVal) return Object.create(parentVal || null);
            {
              assertObjectType(key, childVal, vm);
            }
            if (!parentVal) return childVal;
            var ret = {};
            extend(ret, parentVal);
            for (var key_1 in childVal) {
              var parent_1 = ret[key_1];
              var child = childVal[key_1];
              if (parent_1 && !isArray(parent_1)) {
                parent_1 = [parent_1];
              }
              ret[key_1] = parent_1
                ? parent_1.concat(child)
                : isArray(child)
                ? child
                : [child];
            }
            return ret;
          };
          /**
           * Other object hashes.
           */
          strats.props =
            strats.methods =
            strats.inject =
            strats.computed =
              function (parentVal, childVal, vm, key) {
                if (childVal && true) {
                  assertObjectType(key, childVal, vm);
                }
                if (!parentVal) return childVal;
                var ret = Object.create(null);
                extend(ret, parentVal);
                if (childVal) extend(ret, childVal);
                return ret;
              };
          strats.provide = function (parentVal, childVal) {
            if (!parentVal) return childVal;
            return function () {
              var ret = Object.create(null);
              mergeData(
                ret,
                isFunction(parentVal) ? parentVal.call(this) : parentVal
              );
              if (childVal) {
                mergeData(
                  ret,
                  isFunction(childVal) ? childVal.call(this) : childVal,
                  false // non-recursive
                );
              }
              return ret;
            };
          };
          /**
           * Default strategy.
           */
          var defaultStrat = function (parentVal, childVal) {
            return childVal === undefined ? parentVal : childVal;
          };
          /**
           * Validate component names
           */
          function checkComponents(options) {
            for (var key in options.components) {
              validateComponentName(key);
            }
          }
          function validateComponentName(name) {
            if (
              !new RegExp(
                "^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")
              ).test(name)
            ) {
              warn$2(
                'Invalid component name: "' +
                  name +
                  '". Component names ' +
                  "should conform to valid custom element name in html5 specification."
              );
            }
            if (isBuiltInTag(name) || config.isReservedTag(name)) {
              warn$2(
                "Do not use built-in or reserved HTML elements as component " +
                  "id: " +
                  name
              );
            }
          }
          /**
           * Ensure all props option syntax are normalized into the
           * Object-based format.
           */
          function normalizeProps(options, vm) {
            var props = options.props;
            if (!props) return;
            var res = {};
            var i, val, name;
            if (isArray(props)) {
              i = props.length;
              while (i--) {
                val = props[i];
                if (typeof val === "string") {
                  name = camelize(val);
                  res[name] = { type: null };
                } else {
                  warn$2("props must be strings when using array syntax.");
                }
              }
            } else if (isPlainObject(props)) {
              for (var key in props) {
                val = props[key];
                name = camelize(key);
                res[name] = isPlainObject(val) ? val : { type: val };
              }
            } else {
              warn$2(
                'Invalid value for option "props": expected an Array or an Object, ' +
                  "but got ".concat(toRawType(props), "."),
                vm
              );
            }
            options.props = res;
          }
          /**
           * Normalize all injections into Object-based format
           */
          function normalizeInject(options, vm) {
            var inject = options.inject;
            if (!inject) return;
            var normalized = (options.inject = {});
            if (isArray(inject)) {
              for (var i = 0; i < inject.length; i++) {
                normalized[inject[i]] = { from: inject[i] };
              }
            } else if (isPlainObject(inject)) {
              for (var key in inject) {
                var val = inject[key];
                normalized[key] = isPlainObject(val)
                  ? extend({ from: key }, val)
                  : { from: val };
              }
            } else {
              warn$2(
                'Invalid value for option "inject": expected an Array or an Object, ' +
                  "but got ".concat(toRawType(inject), "."),
                vm
              );
            }
          }
          /**
           * Normalize raw function directives into object format.
           */
          function normalizeDirectives$1(options) {
            var dirs = options.directives;
            if (dirs) {
              for (var key in dirs) {
                var def = dirs[key];
                if (isFunction(def)) {
                  dirs[key] = { bind: def, update: def };
                }
              }
            }
          }
          function assertObjectType(name, value, vm) {
            if (!isPlainObject(value)) {
              warn$2(
                'Invalid value for option "'.concat(
                  name,
                  '": expected an Object, '
                ) + "but got ".concat(toRawType(value), "."),
                vm
              );
            }
          }
          /**
           * Merge two option objects into a new one.
           * Core utility used in both instantiation and inheritance.
           */
          function mergeOptions(parent, child, vm) {
            {
              checkComponents(child);
            }
            if (isFunction(child)) {
              // @ts-expect-error
              child = child.options;
            }
            normalizeProps(child, vm);
            normalizeInject(child, vm);
            normalizeDirectives$1(child);
            // Apply extends and mixins on the child options,
            // but only if it is a raw options object that isn't
            // the result of another mergeOptions call.
            // Only merged options has the _base property.
            if (!child._base) {
              if (child.extends) {
                parent = mergeOptions(parent, child.extends, vm);
              }
              if (child.mixins) {
                for (var i = 0, l = child.mixins.length; i < l; i++) {
                  parent = mergeOptions(parent, child.mixins[i], vm);
                }
              }
            }
            var options = {};
            var key;
            for (key in parent) {
              mergeField(key);
            }
            for (key in child) {
              if (!hasOwn(parent, key)) {
                mergeField(key);
              }
            }
            function mergeField(key) {
              var strat = strats[key] || defaultStrat;
              options[key] = strat(parent[key], child[key], vm, key);
            }
            return options;
          }
          /**
           * Resolve an asset.
           * This function is used because child instances need access
           * to assets defined in its ancestor chain.
           */
          function resolveAsset(options, type, id, warnMissing) {
            /* istanbul ignore if */
            if (typeof id !== "string") {
              return;
            }
            var assets = options[type];
            // check local registration variations first
            if (hasOwn(assets, id)) return assets[id];
            var camelizedId = camelize(id);
            if (hasOwn(assets, camelizedId)) return assets[camelizedId];
            var PascalCaseId = capitalize(camelizedId);
            if (hasOwn(assets, PascalCaseId)) return assets[PascalCaseId];
            // fallback to prototype chain
            var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
            if (warnMissing && !res) {
              warn$2("Failed to resolve " + type.slice(0, -1) + ": " + id);
            }
            return res;
          }

          function validateProp(key, propOptions, propsData, vm) {
            var prop = propOptions[key];
            var absent = !hasOwn(propsData, key);
            var value = propsData[key];
            // boolean casting
            var booleanIndex = getTypeIndex(Boolean, prop.type);
            if (booleanIndex > -1) {
              if (absent && !hasOwn(prop, "default")) {
                value = false;
              } else if (value === "" || value === hyphenate(key)) {
                // only cast empty string / same name to boolean if
                // boolean has higher priority
                var stringIndex = getTypeIndex(String, prop.type);
                if (stringIndex < 0 || booleanIndex < stringIndex) {
                  value = true;
                }
              }
            }
            // check default value
            if (value === undefined) {
              value = getPropDefaultValue(vm, prop, key);
              // since the default value is a fresh copy,
              // make sure to observe it.
              var prevShouldObserve = shouldObserve;
              toggleObserving(true);
              observe(value);
              toggleObserving(prevShouldObserve);
            }
            {
              assertProp(prop, key, value, vm, absent);
            }
            return value;
          }
          /**
           * Get the default value of a prop.
           */
          function getPropDefaultValue(vm, prop, key) {
            // no default, return undefined
            if (!hasOwn(prop, "default")) {
              return undefined;
            }
            var def = prop.default;
            // warn against non-factory defaults for Object & Array
            if (isObject(def)) {
              warn$2(
                'Invalid default value for prop "' +
                  key +
                  '": ' +
                  "Props with type Object/Array must use a factory function " +
                  "to return the default value.",
                vm
              );
            }
            // the raw prop value was also undefined from previous render,
            // return previous default value to avoid unnecessary watcher trigger
            if (
              vm &&
              vm.$options.propsData &&
              vm.$options.propsData[key] === undefined &&
              vm._props[key] !== undefined
            ) {
              return vm._props[key];
            }
            // call factory function for non-Function types
            // a value is Function if its prototype is function even across different execution context
            return isFunction(def) && getType(prop.type) !== "Function"
              ? def.call(vm)
              : def;
          }
          /**
           * Assert whether a prop is valid.
           */
          function assertProp(prop, name, value, vm, absent) {
            if (prop.required && absent) {
              warn$2('Missing required prop: "' + name + '"', vm);
              return;
            }
            if (value == null && !prop.required) {
              return;
            }
            var type = prop.type;
            var valid = !type || type === true;
            var expectedTypes = [];
            if (type) {
              if (!isArray(type)) {
                type = [type];
              }
              for (var i = 0; i < type.length && !valid; i++) {
                var assertedType = assertType(value, type[i], vm);
                expectedTypes.push(assertedType.expectedType || "");
                valid = assertedType.valid;
              }
            }
            var haveExpectedTypes = expectedTypes.some(function (t) {
              return t;
            });
            if (!valid && haveExpectedTypes) {
              warn$2(getInvalidTypeMessage(name, value, expectedTypes), vm);
              return;
            }
            var validator = prop.validator;
            if (validator) {
              if (!validator(value)) {
                warn$2(
                  'Invalid prop: custom validator check failed for prop "' +
                    name +
                    '".',
                  vm
                );
              }
            }
          }
          var simpleCheckRE =
            /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
          function assertType(value, type, vm) {
            var valid;
            var expectedType = getType(type);
            if (simpleCheckRE.test(expectedType)) {
              var t = typeof value;
              valid = t === expectedType.toLowerCase();
              // for primitive wrapper objects
              if (!valid && t === "object") {
                valid = value instanceof type;
              }
            } else if (expectedType === "Object") {
              valid = isPlainObject(value);
            } else if (expectedType === "Array") {
              valid = isArray(value);
            } else {
              try {
                valid = value instanceof type;
              } catch (e) {
                warn$2(
                  'Invalid prop type: "' +
                    String(type) +
                    '" is not a constructor',
                  vm
                );
                valid = false;
              }
            }
            return {
              valid: valid,
              expectedType: expectedType,
            };
          }
          var functionTypeCheckRE = /^\s*function (\w+)/;
          /**
           * Use function string name to check built-in types,
           * because a simple equality check will fail when running
           * across different vms / iframes.
           */
          function getType(fn) {
            var match = fn && fn.toString().match(functionTypeCheckRE);
            return match ? match[1] : "";
          }
          function isSameType(a, b) {
            return getType(a) === getType(b);
          }
          function getTypeIndex(type, expectedTypes) {
            if (!isArray(expectedTypes)) {
              return isSameType(expectedTypes, type) ? 0 : -1;
            }
            for (var i = 0, len = expectedTypes.length; i < len; i++) {
              if (isSameType(expectedTypes[i], type)) {
                return i;
              }
            }
            return -1;
          }
          function getInvalidTypeMessage(name, value, expectedTypes) {
            var message =
              'Invalid prop: type check failed for prop "'.concat(name, '".') +
              " Expected ".concat(expectedTypes.map(capitalize).join(", "));
            var expectedType = expectedTypes[0];
            var receivedType = toRawType(value);
            // check if we need to specify expected value
            if (
              expectedTypes.length === 1 &&
              isExplicable(expectedType) &&
              isExplicable(typeof value) &&
              !isBoolean(expectedType, receivedType)
            ) {
              message += " with value ".concat(styleValue(value, expectedType));
            }
            message += ", got ".concat(receivedType, " ");
            // check if we need to specify received value
            if (isExplicable(receivedType)) {
              message += "with value ".concat(
                styleValue(value, receivedType),
                "."
              );
            }
            return message;
          }
          function styleValue(value, type) {
            if (type === "String") {
              return '"'.concat(value, '"');
            } else if (type === "Number") {
              return "".concat(Number(value));
            } else {
              return "".concat(value);
            }
          }
          var EXPLICABLE_TYPES = ["string", "number", "boolean"];
          function isExplicable(value) {
            return EXPLICABLE_TYPES.some(function (elem) {
              return value.toLowerCase() === elem;
            });
          }
          function isBoolean() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
            }
            return args.some(function (elem) {
              return elem.toLowerCase() === "boolean";
            });
          }

          function Vue(options) {
            if (!(this instanceof Vue)) {
              warn$2(
                "Vue is a constructor and should be called with the `new` keyword"
              );
            }
            this._init(options);
          }
          //@ts-expect-error Vue has function type
          initMixin$1(Vue);
          //@ts-expect-error Vue has function type
          stateMixin(Vue);
          //@ts-expect-error Vue has function type
          eventsMixin(Vue);
          //@ts-expect-error Vue has function type
          lifecycleMixin(Vue);
          //@ts-expect-error Vue has function type
          renderMixin(Vue);

          function initUse(Vue) {
            Vue.use = function (plugin) {
              var installedPlugins =
                this._installedPlugins || (this._installedPlugins = []);
              if (installedPlugins.indexOf(plugin) > -1) {
                return this;
              }
              // additional parameters
              var args = toArray(arguments, 1);
              args.unshift(this);
              if (isFunction(plugin.install)) {
                plugin.install.apply(plugin, args);
              } else if (isFunction(plugin)) {
                plugin.apply(null, args);
              }
              installedPlugins.push(plugin);
              return this;
            };
          }

          function initMixin(Vue) {
            Vue.mixin = function (mixin) {
              this.options = mergeOptions(this.options, mixin);
              return this;
            };
          }

          function initExtend(Vue) {
            /**
             * Each instance constructor, including Vue, has a unique
             * cid. This enables us to create wrapped "child
             * constructors" for prototypal inheritance and cache them.
             */
            Vue.cid = 0;
            var cid = 1;
            /**
             * Class inheritance
             */
            Vue.extend = function (extendOptions) {
              extendOptions = extendOptions || {};
              var Super = this;
              var SuperId = Super.cid;
              var cachedCtors =
                extendOptions._Ctor || (extendOptions._Ctor = {});
              if (cachedCtors[SuperId]) {
                return cachedCtors[SuperId];
              }
              var name =
                getComponentName(extendOptions) ||
                getComponentName(Super.options);
              if (name) {
                validateComponentName(name);
              }
              var Sub = function VueComponent(options) {
                this._init(options);
              };
              Sub.prototype = Object.create(Super.prototype);
              Sub.prototype.constructor = Sub;
              Sub.cid = cid++;
              Sub.options = mergeOptions(Super.options, extendOptions);
              Sub["super"] = Super;
              // For props and computed properties, we define the proxy getters on
              // the Vue instances at extension time, on the extended prototype. This
              // avoids Object.defineProperty calls for each instance created.
              if (Sub.options.props) {
                initProps(Sub);
              }
              if (Sub.options.computed) {
                initComputed(Sub);
              }
              // allow further extension/mixin/plugin usage
              Sub.extend = Super.extend;
              Sub.mixin = Super.mixin;
              Sub.use = Super.use;
              // create asset registers, so extended classes
              // can have their private assets too.
              ASSET_TYPES.forEach(function (type) {
                Sub[type] = Super[type];
              });
              // enable recursive self-lookup
              if (name) {
                Sub.options.components[name] = Sub;
              }
              // keep a reference to the super options at extension time.
              // later at instantiation we can check if Super's options have
              // been updated.
              Sub.superOptions = Super.options;
              Sub.extendOptions = extendOptions;
              Sub.sealedOptions = extend({}, Sub.options);
              // cache constructor
              cachedCtors[SuperId] = Sub;
              return Sub;
            };
          }
          function initProps(Comp) {
            var props = Comp.options.props;
            for (var key in props) {
              proxy(Comp.prototype, "_props", key);
            }
          }
          function initComputed(Comp) {
            var computed = Comp.options.computed;
            for (var key in computed) {
              defineComputed(Comp.prototype, key, computed[key]);
            }
          }

          function initAssetRegisters(Vue) {
            /**
             * Create asset registration methods.
             */
            ASSET_TYPES.forEach(function (type) {
              // @ts-expect-error function is not exact same type
              Vue[type] = function (id, definition) {
                if (!definition) {
                  return this.options[type + "s"][id];
                } else {
                  /* istanbul ignore if */
                  if (type === "component") {
                    validateComponentName(id);
                  }
                  if (type === "component" && isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                  }
                  if (type === "directive" && isFunction(definition)) {
                    definition = { bind: definition, update: definition };
                  }
                  this.options[type + "s"][id] = definition;
                  return definition;
                }
              };
            });
          }

          function _getComponentName(opts) {
            return opts && (getComponentName(opts.Ctor.options) || opts.tag);
          }
          function matches(pattern, name) {
            if (isArray(pattern)) {
              return pattern.indexOf(name) > -1;
            } else if (typeof pattern === "string") {
              return pattern.split(",").indexOf(name) > -1;
            } else if (isRegExp(pattern)) {
              return pattern.test(name);
            }
            /* istanbul ignore next */
            return false;
          }
          function pruneCache(keepAliveInstance, filter) {
            var cache = keepAliveInstance.cache,
              keys = keepAliveInstance.keys,
              _vnode = keepAliveInstance._vnode;
            for (var key in cache) {
              var entry = cache[key];
              if (entry) {
                var name_1 = entry.name;
                if (name_1 && !filter(name_1)) {
                  pruneCacheEntry(cache, key, keys, _vnode);
                }
              }
            }
          }
          function pruneCacheEntry(cache, key, keys, current) {
            var entry = cache[key];
            if (entry && (!current || entry.tag !== current.tag)) {
              // @ts-expect-error can be undefined
              entry.componentInstance.$destroy();
            }
            cache[key] = null;
            remove$2(keys, key);
          }
          var patternTypes = [String, RegExp, Array];
          // TODO defineComponent
          var KeepAlive = {
            name: "keep-alive",
            abstract: true,
            props: {
              include: patternTypes,
              exclude: patternTypes,
              max: [String, Number],
            },
            methods: {
              cacheVNode: function () {
                var _a = this,
                  cache = _a.cache,
                  keys = _a.keys,
                  vnodeToCache = _a.vnodeToCache,
                  keyToCache = _a.keyToCache;
                if (vnodeToCache) {
                  var tag = vnodeToCache.tag,
                    componentInstance = vnodeToCache.componentInstance,
                    componentOptions = vnodeToCache.componentOptions;
                  cache[keyToCache] = {
                    name: _getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance,
                  };
                  keys.push(keyToCache);
                  // prune oldest entry
                  if (this.max && keys.length > parseInt(this.max)) {
                    pruneCacheEntry(cache, keys[0], keys, this._vnode);
                  }
                  this.vnodeToCache = null;
                }
              },
            },
            created: function () {
              this.cache = Object.create(null);
              this.keys = [];
            },
            destroyed: function () {
              for (var key in this.cache) {
                pruneCacheEntry(this.cache, key, this.keys);
              }
            },
            mounted: function () {
              var _this = this;
              this.cacheVNode();
              this.$watch("include", function (val) {
                pruneCache(_this, function (name) {
                  return matches(val, name);
                });
              });
              this.$watch("exclude", function (val) {
                pruneCache(_this, function (name) {
                  return !matches(val, name);
                });
              });
            },
            updated: function () {
              this.cacheVNode();
            },
            render: function () {
              var slot = this.$slots.default;
              var vnode = getFirstComponentChild(slot);
              var componentOptions = vnode && vnode.componentOptions;
              if (componentOptions) {
                // check pattern
                var name_2 = _getComponentName(componentOptions);
                var _a = this,
                  include = _a.include,
                  exclude = _a.exclude;
                if (
                  // not included
                  (include && (!name_2 || !matches(include, name_2))) ||
                  // excluded
                  (exclude && name_2 && matches(exclude, name_2))
                ) {
                  return vnode;
                }
                var _b = this,
                  cache = _b.cache,
                  keys = _b.keys;
                var key =
                  vnode.key == null
                    ? // same constructor may get registered as different local components
                      // so cid alone is not enough (#3269)
                      componentOptions.Ctor.cid +
                      (componentOptions.tag
                        ? "::".concat(componentOptions.tag)
                        : "")
                    : vnode.key;
                if (cache[key]) {
                  vnode.componentInstance = cache[key].componentInstance;
                  // make current key freshest
                  remove$2(keys, key);
                  keys.push(key);
                } else {
                  // delay setting the cache until update
                  this.vnodeToCache = vnode;
                  this.keyToCache = key;
                }
                // @ts-expect-error can vnode.data can be undefined
                vnode.data.keepAlive = true;
              }
              return vnode || (slot && slot[0]);
            },
          };

          var builtInComponents = {
            KeepAlive: KeepAlive,
          };

          function initGlobalAPI(Vue) {
            // config
            var configDef = {};
            configDef.get = function () {
              return config;
            };
            {
              configDef.set = function () {
                warn$2(
                  "Do not replace the Vue.config object, set individual fields instead."
                );
              };
            }
            Object.defineProperty(Vue, "config", configDef);
            // exposed util methods.
            // NOTE: these are not considered part of the public API - avoid relying on
            // them unless you are aware of the risk.
            Vue.util = {
              warn: warn$2,
              extend: extend,
              mergeOptions: mergeOptions,
              defineReactive: defineReactive,
            };
            Vue.set = set;
            Vue.delete = del;
            Vue.nextTick = nextTick;
            // 2.6 explicit observable API
            Vue.observable = function (obj) {
              observe(obj);
              return obj;
            };
            Vue.options = Object.create(null);
            ASSET_TYPES.forEach(function (type) {
              Vue.options[type + "s"] = Object.create(null);
            });
            // this is used to identify the "base" constructor to extend all plain-object
            // components with in Weex's multi-instance scenarios.
            Vue.options._base = Vue;
            extend(Vue.options.components, builtInComponents);
            initUse(Vue);
            initMixin(Vue);
            initExtend(Vue);
            initAssetRegisters(Vue);
          }

          initGlobalAPI(Vue);
          Object.defineProperty(Vue.prototype, "$isServer", {
            get: isServerRendering,
          });
          Object.defineProperty(Vue.prototype, "$ssrContext", {
            get: function () {
              /* istanbul ignore next */
              return this.$vnode && this.$vnode.ssrContext;
            },
          });
          // expose FunctionalRenderContext for ssr runtime helper installation
          Object.defineProperty(Vue, "FunctionalRenderContext", {
            value: FunctionalRenderContext,
          });
          Vue.version = version;

          // these are reserved for web because they are directly compiled away
          // during template compilation
          var isReservedAttr = makeMap("style,class");
          // attributes that should be using props for binding
          var acceptValue = makeMap("input,textarea,option,select,progress");
          var mustUseProp = function (tag, type, attr) {
            return (
              (attr === "value" && acceptValue(tag) && type !== "button") ||
              (attr === "selected" && tag === "option") ||
              (attr === "checked" && tag === "input") ||
              (attr === "muted" && tag === "video")
            );
          };
          var isEnumeratedAttr = makeMap(
            "contenteditable,draggable,spellcheck"
          );
          var isValidContentEditableValue = makeMap(
            "events,caret,typing,plaintext-only"
          );
          var convertEnumeratedValue = function (key, value) {
            return isFalsyAttrValue(value) || value === "false"
              ? "false"
              : // allow arbitrary string value for contenteditable
              key === "contenteditable" && isValidContentEditableValue(value)
              ? value
              : "true";
          };
          var isBooleanAttr = makeMap(
            "allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare," +
              "default,defaultchecked,defaultmuted,defaultselected,defer,disabled," +
              "enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple," +
              "muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly," +
              "required,reversed,scoped,seamless,selected,sortable," +
              "truespeed,typemustmatch,visible"
          );
          var xlinkNS = "http://www.w3.org/1999/xlink";
          var isXlink = function (name) {
            return name.charAt(5) === ":" && name.slice(0, 5) === "xlink";
          };
          var getXlinkProp = function (name) {
            return isXlink(name) ? name.slice(6, name.length) : "";
          };
          var isFalsyAttrValue = function (val) {
            return val == null || val === false;
          };

          function genClassForVnode(vnode) {
            var data = vnode.data;
            var parentNode = vnode;
            var childNode = vnode;
            while (isDef(childNode.componentInstance)) {
              childNode = childNode.componentInstance._vnode;
              if (childNode && childNode.data) {
                data = mergeClassData(childNode.data, data);
              }
            }
            // @ts-expect-error parentNode.parent not VNodeWithData
            while (isDef((parentNode = parentNode.parent))) {
              if (parentNode && parentNode.data) {
                data = mergeClassData(data, parentNode.data);
              }
            }
            return renderClass(data.staticClass, data.class);
          }
          function mergeClassData(child, parent) {
            return {
              staticClass: concat(child.staticClass, parent.staticClass),
              class: isDef(child.class)
                ? [child.class, parent.class]
                : parent.class,
            };
          }
          function renderClass(staticClass, dynamicClass) {
            if (isDef(staticClass) || isDef(dynamicClass)) {
              return concat(staticClass, stringifyClass(dynamicClass));
            }
            /* istanbul ignore next */
            return "";
          }
          function concat(a, b) {
            return a ? (b ? a + " " + b : a) : b || "";
          }
          function stringifyClass(value) {
            if (Array.isArray(value)) {
              return stringifyArray(value);
            }
            if (isObject(value)) {
              return stringifyObject(value);
            }
            if (typeof value === "string") {
              return value;
            }
            /* istanbul ignore next */
            return "";
          }
          function stringifyArray(value) {
            var res = "";
            var stringified;
            for (var i = 0, l = value.length; i < l; i++) {
              if (
                isDef((stringified = stringifyClass(value[i]))) &&
                stringified !== ""
              ) {
                if (res) res += " ";
                res += stringified;
              }
            }
            return res;
          }
          function stringifyObject(value) {
            var res = "";
            for (var key in value) {
              if (value[key]) {
                if (res) res += " ";
                res += key;
              }
            }
            return res;
          }

          var namespaceMap = {
            svg: "http://www.w3.org/2000/svg",
            math: "http://www.w3.org/1998/Math/MathML",
          };
          var isHTMLTag = makeMap(
            "html,body,base,head,link,meta,style,title," +
              "address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section," +
              "div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul," +
              "a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby," +
              "s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video," +
              "embed,object,param,source,canvas,script,noscript,del,ins," +
              "caption,col,colgroup,table,thead,tbody,td,th,tr," +
              "button,datalist,fieldset,form,input,label,legend,meter,optgroup,option," +
              "output,progress,select,textarea," +
              "details,dialog,menu,menuitem,summary," +
              "content,element,shadow,template,blockquote,iframe,tfoot"
          );
          // this map is intentionally selective, only covering SVG elements that may
          // contain child elements.
          var isSVG = makeMap(
            "svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face," +
              "foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern," +
              "polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",
            true
          );
          var isPreTag = function (tag) {
            return tag === "pre";
          };
          var isReservedTag = function (tag) {
            return isHTMLTag(tag) || isSVG(tag);
          };
          function getTagNamespace(tag) {
            if (isSVG(tag)) {
              return "svg";
            }
            // basic support for MathML
            // note it doesn't support other MathML elements being component roots
            if (tag === "math") {
              return "math";
            }
          }
          var unknownElementCache = Object.create(null);
          function isUnknownElement(tag) {
            /* istanbul ignore if */
            if (!inBrowser) {
              return true;
            }
            if (isReservedTag(tag)) {
              return false;
            }
            tag = tag.toLowerCase();
            /* istanbul ignore if */
            if (unknownElementCache[tag] != null) {
              return unknownElementCache[tag];
            }
            var el = document.createElement(tag);
            if (tag.indexOf("-") > -1) {
              // http://stackoverflow.com/a/28210364/1070244
              return (unknownElementCache[tag] =
                el.constructor === window.HTMLUnknownElement ||
                el.constructor === window.HTMLElement);
            } else {
              return (unknownElementCache[tag] = /HTMLUnknownElement/.test(
                el.toString()
              ));
            }
          }
          var isTextInputType = makeMap(
            "text,number,password,search,email,tel,url"
          );

          /**
           * Query an element selector if it's not an element already.
           */
          function query(el) {
            if (typeof el === "string") {
              var selected = document.querySelector(el);
              if (!selected) {
                warn$2("Cannot find element: " + el);
                return document.createElement("div");
              }
              return selected;
            } else {
              return el;
            }
          }

          function createElement(tagName, vnode) {
            var elm = document.createElement(tagName);
            if (tagName !== "select") {
              return elm;
            }
            // false or null will remove the attribute but undefined will not
            if (
              vnode.data &&
              vnode.data.attrs &&
              vnode.data.attrs.multiple !== undefined
            ) {
              elm.setAttribute("multiple", "multiple");
            }
            return elm;
          }
          function createElementNS(namespace, tagName) {
            return document.createElementNS(namespaceMap[namespace], tagName);
          }
          function createTextNode(text) {
            return document.createTextNode(text);
          }
          function createComment(text) {
            return document.createComment(text);
          }
          function insertBefore(parentNode, newNode, referenceNode) {
            parentNode.insertBefore(newNode, referenceNode);
          }
          function removeChild(node, child) {
            node.removeChild(child);
          }
          function appendChild(node, child) {
            node.appendChild(child);
          }
          function parentNode(node) {
            return node.parentNode;
          }
          function nextSibling(node) {
            return node.nextSibling;
          }
          function tagName(node) {
            return node.tagName;
          }
          function setTextContent(node, text) {
            node.textContent = text;
          }
          function setStyleScope(node, scopeId) {
            node.setAttribute(scopeId, "");
          }

          var nodeOps = /*#__PURE__*/ Object.freeze({
            __proto__: null,
            createElement: createElement,
            createElementNS: createElementNS,
            createTextNode: createTextNode,
            createComment: createComment,
            insertBefore: insertBefore,
            removeChild: removeChild,
            appendChild: appendChild,
            parentNode: parentNode,
            nextSibling: nextSibling,
            tagName: tagName,
            setTextContent: setTextContent,
            setStyleScope: setStyleScope,
          });

          var ref = {
            create: function (_, vnode) {
              registerRef(vnode);
            },
            update: function (oldVnode, vnode) {
              if (oldVnode.data.ref !== vnode.data.ref) {
                registerRef(oldVnode, true);
                registerRef(vnode);
              }
            },
            destroy: function (vnode) {
              registerRef(vnode, true);
            },
          };
          function registerRef(vnode, isRemoval) {
            var ref = vnode.data.ref;
            if (!isDef(ref)) return;
            var vm = vnode.context;
            var refValue = vnode.componentInstance || vnode.elm;
            var value = isRemoval ? null : refValue;
            var $refsValue = isRemoval ? undefined : refValue;
            if (isFunction(ref)) {
              invokeWithErrorHandling(
                ref,
                vm,
                [value],
                vm,
                "template ref function"
              );
              return;
            }
            var isFor = vnode.data.refInFor;
            var _isString = typeof ref === "string" || typeof ref === "number";
            var _isRef = isRef(ref);
            var refs = vm.$refs;
            if (_isString || _isRef) {
              if (isFor) {
                var existing = _isString ? refs[ref] : ref.value;
                if (isRemoval) {
                  isArray(existing) && remove$2(existing, refValue);
                } else {
                  if (!isArray(existing)) {
                    if (_isString) {
                      refs[ref] = [refValue];
                      setSetupRef(vm, ref, refs[ref]);
                    } else {
                      ref.value = [refValue];
                    }
                  } else if (!existing.includes(refValue)) {
                    existing.push(refValue);
                  }
                }
              } else if (_isString) {
                if (isRemoval && refs[ref] !== refValue) {
                  return;
                }
                refs[ref] = $refsValue;
                setSetupRef(vm, ref, value);
              } else if (_isRef) {
                if (isRemoval && ref.value !== refValue) {
                  return;
                }
                ref.value = value;
              } else {
                warn$2("Invalid template ref type: ".concat(typeof ref));
              }
            }
          }
          function setSetupRef(_a, key, val) {
            var _setupState = _a._setupState;
            if (_setupState && hasOwn(_setupState, key)) {
              if (isRef(_setupState[key])) {
                _setupState[key].value = val;
              } else {
                _setupState[key] = val;
              }
            }
          }

          /**
           * Virtual DOM patching algorithm based on Snabbdom by
           * Simon Friis Vindum (@paldepind)
           * Licensed under the MIT License
           * https://github.com/paldepind/snabbdom/blob/master/LICENSE
           *
           * modified by Evan You (@yyx990803)
           *
           * Not type-checking this because this file is perf-critical and the cost
           * of making flow understand it is not worth it.
           */
          var emptyNode = new VNode("", {}, []);
          var hooks = ["create", "activate", "update", "remove", "destroy"];
          function sameVnode(a, b) {
            return (
              a.key === b.key &&
              a.asyncFactory === b.asyncFactory &&
              ((a.tag === b.tag &&
                a.isComment === b.isComment &&
                isDef(a.data) === isDef(b.data) &&
                sameInputType(a, b)) ||
                (isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error)))
            );
          }
          function sameInputType(a, b) {
            if (a.tag !== "input") return true;
            var i;
            var typeA = isDef((i = a.data)) && isDef((i = i.attrs)) && i.type;
            var typeB = isDef((i = b.data)) && isDef((i = i.attrs)) && i.type;
            return (
              typeA === typeB ||
              (isTextInputType(typeA) && isTextInputType(typeB))
            );
          }
          function createKeyToOldIdx(children, beginIdx, endIdx) {
            var i, key;
            var map = {};
            for (i = beginIdx; i <= endIdx; ++i) {
              key = children[i].key;
              if (isDef(key)) map[key] = i;
            }
            return map;
          }
          function createPatchFunction(backend) {
            var i, j;
            var cbs = {};
            var modules = backend.modules,
              nodeOps = backend.nodeOps;
            for (i = 0; i < hooks.length; ++i) {
              cbs[hooks[i]] = [];
              for (j = 0; j < modules.length; ++j) {
                if (isDef(modules[j][hooks[i]])) {
                  cbs[hooks[i]].push(modules[j][hooks[i]]);
                }
              }
            }
            function emptyNodeAt(elm) {
              return new VNode(
                nodeOps.tagName(elm).toLowerCase(),
                {},
                [],
                undefined,
                elm
              );
            }
            function createRmCb(childElm, listeners) {
              function remove() {
                if (--remove.listeners === 0) {
                  removeNode(childElm);
                }
              }
              remove.listeners = listeners;
              return remove;
            }
            function removeNode(el) {
              var parent = nodeOps.parentNode(el);
              // element may have already been removed due to v-html / v-text
              if (isDef(parent)) {
                nodeOps.removeChild(parent, el);
              }
            }
            function isUnknownElement(vnode, inVPre) {
              return (
                !inVPre &&
                !vnode.ns &&
                !(
                  config.ignoredElements.length &&
                  config.ignoredElements.some(function (ignore) {
                    return isRegExp(ignore)
                      ? ignore.test(vnode.tag)
                      : ignore === vnode.tag;
                  })
                ) &&
                config.isUnknownElement(vnode.tag)
              );
            }
            var creatingElmInVPre = 0;
            function createElm(
              vnode,
              insertedVnodeQueue,
              parentElm,
              refElm,
              nested,
              ownerArray,
              index
            ) {
              if (isDef(vnode.elm) && isDef(ownerArray)) {
                // This vnode was used in a previous render!
                // now it's used as a new node, overwriting its elm would cause
                // potential patch errors down the road when it's used as an insertion
                // reference node. Instead, we clone the node on-demand before creating
                // associated DOM element for it.
                vnode = ownerArray[index] = cloneVNode(vnode);
              }
              vnode.isRootInsert = !nested; // for transition enter check
              if (
                createComponent(vnode, insertedVnodeQueue, parentElm, refElm)
              ) {
                return;
              }
              var data = vnode.data;
              var children = vnode.children;
              var tag = vnode.tag;
              if (isDef(tag)) {
                {
                  if (data && data.pre) {
                    creatingElmInVPre++;
                  }
                  if (isUnknownElement(vnode, creatingElmInVPre)) {
                    warn$2(
                      "Unknown custom element: <" +
                        tag +
                        "> - did you " +
                        "register the component correctly? For recursive components, " +
                        'make sure to provide the "name" option.',
                      vnode.context
                    );
                  }
                }
                vnode.elm = vnode.ns
                  ? nodeOps.createElementNS(vnode.ns, tag)
                  : nodeOps.createElement(tag, vnode);
                setScope(vnode);
                createChildren(vnode, children, insertedVnodeQueue);
                if (isDef(data)) {
                  invokeCreateHooks(vnode, insertedVnodeQueue);
                }
                insert(parentElm, vnode.elm, refElm);
                if (data && data.pre) {
                  creatingElmInVPre--;
                }
              } else if (isTrue(vnode.isComment)) {
                vnode.elm = nodeOps.createComment(vnode.text);
                insert(parentElm, vnode.elm, refElm);
              } else {
                vnode.elm = nodeOps.createTextNode(vnode.text);
                insert(parentElm, vnode.elm, refElm);
              }
            }
            function createComponent(
              vnode,
              insertedVnodeQueue,
              parentElm,
              refElm
            ) {
              var i = vnode.data;
              if (isDef(i)) {
                var isReactivated =
                  isDef(vnode.componentInstance) && i.keepAlive;
                if (isDef((i = i.hook)) && isDef((i = i.init))) {
                  i(vnode, false /* hydrating */);
                }
                // after calling the init hook, if the vnode is a child component
                // it should've created a child instance and mounted it. the child
                // component also has set the placeholder vnode's elm.
                // in that case we can just return the element and be done.
                if (isDef(vnode.componentInstance)) {
                  initComponent(vnode, insertedVnodeQueue);
                  insert(parentElm, vnode.elm, refElm);
                  if (isTrue(isReactivated)) {
                    reactivateComponent(
                      vnode,
                      insertedVnodeQueue,
                      parentElm,
                      refElm
                    );
                  }
                  return true;
                }
              }
            }
            function initComponent(vnode, insertedVnodeQueue) {
              if (isDef(vnode.data.pendingInsert)) {
                insertedVnodeQueue.push.apply(
                  insertedVnodeQueue,
                  vnode.data.pendingInsert
                );
                vnode.data.pendingInsert = null;
              }
              vnode.elm = vnode.componentInstance.$el;
              if (isPatchable(vnode)) {
                invokeCreateHooks(vnode, insertedVnodeQueue);
                setScope(vnode);
              } else {
                // empty component root.
                // skip all element-related modules except for ref (#3455)
                registerRef(vnode);
                // make sure to invoke the insert hook
                insertedVnodeQueue.push(vnode);
              }
            }
            function reactivateComponent(
              vnode,
              insertedVnodeQueue,
              parentElm,
              refElm
            ) {
              var i;
              // hack for #4339: a reactivated component with inner transition
              // does not trigger because the inner node's created hooks are not called
              // again. It's not ideal to involve module-specific logic in here but
              // there doesn't seem to be a better way to do it.
              var innerNode = vnode;
              while (innerNode.componentInstance) {
                innerNode = innerNode.componentInstance._vnode;
                if (isDef((i = innerNode.data)) && isDef((i = i.transition))) {
                  for (i = 0; i < cbs.activate.length; ++i) {
                    cbs.activate[i](emptyNode, innerNode);
                  }
                  insertedVnodeQueue.push(innerNode);
                  break;
                }
              }
              // unlike a newly created component,
              // a reactivated keep-alive component doesn't insert itself
              insert(parentElm, vnode.elm, refElm);
            }
            function insert(parent, elm, ref) {
              if (isDef(parent)) {
                if (isDef(ref)) {
                  if (nodeOps.parentNode(ref) === parent) {
                    nodeOps.insertBefore(parent, elm, ref);
                  }
                } else {
                  nodeOps.appendChild(parent, elm);
                }
              }
            }
            function createChildren(vnode, children, insertedVnodeQueue) {
              if (isArray(children)) {
                {
                  checkDuplicateKeys(children);
                }
                for (var i_1 = 0; i_1 < children.length; ++i_1) {
                  createElm(
                    children[i_1],
                    insertedVnodeQueue,
                    vnode.elm,
                    null,
                    true,
                    children,
                    i_1
                  );
                }
              } else if (isPrimitive(vnode.text)) {
                nodeOps.appendChild(
                  vnode.elm,
                  nodeOps.createTextNode(String(vnode.text))
                );
              }
            }
            function isPatchable(vnode) {
              while (vnode.componentInstance) {
                vnode = vnode.componentInstance._vnode;
              }
              return isDef(vnode.tag);
            }
            function invokeCreateHooks(vnode, insertedVnodeQueue) {
              for (var i_2 = 0; i_2 < cbs.create.length; ++i_2) {
                cbs.create[i_2](emptyNode, vnode);
              }
              i = vnode.data.hook; // Reuse variable
              if (isDef(i)) {
                if (isDef(i.create)) i.create(emptyNode, vnode);
                if (isDef(i.insert)) insertedVnodeQueue.push(vnode);
              }
            }
            // set scope id attribute for scoped CSS.
            // this is implemented as a special case to avoid the overhead
            // of going through the normal attribute patching process.
            function setScope(vnode) {
              var i;
              if (isDef((i = vnode.fnScopeId))) {
                nodeOps.setStyleScope(vnode.elm, i);
              } else {
                var ancestor = vnode;
                while (ancestor) {
                  if (
                    isDef((i = ancestor.context)) &&
                    isDef((i = i.$options._scopeId))
                  ) {
                    nodeOps.setStyleScope(vnode.elm, i);
                  }
                  ancestor = ancestor.parent;
                }
              }
              // for slot content they should also get the scopeId from the host instance.
              if (
                isDef((i = activeInstance)) &&
                i !== vnode.context &&
                i !== vnode.fnContext &&
                isDef((i = i.$options._scopeId))
              ) {
                nodeOps.setStyleScope(vnode.elm, i);
              }
            }
            function addVnodes(
              parentElm,
              refElm,
              vnodes,
              startIdx,
              endIdx,
              insertedVnodeQueue
            ) {
              for (; startIdx <= endIdx; ++startIdx) {
                createElm(
                  vnodes[startIdx],
                  insertedVnodeQueue,
                  parentElm,
                  refElm,
                  false,
                  vnodes,
                  startIdx
                );
              }
            }
            function invokeDestroyHook(vnode) {
              var i, j;
              var data = vnode.data;
              if (isDef(data)) {
                if (isDef((i = data.hook)) && isDef((i = i.destroy))) i(vnode);
                for (i = 0; i < cbs.destroy.length; ++i) cbs.destroy[i](vnode);
              }
              if (isDef((i = vnode.children))) {
                for (j = 0; j < vnode.children.length; ++j) {
                  invokeDestroyHook(vnode.children[j]);
                }
              }
            }
            function removeVnodes(vnodes, startIdx, endIdx) {
              for (; startIdx <= endIdx; ++startIdx) {
                var ch = vnodes[startIdx];
                if (isDef(ch)) {
                  if (isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                  } else {
                    // Text node
                    removeNode(ch.elm);
                  }
                }
              }
            }
            function removeAndInvokeRemoveHook(vnode, rm) {
              if (isDef(rm) || isDef(vnode.data)) {
                var i_3;
                var listeners = cbs.remove.length + 1;
                if (isDef(rm)) {
                  // we have a recursively passed down rm callback
                  // increase the listeners count
                  rm.listeners += listeners;
                } else {
                  // directly removing
                  rm = createRmCb(vnode.elm, listeners);
                }
                // recursively invoke hooks on child component root node
                if (
                  isDef((i_3 = vnode.componentInstance)) &&
                  isDef((i_3 = i_3._vnode)) &&
                  isDef(i_3.data)
                ) {
                  removeAndInvokeRemoveHook(i_3, rm);
                }
                for (i_3 = 0; i_3 < cbs.remove.length; ++i_3) {
                  cbs.remove[i_3](vnode, rm);
                }
                if (
                  isDef((i_3 = vnode.data.hook)) &&
                  isDef((i_3 = i_3.remove))
                ) {
                  i_3(vnode, rm);
                } else {
                  rm();
                }
              } else {
                removeNode(vnode.elm);
              }
            }
            function updateChildren(
              parentElm,
              oldCh,
              newCh,
              insertedVnodeQueue,
              removeOnly
            ) {
              var oldStartIdx = 0;
              var newStartIdx = 0;
              var oldEndIdx = oldCh.length - 1;
              var oldStartVnode = oldCh[0];
              var oldEndVnode = oldCh[oldEndIdx];
              var newEndIdx = newCh.length - 1;
              var newStartVnode = newCh[0];
              var newEndVnode = newCh[newEndIdx];
              var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
              // removeOnly is a special flag used only by <transition-group>
              // to ensure removed elements stay in correct relative positions
              // during leaving transitions
              var canMove = !removeOnly;
              {
                checkDuplicateKeys(newCh);
              }
              while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
                if (isUndef(oldStartVnode)) {
                  oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
                } else if (isUndef(oldEndVnode)) {
                  oldEndVnode = oldCh[--oldEndIdx];
                } else if (sameVnode(oldStartVnode, newStartVnode)) {
                  patchVnode(
                    oldStartVnode,
                    newStartVnode,
                    insertedVnodeQueue,
                    newCh,
                    newStartIdx
                  );
                  oldStartVnode = oldCh[++oldStartIdx];
                  newStartVnode = newCh[++newStartIdx];
                } else if (sameVnode(oldEndVnode, newEndVnode)) {
                  patchVnode(
                    oldEndVnode,
                    newEndVnode,
                    insertedVnodeQueue,
                    newCh,
                    newEndIdx
                  );
                  oldEndVnode = oldCh[--oldEndIdx];
                  newEndVnode = newCh[--newEndIdx];
                } else if (sameVnode(oldStartVnode, newEndVnode)) {
                  // Vnode moved right
                  patchVnode(
                    oldStartVnode,
                    newEndVnode,
                    insertedVnodeQueue,
                    newCh,
                    newEndIdx
                  );
                  canMove &&
                    nodeOps.insertBefore(
                      parentElm,
                      oldStartVnode.elm,
                      nodeOps.nextSibling(oldEndVnode.elm)
                    );
                  oldStartVnode = oldCh[++oldStartIdx];
                  newEndVnode = newCh[--newEndIdx];
                } else if (sameVnode(oldEndVnode, newStartVnode)) {
                  // Vnode moved left
                  patchVnode(
                    oldEndVnode,
                    newStartVnode,
                    insertedVnodeQueue,
                    newCh,
                    newStartIdx
                  );
                  canMove &&
                    nodeOps.insertBefore(
                      parentElm,
                      oldEndVnode.elm,
                      oldStartVnode.elm
                    );
                  oldEndVnode = oldCh[--oldEndIdx];
                  newStartVnode = newCh[++newStartIdx];
                } else {
                  if (isUndef(oldKeyToIdx))
                    oldKeyToIdx = createKeyToOldIdx(
                      oldCh,
                      oldStartIdx,
                      oldEndIdx
                    );
                  idxInOld = isDef(newStartVnode.key)
                    ? oldKeyToIdx[newStartVnode.key]
                    : findIdxInOld(
                        newStartVnode,
                        oldCh,
                        oldStartIdx,
                        oldEndIdx
                      );
                  if (isUndef(idxInOld)) {
                    // New element
                    createElm(
                      newStartVnode,
                      insertedVnodeQueue,
                      parentElm,
                      oldStartVnode.elm,
                      false,
                      newCh,
                      newStartIdx
                    );
                  } else {
                    vnodeToMove = oldCh[idxInOld];
                    if (sameVnode(vnodeToMove, newStartVnode)) {
                      patchVnode(
                        vnodeToMove,
                        newStartVnode,
                        insertedVnodeQueue,
                        newCh,
                        newStartIdx
                      );
                      oldCh[idxInOld] = undefined;
                      canMove &&
                        nodeOps.insertBefore(
                          parentElm,
                          vnodeToMove.elm,
                          oldStartVnode.elm
                        );
                    } else {
                      // same key but different element. treat as new element
                      createElm(
                        newStartVnode,
                        insertedVnodeQueue,
                        parentElm,
                        oldStartVnode.elm,
                        false,
                        newCh,
                        newStartIdx
                      );
                    }
                  }
                  newStartVnode = newCh[++newStartIdx];
                }
              }
              if (oldStartIdx > oldEndIdx) {
                refElm = isUndef(newCh[newEndIdx + 1])
                  ? null
                  : newCh[newEndIdx + 1].elm;
                addVnodes(
                  parentElm,
                  refElm,
                  newCh,
                  newStartIdx,
                  newEndIdx,
                  insertedVnodeQueue
                );
              } else if (newStartIdx > newEndIdx) {
                removeVnodes(oldCh, oldStartIdx, oldEndIdx);
              }
            }
            function checkDuplicateKeys(children) {
              var seenKeys = {};
              for (var i_4 = 0; i_4 < children.length; i_4++) {
                var vnode = children[i_4];
                var key = vnode.key;
                if (isDef(key)) {
                  if (seenKeys[key]) {
                    warn$2(
                      "Duplicate keys detected: '".concat(
                        key,
                        "'. This may cause an update error."
                      ),
                      vnode.context
                    );
                  } else {
                    seenKeys[key] = true;
                  }
                }
              }
            }
            function findIdxInOld(node, oldCh, start, end) {
              for (var i_5 = start; i_5 < end; i_5++) {
                var c = oldCh[i_5];
                if (isDef(c) && sameVnode(node, c)) return i_5;
              }
            }
            function patchVnode(
              oldVnode,
              vnode,
              insertedVnodeQueue,
              ownerArray,
              index,
              removeOnly
            ) {
              if (oldVnode === vnode) {
                return;
              }
              if (isDef(vnode.elm) && isDef(ownerArray)) {
                // clone reused vnode
                vnode = ownerArray[index] = cloneVNode(vnode);
              }
              var elm = (vnode.elm = oldVnode.elm);
              if (isTrue(oldVnode.isAsyncPlaceholder)) {
                if (isDef(vnode.asyncFactory.resolved)) {
                  hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
                } else {
                  vnode.isAsyncPlaceholder = true;
                }
                return;
              }
              // reuse element for static trees.
              // note we only do this if the vnode is cloned -
              // if the new node is not cloned it means the render functions have been
              // reset by the hot-reload-api and we need to do a proper re-render.
              if (
                isTrue(vnode.isStatic) &&
                isTrue(oldVnode.isStatic) &&
                vnode.key === oldVnode.key &&
                (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
              ) {
                vnode.componentInstance = oldVnode.componentInstance;
                return;
              }
              var i;
              var data = vnode.data;
              if (
                isDef(data) &&
                isDef((i = data.hook)) &&
                isDef((i = i.prepatch))
              ) {
                i(oldVnode, vnode);
              }
              var oldCh = oldVnode.children;
              var ch = vnode.children;
              if (isDef(data) && isPatchable(vnode)) {
                for (i = 0; i < cbs.update.length; ++i)
                  cbs.update[i](oldVnode, vnode);
                if (isDef((i = data.hook)) && isDef((i = i.update)))
                  i(oldVnode, vnode);
              }
              if (isUndef(vnode.text)) {
                if (isDef(oldCh) && isDef(ch)) {
                  if (oldCh !== ch)
                    updateChildren(
                      elm,
                      oldCh,
                      ch,
                      insertedVnodeQueue,
                      removeOnly
                    );
                } else if (isDef(ch)) {
                  {
                    checkDuplicateKeys(ch);
                  }
                  if (isDef(oldVnode.text)) nodeOps.setTextContent(elm, "");
                  addVnodes(
                    elm,
                    null,
                    ch,
                    0,
                    ch.length - 1,
                    insertedVnodeQueue
                  );
                } else if (isDef(oldCh)) {
                  removeVnodes(oldCh, 0, oldCh.length - 1);
                } else if (isDef(oldVnode.text)) {
                  nodeOps.setTextContent(elm, "");
                }
              } else if (oldVnode.text !== vnode.text) {
                nodeOps.setTextContent(elm, vnode.text);
              }
              if (isDef(data)) {
                if (isDef((i = data.hook)) && isDef((i = i.postpatch)))
                  i(oldVnode, vnode);
              }
            }
            function invokeInsertHook(vnode, queue, initial) {
              // delay insert hooks for component root nodes, invoke them after the
              // element is really inserted
              if (isTrue(initial) && isDef(vnode.parent)) {
                vnode.parent.data.pendingInsert = queue;
              } else {
                for (var i_6 = 0; i_6 < queue.length; ++i_6) {
                  queue[i_6].data.hook.insert(queue[i_6]);
                }
              }
            }
            var hydrationBailed = false;
            // list of modules that can skip create hook during hydration because they
            // are already rendered on the client or has no need for initialization
            // Note: style is excluded because it relies on initial clone for future
            // deep updates (#7063).
            var isRenderedModule = makeMap(
              "attrs,class,staticClass,staticStyle,key"
            );
            // Note: this is a browser-only function so we can assume elms are DOM nodes.
            function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
              var i;
              var tag = vnode.tag,
                data = vnode.data,
                children = vnode.children;
              inVPre = inVPre || (data && data.pre);
              vnode.elm = elm;
              if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
                vnode.isAsyncPlaceholder = true;
                return true;
              }
              // assert node match
              {
                if (!assertNodeMatch(elm, vnode, inVPre)) {
                  return false;
                }
              }
              if (isDef(data)) {
                if (isDef((i = data.hook)) && isDef((i = i.init)))
                  i(vnode, true /* hydrating */);
                if (isDef((i = vnode.componentInstance))) {
                  // child component. it should have hydrated its own tree.
                  initComponent(vnode, insertedVnodeQueue);
                  return true;
                }
              }
              if (isDef(tag)) {
                if (isDef(children)) {
                  // empty element, allow client to pick up and populate children
                  if (!elm.hasChildNodes()) {
                    createChildren(vnode, children, insertedVnodeQueue);
                  } else {
                    // v-html and domProps: innerHTML
                    if (
                      isDef((i = data)) &&
                      isDef((i = i.domProps)) &&
                      isDef((i = i.innerHTML))
                    ) {
                      if (i !== elm.innerHTML) {
                        /* istanbul ignore if */
                        if (
                          typeof console !== "undefined" &&
                          !hydrationBailed
                        ) {
                          hydrationBailed = true;
                          console.warn("Parent: ", elm);
                          console.warn("server innerHTML: ", i);
                          console.warn("client innerHTML: ", elm.innerHTML);
                        }
                        return false;
                      }
                    } else {
                      // iterate and compare children lists
                      var childrenMatch = true;
                      var childNode = elm.firstChild;
                      for (var i_7 = 0; i_7 < children.length; i_7++) {
                        if (
                          !childNode ||
                          !hydrate(
                            childNode,
                            children[i_7],
                            insertedVnodeQueue,
                            inVPre
                          )
                        ) {
                          childrenMatch = false;
                          break;
                        }
                        childNode = childNode.nextSibling;
                      }
                      // if childNode is not null, it means the actual childNodes list is
                      // longer than the virtual children list.
                      if (!childrenMatch || childNode) {
                        /* istanbul ignore if */
                        if (
                          typeof console !== "undefined" &&
                          !hydrationBailed
                        ) {
                          hydrationBailed = true;
                          console.warn("Parent: ", elm);
                          console.warn(
                            "Mismatching childNodes vs. VNodes: ",
                            elm.childNodes,
                            children
                          );
                        }
                        return false;
                      }
                    }
                  }
                }
                if (isDef(data)) {
                  var fullInvoke = false;
                  for (var key in data) {
                    if (!isRenderedModule(key)) {
                      fullInvoke = true;
                      invokeCreateHooks(vnode, insertedVnodeQueue);
                      break;
                    }
                  }
                  if (!fullInvoke && data["class"]) {
                    // ensure collecting deps for deep class bindings for future updates
                    traverse(data["class"]);
                  }
                }
              } else if (elm.data !== vnode.text) {
                elm.data = vnode.text;
              }
              return true;
            }
            function assertNodeMatch(node, vnode, inVPre) {
              if (isDef(vnode.tag)) {
                return (
                  vnode.tag.indexOf("vue-component") === 0 ||
                  (!isUnknownElement(vnode, inVPre) &&
                    vnode.tag.toLowerCase() ===
                      (node.tagName && node.tagName.toLowerCase()))
                );
              } else {
                return node.nodeType === (vnode.isComment ? 8 : 3);
              }
            }
            return function patch(oldVnode, vnode, hydrating, removeOnly) {
              if (isUndef(vnode)) {
                if (isDef(oldVnode)) invokeDestroyHook(oldVnode);
                return;
              }
              var isInitialPatch = false;
              var insertedVnodeQueue = [];
              if (isUndef(oldVnode)) {
                // empty mount (likely as component), create new root element
                isInitialPatch = true;
                createElm(vnode, insertedVnodeQueue);
              } else {
                var isRealElement = isDef(oldVnode.nodeType);
                if (!isRealElement && sameVnode(oldVnode, vnode)) {
                  // patch existing root node
                  patchVnode(
                    oldVnode,
                    vnode,
                    insertedVnodeQueue,
                    null,
                    null,
                    removeOnly
                  );
                } else {
                  if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (
                      oldVnode.nodeType === 1 &&
                      oldVnode.hasAttribute(SSR_ATTR)
                    ) {
                      oldVnode.removeAttribute(SSR_ATTR);
                      hydrating = true;
                    }
                    if (isTrue(hydrating)) {
                      if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                        invokeInsertHook(vnode, insertedVnodeQueue, true);
                        return oldVnode;
                      } else {
                        warn$2(
                          "The client-side rendered virtual DOM tree is not matching " +
                            "server-rendered content. This is likely caused by incorrect " +
                            "HTML markup, for example nesting block-level elements inside " +
                            "<p>, or missing <tbody>. Bailing hydration and performing " +
                            "full client-side render."
                        );
                      }
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                  }
                  // replacing existing element
                  var oldElm = oldVnode.elm;
                  var parentElm = nodeOps.parentNode(oldElm);
                  // create new node
                  createElm(
                    vnode,
                    insertedVnodeQueue,
                    // extremely rare edge case: do not insert if old element is in a
                    // leaving transition. Only happens when combining transition +
                    // keep-alive + HOCs. (#4590)
                    oldElm._leaveCb ? null : parentElm,
                    nodeOps.nextSibling(oldElm)
                  );
                  // update parent placeholder node element, recursively
                  if (isDef(vnode.parent)) {
                    var ancestor = vnode.parent;
                    var patchable = isPatchable(vnode);
                    while (ancestor) {
                      for (var i_8 = 0; i_8 < cbs.destroy.length; ++i_8) {
                        cbs.destroy[i_8](ancestor);
                      }
                      ancestor.elm = vnode.elm;
                      if (patchable) {
                        for (var i_9 = 0; i_9 < cbs.create.length; ++i_9) {
                          cbs.create[i_9](emptyNode, ancestor);
                        }
                        // #6513
                        // invoke insert hooks that may have been merged by create hooks.
                        // e.g. for directives that uses the "inserted" hook.
                        var insert_1 = ancestor.data.hook.insert;
                        if (insert_1.merged) {
                          // start at index 1 to avoid re-invoking component mounted hook
                          for (
                            var i_10 = 1;
                            i_10 < insert_1.fns.length;
                            i_10++
                          ) {
                            insert_1.fns[i_10]();
                          }
                        }
                      } else {
                        registerRef(ancestor);
                      }
                      ancestor = ancestor.parent;
                    }
                  }
                  // destroy old node
                  if (isDef(parentElm)) {
                    removeVnodes([oldVnode], 0, 0);
                  } else if (isDef(oldVnode.tag)) {
                    invokeDestroyHook(oldVnode);
                  }
                }
              }
              invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
              return vnode.elm;
            };
          }

          var directives$1 = {
            create: updateDirectives,
            update: updateDirectives,
            destroy: function unbindDirectives(vnode) {
              // @ts-expect-error emptyNode is not VNodeWithData
              updateDirectives(vnode, emptyNode);
            },
          };
          function updateDirectives(oldVnode, vnode) {
            if (oldVnode.data.directives || vnode.data.directives) {
              _update(oldVnode, vnode);
            }
          }
          function _update(oldVnode, vnode) {
            var isCreate = oldVnode === emptyNode;
            var isDestroy = vnode === emptyNode;
            var oldDirs = normalizeDirectives(
              oldVnode.data.directives,
              oldVnode.context
            );
            var newDirs = normalizeDirectives(
              vnode.data.directives,
              vnode.context
            );
            var dirsWithInsert = [];
            var dirsWithPostpatch = [];
            var key, oldDir, dir;
            for (key in newDirs) {
              oldDir = oldDirs[key];
              dir = newDirs[key];
              if (!oldDir) {
                // new directive, bind
                callHook(dir, "bind", vnode, oldVnode);
                if (dir.def && dir.def.inserted) {
                  dirsWithInsert.push(dir);
                }
              } else {
                // existing directive, update
                dir.oldValue = oldDir.value;
                dir.oldArg = oldDir.arg;
                callHook(dir, "update", vnode, oldVnode);
                if (dir.def && dir.def.componentUpdated) {
                  dirsWithPostpatch.push(dir);
                }
              }
            }
            if (dirsWithInsert.length) {
              var callInsert = function () {
                for (var i = 0; i < dirsWithInsert.length; i++) {
                  callHook(dirsWithInsert[i], "inserted", vnode, oldVnode);
                }
              };
              if (isCreate) {
                mergeVNodeHook(vnode, "insert", callInsert);
              } else {
                callInsert();
              }
            }
            if (dirsWithPostpatch.length) {
              mergeVNodeHook(vnode, "postpatch", function () {
                for (var i = 0; i < dirsWithPostpatch.length; i++) {
                  callHook(
                    dirsWithPostpatch[i],
                    "componentUpdated",
                    vnode,
                    oldVnode
                  );
                }
              });
            }
            if (!isCreate) {
              for (key in oldDirs) {
                if (!newDirs[key]) {
                  // no longer present, unbind
                  callHook(
                    oldDirs[key],
                    "unbind",
                    oldVnode,
                    oldVnode,
                    isDestroy
                  );
                }
              }
            }
          }
          var emptyModifiers = Object.create(null);
          function normalizeDirectives(dirs, vm) {
            var res = Object.create(null);
            if (!dirs) {
              // $flow-disable-line
              return res;
            }
            var i, dir;
            for (i = 0; i < dirs.length; i++) {
              dir = dirs[i];
              if (!dir.modifiers) {
                // $flow-disable-line
                dir.modifiers = emptyModifiers;
              }
              res[getRawDirName(dir)] = dir;
              if (vm._setupState && vm._setupState.__sfc) {
                var setupDef =
                  dir.def || resolveAsset(vm, "_setupState", "v-" + dir.name);
                if (typeof setupDef === "function") {
                  dir.def = {
                    bind: setupDef,
                    update: setupDef,
                  };
                } else {
                  dir.def = setupDef;
                }
              }
              dir.def =
                dir.def ||
                resolveAsset(vm.$options, "directives", dir.name, true);
            }
            // $flow-disable-line
            return res;
          }
          function getRawDirName(dir) {
            return (
              dir.rawName ||
              ""
                .concat(dir.name, ".")
                .concat(Object.keys(dir.modifiers || {}).join("."))
            );
          }
          function callHook(dir, hook, vnode, oldVnode, isDestroy) {
            var fn = dir.def && dir.def[hook];
            if (fn) {
              try {
                fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
              } catch (e) {
                handleError(
                  e,
                  vnode.context,
                  "directive ".concat(dir.name, " ").concat(hook, " hook")
                );
              }
            }
          }

          var baseModules = [ref, directives$1];

          function updateAttrs(oldVnode, vnode) {
            var opts = vnode.componentOptions;
            if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
              return;
            }
            if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
              return;
            }
            var key, cur, old;
            var elm = vnode.elm;
            var oldAttrs = oldVnode.data.attrs || {};
            var attrs = vnode.data.attrs || {};
            // clone observed objects, as the user probably wants to mutate it
            if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
              attrs = vnode.data.attrs = extend({}, attrs);
            }
            for (key in attrs) {
              cur = attrs[key];
              old = oldAttrs[key];
              if (old !== cur) {
                setAttr(elm, key, cur, vnode.data.pre);
              }
            }
            // #4391: in IE9, setting type can reset value for input[type=radio]
            // #6666: IE/Edge forces progress value down to 1 before setting a max
            /* istanbul ignore if */
            if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
              setAttr(elm, "value", attrs.value);
            }
            for (key in oldAttrs) {
              if (isUndef(attrs[key])) {
                if (isXlink(key)) {
                  elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
                } else if (!isEnumeratedAttr(key)) {
                  elm.removeAttribute(key);
                }
              }
            }
          }
          function setAttr(el, key, value, isInPre) {
            if (isInPre || el.tagName.indexOf("-") > -1) {
              baseSetAttr(el, key, value);
            } else if (isBooleanAttr(key)) {
              // set attribute for blank value
              // e.g. <option disabled>Select one</option>
              if (isFalsyAttrValue(value)) {
                el.removeAttribute(key);
              } else {
                // technically allowfullscreen is a boolean attribute for <iframe>,
                // but Flash expects a value of "true" when used on <embed> tag
                value =
                  key === "allowfullscreen" && el.tagName === "EMBED"
                    ? "true"
                    : key;
                el.setAttribute(key, value);
              }
            } else if (isEnumeratedAttr(key)) {
              el.setAttribute(key, convertEnumeratedValue(key, value));
            } else if (isXlink(key)) {
              if (isFalsyAttrValue(value)) {
                el.removeAttributeNS(xlinkNS, getXlinkProp(key));
              } else {
                el.setAttributeNS(xlinkNS, key, value);
              }
            } else {
              baseSetAttr(el, key, value);
            }
          }
          function baseSetAttr(el, key, value) {
            if (isFalsyAttrValue(value)) {
              el.removeAttribute(key);
            } else {
              // #7138: IE10 & 11 fires input event when setting placeholder on
              // <textarea>... block the first input event and remove the blocker
              // immediately.
              /* istanbul ignore if */
              if (
                isIE &&
                !isIE9 &&
                el.tagName === "TEXTAREA" &&
                key === "placeholder" &&
                value !== "" &&
                !el.__ieph
              ) {
                var blocker_1 = function (e) {
                  e.stopImmediatePropagation();
                  el.removeEventListener("input", blocker_1);
                };
                el.addEventListener("input", blocker_1);
                // $flow-disable-line
                el.__ieph = true; /* IE placeholder patched */
              }
              el.setAttribute(key, value);
            }
          }
          var attrs = {
            create: updateAttrs,
            update: updateAttrs,
          };

          function updateClass(oldVnode, vnode) {
            var el = vnode.elm;
            var data = vnode.data;
            var oldData = oldVnode.data;
            if (
              isUndef(data.staticClass) &&
              isUndef(data.class) &&
              (isUndef(oldData) ||
                (isUndef(oldData.staticClass) && isUndef(oldData.class)))
            ) {
              return;
            }
            var cls = genClassForVnode(vnode);
            // handle transition classes
            var transitionClass = el._transitionClasses;
            if (isDef(transitionClass)) {
              cls = concat(cls, stringifyClass(transitionClass));
            }
            // set the class
            if (cls !== el._prevClass) {
              el.setAttribute("class", cls);
              el._prevClass = cls;
            }
          }
          var klass$1 = {
            create: updateClass,
            update: updateClass,
          };

          var validDivisionCharRE = /[\w).+\-_$\]]/;
          function parseFilters(exp) {
            var inSingle = false;
            var inDouble = false;
            var inTemplateString = false;
            var inRegex = false;
            var curly = 0;
            var square = 0;
            var paren = 0;
            var lastFilterIndex = 0;
            var c, prev, i, expression, filters;
            for (i = 0; i < exp.length; i++) {
              prev = c;
              c = exp.charCodeAt(i);
              if (inSingle) {
                if (c === 0x27 && prev !== 0x5c) inSingle = false;
              } else if (inDouble) {
                if (c === 0x22 && prev !== 0x5c) inDouble = false;
              } else if (inTemplateString) {
                if (c === 0x60 && prev !== 0x5c) inTemplateString = false;
              } else if (inRegex) {
                if (c === 0x2f && prev !== 0x5c) inRegex = false;
              } else if (
                c === 0x7c && // pipe
                exp.charCodeAt(i + 1) !== 0x7c &&
                exp.charCodeAt(i - 1) !== 0x7c &&
                !curly &&
                !square &&
                !paren
              ) {
                if (expression === undefined) {
                  // first filter, end of expression
                  lastFilterIndex = i + 1;
                  expression = exp.slice(0, i).trim();
                } else {
                  pushFilter();
                }
              } else {
                switch (c) {
                  case 0x22:
                    inDouble = true;
                    break; // "
                  case 0x27:
                    inSingle = true;
                    break; // '
                  case 0x60:
                    inTemplateString = true;
                    break; // `
                  case 0x28:
                    paren++;
                    break; // (
                  case 0x29:
                    paren--;
                    break; // )
                  case 0x5b:
                    square++;
                    break; // [
                  case 0x5d:
                    square--;
                    break; // ]
                  case 0x7b:
                    curly++;
                    break; // {
                  case 0x7d:
                    curly--;
                    break; // }
                }
                if (c === 0x2f) {
                  // /
                  var j = i - 1;
                  var p =
                    // find first non-whitespace prev char
                    void 0;
                  // find first non-whitespace prev char
                  for (; j >= 0; j--) {
                    p = exp.charAt(j);
                    if (p !== " ") break;
                  }
                  if (!p || !validDivisionCharRE.test(p)) {
                    inRegex = true;
                  }
                }
              }
            }
            if (expression === undefined) {
              expression = exp.slice(0, i).trim();
            } else if (lastFilterIndex !== 0) {
              pushFilter();
            }
            function pushFilter() {
              (filters || (filters = [])).push(
                exp.slice(lastFilterIndex, i).trim()
              );
              lastFilterIndex = i + 1;
            }
            if (filters) {
              for (i = 0; i < filters.length; i++) {
                expression = wrapFilter(expression, filters[i]);
              }
            }
            return expression;
          }
          function wrapFilter(exp, filter) {
            var i = filter.indexOf("(");
            if (i < 0) {
              // _f: resolveFilter
              return '_f("'.concat(filter, '")(').concat(exp, ")");
            } else {
              var name_1 = filter.slice(0, i);
              var args = filter.slice(i + 1);
              return '_f("'
                .concat(name_1, '")(')
                .concat(exp)
                .concat(args !== ")" ? "," + args : args);
            }
          }

          /* eslint-disable no-unused-vars */
          function baseWarn(msg, range) {
            console.error("[Vue compiler]: ".concat(msg));
          }
          /* eslint-enable no-unused-vars */
          function pluckModuleFunction(modules, key) {
            return modules
              ? modules
                  .map(function (m) {
                    return m[key];
                  })
                  .filter(function (_) {
                    return _;
                  })
              : [];
          }
          function addProp(el, name, value, range, dynamic) {
            (el.props || (el.props = [])).push(
              rangeSetItem(
                { name: name, value: value, dynamic: dynamic },
                range
              )
            );
            el.plain = false;
          }
          function addAttr(el, name, value, range, dynamic) {
            var attrs = dynamic
              ? el.dynamicAttrs || (el.dynamicAttrs = [])
              : el.attrs || (el.attrs = []);
            attrs.push(
              rangeSetItem(
                { name: name, value: value, dynamic: dynamic },
                range
              )
            );
            el.plain = false;
          }
          // add a raw attr (use this in preTransforms)
          function addRawAttr(el, name, value, range) {
            el.attrsMap[name] = value;
            el.attrsList.push(
              rangeSetItem({ name: name, value: value }, range)
            );
          }
          function addDirective(
            el,
            name,
            rawName,
            value,
            arg,
            isDynamicArg,
            modifiers,
            range
          ) {
            (el.directives || (el.directives = [])).push(
              rangeSetItem(
                {
                  name: name,
                  rawName: rawName,
                  value: value,
                  arg: arg,
                  isDynamicArg: isDynamicArg,
                  modifiers: modifiers,
                },
                range
              )
            );
            el.plain = false;
          }
          function prependModifierMarker(symbol, name, dynamic) {
            return dynamic
              ? "_p(".concat(name, ',"').concat(symbol, '")')
              : symbol + name; // mark the event as captured
          }
          function addHandler(
            el,
            name,
            value,
            modifiers,
            important,
            warn,
            range,
            dynamic
          ) {
            modifiers = modifiers || emptyObject;
            // warn prevent and passive modifier
            /* istanbul ignore if */
            if (warn && modifiers.prevent && modifiers.passive) {
              warn(
                "passive and prevent can't be used together. " +
                  "Passive handler can't prevent default event.",
                range
              );
            }
            // normalize click.right and click.middle since they don't actually fire
            // this is technically browser-specific, but at least for now browsers are
            // the only target envs that have right/middle clicks.
            if (modifiers.right) {
              if (dynamic) {
                name = "("
                  .concat(name, ")==='click'?'contextmenu':(")
                  .concat(name, ")");
              } else if (name === "click") {
                name = "contextmenu";
                delete modifiers.right;
              }
            } else if (modifiers.middle) {
              if (dynamic) {
                name = "("
                  .concat(name, ")==='click'?'mouseup':(")
                  .concat(name, ")");
              } else if (name === "click") {
                name = "mouseup";
              }
            }
            // check capture modifier
            if (modifiers.capture) {
              delete modifiers.capture;
              name = prependModifierMarker("!", name, dynamic);
            }
            if (modifiers.once) {
              delete modifiers.once;
              name = prependModifierMarker("~", name, dynamic);
            }
            /* istanbul ignore if */
            if (modifiers.passive) {
              delete modifiers.passive;
              name = prependModifierMarker("&", name, dynamic);
            }
            var events;
            if (modifiers.native) {
              delete modifiers.native;
              events = el.nativeEvents || (el.nativeEvents = {});
            } else {
              events = el.events || (el.events = {});
            }
            var newHandler = rangeSetItem(
              { value: value.trim(), dynamic: dynamic },
              range
            );
            if (modifiers !== emptyObject) {
              newHandler.modifiers = modifiers;
            }
            var handlers = events[name];
            /* istanbul ignore if */
            if (Array.isArray(handlers)) {
              important
                ? handlers.unshift(newHandler)
                : handlers.push(newHandler);
            } else if (handlers) {
              events[name] = important
                ? [newHandler, handlers]
                : [handlers, newHandler];
            } else {
              events[name] = newHandler;
            }
            el.plain = false;
          }
          function getRawBindingAttr(el, name) {
            return (
              el.rawAttrsMap[":" + name] ||
              el.rawAttrsMap["v-bind:" + name] ||
              el.rawAttrsMap[name]
            );
          }
          function getBindingAttr(el, name, getStatic) {
            var dynamicValue =
              getAndRemoveAttr(el, ":" + name) ||
              getAndRemoveAttr(el, "v-bind:" + name);
            if (dynamicValue != null) {
              return parseFilters(dynamicValue);
            } else if (getStatic !== false) {
              var staticValue = getAndRemoveAttr(el, name);
              if (staticValue != null) {
                return JSON.stringify(staticValue);
              }
            }
          }
          // note: this only removes the attr from the Array (attrsList) so that it
          // doesn't get processed by processAttrs.
          // By default it does NOT remove it from the map (attrsMap) because the map is
          // needed during codegen.
          function getAndRemoveAttr(el, name, removeFromMap) {
            var val;
            if ((val = el.attrsMap[name]) != null) {
              var list = el.attrsList;
              for (var i = 0, l = list.length; i < l; i++) {
                if (list[i].name === name) {
                  list.splice(i, 1);
                  break;
                }
              }
            }
            if (removeFromMap) {
              delete el.attrsMap[name];
            }
            return val;
          }
          function getAndRemoveAttrByRegex(el, name) {
            var list = el.attrsList;
            for (var i = 0, l = list.length; i < l; i++) {
              var attr = list[i];
              if (name.test(attr.name)) {
                list.splice(i, 1);
                return attr;
              }
            }
          }
          function rangeSetItem(item, range) {
            if (range) {
              if (range.start != null) {
                item.start = range.start;
              }
              if (range.end != null) {
                item.end = range.end;
              }
            }
            return item;
          }

          /**
           * Cross-platform code generation for component v-model
           */
          function genComponentModel(el, value, modifiers) {
            var _a = modifiers || {},
              number = _a.number,
              trim = _a.trim;
            var baseValueExpression = "$$v";
            var valueExpression = baseValueExpression;
            if (trim) {
              valueExpression =
                "(typeof ".concat(baseValueExpression, " === 'string'") +
                "? ".concat(baseValueExpression, ".trim()") +
                ": ".concat(baseValueExpression, ")");
            }
            if (number) {
              valueExpression = "_n(".concat(valueExpression, ")");
            }
            var assignment = genAssignmentCode(value, valueExpression);
            el.model = {
              value: "(".concat(value, ")"),
              expression: JSON.stringify(value),
              callback: "function ("
                .concat(baseValueExpression, ") {")
                .concat(assignment, "}"),
            };
          }
          /**
           * Cross-platform codegen helper for generating v-model value assignment code.
           */
          function genAssignmentCode(value, assignment) {
            var res = parseModel(value);
            if (res.key === null) {
              return "".concat(value, "=").concat(assignment);
            } else {
              return "$set("
                .concat(res.exp, ", ")
                .concat(res.key, ", ")
                .concat(assignment, ")");
            }
          }
          /**
           * Parse a v-model expression into a base path and a final key segment.
           * Handles both dot-path and possible square brackets.
           *
           * Possible cases:
           *
           * - test
           * - test[key]
           * - test[test1[key]]
           * - test["a"][key]
           * - xxx.test[a[a].test1[key]]
           * - test.xxx.a["asa"][test1[key]]
           *
           */
          var len, str, chr, index, expressionPos, expressionEndPos;
          function parseModel(val) {
            // Fix https://github.com/vuejs/vue/pull/7730
            // allow v-model="obj.val " (trailing whitespace)
            val = val.trim();
            len = val.length;
            if (val.indexOf("[") < 0 || val.lastIndexOf("]") < len - 1) {
              index = val.lastIndexOf(".");
              if (index > -1) {
                return {
                  exp: val.slice(0, index),
                  key: '"' + val.slice(index + 1) + '"',
                };
              } else {
                return {
                  exp: val,
                  key: null,
                };
              }
            }
            str = val;
            index = expressionPos = expressionEndPos = 0;
            while (!eof()) {
              chr = next();
              /* istanbul ignore if */
              if (isStringStart(chr)) {
                parseString(chr);
              } else if (chr === 0x5b) {
                parseBracket(chr);
              }
            }
            return {
              exp: val.slice(0, expressionPos),
              key: val.slice(expressionPos + 1, expressionEndPos),
            };
          }
          function next() {
            return str.charCodeAt(++index);
          }
          function eof() {
            return index >= len;
          }
          function isStringStart(chr) {
            return chr === 0x22 || chr === 0x27;
          }
          function parseBracket(chr) {
            var inBracket = 1;
            expressionPos = index;
            while (!eof()) {
              chr = next();
              if (isStringStart(chr)) {
                parseString(chr);
                continue;
              }
              if (chr === 0x5b) inBracket++;
              if (chr === 0x5d) inBracket--;
              if (inBracket === 0) {
                expressionEndPos = index;
                break;
              }
            }
          }
          function parseString(chr) {
            var stringQuote = chr;
            while (!eof()) {
              chr = next();
              if (chr === stringQuote) {
                break;
              }
            }
          }

          var warn$1;
          // in some cases, the event used has to be determined at runtime
          // so we used some reserved tokens during compile.
          var RANGE_TOKEN = "__r";
          var CHECKBOX_RADIO_TOKEN = "__c";
          function model$1(el, dir, _warn) {
            warn$1 = _warn;
            var value = dir.value;
            var modifiers = dir.modifiers;
            var tag = el.tag;
            var type = el.attrsMap.type;
            {
              // inputs with type="file" are read only and setting the input's
              // value will throw an error.
              if (tag === "input" && type === "file") {
                warn$1(
                  "<"
                    .concat(el.tag, ' v-model="')
                    .concat(value, '" type="file">:\n') +
                    "File inputs are read only. Use a v-on:change listener instead.",
                  el.rawAttrsMap["v-model"]
                );
              }
            }
            if (el.component) {
              genComponentModel(el, value, modifiers);
              // component v-model doesn't need extra runtime
              return false;
            } else if (tag === "select") {
              genSelect(el, value, modifiers);
            } else if (tag === "input" && type === "checkbox") {
              genCheckboxModel(el, value, modifiers);
            } else if (tag === "input" && type === "radio") {
              genRadioModel(el, value, modifiers);
            } else if (tag === "input" || tag === "textarea") {
              genDefaultModel(el, value, modifiers);
            } else if (!config.isReservedTag(tag)) {
              genComponentModel(el, value, modifiers);
              // component v-model doesn't need extra runtime
              return false;
            } else {
              warn$1(
                "<".concat(el.tag, ' v-model="').concat(value, '">: ') +
                  "v-model is not supported on this element type. " +
                  "If you are working with contenteditable, it's recommended to " +
                  "wrap a library dedicated for that purpose inside a custom component.",
                el.rawAttrsMap["v-model"]
              );
            }
            // ensure runtime directive metadata
            return true;
          }
          function genCheckboxModel(el, value, modifiers) {
            var number = modifiers && modifiers.number;
            var valueBinding = getBindingAttr(el, "value") || "null";
            var trueValueBinding = getBindingAttr(el, "true-value") || "true";
            var falseValueBinding =
              getBindingAttr(el, "false-value") || "false";
            addProp(
              el,
              "checked",
              "Array.isArray(".concat(value, ")") +
                "?_i(".concat(value, ",").concat(valueBinding, ")>-1") +
                (trueValueBinding === "true"
                  ? ":(".concat(value, ")")
                  : ":_q(".concat(value, ",").concat(trueValueBinding, ")"))
            );
            addHandler(
              el,
              "change",
              "var $$a=".concat(value, ",") +
                "$$el=$event.target," +
                "$$c=$$el.checked?("
                  .concat(trueValueBinding, "):(")
                  .concat(falseValueBinding, ");") +
                "if(Array.isArray($$a)){" +
                "var $$v=".concat(
                  number ? "_n(" + valueBinding + ")" : valueBinding,
                  ","
                ) +
                "$$i=_i($$a,$$v);" +
                "if($$el.checked){$$i<0&&(".concat(
                  genAssignmentCode(value, "$$a.concat([$$v])"),
                  ")}"
                ) +
                "else{$$i>-1&&(".concat(
                  genAssignmentCode(
                    value,
                    "$$a.slice(0,$$i).concat($$a.slice($$i+1))"
                  ),
                  ")}"
                ) +
                "}else{".concat(genAssignmentCode(value, "$$c"), "}"),
              null,
              true
            );
          }
          function genRadioModel(el, value, modifiers) {
            var number = modifiers && modifiers.number;
            var valueBinding = getBindingAttr(el, "value") || "null";
            valueBinding = number
              ? "_n(".concat(valueBinding, ")")
              : valueBinding;
            addProp(
              el,
              "checked",
              "_q(".concat(value, ",").concat(valueBinding, ")")
            );
            addHandler(
              el,
              "change",
              genAssignmentCode(value, valueBinding),
              null,
              true
            );
          }
          function genSelect(el, value, modifiers) {
            var number = modifiers && modifiers.number;
            var selectedVal =
              "Array.prototype.filter" +
              ".call($event.target.options,function(o){return o.selected})" +
              '.map(function(o){var val = "_value" in o ? o._value : o.value;' +
              "return ".concat(number ? "_n(val)" : "val", "})");
            var assignment =
              "$event.target.multiple ? $$selectedVal : $$selectedVal[0]";
            var code = "var $$selectedVal = ".concat(selectedVal, ";");
            code = ""
              .concat(code, " ")
              .concat(genAssignmentCode(value, assignment));
            addHandler(el, "change", code, null, true);
          }
          function genDefaultModel(el, value, modifiers) {
            var type = el.attrsMap.type;
            // warn if v-bind:value conflicts with v-model
            // except for inputs with v-bind:type
            {
              var value_1 =
                el.attrsMap["v-bind:value"] || el.attrsMap[":value"];
              var typeBinding =
                el.attrsMap["v-bind:type"] || el.attrsMap[":type"];
              if (value_1 && !typeBinding) {
                var binding = el.attrsMap["v-bind:value"]
                  ? "v-bind:value"
                  : ":value";
                warn$1(
                  ""
                    .concat(binding, '="')
                    .concat(
                      value_1,
                      '" conflicts with v-model on the same element '
                    ) +
                    "because the latter already expands to a value binding internally",
                  el.rawAttrsMap[binding]
                );
              }
            }
            var _a = modifiers || {},
              lazy = _a.lazy,
              number = _a.number,
              trim = _a.trim;
            var needCompositionGuard = !lazy && type !== "range";
            var event = lazy
              ? "change"
              : type === "range"
              ? RANGE_TOKEN
              : "input";
            var valueExpression = "$event.target.value";
            if (trim) {
              valueExpression = "$event.target.value.trim()";
            }
            if (number) {
              valueExpression = "_n(".concat(valueExpression, ")");
            }
            var code = genAssignmentCode(value, valueExpression);
            if (needCompositionGuard) {
              code = "if($event.target.composing)return;".concat(code);
            }
            addProp(el, "value", "(".concat(value, ")"));
            addHandler(el, event, code, null, true);
            if (trim || number) {
              addHandler(el, "blur", "$forceUpdate()");
            }
          }

          // normalize v-model event tokens that can only be determined at runtime.
          // it's important to place the event as the first in the array because
          // the whole point is ensuring the v-model callback gets called before
          // user-attached handlers.
          function normalizeEvents(on) {
            /* istanbul ignore if */
            if (isDef(on[RANGE_TOKEN])) {
              // IE input[type=range] only supports `change` event
              var event_1 = isIE ? "change" : "input";
              on[event_1] = [].concat(on[RANGE_TOKEN], on[event_1] || []);
              delete on[RANGE_TOKEN];
            }
            // This was originally intended to fix #4521 but no longer necessary
            // after 2.5. Keeping it for backwards compat with generated code from < 2.4
            /* istanbul ignore if */
            if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
              on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
              delete on[CHECKBOX_RADIO_TOKEN];
            }
          }
          var target;
          function createOnceHandler(event, handler, capture) {
            var _target = target; // save current target element in closure
            return function onceHandler() {
              var res = handler.apply(null, arguments);
              if (res !== null) {
                remove(event, onceHandler, capture, _target);
              }
            };
          }
          // #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
          // implementation and does not fire microtasks in between event propagation, so
          // safe to exclude.
          var useMicrotaskFix =
            isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
          function add(name, handler, capture, passive) {
            // async edge case #6566: inner click event triggers patch, event handler
            // attached to outer element during patch, and triggered again. This
            // happens because browsers fire microtask ticks between event propagation.
            // the solution is simple: we save the timestamp when a handler is attached,
            // and the handler would only fire if the event passed to it was fired
            // AFTER it was attached.
            if (useMicrotaskFix) {
              var attachedTimestamp_1 = currentFlushTimestamp;
              var original_1 = handler;
              //@ts-expect-error
              handler = original_1._wrapper = function (e) {
                if (
                  // no bubbling, should always fire.
                  // this is just a safety net in case event.timeStamp is unreliable in
                  // certain weird environments...
                  e.target === e.currentTarget ||
                  // event is fired after handler attachment
                  e.timeStamp >= attachedTimestamp_1 ||
                  // bail for environments that have buggy event.timeStamp implementations
                  // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
                  // #9681 QtWebEngine event.timeStamp is negative value
                  e.timeStamp <= 0 ||
                  // #9448 bail if event is fired in another document in a multi-page
                  // electron/nw.js app, since event.timeStamp will be using a different
                  // starting reference
                  e.target.ownerDocument !== document
                ) {
                  return original_1.apply(this, arguments);
                }
              };
            }
            target.addEventListener(
              name,
              handler,
              supportsPassive ? { capture: capture, passive: passive } : capture
            );
          }
          function remove(name, handler, capture, _target) {
            (_target || target).removeEventListener(
              name,
              //@ts-expect-error
              handler._wrapper || handler,
              capture
            );
          }
          function updateDOMListeners(oldVnode, vnode) {
            if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
              return;
            }
            var on = vnode.data.on || {};
            var oldOn = oldVnode.data.on || {};
            // vnode is empty when removing all listeners,
            // and use old vnode dom element
            target = vnode.elm || oldVnode.elm;
            normalizeEvents(on);
            updateListeners(
              on,
              oldOn,
              add,
              remove,
              createOnceHandler,
              vnode.context
            );
            target = undefined;
          }
          var events = {
            create: updateDOMListeners,
            update: updateDOMListeners,
            // @ts-expect-error emptyNode has actually data
            destroy: function (vnode) {
              return updateDOMListeners(vnode, emptyNode);
            },
          };

          var svgContainer;
          function updateDOMProps(oldVnode, vnode) {
            if (
              isUndef(oldVnode.data.domProps) &&
              isUndef(vnode.data.domProps)
            ) {
              return;
            }
            var key, cur;
            var elm = vnode.elm;
            var oldProps = oldVnode.data.domProps || {};
            var props = vnode.data.domProps || {};
            // clone observed objects, as the user probably wants to mutate it
            if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
              props = vnode.data.domProps = extend({}, props);
            }
            for (key in oldProps) {
              if (!(key in props)) {
                elm[key] = "";
              }
            }
            for (key in props) {
              cur = props[key];
              // ignore children if the node has textContent or innerHTML,
              // as these will throw away existing DOM nodes and cause removal errors
              // on subsequent patches (#3360)
              if (key === "textContent" || key === "innerHTML") {
                if (vnode.children) vnode.children.length = 0;
                if (cur === oldProps[key]) continue;
                // #6601 work around Chrome version <= 55 bug where single textNode
                // replaced by innerHTML/textContent retains its parentNode property
                if (elm.childNodes.length === 1) {
                  elm.removeChild(elm.childNodes[0]);
                }
              }
              if (key === "value" && elm.tagName !== "PROGRESS") {
                // store value as _value as well since
                // non-string values will be stringified
                elm._value = cur;
                // avoid resetting cursor position when value is the same
                var strCur = isUndef(cur) ? "" : String(cur);
                if (shouldUpdateValue(elm, strCur)) {
                  elm.value = strCur;
                }
              } else if (
                key === "innerHTML" &&
                isSVG(elm.tagName) &&
                isUndef(elm.innerHTML)
              ) {
                // IE doesn't support innerHTML for SVG elements
                svgContainer = svgContainer || document.createElement("div");
                svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
                var svg = svgContainer.firstChild;
                while (elm.firstChild) {
                  elm.removeChild(elm.firstChild);
                }
                while (svg.firstChild) {
                  elm.appendChild(svg.firstChild);
                }
              } else if (
                // skip the update if old and new VDOM state is the same.
                // `value` is handled separately because the DOM value may be temporarily
                // out of sync with VDOM state due to focus, composition and modifiers.
                // This  #4521 by skipping the unnecessary `checked` update.
                cur !== oldProps[key]
              ) {
                // some property updates can throw
                // e.g. `value` on <progress> w/ non-finite value
                try {
                  elm[key] = cur;
                } catch (e) {}
              }
            }
          }
          function shouldUpdateValue(elm, checkVal) {
            return (
              //@ts-expect-error
              !elm.composing &&
              (elm.tagName === "OPTION" ||
                isNotInFocusAndDirty(elm, checkVal) ||
                isDirtyWithModifiers(elm, checkVal))
            );
          }
          function isNotInFocusAndDirty(elm, checkVal) {
            // return true when textbox (.number and .trim) loses focus and its value is
            // not equal to the updated value
            var notInFocus = true;
            // #6157
            // work around IE bug when accessing document.activeElement in an iframe
            try {
              notInFocus = document.activeElement !== elm;
            } catch (e) {}
            return notInFocus && elm.value !== checkVal;
          }
          function isDirtyWithModifiers(elm, newVal) {
            var value = elm.value;
            var modifiers = elm._vModifiers; // injected by v-model runtime
            if (isDef(modifiers)) {
              if (modifiers.number) {
                return toNumber(value) !== toNumber(newVal);
              }
              if (modifiers.trim) {
                return value.trim() !== newVal.trim();
              }
            }
            return value !== newVal;
          }
          var domProps = {
            create: updateDOMProps,
            update: updateDOMProps,
          };

          var parseStyleText = cached(function (cssText) {
            var res = {};
            var listDelimiter = /;(?![^(]*\))/g;
            var propertyDelimiter = /:(.+)/;
            cssText.split(listDelimiter).forEach(function (item) {
              if (item) {
                var tmp = item.split(propertyDelimiter);
                tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
              }
            });
            return res;
          });
          // merge static and dynamic style data on the same vnode
          function normalizeStyleData(data) {
            var style = normalizeStyleBinding(data.style);
            // static style is pre-processed into an object during compilation
            // and is always a fresh object, so it's safe to merge into it
            return data.staticStyle ? extend(data.staticStyle, style) : style;
          }
          // normalize possible array / string values into Object
          function normalizeStyleBinding(bindingStyle) {
            if (Array.isArray(bindingStyle)) {
              return toObject(bindingStyle);
            }
            if (typeof bindingStyle === "string") {
              return parseStyleText(bindingStyle);
            }
            return bindingStyle;
          }
          /**
           * parent component style should be after child's
           * so that parent component's style could override it
           */
          function getStyle(vnode, checkChild) {
            var res = {};
            var styleData;
            if (checkChild) {
              var childNode = vnode;
              while (childNode.componentInstance) {
                childNode = childNode.componentInstance._vnode;
                if (
                  childNode &&
                  childNode.data &&
                  (styleData = normalizeStyleData(childNode.data))
                ) {
                  extend(res, styleData);
                }
              }
            }
            if ((styleData = normalizeStyleData(vnode.data))) {
              extend(res, styleData);
            }
            var parentNode = vnode;
            // @ts-expect-error parentNode.parent not VNodeWithData
            while ((parentNode = parentNode.parent)) {
              if (
                parentNode.data &&
                (styleData = normalizeStyleData(parentNode.data))
              ) {
                extend(res, styleData);
              }
            }
            return res;
          }

          var cssVarRE = /^--/;
          var importantRE = /\s*!important$/;
          var setProp = function (el, name, val) {
            /* istanbul ignore if */
            if (cssVarRE.test(name)) {
              el.style.setProperty(name, val);
            } else if (importantRE.test(val)) {
              el.style.setProperty(
                hyphenate(name),
                val.replace(importantRE, ""),
                "important"
              );
            } else {
              var normalizedName = normalize(name);
              if (Array.isArray(val)) {
                // Support values array created by autoprefixer, e.g.
                // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
                // Set them one by one, and the browser will only set those it can recognize
                for (var i = 0, len = val.length; i < len; i++) {
                  el.style[normalizedName] = val[i];
                }
              } else {
                el.style[normalizedName] = val;
              }
            }
          };
          var vendorNames = ["Webkit", "Moz", "ms"];
          var emptyStyle;
          var normalize = cached(function (prop) {
            emptyStyle = emptyStyle || document.createElement("div").style;
            prop = camelize(prop);
            if (prop !== "filter" && prop in emptyStyle) {
              return prop;
            }
            var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
            for (var i = 0; i < vendorNames.length; i++) {
              var name_1 = vendorNames[i] + capName;
              if (name_1 in emptyStyle) {
                return name_1;
              }
            }
          });
          function updateStyle(oldVnode, vnode) {
            var data = vnode.data;
            var oldData = oldVnode.data;
            if (
              isUndef(data.staticStyle) &&
              isUndef(data.style) &&
              isUndef(oldData.staticStyle) &&
              isUndef(oldData.style)
            ) {
              return;
            }
            var cur, name;
            var el = vnode.elm;
            var oldStaticStyle = oldData.staticStyle;
            var oldStyleBinding =
              oldData.normalizedStyle || oldData.style || {};
            // if static style exists, stylebinding already merged into it when doing normalizeStyleData
            var oldStyle = oldStaticStyle || oldStyleBinding;
            var style = normalizeStyleBinding(vnode.data.style) || {};
            // store normalized style under a different key for next diff
            // make sure to clone it if it's reactive, since the user likely wants
            // to mutate it.
            vnode.data.normalizedStyle = isDef(style.__ob__)
              ? extend({}, style)
              : style;
            var newStyle = getStyle(vnode, true);
            for (name in oldStyle) {
              if (isUndef(newStyle[name])) {
                setProp(el, name, "");
              }
            }
            for (name in newStyle) {
              cur = newStyle[name];
              if (cur !== oldStyle[name]) {
                // ie9 setting to null has no effect, must use empty string
                setProp(el, name, cur == null ? "" : cur);
              }
            }
          }
          var style$1 = {
            create: updateStyle,
            update: updateStyle,
          };

          var whitespaceRE$1 = /\s+/;
          /**
           * Add class with compatibility for SVG since classList is not supported on
           * SVG elements in IE
           */
          function addClass(el, cls) {
            /* istanbul ignore if */
            if (!cls || !(cls = cls.trim())) {
              return;
            }
            /* istanbul ignore else */
            if (el.classList) {
              if (cls.indexOf(" ") > -1) {
                cls.split(whitespaceRE$1).forEach(function (c) {
                  return el.classList.add(c);
                });
              } else {
                el.classList.add(cls);
              }
            } else {
              var cur = " ".concat(el.getAttribute("class") || "", " ");
              if (cur.indexOf(" " + cls + " ") < 0) {
                el.setAttribute("class", (cur + cls).trim());
              }
            }
          }
          /**
           * Remove class with compatibility for SVG since classList is not supported on
           * SVG elements in IE
           */
          function removeClass(el, cls) {
            /* istanbul ignore if */
            if (!cls || !(cls = cls.trim())) {
              return;
            }
            /* istanbul ignore else */
            if (el.classList) {
              if (cls.indexOf(" ") > -1) {
                cls.split(whitespaceRE$1).forEach(function (c) {
                  return el.classList.remove(c);
                });
              } else {
                el.classList.remove(cls);
              }
              if (!el.classList.length) {
                el.removeAttribute("class");
              }
            } else {
              var cur = " ".concat(el.getAttribute("class") || "", " ");
              var tar = " " + cls + " ";
              while (cur.indexOf(tar) >= 0) {
                cur = cur.replace(tar, " ");
              }
              cur = cur.trim();
              if (cur) {
                el.setAttribute("class", cur);
              } else {
                el.removeAttribute("class");
              }
            }
          }

          function resolveTransition(def) {
            if (!def) {
              return;
            }
            /* istanbul ignore else */
            if (typeof def === "object") {
              var res = {};
              if (def.css !== false) {
                extend(res, autoCssTransition(def.name || "v"));
              }
              extend(res, def);
              return res;
            } else if (typeof def === "string") {
              return autoCssTransition(def);
            }
          }
          var autoCssTransition = cached(function (name) {
            return {
              enterClass: "".concat(name, "-enter"),
              enterToClass: "".concat(name, "-enter-to"),
              enterActiveClass: "".concat(name, "-enter-active"),
              leaveClass: "".concat(name, "-leave"),
              leaveToClass: "".concat(name, "-leave-to"),
              leaveActiveClass: "".concat(name, "-leave-active"),
            };
          });
          var hasTransition = inBrowser && !isIE9;
          var TRANSITION = "transition";
          var ANIMATION = "animation";
          // Transition property/event sniffing
          var transitionProp = "transition";
          var transitionEndEvent = "transitionend";
          var animationProp = "animation";
          var animationEndEvent = "animationend";
          if (hasTransition) {
            /* istanbul ignore if */
            if (
              window.ontransitionend === undefined &&
              window.onwebkittransitionend !== undefined
            ) {
              transitionProp = "WebkitTransition";
              transitionEndEvent = "webkitTransitionEnd";
            }
            if (
              window.onanimationend === undefined &&
              window.onwebkitanimationend !== undefined
            ) {
              animationProp = "WebkitAnimation";
              animationEndEvent = "webkitAnimationEnd";
            }
          }
          // binding to window is necessary to make hot reload work in IE in strict mode
          var raf = inBrowser
            ? window.requestAnimationFrame
              ? window.requestAnimationFrame.bind(window)
              : setTimeout
            : /* istanbul ignore next */ function (
                /* istanbul ignore next */ fn
              ) {
                return fn();
              };
          function nextFrame(fn) {
            raf(function () {
              // @ts-expect-error
              raf(fn);
            });
          }
          function addTransitionClass(el, cls) {
            var transitionClasses =
              el._transitionClasses || (el._transitionClasses = []);
            if (transitionClasses.indexOf(cls) < 0) {
              transitionClasses.push(cls);
              addClass(el, cls);
            }
          }
          function removeTransitionClass(el, cls) {
            if (el._transitionClasses) {
              remove$2(el._transitionClasses, cls);
            }
            removeClass(el, cls);
          }
          function whenTransitionEnds(el, expectedType, cb) {
            var _a = getTransitionInfo(el, expectedType),
              type = _a.type,
              timeout = _a.timeout,
              propCount = _a.propCount;
            if (!type) return cb();
            var event =
              type === TRANSITION ? transitionEndEvent : animationEndEvent;
            var ended = 0;
            var end = function () {
              el.removeEventListener(event, onEnd);
              cb();
            };
            var onEnd = function (e) {
              if (e.target === el) {
                if (++ended >= propCount) {
                  end();
                }
              }
            };
            setTimeout(function () {
              if (ended < propCount) {
                end();
              }
            }, timeout + 1);
            el.addEventListener(event, onEnd);
          }
          var transformRE = /\b(transform|all)(,|$)/;
          function getTransitionInfo(el, expectedType) {
            var styles = window.getComputedStyle(el);
            // JSDOM may return undefined for transition properties
            var transitionDelays = (
              styles[transitionProp + "Delay"] || ""
            ).split(", ");
            var transitionDurations = (
              styles[transitionProp + "Duration"] || ""
            ).split(", ");
            var transitionTimeout = getTimeout(
              transitionDelays,
              transitionDurations
            );
            var animationDelays = (styles[animationProp + "Delay"] || "").split(
              ", "
            );
            var animationDurations = (
              styles[animationProp + "Duration"] || ""
            ).split(", ");
            var animationTimeout = getTimeout(
              animationDelays,
              animationDurations
            );
            var type;
            var timeout = 0;
            var propCount = 0;
            /* istanbul ignore if */
            if (expectedType === TRANSITION) {
              if (transitionTimeout > 0) {
                type = TRANSITION;
                timeout = transitionTimeout;
                propCount = transitionDurations.length;
              }
            } else if (expectedType === ANIMATION) {
              if (animationTimeout > 0) {
                type = ANIMATION;
                timeout = animationTimeout;
                propCount = animationDurations.length;
              }
            } else {
              timeout = Math.max(transitionTimeout, animationTimeout);
              type =
                timeout > 0
                  ? transitionTimeout > animationTimeout
                    ? TRANSITION
                    : ANIMATION
                  : null;
              propCount = type
                ? type === TRANSITION
                  ? transitionDurations.length
                  : animationDurations.length
                : 0;
            }
            var hasTransform =
              type === TRANSITION &&
              transformRE.test(styles[transitionProp + "Property"]);
            return {
              type: type,
              timeout: timeout,
              propCount: propCount,
              hasTransform: hasTransform,
            };
          }
          function getTimeout(delays, durations) {
            /* istanbul ignore next */
            while (delays.length < durations.length) {
              delays = delays.concat(delays);
            }
            return Math.max.apply(
              null,
              durations.map(function (d, i) {
                return toMs(d) + toMs(delays[i]);
              })
            );
          }
          // Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
          // in a locale-dependent way, using a comma instead of a dot.
          // If comma is not replaced with a dot, the input will be rounded down (i.e. acting
          // as a floor function) causing unexpected behaviors
          function toMs(s) {
            return Number(s.slice(0, -1).replace(",", ".")) * 1000;
          }

          function enter(vnode, toggleDisplay) {
            var el = vnode.elm;
            // call leave callback now
            if (isDef(el._leaveCb)) {
              el._leaveCb.cancelled = true;
              el._leaveCb();
            }
            var data = resolveTransition(vnode.data.transition);
            if (isUndef(data)) {
              return;
            }
            /* istanbul ignore if */
            if (isDef(el._enterCb) || el.nodeType !== 1) {
              return;
            }
            var css = data.css,
              type = data.type,
              enterClass = data.enterClass,
              enterToClass = data.enterToClass,
              enterActiveClass = data.enterActiveClass,
              appearClass = data.appearClass,
              appearToClass = data.appearToClass,
              appearActiveClass = data.appearActiveClass,
              beforeEnter = data.beforeEnter,
              enter = data.enter,
              afterEnter = data.afterEnter,
              enterCancelled = data.enterCancelled,
              beforeAppear = data.beforeAppear,
              appear = data.appear,
              afterAppear = data.afterAppear,
              appearCancelled = data.appearCancelled,
              duration = data.duration;
            // activeInstance will always be the <transition> component managing this
            // transition. One edge case to check is when the <transition> is placed
            // as the root node of a child component. In that case we need to check
            // <transition>'s parent for appear check.
            var context = activeInstance;
            var transitionNode = activeInstance.$vnode;
            while (transitionNode && transitionNode.parent) {
              context = transitionNode.context;
              transitionNode = transitionNode.parent;
            }
            var isAppear = !context._isMounted || !vnode.isRootInsert;
            if (isAppear && !appear && appear !== "") {
              return;
            }
            var startClass = isAppear && appearClass ? appearClass : enterClass;
            var activeClass =
              isAppear && appearActiveClass
                ? appearActiveClass
                : enterActiveClass;
            var toClass =
              isAppear && appearToClass ? appearToClass : enterToClass;
            var beforeEnterHook = isAppear
              ? beforeAppear || beforeEnter
              : beforeEnter;
            var enterHook = isAppear
              ? isFunction(appear)
                ? appear
                : enter
              : enter;
            var afterEnterHook = isAppear
              ? afterAppear || afterEnter
              : afterEnter;
            var enterCancelledHook = isAppear
              ? appearCancelled || enterCancelled
              : enterCancelled;
            var explicitEnterDuration = toNumber(
              isObject(duration) ? duration.enter : duration
            );
            if (explicitEnterDuration != null) {
              checkDuration(explicitEnterDuration, "enter", vnode);
            }
            var expectsCSS = css !== false && !isIE9;
            var userWantsControl = getHookArgumentsLength(enterHook);
            var cb = (el._enterCb = once(function () {
              if (expectsCSS) {
                removeTransitionClass(el, toClass);
                removeTransitionClass(el, activeClass);
              }
              // @ts-expect-error
              if (cb.cancelled) {
                if (expectsCSS) {
                  removeTransitionClass(el, startClass);
                }
                enterCancelledHook && enterCancelledHook(el);
              } else {
                afterEnterHook && afterEnterHook(el);
              }
              el._enterCb = null;
            }));
            if (!vnode.data.show) {
              // remove pending leave element on enter by injecting an insert hook
              mergeVNodeHook(vnode, "insert", function () {
                var parent = el.parentNode;
                var pendingNode =
                  parent && parent._pending && parent._pending[vnode.key];
                if (
                  pendingNode &&
                  pendingNode.tag === vnode.tag &&
                  pendingNode.elm._leaveCb
                ) {
                  pendingNode.elm._leaveCb();
                }
                enterHook && enterHook(el, cb);
              });
            }
            // start enter transition
            beforeEnterHook && beforeEnterHook(el);
            if (expectsCSS) {
              addTransitionClass(el, startClass);
              addTransitionClass(el, activeClass);
              nextFrame(function () {
                removeTransitionClass(el, startClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                  addTransitionClass(el, toClass);
                  if (!userWantsControl) {
                    if (isValidDuration(explicitEnterDuration)) {
                      setTimeout(cb, explicitEnterDuration);
                    } else {
                      whenTransitionEnds(el, type, cb);
                    }
                  }
                }
              });
            }
            if (vnode.data.show) {
              toggleDisplay && toggleDisplay();
              enterHook && enterHook(el, cb);
            }
            if (!expectsCSS && !userWantsControl) {
              cb();
            }
          }
          function leave(vnode, rm) {
            var el = vnode.elm;
            // call enter callback now
            if (isDef(el._enterCb)) {
              el._enterCb.cancelled = true;
              el._enterCb();
            }
            var data = resolveTransition(vnode.data.transition);
            if (isUndef(data) || el.nodeType !== 1) {
              return rm();
            }
            /* istanbul ignore if */
            if (isDef(el._leaveCb)) {
              return;
            }
            var css = data.css,
              type = data.type,
              leaveClass = data.leaveClass,
              leaveToClass = data.leaveToClass,
              leaveActiveClass = data.leaveActiveClass,
              beforeLeave = data.beforeLeave,
              leave = data.leave,
              afterLeave = data.afterLeave,
              leaveCancelled = data.leaveCancelled,
              delayLeave = data.delayLeave,
              duration = data.duration;
            var expectsCSS = css !== false && !isIE9;
            var userWantsControl = getHookArgumentsLength(leave);
            var explicitLeaveDuration = toNumber(
              isObject(duration) ? duration.leave : duration
            );
            if (isDef(explicitLeaveDuration)) {
              checkDuration(explicitLeaveDuration, "leave", vnode);
            }
            var cb = (el._leaveCb = once(function () {
              if (el.parentNode && el.parentNode._pending) {
                el.parentNode._pending[vnode.key] = null;
              }
              if (expectsCSS) {
                removeTransitionClass(el, leaveToClass);
                removeTransitionClass(el, leaveActiveClass);
              }
              // @ts-expect-error
              if (cb.cancelled) {
                if (expectsCSS) {
                  removeTransitionClass(el, leaveClass);
                }
                leaveCancelled && leaveCancelled(el);
              } else {
                rm();
                afterLeave && afterLeave(el);
              }
              el._leaveCb = null;
            }));
            if (delayLeave) {
              delayLeave(performLeave);
            } else {
              performLeave();
            }
            function performLeave() {
              // the delayed leave may have already been cancelled
              // @ts-expect-error
              if (cb.cancelled) {
                return;
              }
              // record leaving element
              if (!vnode.data.show && el.parentNode) {
                (el.parentNode._pending || (el.parentNode._pending = {}))[
                  vnode.key
                ] = vnode;
              }
              beforeLeave && beforeLeave(el);
              if (expectsCSS) {
                addTransitionClass(el, leaveClass);
                addTransitionClass(el, leaveActiveClass);
                nextFrame(function () {
                  removeTransitionClass(el, leaveClass);
                  // @ts-expect-error
                  if (!cb.cancelled) {
                    addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                      if (isValidDuration(explicitLeaveDuration)) {
                        setTimeout(cb, explicitLeaveDuration);
                      } else {
                        whenTransitionEnds(el, type, cb);
                      }
                    }
                  }
                });
              }
              leave && leave(el, cb);
              if (!expectsCSS && !userWantsControl) {
                cb();
              }
            }
          }
          // only used in dev mode
          function checkDuration(val, name, vnode) {
            if (typeof val !== "number") {
              warn$2(
                "<transition> explicit ".concat(
                  name,
                  " duration is not a valid number - "
                ) + "got ".concat(JSON.stringify(val), "."),
                vnode.context
              );
            } else if (isNaN(val)) {
              warn$2(
                "<transition> explicit ".concat(name, " duration is NaN - ") +
                  "the duration expression might be incorrect.",
                vnode.context
              );
            }
          }
          function isValidDuration(val) {
            return typeof val === "number" && !isNaN(val);
          }
          /**
           * Normalize a transition hook's argument length. The hook may be:
           * - a merged hook (invoker) with the original in .fns
           * - a wrapped component method (check ._length)
           * - a plain function (.length)
           */
          function getHookArgumentsLength(fn) {
            if (isUndef(fn)) {
              return false;
            }
            // @ts-expect-error
            var invokerFns = fn.fns;
            if (isDef(invokerFns)) {
              // invoker
              return getHookArgumentsLength(
                Array.isArray(invokerFns) ? invokerFns[0] : invokerFns
              );
            } else {
              // @ts-expect-error
              return (fn._length || fn.length) > 1;
            }
          }
          function _enter(_, vnode) {
            if (vnode.data.show !== true) {
              enter(vnode);
            }
          }
          var transition = inBrowser
            ? {
                create: _enter,
                activate: _enter,
                remove: function (vnode, rm) {
                  /* istanbul ignore else */
                  if (vnode.data.show !== true) {
                    // @ts-expect-error
                    leave(vnode, rm);
                  } else {
                    rm();
                  }
                },
              }
            : {};

          var platformModules = [
            attrs,
            klass$1,
            events,
            domProps,
            style$1,
            transition,
          ];

          // the directive module should be applied last, after all
          // built-in modules have been applied.
          var modules$1 = platformModules.concat(baseModules);
          var patch = createPatchFunction({
            nodeOps: nodeOps,
            modules: modules$1,
          });

          /**
           * Not type checking this file because flow doesn't like attaching
           * properties to Elements.
           */
          /* istanbul ignore if */
          if (isIE9) {
            // http://www.matts411.com/post/internet-explorer-9-oninput/
            document.addEventListener("selectionchange", function () {
              var el = document.activeElement;
              // @ts-expect-error
              if (el && el.vmodel) {
                trigger(el, "input");
              }
            });
          }
          var directive = {
            inserted: function (el, binding, vnode, oldVnode) {
              if (vnode.tag === "select") {
                // #6903
                if (oldVnode.elm && !oldVnode.elm._vOptions) {
                  mergeVNodeHook(vnode, "postpatch", function () {
                    directive.componentUpdated(el, binding, vnode);
                  });
                } else {
                  setSelected(el, binding, vnode.context);
                }
                el._vOptions = [].map.call(el.options, getValue);
              } else if (vnode.tag === "textarea" || isTextInputType(el.type)) {
                el._vModifiers = binding.modifiers;
                if (!binding.modifiers.lazy) {
                  el.addEventListener("compositionstart", onCompositionStart);
                  el.addEventListener("compositionend", onCompositionEnd);
                  // Safari < 10.2 & UIWebView doesn't fire compositionend when
                  // switching focus before confirming composition choice
                  // this also fixes the issue where some browsers e.g. iOS Chrome
                  // fires "change" instead of "input" on autocomplete.
                  el.addEventListener("change", onCompositionEnd);
                  /* istanbul ignore if */
                  if (isIE9) {
                    el.vmodel = true;
                  }
                }
              }
            },
            componentUpdated: function (el, binding, vnode) {
              if (vnode.tag === "select") {
                setSelected(el, binding, vnode.context);
                // in case the options rendered by v-for have changed,
                // it's possible that the value is out-of-sync with the rendered options.
                // detect such cases and filter out values that no longer has a matching
                // option in the DOM.
                var prevOptions_1 = el._vOptions;
                var curOptions_1 = (el._vOptions = [].map.call(
                  el.options,
                  getValue
                ));
                if (
                  curOptions_1.some(function (o, i) {
                    return !looseEqual(o, prevOptions_1[i]);
                  })
                ) {
                  // trigger change event if
                  // no matching option found for at least one value
                  var needReset = el.multiple
                    ? binding.value.some(function (v) {
                        return hasNoMatchingOption(v, curOptions_1);
                      })
                    : binding.value !== binding.oldValue &&
                      hasNoMatchingOption(binding.value, curOptions_1);
                  if (needReset) {
                    trigger(el, "change");
                  }
                }
              }
            },
          };
          function setSelected(el, binding, vm) {
            actuallySetSelected(el, binding, vm);
            /* istanbul ignore if */
            if (isIE || isEdge) {
              setTimeout(function () {
                actuallySetSelected(el, binding, vm);
              }, 0);
            }
          }
          function actuallySetSelected(el, binding, vm) {
            var value = binding.value;
            var isMultiple = el.multiple;
            if (isMultiple && !Array.isArray(value)) {
              warn$2(
                '<select multiple v-model="'.concat(binding.expression, '"> ') +
                  "expects an Array value for its binding, but got ".concat(
                    Object.prototype.toString.call(value).slice(8, -1)
                  ),
                vm
              );
              return;
            }
            var selected, option;
            for (var i = 0, l = el.options.length; i < l; i++) {
              option = el.options[i];
              if (isMultiple) {
                selected = looseIndexOf(value, getValue(option)) > -1;
                if (option.selected !== selected) {
                  option.selected = selected;
                }
              } else {
                if (looseEqual(getValue(option), value)) {
                  if (el.selectedIndex !== i) {
                    el.selectedIndex = i;
                  }
                  return;
                }
              }
            }
            if (!isMultiple) {
              el.selectedIndex = -1;
            }
          }
          function hasNoMatchingOption(value, options) {
            return options.every(function (o) {
              return !looseEqual(o, value);
            });
          }
          function getValue(option) {
            return "_value" in option ? option._value : option.value;
          }
          function onCompositionStart(e) {
            e.target.composing = true;
          }
          function onCompositionEnd(e) {
            // prevent triggering an input event for no reason
            if (!e.target.composing) return;
            e.target.composing = false;
            trigger(e.target, "input");
          }
          function trigger(el, type) {
            var e = document.createEvent("HTMLEvents");
            e.initEvent(type, true, true);
            el.dispatchEvent(e);
          }

          // recursively search for possible transition defined inside the component root
          function locateNode(vnode) {
            // @ts-expect-error
            return vnode.componentInstance &&
              (!vnode.data || !vnode.data.transition)
              ? locateNode(vnode.componentInstance._vnode)
              : vnode;
          }
          var show = {
            bind: function (el, _a, vnode) {
              var value = _a.value;
              vnode = locateNode(vnode);
              var transition = vnode.data && vnode.data.transition;
              var originalDisplay = (el.__vOriginalDisplay =
                el.style.display === "none" ? "" : el.style.display);
              if (value && transition) {
                vnode.data.show = true;
                enter(vnode, function () {
                  el.style.display = originalDisplay;
                });
              } else {
                el.style.display = value ? originalDisplay : "none";
              }
            },
            update: function (el, _a, vnode) {
              var value = _a.value,
                oldValue = _a.oldValue;
              /* istanbul ignore if */
              if (!value === !oldValue) return;
              vnode = locateNode(vnode);
              var transition = vnode.data && vnode.data.transition;
              if (transition) {
                vnode.data.show = true;
                if (value) {
                  enter(vnode, function () {
                    el.style.display = el.__vOriginalDisplay;
                  });
                } else {
                  leave(vnode, function () {
                    el.style.display = "none";
                  });
                }
              } else {
                el.style.display = value ? el.__vOriginalDisplay : "none";
              }
            },
            unbind: function (el, binding, vnode, oldVnode, isDestroy) {
              if (!isDestroy) {
                el.style.display = el.__vOriginalDisplay;
              }
            },
          };

          var platformDirectives = {
            model: directive,
            show: show,
          };

          // Provides transition support for a single element/component.
          var transitionProps = {
            name: String,
            appear: Boolean,
            css: Boolean,
            mode: String,
            type: String,
            enterClass: String,
            leaveClass: String,
            enterToClass: String,
            leaveToClass: String,
            enterActiveClass: String,
            leaveActiveClass: String,
            appearClass: String,
            appearActiveClass: String,
            appearToClass: String,
            duration: [Number, String, Object],
          };
          // in case the child is also an abstract component, e.g. <keep-alive>
          // we want to recursively retrieve the real component to be rendered
          function getRealChild(vnode) {
            var compOptions = vnode && vnode.componentOptions;
            if (compOptions && compOptions.Ctor.options.abstract) {
              return getRealChild(getFirstComponentChild(compOptions.children));
            } else {
              return vnode;
            }
          }
          function extractTransitionData(comp) {
            var data = {};
            var options = comp.$options;
            // props
            for (var key in options.propsData) {
              data[key] = comp[key];
            }
            // events.
            // extract listeners and pass them directly to the transition methods
            var listeners = options._parentListeners;
            for (var key in listeners) {
              data[camelize(key)] = listeners[key];
            }
            return data;
          }
          function placeholder(h, rawChild) {
            // @ts-expect-error
            if (/\d-keep-alive$/.test(rawChild.tag)) {
              return h("keep-alive", {
                props: rawChild.componentOptions.propsData,
              });
            }
          }
          function hasParentTransition(vnode) {
            while ((vnode = vnode.parent)) {
              if (vnode.data.transition) {
                return true;
              }
            }
          }
          function isSameChild(child, oldChild) {
            return oldChild.key === child.key && oldChild.tag === child.tag;
          }
          var isNotTextNode = function (c) {
            return c.tag || isAsyncPlaceholder(c);
          };
          var isVShowDirective = function (d) {
            return d.name === "show";
          };
          var Transition = {
            name: "transition",
            props: transitionProps,
            abstract: true,
            render: function (h) {
              var _this = this;
              var children = this.$slots.default;
              if (!children) {
                return;
              }
              // filter out text nodes (possible whitespaces)
              children = children.filter(isNotTextNode);
              /* istanbul ignore if */
              if (!children.length) {
                return;
              }
              // warn multiple elements
              if (children.length > 1) {
                warn$2(
                  "<transition> can only be used on a single element. Use " +
                    "<transition-group> for lists.",
                  this.$parent
                );
              }
              var mode = this.mode;
              // warn invalid mode
              if (mode && mode !== "in-out" && mode !== "out-in") {
                warn$2("invalid <transition> mode: " + mode, this.$parent);
              }
              var rawChild = children[0];
              // if this is a component root node and the component's
              // parent container node also has transition, skip.
              if (hasParentTransition(this.$vnode)) {
                return rawChild;
              }
              // apply transition data to child
              // use getRealChild() to ignore abstract components e.g. keep-alive
              var child = getRealChild(rawChild);
              /* istanbul ignore if */
              if (!child) {
                return rawChild;
              }
              if (this._leaving) {
                return placeholder(h, rawChild);
              }
              // ensure a key that is unique to the vnode type and to this transition
              // component instance. This key will be used to remove pending leaving nodes
              // during entering.
              var id = "__transition-".concat(this._uid, "-");
              child.key =
                child.key == null
                  ? child.isComment
                    ? id + "comment"
                    : id + child.tag
                  : isPrimitive(child.key)
                  ? String(child.key).indexOf(id) === 0
                    ? child.key
                    : id + child.key
                  : child.key;
              var data = ((child.data || (child.data = {})).transition =
                extractTransitionData(this));
              var oldRawChild = this._vnode;
              var oldChild = getRealChild(oldRawChild);
              // mark v-show
              // so that the transition module can hand over the control to the directive
              if (
                child.data.directives &&
                child.data.directives.some(isVShowDirective)
              ) {
                child.data.show = true;
              }
              if (
                oldChild &&
                oldChild.data &&
                !isSameChild(child, oldChild) &&
                !isAsyncPlaceholder(oldChild) &&
                // #6687 component root is a comment node
                !(
                  oldChild.componentInstance &&
                  oldChild.componentInstance._vnode.isComment
                )
              ) {
                // replace old child transition data with fresh one
                // important for dynamic transitions!
                var oldData = (oldChild.data.transition = extend({}, data));
                // handle transition mode
                if (mode === "out-in") {
                  // return placeholder node and queue update when leave finishes
                  this._leaving = true;
                  mergeVNodeHook(oldData, "afterLeave", function () {
                    _this._leaving = false;
                    _this.$forceUpdate();
                  });
                  return placeholder(h, rawChild);
                } else if (mode === "in-out") {
                  if (isAsyncPlaceholder(child)) {
                    return oldRawChild;
                  }
                  var delayedLeave_1;
                  var performLeave = function () {
                    delayedLeave_1();
                  };
                  mergeVNodeHook(data, "afterEnter", performLeave);
                  mergeVNodeHook(data, "enterCancelled", performLeave);
                  mergeVNodeHook(oldData, "delayLeave", function (leave) {
                    delayedLeave_1 = leave;
                  });
                }
              }
              return rawChild;
            },
          };

          // Provides transition support for list items.
          var props = extend(
            {
              tag: String,
              moveClass: String,
            },
            transitionProps
          );
          delete props.mode;
          var TransitionGroup = {
            props: props,
            beforeMount: function () {
              var _this = this;
              var update = this._update;
              this._update = function (vnode, hydrating) {
                var restoreActiveInstance = setActiveInstance(_this);
                // force removing pass
                _this.__patch__(
                  _this._vnode,
                  _this.kept,
                  false, // hydrating
                  true // removeOnly (!important, avoids unnecessary moves)
                );
                _this._vnode = _this.kept;
                restoreActiveInstance();
                update.call(_this, vnode, hydrating);
              };
            },
            render: function (h) {
              var tag = this.tag || this.$vnode.data.tag || "span";
              var map = Object.create(null);
              var prevChildren = (this.prevChildren = this.children);
              var rawChildren = this.$slots.default || [];
              var children = (this.children = []);
              var transitionData = extractTransitionData(this);
              for (var i = 0; i < rawChildren.length; i++) {
                var c = rawChildren[i];
                if (c.tag) {
                  if (c.key != null && String(c.key).indexOf("__vlist") !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                  } else {
                    var opts = c.componentOptions;
                    var name_1 = opts
                      ? getComponentName(opts.Ctor.options) || opts.tag || ""
                      : c.tag;
                    warn$2(
                      "<transition-group> children must be keyed: <".concat(
                        name_1,
                        ">"
                      )
                    );
                  }
                }
              }
              if (prevChildren) {
                var kept = [];
                var removed = [];
                for (var i = 0; i < prevChildren.length; i++) {
                  var c = prevChildren[i];
                  c.data.transition = transitionData;
                  // @ts-expect-error .getBoundingClientRect is not typed in Node
                  c.data.pos = c.elm.getBoundingClientRect();
                  if (map[c.key]) {
                    kept.push(c);
                  } else {
                    removed.push(c);
                  }
                }
                this.kept = h(tag, null, kept);
                this.removed = removed;
              }
              return h(tag, null, children);
            },
            updated: function () {
              var children = this.prevChildren;
              var moveClass = this.moveClass || (this.name || "v") + "-move";
              if (
                !children.length ||
                !this.hasMove(children[0].elm, moveClass)
              ) {
                return;
              }
              // we divide the work into three loops to avoid mixing DOM reads and writes
              // in each iteration - which helps prevent layout thrashing.
              children.forEach(callPendingCbs);
              children.forEach(recordPosition);
              children.forEach(applyTranslation);
              // force reflow to put everything in position
              // assign to this to avoid being removed in tree-shaking
              // $flow-disable-line
              this._reflow = document.body.offsetHeight;
              children.forEach(function (c) {
                if (c.data.moved) {
                  var el_1 = c.elm;
                  var s = el_1.style;
                  addTransitionClass(el_1, moveClass);
                  s.transform = s.WebkitTransform = s.transitionDuration = "";
                  el_1.addEventListener(
                    transitionEndEvent,
                    (el_1._moveCb = function cb(e) {
                      if (e && e.target !== el_1) {
                        return;
                      }
                      if (!e || /transform$/.test(e.propertyName)) {
                        el_1.removeEventListener(transitionEndEvent, cb);
                        el_1._moveCb = null;
                        removeTransitionClass(el_1, moveClass);
                      }
                    })
                  );
                }
              });
            },
            methods: {
              hasMove: function (el, moveClass) {
                /* istanbul ignore if */
                if (!hasTransition) {
                  return false;
                }
                /* istanbul ignore if */
                if (this._hasMove) {
                  return this._hasMove;
                }
                // Detect whether an element with the move class applied has
                // CSS transitions. Since the element may be inside an entering
                // transition at this very moment, we make a clone of it and remove
                // all other transition classes applied to ensure only the move class
                // is applied.
                var clone = el.cloneNode();
                if (el._transitionClasses) {
                  el._transitionClasses.forEach(function (cls) {
                    removeClass(clone, cls);
                  });
                }
                addClass(clone, moveClass);
                clone.style.display = "none";
                this.$el.appendChild(clone);
                var info = getTransitionInfo(clone);
                this.$el.removeChild(clone);
                return (this._hasMove = info.hasTransform);
              },
            },
          };
          function callPendingCbs(c) {
            /* istanbul ignore if */
            if (c.elm._moveCb) {
              c.elm._moveCb();
            }
            /* istanbul ignore if */
            if (c.elm._enterCb) {
              c.elm._enterCb();
            }
          }
          function recordPosition(c) {
            c.data.newPos = c.elm.getBoundingClientRect();
          }
          function applyTranslation(c) {
            var oldPos = c.data.pos;
            var newPos = c.data.newPos;
            var dx = oldPos.left - newPos.left;
            var dy = oldPos.top - newPos.top;
            if (dx || dy) {
              c.data.moved = true;
              var s = c.elm.style;
              s.transform = s.WebkitTransform = "translate("
                .concat(dx, "px,")
                .concat(dy, "px)");
              s.transitionDuration = "0s";
            }
          }

          var platformComponents = {
            Transition: Transition,
            TransitionGroup: TransitionGroup,
          };

          // install platform specific utils
          Vue.config.mustUseProp = mustUseProp;
          Vue.config.isReservedTag = isReservedTag;
          Vue.config.isReservedAttr = isReservedAttr;
          Vue.config.getTagNamespace = getTagNamespace;
          Vue.config.isUnknownElement = isUnknownElement;
          // install platform runtime directives & components
          extend(Vue.options.directives, platformDirectives);
          extend(Vue.options.components, platformComponents);
          // install platform patch function
          Vue.prototype.__patch__ = inBrowser ? patch : noop;
          // public mount method
          Vue.prototype.$mount = function (el, hydrating) {
            el = el && inBrowser ? query(el) : undefined;
            return mountComponent(this, el, hydrating);
          };
          // devtools global hook
          /* istanbul ignore next */
          if (inBrowser) {
            setTimeout(function () {
              if (config.devtools) {
                if (devtools) {
                  devtools.emit("init", Vue);
                } else {
                  // @ts-expect-error
                  console[console.info ? "info" : "log"](
                    "Download the Vue Devtools extension for a better development experience:\n" +
                      "https://github.com/vuejs/vue-devtools"
                  );
                }
              }
              if (
                config.productionTip !== false &&
                typeof console !== "undefined"
              ) {
                // @ts-expect-error
                console[console.info ? "info" : "log"](
                  "You are running Vue in development mode.\n" +
                    "Make sure to turn on production mode when deploying for production.\n" +
                    "See more tips at https://vuejs.org/guide/deployment.html"
                );
              }
            }, 0);
          }

          var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
          var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
          var buildRegex = cached(function (delimiters) {
            var open = delimiters[0].replace(regexEscapeRE, "\\$&");
            var close = delimiters[1].replace(regexEscapeRE, "\\$&");
            return new RegExp(open + "((?:.|\\n)+?)" + close, "g");
          });
          function parseText(text, delimiters) {
            //@ts-expect-error
            var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
            if (!tagRE.test(text)) {
              return;
            }
            var tokens = [];
            var rawTokens = [];
            var lastIndex = (tagRE.lastIndex = 0);
            var match, index, tokenValue;
            while ((match = tagRE.exec(text))) {
              index = match.index;
              // push text token
              if (index > lastIndex) {
                rawTokens.push((tokenValue = text.slice(lastIndex, index)));
                tokens.push(JSON.stringify(tokenValue));
              }
              // tag token
              var exp = parseFilters(match[1].trim());
              tokens.push("_s(".concat(exp, ")"));
              rawTokens.push({ "@binding": exp });
              lastIndex = index + match[0].length;
            }
            if (lastIndex < text.length) {
              rawTokens.push((tokenValue = text.slice(lastIndex)));
              tokens.push(JSON.stringify(tokenValue));
            }
            return {
              expression: tokens.join("+"),
              tokens: rawTokens,
            };
          }

          function transformNode$1(el, options) {
            var warn = options.warn || baseWarn;
            var staticClass = getAndRemoveAttr(el, "class");
            if (staticClass) {
              var res = parseText(staticClass, options.delimiters);
              if (res) {
                warn(
                  'class="'.concat(staticClass, '": ') +
                    "Interpolation inside attributes has been removed. " +
                    "Use v-bind or the colon shorthand instead. For example, " +
                    'instead of <div class="{{ val }}">, use <div :class="val">.',
                  el.rawAttrsMap["class"]
                );
              }
            }
            if (staticClass) {
              el.staticClass = JSON.stringify(
                staticClass.replace(/\s+/g, " ").trim()
              );
            }
            var classBinding = getBindingAttr(
              el,
              "class",
              false /* getStatic */
            );
            if (classBinding) {
              el.classBinding = classBinding;
            }
          }
          function genData$2(el) {
            var data = "";
            if (el.staticClass) {
              data += "staticClass:".concat(el.staticClass, ",");
            }
            if (el.classBinding) {
              data += "class:".concat(el.classBinding, ",");
            }
            return data;
          }
          var klass = {
            staticKeys: ["staticClass"],
            transformNode: transformNode$1,
            genData: genData$2,
          };

          function transformNode(el, options) {
            var warn = options.warn || baseWarn;
            var staticStyle = getAndRemoveAttr(el, "style");
            if (staticStyle) {
              /* istanbul ignore if */
              {
                var res = parseText(staticStyle, options.delimiters);
                if (res) {
                  warn(
                    'style="'.concat(staticStyle, '": ') +
                      "Interpolation inside attributes has been removed. " +
                      "Use v-bind or the colon shorthand instead. For example, " +
                      'instead of <div style="{{ val }}">, use <div :style="val">.',
                    el.rawAttrsMap["style"]
                  );
                }
              }
              el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
            }
            var styleBinding = getBindingAttr(
              el,
              "style",
              false /* getStatic */
            );
            if (styleBinding) {
              el.styleBinding = styleBinding;
            }
          }
          function genData$1(el) {
            var data = "";
            if (el.staticStyle) {
              data += "staticStyle:".concat(el.staticStyle, ",");
            }
            if (el.styleBinding) {
              data += "style:(".concat(el.styleBinding, "),");
            }
            return data;
          }
          var style = {
            staticKeys: ["staticStyle"],
            transformNode: transformNode,
            genData: genData$1,
          };

          var decoder;
          var he = {
            decode: function (html) {
              decoder = decoder || document.createElement("div");
              decoder.innerHTML = html;
              return decoder.textContent;
            },
          };

          var isUnaryTag = makeMap(
            "area,base,br,col,embed,frame,hr,img,input,isindex,keygen," +
              "link,meta,param,source,track,wbr"
          );
          // Elements that you can, intentionally, leave open
          // (and which close themselves)
          var canBeLeftOpenTag = makeMap(
            "colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"
          );
          // HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
          // Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
          var isNonPhrasingTag = makeMap(
            "address,article,aside,base,blockquote,body,caption,col,colgroup,dd," +
              "details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form," +
              "h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta," +
              "optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead," +
              "title,tr,track"
          );

          /**
           * Not type-checking this file because it's mostly vendor code.
           */
          // Regular Expressions for parsing tags and attributes
          var attribute =
            /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
          var dynamicArgAttribute =
            /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
          var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z".concat(
            unicodeRegExp.source,
            "]*"
          );
          var qnameCapture = "((?:".concat(ncname, "\\:)?").concat(ncname, ")");
          var startTagOpen = new RegExp("^<".concat(qnameCapture));
          var startTagClose = /^\s*(\/?)>/;
          var endTag = new RegExp("^<\\/".concat(qnameCapture, "[^>]*>"));
          var doctype = /^<!DOCTYPE [^>]+>/i;
          // #7298: escape - to avoid being passed as HTML comment when inlined in page
          var comment = /^<!\--/;
          var conditionalComment = /^<!\[/;
          // Special Elements (can contain anything)
          var isPlainTextElement = makeMap("script,style,textarea", true);
          var reCache = {};
          var decodingMap = {
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&amp;": "&",
            "&#10;": "\n",
            "&#9;": "\t",
            "&#39;": "'",
          };
          var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
          var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;
          // #5992
          var isIgnoreNewlineTag = makeMap("pre,textarea", true);
          var shouldIgnoreFirstNewline = function (tag, html) {
            return tag && isIgnoreNewlineTag(tag) && html[0] === "\n";
          };
          function decodeAttr(value, shouldDecodeNewlines) {
            var re = shouldDecodeNewlines
              ? encodedAttrWithNewLines
              : encodedAttr;
            return value.replace(re, function (match) {
              return decodingMap[match];
            });
          }
          function parseHTML(html, options) {
            var stack = [];
            var expectHTML = options.expectHTML;
            var isUnaryTag = options.isUnaryTag || no;
            var canBeLeftOpenTag = options.canBeLeftOpenTag || no;
            var index = 0;
            var last, lastTag;
            var _loop_1 = function () {
              last = html;
              // Make sure we're not in a plaintext content element like script/style
              if (!lastTag || !isPlainTextElement(lastTag)) {
                var textEnd = html.indexOf("<");
                if (textEnd === 0) {
                  // Comment:
                  if (comment.test(html)) {
                    var commentEnd = html.indexOf("-->");
                    if (commentEnd >= 0) {
                      if (options.shouldKeepComment && options.comment) {
                        options.comment(
                          html.substring(4, commentEnd),
                          index,
                          index + commentEnd + 3
                        );
                      }
                      advance(commentEnd + 3);
                      return "continue";
                    }
                  }
                  // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
                  if (conditionalComment.test(html)) {
                    var conditionalEnd = html.indexOf("]>");
                    if (conditionalEnd >= 0) {
                      advance(conditionalEnd + 2);
                      return "continue";
                    }
                  }
                  // Doctype:
                  var doctypeMatch = html.match(doctype);
                  if (doctypeMatch) {
                    advance(doctypeMatch[0].length);
                    return "continue";
                  }
                  // End tag:
                  var endTagMatch = html.match(endTag);
                  if (endTagMatch) {
                    var curIndex = index;
                    advance(endTagMatch[0].length);
                    parseEndTag(endTagMatch[1], curIndex, index);
                    return "continue";
                  }
                  // Start tag:
                  var startTagMatch = parseStartTag();
                  if (startTagMatch) {
                    handleStartTag(startTagMatch);
                    if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
                      advance(1);
                    }
                    return "continue";
                  }
                }
                var text = void 0,
                  rest = void 0,
                  next = void 0;
                if (textEnd >= 0) {
                  rest = html.slice(textEnd);
                  while (
                    !endTag.test(rest) &&
                    !startTagOpen.test(rest) &&
                    !comment.test(rest) &&
                    !conditionalComment.test(rest)
                  ) {
                    // < in plain text, be forgiving and treat it as text
                    next = rest.indexOf("<", 1);
                    if (next < 0) break;
                    textEnd += next;
                    rest = html.slice(textEnd);
                  }
                  text = html.substring(0, textEnd);
                }
                if (textEnd < 0) {
                  text = html;
                }
                if (text) {
                  advance(text.length);
                }
                if (options.chars && text) {
                  options.chars(text, index - text.length, index);
                }
              } else {
                var endTagLength_1 = 0;
                var stackedTag_1 = lastTag.toLowerCase();
                var reStackedTag =
                  reCache[stackedTag_1] ||
                  (reCache[stackedTag_1] = new RegExp(
                    "([\\s\\S]*?)(</" + stackedTag_1 + "[^>]*>)",
                    "i"
                  ));
                var rest = html.replace(
                  reStackedTag,
                  function (all, text, endTag) {
                    endTagLength_1 = endTag.length;
                    if (
                      !isPlainTextElement(stackedTag_1) &&
                      stackedTag_1 !== "noscript"
                    ) {
                      text = text
                        .replace(/<!\--([\s\S]*?)-->/g, "$1") // #7298
                        .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, "$1");
                    }
                    if (shouldIgnoreFirstNewline(stackedTag_1, text)) {
                      text = text.slice(1);
                    }
                    if (options.chars) {
                      options.chars(text);
                    }
                    return "";
                  }
                );
                index += html.length - rest.length;
                html = rest;
                parseEndTag(stackedTag_1, index - endTagLength_1, index);
              }
              if (html === last) {
                options.chars && options.chars(html);
                if (!stack.length && options.warn) {
                  options.warn(
                    'Mal-formatted tag at end of template: "'.concat(html, '"'),
                    {
                      start: index + html.length,
                    }
                  );
                }
                return "break";
              }
            };
            while (html) {
              var state_1 = _loop_1();
              if (state_1 === "break") break;
            }
            // Clean up any remaining tags
            parseEndTag();
            function advance(n) {
              index += n;
              html = html.substring(n);
            }
            function parseStartTag() {
              var start = html.match(startTagOpen);
              if (start) {
                var match = {
                  tagName: start[1],
                  attrs: [],
                  start: index,
                };
                advance(start[0].length);
                var end = void 0,
                  attr = void 0;
                while (
                  !(end = html.match(startTagClose)) &&
                  (attr =
                    html.match(dynamicArgAttribute) || html.match(attribute))
                ) {
                  attr.start = index;
                  advance(attr[0].length);
                  attr.end = index;
                  match.attrs.push(attr);
                }
                if (end) {
                  match.unarySlash = end[1];
                  advance(end[0].length);
                  match.end = index;
                  return match;
                }
              }
            }
            function handleStartTag(match) {
              var tagName = match.tagName;
              var unarySlash = match.unarySlash;
              if (expectHTML) {
                if (lastTag === "p" && isNonPhrasingTag(tagName)) {
                  parseEndTag(lastTag);
                }
                if (canBeLeftOpenTag(tagName) && lastTag === tagName) {
                  parseEndTag(tagName);
                }
              }
              var unary = isUnaryTag(tagName) || !!unarySlash;
              var l = match.attrs.length;
              var attrs = new Array(l);
              for (var i = 0; i < l; i++) {
                var args = match.attrs[i];
                var value = args[3] || args[4] || args[5] || "";
                var shouldDecodeNewlines =
                  tagName === "a" && args[1] === "href"
                    ? options.shouldDecodeNewlinesForHref
                    : options.shouldDecodeNewlines;
                attrs[i] = {
                  name: args[1],
                  value: decodeAttr(value, shouldDecodeNewlines),
                };
                if (options.outputSourceRange) {
                  attrs[i].start = args.start + args[0].match(/^\s*/).length;
                  attrs[i].end = args.end;
                }
              }
              if (!unary) {
                stack.push({
                  tag: tagName,
                  lowerCasedTag: tagName.toLowerCase(),
                  attrs: attrs,
                  start: match.start,
                  end: match.end,
                });
                lastTag = tagName;
              }
              if (options.start) {
                options.start(tagName, attrs, unary, match.start, match.end);
              }
            }
            function parseEndTag(tagName, start, end) {
              var pos, lowerCasedTagName;
              if (start == null) start = index;
              if (end == null) end = index;
              // Find the closest opened tag of the same type
              if (tagName) {
                lowerCasedTagName = tagName.toLowerCase();
                for (pos = stack.length - 1; pos >= 0; pos--) {
                  if (stack[pos].lowerCasedTag === lowerCasedTagName) {
                    break;
                  }
                }
              } else {
                // If no tag name is provided, clean shop
                pos = 0;
              }
              if (pos >= 0) {
                // Close all the open elements, up the stack
                for (var i = stack.length - 1; i >= pos; i--) {
                  if ((i > pos || !tagName) && options.warn) {
                    options.warn(
                      "tag <".concat(
                        stack[i].tag,
                        "> has no matching end tag."
                      ),
                      {
                        start: stack[i].start,
                        end: stack[i].end,
                      }
                    );
                  }
                  if (options.end) {
                    options.end(stack[i].tag, start, end);
                  }
                }
                // Remove the open elements from the stack
                stack.length = pos;
                lastTag = pos && stack[pos - 1].tag;
              } else if (lowerCasedTagName === "br") {
                if (options.start) {
                  options.start(tagName, [], true, start, end);
                }
              } else if (lowerCasedTagName === "p") {
                if (options.start) {
                  options.start(tagName, [], false, start, end);
                }
                if (options.end) {
                  options.end(tagName, start, end);
                }
              }
            }
          }

          var onRE = /^@|^v-on:/;
          var dirRE = /^v-|^@|^:|^#/;
          var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
          var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
          var stripParensRE = /^\(|\)$/g;
          var dynamicArgRE = /^\[.*\]$/;
          var argRE = /:(.*)$/;
          var bindRE = /^:|^\.|^v-bind:/;
          var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
          var slotRE = /^v-slot(:|$)|^#/;
          var lineBreakRE = /[\r\n]/;
          var whitespaceRE = /[ \f\t\r\n]+/g;
          var invalidAttributeRE = /[\s"'<>\/=]/;
          var decodeHTMLCached = cached(he.decode);
          var emptySlotScopeToken = "_empty_";
          // configurable state
          var warn;
          var delimiters;
          var transforms;
          var preTransforms;
          var postTransforms;
          var platformIsPreTag;
          var platformMustUseProp;
          var platformGetTagNamespace;
          var maybeComponent;
          function createASTElement(tag, attrs, parent) {
            return {
              type: 1,
              tag: tag,
              attrsList: attrs,
              attrsMap: makeAttrsMap(attrs),
              rawAttrsMap: {},
              parent: parent,
              children: [],
            };
          }
          /**
           * Convert HTML string to AST.
           */
          function parse(template, options) {
            warn = options.warn || baseWarn;
            platformIsPreTag = options.isPreTag || no;
            platformMustUseProp = options.mustUseProp || no;
            platformGetTagNamespace = options.getTagNamespace || no;
            var isReservedTag = options.isReservedTag || no;
            maybeComponent = function (el) {
              return !!(
                el.component ||
                el.attrsMap[":is"] ||
                el.attrsMap["v-bind:is"] ||
                !(el.attrsMap.is
                  ? isReservedTag(el.attrsMap.is)
                  : isReservedTag(el.tag))
              );
            };
            transforms = pluckModuleFunction(options.modules, "transformNode");
            preTransforms = pluckModuleFunction(
              options.modules,
              "preTransformNode"
            );
            postTransforms = pluckModuleFunction(
              options.modules,
              "postTransformNode"
            );
            delimiters = options.delimiters;
            var stack = [];
            var preserveWhitespace = options.preserveWhitespace !== false;
            var whitespaceOption = options.whitespace;
            var root;
            var currentParent;
            var inVPre = false;
            var inPre = false;
            var warned = false;
            function warnOnce(msg, range) {
              if (!warned) {
                warned = true;
                warn(msg, range);
              }
            }
            function closeElement(element) {
              trimEndingWhitespace(element);
              if (!inVPre && !element.processed) {
                element = processElement(element, options);
              }
              // tree management
              if (!stack.length && element !== root) {
                // allow root elements with v-if, v-else-if and v-else
                if (root.if && (element.elseif || element.else)) {
                  {
                    checkRootConstraints(element);
                  }
                  addIfCondition(root, {
                    exp: element.elseif,
                    block: element,
                  });
                } else {
                  warnOnce(
                    "Component template should contain exactly one root element. " +
                      "If you are using v-if on multiple elements, " +
                      "use v-else-if to chain them instead.",
                    { start: element.start }
                  );
                }
              }
              if (currentParent && !element.forbidden) {
                if (element.elseif || element.else) {
                  processIfConditions(element, currentParent);
                } else {
                  if (element.slotScope) {
                    // scoped slot
                    // keep it in the children list so that v-else(-if) conditions can
                    // find it as the prev node.
                    var name_1 = element.slotTarget || '"default"';
                    (currentParent.scopedSlots ||
                      (currentParent.scopedSlots = {}))[name_1] = element;
                  }
                  currentParent.children.push(element);
                  element.parent = currentParent;
                }
              }
              // final children cleanup
              // filter out scoped slots
              element.children = element.children.filter(function (c) {
                return !c.slotScope;
              });
              // remove trailing whitespace node again
              trimEndingWhitespace(element);
              // check pre state
              if (element.pre) {
                inVPre = false;
              }
              if (platformIsPreTag(element.tag)) {
                inPre = false;
              }
              // apply post-transforms
              for (var i = 0; i < postTransforms.length; i++) {
                postTransforms[i](element, options);
              }
            }
            function trimEndingWhitespace(el) {
              // remove trailing whitespace node
              if (!inPre) {
                var lastNode = void 0;
                while (
                  (lastNode = el.children[el.children.length - 1]) &&
                  lastNode.type === 3 &&
                  lastNode.text === " "
                ) {
                  el.children.pop();
                }
              }
            }
            function checkRootConstraints(el) {
              if (el.tag === "slot" || el.tag === "template") {
                warnOnce(
                  "Cannot use <".concat(
                    el.tag,
                    "> as component root element because it may "
                  ) + "contain multiple nodes.",
                  { start: el.start }
                );
              }
              if (el.attrsMap.hasOwnProperty("v-for")) {
                warnOnce(
                  "Cannot use v-for on stateful component root element because " +
                    "it renders multiple elements.",
                  el.rawAttrsMap["v-for"]
                );
              }
            }
            parseHTML(template, {
              warn: warn,
              expectHTML: options.expectHTML,
              isUnaryTag: options.isUnaryTag,
              canBeLeftOpenTag: options.canBeLeftOpenTag,
              shouldDecodeNewlines: options.shouldDecodeNewlines,
              shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
              shouldKeepComment: options.comments,
              outputSourceRange: options.outputSourceRange,
              start: function (tag, attrs, unary, start, end) {
                // check namespace.
                // inherit parent ns if there is one
                var ns =
                  (currentParent && currentParent.ns) ||
                  platformGetTagNamespace(tag);
                // handle IE svg bug
                /* istanbul ignore if */
                if (isIE && ns === "svg") {
                  attrs = guardIESVGBug(attrs);
                }
                var element = createASTElement(tag, attrs, currentParent);
                if (ns) {
                  element.ns = ns;
                }
                {
                  if (options.outputSourceRange) {
                    element.start = start;
                    element.end = end;
                    element.rawAttrsMap = element.attrsList.reduce(function (
                      cumulated,
                      attr
                    ) {
                      cumulated[attr.name] = attr;
                      return cumulated;
                    },
                    {});
                  }
                  attrs.forEach(function (attr) {
                    if (invalidAttributeRE.test(attr.name)) {
                      warn(
                        "Invalid dynamic argument expression: attribute names cannot contain " +
                          "spaces, quotes, <, >, / or =.",
                        options.outputSourceRange
                          ? {
                              start: attr.start + attr.name.indexOf("["),
                              end: attr.start + attr.name.length,
                            }
                          : undefined
                      );
                    }
                  });
                }
                if (isForbiddenTag(element) && !isServerRendering()) {
                  element.forbidden = true;
                  warn(
                    "Templates should only be responsible for mapping the state to the " +
                      "UI. Avoid placing tags with side-effects in your templates, such as " +
                      "<".concat(tag, ">") +
                      ", as they will not be parsed.",
                    { start: element.start }
                  );
                }
                // apply pre-transforms
                for (var i = 0; i < preTransforms.length; i++) {
                  element = preTransforms[i](element, options) || element;
                }
                if (!inVPre) {
                  processPre(element);
                  if (element.pre) {
                    inVPre = true;
                  }
                }
                if (platformIsPreTag(element.tag)) {
                  inPre = true;
                }
                if (inVPre) {
                  processRawAttrs(element);
                } else if (!element.processed) {
                  // structural directives
                  processFor(element);
                  processIf(element);
                  processOnce(element);
                }
                if (!root) {
                  root = element;
                  {
                    checkRootConstraints(root);
                  }
                }
                if (!unary) {
                  currentParent = element;
                  stack.push(element);
                } else {
                  closeElement(element);
                }
              },
              end: function (tag, start, end) {
                var element = stack[stack.length - 1];
                // pop stack
                stack.length -= 1;
                currentParent = stack[stack.length - 1];
                if (options.outputSourceRange) {
                  element.end = end;
                }
                closeElement(element);
              },
              chars: function (text, start, end) {
                if (!currentParent) {
                  {
                    if (text === template) {
                      warnOnce(
                        "Component template requires a root element, rather than just text.",
                        { start: start }
                      );
                    } else if ((text = text.trim())) {
                      warnOnce(
                        'text "'.concat(
                          text,
                          '" outside root element will be ignored.'
                        ),
                        {
                          start: start,
                        }
                      );
                    }
                  }
                  return;
                }
                // IE textarea placeholder bug
                /* istanbul ignore if */
                if (
                  isIE &&
                  currentParent.tag === "textarea" &&
                  currentParent.attrsMap.placeholder === text
                ) {
                  return;
                }
                var children = currentParent.children;
                if (inPre || text.trim()) {
                  text = isTextTag(currentParent)
                    ? text
                    : decodeHTMLCached(text);
                } else if (!children.length) {
                  // remove the whitespace-only node right after an opening tag
                  text = "";
                } else if (whitespaceOption) {
                  if (whitespaceOption === "condense") {
                    // in condense mode, remove the whitespace node if it contains
                    // line break, otherwise condense to a single space
                    text = lineBreakRE.test(text) ? "" : " ";
                  } else {
                    text = " ";
                  }
                } else {
                  text = preserveWhitespace ? " " : "";
                }
                if (text) {
                  if (!inPre && whitespaceOption === "condense") {
                    // condense consecutive whitespaces into single space
                    text = text.replace(whitespaceRE, " ");
                  }
                  var res = void 0;
                  var child = void 0;
                  if (
                    !inVPre &&
                    text !== " " &&
                    (res = parseText(text, delimiters))
                  ) {
                    child = {
                      type: 2,
                      expression: res.expression,
                      tokens: res.tokens,
                      text: text,
                    };
                  } else if (
                    text !== " " ||
                    !children.length ||
                    children[children.length - 1].text !== " "
                  ) {
                    child = {
                      type: 3,
                      text: text,
                    };
                  }
                  if (child) {
                    if (options.outputSourceRange) {
                      child.start = start;
                      child.end = end;
                    }
                    children.push(child);
                  }
                }
              },
              comment: function (text, start, end) {
                // adding anything as a sibling to the root node is forbidden
                // comments should still be allowed, but ignored
                if (currentParent) {
                  var child = {
                    type: 3,
                    text: text,
                    isComment: true,
                  };
                  if (options.outputSourceRange) {
                    child.start = start;
                    child.end = end;
                  }
                  currentParent.children.push(child);
                }
              },
            });
            return root;
          }
          function processPre(el) {
            if (getAndRemoveAttr(el, "v-pre") != null) {
              el.pre = true;
            }
          }
          function processRawAttrs(el) {
            var list = el.attrsList;
            var len = list.length;
            if (len) {
              var attrs = (el.attrs = new Array(len));
              for (var i = 0; i < len; i++) {
                attrs[i] = {
                  name: list[i].name,
                  value: JSON.stringify(list[i].value),
                };
                if (list[i].start != null) {
                  attrs[i].start = list[i].start;
                  attrs[i].end = list[i].end;
                }
              }
            } else if (!el.pre) {
              // non root node in pre blocks with no attributes
              el.plain = true;
            }
          }
          function processElement(element, options) {
            processKey(element);
            // determine whether this is a plain element after
            // removing structural attributes
            element.plain =
              !element.key && !element.scopedSlots && !element.attrsList.length;
            processRef(element);
            processSlotContent(element);
            processSlotOutlet(element);
            processComponent(element);
            for (var i = 0; i < transforms.length; i++) {
              element = transforms[i](element, options) || element;
            }
            processAttrs(element);
            return element;
          }
          function processKey(el) {
            var exp = getBindingAttr(el, "key");
            if (exp) {
              {
                if (el.tag === "template") {
                  warn(
                    "<template> cannot be keyed. Place the key on real elements instead.",
                    getRawBindingAttr(el, "key")
                  );
                }
                if (el.for) {
                  var iterator = el.iterator2 || el.iterator1;
                  var parent_1 = el.parent;
                  if (
                    iterator &&
                    iterator === exp &&
                    parent_1 &&
                    parent_1.tag === "transition-group"
                  ) {
                    warn(
                      "Do not use v-for index as key on <transition-group> children, " +
                        "this is the same as not using keys.",
                      getRawBindingAttr(el, "key"),
                      true /* tip */
                    );
                  }
                }
              }
              el.key = exp;
            }
          }
          function processRef(el) {
            var ref = getBindingAttr(el, "ref");
            if (ref) {
              el.ref = ref;
              el.refInFor = checkInFor(el);
            }
          }
          function processFor(el) {
            var exp;
            if ((exp = getAndRemoveAttr(el, "v-for"))) {
              var res = parseFor(exp);
              if (res) {
                extend(el, res);
              } else {
                warn(
                  "Invalid v-for expression: ".concat(exp),
                  el.rawAttrsMap["v-for"]
                );
              }
            }
          }
          function parseFor(exp) {
            var inMatch = exp.match(forAliasRE);
            if (!inMatch) return;
            var res = {};
            res.for = inMatch[2].trim();
            var alias = inMatch[1].trim().replace(stripParensRE, "");
            var iteratorMatch = alias.match(forIteratorRE);
            if (iteratorMatch) {
              res.alias = alias.replace(forIteratorRE, "").trim();
              res.iterator1 = iteratorMatch[1].trim();
              if (iteratorMatch[2]) {
                res.iterator2 = iteratorMatch[2].trim();
              }
            } else {
              res.alias = alias;
            }
            return res;
          }
          function processIf(el) {
            var exp = getAndRemoveAttr(el, "v-if");
            if (exp) {
              el.if = exp;
              addIfCondition(el, {
                exp: exp,
                block: el,
              });
            } else {
              if (getAndRemoveAttr(el, "v-else") != null) {
                el.else = true;
              }
              var elseif = getAndRemoveAttr(el, "v-else-if");
              if (elseif) {
                el.elseif = elseif;
              }
            }
          }
          function processIfConditions(el, parent) {
            var prev = findPrevElement(parent.children);
            if (prev && prev.if) {
              addIfCondition(prev, {
                exp: el.elseif,
                block: el,
              });
            } else {
              warn(
                "v-".concat(
                  el.elseif ? 'else-if="' + el.elseif + '"' : "else",
                  " "
                ) +
                  "used on element <".concat(
                    el.tag,
                    "> without corresponding v-if."
                  ),
                el.rawAttrsMap[el.elseif ? "v-else-if" : "v-else"]
              );
            }
          }
          function findPrevElement(children) {
            var i = children.length;
            while (i--) {
              if (children[i].type === 1) {
                return children[i];
              } else {
                if (children[i].text !== " ") {
                  warn(
                    'text "'.concat(
                      children[i].text.trim(),
                      '" between v-if and v-else(-if) '
                    ) + "will be ignored.",
                    children[i]
                  );
                }
                children.pop();
              }
            }
          }
          function addIfCondition(el, condition) {
            if (!el.ifConditions) {
              el.ifConditions = [];
            }
            el.ifConditions.push(condition);
          }
          function processOnce(el) {
            var once = getAndRemoveAttr(el, "v-once");
            if (once != null) {
              el.once = true;
            }
          }
          // handle content being passed to a component as slot,
          // e.g. <template slot="xxx">, <div slot-scope="xxx">
          function processSlotContent(el) {
            var slotScope;
            if (el.tag === "template") {
              slotScope = getAndRemoveAttr(el, "scope");
              /* istanbul ignore if */
              if (slotScope) {
                warn(
                  'the "scope" attribute for scoped slots have been deprecated and ' +
                    'replaced by "slot-scope" since 2.5. The new "slot-scope" attribute ' +
                    "can also be used on plain elements in addition to <template> to " +
                    "denote scoped slots.",
                  el.rawAttrsMap["scope"],
                  true
                );
              }
              el.slotScope = slotScope || getAndRemoveAttr(el, "slot-scope");
            } else if ((slotScope = getAndRemoveAttr(el, "slot-scope"))) {
              /* istanbul ignore if */
              if (el.attrsMap["v-for"]) {
                warn(
                  "Ambiguous combined usage of slot-scope and v-for on <".concat(
                    el.tag,
                    "> "
                  ) +
                    "(v-for takes higher priority). Use a wrapper <template> for the " +
                    "scoped slot to make it clearer.",
                  el.rawAttrsMap["slot-scope"],
                  true
                );
              }
              el.slotScope = slotScope;
            }
            // slot="xxx"
            var slotTarget = getBindingAttr(el, "slot");
            if (slotTarget) {
              el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
              el.slotTargetDynamic = !!(
                el.attrsMap[":slot"] || el.attrsMap["v-bind:slot"]
              );
              // preserve slot as an attribute for native shadow DOM compat
              // only for non-scoped slots.
              if (el.tag !== "template" && !el.slotScope) {
                addAttr(el, "slot", slotTarget, getRawBindingAttr(el, "slot"));
              }
            }
            // 2.6 v-slot syntax
            {
              if (el.tag === "template") {
                // v-slot on <template>
                var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
                if (slotBinding) {
                  {
                    if (el.slotTarget || el.slotScope) {
                      warn(
                        "Unexpected mixed usage of different slot syntaxes.",
                        el
                      );
                    }
                    if (el.parent && !maybeComponent(el.parent)) {
                      warn(
                        "<template v-slot> can only appear at the root level inside " +
                          "the receiving component",
                        el
                      );
                    }
                  }
                  var _a = getSlotName(slotBinding),
                    name_2 = _a.name,
                    dynamic = _a.dynamic;
                  el.slotTarget = name_2;
                  el.slotTargetDynamic = dynamic;
                  el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
                }
              } else {
                // v-slot on component, denotes default slot
                var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
                if (slotBinding) {
                  {
                    if (!maybeComponent(el)) {
                      warn(
                        "v-slot can only be used on components or <template>.",
                        slotBinding
                      );
                    }
                    if (el.slotScope || el.slotTarget) {
                      warn(
                        "Unexpected mixed usage of different slot syntaxes.",
                        el
                      );
                    }
                    if (el.scopedSlots) {
                      warn(
                        "To avoid scope ambiguity, the default slot should also use " +
                          "<template> syntax when there are other named slots.",
                        slotBinding
                      );
                    }
                  }
                  // add the component's children to its default slot
                  var slots = el.scopedSlots || (el.scopedSlots = {});
                  var _b = getSlotName(slotBinding),
                    name_3 = _b.name,
                    dynamic = _b.dynamic;
                  var slotContainer_1 = (slots[name_3] = createASTElement(
                    "template",
                    [],
                    el
                  ));
                  slotContainer_1.slotTarget = name_3;
                  slotContainer_1.slotTargetDynamic = dynamic;
                  slotContainer_1.children = el.children.filter(function (c) {
                    if (!c.slotScope) {
                      c.parent = slotContainer_1;
                      return true;
                    }
                  });
                  slotContainer_1.slotScope =
                    slotBinding.value || emptySlotScopeToken;
                  // remove children as they are returned from scopedSlots now
                  el.children = [];
                  // mark el non-plain so data gets generated
                  el.plain = false;
                }
              }
            }
          }
          function getSlotName(binding) {
            var name = binding.name.replace(slotRE, "");
            if (!name) {
              if (binding.name[0] !== "#") {
                name = "default";
              } else {
                warn("v-slot shorthand syntax requires a slot name.", binding);
              }
            }
            return dynamicArgRE.test(name)
              ? // dynamic [name]
                { name: name.slice(1, -1), dynamic: true }
              : // static name
                { name: '"'.concat(name, '"'), dynamic: false };
          }
          // handle <slot/> outlets
          function processSlotOutlet(el) {
            if (el.tag === "slot") {
              el.slotName = getBindingAttr(el, "name");
              if (el.key) {
                warn(
                  "`key` does not work on <slot> because slots are abstract outlets " +
                    "and can possibly expand into multiple elements. " +
                    "Use the key on a wrapping element instead.",
                  getRawBindingAttr(el, "key")
                );
              }
            }
          }
          function processComponent(el) {
            var binding;
            if ((binding = getBindingAttr(el, "is"))) {
              el.component = binding;
            }
            if (getAndRemoveAttr(el, "inline-template") != null) {
              el.inlineTemplate = true;
            }
          }
          function processAttrs(el) {
            var list = el.attrsList;
            var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
            for (i = 0, l = list.length; i < l; i++) {
              name = rawName = list[i].name;
              value = list[i].value;
              if (dirRE.test(name)) {
                // mark element as dynamic
                el.hasBindings = true;
                // modifiers
                modifiers = parseModifiers(name.replace(dirRE, ""));
                // support .foo shorthand syntax for the .prop modifier
                if (modifiers) {
                  name = name.replace(modifierRE, "");
                }
                if (bindRE.test(name)) {
                  // v-bind
                  name = name.replace(bindRE, "");
                  value = parseFilters(value);
                  isDynamic = dynamicArgRE.test(name);
                  if (isDynamic) {
                    name = name.slice(1, -1);
                  }
                  if (value.trim().length === 0) {
                    warn(
                      'The value for a v-bind expression cannot be empty. Found in "v-bind:'.concat(
                        name,
                        '"'
                      )
                    );
                  }
                  if (modifiers) {
                    if (modifiers.prop && !isDynamic) {
                      name = camelize(name);
                      if (name === "innerHtml") name = "innerHTML";
                    }
                    if (modifiers.camel && !isDynamic) {
                      name = camelize(name);
                    }
                    if (modifiers.sync) {
                      syncGen = genAssignmentCode(value, "$event");
                      if (!isDynamic) {
                        addHandler(
                          el,
                          "update:".concat(camelize(name)),
                          syncGen,
                          null,
                          false,
                          warn,
                          list[i]
                        );
                        if (hyphenate(name) !== camelize(name)) {
                          addHandler(
                            el,
                            "update:".concat(hyphenate(name)),
                            syncGen,
                            null,
                            false,
                            warn,
                            list[i]
                          );
                        }
                      } else {
                        // handler w/ dynamic event name
                        addHandler(
                          el,
                          '"update:"+('.concat(name, ")"),
                          syncGen,
                          null,
                          false,
                          warn,
                          list[i],
                          true // dynamic
                        );
                      }
                    }
                  }
                  if (
                    (modifiers && modifiers.prop) ||
                    (!el.component &&
                      platformMustUseProp(el.tag, el.attrsMap.type, name))
                  ) {
                    addProp(el, name, value, list[i], isDynamic);
                  } else {
                    addAttr(el, name, value, list[i], isDynamic);
                  }
                } else if (onRE.test(name)) {
                  // v-on
                  name = name.replace(onRE, "");
                  isDynamic = dynamicArgRE.test(name);
                  if (isDynamic) {
                    name = name.slice(1, -1);
                  }
                  addHandler(
                    el,
                    name,
                    value,
                    modifiers,
                    false,
                    warn,
                    list[i],
                    isDynamic
                  );
                } else {
                  // normal directives
                  name = name.replace(dirRE, "");
                  // parse arg
                  var argMatch = name.match(argRE);
                  var arg = argMatch && argMatch[1];
                  isDynamic = false;
                  if (arg) {
                    name = name.slice(0, -(arg.length + 1));
                    if (dynamicArgRE.test(arg)) {
                      arg = arg.slice(1, -1);
                      isDynamic = true;
                    }
                  }
                  addDirective(
                    el,
                    name,
                    rawName,
                    value,
                    arg,
                    isDynamic,
                    modifiers,
                    list[i]
                  );
                  if (name === "model") {
                    checkForAliasModel(el, value);
                  }
                }
              } else {
                // literal attribute
                {
                  var res = parseText(value, delimiters);
                  if (res) {
                    warn(
                      "".concat(name, '="').concat(value, '": ') +
                        "Interpolation inside attributes has been removed. " +
                        "Use v-bind or the colon shorthand instead. For example, " +
                        'instead of <div id="{{ val }}">, use <div :id="val">.',
                      list[i]
                    );
                  }
                }
                addAttr(el, name, JSON.stringify(value), list[i]);
                // #6887 firefox doesn't update muted state if set via attribute
                // even immediately after element creation
                if (
                  !el.component &&
                  name === "muted" &&
                  platformMustUseProp(el.tag, el.attrsMap.type, name)
                ) {
                  addProp(el, name, "true", list[i]);
                }
              }
            }
          }
          function checkInFor(el) {
            var parent = el;
            while (parent) {
              if (parent.for !== undefined) {
                return true;
              }
              parent = parent.parent;
            }
            return false;
          }
          function parseModifiers(name) {
            var match = name.match(modifierRE);
            if (match) {
              var ret_1 = {};
              match.forEach(function (m) {
                ret_1[m.slice(1)] = true;
              });
              return ret_1;
            }
          }
          function makeAttrsMap(attrs) {
            var map = {};
            for (var i = 0, l = attrs.length; i < l; i++) {
              if (map[attrs[i].name] && !isIE && !isEdge) {
                warn("duplicate attribute: " + attrs[i].name, attrs[i]);
              }
              map[attrs[i].name] = attrs[i].value;
            }
            return map;
          }
          // for script (e.g. type="x/template") or style, do not decode content
          function isTextTag(el) {
            return el.tag === "script" || el.tag === "style";
          }
          function isForbiddenTag(el) {
            return (
              el.tag === "style" ||
              (el.tag === "script" &&
                (!el.attrsMap.type || el.attrsMap.type === "text/javascript"))
            );
          }
          var ieNSBug = /^xmlns:NS\d+/;
          var ieNSPrefix = /^NS\d+:/;
          /* istanbul ignore next */
          function guardIESVGBug(attrs) {
            var res = [];
            for (var i = 0; i < attrs.length; i++) {
              var attr = attrs[i];
              if (!ieNSBug.test(attr.name)) {
                attr.name = attr.name.replace(ieNSPrefix, "");
                res.push(attr);
              }
            }
            return res;
          }
          function checkForAliasModel(el, value) {
            var _el = el;
            while (_el) {
              if (_el.for && _el.alias === value) {
                warn(
                  "<".concat(el.tag, ' v-model="').concat(value, '">: ') +
                    "You are binding v-model directly to a v-for iteration alias. " +
                    "This will not be able to modify the v-for source array because " +
                    "writing to the alias is like modifying a function local variable. " +
                    "Consider using an array of objects and use v-model on an object property instead.",
                  el.rawAttrsMap["v-model"]
                );
              }
              _el = _el.parent;
            }
          }

          /**
           * Expand input[v-model] with dynamic type bindings into v-if-else chains
           * Turn this:
           *   <input v-model="data[type]" :type="type">
           * into this:
           *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
           *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
           *   <input v-else :type="type" v-model="data[type]">
           */
          function preTransformNode(el, options) {
            if (el.tag === "input") {
              var map = el.attrsMap;
              if (!map["v-model"]) {
                return;
              }
              var typeBinding = void 0;
              if (map[":type"] || map["v-bind:type"]) {
                typeBinding = getBindingAttr(el, "type");
              }
              if (!map.type && !typeBinding && map["v-bind"]) {
                typeBinding = "(".concat(map["v-bind"], ").type");
              }
              if (typeBinding) {
                var ifCondition = getAndRemoveAttr(el, "v-if", true);
                var ifConditionExtra = ifCondition
                  ? "&&(".concat(ifCondition, ")")
                  : "";
                var hasElse = getAndRemoveAttr(el, "v-else", true) != null;
                var elseIfCondition = getAndRemoveAttr(el, "v-else-if", true);
                // 1. checkbox
                var branch0 = cloneASTElement(el);
                // process for on the main node
                processFor(branch0);
                addRawAttr(branch0, "type", "checkbox");
                processElement(branch0, options);
                branch0.processed = true; // prevent it from double-processed
                branch0.if =
                  "(".concat(typeBinding, ")==='checkbox'") + ifConditionExtra;
                addIfCondition(branch0, {
                  exp: branch0.if,
                  block: branch0,
                });
                // 2. add radio else-if condition
                var branch1 = cloneASTElement(el);
                getAndRemoveAttr(branch1, "v-for", true);
                addRawAttr(branch1, "type", "radio");
                processElement(branch1, options);
                addIfCondition(branch0, {
                  exp:
                    "(".concat(typeBinding, ")==='radio'") + ifConditionExtra,
                  block: branch1,
                });
                // 3. other
                var branch2 = cloneASTElement(el);
                getAndRemoveAttr(branch2, "v-for", true);
                addRawAttr(branch2, ":type", typeBinding);
                processElement(branch2, options);
                addIfCondition(branch0, {
                  exp: ifCondition,
                  block: branch2,
                });
                if (hasElse) {
                  branch0.else = true;
                } else if (elseIfCondition) {
                  branch0.elseif = elseIfCondition;
                }
                return branch0;
              }
            }
          }
          function cloneASTElement(el) {
            return createASTElement(el.tag, el.attrsList.slice(), el.parent);
          }
          var model = {
            preTransformNode: preTransformNode,
          };

          var modules = [klass, style, model];

          function text(el, dir) {
            if (dir.value) {
              addProp(el, "textContent", "_s(".concat(dir.value, ")"), dir);
            }
          }

          function html(el, dir) {
            if (dir.value) {
              addProp(el, "innerHTML", "_s(".concat(dir.value, ")"), dir);
            }
          }

          var directives = {
            model: model$1,
            text: text,
            html: html,
          };

          var baseOptions = {
            expectHTML: true,
            modules: modules,
            directives: directives,
            isPreTag: isPreTag,
            isUnaryTag: isUnaryTag,
            mustUseProp: mustUseProp,
            canBeLeftOpenTag: canBeLeftOpenTag,
            isReservedTag: isReservedTag,
            getTagNamespace: getTagNamespace,
            staticKeys: genStaticKeys$1(modules),
          };

          var isStaticKey;
          var isPlatformReservedTag;
          var genStaticKeysCached = cached(genStaticKeys);
          /**
           * Goal of the optimizer: walk the generated template AST tree
           * and detect sub-trees that are purely static, i.e. parts of
           * the DOM that never needs to change.
           *
           * Once we detect these sub-trees, we can:
           *
           * 1. Hoist them into constants, so that we no longer need to
           *    create fresh nodes for them on each re-render;
           * 2. Completely skip them in the patching process.
           */
          function optimize(root, options) {
            if (!root) return;
            isStaticKey = genStaticKeysCached(options.staticKeys || "");
            isPlatformReservedTag = options.isReservedTag || no;
            // first pass: mark all non-static nodes.
            markStatic(root);
            // second pass: mark static roots.
            markStaticRoots(root, false);
          }
          function genStaticKeys(keys) {
            return makeMap(
              "type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap" +
                (keys ? "," + keys : "")
            );
          }
          function markStatic(node) {
            node.static = isStatic(node);
            if (node.type === 1) {
              // do not make component slot content static. this avoids
              // 1. components not able to mutate slot nodes
              // 2. static slot content fails for hot-reloading
              if (
                !isPlatformReservedTag(node.tag) &&
                node.tag !== "slot" &&
                node.attrsMap["inline-template"] == null
              ) {
                return;
              }
              for (var i = 0, l = node.children.length; i < l; i++) {
                var child = node.children[i];
                markStatic(child);
                if (!child.static) {
                  node.static = false;
                }
              }
              if (node.ifConditions) {
                for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                  var block = node.ifConditions[i].block;
                  markStatic(block);
                  if (!block.static) {
                    node.static = false;
                  }
                }
              }
            }
          }
          function markStaticRoots(node, isInFor) {
            if (node.type === 1) {
              if (node.static || node.once) {
                node.staticInFor = isInFor;
              }
              // For a node to qualify as a static root, it should have children that
              // are not just static text. Otherwise the cost of hoisting out will
              // outweigh the benefits and it's better off to just always render it fresh.
              if (
                node.static &&
                node.children.length &&
                !(node.children.length === 1 && node.children[0].type === 3)
              ) {
                node.staticRoot = true;
                return;
              } else {
                node.staticRoot = false;
              }
              if (node.children) {
                for (var i = 0, l = node.children.length; i < l; i++) {
                  markStaticRoots(node.children[i], isInFor || !!node.for);
                }
              }
              if (node.ifConditions) {
                for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                  markStaticRoots(node.ifConditions[i].block, isInFor);
                }
              }
            }
          }
          function isStatic(node) {
            if (node.type === 2) {
              // expression
              return false;
            }
            if (node.type === 3) {
              // text
              return true;
            }
            return !!(
              node.pre ||
              (!node.hasBindings && // no dynamic bindings
                !node.if &&
                !node.for && // not v-if or v-for or v-else
                !isBuiltInTag(node.tag) && // not a built-in
                isPlatformReservedTag(node.tag) && // not a component
                !isDirectChildOfTemplateFor(node) &&
                Object.keys(node).every(isStaticKey))
            );
          }
          function isDirectChildOfTemplateFor(node) {
            while (node.parent) {
              node = node.parent;
              if (node.tag !== "template") {
                return false;
              }
              if (node.for) {
                return true;
              }
            }
            return false;
          }

          var fnExpRE =
            /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
          var fnInvokeRE = /\([^)]*?\);*$/;
          var simplePathRE =
            /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
          // KeyboardEvent.keyCode aliases
          var keyCodes = {
            esc: 27,
            tab: 9,
            enter: 13,
            space: 32,
            up: 38,
            left: 37,
            right: 39,
            down: 40,
            delete: [8, 46],
          };
          // KeyboardEvent.key aliases
          var keyNames = {
            // #7880: IE11 and Edge use `Esc` for Escape key name.
            esc: ["Esc", "Escape"],
            tab: "Tab",
            enter: "Enter",
            // #9112: IE11 uses `Spacebar` for Space key name.
            space: [" ", "Spacebar"],
            // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
            up: ["Up", "ArrowUp"],
            left: ["Left", "ArrowLeft"],
            right: ["Right", "ArrowRight"],
            down: ["Down", "ArrowDown"],
            // #9112: IE11 uses `Del` for Delete key name.
            delete: ["Backspace", "Delete", "Del"],
          };
          // #4868: modifiers that prevent the execution of the listener
          // need to explicitly return null so that we can determine whether to remove
          // the listener for .once
          var genGuard = function (condition) {
            return "if(".concat(condition, ")return null;");
          };
          var modifierCode = {
            stop: "$event.stopPropagation();",
            prevent: "$event.preventDefault();",
            self: genGuard("$event.target !== $event.currentTarget"),
            ctrl: genGuard("!$event.ctrlKey"),
            shift: genGuard("!$event.shiftKey"),
            alt: genGuard("!$event.altKey"),
            meta: genGuard("!$event.metaKey"),
            left: genGuard("'button' in $event && $event.button !== 0"),
            middle: genGuard("'button' in $event && $event.button !== 1"),
            right: genGuard("'button' in $event && $event.button !== 2"),
          };
          function genHandlers(events, isNative) {
            var prefix = isNative ? "nativeOn:" : "on:";
            var staticHandlers = "";
            var dynamicHandlers = "";
            for (var name_1 in events) {
              var handlerCode = genHandler(events[name_1]);
              //@ts-expect-error
              if (events[name_1] && events[name_1].dynamic) {
                dynamicHandlers += ""
                  .concat(name_1, ",")
                  .concat(handlerCode, ",");
              } else {
                staticHandlers += '"'
                  .concat(name_1, '":')
                  .concat(handlerCode, ",");
              }
            }
            staticHandlers = "{".concat(staticHandlers.slice(0, -1), "}");
            if (dynamicHandlers) {
              return (
                prefix +
                "_d("
                  .concat(staticHandlers, ",[")
                  .concat(dynamicHandlers.slice(0, -1), "])")
              );
            } else {
              return prefix + staticHandlers;
            }
          }
          function genHandler(handler) {
            if (!handler) {
              return "function(){}";
            }
            if (Array.isArray(handler)) {
              return "[".concat(
                handler
                  .map(function (handler) {
                    return genHandler(handler);
                  })
                  .join(","),
                "]"
              );
            }
            var isMethodPath = simplePathRE.test(handler.value);
            var isFunctionExpression = fnExpRE.test(handler.value);
            var isFunctionInvocation = simplePathRE.test(
              handler.value.replace(fnInvokeRE, "")
            );
            if (!handler.modifiers) {
              if (isMethodPath || isFunctionExpression) {
                return handler.value;
              }
              return "function($event){".concat(
                isFunctionInvocation
                  ? "return ".concat(handler.value)
                  : handler.value,
                "}"
              ); // inline statement
            } else {
              var code = "";
              var genModifierCode = "";
              var keys = [];
              var _loop_1 = function (key) {
                if (modifierCode[key]) {
                  genModifierCode += modifierCode[key];
                  // left/right
                  if (keyCodes[key]) {
                    keys.push(key);
                  }
                } else if (key === "exact") {
                  var modifiers_1 = handler.modifiers;
                  genModifierCode += genGuard(
                    ["ctrl", "shift", "alt", "meta"]
                      .filter(function (keyModifier) {
                        return !modifiers_1[keyModifier];
                      })
                      .map(function (keyModifier) {
                        return "$event.".concat(keyModifier, "Key");
                      })
                      .join("||")
                  );
                } else {
                  keys.push(key);
                }
              };
              for (var key in handler.modifiers) {
                _loop_1(key);
              }
              if (keys.length) {
                code += genKeyFilter(keys);
              }
              // Make sure modifiers like prevent and stop get executed after key filtering
              if (genModifierCode) {
                code += genModifierCode;
              }
              var handlerCode = isMethodPath
                ? "return ".concat(handler.value, ".apply(null, arguments)")
                : isFunctionExpression
                ? "return (".concat(handler.value, ").apply(null, arguments)")
                : isFunctionInvocation
                ? "return ".concat(handler.value)
                : handler.value;
              return "function($event){".concat(code).concat(handlerCode, "}");
            }
          }
          function genKeyFilter(keys) {
            return (
              // make sure the key filters only apply to KeyboardEvents
              // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
              // key events that do not have keyCode property...
              "if(!$event.type.indexOf('key')&&" +
              "".concat(keys.map(genFilterCode).join("&&"), ")return null;")
            );
          }
          function genFilterCode(key) {
            var keyVal = parseInt(key, 10);
            if (keyVal) {
              return "$event.keyCode!==".concat(keyVal);
            }
            var keyCode = keyCodes[key];
            var keyName = keyNames[key];
            return (
              "_k($event.keyCode," +
              "".concat(JSON.stringify(key), ",") +
              "".concat(JSON.stringify(keyCode), ",") +
              "$event.key," +
              "".concat(JSON.stringify(keyName)) +
              ")"
            );
          }

          function on(el, dir) {
            if (dir.modifiers) {
              warn$2("v-on without argument does not support modifiers.");
            }
            el.wrapListeners = function (code) {
              return "_g(".concat(code, ",").concat(dir.value, ")");
            };
          }

          function bind(el, dir) {
            el.wrapData = function (code) {
              return "_b("
                .concat(code, ",'")
                .concat(el.tag, "',")
                .concat(dir.value, ",")
                .concat(dir.modifiers && dir.modifiers.prop ? "true" : "false")
                .concat(
                  dir.modifiers && dir.modifiers.sync ? ",true" : "",
                  ")"
                );
            };
          }

          var baseDirectives = {
            on: on,
            bind: bind,
            cloak: noop,
          };

          var CodegenState = /** @class */ (function () {
            function CodegenState(options) {
              this.options = options;
              this.warn = options.warn || baseWarn;
              this.transforms = pluckModuleFunction(
                options.modules,
                "transformCode"
              );
              this.dataGenFns = pluckModuleFunction(options.modules, "genData");
              this.directives = extend(
                extend({}, baseDirectives),
                options.directives
              );
              var isReservedTag = options.isReservedTag || no;
              this.maybeComponent = function (el) {
                return !!el.component || !isReservedTag(el.tag);
              };
              this.onceId = 0;
              this.staticRenderFns = [];
              this.pre = false;
            }
            return CodegenState;
          })();
          function generate(ast, options) {
            var state = new CodegenState(options);
            // fix #11483, Root level <script> tags should not be rendered.
            var code = ast
              ? ast.tag === "script"
                ? "null"
                : genElement(ast, state)
              : '_c("div")';
            return {
              render: "with(this){return ".concat(code, "}"),
              staticRenderFns: state.staticRenderFns,
            };
          }
          function genElement(el, state) {
            if (el.parent) {
              el.pre = el.pre || el.parent.pre;
            }
            if (el.staticRoot && !el.staticProcessed) {
              return genStatic(el, state);
            } else if (el.once && !el.onceProcessed) {
              return genOnce(el, state);
            } else if (el.for && !el.forProcessed) {
              return genFor(el, state);
            } else if (el.if && !el.ifProcessed) {
              return genIf(el, state);
            } else if (el.tag === "template" && !el.slotTarget && !state.pre) {
              return genChildren(el, state) || "void 0";
            } else if (el.tag === "slot") {
              return genSlot(el, state);
            } else {
              // component or element
              var code = void 0;
              if (el.component) {
                code = genComponent(el.component, el, state);
              } else {
                var data = void 0;
                var maybeComponent = state.maybeComponent(el);
                if (!el.plain || (el.pre && maybeComponent)) {
                  data = genData(el, state);
                }
                var tag =
                  // check if this is a component in <script setup>
                  void 0;
                // check if this is a component in <script setup>
                var bindings = state.options.bindings;
                if (
                  maybeComponent &&
                  bindings &&
                  bindings.__isScriptSetup !== false
                ) {
                  tag = checkBindingType(bindings, el.tag);
                }
                if (!tag) tag = "'".concat(el.tag, "'");
                var children = el.inlineTemplate
                  ? null
                  : genChildren(el, state, true);
                code = "_c("
                  .concat(tag)
                  .concat(
                    data ? ",".concat(data) : "" // data
                  )
                  .concat(
                    children ? ",".concat(children) : "", // children
                    ")"
                  );
              }
              // module transforms
              for (var i = 0; i < state.transforms.length; i++) {
                code = state.transforms[i](el, code);
              }
              return code;
            }
          }
          function checkBindingType(bindings, key) {
            var camelName = camelize(key);
            var PascalName = capitalize(camelName);
            var checkType = function (type) {
              if (bindings[key] === type) {
                return key;
              }
              if (bindings[camelName] === type) {
                return camelName;
              }
              if (bindings[PascalName] === type) {
                return PascalName;
              }
            };
            var fromConst =
              checkType("setup-const" /* BindingTypes.SETUP_CONST */) ||
              checkType(
                "setup-reactive-const" /* BindingTypes.SETUP_REACTIVE_CONST */
              );
            if (fromConst) {
              return fromConst;
            }
            var fromMaybeRef =
              checkType("setup-let" /* BindingTypes.SETUP_LET */) ||
              checkType("setup-ref" /* BindingTypes.SETUP_REF */) ||
              checkType("setup-maybe-ref" /* BindingTypes.SETUP_MAYBE_REF */);
            if (fromMaybeRef) {
              return fromMaybeRef;
            }
          }
          // hoist static sub-trees out
          function genStatic(el, state) {
            el.staticProcessed = true;
            // Some elements (templates) need to behave differently inside of a v-pre
            // node.  All pre nodes are static roots, so we can use this as a location to
            // wrap a state change and reset it upon exiting the pre node.
            var originalPreState = state.pre;
            if (el.pre) {
              state.pre = el.pre;
            }
            state.staticRenderFns.push(
              "with(this){return ".concat(genElement(el, state), "}")
            );
            state.pre = originalPreState;
            return "_m("
              .concat(state.staticRenderFns.length - 1)
              .concat(el.staticInFor ? ",true" : "", ")");
          }
          // v-once
          function genOnce(el, state) {
            el.onceProcessed = true;
            if (el.if && !el.ifProcessed) {
              return genIf(el, state);
            } else if (el.staticInFor) {
              var key = "";
              var parent_1 = el.parent;
              while (parent_1) {
                if (parent_1.for) {
                  key = parent_1.key;
                  break;
                }
                parent_1 = parent_1.parent;
              }
              if (!key) {
                state.warn(
                  "v-once can only be used inside v-for that is keyed. ",
                  el.rawAttrsMap["v-once"]
                );
                return genElement(el, state);
              }
              return "_o("
                .concat(genElement(el, state), ",")
                .concat(state.onceId++, ",")
                .concat(key, ")");
            } else {
              return genStatic(el, state);
            }
          }
          function genIf(el, state, altGen, altEmpty) {
            el.ifProcessed = true; // avoid recursion
            return genIfConditions(
              el.ifConditions.slice(),
              state,
              altGen,
              altEmpty
            );
          }
          function genIfConditions(conditions, state, altGen, altEmpty) {
            if (!conditions.length) {
              return altEmpty || "_e()";
            }
            var condition = conditions.shift();
            if (condition.exp) {
              return "("
                .concat(condition.exp, ")?")
                .concat(genTernaryExp(condition.block), ":")
                .concat(genIfConditions(conditions, state, altGen, altEmpty));
            } else {
              return "".concat(genTernaryExp(condition.block));
            }
            // v-if with v-once should generate code like (a)?_m(0):_m(1)
            function genTernaryExp(el) {
              return altGen
                ? altGen(el, state)
                : el.once
                ? genOnce(el, state)
                : genElement(el, state);
            }
          }
          function genFor(el, state, altGen, altHelper) {
            var exp = el.for;
            var alias = el.alias;
            var iterator1 = el.iterator1 ? ",".concat(el.iterator1) : "";
            var iterator2 = el.iterator2 ? ",".concat(el.iterator2) : "";
            if (
              state.maybeComponent(el) &&
              el.tag !== "slot" &&
              el.tag !== "template" &&
              !el.key
            ) {
              state.warn(
                "<"
                  .concat(el.tag, ' v-for="')
                  .concat(alias, " in ")
                  .concat(exp, '">: component lists rendered with ') +
                  "v-for should have explicit keys. " +
                  "See https://v2.vuejs.org/v2/guide/list.html#key for more info.",
                el.rawAttrsMap["v-for"],
                true /* tip */
              );
            }
            el.forProcessed = true; // avoid recursion
            return (
              "".concat(altHelper || "_l", "((").concat(exp, "),") +
              "function("
                .concat(alias)
                .concat(iterator1)
                .concat(iterator2, "){") +
              "return ".concat((altGen || genElement)(el, state)) +
              "})"
            );
          }
          function genData(el, state) {
            var data = "{";
            // directives first.
            // directives may mutate the el's other properties before they are generated.
            var dirs = genDirectives(el, state);
            if (dirs) data += dirs + ",";
            // key
            if (el.key) {
              data += "key:".concat(el.key, ",");
            }
            // ref
            if (el.ref) {
              data += "ref:".concat(el.ref, ",");
            }
            if (el.refInFor) {
              data += "refInFor:true,";
            }
            // pre
            if (el.pre) {
              data += "pre:true,";
            }
            // record original tag name for components using "is" attribute
            if (el.component) {
              data += 'tag:"'.concat(el.tag, '",');
            }
            // module data generation functions
            for (var i = 0; i < state.dataGenFns.length; i++) {
              data += state.dataGenFns[i](el);
            }
            // attributes
            if (el.attrs) {
              data += "attrs:".concat(genProps(el.attrs), ",");
            }
            // DOM props
            if (el.props) {
              data += "domProps:".concat(genProps(el.props), ",");
            }
            // event handlers
            if (el.events) {
              data += "".concat(genHandlers(el.events, false), ",");
            }
            if (el.nativeEvents) {
              data += "".concat(genHandlers(el.nativeEvents, true), ",");
            }
            // slot target
            // only for non-scoped slots
            if (el.slotTarget && !el.slotScope) {
              data += "slot:".concat(el.slotTarget, ",");
            }
            // scoped slots
            if (el.scopedSlots) {
              data += "".concat(genScopedSlots(el, el.scopedSlots, state), ",");
            }
            // component v-model
            if (el.model) {
              data += "model:{value:"
                .concat(el.model.value, ",callback:")
                .concat(el.model.callback, ",expression:")
                .concat(el.model.expression, "},");
            }
            // inline-template
            if (el.inlineTemplate) {
              var inlineTemplate = genInlineTemplate(el, state);
              if (inlineTemplate) {
                data += "".concat(inlineTemplate, ",");
              }
            }
            data = data.replace(/,$/, "") + "}";
            // v-bind dynamic argument wrap
            // v-bind with dynamic arguments must be applied using the same v-bind object
            // merge helper so that class/style/mustUseProp attrs are handled correctly.
            if (el.dynamicAttrs) {
              data = "_b("
                .concat(data, ',"')
                .concat(el.tag, '",')
                .concat(genProps(el.dynamicAttrs), ")");
            }
            // v-bind data wrap
            if (el.wrapData) {
              data = el.wrapData(data);
            }
            // v-on data wrap
            if (el.wrapListeners) {
              data = el.wrapListeners(data);
            }
            return data;
          }
          function genDirectives(el, state) {
            var dirs = el.directives;
            if (!dirs) return;
            var res = "directives:[";
            var hasRuntime = false;
            var i, l, dir, needRuntime;
            for (i = 0, l = dirs.length; i < l; i++) {
              dir = dirs[i];
              needRuntime = true;
              var gen = state.directives[dir.name];
              if (gen) {
                // compile-time directive that manipulates AST.
                // returns true if it also needs a runtime counterpart.
                needRuntime = !!gen(el, dir, state.warn);
              }
              if (needRuntime) {
                hasRuntime = true;
                res += '{name:"'
                  .concat(dir.name, '",rawName:"')
                  .concat(dir.rawName, '"')
                  .concat(
                    dir.value
                      ? ",value:("
                          .concat(dir.value, "),expression:")
                          .concat(JSON.stringify(dir.value))
                      : ""
                  )
                  .concat(
                    dir.arg
                      ? ",arg:".concat(
                          dir.isDynamicArg ? dir.arg : '"'.concat(dir.arg, '"')
                        )
                      : ""
                  )
                  .concat(
                    dir.modifiers
                      ? ",modifiers:".concat(JSON.stringify(dir.modifiers))
                      : "",
                    "},"
                  );
              }
            }
            if (hasRuntime) {
              return res.slice(0, -1) + "]";
            }
          }
          function genInlineTemplate(el, state) {
            var ast = el.children[0];
            if (el.children.length !== 1 || ast.type !== 1) {
              state.warn(
                "Inline-template components must have exactly one child element.",
                { start: el.start }
              );
            }
            if (ast && ast.type === 1) {
              var inlineRenderFns = generate(ast, state.options);
              return "inlineTemplate:{render:function(){"
                .concat(inlineRenderFns.render, "},staticRenderFns:[")
                .concat(
                  inlineRenderFns.staticRenderFns
                    .map(function (code) {
                      return "function(){".concat(code, "}");
                    })
                    .join(","),
                  "]}"
                );
            }
          }
          function genScopedSlots(el, slots, state) {
            // by default scoped slots are considered "stable", this allows child
            // components with only scoped slots to skip forced updates from parent.
            // but in some cases we have to bail-out of this optimization
            // for example if the slot contains dynamic names, has v-if or v-for on them...
            var needsForceUpdate =
              el.for ||
              Object.keys(slots).some(function (key) {
                var slot = slots[key];
                return (
                  slot.slotTargetDynamic ||
                  slot.if ||
                  slot.for ||
                  containsSlotChild(slot) // is passing down slot from parent which may be dynamic
                );
              });
            // #9534: if a component with scoped slots is inside a conditional branch,
            // it's possible for the same component to be reused but with different
            // compiled slot content. To avoid that, we generate a unique key based on
            // the generated code of all the slot contents.
            var needsKey = !!el.if;
            // OR when it is inside another scoped slot or v-for (the reactivity may be
            // disconnected due to the intermediate scope variable)
            // #9438, #9506
            // TODO: this can be further optimized by properly analyzing in-scope bindings
            // and skip force updating ones that do not actually use scope variables.
            if (!needsForceUpdate) {
              var parent_2 = el.parent;
              while (parent_2) {
                if (
                  (parent_2.slotScope &&
                    parent_2.slotScope !== emptySlotScopeToken) ||
                  parent_2.for
                ) {
                  needsForceUpdate = true;
                  break;
                }
                if (parent_2.if) {
                  needsKey = true;
                }
                parent_2 = parent_2.parent;
              }
            }
            var generatedSlots = Object.keys(slots)
              .map(function (key) {
                return genScopedSlot(slots[key], state);
              })
              .join(",");
            return "scopedSlots:_u(["
              .concat(generatedSlots, "]")
              .concat(needsForceUpdate ? ",null,true" : "")
              .concat(
                !needsForceUpdate && needsKey
                  ? ",null,false,".concat(hash(generatedSlots))
                  : "",
                ")"
              );
          }
          function hash(str) {
            var hash = 5381;
            var i = str.length;
            while (i) {
              hash = (hash * 33) ^ str.charCodeAt(--i);
            }
            return hash >>> 0;
          }
          function containsSlotChild(el) {
            if (el.type === 1) {
              if (el.tag === "slot") {
                return true;
              }
              return el.children.some(containsSlotChild);
            }
            return false;
          }
          function genScopedSlot(el, state) {
            var isLegacySyntax = el.attrsMap["slot-scope"];
            if (el.if && !el.ifProcessed && !isLegacySyntax) {
              return genIf(el, state, genScopedSlot, "null");
            }
            if (el.for && !el.forProcessed) {
              return genFor(el, state, genScopedSlot);
            }
            var slotScope =
              el.slotScope === emptySlotScopeToken ? "" : String(el.slotScope);
            var fn =
              "function(".concat(slotScope, "){") +
              "return ".concat(
                el.tag === "template"
                  ? el.if && isLegacySyntax
                    ? "("
                        .concat(el.if, ")?")
                        .concat(
                          genChildren(el, state) || "undefined",
                          ":undefined"
                        )
                    : genChildren(el, state) || "undefined"
                  : genElement(el, state),
                "}"
              );
            // reverse proxy v-slot without scope on this.$slots
            var reverseProxy = slotScope ? "" : ",proxy:true";
            return "{key:"
              .concat(el.slotTarget || '"default"', ",fn:")
              .concat(fn)
              .concat(reverseProxy, "}");
          }
          function genChildren(
            el,
            state,
            checkSkip,
            altGenElement,
            altGenNode
          ) {
            var children = el.children;
            if (children.length) {
              var el_1 = children[0];
              // optimize single v-for
              if (
                children.length === 1 &&
                el_1.for &&
                el_1.tag !== "template" &&
                el_1.tag !== "slot"
              ) {
                var normalizationType_1 = checkSkip
                  ? state.maybeComponent(el_1)
                    ? ",1"
                    : ",0"
                  : "";
                return ""
                  .concat((altGenElement || genElement)(el_1, state))
                  .concat(normalizationType_1);
              }
              var normalizationType = checkSkip
                ? getNormalizationType(children, state.maybeComponent)
                : 0;
              var gen_1 = altGenNode || genNode;
              return "["
                .concat(
                  children
                    .map(function (c) {
                      return gen_1(c, state);
                    })
                    .join(","),
                  "]"
                )
                .concat(normalizationType ? ",".concat(normalizationType) : "");
            }
          }
          // determine the normalization needed for the children array.
          // 0: no normalization needed
          // 1: simple normalization needed (possible 1-level deep nested array)
          // 2: full normalization needed
          function getNormalizationType(children, maybeComponent) {
            var res = 0;
            for (var i = 0; i < children.length; i++) {
              var el = children[i];
              if (el.type !== 1) {
                continue;
              }
              if (
                needsNormalization(el) ||
                (el.ifConditions &&
                  el.ifConditions.some(function (c) {
                    return needsNormalization(c.block);
                  }))
              ) {
                res = 2;
                break;
              }
              if (
                maybeComponent(el) ||
                (el.ifConditions &&
                  el.ifConditions.some(function (c) {
                    return maybeComponent(c.block);
                  }))
              ) {
                res = 1;
              }
            }
            return res;
          }
          function needsNormalization(el) {
            return (
              el.for !== undefined || el.tag === "template" || el.tag === "slot"
            );
          }
          function genNode(node, state) {
            if (node.type === 1) {
              return genElement(node, state);
            } else if (node.type === 3 && node.isComment) {
              return genComment(node);
            } else {
              return genText(node);
            }
          }
          function genText(text) {
            return "_v(".concat(
              text.type === 2
                ? text.expression // no need for () because already wrapped in _s()
                : transformSpecialNewlines(JSON.stringify(text.text)),
              ")"
            );
          }
          function genComment(comment) {
            return "_e(".concat(JSON.stringify(comment.text), ")");
          }
          function genSlot(el, state) {
            var slotName = el.slotName || '"default"';
            var children = genChildren(el, state);
            var res = "_t("
              .concat(slotName)
              .concat(
                children ? ",function(){return ".concat(children, "}") : ""
              );
            var attrs =
              el.attrs || el.dynamicAttrs
                ? genProps(
                    (el.attrs || [])
                      .concat(el.dynamicAttrs || [])
                      .map(function (attr) {
                        return {
                          // slot props are camelized
                          name: camelize(attr.name),
                          value: attr.value,
                          dynamic: attr.dynamic,
                        };
                      })
                  )
                : null;
            var bind = el.attrsMap["v-bind"];
            if ((attrs || bind) && !children) {
              res += ",null";
            }
            if (attrs) {
              res += ",".concat(attrs);
            }
            if (bind) {
              res += "".concat(attrs ? "" : ",null", ",").concat(bind);
            }
            return res + ")";
          }
          // componentName is el.component, take it as argument to shun flow's pessimistic refinement
          function genComponent(componentName, el, state) {
            var children = el.inlineTemplate
              ? null
              : genChildren(el, state, true);
            return "_c("
              .concat(componentName, ",")
              .concat(genData(el, state))
              .concat(children ? ",".concat(children) : "", ")");
          }
          function genProps(props) {
            var staticProps = "";
            var dynamicProps = "";
            for (var i = 0; i < props.length; i++) {
              var prop = props[i];
              var value = transformSpecialNewlines(prop.value);
              if (prop.dynamic) {
                dynamicProps += "".concat(prop.name, ",").concat(value, ",");
              } else {
                staticProps += '"'.concat(prop.name, '":').concat(value, ",");
              }
            }
            staticProps = "{".concat(staticProps.slice(0, -1), "}");
            if (dynamicProps) {
              return "_d("
                .concat(staticProps, ",[")
                .concat(dynamicProps.slice(0, -1), "])");
            } else {
              return staticProps;
            }
          }
          // #3895, #4268
          function transformSpecialNewlines(text) {
            return text
              .replace(/\u2028/g, "\\u2028")
              .replace(/\u2029/g, "\\u2029");
          }

          // these keywords should not appear inside expressions, but operators like
          // typeof, instanceof and in are allowed
          var prohibitedKeywordRE = new RegExp(
            "\\b" +
              (
                "do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const," +
                "super,throw,while,yield,delete,export,import,return,switch,default," +
                "extends,finally,continue,debugger,function,arguments"
              )
                .split(",")
                .join("\\b|\\b") +
              "\\b"
          );
          // these unary operators should not be used as property/method names
          var unaryOperatorsRE = new RegExp(
            "\\b" +
              "delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b") +
              "\\s*\\([^\\)]*\\)"
          );
          // strip strings in expressions
          var stripStringRE =
            /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
          // detect problematic expressions in a template
          function detectErrors(ast, warn) {
            if (ast) {
              checkNode(ast, warn);
            }
          }
          function checkNode(node, warn) {
            if (node.type === 1) {
              for (var name_1 in node.attrsMap) {
                if (dirRE.test(name_1)) {
                  var value = node.attrsMap[name_1];
                  if (value) {
                    var range = node.rawAttrsMap[name_1];
                    if (name_1 === "v-for") {
                      checkFor(node, 'v-for="'.concat(value, '"'), warn, range);
                    } else if (name_1 === "v-slot" || name_1[0] === "#") {
                      checkFunctionParameterExpression(
                        value,
                        "".concat(name_1, '="').concat(value, '"'),
                        warn,
                        range
                      );
                    } else if (onRE.test(name_1)) {
                      checkEvent(
                        value,
                        "".concat(name_1, '="').concat(value, '"'),
                        warn,
                        range
                      );
                    } else {
                      checkExpression(
                        value,
                        "".concat(name_1, '="').concat(value, '"'),
                        warn,
                        range
                      );
                    }
                  }
                }
              }
              if (node.children) {
                for (var i = 0; i < node.children.length; i++) {
                  checkNode(node.children[i], warn);
                }
              }
            } else if (node.type === 2) {
              checkExpression(node.expression, node.text, warn, node);
            }
          }
          function checkEvent(exp, text, warn, range) {
            var stripped = exp.replace(stripStringRE, "");
            var keywordMatch = stripped.match(unaryOperatorsRE);
            if (
              keywordMatch &&
              stripped.charAt(keywordMatch.index - 1) !== "$"
            ) {
              warn(
                "avoid using JavaScript unary operator as property name: " +
                  '"'
                    .concat(keywordMatch[0], '" in expression ')
                    .concat(text.trim()),
                range
              );
            }
            checkExpression(exp, text, warn, range);
          }
          function checkFor(node, text, warn, range) {
            checkExpression(node.for || "", text, warn, range);
            checkIdentifier(node.alias, "v-for alias", text, warn, range);
            checkIdentifier(
              node.iterator1,
              "v-for iterator",
              text,
              warn,
              range
            );
            checkIdentifier(
              node.iterator2,
              "v-for iterator",
              text,
              warn,
              range
            );
          }
          function checkIdentifier(ident, type, text, warn, range) {
            if (typeof ident === "string") {
              try {
                new Function("var ".concat(ident, "=_"));
              } catch (e) {
                warn(
                  "invalid "
                    .concat(type, ' "')
                    .concat(ident, '" in expression: ')
                    .concat(text.trim()),
                  range
                );
              }
            }
          }
          function checkExpression(exp, text, warn, range) {
            try {
              new Function("return ".concat(exp));
            } catch (e) {
              var keywordMatch = exp
                .replace(stripStringRE, "")
                .match(prohibitedKeywordRE);
              if (keywordMatch) {
                warn(
                  "avoid using JavaScript keyword as property name: " +
                    '"'
                      .concat(keywordMatch[0], '"\n  Raw expression: ')
                      .concat(text.trim()),
                  range
                );
              } else {
                warn(
                  "invalid expression: ".concat(e.message, " in\n\n") +
                    "    ".concat(exp, "\n\n") +
                    "  Raw expression: ".concat(text.trim(), "\n"),
                  range
                );
              }
            }
          }
          function checkFunctionParameterExpression(exp, text, warn, range) {
            try {
              new Function(exp, "");
            } catch (e) {
              warn(
                "invalid function parameter expression: ".concat(
                  e.message,
                  " in\n\n"
                ) +
                  "    ".concat(exp, "\n\n") +
                  "  Raw expression: ".concat(text.trim(), "\n"),
                range
              );
            }
          }

          var range = 2;
          function generateCodeFrame(source, start, end) {
            if (start === void 0) {
              start = 0;
            }
            if (end === void 0) {
              end = source.length;
            }
            var lines = source.split(/\r?\n/);
            var count = 0;
            var res = [];
            for (var i = 0; i < lines.length; i++) {
              count += lines[i].length + 1;
              if (count >= start) {
                for (var j = i - range; j <= i + range || end > count; j++) {
                  if (j < 0 || j >= lines.length) continue;
                  res.push(
                    ""
                      .concat(j + 1)
                      .concat(repeat(" ", 3 - String(j + 1).length), "|  ")
                      .concat(lines[j])
                  );
                  var lineLength = lines[j].length;
                  if (j === i) {
                    // push underline
                    var pad = start - (count - lineLength) + 1;
                    var length_1 = end > count ? lineLength - pad : end - start;
                    res.push(
                      "   |  " + repeat(" ", pad) + repeat("^", length_1)
                    );
                  } else if (j > i) {
                    if (end > count) {
                      var length_2 = Math.min(end - count, lineLength);
                      res.push("   |  " + repeat("^", length_2));
                    }
                    count += lineLength + 1;
                  }
                }
                break;
              }
            }
            return res.join("\n");
          }
          function repeat(str, n) {
            var result = "";
            if (n > 0) {
              // eslint-disable-next-line no-constant-condition
              while (true) {
                // eslint-disable-line
                if (n & 1) result += str;
                n >>>= 1;
                if (n <= 0) break;
                str += str;
              }
            }
            return result;
          }

          function createFunction(code, errors) {
            try {
              return new Function(code);
            } catch (err) {
              errors.push({ err: err, code: code });
              return noop;
            }
          }
          function createCompileToFunctionFn(compile) {
            var cache = Object.create(null);
            return function compileToFunctions(template, options, vm) {
              options = extend({}, options);
              var warn = options.warn || warn$2;
              delete options.warn;
              /* istanbul ignore if */
              {
                // detect possible CSP restriction
                try {
                  new Function("return 1");
                } catch (e) {
                  if (e.toString().match(/unsafe-eval|CSP/)) {
                    warn(
                      "It seems you are using the standalone build of Vue.js in an " +
                        "environment with Content Security Policy that prohibits unsafe-eval. " +
                        "The template compiler cannot work in this environment. Consider " +
                        "relaxing the policy to allow unsafe-eval or pre-compiling your " +
                        "templates into render functions."
                    );
                  }
                }
              }
              // check cache
              var key = options.delimiters
                ? String(options.delimiters) + template
                : template;
              if (cache[key]) {
                return cache[key];
              }
              // compile
              var compiled = compile(template, options);
              // check compilation errors/tips
              {
                if (compiled.errors && compiled.errors.length) {
                  if (options.outputSourceRange) {
                    compiled.errors.forEach(function (e) {
                      warn(
                        "Error compiling template:\n\n".concat(e.msg, "\n\n") +
                          generateCodeFrame(template, e.start, e.end),
                        vm
                      );
                    });
                  } else {
                    warn(
                      "Error compiling template:\n\n".concat(template, "\n\n") +
                        compiled.errors
                          .map(function (e) {
                            return "- ".concat(e);
                          })
                          .join("\n") +
                        "\n",
                      vm
                    );
                  }
                }
                if (compiled.tips && compiled.tips.length) {
                  if (options.outputSourceRange) {
                    compiled.tips.forEach(function (e) {
                      return tip(e.msg, vm);
                    });
                  } else {
                    compiled.tips.forEach(function (msg) {
                      return tip(msg, vm);
                    });
                  }
                }
              }
              // turn code into functions
              var res = {};
              var fnGenErrors = [];
              res.render = createFunction(compiled.render, fnGenErrors);
              res.staticRenderFns = compiled.staticRenderFns.map(function (
                code
              ) {
                return createFunction(code, fnGenErrors);
              });
              // check function generation errors.
              // this should only happen if there is a bug in the compiler itself.
              // mostly for codegen development use
              /* istanbul ignore if */
              {
                if (
                  (!compiled.errors || !compiled.errors.length) &&
                  fnGenErrors.length
                ) {
                  warn(
                    "Failed to generate render function:\n\n" +
                      fnGenErrors
                        .map(function (_a) {
                          var err = _a.err,
                            code = _a.code;
                          return ""
                            .concat(err.toString(), " in\n\n")
                            .concat(code, "\n");
                        })
                        .join("\n"),
                    vm
                  );
                }
              }
              return (cache[key] = res);
            };
          }

          function createCompilerCreator(baseCompile) {
            return function createCompiler(baseOptions) {
              function compile(template, options) {
                var finalOptions = Object.create(baseOptions);
                var errors = [];
                var tips = [];
                var warn = function (msg, range, tip) {
                  (tip ? tips : errors).push(msg);
                };
                if (options) {
                  if (options.outputSourceRange) {
                    // $flow-disable-line
                    var leadingSpaceLength_1 = template.match(/^\s*/)[0].length;
                    warn = function (msg, range, tip) {
                      var data = typeof msg === "string" ? { msg: msg } : msg;
                      if (range) {
                        if (range.start != null) {
                          data.start = range.start + leadingSpaceLength_1;
                        }
                        if (range.end != null) {
                          data.end = range.end + leadingSpaceLength_1;
                        }
                      }
                      (tip ? tips : errors).push(data);
                    };
                  }
                  // merge custom modules
                  if (options.modules) {
                    finalOptions.modules = (baseOptions.modules || []).concat(
                      options.modules
                    );
                  }
                  // merge custom directives
                  if (options.directives) {
                    finalOptions.directives = extend(
                      Object.create(baseOptions.directives || null),
                      options.directives
                    );
                  }
                  // copy other options
                  for (var key in options) {
                    if (key !== "modules" && key !== "directives") {
                      finalOptions[key] = options[key];
                    }
                  }
                }
                finalOptions.warn = warn;
                var compiled = baseCompile(template.trim(), finalOptions);
                {
                  detectErrors(compiled.ast, warn);
                }
                compiled.errors = errors;
                compiled.tips = tips;
                return compiled;
              }
              return {
                compile: compile,
                compileToFunctions: createCompileToFunctionFn(compile),
              };
            };
          }

          // `createCompilerCreator` allows creating compilers that use alternative
          // parser/optimizer/codegen, e.g the SSR optimizing compiler.
          // Here we just export a default compiler using the default parts.
          var createCompiler = createCompilerCreator(function baseCompile(
            template,
            options
          ) {
            var ast = parse(template.trim(), options);
            if (options.optimize !== false) {
              optimize(ast, options);
            }
            var code = generate(ast, options);
            return {
              ast: ast,
              render: code.render,
              staticRenderFns: code.staticRenderFns,
            };
          });

          var _a = createCompiler(baseOptions),
            compileToFunctions = _a.compileToFunctions;

          // check whether current browser encodes a char inside attribute values
          var div;
          function getShouldDecode(href) {
            div = div || document.createElement("div");
            div.innerHTML = href ? '<a href="\n"/>' : '<div a="\n"/>';
            return div.innerHTML.indexOf("&#10;") > 0;
          }
          // #3663: IE encodes newlines inside attribute values while other browsers don't
          var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
          // #6828: chrome encodes content in a[href]
          var shouldDecodeNewlinesForHref = inBrowser
            ? getShouldDecode(true)
            : false;

          var idToTemplate = cached(function (id) {
            var el = query(id);
            return el && el.innerHTML;
          });
          var mount = Vue.prototype.$mount;
          Vue.prototype.$mount = function (el, hydrating) {
            el = el && query(el);
            /* istanbul ignore if */
            if (el === document.body || el === document.documentElement) {
              warn$2(
                "Do not mount Vue to <html> or <body> - mount to normal elements instead."
              );
              return this;
            }
            var options = this.$options;
            // resolve template/el and convert to render function
            if (!options.render) {
              var template = options.template;
              if (template) {
                if (typeof template === "string") {
                  if (template.charAt(0) === "#") {
                    template = idToTemplate(template);
                    /* istanbul ignore if */
                    if (!template) {
                      warn$2(
                        "Template element not found or is empty: ".concat(
                          options.template
                        ),
                        this
                      );
                    }
                  }
                } else if (template.nodeType) {
                  template = template.innerHTML;
                } else {
                  {
                    warn$2("invalid template option:" + template, this);
                  }
                  return this;
                }
              } else if (el) {
                // @ts-expect-error
                template = getOuterHTML(el);
              }
              if (template) {
                /* istanbul ignore if */
                if (config.performance && mark) {
                  mark("compile");
                }
                var _a = compileToFunctions(
                    template,
                    {
                      outputSourceRange: true,
                      shouldDecodeNewlines: shouldDecodeNewlines,
                      shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
                      delimiters: options.delimiters,
                      comments: options.comments,
                    },
                    this
                  ),
                  render = _a.render,
                  staticRenderFns = _a.staticRenderFns;
                options.render = render;
                options.staticRenderFns = staticRenderFns;
                /* istanbul ignore if */
                if (config.performance && mark) {
                  mark("compile end");
                  measure(
                    "vue ".concat(this._name, " compile"),
                    "compile",
                    "compile end"
                  );
                }
              }
            }
            return mount.call(this, el, hydrating);
          };
          /**
           * Get outerHTML of elements, taking care
           * of SVG elements in IE as well.
           */
          function getOuterHTML(el) {
            if (el.outerHTML) {
              return el.outerHTML;
            } else {
              var container = document.createElement("div");
              container.appendChild(el.cloneNode(true));
              return container.innerHTML;
            }
          }
          Vue.compile = compileToFunctions;

          // export type EffectScheduler = (...args: any[]) => any
          /**
           * @internal since we are not exposing this in Vue 2, it's used only for
           * internal testing.
           */
          function effect(fn, scheduler) {
            var watcher = new Watcher(currentInstance, fn, noop, {
              sync: true,
            });
            if (scheduler) {
              watcher.update = function () {
                scheduler(function () {
                  return watcher.run();
                });
              };
            }
          }

          extend(Vue, vca);
          Vue.effect = effect;

          return Vue;
        });

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/autocompleteImpl.js":
      /*!***************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/autocompleteImpl.js ***!
  \***************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i];
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }
            return target;
          };

        var _bindProps = __webpack_require__(
          /*! ../utils/bindProps.js */ "./node_modules/vue2-google-maps/dist/utils/bindProps.js"
        );

        var _simulateArrowDown = __webpack_require__(
          /*! ../utils/simulateArrowDown.js */ "./node_modules/vue2-google-maps/dist/utils/simulateArrowDown.js"
        );

        var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

        var _mapElementFactory = __webpack_require__(
          /*! ./mapElementFactory */ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js"
        );

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        var mappedProps = {
          bounds: {
            type: Object,
          },
          componentRestrictions: {
            type: Object,
            // Do not bind -- must check for undefined
            // in the property
            noBind: true,
          },
          types: {
            type: Array,
            default: function _default() {
              return [];
            },
          },
        };

        var props = {
          selectFirstOnEnter: {
            required: false,
            type: Boolean,
            default: false,
          },
          options: {
            type: Object,
          },
        };

        exports["default"] = {
          mounted: function mounted() {
            var _this = this;

            this.$gmapApiPromiseLazy().then(function () {
              if (_this.selectFirstOnEnter) {
                (0, _simulateArrowDown2.default)(_this.$refs.input);
              }

              if (typeof google.maps.places.Autocomplete !== "function") {
                throw new Error(
                  "google.maps.places.Autocomplete is undefined. Did you add 'places' to libraries when loading Google Maps?"
                );
              }

              /* eslint-disable no-unused-vars */
              var finalOptions = _extends(
                {},
                (0, _bindProps.getPropsValues)(_this, mappedProps),
                _this.options
              );

              _this.$autocomplete = new google.maps.places.Autocomplete(
                _this.$refs.input,
                finalOptions
              );
              (0,
              _bindProps.bindProps)(_this, _this.$autocomplete, mappedProps);

              _this.$watch("componentRestrictions", function (v) {
                if (v !== undefined) {
                  _this.$autocomplete.setComponentRestrictions(v);
                }
              });

              // Not using `bindEvents` because we also want
              // to return the result of `getPlace()`
              _this.$autocomplete.addListener("place_changed", function () {
                _this.$emit("place_changed", _this.$autocomplete.getPlace());
              });
            });
          },

          props: _extends(
            {},
            (0, _mapElementFactory.mappedPropsToVueProps)(mappedProps),
            props
          ),
        };

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/circle.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/circle.js ***!
  \*****************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _mapElementFactory = __webpack_require__(
          /*! ./mapElementFactory */ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js"
        );

        var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        var props = {
          center: {
            type: Object,
            twoWay: true,
            required: true,
          },
          radius: {
            type: Number,
            twoWay: true,
          },
          draggable: {
            type: Boolean,
            default: false,
          },
          editable: {
            type: Boolean,
            default: false,
          },
          options: {
            type: Object,
            twoWay: false,
          },
        };

        var events = [
          "click",
          "dblclick",
          "drag",
          "dragend",
          "dragstart",
          "mousedown",
          "mousemove",
          "mouseout",
          "mouseover",
          "mouseup",
          "rightclick",
        ];

        exports["default"] = (0, _mapElementFactory2.default)({
          mappedProps: props,
          name: "circle",
          ctr: function ctr() {
            return google.maps.Circle;
          },
          events: events,
        });

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/infoWindowImpl.js":
      /*!*************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/infoWindowImpl.js ***!
  \*************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _mapElementFactory = __webpack_require__(
          /*! ./mapElementFactory.js */ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js"
        );

        var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        var props = {
          options: {
            type: Object,
            required: false,
            default: function _default() {
              return {};
            },
          },
          position: {
            type: Object,
            twoWay: true,
          },
          zIndex: {
            type: Number,
            twoWay: true,
          },
        };

        var events = ["domready", "closeclick", "content_changed"];

        exports["default"] = (0, _mapElementFactory2.default)({
          mappedProps: props,
          events: events,
          name: "infoWindow",
          ctr: function ctr() {
            return google.maps.InfoWindow;
          },
          props: {
            opened: {
              type: Boolean,
              default: true,
            },
          },

          inject: {
            $markerPromise: {
              default: null,
            },
          },

          mounted: function mounted() {
            var el = this.$refs.flyaway;
            el.parentNode.removeChild(el);
          },
          beforeCreate: function beforeCreate(options) {
            var _this = this;

            options.content = this.$refs.flyaway;

            if (this.$markerPromise) {
              delete options.position;
              return this.$markerPromise.then(function (mo) {
                _this.$markerObject = mo;
                return mo;
              });
            }
          },

          methods: {
            _openInfoWindow: function _openInfoWindow() {
              if (this.opened) {
                if (this.$markerObject !== null) {
                  this.$infoWindowObject.open(this.$map, this.$markerObject);
                } else {
                  this.$infoWindowObject.open(this.$map);
                }
              } else {
                this.$infoWindowObject.close();
              }
            },
          },

          afterCreate: function afterCreate() {
            var _this2 = this;

            this._openInfoWindow();
            this.$watch("opened", function () {
              _this2._openInfoWindow();
            });
          },
        });

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js":
      /*!****************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/mapElementFactory.js ***!
  \****************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _slicedToArray = (function () {
          function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
              for (
                var _i = arr[Symbol.iterator](), _s;
                !(_n = (_s = _i.next()).done);
                _n = true
              ) {
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i["return"]) _i["return"]();
              } finally {
                if (_d) throw _e;
              }
            }
            return _arr;
          }
          return function (arr, i) {
            if (Array.isArray(arr)) {
              return arr;
            } else if (Symbol.iterator in Object(arr)) {
              return sliceIterator(arr, i);
            } else {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance"
              );
            }
          };
        })();

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i];
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }
            return target;
          };

        exports["default"] = function (options) {
          var mappedProps = options.mappedProps,
            name = options.name,
            ctr = options.ctr,
            ctrArgs = options.ctrArgs,
            events = options.events,
            beforeCreate = options.beforeCreate,
            afterCreate = options.afterCreate,
            props = options.props,
            rest = _objectWithoutProperties(options, [
              "mappedProps",
              "name",
              "ctr",
              "ctrArgs",
              "events",
              "beforeCreate",
              "afterCreate",
              "props",
            ]);

          var promiseName = "$" + name + "Promise";
          var instanceName = "$" + name + "Object";

          assert(
            !(rest.props instanceof Array),
            "`props` should be an object, not Array"
          );

          return _extends(
            {},
            typeof GENERATE_DOC !== "undefined" ? { $vgmOptions: options } : {},
            {
              mixins: [_mapElementMixin2.default],
              props: _extends({}, props, mappedPropsToVueProps(mappedProps)),
              render: function render() {
                return "";
              },
              provide: function provide() {
                var _this = this;

                var promise = this.$mapPromise
                  .then(function (map) {
                    // Infowindow needs this to be immediately available
                    _this.$map = map;

                    // Initialize the maps with the given options
                    var options = _extends(
                      {},
                      _this.options,
                      {
                        map: map,
                      },
                      (0, _bindProps.getPropsValues)(_this, mappedProps)
                    );
                    delete options.options; // delete the extra options

                    if (beforeCreate) {
                      var result = beforeCreate.bind(_this)(options);

                      if (result instanceof Promise) {
                        return result.then(function () {
                          return { options: options };
                        });
                      }
                    }
                    return { options: options };
                  })
                  .then(function (_ref) {
                    var _Function$prototype$b;

                    var options = _ref.options;

                    var ConstructorObject = ctr();
                    // https://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
                    _this[instanceName] = ctrArgs
                      ? new ((_Function$prototype$b =
                          Function.prototype.bind).call.apply(
                          _Function$prototype$b,
                          [ConstructorObject, null].concat(
                            _toConsumableArray(
                              ctrArgs(
                                options,
                                (0, _bindProps.getPropsValues)(
                                  _this,
                                  props || {}
                                )
                              )
                            )
                          )
                        ))()
                      : new ConstructorObject(options);

                    (0,
                    _bindProps.bindProps)(_this, _this[instanceName], mappedProps);
                    (0,
                    _bindEvents2.default)(_this, _this[instanceName], events);

                    if (afterCreate) {
                      afterCreate.bind(_this)(_this[instanceName]);
                    }
                    return _this[instanceName];
                  });
                this[promiseName] = promise;
                return _defineProperty({}, promiseName, promise);
              },
              destroyed: function destroyed() {
                // Note: not all Google Maps components support maps
                if (this[instanceName] && this[instanceName].setMap) {
                  this[instanceName].setMap(null);
                }
              },
            },
            rest
          );
        };

        exports.mappedPropsToVueProps = mappedPropsToVueProps;

        var _bindEvents = __webpack_require__(
          /*! ../utils/bindEvents.js */ "./node_modules/vue2-google-maps/dist/utils/bindEvents.js"
        );

        var _bindEvents2 = _interopRequireDefault(_bindEvents);

        var _bindProps = __webpack_require__(
          /*! ../utils/bindProps.js */ "./node_modules/vue2-google-maps/dist/utils/bindProps.js"
        );

        var _mapElementMixin = __webpack_require__(
          /*! ./mapElementMixin */ "./node_modules/vue2-google-maps/dist/components/mapElementMixin.js"
        );

        var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true,
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }

        function _toConsumableArray(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }
            return arr2;
          } else {
            return Array.from(arr);
          }
        }

        function _objectWithoutProperties(obj, keys) {
          var target = {};
          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }
          return target;
        }

        /**
         *
         * @param {Object} options
         * @param {Object} options.mappedProps - Definitions of props
         * @param {Object} options.mappedProps.PROP.type - Value type
         * @param {Boolean} options.mappedProps.PROP.twoWay
         *  - Whether the prop has a corresponding PROP_changed
         *   event
         * @param {Boolean} options.mappedProps.PROP.noBind
         *  - If true, do not apply the default bindProps / bindEvents.
         * However it will still be added to the list of component props
         * @param {Object} options.props - Regular Vue-style props.
         *  Note: must be in the Object form because it will be
         *  merged with the `mappedProps`
         *
         * @param {Object} options.events - Google Maps API events
         *  that are not bound to a corresponding prop
         * @param {String} options.name - e.g. `polyline`
         * @param {=> String} options.ctr - constructor, e.g.
         *  `google.maps.Polyline`. However, since this is not
         *  generally available during library load, this becomes
         *  a function instead, e.g. () => google.maps.Polyline
         *  which will be called only after the API has been loaded
         * @param {(MappedProps, OtherVueProps) => Array} options.ctrArgs -
         *   If the constructor in `ctr` needs to be called with
         *   arguments other than a single `options` object, e.g. for
         *   GroundOverlay, we call `new GroundOverlay(url, bounds, options)`
         *   then pass in a function that returns the argument list as an array
         *
         * Otherwise, the constructor will be called with an `options` object,
         *   with property and values merged from:
         *
         *   1. the `options` property, if any
         *   2. a `map` property with the Google Maps
         *   3. all the properties passed to the component in `mappedProps`
         * @param {Object => Any} options.beforeCreate -
         *  Hook to modify the options passed to the initializer
         * @param {(options.ctr, Object) => Any} options.afterCreate -
         *  Hook called when
         *
         */

        function assert(v, message) {
          if (!v) throw new Error(message);
        }

        /**
         * Strips out the extraneous properties we have in our
         * props definitions
         * @param {Object} props
         */
        function mappedPropsToVueProps(mappedProps) {
          return Object.entries(mappedProps)
            .map(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                key = _ref4[0],
                prop = _ref4[1];

              var value = {};

              if ("type" in prop) value.type = prop.type;
              if ("default" in prop) value.default = prop.default;
              if ("required" in prop) value.required = prop.required;

              return [key, value];
            })
            .reduce(function (acc, _ref5) {
              var _ref6 = _slicedToArray(_ref5, 2),
                key = _ref6[0],
                val = _ref6[1];

              acc[key] = val;
              return acc;
            }, {});
        }

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/mapElementMixin.js":
      /*!**************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/mapElementMixin.js ***!
  \**************************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        /**
         * @class MapElementMixin
         *
         * Extends components to include the following fields:
         *
         * @property $map        The Google map (valid only after the promise returns)
         *
         *
         * */
        exports["default"] = {
          inject: {
            $mapPromise: { default: "abcdef" },
          },

          provide: function provide() {
            var _this = this;

            // Note: although this mixin is not "providing" anything,
            // components' expect the `$map` property to be present on the component.
            // In order for that to happen, this mixin must intercept the $mapPromise
            // .then(() =>) first before its component does so.
            //
            // Since a provide() on a mixin is executed before a provide() on the
            // component, putting this code in provide() ensures that the $map is
            // already set by the time the
            // component's provide() is called.
            this.$mapPromise.then(function (map) {
              _this.$map = map;
            });

            return {};
          },
        };

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/mapImpl.js":
      /*!******************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/mapImpl.js ***!
  \******************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i];
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }
            return target;
          };

        var _bindEvents = __webpack_require__(
          /*! ../utils/bindEvents.js */ "./node_modules/vue2-google-maps/dist/utils/bindEvents.js"
        );

        var _bindEvents2 = _interopRequireDefault(_bindEvents);

        var _bindProps = __webpack_require__(
          /*! ../utils/bindProps.js */ "./node_modules/vue2-google-maps/dist/utils/bindProps.js"
        );

        var _mountableMixin = __webpack_require__(
          /*! ../utils/mountableMixin.js */ "./node_modules/vue2-google-maps/dist/utils/mountableMixin.js"
        );

        var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

        var _TwoWayBindingWrapper = __webpack_require__(
          /*! ../utils/TwoWayBindingWrapper.js */ "./node_modules/vue2-google-maps/dist/utils/TwoWayBindingWrapper.js"
        );

        var _TwoWayBindingWrapper2 = _interopRequireDefault(
          _TwoWayBindingWrapper
        );

        var _WatchPrimitiveProperties = __webpack_require__(
          /*! ../utils/WatchPrimitiveProperties.js */ "./node_modules/vue2-google-maps/dist/utils/WatchPrimitiveProperties.js"
        );

        var _WatchPrimitiveProperties2 = _interopRequireDefault(
          _WatchPrimitiveProperties
        );

        var _mapElementFactory = __webpack_require__(
          /*! ./mapElementFactory.js */ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js"
        );

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        var props = {
          center: {
            required: true,
            twoWay: true,
            type: Object,
            noBind: true,
          },
          zoom: {
            required: false,
            twoWay: true,
            type: Number,
            noBind: true,
          },
          heading: {
            type: Number,
            twoWay: true,
          },
          mapTypeId: {
            twoWay: true,
            type: String,
          },
          tilt: {
            twoWay: true,
            type: Number,
          },
          options: {
            type: Object,
            default: function _default() {
              return {};
            },
          },
        };

        var events = [
          "bounds_changed",
          "click",
          "dblclick",
          "drag",
          "dragend",
          "dragstart",
          "idle",
          "mousemove",
          "mouseout",
          "mouseover",
          "resize",
          "rightclick",
          "tilesloaded",
        ];

        // Plain Google Maps methods exposed here for convenience
        var linkedMethods = [
          "panBy",
          "panTo",
          "panToBounds",
          "fitBounds",
        ].reduce(function (all, methodName) {
          all[methodName] = function () {
            if (this.$mapObject) {
              this.$mapObject[methodName].apply(this.$mapObject, arguments);
            }
          };
          return all;
        }, {});

        // Other convenience methods exposed by Vue Google Maps
        var customMethods = {
          resize: function resize() {
            if (this.$mapObject) {
              google.maps.event.trigger(this.$mapObject, "resize");
            }
          },
          resizePreserveCenter: function resizePreserveCenter() {
            if (!this.$mapObject) {
              return;
            }

            var oldCenter = this.$mapObject.getCenter();
            google.maps.event.trigger(this.$mapObject, "resize");
            this.$mapObject.setCenter(oldCenter);
          },

          /// Override mountableMixin::_resizeCallback
          /// because resizePreserveCenter is usually the
          /// expected behaviour
          _resizeCallback: function _resizeCallback() {
            this.resizePreserveCenter();
          },
        };

        exports["default"] = {
          mixins: [_mountableMixin2.default],
          props: (0, _mapElementFactory.mappedPropsToVueProps)(props),

          provide: function provide() {
            var _this = this;

            this.$mapPromise = new Promise(function (resolve, reject) {
              _this.$mapPromiseDeferred = { resolve: resolve, reject: reject };
            });
            return {
              $mapPromise: this.$mapPromise,
            };
          },

          computed: {
            finalLat: function finalLat() {
              return this.center && typeof this.center.lat === "function"
                ? this.center.lat()
                : this.center.lat;
            },
            finalLng: function finalLng() {
              return this.center && typeof this.center.lng === "function"
                ? this.center.lng()
                : this.center.lng;
            },
            finalLatLng: function finalLatLng() {
              return { lat: this.finalLat, lng: this.finalLng };
            },
          },

          watch: {
            zoom: function zoom(_zoom) {
              if (this.$mapObject) {
                this.$mapObject.setZoom(_zoom);
              }
            },
          },

          mounted: function mounted() {
            var _this2 = this;

            return this.$gmapApiPromiseLazy()
              .then(function () {
                // getting the DOM element where to create the map
                var element = _this2.$refs["vue-map"];

                // creating the map
                var options = _extends(
                  {},
                  _this2.options,
                  (0, _bindProps.getPropsValues)(_this2, props)
                );
                delete options.options;
                _this2.$mapObject = new google.maps.Map(element, options);

                // binding properties (two and one way)
                (0, _bindProps.bindProps)(_this2, _this2.$mapObject, props);
                // binding events
                (0, _bindEvents2.default)(_this2, _this2.$mapObject, events);

                // manually trigger center and zoom
                (0,
                _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
                  _this2.$mapObject.addListener("center_changed", function () {
                    if (shouldUpdate()) {
                      _this2.$emit(
                        "center_changed",
                        _this2.$mapObject.getCenter()
                      );
                    }
                    decrement();
                  });

                  (0,
                  _WatchPrimitiveProperties2.default)(_this2, ["finalLat", "finalLng"], function updateCenter() {
                    increment();
                    _this2.$mapObject.setCenter(_this2.finalLatLng);
                  });
                });
                _this2.$mapObject.addListener("zoom_changed", function () {
                  _this2.$emit("zoom_changed", _this2.$mapObject.getZoom());
                });
                _this2.$mapObject.addListener("bounds_changed", function () {
                  _this2.$emit("bounds_changed", _this2.$mapObject.getBounds());
                });

                _this2.$mapPromiseDeferred.resolve(_this2.$mapObject);

                return _this2.$mapObject;
              })
              .catch(function (error) {
                throw error;
              });
          },

          methods: _extends({}, customMethods, linkedMethods),
        };

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/marker.js":
      /*!*****************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/marker.js ***!
  \*****************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _mapElementFactory = __webpack_require__(
          /*! ./mapElementFactory.js */ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js"
        );

        var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        var props = {
          animation: {
            twoWay: true,
            type: Number,
          },
          attribution: {
            type: Object,
          },
          clickable: {
            type: Boolean,
            twoWay: true,
            default: true,
          },
          cursor: {
            type: String,
            twoWay: true,
          },
          draggable: {
            type: Boolean,
            twoWay: true,
            default: false,
          },
          icon: {
            twoWay: true,
          },
          label: {},
          opacity: {
            type: Number,
            default: 1,
          },
          options: {
            type: Object,
          },
          place: {
            type: Object,
          },
          position: {
            type: Object,
            twoWay: true,
          },
          shape: {
            type: Object,
            twoWay: true,
          },
          title: {
            type: String,
            twoWay: true,
          },
          zIndex: {
            type: Number,
            twoWay: true,
          },
          visible: {
            twoWay: true,
            default: true,
          },
        };

        var events = [
          "click",
          "rightclick",
          "dblclick",
          "drag",
          "dragstart",
          "dragend",
          "mouseup",
          "mousedown",
          "mouseover",
          "mouseout",
        ];

        /**
         * @class Marker
         *
         * Marker class with extra support for
         *
         * - Embedded info windows
         * - Clustered markers
         *
         * Support for clustered markers is for backward-compatability
         * reasons. Otherwise we should use a cluster-marker mixin or
         * subclass.
         */
        exports["default"] = (0, _mapElementFactory2.default)({
          mappedProps: props,
          events: events,
          name: "marker",
          ctr: function ctr() {
            return google.maps.Marker;
          },

          inject: {
            $clusterPromise: {
              default: null,
            },
          },

          render: function render(h) {
            if (!this.$slots.default || this.$slots.default.length === 0) {
              return "";
            } else if (this.$slots.default.length === 1) {
              // So that infowindows can have a marker parent
              return this.$slots.default[0];
            } else {
              return h("div", this.$slots.default);
            }
          },
          destroyed: function destroyed() {
            if (!this.$markerObject) {
              return;
            }

            if (this.$clusterObject) {
              // Repaint will be performed in `updated()` of cluster
              this.$clusterObject.removeMarker(this.$markerObject, true);
            } else {
              this.$markerObject.setMap(null);
            }
          },
          beforeCreate: function beforeCreate(options) {
            if (this.$clusterPromise) {
              options.map = null;
            }

            return this.$clusterPromise;
          },
          afterCreate: function afterCreate(inst) {
            var _this = this;

            if (this.$clusterPromise) {
              this.$clusterPromise.then(function (co) {
                co.addMarker(inst);
                _this.$clusterObject = co;
              });
            }
          },
        });

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/placeInputImpl.js?vue&type=script&lang=js&?0ebb":
      /*!**************************************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/placeInputImpl.js?vue&type=script&lang=js& ***!
  \**************************************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _bindProps = __webpack_require__(
          /*! ../utils/bindProps.js */ "./node_modules/vue2-google-maps/dist/utils/bindProps.js"
        );

        var _simulateArrowDown = __webpack_require__(
          /*! ../utils/simulateArrowDown.js */ "./node_modules/vue2-google-maps/dist/utils/simulateArrowDown.js"
        );

        var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        function _objectWithoutProperties(obj, keys) {
          var target = {};
          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }
          return target;
        }

        var props = {
          bounds: {
            type: Object,
          },
          defaultPlace: {
            type: String,
            default: "",
          },
          componentRestrictions: {
            type: Object,
            default: null,
          },
          types: {
            type: Array,
            default: function _default() {
              return [];
            },
          },
          placeholder: {
            required: false,
            type: String,
          },
          className: {
            required: false,
            type: String,
          },
          label: {
            required: false,
            type: String,
            default: null,
          },
          selectFirstOnEnter: {
            require: false,
            type: Boolean,
            default: false,
          },
        };

        exports["default"] = {
          mounted: function mounted() {
            var _this = this;

            var input = this.$refs.input;

            // Allow default place to be set
            input.value = this.defaultPlace;
            this.$watch("defaultPlace", function () {
              input.value = _this.defaultPlace;
            });

            this.$gmapApiPromiseLazy().then(function () {
              var options = (0, _bindProps.getPropsValues)(_this, props);
              if (_this.selectFirstOnEnter) {
                (0, _simulateArrowDown2.default)(_this.$refs.input);
              }

              if (typeof google.maps.places.Autocomplete !== "function") {
                throw new Error(
                  "google.maps.places.Autocomplete is undefined. Did you add 'places' to libraries when loading Google Maps?"
                );
              }

              _this.autoCompleter = new google.maps.places.Autocomplete(
                _this.$refs.input,
                options
              );

              var placeholder = props.placeholder,
                place = props.place,
                defaultPlace = props.defaultPlace,
                className = props.className,
                label = props.label,
                selectFirstOnEnter = props.selectFirstOnEnter,
                rest = _objectWithoutProperties(props, [
                  "placeholder",
                  "place",
                  "defaultPlace",
                  "className",
                  "label",
                  "selectFirstOnEnter",
                ]); // eslint-disable-line

              (0, _bindProps.bindProps)(_this, _this.autoCompleter, rest);

              _this.autoCompleter.addListener("place_changed", function () {
                _this.$emit("place_changed", _this.autoCompleter.getPlace());
              });
            });
          },
          created: function created() {
            console.warn(
              "The PlaceInput class is deprecated! Please consider using the Autocomplete input instead"
            ); // eslint-disable-line no-console
          },

          props: props,
        };

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/polygon.js":
      /*!******************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/polygon.js ***!
  \******************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _slicedToArray = (function () {
          function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
              for (
                var _i = arr[Symbol.iterator](), _s;
                !(_n = (_s = _i.next()).done);
                _n = true
              ) {
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i["return"]) _i["return"]();
              } finally {
                if (_d) throw _e;
              }
            }
            return _arr;
          }
          return function (arr, i) {
            if (Array.isArray(arr)) {
              return arr;
            } else if (Symbol.iterator in Object(arr)) {
              return sliceIterator(arr, i);
            } else {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance"
              );
            }
          };
        })();

        var _mapElementFactory = __webpack_require__(
          /*! ./mapElementFactory.js */ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js"
        );

        var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        var props = {
          draggable: {
            type: Boolean,
          },
          editable: {
            type: Boolean,
          },
          options: {
            type: Object,
          },
          path: {
            type: Array,
            twoWay: true,
            noBind: true,
          },
          paths: {
            type: Array,
            twoWay: true,
            noBind: true,
          },
        };

        var events = [
          "click",
          "dblclick",
          "drag",
          "dragend",
          "dragstart",
          "mousedown",
          "mousemove",
          "mouseout",
          "mouseover",
          "mouseup",
          "rightclick",
        ];

        exports["default"] = (0, _mapElementFactory2.default)({
          props: {
            deepWatch: {
              type: Boolean,
              default: false,
            },
          },
          events: events,
          mappedProps: props,
          name: "polygon",
          ctr: function ctr() {
            return google.maps.Polygon;
          },

          beforeCreate: function beforeCreate(options) {
            if (!options.path) delete options.path;
            if (!options.paths) delete options.paths;
          },
          afterCreate: function afterCreate(inst) {
            var _this = this;

            var clearEvents = function () {};

            // Watch paths, on our own, because we do not want to set either when it is
            // empty
            this.$watch(
              "paths",
              function (paths) {
                if (paths) {
                  clearEvents();

                  inst.setPaths(paths);

                  var updatePaths = function () {
                    _this.$emit("paths_changed", inst.getPaths());
                  };
                  var eventListeners = [];

                  var mvcArray = inst.getPaths();
                  for (var i = 0; i < mvcArray.getLength(); i++) {
                    var mvcPath = mvcArray.getAt(i);
                    eventListeners.push([
                      mvcPath,
                      mvcPath.addListener("insert_at", updatePaths),
                    ]);
                    eventListeners.push([
                      mvcPath,
                      mvcPath.addListener("remove_at", updatePaths),
                    ]);
                    eventListeners.push([
                      mvcPath,
                      mvcPath.addListener("set_at", updatePaths),
                    ]);
                  }
                  eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("insert_at", updatePaths),
                  ]);
                  eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("remove_at", updatePaths),
                  ]);
                  eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("set_at", updatePaths),
                  ]);

                  clearEvents = function () {
                    eventListeners.map(function (_ref) {
                      var _ref2 = _slicedToArray(_ref, 2),
                        obj = _ref2[0],
                        listenerHandle = _ref2[1];

                      return (
                        // eslint-disable-line no-unused-vars
                        google.maps.event.removeListener(listenerHandle)
                      );
                    });
                  };
                }
              },
              {
                deep: this.deepWatch,
                immediate: true,
              }
            );

            this.$watch(
              "path",
              function (path) {
                if (path) {
                  clearEvents();

                  inst.setPaths(path);

                  var mvcPath = inst.getPath();
                  var eventListeners = [];

                  var updatePaths = function () {
                    _this.$emit("path_changed", inst.getPath());
                  };

                  eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("insert_at", updatePaths),
                  ]);
                  eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("remove_at", updatePaths),
                  ]);
                  eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("set_at", updatePaths),
                  ]);

                  clearEvents = function () {
                    eventListeners.map(function (_ref3) {
                      var _ref4 = _slicedToArray(_ref3, 2),
                        obj = _ref4[0],
                        listenerHandle = _ref4[1];

                      return (
                        // eslint-disable-line no-unused-vars
                        google.maps.event.removeListener(listenerHandle)
                      );
                    });
                  };
                }
              },
              {
                deep: this.deepWatch,
                immediate: true,
              }
            );
          },
        });

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/polyline.js":
      /*!*******************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/polyline.js ***!
  \*******************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _slicedToArray = (function () {
          function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
              for (
                var _i = arr[Symbol.iterator](), _s;
                !(_n = (_s = _i.next()).done);
                _n = true
              ) {
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i["return"]) _i["return"]();
              } finally {
                if (_d) throw _e;
              }
            }
            return _arr;
          }
          return function (arr, i) {
            if (Array.isArray(arr)) {
              return arr;
            } else if (Symbol.iterator in Object(arr)) {
              return sliceIterator(arr, i);
            } else {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance"
              );
            }
          };
        })();

        var _mapElementFactory = __webpack_require__(
          /*! ./mapElementFactory.js */ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js"
        );

        var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        var props = {
          draggable: {
            type: Boolean,
          },
          editable: {
            type: Boolean,
          },
          options: {
            twoWay: false,
            type: Object,
          },
          path: {
            type: Array,
            twoWay: true,
          },
        };

        var events = [
          "click",
          "dblclick",
          "drag",
          "dragend",
          "dragstart",
          "mousedown",
          "mousemove",
          "mouseout",
          "mouseover",
          "mouseup",
          "rightclick",
        ];

        exports["default"] = (0, _mapElementFactory2.default)({
          mappedProps: props,
          props: {
            deepWatch: {
              type: Boolean,
              default: false,
            },
          },
          events: events,

          name: "polyline",
          ctr: function ctr() {
            return google.maps.Polyline;
          },

          afterCreate: function afterCreate() {
            var _this = this;

            var clearEvents = function () {};

            this.$watch(
              "path",
              function (path) {
                if (path) {
                  clearEvents();

                  _this.$polylineObject.setPath(path);

                  var mvcPath = _this.$polylineObject.getPath();
                  var eventListeners = [];

                  var updatePaths = function () {
                    _this.$emit(
                      "path_changed",
                      _this.$polylineObject.getPath()
                    );
                  };

                  eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("insert_at", updatePaths),
                  ]);
                  eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("remove_at", updatePaths),
                  ]);
                  eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("set_at", updatePaths),
                  ]);

                  clearEvents = function () {
                    eventListeners.map(function (_ref) {
                      var _ref2 = _slicedToArray(_ref, 2),
                        obj = _ref2[0],
                        listenerHandle = _ref2[1];

                      return (
                        // eslint-disable-line no-unused-vars
                        google.maps.event.removeListener(listenerHandle)
                      );
                    });
                  };
                }
              },
              {
                deep: this.deepWatch,
                immediate: true,
              }
            );
          },
        });

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/rectangle.js":
      /*!********************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/rectangle.js ***!
  \********************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _mapElementFactory = __webpack_require__(
          /*! ./mapElementFactory.js */ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js"
        );

        var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        var props = {
          bounds: {
            type: Object,
            twoWay: true,
          },
          draggable: {
            type: Boolean,
            default: false,
          },
          editable: {
            type: Boolean,
            default: false,
          },
          options: {
            type: Object,
            twoWay: false,
          },
        };

        var events = [
          "click",
          "dblclick",
          "drag",
          "dragend",
          "dragstart",
          "mousedown",
          "mousemove",
          "mouseout",
          "mouseover",
          "mouseup",
          "rightclick",
        ];

        exports["default"] = (0, _mapElementFactory2.default)({
          mappedProps: props,
          name: "rectangle",
          ctr: function ctr() {
            return google.maps.Rectangle;
          },
          events: events,
        });

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/components/streetViewPanoramaImpl.js":
      /*!*********************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/components/streetViewPanoramaImpl.js ***!
  \*********************************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i];
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }
            return target;
          };

        var _bindEvents = __webpack_require__(
          /*! ../utils/bindEvents.js */ "./node_modules/vue2-google-maps/dist/utils/bindEvents.js"
        );

        var _bindEvents2 = _interopRequireDefault(_bindEvents);

        var _bindProps = __webpack_require__(
          /*! ../utils/bindProps.js */ "./node_modules/vue2-google-maps/dist/utils/bindProps.js"
        );

        var _mountableMixin = __webpack_require__(
          /*! ../utils/mountableMixin.js */ "./node_modules/vue2-google-maps/dist/utils/mountableMixin.js"
        );

        var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

        var _TwoWayBindingWrapper = __webpack_require__(
          /*! ../utils/TwoWayBindingWrapper.js */ "./node_modules/vue2-google-maps/dist/utils/TwoWayBindingWrapper.js"
        );

        var _TwoWayBindingWrapper2 = _interopRequireDefault(
          _TwoWayBindingWrapper
        );

        var _WatchPrimitiveProperties = __webpack_require__(
          /*! ../utils/WatchPrimitiveProperties.js */ "./node_modules/vue2-google-maps/dist/utils/WatchPrimitiveProperties.js"
        );

        var _WatchPrimitiveProperties2 = _interopRequireDefault(
          _WatchPrimitiveProperties
        );

        var _mapElementFactory = __webpack_require__(
          /*! ./mapElementFactory.js */ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js"
        );

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        var props = {
          zoom: {
            twoWay: true,
            type: Number,
          },
          pov: {
            twoWay: true,
            type: Object,
            trackProperties: ["pitch", "heading"],
          },
          position: {
            twoWay: true,
            type: Object,
            noBind: true,
          },
          pano: {
            twoWay: true,
            type: String,
          },
          motionTracking: {
            twoWay: false,
            type: Boolean,
          },
          visible: {
            twoWay: true,
            type: Boolean,
            default: true,
          },
          options: {
            twoWay: false,
            type: Object,
            default: function _default() {
              return {};
            },
          },
        };

        var events = ["closeclick", "status_changed"];

        exports["default"] = {
          mixins: [_mountableMixin2.default],
          props: (0, _mapElementFactory.mappedPropsToVueProps)(props),
          replace: false, // necessary for css styles
          methods: {
            resize: function resize() {
              if (this.$panoObject) {
                google.maps.event.trigger(this.$panoObject, "resize");
              }
            },
          },

          provide: function provide() {
            var _this = this;

            var promise = new Promise(function (resolve, reject) {
              _this.$panoPromiseDeferred = { resolve: resolve, reject: reject };
            });
            return {
              $panoPromise: promise,
              $mapPromise: promise, // so that we can use it with markers
            };
          },

          computed: {
            finalLat: function finalLat() {
              return this.position && typeof this.position.lat === "function"
                ? this.position.lat()
                : this.position.lat;
            },
            finalLng: function finalLng() {
              return this.position && typeof this.position.lng === "function"
                ? this.position.lng()
                : this.position.lng;
            },
            finalLatLng: function finalLatLng() {
              return {
                lat: this.finalLat,
                lng: this.finalLng,
              };
            },
          },

          watch: {
            zoom: function zoom(_zoom) {
              if (this.$panoObject) {
                this.$panoObject.setZoom(_zoom);
              }
            },
          },

          mounted: function mounted() {
            var _this2 = this;

            return this.$gmapApiPromiseLazy()
              .then(function () {
                // getting the DOM element where to create the map
                var element = _this2.$refs["vue-street-view-pano"];

                // creating the map
                var options = _extends(
                  {},
                  _this2.options,
                  (0, _bindProps.getPropsValues)(_this2, props)
                );
                delete options.options;

                _this2.$panoObject = new google.maps.StreetViewPanorama(
                  element,
                  options
                );

                // binding properties (two and one way)
                (0, _bindProps.bindProps)(_this2, _this2.$panoObject, props);
                // binding events
                (0, _bindEvents2.default)(_this2, _this2.$panoObject, events);

                // manually trigger position
                (0,
                _TwoWayBindingWrapper2.default)(function (increment, decrement, shouldUpdate) {
                  // Panos take a while to load
                  increment();

                  _this2.$panoObject.addListener(
                    "position_changed",
                    function () {
                      if (shouldUpdate()) {
                        _this2.$emit(
                          "position_changed",
                          _this2.$panoObject.getPosition()
                        );
                      }
                      decrement();
                    }
                  );

                  (0,
                  _WatchPrimitiveProperties2.default)(_this2, ["finalLat", "finalLng"], function updateCenter() {
                    increment();
                    _this2.$panoObject.setPosition(_this2.finalLatLng);
                  });
                });

                _this2.$panoPromiseDeferred.resolve(_this2.$panoObject);

                return _this2.$panoPromise;
              })
              .catch(function (error) {
                throw error;
              });
          },
        };

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/main.js":
      /*!****************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/main.js ***!
  \****************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        exports.StreetViewPanorama =
          exports.MountableMixin =
          exports.Autocomplete =
          exports.MapElementFactory =
          exports.MapElementMixin =
          exports.PlaceInput =
          exports.Map =
          exports.InfoWindow =
          exports.Rectangle =
          exports.Cluster =
          exports.Circle =
          exports.Polygon =
          exports.Polyline =
          exports.Marker =
          exports.loadGmapApi =
            undefined;

        var _extends =
          Object.assign ||
          function (target) {
            for (var i = 1; i < arguments.length; i++) {
              var source = arguments[i];
              for (var key in source) {
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                  target[key] = source[key];
                }
              }
            }
            return target;
          };

        // Vue component imports

        exports.install = install;
        exports.gmapApi = gmapApi;

        var _lazyValue = __webpack_require__(
          /*! ./utils/lazyValue */ "./node_modules/vue2-google-maps/dist/utils/lazyValue.js"
        );

        var _lazyValue2 = _interopRequireDefault(_lazyValue);

        var _manager = __webpack_require__(
          /*! ./manager */ "./node_modules/vue2-google-maps/dist/manager.js"
        );

        var _marker = __webpack_require__(
          /*! ./components/marker */ "./node_modules/vue2-google-maps/dist/components/marker.js"
        );

        var _marker2 = _interopRequireDefault(_marker);

        var _polyline = __webpack_require__(
          /*! ./components/polyline */ "./node_modules/vue2-google-maps/dist/components/polyline.js"
        );

        var _polyline2 = _interopRequireDefault(_polyline);

        var _polygon = __webpack_require__(
          /*! ./components/polygon */ "./node_modules/vue2-google-maps/dist/components/polygon.js"
        );

        var _polygon2 = _interopRequireDefault(_polygon);

        var _circle = __webpack_require__(
          /*! ./components/circle */ "./node_modules/vue2-google-maps/dist/components/circle.js"
        );

        var _circle2 = _interopRequireDefault(_circle);

        var _rectangle = __webpack_require__(
          /*! ./components/rectangle */ "./node_modules/vue2-google-maps/dist/components/rectangle.js"
        );

        var _rectangle2 = _interopRequireDefault(_rectangle);

        var _infoWindow = __webpack_require__(
          /*! ./components/infoWindow.vue */ "./node_modules/vue2-google-maps/dist/components/infoWindow.vue"
        );

        var _infoWindow2 = _interopRequireDefault(_infoWindow);

        var _map = __webpack_require__(
          /*! ./components/map.vue */ "./node_modules/vue2-google-maps/dist/components/map.vue"
        );

        var _map2 = _interopRequireDefault(_map);

        var _streetViewPanorama = __webpack_require__(
          /*! ./components/streetViewPanorama.vue */ "./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue"
        );

        var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);

        var _placeInput = __webpack_require__(
          /*! ./components/placeInput.vue */ "./node_modules/vue2-google-maps/dist/components/placeInput.vue"
        );

        var _placeInput2 = _interopRequireDefault(_placeInput);

        var _autocomplete = __webpack_require__(
          /*! ./components/autocomplete.vue */ "./node_modules/vue2-google-maps/dist/components/autocomplete.vue"
        );

        var _autocomplete2 = _interopRequireDefault(_autocomplete);

        var _mapElementMixin = __webpack_require__(
          /*! ./components/mapElementMixin */ "./node_modules/vue2-google-maps/dist/components/mapElementMixin.js"
        );

        var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

        var _mapElementFactory = __webpack_require__(
          /*! ./components/mapElementFactory */ "./node_modules/vue2-google-maps/dist/components/mapElementFactory.js"
        );

        var _mapElementFactory2 = _interopRequireDefault(_mapElementFactory);

        var _mountableMixin = __webpack_require__(
          /*! ./utils/mountableMixin */ "./node_modules/vue2-google-maps/dist/utils/mountableMixin.js"
        );

        var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        // HACK: Cluster should be loaded conditionally
        // However in the web version, it's not possible to write
        // `import 'vue2-google-maps/src/components/cluster'`, so we need to
        // import it anyway (but we don't have to register it)
        // Therefore we use babel-plugin-transform-inline-environment-variables to
        // set BUILD_DEV to truthy / falsy
        var Cluster = undefined;

        var GmapApi = null;

        // export everything
        exports.loadGmapApi = _manager.loadGmapApi;
        exports.Marker = _marker2.default;
        exports.Polyline = _polyline2.default;
        exports.Polygon = _polygon2.default;
        exports.Circle = _circle2.default;
        exports.Cluster = Cluster;
        exports.Rectangle = _rectangle2.default;
        exports.InfoWindow = _infoWindow2.default;
        exports.Map = _map2.default;
        exports.PlaceInput = _placeInput2.default;
        exports.MapElementMixin = _mapElementMixin2.default;
        exports.MapElementFactory = _mapElementFactory2.default;
        exports.Autocomplete = _autocomplete2.default;
        exports.MountableMixin = _mountableMixin2.default;
        exports.StreetViewPanorama = _streetViewPanorama2.default;
        function install(Vue, options) {
          // Set defaults
          options = _extends(
            {
              installComponents: true,
              autobindAllEvents: false,
            },
            options
          );

          // Update the global `GmapApi`. This will allow
          // components to use the `google` global reactively
          // via:
          //   import {gmapApi} from 'vue2-google-maps'
          //   export default {  computed: { google: gmapApi }  }
          GmapApi = new Vue({ data: { gmapApi: null } });

          var defaultResizeBus = new Vue();

          // Use a lazy to only load the API when
          // a VGM component is loaded
          var gmapApiPromiseLazy = makeGmapApiPromiseLazy(options);

          Vue.mixin({
            created: function created() {
              this.$gmapDefaultResizeBus = defaultResizeBus;
              this.$gmapOptions = options;
              this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
            },
          });
          Vue.$gmapDefaultResizeBus = defaultResizeBus;
          Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;

          if (options.installComponents) {
            Vue.component("GmapMap", _map2.default);
            Vue.component("GmapMarker", _marker2.default);
            Vue.component("GmapInfoWindow", _infoWindow2.default);
            Vue.component("GmapPolyline", _polyline2.default);
            Vue.component("GmapPolygon", _polygon2.default);
            Vue.component("GmapCircle", _circle2.default);
            Vue.component("GmapRectangle", _rectangle2.default);
            Vue.component("GmapAutocomplete", _autocomplete2.default);
            Vue.component("GmapPlaceInput", _placeInput2.default);
            Vue.component(
              "GmapStreetViewPanorama",
              _streetViewPanorama2.default
            );
          }
        }

        function makeGmapApiPromiseLazy(options) {
          // Things to do once the API is loaded
          function onApiLoaded() {
            GmapApi.gmapApi = {};
            return window.google;
          }

          if (options.load) {
            // If library should load the API
            return (0, _lazyValue2.default)(function () {
              // Load the
              // This will only be evaluated once
              if (typeof window === "undefined") {
                // server side -- never resolve this promise
                return new Promise(function () {}).then(onApiLoaded);
              } else {
                return new Promise(function (resolve, reject) {
                  try {
                    window["vueGoogleMapsInit"] = resolve;
                    (0, _manager.loadGmapApi)(options.load, options.loadCn);
                  } catch (err) {
                    reject(err);
                  }
                }).then(onApiLoaded);
              }
            });
          } else {
            // If library should not handle API, provide
            // end-users with the global `vueGoogleMapsInit: () => undefined`
            // when the Google Maps API has been loaded
            var promise = new Promise(function (resolve) {
              if (typeof window === "undefined") {
                // Do nothing if run from server-side
                return;
              }
              window["vueGoogleMapsInit"] = resolve;
            }).then(onApiLoaded);

            return (0, _lazyValue2.default)(function () {
              return promise;
            });
          }
        }

        function gmapApi() {
          return GmapApi.gmapApi && window.google;
        }

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/manager.js":
      /*!*******************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/manager.js ***!
  \*******************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _typeof =
          typeof Symbol === "function" && typeof Symbol.iterator === "symbol"
            ? function (obj) {
                return typeof obj;
              }
            : function (obj) {
                return obj &&
                  typeof Symbol === "function" &&
                  obj.constructor === Symbol &&
                  obj !== Symbol.prototype
                  ? "symbol"
                  : typeof obj;
              };

        var isApiSetUp = false;

        /**
         * @param apiKey    API Key, or object with the URL parameters. For example
         *                  to use Google Maps Premium API, pass
         *                    `{ client: <YOUR-CLIENT-ID> }`.
         *                  You may pass the libraries and/or version (as `v`) parameter into
         *                  this parameter and skip the next two parameters
         * @param version   Google Maps version
         * @param libraries Libraries to load (@see
         *                  https://developers.google.com/maps/documentation/javascript/libraries)
         * @param loadCn    Boolean. If set to true, the map will be loaded from google maps China
         *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
         *
         * Example:
         * ```
         *      import {load} from 'vue-google-maps'
         *
         *      load(<YOUR-API-KEY>)
         *
         *      load({
         *              key: <YOUR-API-KEY>,
         *      })
         *
         *      load({
         *              client: <YOUR-CLIENT-ID>,
         *              channel: <YOUR CHANNEL>
         *      })
         * ```
         */
        var loadGmapApi = (exports.loadGmapApi = function (options, loadCn) {
          if (typeof document === "undefined") {
            // Do nothing if run from server-side
            return;
          }
          if (!isApiSetUp) {
            isApiSetUp = true;

            var googleMapScript = document.createElement("SCRIPT");

            // Allow options to be an object.
            // This is to support more esoteric means of loading Google Maps,
            // such as Google for business
            // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
            if (
              (typeof options === "undefined"
                ? "undefined"
                : _typeof(options)) !== "object"
            ) {
              throw new Error("options should  be an object");
            }

            // libraries
            if (Array.prototype.isPrototypeOf(options.libraries)) {
              options.libraries = options.libraries.join(",");
            }
            options["callback"] = "vueGoogleMapsInit";

            var baseUrl = "https://maps.googleapis.com/";

            if (typeof loadCn === "boolean" && loadCn === true) {
              baseUrl = "https://maps.google.cn/";
            }

            var url =
              baseUrl +
              "maps/api/js?" +
              Object.keys(options)
                .map(function (key) {
                  return (
                    encodeURIComponent(key) +
                    "=" +
                    encodeURIComponent(options[key])
                  );
                })
                .join("&");

            googleMapScript.setAttribute("src", url);
            googleMapScript.setAttribute("async", "");
            googleMapScript.setAttribute("defer", "");
            document.head.appendChild(googleMapScript);
          } else {
            throw new Error("You already started the loading of google maps");
          }
        });

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/utils/TwoWayBindingWrapper.js":
      /*!**************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/utils/TwoWayBindingWrapper.js ***!
  \**************************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        exports["default"] = TwoWayBindingWrapper;
        /**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */
        function TwoWayBindingWrapper(fn) {
          var counter = 0;

          fn(
            function () {
              counter += 1;
            },
            function () {
              counter = Math.max(0, counter - 1);
            },
            function () {
              return counter === 0;
            }
          );
        }

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/utils/WatchPrimitiveProperties.js":
      /*!******************************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/utils/WatchPrimitiveProperties.js ***!
  \******************************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        exports["default"] = WatchPrimitiveProperties;
        /**
         * Watch the individual properties of a PoD object, instead of the object
         * per se. This is different from a deep watch where both the reference
         * and the individual values are watched.
         *
         * In effect, it throttles the multiple $watch to execute at most once per tick.
         */
        function WatchPrimitiveProperties(vueInst, propertiesToTrack, handler) {
          var immediate =
            arguments.length > 3 && arguments[3] !== undefined
              ? arguments[3]
              : false;

          var isHandled = false;

          function requestHandle() {
            if (!isHandled) {
              isHandled = true;
              vueInst.$nextTick(function () {
                isHandled = false;
                handler();
              });
            }
          }

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (
              var _iterator = propertiesToTrack[Symbol.iterator](), _step;
              !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
              _iteratorNormalCompletion = true
            ) {
              var prop = _step.value;

              vueInst.$watch(prop, requestHandle, { immediate: immediate });
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/utils/bindEvents.js":
      /*!****************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/utils/bindEvents.js ***!
  \****************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        exports["default"] = function (vueInst, googleMapsInst, events) {
          var _loop = function (eventName) {
            if (
              vueInst.$gmapOptions.autobindAllEvents ||
              vueInst.$listeners[eventName]
            ) {
              googleMapsInst.addListener(eventName, function (ev) {
                vueInst.$emit(eventName, ev);
              });
            }
          };

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (
              var _iterator = events[Symbol.iterator](), _step;
              !(_iteratorNormalCompletion = (_step = _iterator.next()).done);
              _iteratorNormalCompletion = true
            ) {
              var eventName = _step.value;

              _loop(eventName);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        };

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/utils/bindProps.js":
      /*!***************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/utils/bindProps.js ***!
  \***************************************************************/
      /***/ (__unused_webpack_module, exports, __webpack_require__) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        exports.getPropsValues = getPropsValues;
        exports.bindProps = bindProps;

        var _WatchPrimitiveProperties = __webpack_require__(
          /*! ../utils/WatchPrimitiveProperties */ "./node_modules/vue2-google-maps/dist/utils/WatchPrimitiveProperties.js"
        );

        var _WatchPrimitiveProperties2 = _interopRequireDefault(
          _WatchPrimitiveProperties
        );

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        function capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        }

        function getPropsValues(vueInst, props) {
          return Object.keys(props).reduce(function (acc, prop) {
            if (vueInst[prop] !== undefined) {
              acc[prop] = vueInst[prop];
            }
            return acc;
          }, {});
        }

        /**
         * Binds the properties defined in props to the google maps instance.
         * If the prop is an Object type, and we wish to track the properties
         * of the object (e.g. the lat and lng of a LatLng), then we do a deep
         * watch. For deep watch, we also prevent the _changed event from being
         * emitted if the data source was external.
         */
        function bindProps(vueInst, googleMapsInst, props) {
          var _loop = function (attribute) {
            var _props$attribute = props[attribute],
              twoWay = _props$attribute.twoWay,
              type = _props$attribute.type,
              trackProperties = _props$attribute.trackProperties,
              noBind = _props$attribute.noBind;

            if (noBind) return "continue";

            var setMethodName = "set" + capitalizeFirstLetter(attribute);
            var getMethodName = "get" + capitalizeFirstLetter(attribute);
            var eventName = attribute.toLowerCase() + "_changed";
            var initialValue = vueInst[attribute];

            if (typeof googleMapsInst[setMethodName] === "undefined") {
              throw new Error(
                setMethodName +
                  " is not a method of (the Maps object corresponding to) " +
                  vueInst.$options._componentTag
              );
            }

            // We need to avoid an endless
            // propChanged -> event emitted -> propChanged -> event emitted loop
            // although this may really be the user's responsibility
            if (type !== Object || !trackProperties) {
              // Track the object deeply
              vueInst.$watch(
                attribute,
                function () {
                  var attributeValue = vueInst[attribute];

                  googleMapsInst[setMethodName](attributeValue);
                },
                {
                  immediate: typeof initialValue !== "undefined",
                  deep: type === Object,
                }
              );
            } else {
              (0, _WatchPrimitiveProperties2.default)(
                vueInst,
                trackProperties.map(function (prop) {
                  return attribute + "." + prop;
                }),
                function () {
                  googleMapsInst[setMethodName](vueInst[attribute]);
                },
                vueInst[attribute] !== undefined
              );
            }

            if (
              twoWay &&
              (vueInst.$gmapOptions.autobindAllEvents ||
                vueInst.$listeners[eventName])
            ) {
              googleMapsInst.addListener(eventName, function () {
                // eslint-disable-line no-unused-vars
                vueInst.$emit(eventName, googleMapsInst[getMethodName]());
              });
            }
          };

          for (var attribute in props) {
            var _ret = _loop(attribute);

            if (_ret === "continue") continue;
          }
        }

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/utils/lazyValue.js":
      /*!***************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/utils/lazyValue.js ***!
  \***************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        // This piece of code was orignally written by sindresorhus and can be seen here
        // https://github.com/sindresorhus/lazy-value/blob/master/index.js

        exports["default"] = function (fn) {
          var called = false;
          var ret = void 0;

          return function () {
            if (!called) {
              called = true;
              ret = fn();
            }

            return ret;
          };
        };

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/utils/mountableMixin.js":
      /*!********************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/utils/mountableMixin.js ***!
  \********************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });
        /*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/

        exports["default"] = {
          props: ["resizeBus"],

          data: function data() {
            return {
              _actualResizeBus: null,
            };
          },
          created: function created() {
            if (typeof this.resizeBus === "undefined") {
              this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
            } else {
              this.$data._actualResizeBus = this.resizeBus;
            }
          },

          methods: {
            _resizeCallback: function _resizeCallback() {
              this.resize();
            },
            _delayedResizeCallback: function _delayedResizeCallback() {
              var _this = this;

              this.$nextTick(function () {
                return _this._resizeCallback();
              });
            },
          },

          watch: {
            resizeBus: function resizeBus(newVal) {
              // eslint-disable-line no-unused-vars
              this.$data._actualResizeBus = newVal;
            },
            "$data._actualResizeBus": function $data_actualResizeBus(
              newVal,
              oldVal
            ) {
              if (oldVal) {
                oldVal.$off("resize", this._delayedResizeCallback);
              }
              if (newVal) {
                newVal.$on("resize", this._delayedResizeCallback);
              }
            },
          },

          destroyed: function destroyed() {
            if (this.$data._actualResizeBus) {
              this.$data._actualResizeBus.$off(
                "resize",
                this._delayedResizeCallback
              );
            }
          },
        };

        /***/
      },

    /***/ "./node_modules/vue2-google-maps/dist/utils/simulateArrowDown.js":
      /*!***********************************************************************!*\
  !*** ./node_modules/vue2-google-maps/dist/utils/simulateArrowDown.js ***!
  \***********************************************************************/
      /***/ (__unused_webpack_module, exports) => {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        // This piece of code was orignally written by amirnissim and can be seen here
        // http://stackoverflow.com/a/11703018/2694653
        // This has been ported to Vanilla.js by GuillaumeLeclerc
        exports["default"] = function (input) {
          var _addEventListener = input.addEventListener
            ? input.addEventListener
            : input.attachEvent;

          function addEventListenerWrapper(type, listener) {
            // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
            // and then trigger the original listener.
            if (type === "keydown") {
              var origListener = listener;
              listener = function (event) {
                var suggestionSelected =
                  document.getElementsByClassName("pac-item-selected").length >
                  0;
                if (event.which === 13 && !suggestionSelected) {
                  var simulatedEvent = document.createEvent("Event");
                  simulatedEvent.keyCode = 40;
                  simulatedEvent.which = 40;
                  origListener.apply(input, [simulatedEvent]);
                }
                origListener.apply(input, [event]);
              };
            }
            _addEventListener.apply(input, [type, listener]);
          }

          input.addEventListener = addEventListenerWrapper;
          input.attachEvent = addEventListenerWrapper;
        };

        /***/
      },

    /***/ "./node_modules/vuex/dist/vuex.esm.js":
      /*!********************************************!*\
  !*** ./node_modules/vuex/dist/vuex.esm.js ***!
  \********************************************/
      /***/ (
        __unused_webpack_module,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ Store: () => /* binding */ Store,
          /* harmony export */ createLogger: () => /* binding */ createLogger,
          /* harmony export */ createNamespacedHelpers: () =>
            /* binding */ createNamespacedHelpers,
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */ install: () => /* binding */ install,
          /* harmony export */ mapActions: () => /* binding */ mapActions,
          /* harmony export */ mapGetters: () => /* binding */ mapGetters,
          /* harmony export */ mapMutations: () => /* binding */ mapMutations,
          /* harmony export */ mapState: () => /* binding */ mapState,
          /* harmony export */
        });
        /*!
         * vuex v3.6.2
         * (c) 2021 Evan You
         * @license MIT
         */
        function applyMixin(Vue) {
          var version = Number(Vue.version.split(".")[0]);

          if (version >= 2) {
            Vue.mixin({ beforeCreate: vuexInit });
          } else {
            // override init and inject vuex init procedure
            // for 1.x backwards compatibility.
            var _init = Vue.prototype._init;
            Vue.prototype._init = function (options) {
              if (options === void 0) options = {};

              options.init = options.init
                ? [vuexInit].concat(options.init)
                : vuexInit;
              _init.call(this, options);
            };
          }

          /**
           * Vuex init hook, injected into each instances init hooks list.
           */

          function vuexInit() {
            var options = this.$options;
            // store injection
            if (options.store) {
              this.$store =
                typeof options.store === "function"
                  ? options.store()
                  : options.store;
            } else if (options.parent && options.parent.$store) {
              this.$store = options.parent.$store;
            }
          }
        }

        var target =
          typeof window !== "undefined"
            ? window
            : typeof __webpack_require__.g !== "undefined"
            ? __webpack_require__.g
            : {};
        var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

        function devtoolPlugin(store) {
          if (!devtoolHook) {
            return;
          }

          store._devtoolHook = devtoolHook;

          devtoolHook.emit("vuex:init", store);

          devtoolHook.on("vuex:travel-to-state", function (targetState) {
            store.replaceState(targetState);
          });

          store.subscribe(
            function (mutation, state) {
              devtoolHook.emit("vuex:mutation", mutation, state);
            },
            { prepend: true }
          );

          store.subscribeAction(
            function (action, state) {
              devtoolHook.emit("vuex:action", action, state);
            },
            { prepend: true }
          );
        }

        /**
         * Get the first item that pass the test
         * by second argument function
         *
         * @param {Array} list
         * @param {Function} f
         * @return {*}
         */
        function find(list, f) {
          return list.filter(f)[0];
        }

        /**
         * Deep copy the given object considering circular structure.
         * This function caches all nested objects and its copies.
         * If it detects circular structure, use cached copy to avoid infinite loop.
         *
         * @param {*} obj
         * @param {Array<Object>} cache
         * @return {*}
         */
        function deepCopy(obj, cache) {
          if (cache === void 0) cache = [];

          // just return if obj is immutable value
          if (obj === null || typeof obj !== "object") {
            return obj;
          }

          // if obj is hit, it is in circular structure
          var hit = find(cache, function (c) {
            return c.original === obj;
          });
          if (hit) {
            return hit.copy;
          }

          var copy = Array.isArray(obj) ? [] : {};
          // put the copy into cache at first
          // because we want to refer it in recursive deepCopy
          cache.push({
            original: obj,
            copy: copy,
          });

          Object.keys(obj).forEach(function (key) {
            copy[key] = deepCopy(obj[key], cache);
          });

          return copy;
        }

        /**
         * forEach for object
         */
        function forEachValue(obj, fn) {
          Object.keys(obj).forEach(function (key) {
            return fn(obj[key], key);
          });
        }

        function isObject(obj) {
          return obj !== null && typeof obj === "object";
        }

        function isPromise(val) {
          return val && typeof val.then === "function";
        }

        function assert(condition, msg) {
          if (!condition) {
            throw new Error("[vuex] " + msg);
          }
        }

        function partial(fn, arg) {
          return function () {
            return fn(arg);
          };
        }

        // Base data struct for store's module, package with some attribute and method
        var Module = function Module(rawModule, runtime) {
          this.runtime = runtime;
          // Store some children item
          this._children = Object.create(null);
          // Store the origin module object which passed by programmer
          this._rawModule = rawModule;
          var rawState = rawModule.state;

          // Store the origin module's state
          this.state =
            (typeof rawState === "function" ? rawState() : rawState) || {};
        };

        var prototypeAccessors = { namespaced: { configurable: true } };

        prototypeAccessors.namespaced.get = function () {
          return !!this._rawModule.namespaced;
        };

        Module.prototype.addChild = function addChild(key, module) {
          this._children[key] = module;
        };

        Module.prototype.removeChild = function removeChild(key) {
          delete this._children[key];
        };

        Module.prototype.getChild = function getChild(key) {
          return this._children[key];
        };

        Module.prototype.hasChild = function hasChild(key) {
          return key in this._children;
        };

        Module.prototype.update = function update(rawModule) {
          this._rawModule.namespaced = rawModule.namespaced;
          if (rawModule.actions) {
            this._rawModule.actions = rawModule.actions;
          }
          if (rawModule.mutations) {
            this._rawModule.mutations = rawModule.mutations;
          }
          if (rawModule.getters) {
            this._rawModule.getters = rawModule.getters;
          }
        };

        Module.prototype.forEachChild = function forEachChild(fn) {
          forEachValue(this._children, fn);
        };

        Module.prototype.forEachGetter = function forEachGetter(fn) {
          if (this._rawModule.getters) {
            forEachValue(this._rawModule.getters, fn);
          }
        };

        Module.prototype.forEachAction = function forEachAction(fn) {
          if (this._rawModule.actions) {
            forEachValue(this._rawModule.actions, fn);
          }
        };

        Module.prototype.forEachMutation = function forEachMutation(fn) {
          if (this._rawModule.mutations) {
            forEachValue(this._rawModule.mutations, fn);
          }
        };

        Object.defineProperties(Module.prototype, prototypeAccessors);

        var ModuleCollection = function ModuleCollection(rawRootModule) {
          // register root module (Vuex.Store options)
          this.register([], rawRootModule, false);
        };

        ModuleCollection.prototype.get = function get(path) {
          return path.reduce(function (module, key) {
            return module.getChild(key);
          }, this.root);
        };

        ModuleCollection.prototype.getNamespace = function getNamespace(path) {
          var module = this.root;
          return path.reduce(function (namespace, key) {
            module = module.getChild(key);
            return namespace + (module.namespaced ? key + "/" : "");
          }, "");
        };

        ModuleCollection.prototype.update = function update$1(rawRootModule) {
          update([], this.root, rawRootModule);
        };

        ModuleCollection.prototype.register = function register(
          path,
          rawModule,
          runtime
        ) {
          var this$1 = this;
          if (runtime === void 0) runtime = true;

          if (true) {
            assertRawModule(path, rawModule);
          }

          var newModule = new Module(rawModule, runtime);
          if (path.length === 0) {
            this.root = newModule;
          } else {
            var parent = this.get(path.slice(0, -1));
            parent.addChild(path[path.length - 1], newModule);
          }

          // register nested modules
          if (rawModule.modules) {
            forEachValue(rawModule.modules, function (rawChildModule, key) {
              this$1.register(path.concat(key), rawChildModule, runtime);
            });
          }
        };

        ModuleCollection.prototype.unregister = function unregister(path) {
          var parent = this.get(path.slice(0, -1));
          var key = path[path.length - 1];
          var child = parent.getChild(key);

          if (!child) {
            if (true) {
              console.warn(
                "[vuex] trying to unregister module '" +
                  key +
                  "', which is " +
                  "not registered"
              );
            }
            return;
          }

          if (!child.runtime) {
            return;
          }

          parent.removeChild(key);
        };

        ModuleCollection.prototype.isRegistered = function isRegistered(path) {
          var parent = this.get(path.slice(0, -1));
          var key = path[path.length - 1];

          if (parent) {
            return parent.hasChild(key);
          }

          return false;
        };

        function update(path, targetModule, newModule) {
          if (true) {
            assertRawModule(path, newModule);
          }

          // update target module
          targetModule.update(newModule);

          // update nested modules
          if (newModule.modules) {
            for (var key in newModule.modules) {
              if (!targetModule.getChild(key)) {
                if (true) {
                  console.warn(
                    "[vuex] trying to add a new module '" +
                      key +
                      "' on hot reloading, " +
                      "manual reload is needed"
                  );
                }
                return;
              }
              update(
                path.concat(key),
                targetModule.getChild(key),
                newModule.modules[key]
              );
            }
          }
        }

        var functionAssert = {
          assert: function (value) {
            return typeof value === "function";
          },
          expected: "function",
        };

        var objectAssert = {
          assert: function (value) {
            return (
              typeof value === "function" ||
              (typeof value === "object" && typeof value.handler === "function")
            );
          },
          expected: 'function or object with "handler" function',
        };

        var assertTypes = {
          getters: functionAssert,
          mutations: functionAssert,
          actions: objectAssert,
        };

        function assertRawModule(path, rawModule) {
          Object.keys(assertTypes).forEach(function (key) {
            if (!rawModule[key]) {
              return;
            }

            var assertOptions = assertTypes[key];

            forEachValue(rawModule[key], function (value, type) {
              assert(
                assertOptions.assert(value),
                makeAssertionMessage(
                  path,
                  key,
                  type,
                  value,
                  assertOptions.expected
                )
              );
            });
          });
        }

        function makeAssertionMessage(path, key, type, value, expected) {
          var buf =
            key + " should be " + expected + ' but "' + key + "." + type + '"';
          if (path.length > 0) {
            buf += ' in module "' + path.join(".") + '"';
          }
          buf += " is " + JSON.stringify(value) + ".";
          return buf;
        }

        var Vue; // bind on install

        var Store = function Store(options) {
          var this$1 = this;
          if (options === void 0) options = {};

          // Auto install if it is not done yet and `window` has `Vue`.
          // To allow users to avoid auto-installation in some cases,
          // this code should be placed here. See #731
          if (!Vue && typeof window !== "undefined" && window.Vue) {
            install(window.Vue);
          }

          if (true) {
            assert(
              Vue,
              "must call Vue.use(Vuex) before creating a store instance."
            );
            assert(
              typeof Promise !== "undefined",
              "vuex requires a Promise polyfill in this browser."
            );
            assert(
              this instanceof Store,
              "store must be called with the new operator."
            );
          }

          var plugins = options.plugins;
          if (plugins === void 0) plugins = [];
          var strict = options.strict;
          if (strict === void 0) strict = false;

          // store internal state
          this._committing = false;
          this._actions = Object.create(null);
          this._actionSubscribers = [];
          this._mutations = Object.create(null);
          this._wrappedGetters = Object.create(null);
          this._modules = new ModuleCollection(options);
          this._modulesNamespaceMap = Object.create(null);
          this._subscribers = [];
          this._watcherVM = new Vue();
          this._makeLocalGettersCache = Object.create(null);

          // bind commit and dispatch to self
          var store = this;
          var ref = this;
          var dispatch = ref.dispatch;
          var commit = ref.commit;
          this.dispatch = function boundDispatch(type, payload) {
            return dispatch.call(store, type, payload);
          };
          this.commit = function boundCommit(type, payload, options) {
            return commit.call(store, type, payload, options);
          };

          // strict mode
          this.strict = strict;

          var state = this._modules.root.state;

          // init root module.
          // this also recursively registers all sub-modules
          // and collects all module getters inside this._wrappedGetters
          installModule(this, state, [], this._modules.root);

          // initialize the store vm, which is responsible for the reactivity
          // (also registers _wrappedGetters as computed properties)
          resetStoreVM(this, state);

          // apply plugins
          plugins.forEach(function (plugin) {
            return plugin(this$1);
          });

          var useDevtools =
            options.devtools !== undefined
              ? options.devtools
              : Vue.config.devtools;
          if (useDevtools) {
            devtoolPlugin(this);
          }
        };

        var prototypeAccessors$1 = { state: { configurable: true } };

        prototypeAccessors$1.state.get = function () {
          return this._vm._data.$$state;
        };

        prototypeAccessors$1.state.set = function (v) {
          if (true) {
            assert(
              false,
              "use store.replaceState() to explicit replace store state."
            );
          }
        };

        Store.prototype.commit = function commit(_type, _payload, _options) {
          var this$1 = this;

          // check object-style commit
          var ref = unifyObjectStyle(_type, _payload, _options);
          var type = ref.type;
          var payload = ref.payload;
          var options = ref.options;

          var mutation = { type: type, payload: payload };
          var entry = this._mutations[type];
          if (!entry) {
            if (true) {
              console.error("[vuex] unknown mutation type: " + type);
            }
            return;
          }
          this._withCommit(function () {
            entry.forEach(function commitIterator(handler) {
              handler(payload);
            });
          });

          this._subscribers
            .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
            .forEach(function (sub) {
              return sub(mutation, this$1.state);
            });

          if (true && options && options.silent) {
            console.warn(
              "[vuex] mutation type: " +
                type +
                ". Silent option has been removed. " +
                "Use the filter functionality in the vue-devtools"
            );
          }
        };

        Store.prototype.dispatch = function dispatch(_type, _payload) {
          var this$1 = this;

          // check object-style dispatch
          var ref = unifyObjectStyle(_type, _payload);
          var type = ref.type;
          var payload = ref.payload;

          var action = { type: type, payload: payload };
          var entry = this._actions[type];
          if (!entry) {
            if (true) {
              console.error("[vuex] unknown action type: " + type);
            }
            return;
          }

          try {
            this._actionSubscribers
              .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
              .filter(function (sub) {
                return sub.before;
              })
              .forEach(function (sub) {
                return sub.before(action, this$1.state);
              });
          } catch (e) {
            if (true) {
              console.warn("[vuex] error in before action subscribers: ");
              console.error(e);
            }
          }

          var result =
            entry.length > 1
              ? Promise.all(
                  entry.map(function (handler) {
                    return handler(payload);
                  })
                )
              : entry[0](payload);

          return new Promise(function (resolve, reject) {
            result.then(
              function (res) {
                try {
                  this$1._actionSubscribers
                    .filter(function (sub) {
                      return sub.after;
                    })
                    .forEach(function (sub) {
                      return sub.after(action, this$1.state);
                    });
                } catch (e) {
                  if (true) {
                    console.warn("[vuex] error in after action subscribers: ");
                    console.error(e);
                  }
                }
                resolve(res);
              },
              function (error) {
                try {
                  this$1._actionSubscribers
                    .filter(function (sub) {
                      return sub.error;
                    })
                    .forEach(function (sub) {
                      return sub.error(action, this$1.state, error);
                    });
                } catch (e) {
                  if (true) {
                    console.warn("[vuex] error in error action subscribers: ");
                    console.error(e);
                  }
                }
                reject(error);
              }
            );
          });
        };

        Store.prototype.subscribe = function subscribe(fn, options) {
          return genericSubscribe(fn, this._subscribers, options);
        };

        Store.prototype.subscribeAction = function subscribeAction(
          fn,
          options
        ) {
          var subs = typeof fn === "function" ? { before: fn } : fn;
          return genericSubscribe(subs, this._actionSubscribers, options);
        };

        Store.prototype.watch = function watch(getter, cb, options) {
          var this$1 = this;

          if (true) {
            assert(
              typeof getter === "function",
              "store.watch only accepts a function."
            );
          }
          return this._watcherVM.$watch(
            function () {
              return getter(this$1.state, this$1.getters);
            },
            cb,
            options
          );
        };

        Store.prototype.replaceState = function replaceState(state) {
          var this$1 = this;

          this._withCommit(function () {
            this$1._vm._data.$$state = state;
          });
        };

        Store.prototype.registerModule = function registerModule(
          path,
          rawModule,
          options
        ) {
          if (options === void 0) options = {};

          if (typeof path === "string") {
            path = [path];
          }

          if (true) {
            assert(
              Array.isArray(path),
              "module path must be a string or an Array."
            );
            assert(
              path.length > 0,
              "cannot register the root module by using registerModule."
            );
          }

          this._modules.register(path, rawModule);
          installModule(
            this,
            this.state,
            path,
            this._modules.get(path),
            options.preserveState
          );
          // reset store to update getters...
          resetStoreVM(this, this.state);
        };

        Store.prototype.unregisterModule = function unregisterModule(path) {
          var this$1 = this;

          if (typeof path === "string") {
            path = [path];
          }

          if (true) {
            assert(
              Array.isArray(path),
              "module path must be a string or an Array."
            );
          }

          this._modules.unregister(path);
          this._withCommit(function () {
            var parentState = getNestedState(this$1.state, path.slice(0, -1));
            Vue.delete(parentState, path[path.length - 1]);
          });
          resetStore(this);
        };

        Store.prototype.hasModule = function hasModule(path) {
          if (typeof path === "string") {
            path = [path];
          }

          if (true) {
            assert(
              Array.isArray(path),
              "module path must be a string or an Array."
            );
          }

          return this._modules.isRegistered(path);
        };

        Store.prototype.hotUpdate = function hotUpdate(newOptions) {
          this._modules.update(newOptions);
          resetStore(this, true);
        };

        Store.prototype._withCommit = function _withCommit(fn) {
          var committing = this._committing;
          this._committing = true;
          fn();
          this._committing = committing;
        };

        Object.defineProperties(Store.prototype, prototypeAccessors$1);

        function genericSubscribe(fn, subs, options) {
          if (subs.indexOf(fn) < 0) {
            options && options.prepend ? subs.unshift(fn) : subs.push(fn);
          }
          return function () {
            var i = subs.indexOf(fn);
            if (i > -1) {
              subs.splice(i, 1);
            }
          };
        }

        function resetStore(store, hot) {
          store._actions = Object.create(null);
          store._mutations = Object.create(null);
          store._wrappedGetters = Object.create(null);
          store._modulesNamespaceMap = Object.create(null);
          var state = store.state;
          // init all modules
          installModule(store, state, [], store._modules.root, true);
          // reset vm
          resetStoreVM(store, state, hot);
        }

        function resetStoreVM(store, state, hot) {
          var oldVm = store._vm;

          // bind store public getters
          store.getters = {};
          // reset local getters cache
          store._makeLocalGettersCache = Object.create(null);
          var wrappedGetters = store._wrappedGetters;
          var computed = {};
          forEachValue(wrappedGetters, function (fn, key) {
            // use computed to leverage its lazy-caching mechanism
            // direct inline function use will lead to closure preserving oldVm.
            // using partial to return function with only arguments preserved in closure environment.
            computed[key] = partial(fn, store);
            Object.defineProperty(store.getters, key, {
              get: function () {
                return store._vm[key];
              },
              enumerable: true, // for local getters
            });
          });

          // use a Vue instance to store the state tree
          // suppress warnings just in case the user has added
          // some funky global mixins
          var silent = Vue.config.silent;
          Vue.config.silent = true;
          store._vm = new Vue({
            data: {
              $$state: state,
            },
            computed: computed,
          });
          Vue.config.silent = silent;

          // enable strict mode for new vm
          if (store.strict) {
            enableStrictMode(store);
          }

          if (oldVm) {
            if (hot) {
              // dispatch changes in all subscribed watchers
              // to force getter re-evaluation for hot reloading.
              store._withCommit(function () {
                oldVm._data.$$state = null;
              });
            }
            Vue.nextTick(function () {
              return oldVm.$destroy();
            });
          }
        }

        function installModule(store, rootState, path, module, hot) {
          var isRoot = !path.length;
          var namespace = store._modules.getNamespace(path);

          // register in namespace map
          if (module.namespaced) {
            if (
              store._modulesNamespaceMap[namespace] &&
              "development" !== "production"
            ) {
              console.error(
                "[vuex] duplicate namespace " +
                  namespace +
                  " for the namespaced module " +
                  path.join("/")
              );
            }
            store._modulesNamespaceMap[namespace] = module;
          }

          // set state
          if (!isRoot && !hot) {
            var parentState = getNestedState(rootState, path.slice(0, -1));
            var moduleName = path[path.length - 1];
            store._withCommit(function () {
              if (true) {
                if (moduleName in parentState) {
                  console.warn(
                    '[vuex] state field "' +
                      moduleName +
                      '" was overridden by a module with the same name at "' +
                      path.join(".") +
                      '"'
                  );
                }
              }
              Vue.set(parentState, moduleName, module.state);
            });
          }

          var local = (module.context = makeLocalContext(
            store,
            namespace,
            path
          ));

          module.forEachMutation(function (mutation, key) {
            var namespacedType = namespace + key;
            registerMutation(store, namespacedType, mutation, local);
          });

          module.forEachAction(function (action, key) {
            var type = action.root ? key : namespace + key;
            var handler = action.handler || action;
            registerAction(store, type, handler, local);
          });

          module.forEachGetter(function (getter, key) {
            var namespacedType = namespace + key;
            registerGetter(store, namespacedType, getter, local);
          });

          module.forEachChild(function (child, key) {
            installModule(store, rootState, path.concat(key), child, hot);
          });
        }

        /**
         * make localized dispatch, commit, getters and state
         * if there is no namespace, just use root ones
         */
        function makeLocalContext(store, namespace, path) {
          var noNamespace = namespace === "";

          var local = {
            dispatch: noNamespace
              ? store.dispatch
              : function (_type, _payload, _options) {
                  var args = unifyObjectStyle(_type, _payload, _options);
                  var payload = args.payload;
                  var options = args.options;
                  var type = args.type;

                  if (!options || !options.root) {
                    type = namespace + type;
                    if (true && !store._actions[type]) {
                      console.error(
                        "[vuex] unknown local action type: " +
                          args.type +
                          ", global type: " +
                          type
                      );
                      return;
                    }
                  }

                  return store.dispatch(type, payload);
                },

            commit: noNamespace
              ? store.commit
              : function (_type, _payload, _options) {
                  var args = unifyObjectStyle(_type, _payload, _options);
                  var payload = args.payload;
                  var options = args.options;
                  var type = args.type;

                  if (!options || !options.root) {
                    type = namespace + type;
                    if (true && !store._mutations[type]) {
                      console.error(
                        "[vuex] unknown local mutation type: " +
                          args.type +
                          ", global type: " +
                          type
                      );
                      return;
                    }
                  }

                  store.commit(type, payload, options);
                },
          };

          // getters and state object must be gotten lazily
          // because they will be changed by vm update
          Object.defineProperties(local, {
            getters: {
              get: noNamespace
                ? function () {
                    return store.getters;
                  }
                : function () {
                    return makeLocalGetters(store, namespace);
                  },
            },
            state: {
              get: function () {
                return getNestedState(store.state, path);
              },
            },
          });

          return local;
        }

        function makeLocalGetters(store, namespace) {
          if (!store._makeLocalGettersCache[namespace]) {
            var gettersProxy = {};
            var splitPos = namespace.length;
            Object.keys(store.getters).forEach(function (type) {
              // skip if the target getter is not match this namespace
              if (type.slice(0, splitPos) !== namespace) {
                return;
              }

              // extract local getter type
              var localType = type.slice(splitPos);

              // Add a port to the getters proxy.
              // Define as getter property because
              // we do not want to evaluate the getters in this time.
              Object.defineProperty(gettersProxy, localType, {
                get: function () {
                  return store.getters[type];
                },
                enumerable: true,
              });
            });
            store._makeLocalGettersCache[namespace] = gettersProxy;
          }

          return store._makeLocalGettersCache[namespace];
        }

        function registerMutation(store, type, handler, local) {
          var entry = store._mutations[type] || (store._mutations[type] = []);
          entry.push(function wrappedMutationHandler(payload) {
            handler.call(store, local.state, payload);
          });
        }

        function registerAction(store, type, handler, local) {
          var entry = store._actions[type] || (store._actions[type] = []);
          entry.push(function wrappedActionHandler(payload) {
            var res = handler.call(
              store,
              {
                dispatch: local.dispatch,
                commit: local.commit,
                getters: local.getters,
                state: local.state,
                rootGetters: store.getters,
                rootState: store.state,
              },
              payload
            );
            if (!isPromise(res)) {
              res = Promise.resolve(res);
            }
            if (store._devtoolHook) {
              return res.catch(function (err) {
                store._devtoolHook.emit("vuex:error", err);
                throw err;
              });
            } else {
              return res;
            }
          });
        }

        function registerGetter(store, type, rawGetter, local) {
          if (store._wrappedGetters[type]) {
            if (true) {
              console.error("[vuex] duplicate getter key: " + type);
            }
            return;
          }
          store._wrappedGetters[type] = function wrappedGetter(store) {
            return rawGetter(
              local.state, // local state
              local.getters, // local getters
              store.state, // root state
              store.getters // root getters
            );
          };
        }

        function enableStrictMode(store) {
          store._vm.$watch(
            function () {
              return this._data.$$state;
            },
            function () {
              if (true) {
                assert(
                  store._committing,
                  "do not mutate vuex store state outside mutation handlers."
                );
              }
            },
            { deep: true, sync: true }
          );
        }

        function getNestedState(state, path) {
          return path.reduce(function (state, key) {
            return state[key];
          }, state);
        }

        function unifyObjectStyle(type, payload, options) {
          if (isObject(type) && type.type) {
            options = payload;
            payload = type;
            type = type.type;
          }

          if (true) {
            assert(
              typeof type === "string",
              "expects string as the type, but found " + typeof type + "."
            );
          }

          return { type: type, payload: payload, options: options };
        }

        function install(_Vue) {
          if (Vue && _Vue === Vue) {
            if (true) {
              console.error(
                "[vuex] already installed. Vue.use(Vuex) should be called only once."
              );
            }
            return;
          }
          Vue = _Vue;
          applyMixin(Vue);
        }

        /**
         * Reduce the code which written in Vue.js for getting the state.
         * @param {String} [namespace] - Module's namespace
         * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
         * @param {Object}
         */
        var mapState = normalizeNamespace(function (namespace, states) {
          var res = {};
          if (true && !isValidMap(states)) {
            console.error(
              "[vuex] mapState: mapper parameter must be either an Array or an Object"
            );
          }
          normalizeMap(states).forEach(function (ref) {
            var key = ref.key;
            var val = ref.val;

            res[key] = function mappedState() {
              var state = this.$store.state;
              var getters = this.$store.getters;
              if (namespace) {
                var module = getModuleByNamespace(
                  this.$store,
                  "mapState",
                  namespace
                );
                if (!module) {
                  return;
                }
                state = module.context.state;
                getters = module.context.getters;
              }
              return typeof val === "function"
                ? val.call(this, state, getters)
                : state[val];
            };
            // mark vuex getter for devtools
            res[key].vuex = true;
          });
          return res;
        });

        /**
         * Reduce the code which written in Vue.js for committing the mutation
         * @param {String} [namespace] - Module's namespace
         * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
         * @return {Object}
         */
        var mapMutations = normalizeNamespace(function (namespace, mutations) {
          var res = {};
          if (true && !isValidMap(mutations)) {
            console.error(
              "[vuex] mapMutations: mapper parameter must be either an Array or an Object"
            );
          }
          normalizeMap(mutations).forEach(function (ref) {
            var key = ref.key;
            var val = ref.val;

            res[key] = function mappedMutation() {
              var args = [],
                len = arguments.length;
              while (len--) args[len] = arguments[len];

              // Get the commit method from store
              var commit = this.$store.commit;
              if (namespace) {
                var module = getModuleByNamespace(
                  this.$store,
                  "mapMutations",
                  namespace
                );
                if (!module) {
                  return;
                }
                commit = module.context.commit;
              }
              return typeof val === "function"
                ? val.apply(this, [commit].concat(args))
                : commit.apply(this.$store, [val].concat(args));
            };
          });
          return res;
        });

        /**
         * Reduce the code which written in Vue.js for getting the getters
         * @param {String} [namespace] - Module's namespace
         * @param {Object|Array} getters
         * @return {Object}
         */
        var mapGetters = normalizeNamespace(function (namespace, getters) {
          var res = {};
          if (true && !isValidMap(getters)) {
            console.error(
              "[vuex] mapGetters: mapper parameter must be either an Array or an Object"
            );
          }
          normalizeMap(getters).forEach(function (ref) {
            var key = ref.key;
            var val = ref.val;

            // The namespace has been mutated by normalizeNamespace
            val = namespace + val;
            res[key] = function mappedGetter() {
              if (
                namespace &&
                !getModuleByNamespace(this.$store, "mapGetters", namespace)
              ) {
                return;
              }
              if (true && !(val in this.$store.getters)) {
                console.error("[vuex] unknown getter: " + val);
                return;
              }
              return this.$store.getters[val];
            };
            // mark vuex getter for devtools
            res[key].vuex = true;
          });
          return res;
        });

        /**
         * Reduce the code which written in Vue.js for dispatch the action
         * @param {String} [namespace] - Module's namespace
         * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
         * @return {Object}
         */
        var mapActions = normalizeNamespace(function (namespace, actions) {
          var res = {};
          if (true && !isValidMap(actions)) {
            console.error(
              "[vuex] mapActions: mapper parameter must be either an Array or an Object"
            );
          }
          normalizeMap(actions).forEach(function (ref) {
            var key = ref.key;
            var val = ref.val;

            res[key] = function mappedAction() {
              var args = [],
                len = arguments.length;
              while (len--) args[len] = arguments[len];

              // get dispatch function from store
              var dispatch = this.$store.dispatch;
              if (namespace) {
                var module = getModuleByNamespace(
                  this.$store,
                  "mapActions",
                  namespace
                );
                if (!module) {
                  return;
                }
                dispatch = module.context.dispatch;
              }
              return typeof val === "function"
                ? val.apply(this, [dispatch].concat(args))
                : dispatch.apply(this.$store, [val].concat(args));
            };
          });
          return res;
        });

        /**
         * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
         * @param {String} namespace
         * @return {Object}
         */
        var createNamespacedHelpers = function (namespace) {
          return {
            mapState: mapState.bind(null, namespace),
            mapGetters: mapGetters.bind(null, namespace),
            mapMutations: mapMutations.bind(null, namespace),
            mapActions: mapActions.bind(null, namespace),
          };
        };

        /**
         * Normalize the map
         * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
         * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
         * @param {Array|Object} map
         * @return {Object}
         */
        function normalizeMap(map) {
          if (!isValidMap(map)) {
            return [];
          }
          return Array.isArray(map)
            ? map.map(function (key) {
                return { key: key, val: key };
              })
            : Object.keys(map).map(function (key) {
                return { key: key, val: map[key] };
              });
        }

        /**
         * Validate whether given map is valid or not
         * @param {*} map
         * @return {Boolean}
         */
        function isValidMap(map) {
          return Array.isArray(map) || isObject(map);
        }

        /**
         * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
         * @param {Function} fn
         * @return {Function}
         */
        function normalizeNamespace(fn) {
          return function (namespace, map) {
            if (typeof namespace !== "string") {
              map = namespace;
              namespace = "";
            } else if (namespace.charAt(namespace.length - 1) !== "/") {
              namespace += "/";
            }
            return fn(namespace, map);
          };
        }

        /**
         * Search a special module from store by namespace. if module not exist, print error message.
         * @param {Object} store
         * @param {String} helper
         * @param {String} namespace
         * @return {Object}
         */
        function getModuleByNamespace(store, helper, namespace) {
          var module = store._modulesNamespaceMap[namespace];
          if (true && !module) {
            console.error(
              "[vuex] module namespace not found in " +
                helper +
                "(): " +
                namespace
            );
          }
          return module;
        }

        // Credits: borrowed code from fcomb/redux-logger

        function createLogger(ref) {
          if (ref === void 0) ref = {};
          var collapsed = ref.collapsed;
          if (collapsed === void 0) collapsed = true;
          var filter = ref.filter;
          if (filter === void 0)
            filter = function (mutation, stateBefore, stateAfter) {
              return true;
            };
          var transformer = ref.transformer;
          if (transformer === void 0)
            transformer = function (state) {
              return state;
            };
          var mutationTransformer = ref.mutationTransformer;
          if (mutationTransformer === void 0)
            mutationTransformer = function (mut) {
              return mut;
            };
          var actionFilter = ref.actionFilter;
          if (actionFilter === void 0)
            actionFilter = function (action, state) {
              return true;
            };
          var actionTransformer = ref.actionTransformer;
          if (actionTransformer === void 0)
            actionTransformer = function (act) {
              return act;
            };
          var logMutations = ref.logMutations;
          if (logMutations === void 0) logMutations = true;
          var logActions = ref.logActions;
          if (logActions === void 0) logActions = true;
          var logger = ref.logger;
          if (logger === void 0) logger = console;

          return function (store) {
            var prevState = deepCopy(store.state);

            if (typeof logger === "undefined") {
              return;
            }

            if (logMutations) {
              store.subscribe(function (mutation, state) {
                var nextState = deepCopy(state);

                if (filter(mutation, prevState, nextState)) {
                  var formattedTime = getFormattedTime();
                  var formattedMutation = mutationTransformer(mutation);
                  var message = "mutation " + mutation.type + formattedTime;

                  startMessage(logger, message, collapsed);
                  logger.log(
                    "%c prev state",
                    "color: #9E9E9E; font-weight: bold",
                    transformer(prevState)
                  );
                  logger.log(
                    "%c mutation",
                    "color: #03A9F4; font-weight: bold",
                    formattedMutation
                  );
                  logger.log(
                    "%c next state",
                    "color: #4CAF50; font-weight: bold",
                    transformer(nextState)
                  );
                  endMessage(logger);
                }

                prevState = nextState;
              });
            }

            if (logActions) {
              store.subscribeAction(function (action, state) {
                if (actionFilter(action, state)) {
                  var formattedTime = getFormattedTime();
                  var formattedAction = actionTransformer(action);
                  var message = "action " + action.type + formattedTime;

                  startMessage(logger, message, collapsed);
                  logger.log(
                    "%c action",
                    "color: #03A9F4; font-weight: bold",
                    formattedAction
                  );
                  endMessage(logger);
                }
              });
            }
          };
        }

        function startMessage(logger, message, collapsed) {
          var startMessage = collapsed ? logger.groupCollapsed : logger.group;

          // render
          try {
            startMessage.call(logger, message);
          } catch (e) {
            logger.log(message);
          }
        }

        function endMessage(logger) {
          try {
            logger.groupEnd();
          } catch (e) {
            logger.log("—— log end ——");
          }
        }

        function getFormattedTime() {
          var time = new Date();
          return (
            " @ " +
            pad(time.getHours(), 2) +
            ":" +
            pad(time.getMinutes(), 2) +
            ":" +
            pad(time.getSeconds(), 2) +
            "." +
            pad(time.getMilliseconds(), 3)
          );
        }

        function repeat(str, times) {
          return new Array(times + 1).join(str);
        }

        function pad(num, maxLength) {
          return repeat("0", maxLength - num.toString().length) + num;
        }

        var index = {
          Store: Store,
          install: install,
          version: "3.6.2",
          mapState: mapState,
          mapMutations: mapMutations,
          mapGetters: mapGetters,
          mapActions: mapActions,
          createNamespacedHelpers: createNamespacedHelpers,
          createLogger: createLogger,
        };

        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = index;

        /***/
      },

    /***/ "./src/modules sync recursive ^\\.\\/.*\\.js$":
      /*!****************************************!*\
  !*** ./src/modules/ sync ^\.\/.*\.js$ ***!
  \****************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var map = {
          "./accordion/accordion.js": "./src/modules/accordion/accordion.js",
          "./account-activate-form/account-activate-form.js":
            "./src/modules/account-activate-form/account-activate-form.js",
          "./account-address-item/account-address-item.vue.js":
            "./src/modules/account-address-item/account-address-item.vue.js",
          "./account-address/account-address.js":
            "./src/modules/account-address/account-address.js",
          "./account-forms/account-forms.js":
            "./src/modules/account-forms/account-forms.js",
          "./account-login-form/account-login-form.vue.js":
            "./src/modules/account-login-form/account-login-form.vue.js",
          "./account-new-address/account-new-address.vue.js":
            "./src/modules/account-new-address/account-new-address.vue.js",
          "./account-recover-form/account-recover-form.vue.js":
            "./src/modules/account-recover-form/account-recover-form.vue.js",
          "./account-register-form/account-register-form.vue.js":
            "./src/modules/account-register-form/account-register-form.vue.js",
          "./account-reset-form/account-reset-form.vue.js":
            "./src/modules/account-reset-form/account-reset-form.vue.js",
          "./callout-interactive/callout-interactive.js":
            "./src/modules/callout-interactive/callout-interactive.js",
          "./callout-three-up/callout-three-up.js":
            "./src/modules/callout-three-up/callout-three-up.js",
          "./cart-grid-bb/@actions.js":
            "./src/modules/cart-grid-bb/@actions.js",
          "./cart-grid-bb/@getters.js":
            "./src/modules/cart-grid-bb/@getters.js",
          "./cart-grid-bb/@mutations.js":
            "./src/modules/cart-grid-bb/@mutations.js",
          "./cart-grid-bb/@store.js": "./src/modules/cart-grid-bb/@store.js",
          "./cart-grid-bb/cart-grid-bb.js":
            "./src/modules/cart-grid-bb/cart-grid-bb.js",
          "./cart-grid-bb/cart-grid-bb.vue.js":
            "./src/modules/cart-grid-bb/cart-grid-bb.vue.js",
          "./cart-grid/@actions.js": "./src/modules/cart-grid/@actions.js",
          "./cart-grid/@getters.js": "./src/modules/cart-grid/@getters.js",
          "./cart-grid/@mutations.js": "./src/modules/cart-grid/@mutations.js",
          "./cart-grid/@store.js": "./src/modules/cart-grid/@store.js",
          "./cart-grid/cart-grid.js": "./src/modules/cart-grid/cart-grid.js",
          "./cart-grid/cart-grid.vue.js":
            "./src/modules/cart-grid/cart-grid.vue.js",
          "./cart-item/cart-item.vue.js":
            "./src/modules/cart-item/cart-item.vue.js",
          "./checkbox/checkbox.vue.js":
            "./src/modules/checkbox/checkbox.vue.js",
          "./contact-form/contact-form.vue.js":
            "./src/modules/contact-form/contact-form.vue.js",
          "./contact/contact.js": "./src/modules/contact/contact.js",
          "./footer/footer.js": "./src/modules/footer/footer.js",
          "./header-cart-icon/header-cart-icon.js":
            "./src/modules/header-cart-icon/header-cart-icon.js",
          "./header-mega/header-mega.js":
            "./src/modules/header-mega/header-mega.js",
          "./header-search-icon/header-search-icon.js":
            "./src/modules/header-search-icon/header-search-icon.js",
          "./header-search/header-search.js":
            "./src/modules/header-search/header-search.js",
          "./hero-main/hero-main.js": "./src/modules/hero-main/hero-main.js",
          "./hero-product/hero-product.js":
            "./src/modules/hero-product/hero-product.js",
          "./hero-secondary/hero-secondary.js":
            "./src/modules/hero-secondary/hero-secondary.js",
          "./hero/hero.js": "./src/modules/hero/hero.js",
          "./home-product-three-up/home-product-three-up.js":
            "./src/modules/home-product-three-up/home-product-three-up.js",
          "./image/image.js": "./src/modules/image/image.js",
          "./image/image.vue.js": "./src/modules/image/image.vue.js",
          "./instagram-grid/instagram-grid.js":
            "./src/modules/instagram-grid/instagram-grid.js",
          "./loading-animation/loading-animation.js":
            "./src/modules/loading-animation/loading-animation.js",
          "./mini-cart/mini-cart.js": "./src/modules/mini-cart/mini-cart.js",
          "./mini-cart/mini-cart.vue.js":
            "./src/modules/mini-cart/mini-cart.vue.js",
          "./modal/modal.js": "./src/modules/modal/modal.js",
          "./newsletter-form/newsletter-form.vue.js":
            "./src/modules/newsletter-form/newsletter-form.vue.js",
          "./pagination/pagination.vue.js":
            "./src/modules/pagination/pagination.vue.js",
          "./pdp-product-three-up/pdp-product-three-up.js":
            "./src/modules/pdp-product-three-up/pdp-product-three-up.js",
          "./product-accordion/product-accordion.js":
            "./src/modules/product-accordion/product-accordion.js",
          "./product-card/product-card.vue.js":
            "./src/modules/product-card/product-card.vue.js",
          "./product-cross-sell/product-cross-sell.js":
            "./src/modules/product-cross-sell/product-cross-sell.js",
          "./product-form/product-form.js":
            "./src/modules/product-form/product-form.js",
          "./product-main/product-main.js":
            "./src/modules/product-main/product-main.js",
          "./product-slide-out/product-slide-out.js":
            "./src/modules/product-slide-out/product-slide-out.js",
          "./product-three-up/product-three-up.js":
            "./src/modules/product-three-up/product-three-up.js",
          "./promo-bar/promo-bar.js": "./src/modules/promo-bar/promo-bar.js",
          "./quantity-selector/quantity-selector.vue.js":
            "./src/modules/quantity-selector/quantity-selector.vue.js",
          "./select-input/select-input.vue.js":
            "./src/modules/select-input/select-input.vue.js",
          "./splash-layout/splash-layout.js":
            "./src/modules/splash-layout/splash-layout.js",
          "./text-input/text-input.vue.js":
            "./src/modules/text-input/text-input.vue.js",
          "./three-up/three-up.js": "./src/modules/three-up/three-up.js",
          "./video/video.js": "./src/modules/video/video.js",
        };

        function webpackContext(req) {
          var id = webpackContextResolve(req);
          return __webpack_require__(id);
        }
        function webpackContextResolve(req) {
          if (!__webpack_require__.o(map, req)) {
            var e = new Error("Cannot find module '" + req + "'");
            e.code = "MODULE_NOT_FOUND";
            throw e;
          }
          return map[req];
        }
        webpackContext.keys = function webpackContextKeys() {
          return Object.keys(map);
        };
        webpackContext.resolve = webpackContextResolve;
        module.exports = webpackContext;
        webpackContext.id = "./src/modules sync recursive ^\\.\\/.*\\.js$";

        /***/
      },

    /***/ "./src/modules sync recursive ^\\.\\/.*\\.vue\\.js$":
      /*!*********************************************!*\
  !*** ./src/modules/ sync ^\.\/.*\.vue\.js$ ***!
  \*********************************************/
      /***/ (module, __unused_webpack_exports, __webpack_require__) => {
        var map = {
          "./account-address-item/account-address-item.vue.js":
            "./src/modules/account-address-item/account-address-item.vue.js",
          "./account-login-form/account-login-form.vue.js":
            "./src/modules/account-login-form/account-login-form.vue.js",
          "./account-new-address/account-new-address.vue.js":
            "./src/modules/account-new-address/account-new-address.vue.js",
          "./account-recover-form/account-recover-form.vue.js":
            "./src/modules/account-recover-form/account-recover-form.vue.js",
          "./account-register-form/account-register-form.vue.js":
            "./src/modules/account-register-form/account-register-form.vue.js",
          "./account-reset-form/account-reset-form.vue.js":
            "./src/modules/account-reset-form/account-reset-form.vue.js",
          "./cart-grid-bb/cart-grid-bb.vue.js":
            "./src/modules/cart-grid-bb/cart-grid-bb.vue.js",
          "./cart-grid/cart-grid.vue.js":
            "./src/modules/cart-grid/cart-grid.vue.js",
          "./cart-item/cart-item.vue.js":
            "./src/modules/cart-item/cart-item.vue.js",
          "./checkbox/checkbox.vue.js":
            "./src/modules/checkbox/checkbox.vue.js",
          "./contact-form/contact-form.vue.js":
            "./src/modules/contact-form/contact-form.vue.js",
          "./image/image.vue.js": "./src/modules/image/image.vue.js",
          "./mini-cart/mini-cart.vue.js":
            "./src/modules/mini-cart/mini-cart.vue.js",
          "./newsletter-form/newsletter-form.vue.js":
            "./src/modules/newsletter-form/newsletter-form.vue.js",
          "./pagination/pagination.vue.js":
            "./src/modules/pagination/pagination.vue.js",
          "./product-card/product-card.vue.js":
            "./src/modules/product-card/product-card.vue.js",
          "./quantity-selector/quantity-selector.vue.js":
            "./src/modules/quantity-selector/quantity-selector.vue.js",
          "./select-input/select-input.vue.js":
            "./src/modules/select-input/select-input.vue.js",
          "./text-input/text-input.vue.js":
            "./src/modules/text-input/text-input.vue.js",
        };

        function webpackContext(req) {
          var id = webpackContextResolve(req);
          return __webpack_require__(id);
        }
        function webpackContextResolve(req) {
          if (!__webpack_require__.o(map, req)) {
            var e = new Error("Cannot find module '" + req + "'");
            e.code = "MODULE_NOT_FOUND";
            throw e;
          }
          return map[req];
        }
        webpackContext.keys = function webpackContextKeys() {
          return Object.keys(map);
        };
        webpackContext.resolve = webpackContextResolve;
        module.exports = webpackContext;
        webpackContext.id =
          "./src/modules sync recursive ^\\.\\/.*\\.vue\\.js$";

        /***/
      },

    /***/ "./node_modules/select-dom/index.js":
      /*!******************************************!*\
  !*** ./node_modules/select-dom/index.js ***!
  \******************************************/
      /***/ (
        __unused_webpack___webpack_module__,
        __webpack_exports__,
        __webpack_require__
      ) => {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */ __webpack_require__.d(__webpack_exports__, {
          /* harmony export */ default: () => __WEBPACK_DEFAULT_EXPORT__,
          /* harmony export */
        });
        // Type predicate for TypeScript
        function isQueryable(object) {
          return typeof object.querySelectorAll === "function";
        }
        function select(selectors, baseElement) {
          var _a;
          // Shortcut with specified-but-null baseElement
          if (arguments.length === 2 && !baseElement) {
            return;
          }
          return (_a = (
            baseElement !== null && baseElement !== void 0
              ? baseElement
              : document
          ).querySelector(String(selectors))) !== null && _a !== void 0
            ? _a
            : undefined;
        }
        function selectLast(selectors, baseElement) {
          // Shortcut with specified-but-null baseElement
          if (arguments.length === 2 && !baseElement) {
            return undefined;
          }
          const all = (
            baseElement !== null && baseElement !== void 0
              ? baseElement
              : document
          ).querySelectorAll(String(selectors));
          return all[all.length - 1];
        }
        /**
         * @param selectors      One or more CSS selectors separated by commas
         * @param [baseElement]  The element to look inside of
         * @return               Whether it's been found
         */
        function selectExists(selectors, baseElement) {
          // Shortcut with specified-but-null baseElement
          if (arguments.length === 2 && !baseElement) {
            return false;
          }
          return Boolean(
            (baseElement !== null && baseElement !== void 0
              ? baseElement
              : document
            ).querySelector(String(selectors))
          );
        }
        function selectAll(selectors, baseElements) {
          // Shortcut with specified-but-null baseElements
          if (arguments.length === 2 && !baseElements) {
            return [];
          }
          // Can be: select.all('selectors') or select.all('selectors', singleElementOrDocument)
          if (!baseElements || isQueryable(baseElements)) {
            const elements = (
              baseElements !== null && baseElements !== void 0
                ? baseElements
                : document
            ).querySelectorAll(String(selectors));
            return [...elements];
          }
          const queried = new Set();
          for (const baseElement of baseElements) {
            for (const element of baseElement.querySelectorAll(
              String(selectors)
            )) {
              queried.add(element);
            }
          }
          return [...queried]; // Convert to array
        }
        select.last = selectLast;
        select.exists = selectExists;
        select.all = selectAll;
        /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = select;

        /***/
      },

    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/ var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/ var cachedModule = __webpack_module_cache__[moduleId];
    /******/ if (cachedModule !== undefined) {
      /******/ return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (__webpack_module_cache__[moduleId] = {
      /******/ id: moduleId,
      /******/ // no module.loaded needed
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ __webpack_modules__[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__
    );
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = __webpack_modules__;
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/chunk loaded */
  /******/ (() => {
    /******/ var deferred = [];
    /******/ __webpack_require__.O = (result, chunkIds, fn, priority) => {
      /******/ if (chunkIds) {
        /******/ priority = priority || 0;
        /******/ for (
          var i = deferred.length;
          i > 0 && deferred[i - 1][2] > priority;
          i--
        )
          deferred[i] = deferred[i - 1];
        /******/ deferred[i] = [chunkIds, fn, priority];
        /******/ return;
        /******/
      }
      /******/ var notFulfilled = Infinity;
      /******/ for (var i = 0; i < deferred.length; i++) {
        /******/ var [chunkIds, fn, priority] = deferred[i];
        /******/ var fulfilled = true;
        /******/ for (var j = 0; j < chunkIds.length; j++) {
          /******/ if (
            (priority & (1 === 0) || notFulfilled >= priority) &&
            Object.keys(__webpack_require__.O).every((key) =>
              __webpack_require__.O[key](chunkIds[j])
            )
          ) {
            /******/ chunkIds.splice(j--, 1);
            /******/
          } else {
            /******/ fulfilled = false;
            /******/ if (priority < notFulfilled) notFulfilled = priority;
            /******/
          }
          /******/
        }
        /******/ if (fulfilled) {
          /******/ deferred.splice(i--, 1);
          /******/ var r = fn();
          /******/ if (r !== undefined) result = r;
          /******/
        }
        /******/
      }
      /******/ return result;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/compat get default export */
  /******/ (() => {
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = (module) => {
      /******/ var getter =
        module && module.__esModule
          ? /******/ () => module["default"]
          : /******/ () => module;
      /******/ __webpack_require__.d(getter, { a: getter });
      /******/ return getter;
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/ (() => {
    /******/ // define getter functions for harmony exports
    /******/ __webpack_require__.d = (exports, definition) => {
      /******/ for (var key in definition) {
        /******/ if (
          __webpack_require__.o(definition, key) &&
          !__webpack_require__.o(exports, key)
        ) {
          /******/ Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key],
          });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/global */
  /******/ (() => {
    /******/ __webpack_require__.g = (function () {
      /******/ if (typeof globalThis === "object") return globalThis;
      /******/ try {
        /******/ return this || new Function("return this")();
        /******/
      } catch (e) {
        /******/ if (typeof window === "object") return window;
        /******/
      }
      /******/
    })();
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/ (() => {
    /******/ __webpack_require__.o = (obj, prop) =>
      Object.prototype.hasOwnProperty.call(obj, prop);
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/ (() => {
    /******/ // define __esModule on exports
    /******/ __webpack_require__.r = (exports) => {
      /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        /******/ Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module",
        });
        /******/
      }
      /******/ Object.defineProperty(exports, "__esModule", { value: true });
      /******/
    };
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/jsonp chunk loading */
  /******/ (() => {
    /******/ // no baseURI
    /******/
    /******/ // object to store loaded and loading chunks
    /******/ // undefined = chunk not loaded, null = chunk preloaded/prefetched
    /******/ // [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
    /******/ var installedChunks = {
      /******/ "/assets/main": 0,
      /******/ "assets/main": 0,
      /******/
    };
    /******/
    /******/ // no chunk on demand loading
    /******/
    /******/ // no prefetching
    /******/
    /******/ // no preloaded
    /******/
    /******/ // no HMR
    /******/
    /******/ // no HMR manifest
    /******/
    /******/ __webpack_require__.O.j = (chunkId) =>
      installedChunks[chunkId] === 0;
    /******/
    /******/ // install a JSONP callback for chunk loading
    /******/ var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
      /******/ var [chunkIds, moreModules, runtime] = data;
      /******/ // add "moreModules" to the modules object,
      /******/ // then flag all "chunkIds" as loaded and fire callback
      /******/ var moduleId,
        chunkId,
        i = 0;
      /******/ if (chunkIds.some((id) => installedChunks[id] !== 0)) {
        /******/ for (moduleId in moreModules) {
          /******/ if (__webpack_require__.o(moreModules, moduleId)) {
            /******/ __webpack_require__.m[moduleId] = moreModules[moduleId];
            /******/
          }
          /******/
        }
        /******/ if (runtime) var result = runtime(__webpack_require__);
        /******/
      }
      /******/ if (parentChunkLoadingFunction) parentChunkLoadingFunction(data);
      /******/ for (; i < chunkIds.length; i++) {
        /******/ chunkId = chunkIds[i];
        /******/ if (
          __webpack_require__.o(installedChunks, chunkId) &&
          installedChunks[chunkId]
        ) {
          /******/ installedChunks[chunkId][0]();
          /******/
        }
        /******/ installedChunks[chunkId] = 0;
        /******/
      }
      /******/ return __webpack_require__.O(result);
      /******/
    };
    /******/
    /******/ var chunkLoadingGlobal = (self["webpackChunkbrave_face"] =
      self["webpackChunkbrave_face"] || []);
    /******/ chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
    /******/ chunkLoadingGlobal.push = webpackJsonpCallback.bind(
      null,
      chunkLoadingGlobal.push.bind(chunkLoadingGlobal)
    );
    /******/
  })();
  /******/
  /******/ /* webpack/runtime/nonce */
  /******/ (() => {
    /******/ __webpack_require__.nc = undefined;
    /******/
  })();
  /******/
  /************************************************************************/
  /******/
  /******/ // startup
  /******/ // Load entry module and return exports
  /******/ // This entry module depends on other loaded chunks and execution need to be delayed
  /******/ __webpack_require__.O(undefined, ["assets/main"], () =>
    __webpack_require__("./src/js/main.js")
  );
  /******/ var __webpack_exports__ = __webpack_require__.O(
    undefined,
    ["assets/main"],
    () => __webpack_require__("./src/css/main.scss")
  );
  /******/ __webpack_exports__ = __webpack_require__.O(__webpack_exports__);
  /******/
  /******/
})();
